import { defineComponent as r5, computed as U, openBlock as b, createElementBlock as _, createElementVNode as d, toDisplayString as V, createCommentVNode as X, createVNode as Z, unref as O, createTextVNode as c1, Transition as mt, withCtx as c5, toRefs as N5, normalizeClass as F, withDirectives as b5, isRef as h1, vModelCheckbox as ot, createStaticVNode as O5, useSlots as $2, ref as P, onMounted as I5, onUnmounted as S2, Fragment as p5, renderSlot as u5, pushScopeId as g1, popScopeId as v1, nextTick as $e, onBeforeUnmount as se, watch as s5, normalizeStyle as R5, renderList as S5, getCurrentInstance as g4, vModelDynamic as $L, reactive as st, h as Q, createBlock as x5, resolveComponent as o0, withModifiers as re, mergeProps as C2, vShow as T1, resolveDynamicComponent as q0, Teleport as SL, withKeys as ee, vModelText as qe, useCssVars as CL, watchEffect as v4, withScopeId as DL, markRaw as zL, shallowReactive as IL, resolveDirective as D2, toHandlers as TL, onBeforeMount as OL, readonly as PL, getCurrentScope as ZL, onScopeDispose as EL, shallowRef as $0 } from "vue";
const AL = { class: "patient-identifier h-12 w-96 flex items-center shadow-md rounded-br-panel overflow-hidden bg-bl-panel-color dark:bg-bl-dk-panel-color" }, NL = /* @__PURE__ */ d("svg", {
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ d("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1), HL = [
  NL
], BL = { class: "text-sm px-4 flex-1 grid grid-flow-row" }, VL = {
  key: 0,
  "data-test-id": "patient-full-name"
}, RL = {
  key: 1,
  "data-test-id": "patient-id"
}, YL = {
  key: 0,
  "data-test-id": "states-section",
  class: "px-4 text-xs tracking-wide"
}, FL = {
  key: 0,
  "data-test-id": "saving-state",
  class: "flex items-center"
}, jL = {
  id: "Layer_1",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 19.9 19.9",
  style: { "enable-background": "new 0 0 19.9 19.9" },
  "xml:space": "preserve",
  class: "w-5 h-5 fill-current text-gray-darker"
}, WL = /* @__PURE__ */ d("g", {
  id: "Ebene_2",
  "data-name": "Ebene 2"
}, [
  /* @__PURE__ */ d("path", {
    class: "cls-1",
    d: "M5.75,11.73a.71.71,0,0,0-.71.71v.89A6,6,0,0,1,10.61,4a.75.75,0,1,0,.14-1.5A7.52,7.52,0,0,0,4,14.43H3.05a.72.72,0,0,0,0,1.43H6.47V12.44A.71.71,0,0,0,5.75,11.73Z"
  }),
  /* @__PURE__ */ d("polygon", {
    class: "cls-1",
    points: "15.82 14.74 15.82 14.74 15.82 14.74 15.82 14.74"
  }),
  /* @__PURE__ */ d("path", {
    class: "cls-1",
    d: "M15.83,14.74l.15-.21-.15.21Z"
  }),
  /* @__PURE__ */ d("path", {
    class: "cls-1",
    d: "M17,5.51h0a.73.73,0,0,0,.72-.72A.71.71,0,0,0,17,4.08H13.58V7.49a.72.72,0,1,0,1.43,0V6.62A6,6,0,0,1,10,16H9.93L9.5,16a.74.74,0,0,0-.81.69.75.75,0,0,0,.68.81l.54,0H10a7.51,7.51,0,0,0,6.06-12Z"
  })
], -1), UL = [
  WL
], GL = {
  key: 0,
  class: "ml-1 text-gray-darker"
}, KL = {
  key: 1,
  "data-test-id": "saved-state",
  class: "flex items-center transition-all duration-1000 ease-in-out"
}, qL = {
  id: "Layer_1",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 19.9 19.9",
  style: { "enable-background": "new 0 0 19.9 19.9" },
  "xml:space": "preserve",
  class: "w-5 h-5 fill-current text-gray-darker"
}, XL = /* @__PURE__ */ d("path", {
  class: "cls-1",
  d: "M9.84,2.56a7.5,7.5,0,1,0,7.5,7.5A7.52,7.52,0,0,0,9.84,2.56Zm0,13.55a6.05,6.05,0,1,1,6.05-6A6,6,0,0,1,9.84,16.11Z"
}, null, -1), JL = /* @__PURE__ */ d("path", {
  class: "cls-1",
  d: "M12.25,7.3l-3.5,4L7.44,9.77a.73.73,0,0,0-1.09,1l2.4,2.7,4.59-5.16a.73.73,0,1,0-1.09-1Z"
}, null, -1), QL = [
  XL,
  JL
], en = {
  key: 0,
  class: "ml-1 text-gray-darker"
}, tn = {
  name: "MfxPatientIdentifier"
}, dT = /* @__PURE__ */ r5({
  ...tn,
  props: {
    firstName: {},
    lastName: {},
    id: {},
    isDraftSaving: { type: Boolean },
    isDraftSaved: { type: Boolean },
    draftSavingText: {},
    draftSavedText: {},
    languages: {},
    settingsTitle: {},
    themeModeToggleItems: {}
  },
  emits: ["go-back", "change:language", "change:themeMode"],
  setup(t, { expose: e, emit: r }) {
    const L = t, o = U(() => {
      if (!(!L.firstName && !L.lastName))
        return `${L.firstName} ${L.lastName}`;
    }), n = () => {
      r("go-back");
    }, a = (i) => {
      r("change:language", i);
    }, s = (i) => {
      r("change:themeMode", i.value);
    };
    return e({
      goBack: n
    }), (i, l) => (b(), _("div", AL, [
      d("div", {
        "data-test-id": "back-button",
        class: "hover:bg-bl-icon-hover-diminished-color dark:hover:bg-bl-dk-icon-hover-diminished-color border-bl-background-color dark:border-bl-dk-background-color border-r cursor-pointer flex items-center justify-center h-full w-14",
        onClick: n
      }, HL),
      d("div", BL, [
        o.value ? (b(), _("span", VL, V(o.value), 1)) : X("", !0),
        i.id ? (b(), _("span", RL, "ID: " + V(i.id), 1)) : X("", !0)
      ]),
      Z(O(gI), {
        languages: i.languages,
        "theme-mode-toggle-items": i.themeModeToggleItems,
        "settings-title": i.settingsTitle,
        "onChange:language": a,
        "onChange:themeMode": s
      }, null, 8, ["languages", "theme-mode-toggle-items", "settings-title"]),
      c1(" 2 "),
      i.isDraftSaved || i.isDraftSaving ? (b(), _("div", YL, [
        Z(mt, { name: "fade" }, {
          default: c5(() => [
            i.isDraftSaving ? (b(), _("div", FL, [
              (b(), _("svg", jL, UL)),
              i.draftSavingText ? (b(), _("div", GL, V(i.draftSavingText), 1)) : X("", !0)
            ])) : i.isDraftSaved ? (b(), _("div", KL, [
              (b(), _("svg", qL, QL)),
              i.draftSavedText ? (b(), _("div", en, V(i.draftSavedText), 1)) : X("", !0)
            ])) : X("", !0)
          ]),
          _: 1
        })
      ])) : X("", !0)
    ]));
  }
});
function y1(t, e, r) {
  const L = U({
    get: () => t.value,
    set: (n) => {
      e("update:modelValue", n);
    }
  }), o = U({
    get: () => r,
    set(n) {
      e("onAdditionalUpdateFormField", n);
    }
  });
  return {
    localValue: L,
    additionalLocalValue: o
  };
}
const rn = { class: "relative flex items-center justify-center" }, Ln = ["disabled", "name", "value"], nn = /* @__PURE__ */ O5('<svg xmlns="http://www.w3.org/2000/svg" width="12.2" height="10.5" viewBox="0 0 12.2 10.5" fill="currentColor" class="fill-current absolute hidden w-4 h-4"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Pfad_7172" data-name="Pfad 7172"><path d="M4.2,10.5.2,6A1.1,1.1,0,0,1,.3,4.6a1,1,0,0,1,1.4,0L4.2,7.4,10.5.3a1,1,0,0,1,1.4,0A1.1,1.1,0,0,1,12,1.7Z"></path></g></g></g></svg>', 1), on = {
  name: "MfxCheckbox"
}, cT = /* @__PURE__ */ r5({
  ...on,
  props: {
    name: { default: "checkbox" },
    text: { default: "checkbox" },
    modelValue: { type: [Array, Boolean], default: () => [] },
    value: { default: "checkbox" },
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    horizontal: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, { modelValue: L } = N5(r), { localValue: o } = y1(L, e), n = U(
      () => o.value && Array.isArray(o.value) && o.value.includes(r.value)
    );
    return (a, s) => (b(), _("label", {
      class: F(["text-sm leading-none space-x-2 cursor-pointer items-center", a.horizontal ? "inline-flex mr-6" : "flex"])
    }, [
      d("div", rn, [
        b5(d("input", {
          "onUpdate:modelValue": s[0] || (s[0] = (i) => h1(o) ? o.value = i : null),
          type: "checkbox",
          class: "bg-bl-button-background-checkbox-color dark:bg-bl-dk-button-background-checkbox-color border-transparent rounded focus:ring-0 focus:ring-transparent checked:text-bl-button-background-checkbox-color dark:checked:bg-bl-dk-button-background-checkbox-color",
          disabled: a.disabled,
          name: a.name,
          value: a.value
        }, null, 8, Ln), [
          [ot, O(o)]
        ]),
        nn
      ]),
      d("span", {
        class: F(["text-bl-text-color dark:text-bl-dk-text-color", n.value ? "selection-shadow" : "font-medium"])
      }, V(a.text), 3)
    ], 2));
  }
});
function sn() {
  for (var t = 0, e, r, L = ""; t < arguments.length; )
    (e = arguments[t++]) && (r = k3(e)) && (L && (L += " "), L += r);
  return L;
}
function k3(t) {
  if (typeof t == "string")
    return t;
  for (var e, r = "", L = 0; L < t.length; L++)
    t[L] && (e = k3(t[L])) && (r && (r += " "), r += e);
  return r;
}
var z2 = "-";
function an(t) {
  var e = un(t), r = t.conflictingClassGroups, L = t.conflictingClassGroupModifiers, o = L === void 0 ? {} : L;
  function n(s) {
    var i = s.split(z2);
    return i[0] === "" && i.length !== 1 && i.shift(), M3(i, e) || ln(s);
  }
  function a(s, i) {
    var l = r[s] || [];
    return i && o[s] ? [].concat(l, o[s]) : l;
  }
  return {
    getClassGroupId: n,
    getConflictingClassGroupIds: a
  };
}
function M3(t, e) {
  var a;
  if (t.length === 0)
    return e.classGroupId;
  var r = t[0], L = e.nextPart.get(r), o = L ? M3(t.slice(1), L) : void 0;
  if (o)
    return o;
  if (e.validators.length !== 0) {
    var n = t.join(z2);
    return (a = e.validators.find(function(s) {
      var i = s.validator;
      return i(n);
    })) == null ? void 0 : a.classGroupId;
  }
}
var y4 = /^\[(.+)\]$/;
function ln(t) {
  if (y4.test(t)) {
    var e = y4.exec(t)[1], r = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}
function un(t) {
  var e = t.theme, r = t.prefix, L = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = cn(Object.entries(t.classGroups), r);
  return o.forEach(function(n) {
    var a = n[0], s = n[1];
    X0(s, L, a, e);
  }), L;
}
function X0(t, e, r, L) {
  t.forEach(function(o) {
    if (typeof o == "string") {
      var n = o === "" ? e : w4(e, o);
      n.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (dn(o)) {
        X0(o(L), e, r, L);
        return;
      }
      e.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(function(a) {
      var s = a[0], i = a[1];
      X0(i, w4(e, s), r, L);
    });
  });
}
function w4(t, e) {
  var r = t;
  return e.split(z2).forEach(function(L) {
    r.nextPart.has(L) || r.nextPart.set(L, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(L);
  }), r;
}
function dn(t) {
  return t.isThemeGetter;
}
function cn(t, e) {
  return e ? t.map(function(r) {
    var L = r[0], o = r[1], n = o.map(function(a) {
      return typeof a == "string" ? e + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var i = s[0], l = s[1];
        return [e + i, l];
      })) : a;
    });
    return [L, n];
  }) : t;
}
function hn(t) {
  if (t < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, r = /* @__PURE__ */ new Map(), L = /* @__PURE__ */ new Map();
  function o(n, a) {
    r.set(n, a), e++, e > t && (e = 0, L = r, r = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = r.get(a);
      if (s !== void 0)
        return s;
      if ((s = L.get(a)) !== void 0)
        return o(a, s), s;
    },
    set: function(a, s) {
      r.has(a) ? r.set(a, s) : o(a, s);
    }
  };
}
var _3 = "!";
function fn(t) {
  var e = t.separator || ":", r = e.length === 1, L = e[0], o = e.length;
  return function(a) {
    for (var s = [], i = 0, l = 0, u, c = 0; c < a.length; c++) {
      var v = a[c];
      if (i === 0) {
        if (v === L && (r || a.slice(c, c + o) === e)) {
          s.push(a.slice(l, c)), l = c + o;
          continue;
        }
        if (v === "/") {
          u = c;
          continue;
        }
      }
      v === "[" ? i++ : v === "]" && i--;
    }
    var p = s.length === 0 ? a : a.substring(l), m = p.startsWith(_3), f = m ? p.substring(1) : p, x = u && u > l ? u - l : void 0;
    return {
      modifiers: s,
      hasImportantModifier: m,
      baseClassName: f,
      maybePostfixModifierPosition: x
    };
  };
}
function pn(t) {
  if (t.length <= 1)
    return t;
  var e = [], r = [];
  return t.forEach(function(L) {
    var o = L[0] === "[";
    o ? (e.push.apply(e, r.sort().concat([L])), r = []) : r.push(L);
  }), e.push.apply(e, r.sort()), e;
}
function mn(t) {
  return {
    cache: hn(t.cacheSize),
    splitModifiers: fn(t),
    ...an(t)
  };
}
var gn = /\s+/;
function vn(t, e) {
  var r = e.splitModifiers, L = e.getClassGroupId, o = e.getConflictingClassGroupIds, n = /* @__PURE__ */ new Set();
  return t.trim().split(gn).map(function(a) {
    var s = r(a), i = s.modifiers, l = s.hasImportantModifier, u = s.baseClassName, c = s.maybePostfixModifierPosition, v = L(c ? u.substring(0, c) : u), p = !!c;
    if (!v) {
      if (!c)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (v = L(u), !v)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      p = !1;
    }
    var m = pn(i).join(":"), f = l ? m + _3 : m;
    return {
      isTailwindClass: !0,
      modifierId: f,
      classGroupId: v,
      originalClassName: a,
      hasPostfixModifier: p
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, i = a.classGroupId, l = a.hasPostfixModifier, u = s + i;
    return n.has(u) ? !1 : (n.add(u), o(i, l).forEach(function(c) {
      return n.add(s + c);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function yn() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var L, o, n, a = s;
  function s(l) {
    var u = e[0], c = e.slice(1), v = c.reduce(function(p, m) {
      return m(p);
    }, u());
    return L = mn(v), o = L.cache.get, n = L.cache.set, a = i, i(l);
  }
  function i(l) {
    var u = o(l);
    if (u)
      return u;
    var c = vn(l, L);
    return n(l, c), c;
  }
  return function() {
    return a(sn.apply(null, arguments));
  };
}
function y5(t) {
  var e = function(L) {
    return L[t] || [];
  };
  return e.isThemeGetter = !0, e;
}
var $3 = /^\[(?:([a-z-]+):)?(.+)\]$/i, wn = /^\d+\/\d+$/, bn = /* @__PURE__ */ new Set(["px", "full", "screen"]), xn = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, kn = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))/, Mn = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function l1(t) {
  return te(t) || bn.has(t) || wn.test(t) || V1(t);
}
function V1(t) {
  return ae(t, "length", zn);
}
function _n(t) {
  return ae(t, "size", S3);
}
function $n(t) {
  return ae(t, "position", S3);
}
function Sn(t) {
  return ae(t, "url", In);
}
function $t(t) {
  return ae(t, "number", te);
}
function te(t) {
  return !Number.isNaN(Number(t));
}
function Cn(t) {
  return t.endsWith("%") && te(t.slice(0, -1));
}
function Re(t) {
  return b4(t) || ae(t, "number", b4);
}
function M5(t) {
  return $3.test(t);
}
function Ye() {
  return !0;
}
function A1(t) {
  return xn.test(t);
}
function Dn(t) {
  return ae(t, "", Tn);
}
function ae(t, e, r) {
  var L = $3.exec(t);
  return L ? L[1] ? L[1] === e : r(L[2]) : !1;
}
function zn(t) {
  return kn.test(t);
}
function S3() {
  return !1;
}
function In(t) {
  return t.startsWith("url(");
}
function b4(t) {
  return Number.isInteger(Number(t));
}
function Tn(t) {
  return Mn.test(t);
}
function On() {
  var t = y5("colors"), e = y5("spacing"), r = y5("blur"), L = y5("brightness"), o = y5("borderColor"), n = y5("borderRadius"), a = y5("borderSpacing"), s = y5("borderWidth"), i = y5("contrast"), l = y5("grayscale"), u = y5("hueRotate"), c = y5("invert"), v = y5("gap"), p = y5("gradientColorStops"), m = y5("gradientColorStopPositions"), f = y5("inset"), x = y5("margin"), y = y5("opacity"), w = y5("padding"), g = y5("saturate"), h = y5("scale"), k = y5("sepia"), M = y5("skew"), $ = y5("space"), C = y5("translate"), D = function() {
    return ["auto", "contain", "none"];
  }, S = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, T = function() {
    return ["auto", e];
  }, B = function() {
    return ["", l1];
  }, I = function() {
    return ["auto", te, M5];
  }, R = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, N = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, H = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, G = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, e5 = function() {
    return ["", "0", M5];
  }, t5 = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, J = function() {
    return [te, $t];
  }, h5 = function() {
    return [te, M5];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Ye],
      spacing: [l1],
      blur: ["none", "", A1, V1],
      brightness: J(),
      borderColor: [t],
      borderRadius: ["none", "", "full", A1, V1],
      borderSpacing: [e],
      borderWidth: B(),
      contrast: J(),
      grayscale: e5(),
      hueRotate: h5(),
      invert: e5(),
      gap: [e],
      gradientColorStops: [t],
      gradientColorStopPositions: [Cn, V1],
      inset: T(),
      margin: T(),
      opacity: J(),
      padding: [e],
      saturate: J(),
      scale: J(),
      sepia: e5(),
      skew: h5(),
      space: [e],
      translate: [e]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", M5]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [A1]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": t5()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": t5()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(R(), [M5])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: S()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": S()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": S()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Re]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [e]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", M5]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: e5()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: e5()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Re]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ye]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [Re]
        }, M5]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": I()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": I()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ye]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Re]
        }, M5]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": I()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": I()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", M5]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", M5]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [v]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [v]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [v]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(G())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(G(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(G(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [x]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [x]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [x]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [x]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [x]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [x]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [x]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [x]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [x]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [$]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [$]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", l1]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [A1]
        }, A1, V1]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", l1]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", A1, V1]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", $t]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ye]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", V1]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", te, $t]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", l1]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", M5]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", M5]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(N(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", l1]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", l1]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [e]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", V1]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", M5]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(R(), [$n])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", _n]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Sn]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [n]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [n]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [n]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [n]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [n]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [n]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [n]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [n]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [n]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [n]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [n]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [n]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [n]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [n]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [n]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(N(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: N()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(N())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [l1]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [l1]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: B()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [l1]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", A1, Dn]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ye]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Beldn Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": H()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": H()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [L]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [i]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", A1, M5]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [c]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [g]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [k]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [L]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [i]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [c]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [g]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [k]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", M5]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: h5()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", M5]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: h5()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", M5]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [h]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [h]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [h]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Re, M5]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [C]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [C]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", M5]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", M5]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [e]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [e]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [e]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [e]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [e]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [e]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [e]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [e]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [e]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [e]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [e]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [e]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [e]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [e]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [e]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [e]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [e]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [e]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", M5]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [l1, $t]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var T5 = /* @__PURE__ */ yn(On);
const C5 = () => ({ toString: (e) => {
  if (typeof e == "string")
    return e;
  let r = "";
  return e && Object.keys(e).forEach((L) => {
    e[L] && (r += L + " ");
  }), r;
} }), Pn = { class: "bg-bl-panel-color dark:bg-bl-dk-panel-color border-bl-border-color dark:border-bl-dk-border-color border-[1px] pt-3 pb-3 pr-6 pl-6 rounded-md" }, Zn = {
  key: 0,
  class: "border-black border-solid border-b-2 mt-3 mb-3"
}, En = /* @__PURE__ */ r5({
  __name: "MfxDropdownMenu",
  props: {
    containerClasses: {},
    itemListClasses: {}
  },
  setup(t) {
    const e = t, r = $2(), L = U(() => !!r.item2), o = U(() => {
      const c = "dropdownContainer cursor-pointer bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color rounded-full pt-2 pb-2 pr-6 pl-6 text-center";
      return e.containerClasses ? T5(
        c,
        C5().toString(e.containerClasses)
      ) : c;
    }), n = U(() => {
      const c = "dropdownItemList noShow";
      return e.itemListClasses ? T5(c, C5().toString(e.itemListClasses)) : c;
    }), a = P(null), s = P(null), i = P(null), l = () => {
      i.value.classList.toggle("show"), i.value.classList.toggle("noShow"), s.value.classList.toggle("show"), s.value.classList.toggle("noShow");
    }, u = () => {
      const { top: c, height: v, left: p } = a.value.getBoundingClientRect();
      i.value.style.top = `${window.scrollY + c + v}px`, i.value.style.left = `${p}px`;
    };
    return I5(() => {
      window.addEventListener("resize", u), u();
    }), S2(() => {
      window.removeEventListener("resize", u);
    }), (c, v) => (b(), _(p5, null, [
      d("div", {
        ref_key: "refDropdownContainer",
        ref: a,
        class: F(o.value),
        onClick: l
      }, [
        u5(c.$slots, "title", {}, void 0, !0)
      ], 2),
      d("div", {
        ref_key: "refBlocker",
        ref: s,
        class: "blocker noShow",
        onClick: l
      }, null, 512),
      d("div", {
        ref_key: "refDropdownItemList",
        ref: i,
        class: F(n.value)
      }, [
        d("div", Pn, [
          u5(c.$slots, "default", {}, void 0, !0),
          L.value ? (b(), _("div", Zn)) : X("", !0),
          u5(c.$slots, "item2", {}, void 0, !0),
          u5(c.$slots, "item3", {}, void 0, !0),
          u5(c.$slots, "item4", {}, void 0, !0)
        ])
      ], 2)
    ], 64));
  }
});
const K = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [L, o] of e)
    r[L] = o;
  return r;
}, An = /* @__PURE__ */ K(En, [["__scopeId", "data-v-d5b81b32"]]), Nn = r5({
  name: "IconBase",
  props: {
    iconName: {
      type: String,
      default: "box"
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: "currentColor"
    },
    viewBox: {
      type: String,
      default: "0 0 15 15"
    },
    preserveAspectRatio: {
      type: String,
      default: "xMidYMid meet"
    }
  },
  methods: {
    clickHandler() {
      this.$emit("click");
    }
  }
});
const Hn = ["width", "height", "viewBox", "aria-labelledby", "preserveAspectRatio"], Bn = ["id"], Vn = ["fill"];
function Rn(t, e, r, L, o, n) {
  return b(), _("svg", {
    class: "cursor-pointer",
    xmlns: "http://www.w3.org/2000/svg",
    width: t.width,
    height: t.height,
    viewBox: t.viewBox,
    "aria-labelledby": t.iconName,
    preserveAspectRatio: t.preserveAspectRatio,
    role: "presentation",
    onClick: e[0] || (e[0] = (...a) => t.clickHandler && t.clickHandler(...a))
  }, [
    d("title", {
      id: t.iconName,
      lang: "en"
    }, V(t.iconName) + " icon", 9, Bn),
    d("g", { fill: t.iconColor }, [
      u5(t.$slots, "default", {}, void 0, !0)
    ], 8, Vn)
  ], 8, Hn);
}
const ce = /* @__PURE__ */ K(Nn, [["render", Rn], ["__scopeId", "data-v-9e65c185"]]), Yn = {}, Fn = { d: "M15.4,7.5h-2a5.4,5.4,0,0,0-4.9-5V.5A.5.5,0,0,0,8,0a.5.5,0,0,0-.5.5v2a5.4,5.4,0,0,0-5,5H.5A.5.5,0,0,0,0,8a.5.5,0,0,0,.5.5h2a5.4,5.4,0,0,0,5,4.9v2a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-2a5.4,5.4,0,0,0,4.9-4.9h2a.5.5,0,0,0,.5-.5A.5.5,0,0,0,15.4,7.5Zm-3,0H8.5v-4A4.5,4.5,0,0,1,12.4,7.5Zm-4.9-4v4h-4A4.5,4.5,0,0,1,7.5,3.5Zm-4,5h4v3.9A4.5,4.5,0,0,1,3.5,8.5Zm5,3.9V8.5h3.9A4.5,4.5,0,0,1,8.5,12.4Z" };
function jn(t, e) {
  return b(), _("path", Fn);
}
const Wn = /* @__PURE__ */ K(Yn, [["render", jn]]), Un = (t) => (g1("data-v-e655419e"), t = t(), v1(), t), Gn = { class: "relative flex justify-center mt-0.5" }, Kn = ["disabled", "name", "value", "checked"], qn = /* @__PURE__ */ Un(() => /* @__PURE__ */ d("svg", {
  viewBox: "0 0 16 16",
  class: "fill-black dark:fill-bl-dk-panel-color absolute hidden w-4 h-4",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ d("circle", {
    cx: "8",
    cy: "8",
    r: "4"
  })
], -1)), Xn = { class: "relative flex justify-center mt-0.5" }, Jn = ["disabled", "name", "value", "checked"], Qn = {
  name: "MfxRadioButton"
}, eo = /* @__PURE__ */ r5({
  ...Qn,
  props: {
    name: { default: "radio" },
    text: { default: "radio" },
    value: { default: "radio" },
    modelValue: { default: "" },
    type: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    horizontal: { type: Boolean, default: !1 },
    selected: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, { modelValue: L } = N5(r), { localValue: o } = y1(L, e), n = U(
      () => o.value && o.value === r.value
    );
    return (a, s) => (b(), _("label", {
      class: F(["items-center text-sm leading-5 space-x-2 cursor-pointer", a.horizontal ? "inline-flex mr-6" : "flex"])
    }, [
      a.type === "default" ? (b(), _(p5, { key: 0 }, [
        d("div", Gn, [
          d("input", {
            type: "radio",
            class: "bg-bl-button-background-radio-color dark:bg-bl-dk-button-background-radio-color border-transparent rounded-full text-bl-button-background-radio-color dark:text-bl-dk-button-background-radio-color focus:ring-0 focus:ring-transparent",
            disabled: a.disabled,
            name: a.name,
            value: a.value,
            checked: n.value || !1,
            onChange: s[0] || (s[0] = (i) => e("update:modelValue", i.target.value))
          }, null, 40, Kn),
          qn
        ]),
        d("span", {
          class: F([
            n.value ? "selection-shadow" : "font-medium",
            a.text === "" ? "hidden" : ""
          ])
        }, V(a.text), 3)
      ], 64)) : (b(), _(p5, { key: 1 }, [
        d("div", Xn, [
          d("input", {
            type: "radio",
            class: "toggle-input bg-gray-light border-transparent rounded-full text-gray-light focus:ring-0 focus:ring-transparent",
            disabled: a.disabled,
            name: a.name,
            value: a.value,
            checked: n.value || !1,
            onChange: s[1] || (s[1] = (i) => e("update:modelValue", i.target.value))
          }, null, 40, Jn),
          Z(ce, {
            class: "toggle-icon",
            "view-box": "0 0 16 16",
            height: "16px",
            width: "16px"
          }, {
            default: c5(() => [
              Z(Wn)
            ]),
            _: 1
          })
        ]),
        d("span", {
          class: F(["toggle-text text-gray-900", [
            n.value ? "selection-shadow" : "font-medium",
            a.text === "" ? "hidden" : ""
          ]])
        }, V(a.text), 3)
      ], 64))
    ], 2));
  }
});
const S0 = /* @__PURE__ */ K(eo, [["__scopeId", "data-v-e655419e"]]), to = {
  name: "MfxPanel"
}, hT = /* @__PURE__ */ r5({
  ...to,
  props: {
    isActive: { type: Boolean, default: !0 },
    noRightBottomBorder: { type: Boolean, default: !1 },
    noRightTopBorder: { type: Boolean, default: !1 },
    classes: { default: void 0 }
  },
  setup(t) {
    const e = t, r = U(() => {
      const L = {
        "bg-bl-panel-color": !0,
        "dark:bg-bl-dk-panel-color": !0,
        "rounded-panel": !0,
        "shadow-md": !0,
        "p-5": !0,
        "rounded-br-none": e.noRightBottomBorder,
        "rounded-tr-none": e.noRightTopBorder
      };
      let o = C5().toString(L);
      return e.classes && (o = T5(
        o,
        C5().toString(e.classes)
      )), o;
    });
    return (L, o) => (b(), _("div", {
      class: F(r.value)
    }, [
      u5(L.$slots, "default")
    ], 2));
  }
}), ro = (t) => (g1("data-v-4e5534e6"), t = t(), v1(), t), Lo = ["data-min", "data-max", "data-step"], no = /* @__PURE__ */ ro(() => /* @__PURE__ */ d("span", { class: "drag-image" }, "x", -1)), oo = { class: "flex items-center" }, so = ["onClick"], ao = ["name", "value"], io = {
  name: "MfxSlider"
}, lo = /* @__PURE__ */ r5({
  ...io,
  props: {
    modelValue: { default: "" },
    name: { default: "" },
    min: { default: 0 },
    max: { default: 1 },
    step: { default: 1 },
    theme: { default: "desert" },
    snap: { type: Boolean, default: !0 },
    values: { default: () => [] },
    checkedValue: { default: 0 },
    notApplicable: { default: () => ({ enabled: !0, label: "-" }) },
    noLabel: { type: Boolean, default: !1 },
    sliderType: { default: "numbers" },
    vertical: { type: Boolean, default: !1 },
    gradientData: { default: () => ({}) }
  },
  emits: [
    "update:modelValue",
    "update:colorModel",
    "update:trackPosition"
  ],
  setup(t, { expose: e, emit: r }) {
    const L = t, {
      modelValue: o,
      notApplicable: n,
      min: a,
      max: s,
      step: i,
      theme: l,
      snap: u,
      values: c,
      checkedValue: v,
      sliderType: p,
      vertical: m,
      gradientData: f
    } = N5(L), { localValue: x } = y1(o, r), y = P(null), w = P([]), g = P(), h = P(), k = P(), M = P(""), $ = P(0), C = P({
      // Refer to stylesheet for the gradient configuration minus alpha channel. Minimum of 2 colors.
      // noTheme doesn't use 161, 161, 161 as defined in stylesheet to force the original thumb color.
      noTheme: [
        {
          from: 0,
          color: [112, 112, 112]
        },
        {
          from: 100,
          color: [112, 112, 112]
        }
      ],
      desert: [
        {
          from: 0,
          color: [112, 112, 112]
        },
        {
          from: 5,
          color: [189, 221, 9]
        },
        {
          from: 40,
          color: [255, 231, 22]
        },
        {
          from: 60,
          color: [250, 162, 27]
        },
        {
          from: 90,
          color: [249, 25, 25]
        },
        {
          from: 100,
          color: [124, 8, 8]
        }
      ],
      skinColor: [
        { from: 0, color: [241, 206, 182] },
        { from: 50, color: [167, 125, 91] },
        { from: 100, color: [95, 43, 6] }
      ]
    }), D = P(null), S = P(), T = P({}), B = P(), I = () => {
      const { width: z, height: A } = g.value.getBoundingClientRect();
      if (!z || !A)
        return;
      const W = document.createElement("canvas").getContext("2d");
      W.canvas.width = z, W.canvas.height = A;
      const q = W.createLinearGradient(0, 0, z, A);
      C.value[l.value].forEach((d5) => {
        q.addColorStop(
          d5.from / 100,
          `rgb(${d5.color[0]}, ${d5.color[1]}, ${d5.color[2]})`
        );
      }), W.fillStyle = q, W.fillRect(0, 0, z, A), h.value = W.getImageData(0, 0, z, A).data, k.value = z;
    }, R = (z) => {
      const { offsetX: A } = z;
      if (A > 0) {
        const Y = N(
          k.value,
          A,
          h.value
        );
        Y.red !== void 0 && (M.value = `#${[Y.red, Y.green, Y.blue].map((W) => W.toString(16).padStart(2, "0")).join("")}`, r("update:colorModel", M.value), r("update:trackPosition", $.value));
        return;
      }
      M.value = `#${[112, 112, 112].map((Y) => Y.toString(16).padStart(2, "0")).join("")}`, r("update:colorModel", M.value), r("update:trackPosition", $.value);
    }, N = (z, A, Y) => {
      const q = z * A * 4;
      return {
        red: Y[q],
        green: Y[q + 1],
        blue: Y[q + 2],
        alpha: Y[q + 3]
      };
    }, H = (z) => {
      E(z, !0);
    }, G = (z) => {
      L5(z, !1);
    }, e5 = (z) => {
      k5(z, !0);
    }, t5 = (z) => {
      z && (z.addEventListener("touchstart", H, { passive: !0 }), z.addEventListener("touchend", G, { passive: !0 }), z.addEventListener("touchmove", e5, { passive: !0 }));
    }, J = (z) => {
      z && (z.removeEventListener("touchstart", H), z.removeEventListener("touchend", G), z.removeEventListener("touchmove", e5));
    }, h5 = () => {
      const z = [];
      if (n.value.enabled && z.push(n.value.label), p.value === "color")
        z.push(...c.value);
      else
        for (let A = a.value; A <= s.value && i.value !== 0; A += i.value)
          z.push(A);
      return z;
    }, n5 = () => {
      var Y, W;
      const z = {}, A = ((W = (Y = S.value) == null ? void 0 : Y.querySelector(".label")) == null ? void 0 : W.children) ?? null;
      if (!A)
        return null;
      for (let q = 0; q < A.length; q++) {
        const d5 = A[q].getBoundingClientRect();
        z[w.value[q]] = {
          left: d5.left + d5.width / 2,
          top: d5.top + d5.height / 2
        };
      }
      return z;
    }, _5 = (z) => {
      const A = n5(), Y = [];
      for (const q in A) {
        m.value ? A[q] = { ...A[q], top: z - A[q].top } : A[q] = { ...A[q], left: z - A[q].left };
        const d5 = {
          index: q,
          value: Math.abs(m.value ? A[q].top : A[q].left)
        };
        Y.push(d5);
      }
      Y.sort((q, d5) => q.value - d5.value);
      const W = {
        value: 0,
        positionOffset: 0
      };
      return Y.length > 0 && (W.value = Y[0].index, W.positionOffset = (m.value ? A && A[W.value].top : A && A[W.value].left) || 0), W;
    }, o5 = (z, A) => {
      const Y = l.value in C.value ? C.value[l.value] : C.value.noTheme, W = {
        first: [],
        second: []
      };
      z = z < 0 ? 0 : z;
      for (let D5 = 1; D5 < Y.length; D5++)
        if (z >= Y[D5 - 1].from && z < Y[D5].from) {
          W.first = Y[D5 - 1], W.second = Y[D5];
          break;
        }
      const q = A * (W.first.from / 100), d5 = A * (W.second.from / 100) - q, j5 = (((A * (z / 100) - q) / d5 * 2 - 1) / 1 + 1) / 2, i1 = 1 - j5;
      return [
        Math.round(
          (W.second.color && W.second.color[0]) * j5 + (W.first.color && W.first.color[0]) * i1
        ),
        Math.round(
          (W.second.color && W.second.color[1]) * j5 + (W.first.color && W.first.color[1]) * i1
        ),
        Math.round(
          (W.second.color && W.second.color[2]) * j5 + (W.first.color && W.first.color[2]) * i1
        )
      ];
    }, i5 = (z) => {
      typeof window.InstallTrigger < "u" && k5(z, !0);
    }, k5 = (z, A) => {
      var Be;
      if (navigator.userAgent.search("Firefox") !== -1 && z.type === "drag")
        return;
      const Y = (_t) => window.TouchEvent && _t instanceof TouchEvent;
      if (!Y(z) && z.screenX === 0)
        return;
      const W = (Be = S.value) == null ? void 0 : Be.querySelector(".track"), q = W == null ? void 0 : W.getBoundingClientRect(), d5 = getComputedStyle(W), E1 = parseInt(
        d5.getPropertyValue("--thumb-dimension")
      ), q1 = parseInt(
        d5.getPropertyValue("--thumb-border-width")
      ), X1 = parseInt(
        d5.getPropertyValue("--thumb-outer-ring")
      ), b1 = u.value || "isJumpByValue" in z, x1 = 2, j5 = (E1 - q1 + X1 * 2) / x1, i1 = Y(z) ? z.changedTouches[0].pageX : z.pageX, D5 = Y(z) ? z.changedTouches[0].clientY : z.clientY;
      let H5 = 0;
      if (b1) {
        const _t = _5(m.value ? D5 : i1);
        H5 = m.value ? D5 - q.top : i1 - (Number(_t.positionOffset) || 0) - q.left, m.value && (D5 - q.top < 0 && (H5 = 0), D5 - q.top > q.height && (H5 = q.height + 32)), y.value !== null && Object.keys(T.value).filter((Ve) => Ve.startsWith("selected-label-") && Ve === `selected-label-${y.value}` && T.value[Ve].classList.contains("font-bold")).forEach(
          (Ve) => T.value[Ve].classList.remove("font-bold")
        ), y.value = _t.value, T.value[`selected-label-${y.value}`].classList.add("font-bold");
      } else
        H5 = m.value ? D5 - q.top : i1 - q.left, (H5 - j5 / x1 <= 0 || H5 + j5 >= q.width) && (H5 -= Number(
          _5(m.value ? D5 : i1).positionOffset
        ) - j5 / x1);
      const le = o5(
        // newPosition in drag event aren't always specific values so adjust its value
        (A ? H5 - j5 / x1 : H5) / q.width * 100,
        q.width
      ), ue = `rgba(${le[0]}, ${le[1]}, ${le[2]}, 1)`;
      W.style.setProperty(
        "--thumb-position",
        `${Math.round(H5 - j5)}px`
      ), m.value ? ($.value = H5, R(z), W.style.setProperty("--thumb-border-color", M.value), D.value = ue) : (W.style.setProperty("--thumb-border-color", ue), D.value = ue);
    }, f5 = (z) => {
      var Y, W, q;
      const A = n5();
      k5({
        target: (Y = S.value) == null ? void 0 : Y.querySelector(".track"),
        pageX: A && ((W = A[z]) == null ? void 0 : W.left) || 0,
        clientY: A && ((q = A[z]) == null ? void 0 : q.top) || 0,
        isJumpByValue: !0
      });
    }, E = (z, A) => {
      var W, q;
      const Y = (d5) => d5 instanceof DragEvent;
      if ((W = S.value) == null || W.classList.toggle("slider-dragging", A), !!Y(z) && z.dataTransfer) {
        const d5 = (q = S.value) == null ? void 0 : q.querySelector(".drag-image");
        d5 && z.dataTransfer.setDragImage(d5, 0, 0);
      }
    }, L5 = (z, A) => {
      var Y;
      (Y = S.value) == null || Y.classList.toggle("slider-dragging", A), k5(z, !0);
    }, g5 = () => {
      var Y;
      const z = (Y = S.value) == null ? void 0 : Y.querySelector(".track");
      let A = "linear-gradient( 90deg";
      C.value[l.value].forEach((W) => {
        A += `, rgba(${W.color[0]}, ${W.color[1]}, ${W.color[2]}, 1) ${W.from}%`;
      }), A += " )", z && z.style.setProperty("--linear-gradient-background", A);
    };
    return I5(() => {
      Object.keys(f.value).length && (C.value = f.value), c.value && c.value.length && p.value !== "color" ? w.value = c.value : w.value = h5(), g5(), $e(() => {
        (x.value || x.value !== null && x.value !== "") && f5(x.value), t5(B.value), !x.value && v.value && f5(v.value);
      }), setTimeout(() => {
        I();
      }, 1e3);
    }), se(() => {
      J(B.value);
    }), s5(i, () => {
      w.value = h5();
    }), s5(y, (z) => {
      x.value = z === null || isNaN(Number(z)) ? "" : z;
    }), s5(x, (z) => {
      z ?? f5(z || n.value.label || a.value);
    }), s5(c, (z) => {
      w.value = [...z];
    }), e({
      props: N5(L),
      jumpByValue: f5,
      gradient: C.value,
      selectedValue: y.value
    }), (z, A) => (b(), _("div", {
      ref_key: "component",
      ref: S,
      class: F(["slider", [O(l), O(m) ? "vertical-slider" : ""]]),
      "data-min": O(a),
      "data-max": O(s),
      "data-step": O(i)
    }, [
      no,
      d("div", oo, [
        O(n).enabled ? (b(), _("div", {
          key: 0,
          class: "not-applicable",
          onClick: A[0] || (A[0] = (Y) => f5(O(n).label))
        }, " ... ")) : X("", !0),
        d("div", {
          ref_key: "sliderWrapper",
          ref: B,
          class: "slider__wrapper",
          draggable: "true",
          onClick: A[1] || (A[1] = (Y) => k5(Y)),
          onDragstart: A[2] || (A[2] = (Y) => E(Y, !0)),
          onDragend: A[3] || (A[3] = (Y) => L5(Y, !1)),
          onDragover: A[4] || (A[4] = (Y) => i5(Y)),
          onDrag: A[5] || (A[5] = (Y) => k5(Y, !0))
        }, [
          d("div", {
            ref_key: "track",
            ref: g,
            class: F(["track", {
              "has-not-applicable": O(n).enabled,
              "vertical-track": O(m)
            }])
          }, null, 2)
        ], 544)
      ]),
      d("div", {
        style: R5({ opacity: z.noLabel ? 0 : 1 }),
        class: F(["label", {
          "has-not-applicable": O(n).enabled
        }])
      }, [
        (b(!0), _(p5, null, S5(w.value, (Y) => (b(), _("span", {
          key: Y,
          ref_for: !0,
          ref: (W) => {
            T.value["selected-label-" + Y] = W;
          },
          onClick: (W) => f5(Y)
        }, V(Y), 9, so))), 128))
      ], 6),
      d("input", {
        type: "hidden",
        name: z.name,
        value: y.value
      }, null, 8, ao)
    ], 10, Lo));
  }
});
const fT = /* @__PURE__ */ K(lo, [["__scopeId", "data-v-4e5534e6"]]), uo = (t) => (g1("data-v-128f0b07"), t = t(), v1(), t), co = { class: "relative flex input-wrapper mr-0.5" }, ho = ["type", "placeholder", "readonly", "disabled", "data-min-width"], fo = /* @__PURE__ */ uo(() => /* @__PURE__ */ d("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, [
  /* @__PURE__ */ d("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, [
    /* @__PURE__ */ d("path", {
      id: "Pfad_7045",
      class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
      "data-name": "Pfad 7045",
      d: "M12.4,5.6,5.9,12.1,3,9,9.4,2.6ZM0,15l5.2-2.4-2.8-3ZM14.7,1.7,13.3.3a1.2,1.2,0,0,0-1.6,0h-.1L11,1h0L10,2.1,12.9,5l.9-.8h0l.8-.8h.1a1.2,1.2,0,0,0,0-1.6Z"
    })
  ])
], -1)), po = [
  fo
], mo = {
  name: "MfxInputText"
}, go = /* @__PURE__ */ r5({
  ...mo,
  props: {
    isInlineBlock: { type: Boolean, default: !1 },
    placeholder: { default: "Bitte Eintragen" },
    value: { default: "" },
    modelValue: { default: "" },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    animate: { type: Boolean, default: !1 },
    primary: { type: Boolean, default: !0 },
    minWidth: { default: "144" },
    expandable: { type: Boolean, default: !0 },
    type: { default: "text" },
    hideSvg: { type: Boolean, default: !1 },
    inputClasses: { default: "" },
    isValid: { type: Function, default: () => !0 }
  },
  emits: ["update:modelValue", "focus", "focus-out"],
  setup(t, { emit: e }) {
    const r = t, { modelValue: L } = N5(r), { localValue: o } = y1(L, e), n = U(() => ({
      "bl-input-text": !0,
      "bl-input-text--primary": r.primary,
      "bl-input-text--secondary": !r.primary,
      "bl-input-text--disabled": r.disabled
    })), a = U(() => {
      const m = r.isInlineBlock ? "bl-input-text relative inline-block" : "bl-input-text flex relative";
      return n.value ? T5(m, C5().toString(n.value)) : m;
    }), s = U(() => {
      const m = "border-none text-sm font-bold focus:ring-0 leading-none w-full outline-none bg-transparent p-0";
      return r.inputClasses ? T5(m, C5().toString(r.inputClasses)) : m;
    }), i = U(() => ({ "pencil-animate-writing": r.animate }));
    I5(() => {
      var g;
      const m = (g = g4()) == null ? void 0 : g.vnode.el, f = m == null ? void 0 : m.querySelector("input"), x = f.getAttribute("data-min-width"), y = parseInt(x, 10), w = x.substring(y.toString().length) || "px";
      f.style.width = `${y}${w}`, r.value && (o.value = r.value);
    });
    const l = P(null), u = (m) => {
      var T, B, I, R;
      const f = (T = g4()) == null ? void 0 : T.vnode.el, x = m.target, y = f == null ? void 0 : f.classList.contains("bl-input-text--primary"), w = x.getBoundingClientRect().width, g = getComputedStyle(x), h = x.getAttribute("data-min-width") || r.minWidth, k = parseInt(h, 10);
      let M = k;
      const $ = h.substring(k.toString().length) || "px", D = (l.value || (l.value = document.createElement("canvas"))).getContext("2d");
      if (!D)
        return;
      D.font = `${g.fontWeight} ${g.fontSize} ${g.fontFamily}`;
      const S = D.measureText(x.value).width + parseInt(g.paddingRight, 10);
      if (S > w) {
        const N = Math.floor(
          ((B = x.nextElementSibling) == null ? void 0 : B.getBoundingClientRect().width) || 0
        ), H = Math.floor(
          ((R = (I = x.parentElement) == null ? void 0 : I.parentElement) == null ? void 0 : R.getBoundingClientRect().width) || 0
        );
        M = Math.floor(S + N) < H ? S : H + (y ? -N : 0);
      } else
        S > k && (M = S);
      x.style.width = `${M}${$}`;
    }, c = (m) => {
      r.expandable && u(m);
      let f = m.target.value;
      r.isValid(f) || (f = "", o.value = "");
    }, v = () => {
      e("focus");
    }, p = () => {
      e("focus-out");
    };
    return (m, f) => (b(), _("div", {
      class: F(a.value)
    }, [
      d("div", co, [
        b5(d("input", {
          "onUpdate:modelValue": f[0] || (f[0] = (x) => h1(o) ? o.value = x : null),
          class: F(s.value),
          type: m.type,
          placeholder: m.placeholder,
          readonly: m.readonly,
          disabled: m.disabled,
          "data-min-width": m.minWidth,
          "data-testid": "inputText",
          onInput: c,
          onFocus: v,
          onBlur: p
        }, null, 42, ho), [
          [$L, O(o)]
        ])
      ]),
      m.hideSvg ? X("", !0) : (b(), _("svg", {
        key: 0,
        class: F(i.value),
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15"
      }, po, 2))
    ], 2));
  }
});
const Nt = /* @__PURE__ */ K(go, [["__scopeId", "data-v-128f0b07"]]);
var Y5 = "top", n1 = "bottom", o1 = "right", F5 = "left", s0 = "auto", gt = [Y5, n1, o1, F5], he = "start", at = "end", vo = "clippingParents", C3 = "viewport", Fe = "popper", yo = "reference", x4 = /* @__PURE__ */ gt.reduce(function(t, e) {
  return t.concat([e + "-" + he, e + "-" + at]);
}, []), D3 = /* @__PURE__ */ [].concat(gt, [s0]).reduce(function(t, e) {
  return t.concat([e, e + "-" + he, e + "-" + at]);
}, []), wo = "beforeRead", bo = "read", xo = "afterRead", ko = "beforeMain", Mo = "main", _o = "afterMain", $o = "beforeWrite", So = "write", Co = "afterWrite", J0 = [wo, bo, xo, ko, Mo, _o, $o, So, Co];
function _1(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function K5(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function ne(t) {
  var e = K5(t).Element;
  return t instanceof e || t instanceof Element;
}
function G5(t) {
  var e = K5(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function I2(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = K5(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Do(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var L = e.styles[r] || {}, o = e.attributes[r] || {}, n = e.elements[r];
    !G5(n) || !_1(n) || (Object.assign(n.style, L), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? n.removeAttribute(a) : n.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function zo(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(L) {
      var o = e.elements[L], n = e.attributes[L] || {}, a = Object.keys(e.styles.hasOwnProperty(L) ? e.styles[L] : r[L]), s = a.reduce(function(i, l) {
        return i[l] = "", i;
      }, {});
      !G5(o) || !_1(o) || (Object.assign(o.style, s), Object.keys(n).forEach(function(i) {
        o.removeAttribute(i);
      }));
    });
  };
}
const Io = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Do,
  effect: zo,
  requires: ["computeStyles"]
};
function d1(t) {
  return t.split("-")[0];
}
var Le = Math.max, Ut = Math.min, fe = Math.round;
function Q0() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function z3() {
  return !/^((?!chrome|android).)*safari/i.test(Q0());
}
function pe(t, e, r) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  var L = t.getBoundingClientRect(), o = 1, n = 1;
  e && G5(t) && (o = t.offsetWidth > 0 && fe(L.width) / t.offsetWidth || 1, n = t.offsetHeight > 0 && fe(L.height) / t.offsetHeight || 1);
  var a = ne(t) ? K5(t) : window, s = a.visualViewport, i = !z3() && r, l = (L.left + (i && s ? s.offsetLeft : 0)) / o, u = (L.top + (i && s ? s.offsetTop : 0)) / n, c = L.width / o, v = L.height / n;
  return {
    width: c,
    height: v,
    top: u,
    right: l + c,
    bottom: u + v,
    left: l,
    x: l,
    y: u
  };
}
function T2(t) {
  var e = pe(t), r = t.offsetWidth, L = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - L) <= 1 && (L = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: L
  };
}
function I3(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && I2(r)) {
    var L = e;
    do {
      if (L && t.isSameNode(L))
        return !0;
      L = L.parentNode || L.host;
    } while (L);
  }
  return !1;
}
function f1(t) {
  return K5(t).getComputedStyle(t);
}
function To(t) {
  return ["table", "td", "th"].indexOf(_1(t)) >= 0;
}
function U1(t) {
  return ((ne(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function a0(t) {
  return _1(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (I2(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    U1(t)
  );
}
function k4(t) {
  return !G5(t) || // https://github.com/popperjs/popper-core/issues/837
  f1(t).position === "fixed" ? null : t.offsetParent;
}
function Oo(t) {
  var e = /firefox/i.test(Q0()), r = /Trident/i.test(Q0());
  if (r && G5(t)) {
    var L = f1(t);
    if (L.position === "fixed")
      return null;
  }
  var o = a0(t);
  for (I2(o) && (o = o.host); G5(o) && ["html", "body"].indexOf(_1(o)) < 0; ) {
    var n = f1(o);
    if (n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].indexOf(n.willChange) !== -1 || e && n.willChange === "filter" || e && n.filter && n.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function vt(t) {
  for (var e = K5(t), r = k4(t); r && To(r) && f1(r).position === "static"; )
    r = k4(r);
  return r && (_1(r) === "html" || _1(r) === "body" && f1(r).position === "static") ? e : r || Oo(t) || e;
}
function O2(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Xe(t, e, r) {
  return Le(t, Ut(e, r));
}
function Po(t, e, r) {
  var L = Xe(t, e, r);
  return L > r ? r : L;
}
function T3() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function O3(t) {
  return Object.assign({}, T3(), t);
}
function P3(t, e) {
  return e.reduce(function(r, L) {
    return r[L] = t, r;
  }, {});
}
var Zo = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, O3(typeof e != "number" ? e : P3(e, gt));
};
function Eo(t) {
  var e, r = t.state, L = t.name, o = t.options, n = r.elements.arrow, a = r.modifiersData.popperOffsets, s = d1(r.placement), i = O2(s), l = [F5, o1].indexOf(s) >= 0, u = l ? "height" : "width";
  if (!(!n || !a)) {
    var c = Zo(o.padding, r), v = T2(n), p = i === "y" ? Y5 : F5, m = i === "y" ? n1 : o1, f = r.rects.reference[u] + r.rects.reference[i] - a[i] - r.rects.popper[u], x = a[i] - r.rects.reference[i], y = vt(n), w = y ? i === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, g = f / 2 - x / 2, h = c[p], k = w - v[u] - c[m], M = w / 2 - v[u] / 2 + g, $ = Xe(h, M, k), C = i;
    r.modifiersData[L] = (e = {}, e[C] = $, e.centerOffset = $ - M, e);
  }
}
function Ao(t) {
  var e = t.state, r = t.options, L = r.element, o = L === void 0 ? "[data-popper-arrow]" : L;
  if (o != null && !(typeof o == "string" && (o = e.elements.popper.querySelector(o), !o))) {
    if (process.env.NODE_ENV !== "production" && (G5(o) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !I3(e.elements.popper, o)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = o;
  }
}
const No = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Eo,
  effect: Ao,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function me(t) {
  return t.split("-")[1];
}
var Ho = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Bo(t, e) {
  var r = t.x, L = t.y, o = e.devicePixelRatio || 1;
  return {
    x: fe(r * o) / o || 0,
    y: fe(L * o) / o || 0
  };
}
function M4(t) {
  var e, r = t.popper, L = t.popperRect, o = t.placement, n = t.variation, a = t.offsets, s = t.position, i = t.gpuAcceleration, l = t.adaptive, u = t.roundOffsets, c = t.isFixed, v = a.x, p = v === void 0 ? 0 : v, m = a.y, f = m === void 0 ? 0 : m, x = typeof u == "function" ? u({
    x: p,
    y: f
  }) : {
    x: p,
    y: f
  };
  p = x.x, f = x.y;
  var y = a.hasOwnProperty("x"), w = a.hasOwnProperty("y"), g = F5, h = Y5, k = window;
  if (l) {
    var M = vt(r), $ = "clientHeight", C = "clientWidth";
    if (M === K5(r) && (M = U1(r), f1(M).position !== "static" && s === "absolute" && ($ = "scrollHeight", C = "scrollWidth")), M = M, o === Y5 || (o === F5 || o === o1) && n === at) {
      h = n1;
      var D = c && M === k && k.visualViewport ? k.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        M[$]
      );
      f -= D - L.height, f *= i ? 1 : -1;
    }
    if (o === F5 || (o === Y5 || o === n1) && n === at) {
      g = o1;
      var S = c && M === k && k.visualViewport ? k.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        M[C]
      );
      p -= S - L.width, p *= i ? 1 : -1;
    }
  }
  var T = Object.assign({
    position: s
  }, l && Ho), B = u === !0 ? Bo({
    x: p,
    y: f
  }, K5(r)) : {
    x: p,
    y: f
  };
  if (p = B.x, f = B.y, i) {
    var I;
    return Object.assign({}, T, (I = {}, I[h] = w ? "0" : "", I[g] = y ? "0" : "", I.transform = (k.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + f + "px)" : "translate3d(" + p + "px, " + f + "px, 0)", I));
  }
  return Object.assign({}, T, (e = {}, e[h] = w ? f + "px" : "", e[g] = y ? p + "px" : "", e.transform = "", e));
}
function Vo(t) {
  var e = t.state, r = t.options, L = r.gpuAcceleration, o = L === void 0 ? !0 : L, n = r.adaptive, a = n === void 0 ? !0 : n, s = r.roundOffsets, i = s === void 0 ? !0 : s;
  if (process.env.NODE_ENV !== "production") {
    var l = f1(e.elements.popper).transitionProperty || "";
    a && ["transform", "top", "right", "bottom", "left"].some(function(c) {
      return l.indexOf(c) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var u = {
    placement: d1(e.placement),
    variation: me(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, M4(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a,
    roundOffsets: i
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, M4(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: i
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const Ro = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Vo,
  data: {}
};
var St = {
  passive: !0
};
function Yo(t) {
  var e = t.state, r = t.instance, L = t.options, o = L.scroll, n = o === void 0 ? !0 : o, a = L.resize, s = a === void 0 ? !0 : a, i = K5(e.elements.popper), l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return n && l.forEach(function(u) {
    u.addEventListener("scroll", r.update, St);
  }), s && i.addEventListener("resize", r.update, St), function() {
    n && l.forEach(function(u) {
      u.removeEventListener("scroll", r.update, St);
    }), s && i.removeEventListener("resize", r.update, St);
  };
}
const Fo = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Yo,
  data: {}
};
var jo = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ht(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return jo[e];
  });
}
var Wo = {
  start: "end",
  end: "start"
};
function _4(t) {
  return t.replace(/start|end/g, function(e) {
    return Wo[e];
  });
}
function P2(t) {
  var e = K5(t), r = e.pageXOffset, L = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: L
  };
}
function Z2(t) {
  return pe(U1(t)).left + P2(t).scrollLeft;
}
function Uo(t, e) {
  var r = K5(t), L = U1(t), o = r.visualViewport, n = L.clientWidth, a = L.clientHeight, s = 0, i = 0;
  if (o) {
    n = o.width, a = o.height;
    var l = z3();
    (l || !l && e === "fixed") && (s = o.offsetLeft, i = o.offsetTop);
  }
  return {
    width: n,
    height: a,
    x: s + Z2(t),
    y: i
  };
}
function Go(t) {
  var e, r = U1(t), L = P2(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, n = Le(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Le(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -L.scrollLeft + Z2(t), i = -L.scrollTop;
  return f1(o || r).direction === "rtl" && (s += Le(r.clientWidth, o ? o.clientWidth : 0) - n), {
    width: n,
    height: a,
    x: s,
    y: i
  };
}
function E2(t) {
  var e = f1(t), r = e.overflow, L = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + L);
}
function Z3(t) {
  return ["html", "body", "#document"].indexOf(_1(t)) >= 0 ? t.ownerDocument.body : G5(t) && E2(t) ? t : Z3(a0(t));
}
function Je(t, e) {
  var r;
  e === void 0 && (e = []);
  var L = Z3(t), o = L === ((r = t.ownerDocument) == null ? void 0 : r.body), n = K5(L), a = o ? [n].concat(n.visualViewport || [], E2(L) ? L : []) : L, s = e.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Je(a0(a)))
  );
}
function e2(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Ko(t, e) {
  var r = pe(t, !1, e === "fixed");
  return r.top = r.top + t.clientTop, r.left = r.left + t.clientLeft, r.bottom = r.top + t.clientHeight, r.right = r.left + t.clientWidth, r.width = t.clientWidth, r.height = t.clientHeight, r.x = r.left, r.y = r.top, r;
}
function $4(t, e, r) {
  return e === C3 ? e2(Uo(t, r)) : ne(e) ? Ko(e, r) : e2(Go(U1(t)));
}
function qo(t) {
  var e = Je(a0(t)), r = ["absolute", "fixed"].indexOf(f1(t).position) >= 0, L = r && G5(t) ? vt(t) : t;
  return ne(L) ? e.filter(function(o) {
    return ne(o) && I3(o, L) && _1(o) !== "body";
  }) : [];
}
function Xo(t, e, r, L) {
  var o = e === "clippingParents" ? qo(t) : [].concat(e), n = [].concat(o, [r]), a = n[0], s = n.reduce(function(i, l) {
    var u = $4(t, l, L);
    return i.top = Le(u.top, i.top), i.right = Ut(u.right, i.right), i.bottom = Ut(u.bottom, i.bottom), i.left = Le(u.left, i.left), i;
  }, $4(t, a, L));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function E3(t) {
  var e = t.reference, r = t.element, L = t.placement, o = L ? d1(L) : null, n = L ? me(L) : null, a = e.x + e.width / 2 - r.width / 2, s = e.y + e.height / 2 - r.height / 2, i;
  switch (o) {
    case Y5:
      i = {
        x: a,
        y: e.y - r.height
      };
      break;
    case n1:
      i = {
        x: a,
        y: e.y + e.height
      };
      break;
    case o1:
      i = {
        x: e.x + e.width,
        y: s
      };
      break;
    case F5:
      i = {
        x: e.x - r.width,
        y: s
      };
      break;
    default:
      i = {
        x: e.x,
        y: e.y
      };
  }
  var l = o ? O2(o) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (n) {
      case he:
        i[l] = i[l] - (e[u] / 2 - r[u] / 2);
        break;
      case at:
        i[l] = i[l] + (e[u] / 2 - r[u] / 2);
        break;
    }
  }
  return i;
}
function it(t, e) {
  e === void 0 && (e = {});
  var r = e, L = r.placement, o = L === void 0 ? t.placement : L, n = r.strategy, a = n === void 0 ? t.strategy : n, s = r.boundary, i = s === void 0 ? vo : s, l = r.rootBoundary, u = l === void 0 ? C3 : l, c = r.elementContext, v = c === void 0 ? Fe : c, p = r.altBoundary, m = p === void 0 ? !1 : p, f = r.padding, x = f === void 0 ? 0 : f, y = O3(typeof x != "number" ? x : P3(x, gt)), w = v === Fe ? yo : Fe, g = t.rects.popper, h = t.elements[m ? w : v], k = Xo(ne(h) ? h : h.contextElement || U1(t.elements.popper), i, u, a), M = pe(t.elements.reference), $ = E3({
    reference: M,
    element: g,
    strategy: "absolute",
    placement: o
  }), C = e2(Object.assign({}, g, $)), D = v === Fe ? C : M, S = {
    top: k.top - D.top + y.top,
    bottom: D.bottom - k.bottom + y.bottom,
    left: k.left - D.left + y.left,
    right: D.right - k.right + y.right
  }, T = t.modifiersData.offset;
  if (v === Fe && T) {
    var B = T[o];
    Object.keys(S).forEach(function(I) {
      var R = [o1, n1].indexOf(I) >= 0 ? 1 : -1, N = [Y5, n1].indexOf(I) >= 0 ? "y" : "x";
      S[I] += B[N] * R;
    });
  }
  return S;
}
function Jo(t, e) {
  e === void 0 && (e = {});
  var r = e, L = r.placement, o = r.boundary, n = r.rootBoundary, a = r.padding, s = r.flipVariations, i = r.allowedAutoPlacements, l = i === void 0 ? D3 : i, u = me(L), c = u ? s ? x4 : x4.filter(function(m) {
    return me(m) === u;
  }) : gt, v = c.filter(function(m) {
    return l.indexOf(m) >= 0;
  });
  v.length === 0 && (v = c, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var p = v.reduce(function(m, f) {
    return m[f] = it(t, {
      placement: f,
      boundary: o,
      rootBoundary: n,
      padding: a
    })[d1(f)], m;
  }, {});
  return Object.keys(p).sort(function(m, f) {
    return p[m] - p[f];
  });
}
function Qo(t) {
  if (d1(t) === s0)
    return [];
  var e = Ht(t);
  return [_4(t), e, _4(e)];
}
function es(t) {
  var e = t.state, r = t.options, L = t.name;
  if (!e.modifiersData[L]._skip) {
    for (var o = r.mainAxis, n = o === void 0 ? !0 : o, a = r.altAxis, s = a === void 0 ? !0 : a, i = r.fallbackPlacements, l = r.padding, u = r.boundary, c = r.rootBoundary, v = r.altBoundary, p = r.flipVariations, m = p === void 0 ? !0 : p, f = r.allowedAutoPlacements, x = e.options.placement, y = d1(x), w = y === x, g = i || (w || !m ? [Ht(x)] : Qo(x)), h = [x].concat(g).reduce(function(o5, i5) {
      return o5.concat(d1(i5) === s0 ? Jo(e, {
        placement: i5,
        boundary: u,
        rootBoundary: c,
        padding: l,
        flipVariations: m,
        allowedAutoPlacements: f
      }) : i5);
    }, []), k = e.rects.reference, M = e.rects.popper, $ = /* @__PURE__ */ new Map(), C = !0, D = h[0], S = 0; S < h.length; S++) {
      var T = h[S], B = d1(T), I = me(T) === he, R = [Y5, n1].indexOf(B) >= 0, N = R ? "width" : "height", H = it(e, {
        placement: T,
        boundary: u,
        rootBoundary: c,
        altBoundary: v,
        padding: l
      }), G = R ? I ? o1 : F5 : I ? n1 : Y5;
      k[N] > M[N] && (G = Ht(G));
      var e5 = Ht(G), t5 = [];
      if (n && t5.push(H[B] <= 0), s && t5.push(H[G] <= 0, H[e5] <= 0), t5.every(function(o5) {
        return o5;
      })) {
        D = T, C = !1;
        break;
      }
      $.set(T, t5);
    }
    if (C)
      for (var J = m ? 3 : 1, h5 = function(i5) {
        var k5 = h.find(function(f5) {
          var E = $.get(f5);
          if (E)
            return E.slice(0, i5).every(function(L5) {
              return L5;
            });
        });
        if (k5)
          return D = k5, "break";
      }, n5 = J; n5 > 0; n5--) {
        var _5 = h5(n5);
        if (_5 === "break")
          break;
      }
    e.placement !== D && (e.modifiersData[L]._skip = !0, e.placement = D, e.reset = !0);
  }
}
const ts = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: es,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function S4(t, e, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}
function C4(t) {
  return [Y5, o1, n1, F5].some(function(e) {
    return t[e] >= 0;
  });
}
function rs(t) {
  var e = t.state, r = t.name, L = e.rects.reference, o = e.rects.popper, n = e.modifiersData.preventOverflow, a = it(e, {
    elementContext: "reference"
  }), s = it(e, {
    altBoundary: !0
  }), i = S4(a, L), l = S4(s, o, n), u = C4(i), c = C4(l);
  e.modifiersData[r] = {
    referenceClippingOffsets: i,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: c
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": c
  });
}
const Ls = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: rs
};
function ns(t, e, r) {
  var L = d1(t), o = [F5, Y5].indexOf(L) >= 0 ? -1 : 1, n = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, a = n[0], s = n[1];
  return a = a || 0, s = (s || 0) * o, [F5, o1].indexOf(L) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function os(t) {
  var e = t.state, r = t.options, L = t.name, o = r.offset, n = o === void 0 ? [0, 0] : o, a = D3.reduce(function(u, c) {
    return u[c] = ns(c, e.rects, n), u;
  }, {}), s = a[e.placement], i = s.x, l = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += i, e.modifiersData.popperOffsets.y += l), e.modifiersData[L] = a;
}
const ss = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: os
};
function as(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = E3({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const is = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: as,
  data: {}
};
function ls(t) {
  return t === "x" ? "y" : "x";
}
function us(t) {
  var e = t.state, r = t.options, L = t.name, o = r.mainAxis, n = o === void 0 ? !0 : o, a = r.altAxis, s = a === void 0 ? !1 : a, i = r.boundary, l = r.rootBoundary, u = r.altBoundary, c = r.padding, v = r.tether, p = v === void 0 ? !0 : v, m = r.tetherOffset, f = m === void 0 ? 0 : m, x = it(e, {
    boundary: i,
    rootBoundary: l,
    padding: c,
    altBoundary: u
  }), y = d1(e.placement), w = me(e.placement), g = !w, h = O2(y), k = ls(h), M = e.modifiersData.popperOffsets, $ = e.rects.reference, C = e.rects.popper, D = typeof f == "function" ? f(Object.assign({}, e.rects, {
    placement: e.placement
  })) : f, S = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), T = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, B = {
    x: 0,
    y: 0
  };
  if (M) {
    if (n) {
      var I, R = h === "y" ? Y5 : F5, N = h === "y" ? n1 : o1, H = h === "y" ? "height" : "width", G = M[h], e5 = G + x[R], t5 = G - x[N], J = p ? -C[H] / 2 : 0, h5 = w === he ? $[H] : C[H], n5 = w === he ? -C[H] : -$[H], _5 = e.elements.arrow, o5 = p && _5 ? T2(_5) : {
        width: 0,
        height: 0
      }, i5 = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : T3(), k5 = i5[R], f5 = i5[N], E = Xe(0, $[H], o5[H]), L5 = g ? $[H] / 2 - J - E - k5 - S.mainAxis : h5 - E - k5 - S.mainAxis, g5 = g ? -$[H] / 2 + J + E + f5 + S.mainAxis : n5 + E + f5 + S.mainAxis, z = e.elements.arrow && vt(e.elements.arrow), A = z ? h === "y" ? z.clientTop || 0 : z.clientLeft || 0 : 0, Y = (I = T == null ? void 0 : T[h]) != null ? I : 0, W = G + L5 - Y - A, q = G + g5 - Y, d5 = Xe(p ? Ut(e5, W) : e5, G, p ? Le(t5, q) : t5);
      M[h] = d5, B[h] = d5 - G;
    }
    if (s) {
      var E1, q1 = h === "x" ? Y5 : F5, X1 = h === "x" ? n1 : o1, b1 = M[k], x1 = k === "y" ? "height" : "width", j5 = b1 + x[q1], i1 = b1 - x[X1], D5 = [Y5, F5].indexOf(y) !== -1, H5 = (E1 = T == null ? void 0 : T[k]) != null ? E1 : 0, le = D5 ? j5 : b1 - $[x1] - C[x1] - H5 + S.altAxis, ue = D5 ? b1 + $[x1] + C[x1] - H5 - S.altAxis : i1, Be = p && D5 ? Po(le, b1, ue) : Xe(p ? le : j5, b1, p ? ue : i1);
      M[k] = Be, B[k] = Be - b1;
    }
    e.modifiersData[L] = B;
  }
}
const ds = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: us,
  requiresIfExists: ["offset"]
};
function cs(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function hs(t) {
  return t === K5(t) || !G5(t) ? P2(t) : cs(t);
}
function fs(t) {
  var e = t.getBoundingClientRect(), r = fe(e.width) / t.offsetWidth || 1, L = fe(e.height) / t.offsetHeight || 1;
  return r !== 1 || L !== 1;
}
function ps(t, e, r) {
  r === void 0 && (r = !1);
  var L = G5(e), o = G5(e) && fs(e), n = U1(e), a = pe(t, o, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = {
    x: 0,
    y: 0
  };
  return (L || !L && !r) && ((_1(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  E2(n)) && (s = hs(e)), G5(e) ? (i = pe(e, !0), i.x += e.clientLeft, i.y += e.clientTop) : n && (i.x = Z2(n))), {
    x: a.left + s.scrollLeft - i.x,
    y: a.top + s.scrollTop - i.y,
    width: a.width,
    height: a.height
  };
}
function ms(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), L = [];
  t.forEach(function(n) {
    e.set(n.name, n);
  });
  function o(n) {
    r.add(n.name);
    var a = [].concat(n.requires || [], n.requiresIfExists || []);
    a.forEach(function(s) {
      if (!r.has(s)) {
        var i = e.get(s);
        i && o(i);
      }
    }), L.push(n);
  }
  return t.forEach(function(n) {
    r.has(n.name) || o(n);
  }), L;
}
function gs(t) {
  var e = ms(t);
  return J0.reduce(function(r, L) {
    return r.concat(e.filter(function(o) {
      return o.phase === L;
    }));
  }, []);
}
function vs(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function N1(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), L = 1; L < e; L++)
    r[L - 1] = arguments[L];
  return [].concat(r).reduce(function(o, n) {
    return o.replace(/%s/, n);
  }, t);
}
var J1 = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', ys = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', D4 = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function ws(t) {
  t.forEach(function(e) {
    [].concat(Object.keys(e), D4).filter(function(r, L, o) {
      return o.indexOf(r) === L;
    }).forEach(function(r) {
      switch (r) {
        case "name":
          typeof e.name != "string" && console.error(N1(J1, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(N1(J1, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
          break;
        case "phase":
          J0.indexOf(e.phase) < 0 && console.error(N1(J1, e.name, '"phase"', "either " + J0.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(N1(J1, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          e.effect != null && typeof e.effect != "function" && console.error(N1(J1, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          e.requires != null && !Array.isArray(e.requires) && console.error(N1(J1, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(N1(J1, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + D4.map(function(L) {
            return '"' + L + '"';
          }).join(", ") + '; but "' + r + '" was provided.');
      }
      e.requires && e.requires.forEach(function(L) {
        t.find(function(o) {
          return o.name === L;
        }) == null && console.error(N1(ys, String(e.name), L, L));
      });
    });
  });
}
function bs(t, e) {
  var r = /* @__PURE__ */ new Set();
  return t.filter(function(L) {
    var o = e(L);
    if (!r.has(o))
      return r.add(o), !0;
  });
}
function xs(t) {
  var e = t.reduce(function(r, L) {
    var o = r[L.name];
    return r[L.name] = o ? Object.assign({}, o, L, {
      options: Object.assign({}, o.options, L.options),
      data: Object.assign({}, o.data, L.data)
    }) : L, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var z4 = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", ks = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", I4 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function T4() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(L) {
    return !(L && typeof L.getBoundingClientRect == "function");
  });
}
function Ms(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, L = r === void 0 ? [] : r, o = e.defaultOptions, n = o === void 0 ? I4 : o;
  return function(s, i, l) {
    l === void 0 && (l = n);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, I4, n),
      modifiersData: {},
      elements: {
        reference: s,
        popper: i
      },
      attributes: {},
      styles: {}
    }, c = [], v = !1, p = {
      state: u,
      setOptions: function(y) {
        var w = typeof y == "function" ? y(u.options) : y;
        f(), u.options = Object.assign({}, n, u.options, w), u.scrollParents = {
          reference: ne(s) ? Je(s) : s.contextElement ? Je(s.contextElement) : [],
          popper: Je(i)
        };
        var g = gs(xs([].concat(L, u.options.modifiers)));
        if (u.orderedModifiers = g.filter(function(T) {
          return T.enabled;
        }), process.env.NODE_ENV !== "production") {
          var h = bs([].concat(g, u.options.modifiers), function(T) {
            var B = T.name;
            return B;
          });
          if (ws(h), d1(u.options.placement) === s0) {
            var k = u.orderedModifiers.find(function(T) {
              var B = T.name;
              return B === "flip";
            });
            k || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var M = f1(i), $ = M.marginTop, C = M.marginRight, D = M.marginBottom, S = M.marginLeft;
          [$, C, D, S].some(function(T) {
            return parseFloat(T);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return m(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!v) {
          var y = u.elements, w = y.reference, g = y.popper;
          if (!T4(w, g)) {
            process.env.NODE_ENV !== "production" && console.error(z4);
            return;
          }
          u.rects = {
            reference: ps(w, vt(g), u.options.strategy === "fixed"),
            popper: T2(g)
          }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(T) {
            return u.modifiersData[T.name] = Object.assign({}, T.data);
          });
          for (var h = 0, k = 0; k < u.orderedModifiers.length; k++) {
            if (process.env.NODE_ENV !== "production" && (h += 1, h > 100)) {
              console.error(ks);
              break;
            }
            if (u.reset === !0) {
              u.reset = !1, k = -1;
              continue;
            }
            var M = u.orderedModifiers[k], $ = M.fn, C = M.options, D = C === void 0 ? {} : C, S = M.name;
            typeof $ == "function" && (u = $({
              state: u,
              options: D,
              name: S,
              instance: p
            }) || u);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: vs(function() {
        return new Promise(function(x) {
          p.forceUpdate(), x(u);
        });
      }),
      destroy: function() {
        f(), v = !0;
      }
    };
    if (!T4(s, i))
      return process.env.NODE_ENV !== "production" && console.error(z4), p;
    p.setOptions(l).then(function(x) {
      !v && l.onFirstUpdate && l.onFirstUpdate(x);
    });
    function m() {
      u.orderedModifiers.forEach(function(x) {
        var y = x.name, w = x.options, g = w === void 0 ? {} : w, h = x.effect;
        if (typeof h == "function") {
          var k = h({
            state: u,
            name: y,
            instance: p,
            options: g
          }), M = function() {
          };
          c.push(k || M);
        }
      });
    }
    function f() {
      c.forEach(function(x) {
        return x();
      }), c = [];
    }
    return p;
  };
}
var _s = [Fo, is, Ro, Io, ss, ts, ds, No, Ls], $s = /* @__PURE__ */ Ms({
  defaultModifiers: _s
});
const Ss = Object.defineProperty, Cs = Object.defineProperties, Ds = Object.getOwnPropertyDescriptors, Gt = Object.getOwnPropertySymbols, A3 = Object.prototype.hasOwnProperty, N3 = Object.prototype.propertyIsEnumerable, O4 = (t, e, r) => e in t ? Ss(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: r
}) : t[e] = r, j = (t, e) => {
  for (var r in e || (e = {}))
    A3.call(e, r) && O4(t, r, e[r]);
  if (Gt)
    for (var r of Gt(e))
      N3.call(e, r) && O4(t, r, e[r]);
  return t;
}, a5 = (t, e) => Cs(t, Ds(e)), zs = (t, e) => {
  const r = {};
  for (var L in t)
    A3.call(t, L) && e.indexOf(L) < 0 && (r[L] = t[L]);
  if (t != null && Gt)
    for (var L of Gt(t))
      e.indexOf(L) < 0 && N3.call(t, L) && (r[L] = t[L]);
  return r;
};
function $1(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  const e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function P5(t, e) {
  if (e.length < t)
    throw new TypeError(
      t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present"
    );
}
function Z1(t) {
  P5(1, arguments);
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn(
    "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"
  ), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function k1(t, e) {
  P5(2, arguments);
  const r = Z1(t), L = $1(e);
  return isNaN(L) ? /* @__PURE__ */ new Date(NaN) : (L && r.setDate(r.getDate() + L), r);
}
function t2(t, e) {
  P5(2, arguments);
  const r = Z1(t), L = $1(e);
  if (isNaN(L))
    return /* @__PURE__ */ new Date(NaN);
  if (!L)
    return r;
  const o = r.getDate(), n = new Date(r.getTime());
  n.setMonth(r.getMonth() + L + 1, 0);
  const a = n.getDate();
  return o >= a ? n : (r.setFullYear(
    n.getFullYear(),
    n.getMonth(),
    o
  ), r);
}
function P4(t, e) {
  P5(2, arguments);
  const r = $1(e);
  return t2(t, r * 12);
}
const Ct = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Is = typeof Ct == "object" && Ct && Ct.Object === Object && Ct, H3 = Is, Ts = H3, Os = typeof self == "object" && self && self.Object === Object && self, Ps = Ts || Os || Function("return this")(), C1 = Ps, Zs = C1, Es = Zs.Symbol, Se = Es, Z4 = Se, B3 = Object.prototype, As = B3.hasOwnProperty, Ns = B3.toString, je = Z4 ? Z4.toStringTag : void 0;
function Hs(t) {
  const e = As.call(t, je), r = t[je];
  try {
    t[je] = void 0;
    var L = !0;
  } catch {
  }
  const o = Ns.call(t);
  return L && (e ? t[je] = r : delete t[je]), o;
}
const Bs = Hs, Vs = Object.prototype, Rs = Vs.toString;
function Ys(t) {
  return Rs.call(t);
}
const Fs = Ys, E4 = Se, js = Bs, Ws = Fs, Us = "[object Null]", Gs = "[object Undefined]", A4 = E4 ? E4.toStringTag : void 0;
function Ks(t) {
  return t == null ? t === void 0 ? Gs : Us : A4 && A4 in Object(t) ? js(t) : Ws(t);
}
const D1 = Ks;
function qs(t) {
  return t != null && typeof t == "object";
}
const q5 = qs, Xs = D1, Js = q5, Qs = "[object Boolean]";
function e7(t) {
  return t === !0 || t === !1 || Js(t) && Xs(t) == Qs;
}
const t7 = e7, r7 = D1, L7 = q5, n7 = "[object Number]";
function o7(t) {
  return typeof t == "number" || L7(t) && r7(t) == n7;
}
const Qe = o7, s7 = Array.isArray, X5 = s7, a7 = D1, i7 = X5, l7 = q5, u7 = "[object String]";
function d7(t) {
  return typeof t == "string" || !i7(t) && l7(t) && a7(t) == u7;
}
const R1 = d7;
function c7(t) {
  const e = typeof t;
  return t != null && (e == "object" || e == "function");
}
const a1 = c7, h7 = D1, f7 = a1, p7 = "[object AsyncFunction]", m7 = "[object Function]", g7 = "[object GeneratorFunction]", v7 = "[object Proxy]";
function y7(t) {
  if (!f7(t))
    return !1;
  const e = h7(t);
  return e == m7 || e == g7 || e == p7 || e == v7;
}
const O1 = y7, w7 = 9007199254740991;
function b7(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= w7;
}
const A2 = b7, x7 = O1, k7 = A2;
function M7(t) {
  return t != null && k7(t.length) && !x7(t);
}
const yt = M7, _7 = yt, $7 = q5;
function S7(t) {
  return $7(t) && _7(t);
}
const V5 = S7;
function C7(t) {
  return t === void 0;
}
const D7 = C7, z7 = D1, I7 = q5, T7 = "[object Date]";
function O7(t) {
  return I7(t) && z7(t) == T7;
}
const P7 = O7;
function Z7(t) {
  return function(e) {
    return t(e);
  };
}
const i0 = Z7, ge = { exports: {} };
(function(t, e) {
  const r = H3, L = e && !e.nodeType && e, o = L && !0 && t && !t.nodeType && t, a = o && o.exports === L && r.process, s = function() {
    try {
      const i = o && o.require && o.require("util").types;
      return i || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  t.exports = s;
})(ge, ge.exports);
const E7 = P7, A7 = i0, N4 = ge.exports, H4 = N4 && N4.isDate, N7 = H4 ? A7(H4) : E7, H7 = N7;
function B7(t, e, r) {
  return t === t && (r !== void 0 && (t = t <= r ? t : r), e !== void 0 && (t = t >= e ? t : e)), t;
}
const V7 = B7, R7 = D1, Y7 = q5, F7 = "[object Symbol]";
function j7(t) {
  return typeof t == "symbol" || Y7(t) && R7(t) == F7;
}
const l0 = j7, B4 = a1, W7 = l0, V4 = 0 / 0, U7 = /^\s+|\s+$/g, G7 = /^[-+]0x[0-9a-f]+$/i, K7 = /^0b[01]+$/i, q7 = /^0o[0-7]+$/i, X7 = parseInt;
function J7(t) {
  if (typeof t == "number")
    return t;
  if (W7(t))
    return V4;
  if (B4(t)) {
    const r = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = B4(r) ? r + "" : r;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(U7, "");
  const e = K7.test(t);
  return e || q7.test(t) ? X7(t.slice(2), e ? 2 : 8) : G7.test(t) ? V4 : +t;
}
const Q7 = J7, ea = V7, C0 = Q7;
function ta(t, e, r) {
  return r === void 0 && (r = e, e = void 0), r !== void 0 && (r = C0(r), r = r === r ? r : 0), e !== void 0 && (e = C0(e), e = e === e ? e : 0), ea(C0(t), e, r);
}
const ra = ta, La = X5, na = l0, oa = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, sa = /^\w*$/;
function aa(t, e) {
  if (La(t))
    return !1;
  const r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || na(t) ? !0 : sa.test(t) || !oa.test(t) || e != null && t in Object(e);
}
const N2 = aa, ia = C1, la = ia["__core-js_shared__"], ua = la, D0 = ua, R4 = function() {
  const t = /[^.]+$/.exec(
    D0 && D0.keys && D0.keys.IE_PROTO || ""
  );
  return t ? "Symbol(src)_1." + t : "";
}();
function da(t) {
  return !!R4 && R4 in t;
}
const ca = da, ha = Function.prototype, fa = ha.toString;
function pa(t) {
  if (t != null) {
    try {
      return fa.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
const V3 = pa, ma = O1, ga = ca, va = a1, ya = V3, wa = /[\\^$.*+?()[\]{}|]/g, ba = /^\[object .+?Constructor\]$/, xa = Function.prototype, ka = Object.prototype, Ma = xa.toString, _a = ka.hasOwnProperty, $a = RegExp(
  "^" + Ma.call(_a).replace(wa, "\\$&").replace(
    /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
    "$1.*?"
  ) + "$"
);
function Sa(t) {
  return !va(t) || ga(t) ? !1 : (ma(t) ? $a : ba).test(ya(t));
}
const Ca = Sa;
function Da(t, e) {
  return t == null ? void 0 : t[e];
}
const za = Da, Ia = Ca, Ta = za;
function Oa(t, e) {
  const r = Ta(t, e);
  return Ia(r) ? r : void 0;
}
const ie = Oa, Pa = ie, Za = Pa(Object, "create"), u0 = Za, Y4 = u0;
function Ea() {
  this.__data__ = Y4 ? Y4(null) : {}, this.size = 0;
}
const Aa = Ea;
function Na(t) {
  const e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
const Ha = Na, Ba = u0, Va = "__lodash_hash_undefined__", Ra = Object.prototype, Ya = Ra.hasOwnProperty;
function Fa(t) {
  const e = this.__data__;
  if (Ba) {
    const r = e[t];
    return r === Va ? void 0 : r;
  }
  return Ya.call(e, t) ? e[t] : void 0;
}
const ja = Fa, Wa = u0, Ua = Object.prototype, Ga = Ua.hasOwnProperty;
function Ka(t) {
  const e = this.__data__;
  return Wa ? e[t] !== void 0 : Ga.call(e, t);
}
const qa = Ka, Xa = u0, Ja = "__lodash_hash_undefined__";
function Qa(t, e) {
  const r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = Xa && e === void 0 ? Ja : e, this;
}
const e9 = Qa, t9 = Aa, r9 = Ha, L9 = ja, n9 = qa, o9 = e9;
function Ce(t) {
  let e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    const L = t[e];
    this.set(L[0], L[1]);
  }
}
Ce.prototype.clear = t9;
Ce.prototype.delete = r9;
Ce.prototype.get = L9;
Ce.prototype.has = n9;
Ce.prototype.set = o9;
const s9 = Ce;
function a9() {
  this.__data__ = [], this.size = 0;
}
const i9 = a9;
function l9(t, e) {
  return t === e || t !== t && e !== e;
}
const De = l9, u9 = De;
function d9(t, e) {
  let r = t.length;
  for (; r--; )
    if (u9(t[r][0], e))
      return r;
  return -1;
}
const d0 = d9, c9 = d0, h9 = Array.prototype, f9 = h9.splice;
function p9(t) {
  const e = this.__data__, r = c9(e, t);
  if (r < 0)
    return !1;
  const L = e.length - 1;
  return r == L ? e.pop() : f9.call(e, r, 1), --this.size, !0;
}
const m9 = p9, g9 = d0;
function v9(t) {
  const e = this.__data__, r = g9(e, t);
  return r < 0 ? void 0 : e[r][1];
}
const y9 = v9, w9 = d0;
function b9(t) {
  return w9(this.__data__, t) > -1;
}
const x9 = b9, k9 = d0;
function M9(t, e) {
  const r = this.__data__, L = k9(r, t);
  return L < 0 ? (++this.size, r.push([t, e])) : r[L][1] = e, this;
}
const _9 = M9, $9 = i9, S9 = m9, C9 = y9, D9 = x9, z9 = _9;
function ze(t) {
  let e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    const L = t[e];
    this.set(L[0], L[1]);
  }
}
ze.prototype.clear = $9;
ze.prototype.delete = S9;
ze.prototype.get = C9;
ze.prototype.has = D9;
ze.prototype.set = z9;
const c0 = ze, I9 = ie, T9 = C1, O9 = I9(T9, "Map"), H2 = O9, F4 = s9, P9 = c0, Z9 = H2;
function E9() {
  this.size = 0, this.__data__ = {
    hash: new F4(),
    map: new (Z9 || P9)(),
    string: new F4()
  };
}
const A9 = E9;
function N9(t) {
  const e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
const H9 = N9, B9 = H9;
function V9(t, e) {
  const r = t.__data__;
  return B9(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
const h0 = V9, R9 = h0;
function Y9(t) {
  const e = R9(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
const F9 = Y9, j9 = h0;
function W9(t) {
  return j9(this, t).get(t);
}
const U9 = W9, G9 = h0;
function K9(t) {
  return G9(this, t).has(t);
}
const q9 = K9, X9 = h0;
function J9(t, e) {
  const r = X9(this, t), L = r.size;
  return r.set(t, e), this.size += r.size == L ? 0 : 1, this;
}
const Q9 = J9, ei = A9, ti = F9, ri = U9, Li = q9, ni = Q9;
function Ie(t) {
  let e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    const L = t[e];
    this.set(L[0], L[1]);
  }
}
Ie.prototype.clear = ei;
Ie.prototype.delete = ti;
Ie.prototype.get = ri;
Ie.prototype.has = Li;
Ie.prototype.set = ni;
const B2 = Ie, R3 = B2, oi = "Expected a function";
function V2(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(oi);
  var r = function() {
    const L = arguments, o = e ? e.apply(this, L) : L[0], n = r.cache;
    if (n.has(o))
      return n.get(o);
    const a = t.apply(this, L);
    return r.cache = n.set(o, a) || n, a;
  };
  return r.cache = new (V2.Cache || R3)(), r;
}
V2.Cache = R3;
const si = V2, ai = si, ii = 500;
function li(t) {
  const e = ai(t, function(L) {
    return r.size === ii && r.clear(), L;
  });
  var r = e.cache;
  return e;
}
const ui = li, di = ui, ci = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hi = /\\(\\)?/g, fi = di(function(t) {
  const e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(ci, function(r, L, o, n) {
    e.push(o ? n.replace(hi, "$1") : L || r);
  }), e;
}), pi = fi;
function mi(t, e) {
  let r = -1, L = t == null ? 0 : t.length, o = Array(L);
  for (; ++r < L; )
    o[r] = e(t[r], r, t);
  return o;
}
const R2 = mi, j4 = Se, gi = R2, vi = X5, yi = l0, wi = 1 / 0, W4 = j4 ? j4.prototype : void 0, U4 = W4 ? W4.toString : void 0;
function Y3(t) {
  if (typeof t == "string")
    return t;
  if (vi(t))
    return gi(t, Y3) + "";
  if (yi(t))
    return U4 ? U4.call(t) : "";
  const e = t + "";
  return e == "0" && 1 / t == -wi ? "-0" : e;
}
const bi = Y3, xi = bi;
function ki(t) {
  return t == null ? "" : xi(t);
}
const Mi = ki, _i = X5, $i = N2, Si = pi, Ci = Mi;
function Di(t, e) {
  return _i(t) ? t : $i(t, e) ? [t] : Si(Ci(t));
}
const Te = Di, zi = l0, Ii = 1 / 0;
function Ti(t) {
  if (typeof t == "string" || zi(t))
    return t;
  const e = t + "";
  return e == "0" && 1 / t == -Ii ? "-0" : e;
}
const Oe = Ti, Oi = Te, Pi = Oe;
function Zi(t, e) {
  e = Oi(e, t);
  let r = 0, L = e.length;
  for (; t != null && r < L; )
    t = t[Pi(e[r++])];
  return r && r == L ? t : void 0;
}
const f0 = Zi, Ei = f0;
function Ai(t, e, r) {
  const L = t == null ? void 0 : Ei(t, e);
  return L === void 0 ? r : L;
}
const lt = Ai, Ni = ie, Hi = function() {
  try {
    const t = Ni(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), F3 = Hi, G4 = F3;
function Bi(t, e, r) {
  e == "__proto__" && G4 ? G4(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
const p0 = Bi, Vi = p0, Ri = De, Yi = Object.prototype, Fi = Yi.hasOwnProperty;
function ji(t, e, r) {
  const L = t[e];
  (!(Fi.call(t, e) && Ri(L, r)) || r === void 0 && !(e in t)) && Vi(t, e, r);
}
const Y2 = ji, Wi = 9007199254740991, Ui = /^(?:0|[1-9]\d*)$/;
function Gi(t, e) {
  const r = typeof t;
  return e = e ?? Wi, !!e && (r == "number" || r != "symbol" && Ui.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
const m0 = Gi, Ki = Y2, qi = Te, Xi = m0, K4 = a1, Ji = Oe;
function Qi(t, e, r, L) {
  if (!K4(t))
    return t;
  e = qi(e, t);
  let o = -1, n = e.length, a = n - 1, s = t;
  for (; s != null && ++o < n; ) {
    let i = Ji(e[o]), l = r;
    if (i === "__proto__" || i === "constructor" || i === "prototype")
      return t;
    if (o != a) {
      const u = s[i];
      l = L ? L(u, i, s) : void 0, l === void 0 && (l = K4(u) ? u : Xi(e[o + 1]) ? [] : {});
    }
    Ki(s, i, l), s = s[i];
  }
  return t;
}
const j3 = Qi, e8 = j3;
function t8(t, e, r) {
  return t == null ? t : e8(t, e, r);
}
const r8 = t8;
function L8(t) {
  return function(e, r, L) {
    let o = -1, n = Object(e), a = L(e), s = a.length;
    for (; s--; ) {
      const i = a[t ? s : ++o];
      if (r(n[i], i, n) === !1)
        break;
    }
    return e;
  };
}
const n8 = L8, o8 = n8, s8 = o8(), W3 = s8;
function a8(t, e) {
  let r = -1, L = Array(t);
  for (; ++r < t; )
    L[r] = e(r);
  return L;
}
const i8 = a8, l8 = D1, u8 = q5, d8 = "[object Arguments]";
function c8(t) {
  return u8(t) && l8(t) == d8;
}
const h8 = c8, q4 = h8, f8 = q5, U3 = Object.prototype, p8 = U3.hasOwnProperty, m8 = U3.propertyIsEnumerable, g8 = q4(
  function() {
    return arguments;
  }()
) ? q4 : function(t) {
  return f8(t) && p8.call(t, "callee") && !m8.call(t, "callee");
}, g0 = g8, ve = { exports: {} };
function v8() {
  return !1;
}
const y8 = v8;
(function(t, e) {
  const r = C1, L = y8, o = e && !e.nodeType && e, n = o && !0 && t && !t.nodeType && t, s = n && n.exports === o ? r.Buffer : void 0, l = (s ? s.isBuffer : void 0) || L;
  t.exports = l;
})(ve, ve.exports);
const w8 = D1, b8 = A2, x8 = q5, k8 = "[object Arguments]", M8 = "[object Array]", _8 = "[object Boolean]", $8 = "[object Date]", S8 = "[object Error]", C8 = "[object Function]", D8 = "[object Map]", z8 = "[object Number]", I8 = "[object Object]", T8 = "[object RegExp]", O8 = "[object Set]", P8 = "[object String]", Z8 = "[object WeakMap]", E8 = "[object ArrayBuffer]", A8 = "[object DataView]", N8 = "[object Float32Array]", H8 = "[object Float64Array]", B8 = "[object Int8Array]", V8 = "[object Int16Array]", R8 = "[object Int32Array]", Y8 = "[object Uint8Array]", F8 = "[object Uint8ClampedArray]", j8 = "[object Uint16Array]", W8 = "[object Uint32Array]", w5 = {};
w5[N8] = w5[H8] = w5[B8] = w5[V8] = w5[R8] = w5[Y8] = w5[F8] = w5[j8] = w5[W8] = !0;
w5[k8] = w5[M8] = w5[E8] = w5[_8] = w5[A8] = w5[$8] = w5[S8] = w5[C8] = w5[D8] = w5[z8] = w5[I8] = w5[T8] = w5[O8] = w5[P8] = w5[Z8] = !1;
function U8(t) {
  return x8(t) && b8(t.length) && !!w5[w8(t)];
}
const G8 = U8, K8 = G8, q8 = i0, X4 = ge.exports, J4 = X4 && X4.isTypedArray, X8 = J4 ? q8(J4) : K8, F2 = X8, J8 = i8, Q8 = g0, el = X5, tl = ve.exports, rl = m0, Ll = F2, nl = Object.prototype, ol = nl.hasOwnProperty;
function sl(t, e) {
  const r = el(t), L = !r && Q8(t), o = !r && !L && tl(t), n = !r && !L && !o && Ll(t), a = r || L || o || n, s = a ? J8(t.length, String) : [], i = s.length;
  for (const l in t)
    (e || ol.call(t, l)) && !(a && (l == "length" || o && (l == "offset" || l == "parent") || n && (l == "buffer" || l == "byteLength" || l == "byteOffset") || rl(l, i))) && s.push(l);
  return s;
}
const G3 = sl, al = Object.prototype;
function il(t) {
  const e = t && t.constructor, r = typeof e == "function" && e.prototype || al;
  return t === r;
}
const j2 = il;
function ll(t, e) {
  return function(r) {
    return t(e(r));
  };
}
const K3 = ll, ul = K3, dl = ul(Object.keys, Object), cl = dl, hl = j2, fl = cl, pl = Object.prototype, ml = pl.hasOwnProperty;
function gl(t) {
  if (!hl(t))
    return fl(t);
  const e = [];
  for (const r in Object(t))
    ml.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
const vl = gl, yl = G3, wl = vl, bl = yt;
function xl(t) {
  return bl(t) ? yl(t) : wl(t);
}
const Pe = xl, kl = W3, Ml = Pe;
function _l(t, e) {
  return t && kl(t, e, Ml);
}
const q3 = _l, $l = c0;
function Sl() {
  this.__data__ = new $l(), this.size = 0;
}
const Cl = Sl;
function Dl(t) {
  const e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
const zl = Dl;
function Il(t) {
  return this.__data__.get(t);
}
const Tl = Il;
function Ol(t) {
  return this.__data__.has(t);
}
const Pl = Ol, Zl = c0, El = H2, Al = B2, Nl = 200;
function Hl(t, e) {
  let r = this.__data__;
  if (r instanceof Zl) {
    const L = r.__data__;
    if (!El || L.length < Nl - 1)
      return L.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Al(L);
  }
  return r.set(t, e), this.size = r.size, this;
}
const Bl = Hl, Vl = c0, Rl = Cl, Yl = zl, Fl = Tl, jl = Pl, Wl = Bl;
function Ze(t) {
  const e = this.__data__ = new Vl(t);
  this.size = e.size;
}
Ze.prototype.clear = Rl;
Ze.prototype.delete = Yl;
Ze.prototype.get = Fl;
Ze.prototype.has = jl;
Ze.prototype.set = Wl;
const v0 = Ze, Ul = "__lodash_hash_undefined__";
function Gl(t) {
  return this.__data__.set(t, Ul), this;
}
const Kl = Gl;
function ql(t) {
  return this.__data__.has(t);
}
const Xl = ql, Jl = B2, Ql = Kl, eu = Xl;
function Kt(t) {
  let e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new Jl(); ++e < r; )
    this.add(t[e]);
}
Kt.prototype.add = Kt.prototype.push = Ql;
Kt.prototype.has = eu;
const tu = Kt;
function ru(t, e) {
  let r = -1, L = t == null ? 0 : t.length;
  for (; ++r < L; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
const X3 = ru;
function Lu(t, e) {
  return t.has(e);
}
const nu = Lu, ou = tu, su = X3, au = nu, iu = 1, lu = 2;
function uu(t, e, r, L, o, n) {
  const a = r & iu, s = t.length, i = e.length;
  if (s != i && !(a && i > s))
    return !1;
  const l = n.get(t), u = n.get(e);
  if (l && u)
    return l == e && u == t;
  let c = -1, v = !0, p = r & lu ? new ou() : void 0;
  for (n.set(t, e), n.set(e, t); ++c < s; ) {
    var m = t[c], f = e[c];
    if (L)
      var x = a ? L(f, m, c, e, t, n) : L(m, f, c, t, e, n);
    if (x !== void 0) {
      if (x)
        continue;
      v = !1;
      break;
    }
    if (p) {
      if (!su(e, function(y, w) {
        if (!au(p, w) && (m === y || o(m, y, r, L, n)))
          return p.push(w);
      })) {
        v = !1;
        break;
      }
    } else if (!(m === f || o(m, f, r, L, n))) {
      v = !1;
      break;
    }
  }
  return n.delete(t), n.delete(e), v;
}
const J3 = uu, du = C1, cu = du.Uint8Array, Q3 = cu;
function hu(t) {
  let e = -1, r = Array(t.size);
  return t.forEach(function(L, o) {
    r[++e] = [o, L];
  }), r;
}
const er = hu;
function fu(t) {
  let e = -1, r = Array(t.size);
  return t.forEach(function(L) {
    r[++e] = L;
  }), r;
}
const pu = fu, Q4 = Se, e6 = Q3, mu = De, gu = J3, vu = er, yu = pu, wu = 1, bu = 2, xu = "[object Boolean]", ku = "[object Date]", Mu = "[object Error]", _u = "[object Map]", $u = "[object Number]", Su = "[object RegExp]", Cu = "[object Set]", Du = "[object String]", zu = "[object Symbol]", Iu = "[object ArrayBuffer]", Tu = "[object DataView]", t6 = Q4 ? Q4.prototype : void 0, z0 = t6 ? t6.valueOf : void 0;
function Ou(t, e, r, L, o, n, a) {
  switch (r) {
    case Tu:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case Iu:
      return !(t.byteLength != e.byteLength || !n(new e6(t), new e6(e)));
    case xu:
    case ku:
    case $u:
      return mu(+t, +e);
    case Mu:
      return t.name == e.name && t.message == e.message;
    case Su:
    case Du:
      return t == e + "";
    case _u:
      var s = vu;
    case Cu:
      var i = L & wu;
      if (s || (s = yu), t.size != e.size && !i)
        return !1;
      var l = a.get(t);
      if (l)
        return l == e;
      L |= bu, a.set(t, e);
      var u = gu(
        s(t),
        s(e),
        L,
        o,
        n,
        a
      );
      return a.delete(t), u;
    case zu:
      if (z0)
        return z0.call(t) == z0.call(e);
  }
  return !1;
}
const Pu = Ou;
function Zu(t, e) {
  let r = -1, L = e.length, o = t.length;
  for (; ++r < L; )
    t[o + r] = e[r];
  return t;
}
const W2 = Zu, Eu = W2, Au = X5;
function Nu(t, e, r) {
  const L = e(t);
  return Au(t) ? L : Eu(L, r(t));
}
const tr = Nu;
function Hu(t, e) {
  let r = -1, L = t == null ? 0 : t.length, o = 0, n = [];
  for (; ++r < L; ) {
    const a = t[r];
    e(a, r, t) && (n[o++] = a);
  }
  return n;
}
const Bu = Hu;
function Vu() {
  return [];
}
const rr = Vu, Ru = Bu, Yu = rr, Fu = Object.prototype, ju = Fu.propertyIsEnumerable, r6 = Object.getOwnPropertySymbols, Wu = r6 ? function(t) {
  return t == null ? [] : (t = Object(t), Ru(r6(t), function(e) {
    return ju.call(t, e);
  }));
} : Yu, U2 = Wu, Uu = tr, Gu = U2, Ku = Pe;
function qu(t) {
  return Uu(t, Ku, Gu);
}
const Lr = qu, L6 = Lr, Xu = 1, Ju = Object.prototype, Qu = Ju.hasOwnProperty;
function ed(t, e, r, L, o, n) {
  const a = r & Xu, s = L6(t), i = s.length, l = L6(e), u = l.length;
  if (i != u && !a)
    return !1;
  let c = i;
  for (; c--; ) {
    var v = s[c];
    if (!(a ? v in e : Qu.call(e, v)))
      return !1;
  }
  const p = n.get(t), m = n.get(e);
  if (p && m)
    return p == e && m == t;
  let f = !0;
  n.set(t, e), n.set(e, t);
  let x = a;
  for (; ++c < i; ) {
    v = s[c];
    const w = t[v], g = e[v];
    if (L)
      var y = a ? L(g, w, v, e, t, n) : L(w, g, v, t, e, n);
    if (!(y === void 0 ? w === g || o(w, g, r, L, n) : y)) {
      f = !1;
      break;
    }
    x || (x = v == "constructor");
  }
  if (f && !x) {
    const w = t.constructor, g = e.constructor;
    w != g && "constructor" in t && "constructor" in e && !(typeof w == "function" && w instanceof w && typeof g == "function" && g instanceof g) && (f = !1);
  }
  return n.delete(t), n.delete(e), f;
}
const td = ed, rd = ie, Ld = C1, nd = rd(Ld, "DataView"), od = nd, sd = ie, ad = C1, id = sd(ad, "Promise"), ld = id, ud = ie, dd = C1, cd = ud(dd, "Set"), hd = cd, fd = ie, pd = C1, md = fd(pd, "WeakMap"), gd = md, r2 = od, L2 = H2, n2 = ld, o2 = hd, s2 = gd, nr = D1, Ee = V3, n6 = "[object Map]", vd = "[object Object]", o6 = "[object Promise]", s6 = "[object Set]", a6 = "[object WeakMap]", i6 = "[object DataView]", yd = Ee(r2), wd = Ee(L2), bd = Ee(n2), xd = Ee(o2), kd = Ee(s2);
let Q1 = nr;
(r2 && Q1(new r2(new ArrayBuffer(1))) != i6 || L2 && Q1(new L2()) != n6 || n2 && Q1(n2.resolve()) != o6 || o2 && Q1(new o2()) != s6 || s2 && Q1(new s2()) != a6) && (Q1 = function(t) {
  const e = nr(t), r = e == vd ? t.constructor : void 0, L = r ? Ee(r) : "";
  if (L)
    switch (L) {
      case yd:
        return i6;
      case wd:
        return n6;
      case bd:
        return o6;
      case xd:
        return s6;
      case kd:
        return a6;
    }
  return e;
});
const wt = Q1, I0 = v0, Md = J3, _d = Pu, $d = td, l6 = wt, u6 = X5, d6 = ve.exports, Sd = F2, Cd = 1, c6 = "[object Arguments]", h6 = "[object Array]", Dt = "[object Object]", Dd = Object.prototype, f6 = Dd.hasOwnProperty;
function zd(t, e, r, L, o, n) {
  let a = u6(t), s = u6(e), i = a ? h6 : l6(t), l = s ? h6 : l6(e);
  i = i == c6 ? Dt : i, l = l == c6 ? Dt : l;
  let u = i == Dt, c = l == Dt, v = i == l;
  if (v && d6(t)) {
    if (!d6(e))
      return !1;
    a = !0, u = !1;
  }
  if (v && !u)
    return n || (n = new I0()), a || Sd(t) ? Md(t, e, r, L, o, n) : _d(t, e, i, r, L, o, n);
  if (!(r & Cd)) {
    const p = u && f6.call(t, "__wrapped__"), m = c && f6.call(e, "__wrapped__");
    if (p || m) {
      const f = p ? t.value() : t, x = m ? e.value() : e;
      return n || (n = new I0()), o(f, x, r, L, n);
    }
  }
  return v ? (n || (n = new I0()), $d(t, e, r, L, o, n)) : !1;
}
const Id = zd, Td = Id, p6 = q5;
function or(t, e, r, L, o) {
  return t === e ? !0 : t == null || e == null || !p6(t) && !p6(e) ? t !== t && e !== e : Td(
    t,
    e,
    r,
    L,
    or,
    o
  );
}
const sr = or, Od = v0, Pd = sr, Zd = 1, Ed = 2;
function Ad(t, e, r, L) {
  let o = r.length, n = o, a = !L;
  if (t == null)
    return !n;
  for (t = Object(t); o--; ) {
    var s = r[o];
    if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++o < n; ) {
    s = r[o];
    const l = s[0], u = t[l], c = s[1];
    if (a && s[2]) {
      if (u === void 0 && !(l in t))
        return !1;
    } else {
      const v = new Od();
      if (L)
        var i = L(u, c, l, t, e, v);
      if (!(i === void 0 ? Pd(
        c,
        u,
        Zd | Ed,
        L,
        v
      ) : i))
        return !1;
    }
  }
  return !0;
}
const Nd = Ad, Hd = a1;
function Bd(t) {
  return t === t && !Hd(t);
}
const ar = Bd, Vd = ar, Rd = Pe;
function Yd(t) {
  let e = Rd(t), r = e.length;
  for (; r--; ) {
    const L = e[r], o = t[L];
    e[r] = [L, o, Vd(o)];
  }
  return e;
}
const Fd = Yd;
function jd(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
const ir = jd, Wd = Nd, Ud = Fd, Gd = ir;
function Kd(t) {
  const e = Ud(t);
  return e.length == 1 && e[0][2] ? Gd(e[0][0], e[0][1]) : function(r) {
    return r === t || Wd(r, t, e);
  };
}
const qd = Kd;
function Xd(t, e) {
  return t != null && e in Object(t);
}
const Jd = Xd, Qd = Te, ec = g0, tc = X5, rc = m0, Lc = A2, nc = Oe;
function oc(t, e, r) {
  e = Qd(e, t);
  let L = -1, o = e.length, n = !1;
  for (; ++L < o; ) {
    var a = nc(e[L]);
    if (!(n = t != null && r(t, a)))
      break;
    t = t[a];
  }
  return n || ++L != o ? n : (o = t == null ? 0 : t.length, !!o && Lc(o) && rc(a, o) && (tc(t) || ec(t)));
}
const lr = oc, sc = Jd, ac = lr;
function ic(t, e) {
  return t != null && ac(t, e, sc);
}
const ur = ic, lc = sr, uc = lt, dc = ur, cc = N2, hc = ar, fc = ir, pc = Oe, mc = 1, gc = 2;
function vc(t, e) {
  return cc(t) && hc(e) ? fc(pc(t), e) : function(r) {
    const L = uc(r, t);
    return L === void 0 && L === e ? dc(r, t) : lc(
      e,
      L,
      mc | gc
    );
  };
}
const yc = vc;
function wc(t) {
  return t;
}
const G2 = wc;
function bc(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
const xc = bc, kc = f0;
function Mc(t) {
  return function(e) {
    return kc(e, t);
  };
}
const _c = Mc, $c = xc, Sc = _c, Cc = N2, Dc = Oe;
function zc(t) {
  return Cc(t) ? $c(Dc(t)) : Sc(t);
}
const Ic = zc, Tc = qd, Oc = yc, Pc = G2, Zc = X5, Ec = Ic;
function Ac(t) {
  return typeof t == "function" ? t : t == null ? Pc : typeof t == "object" ? Zc(t) ? Oc(t[0], t[1]) : Tc(t) : Ec(t);
}
const dr = Ac, Nc = p0, Hc = q3, Bc = dr;
function Vc(t, e) {
  const r = {};
  return e = Bc(e), Hc(t, function(L, o, n) {
    Nc(r, o, e(L, o, n));
  }), r;
}
const Rc = Vc, Yc = R2;
function Fc(t, e) {
  return Yc(e, function(r) {
    return [r, t[r]];
  });
}
const jc = Fc;
function Wc(t) {
  let e = -1, r = Array(t.size);
  return t.forEach(function(L) {
    r[++e] = [L, L];
  }), r;
}
const Uc = Wc, Gc = jc, Kc = wt, qc = er, Xc = Uc, Jc = "[object Map]", Qc = "[object Set]";
function eh(t) {
  return function(e) {
    const r = Kc(e);
    return r == Jc ? qc(e) : r == Qc ? Xc(e) : Gc(e, t(e));
  };
}
const th = eh, rh = th, Lh = Pe, nh = rh(Lh), Bt = nh;
function oh(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
const cr = oh, sh = cr, m6 = Math.max;
function ah(t, e, r) {
  return e = m6(e === void 0 ? t.length - 1 : e, 0), function() {
    let L = arguments, o = -1, n = m6(L.length - e, 0), a = Array(n);
    for (; ++o < n; )
      a[o] = L[e + o];
    o = -1;
    const s = Array(e + 1);
    for (; ++o < e; )
      s[o] = L[o];
    return s[e] = r(a), sh(t, this, s);
  };
}
const hr = ah;
function ih(t) {
  return function() {
    return t;
  };
}
const lh = ih, uh = lh, g6 = F3, dh = G2, ch = g6 ? function(t, e) {
  return g6(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: uh(e),
    writable: !0
  });
} : dh, hh = ch, fh = 800, ph = 16, mh = Date.now;
function gh(t) {
  let e = 0, r = 0;
  return function() {
    const L = mh(), o = ph - (L - r);
    if (r = L, o > 0) {
      if (++e >= fh)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
const vh = gh, yh = hh, wh = vh, bh = wh(yh), fr = bh, xh = G2, kh = hr, Mh = fr;
function _h(t, e) {
  return Mh(kh(t, e, xh), t + "");
}
const K2 = _h, $h = De, Sh = yt, Ch = m0, Dh = a1;
function zh(t, e, r) {
  if (!Dh(r))
    return !1;
  const L = typeof e;
  return (L == "number" ? Sh(r) && Ch(e, r.length) : L == "string" && e in r) ? $h(r[e], t) : !1;
}
const q2 = zh;
function Ih(t) {
  const e = [];
  if (t != null)
    for (const r in Object(t))
      e.push(r);
  return e;
}
const Th = Ih, Oh = a1, Ph = j2, Zh = Th, Eh = Object.prototype, Ah = Eh.hasOwnProperty;
function Nh(t) {
  if (!Oh(t))
    return Zh(t);
  const e = Ph(t), r = [];
  for (const L in t)
    L == "constructor" && (e || !Ah.call(t, L)) || r.push(L);
  return r;
}
const Hh = Nh, Bh = G3, Vh = Hh, Rh = yt;
function Yh(t) {
  return Rh(t) ? Bh(t, !0) : Vh(t);
}
const Ae = Yh, Fh = K2, jh = De, Wh = q2, Uh = Ae, pr = Object.prototype, Gh = pr.hasOwnProperty, Kh = Fh(function(t, e) {
  t = Object(t);
  let r = -1, L = e.length;
  const o = L > 2 ? e[2] : void 0;
  for (o && Wh(e[0], e[1], o) && (L = 1); ++r < L; ) {
    const n = e[r], a = Uh(n);
    let s = -1;
    const i = a.length;
    for (; ++s < i; ) {
      const l = a[s], u = t[l];
      (u === void 0 || jh(u, pr[l]) && !Gh.call(t, l)) && (t[l] = n[l]);
    }
  }
  return t;
}), et = Kh, qh = p0, Xh = De;
function Jh(t, e, r) {
  (r !== void 0 && !Xh(t[e], r) || r === void 0 && !(e in t)) && qh(t, e, r);
}
const mr = Jh, qt = { exports: {} };
(function(t, e) {
  const r = C1, L = e && !e.nodeType && e, o = L && !0 && t && !t.nodeType && t, a = o && o.exports === L ? r.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function i(l, u) {
    if (u)
      return l.slice();
    const c = l.length, v = s ? s(c) : new l.constructor(c);
    return l.copy(v), v;
  }
  t.exports = i;
})(qt, qt.exports);
const v6 = Q3;
function Qh(t) {
  const e = new t.constructor(t.byteLength);
  return new v6(e).set(new v6(t)), e;
}
const X2 = Qh, ef = X2;
function tf(t, e) {
  const r = e ? ef(t.buffer) : t.buffer;
  return new t.constructor(
    r,
    t.byteOffset,
    t.length
  );
}
const gr = tf;
function rf(t, e) {
  let r = -1, L = t.length;
  for (e || (e = Array(L)); ++r < L; )
    e[r] = t[r];
  return e;
}
const vr = rf, Lf = a1, y6 = Object.create, nf = function() {
  function t() {
  }
  return function(e) {
    if (!Lf(e))
      return {};
    if (y6)
      return y6(e);
    t.prototype = e;
    const r = new t();
    return t.prototype = void 0, r;
  };
}(), of = nf, sf = K3, af = sf(Object.getPrototypeOf, Object), J2 = af, lf = of, uf = J2, df = j2;
function cf(t) {
  return typeof t.constructor == "function" && !df(t) ? lf(uf(t)) : {};
}
const yr = cf, hf = D1, ff = J2, pf = q5, mf = "[object Object]", gf = Function.prototype, vf = Object.prototype, wr = gf.toString, yf = vf.hasOwnProperty, wf = wr.call(Object);
function bf(t) {
  if (!pf(t) || hf(t) != mf)
    return !1;
  const e = ff(t);
  if (e === null)
    return !0;
  const r = yf.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && wr.call(r) == wf;
}
const br = bf;
function xf(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
const xr = xf, kf = Y2, Mf = p0;
function _f(t, e, r, L) {
  const o = !r;
  r || (r = {});
  let n = -1, a = e.length;
  for (; ++n < a; ) {
    const s = e[n];
    let i = L ? L(r[s], t[s], s, r, t) : void 0;
    i === void 0 && (i = t[s]), o ? Mf(r, s, i) : kf(r, s, i);
  }
  return r;
}
const Ne = _f, $f = Ne, Sf = Ae;
function Cf(t) {
  return $f(t, Sf(t));
}
const Df = Cf, w6 = mr, zf = qt.exports, If = gr, Tf = vr, Of = yr, b6 = g0, x6 = X5, Pf = V5, Zf = ve.exports, Ef = O1, Af = a1, Nf = br, Hf = F2, k6 = xr, Bf = Df;
function Vf(t, e, r, L, o, n, a) {
  const s = k6(t, r), i = k6(e, r), l = a.get(i);
  if (l) {
    w6(t, r, l);
    return;
  }
  let u = n ? n(s, i, r + "", t, e, a) : void 0, c = u === void 0;
  if (c) {
    const v = x6(i), p = !v && Zf(i), m = !v && !p && Hf(i);
    u = i, v || p || m ? x6(s) ? u = s : Pf(s) ? u = Tf(s) : p ? (c = !1, u = zf(i, !0)) : m ? (c = !1, u = If(i, !0)) : u = [] : Nf(i) || b6(i) ? (u = s, b6(s) ? u = Bf(s) : (!Af(s) || Ef(s)) && (u = Of(i))) : c = !1;
  }
  c && (a.set(i, u), o(u, i, L, n, a), a.delete(i)), w6(t, r, u);
}
const Rf = Vf, Yf = v0, Ff = mr, jf = W3, Wf = Rf, Uf = a1, Gf = Ae, Kf = xr;
function kr(t, e, r, L, o) {
  t !== e && jf(
    e,
    function(n, a) {
      if (o || (o = new Yf()), Uf(n))
        Wf(
          t,
          e,
          a,
          r,
          kr,
          L,
          o
        );
      else {
        let s = L ? L(
          Kf(t, a),
          n,
          a + "",
          t,
          e,
          o
        ) : void 0;
        s === void 0 && (s = n), Ff(t, a, s);
      }
    },
    Gf
  );
}
const Mr = kr, qf = Mr, M6 = a1;
function _r(t, e, r, L, o, n) {
  return M6(t) && M6(e) && (n.set(e, t), qf(t, e, void 0, _r, n), n.delete(e)), t;
}
const Xf = _r, Jf = K2, Qf = q2;
function ep(t) {
  return Jf(function(e, r) {
    let L = -1, o = r.length, n = o > 1 ? r[o - 1] : void 0, a = o > 2 ? r[2] : void 0;
    for (n = t.length > 3 && typeof n == "function" ? (o--, n) : void 0, a && Qf(r[0], r[1], a) && (n = o < 3 ? void 0 : n, o = 1), e = Object(e); ++L < o; ) {
      const s = r[L];
      s && t(e, s, L, n);
    }
    return e;
  });
}
const tp = ep, rp = Mr, Lp = tp, np = Lp(function(t, e, r, L) {
  rp(t, e, r, L);
}), op = np, sp = cr, ap = K2, ip = Xf, lp = op, up = ap(function(t) {
  return t.push(void 0, ip), sp(lp, void 0, t);
}), Q2 = up, dp = f0, cp = j3, hp = Te;
function fp(t, e, r) {
  let L = -1, o = e.length, n = {};
  for (; ++L < o; ) {
    const a = e[L], s = dp(t, a);
    r(s, a) && cp(n, hp(a, t), s);
  }
  return n;
}
const pp = fp, mp = pp, gp = ur;
function vp(t, e) {
  return mp(t, e, function(r, L) {
    return gp(t, L);
  });
}
const yp = vp, _6 = Se, wp = g0, bp = X5, $6 = _6 ? _6.isConcatSpreadable : void 0;
function xp(t) {
  return bp(t) || wp(t) || !!($6 && t && t[$6]);
}
const kp = xp, Mp = W2, _p = kp;
function $r(t, e, r, L, o) {
  let n = -1, a = t.length;
  for (r || (r = _p), o || (o = []); ++n < a; ) {
    const s = t[n];
    e > 0 && r(s) ? e > 1 ? $r(s, e - 1, r, L, o) : Mp(o, s) : L || (o[o.length] = s);
  }
  return o;
}
const $p = $r, Sp = $p;
function Cp(t) {
  return (t == null ? 0 : t.length) ? Sp(t, 1) : [];
}
const Dp = Cp, zp = Dp, Ip = hr, Tp = fr;
function Op(t) {
  return Tp(Ip(t, void 0, zp), t + "");
}
const Sr = Op, Pp = yp, Zp = Sr, Ep = Zp(function(t, e) {
  return t == null ? {} : Pp(t, e);
}), Ap = Ep;
function Np(t, e) {
  let r = -1, L = t == null ? 0 : t.length;
  for (; ++r < L && e(t[r], r, t) !== !1; )
    ;
  return t;
}
const Hp = Np, Bp = Ne, Vp = Pe;
function Rp(t, e) {
  return t && Bp(e, Vp(e), t);
}
const Yp = Rp, Fp = Ne, jp = Ae;
function Wp(t, e) {
  return t && Fp(e, jp(e), t);
}
const Up = Wp, Gp = Ne, Kp = U2;
function qp(t, e) {
  return Gp(t, Kp(t), e);
}
const Xp = qp, Jp = W2, Qp = J2, em = U2, tm = rr, rm = Object.getOwnPropertySymbols, Lm = rm ? function(t) {
  const e = [];
  for (; t; )
    Jp(e, em(t)), t = Qp(t);
  return e;
} : tm, Cr = Lm, nm = Ne, om = Cr;
function sm(t, e) {
  return nm(t, om(t), e);
}
const am = sm, im = tr, lm = Cr, um = Ae;
function dm(t) {
  return im(t, um, lm);
}
const Dr = dm, cm = Object.prototype, hm = cm.hasOwnProperty;
function fm(t) {
  const e = t.length, r = new t.constructor(e);
  return e && typeof t[0] == "string" && hm.call(t, "index") && (r.index = t.index, r.input = t.input), r;
}
const pm = fm, mm = X2;
function gm(t, e) {
  const r = e ? mm(t.buffer) : t.buffer;
  return new t.constructor(
    r,
    t.byteOffset,
    t.byteLength
  );
}
const vm = gm, ym = /\w*$/;
function wm(t) {
  const e = new t.constructor(t.source, ym.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
const bm = wm, S6 = Se, C6 = S6 ? S6.prototype : void 0, D6 = C6 ? C6.valueOf : void 0;
function xm(t) {
  return D6 ? Object(D6.call(t)) : {};
}
const km = xm, Mm = X2, _m = vm, $m = bm, Sm = km, Cm = gr, Dm = "[object Boolean]", zm = "[object Date]", Im = "[object Map]", Tm = "[object Number]", Om = "[object RegExp]", Pm = "[object Set]", Zm = "[object String]", Em = "[object Symbol]", Am = "[object ArrayBuffer]", Nm = "[object DataView]", Hm = "[object Float32Array]", Bm = "[object Float64Array]", Vm = "[object Int8Array]", Rm = "[object Int16Array]", Ym = "[object Int32Array]", Fm = "[object Uint8Array]", jm = "[object Uint8ClampedArray]", Wm = "[object Uint16Array]", Um = "[object Uint32Array]";
function Gm(t, e, r) {
  const L = t.constructor;
  switch (e) {
    case Am:
      return Mm(t);
    case Dm:
    case zm:
      return new L(+t);
    case Nm:
      return _m(t, r);
    case Hm:
    case Bm:
    case Vm:
    case Rm:
    case Ym:
    case Fm:
    case jm:
    case Wm:
    case Um:
      return Cm(t, r);
    case Im:
      return new L();
    case Tm:
    case Zm:
      return new L(t);
    case Om:
      return $m(t);
    case Pm:
      return new L();
    case Em:
      return Sm(t);
  }
}
const Km = Gm, qm = wt, Xm = q5, Jm = "[object Map]";
function Qm(t) {
  return Xm(t) && qm(t) == Jm;
}
const eg = Qm, tg = eg, rg = i0, z6 = ge.exports, I6 = z6 && z6.isMap, Lg = I6 ? rg(I6) : tg, ng = Lg, og = wt, sg = q5, ag = "[object Set]";
function ig(t) {
  return sg(t) && og(t) == ag;
}
const lg = ig, ug = lg, dg = i0, T6 = ge.exports, O6 = T6 && T6.isSet, cg = O6 ? dg(O6) : ug, hg = cg, fg = v0, pg = Hp, mg = Y2, gg = Yp, vg = Up, yg = qt.exports, wg = vr, bg = Xp, xg = am, kg = Lr, Mg = Dr, _g = wt, $g = pm, Sg = Km, Cg = yr, Dg = X5, zg = ve.exports, Ig = ng, Tg = a1, Og = hg, Pg = Pe, Zg = Ae, Eg = 1, Ag = 2, Ng = 4, zr = "[object Arguments]", Hg = "[object Array]", Bg = "[object Boolean]", Vg = "[object Date]", Rg = "[object Error]", Ir = "[object Function]", Yg = "[object GeneratorFunction]", Fg = "[object Map]", jg = "[object Number]", Tr = "[object Object]", Wg = "[object RegExp]", Ug = "[object Set]", Gg = "[object String]", Kg = "[object Symbol]", qg = "[object WeakMap]", Xg = "[object ArrayBuffer]", Jg = "[object DataView]", Qg = "[object Float32Array]", ev = "[object Float64Array]", tv = "[object Int8Array]", rv = "[object Int16Array]", Lv = "[object Int32Array]", nv = "[object Uint8Array]", ov = "[object Uint8ClampedArray]", sv = "[object Uint16Array]", av = "[object Uint32Array]", v5 = {};
v5[zr] = v5[Hg] = v5[Xg] = v5[Jg] = v5[Bg] = v5[Vg] = v5[Qg] = v5[ev] = v5[tv] = v5[rv] = v5[Lv] = v5[Fg] = v5[jg] = v5[Tr] = v5[Wg] = v5[Ug] = v5[Gg] = v5[Kg] = v5[nv] = v5[ov] = v5[sv] = v5[av] = !0;
v5[Rg] = v5[Ir] = v5[qg] = !1;
function Vt(t, e, r, L, o, n) {
  let a, s = e & Eg, i = e & Ag, l = e & Ng;
  if (r && (a = o ? r(t, L, o, n) : r(t)), a !== void 0)
    return a;
  if (!Tg(t))
    return t;
  const u = Dg(t);
  if (u) {
    if (a = $g(t), !s)
      return wg(t, a);
  } else {
    const m = _g(t), f = m == Ir || m == Yg;
    if (zg(t))
      return yg(t, s);
    if (m == Tr || m == zr || f && !o) {
      if (a = i || f ? {} : Cg(t), !s)
        return i ? xg(t, vg(a, t)) : bg(t, gg(a, t));
    } else {
      if (!v5[m])
        return o ? t : {};
      a = Sg(t, m, s);
    }
  }
  n || (n = new fg());
  const c = n.get(t);
  if (c)
    return c;
  n.set(t, a), Og(t) ? t.forEach(function(m) {
    a.add(
      Vt(m, e, r, m, t, n)
    );
  }) : Ig(t) && t.forEach(function(m, f) {
    a.set(
      f,
      Vt(m, e, r, f, t, n)
    );
  });
  const p = u ? void 0 : (l ? i ? Mg : kg : i ? Zg : Pg)(t);
  return pg(p || t, function(m, f) {
    p && (f = m, m = t[f]), mg(
      a,
      f,
      Vt(m, e, r, f, t, n)
    );
  }), a;
}
const iv = Vt;
function lv(t) {
  const e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
const ut = lv;
function uv(t, e, r) {
  let L = -1, o = t.length;
  e < 0 && (e = -e > o ? 0 : o + e), r = r > o ? o : r, r < 0 && (r += o), o = e > r ? 0 : r - e >>> 0, e >>>= 0;
  const n = Array(o);
  for (; ++L < o; )
    n[L] = t[L + e];
  return n;
}
const dv = uv, cv = f0, hv = dv;
function fv(t, e) {
  return e.length < 2 ? t : cv(t, hv(e, 0, -1));
}
const pv = fv, mv = Te, gv = ut, vv = pv, yv = Oe;
function wv(t, e) {
  return e = mv(e, t), t = vv(t, e), t == null || delete t[yv(gv(e))];
}
const bv = wv, xv = br;
function kv(t) {
  return xv(t) ? void 0 : t;
}
const Mv = kv, _v = R2, $v = iv, Sv = bv, Cv = Te, Dv = Ne, zv = Mv, Iv = Sr, Tv = Dr, Ov = 1, Pv = 2, Zv = 4, Ev = Iv(function(t, e) {
  let r = {};
  if (t == null)
    return r;
  let L = !1;
  e = _v(e, function(n) {
    return n = Cv(n, t), L || (L = n.length > 1), n;
  }), Dv(t, Tv(t), r), L && (r = $v(
    r,
    Ov | Pv | Zv,
    zv
  ));
  let o = e.length;
  for (; o--; )
    Sv(r, e[o]);
  return r;
}), a2 = Ev, Av = Object.prototype, Nv = Av.hasOwnProperty;
function Hv(t, e) {
  return t != null && Nv.call(t, e);
}
const Bv = Hv, Vv = Bv, Rv = lr;
function Yv(t, e) {
  return t != null && Rv(t, e, Vv);
}
const Or = Yv, Fv = yt;
function jv(t, e) {
  return function(r, L) {
    if (r == null)
      return r;
    if (!Fv(r))
      return t(r, L);
    let o = r.length, n = e ? o : -1, a = Object(r);
    for (; (e ? n-- : ++n < o) && L(a[n], n, a) !== !1; )
      ;
    return r;
  };
}
const Wv = jv, Uv = q3, Gv = Wv, Kv = Gv(Uv), qv = Kv;
function Xv(t) {
  return t && t.length ? t[0] : void 0;
}
const Pr = Xv, Jv = qv;
function Qv(t, e) {
  let r;
  return Jv(t, function(L, o, n) {
    return r = e(L, o, n), !r;
  }), !!r;
}
const ey = Qv, ty = X3, ry = dr, Ly = ey, ny = X5, oy = q2;
function sy(t, e, r) {
  const L = ny(t) ? ty : Ly;
  return r && oy(t, e, r) && (e = void 0), L(t, ry(e));
}
const Zr = sy, ay = (t) => Object.prototype.toString.call(t).slice(8, -1), F1 = (t) => H7(t) && !isNaN(t.getTime()), e1 = (t) => ay(t) === "Object", e4 = Or, i2 = (t, e) => Zr(e, (r) => Or(t, r)), iy = Zr, l5 = (t, e, r = "0") => {
  for (t = t != null ? String(t) : "", e = e || 2; t.length < e; )
    t = `${r}${t}`;
  return t;
}, ly = (...t) => {
  const e = {};
  return t.forEach(
    (r) => Object.entries(r).forEach(([L, o]) => {
      e[L] ? V5(e[L]) ? e[L].push(o) : e[L] = [e[L], o] : e[L] = o;
    })
  ), e;
}, U5 = (t) => !!(t && t.month && t.year), Ke = (t, e) => !U5(t) || !U5(e) ? !1 : t.year === e.year ? t.month < e.month : t.year < e.year, tt = (t, e) => !U5(t) || !U5(e) ? !1 : t.year === e.year ? t.month > e.month : t.year > e.year, Er = (t, e, r) => (t || !1) && !Ke(t, e) && !tt(t, r), T0 = (t, e) => !t && e || t && !e ? !1 : !t && !e ? !0 : t.month === e.month && t.year === e.year, I1 = ({ month: t, year: e }, r) => {
  const L = r > 0 ? 1 : -1;
  for (let o = 0; o < Math.abs(r); o++)
    t += L, t > 12 ? (t = 1, e++) : t < 1 && (t = 12, e--);
  return {
    month: t,
    year: e
  };
}, uy = (t, e) => {
  if (!U5(t) || !U5(e))
    return [];
  const r = [];
  for (; !tt(t, e); )
    r.push(t), t = I1(t, 1);
  return r;
};
function O0(t, e) {
  const r = F1(t), L = F1(e);
  return !r && !L ? !0 : r !== L ? !1 : t.getTime() === e.getTime();
}
const Q5 = (t) => V5(t) && t.length > 0, P6 = (t, e, r) => {
  const L = [];
  return r.forEach((o) => {
    const n = o.name || o.toString(), a = o.mixin, s = o.validate;
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      const i = s ? s(t[n]) : t[n];
      e[n] = a && e1(i) ? j(j({}, a), i) : i, L.push(n);
    }
  }), {
    target: e,
    assigned: L.length ? L : null
  };
}, E5 = (t, e, r, L) => {
  t && e && r && t.addEventListener(e, r, L);
}, A5 = (t, e, r, L) => {
  t && e && t.removeEventListener(e, r, L);
}, rt = (t, e) => !!t && !!e && (t === e || t.contains(e)), Ar = (t, e) => {
  (t.key === " " || t.key === "Enter") && (e(t), t.preventDefault());
}, Xt = () => {
  function t() {
    return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
  }
  return `${t() + t()}-${t()}-${t()}-${t()}-${t()}${t()}${t()}`;
};
function dy(t) {
  let e = 0, r = 0, L;
  if (t.length === 0)
    return e;
  for (r = 0; r < t.length; r++)
    L = t.charCodeAt(r), e = (e << 5) - e + L, e |= 0;
  return e;
}
const He = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [L, o] of e)
    r[L] = o;
  return r;
}, cy = {
  name: "CustomTransition",
  emits: [
    "before-enter",
    "before-transition",
    "after-enter",
    "after-transition"
  ],
  props: {
    name: String,
    appear: Boolean
  },
  computed: {
    name_() {
      return `vc-${this.name || "none"}`;
    }
  },
  methods: {
    beforeEnter(t) {
      this.$emit("before-enter", t), this.$emit("before-transition", t);
    },
    afterEnter(t) {
      this.$emit("after-enter", t), this.$emit("after-transition", t);
    }
  }
};
function hy(t, e, r, L, o, n) {
  return b(), x5(
    mt,
    {
      name: n.name_,
      appear: r.appear,
      onBeforeEnter: n.beforeEnter,
      onAfterEnter: n.afterEnter
    },
    {
      default: c5(() => [u5(t.$slots, "default")]),
      _: 3
    },
    8,
    ["name", "appear", "onBeforeEnter", "onAfterEnter"]
  );
}
const Nr = /* @__PURE__ */ He(cy, [
  ["render", hy]
]), l2 = {
  name: "Popover",
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  render() {
    return Q(
      "div",
      {
        class: [
          "vc-popover-content-wrapper",
          {
            "is-interactive": this.isInteractive
          }
        ],
        ref: "popover"
      },
      [
        Q(
          Nr,
          {
            name: this.transition,
            appear: !0,
            "on-before-enter": this.beforeEnter,
            "on-after-enter": this.afterEnter,
            "on-before-leave": this.beforeLeave,
            "on-after-leave": this.afterLeave
          },
          {
            default: () => this.isVisible ? Q(
              "div",
              {
                tabindex: -1,
                class: [
                  "vc-popover-content",
                  `direction-${this.direction}`,
                  this.contentClass
                ],
                style: this.contentStyle
              },
              [
                this.content,
                Q("span", {
                  class: [
                    "vc-popover-caret",
                    `direction-${this.direction}`,
                    `align-${this.alignment}`
                  ]
                })
              ]
            ) : null
          }
        )
      ]
    );
  },
  props: {
    id: { type: String, required: !0 },
    contentClass: String
  },
  data() {
    return {
      ref: null,
      opts: null,
      data: null,
      transition: "slide-fade",
      transitionTranslate: "15px",
      transitionDuration: "0.15s",
      placement: "bottom",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !1,
      isHovered: !1,
      isFocused: !1,
      showDelay: 0,
      hideDelay: 110,
      autoHide: !1,
      popperEl: null
    };
  },
  computed: {
    content() {
      return O1(this.$slots.default) && this.$slots.default({
        direction: this.direction,
        alignment: this.alignment,
        data: this.data,
        updateLayout: this.setupPopper,
        hide: (t) => this.hide(t)
      }) || this.$slots.default;
    },
    contentStyle() {
      return {
        "--slide-translate": this.transitionTranslate,
        "--slide-duration": this.transitionDuration
      };
    },
    popperOptions() {
      return {
        placement: this.placement,
        strategy: this.positionFixed ? "fixed" : "absolute",
        modifiers: [
          {
            name: "onUpdate",
            enabled: !0,
            phase: "afterWrite",
            fn: this.onPopperUpdate
          },
          ...this.modifiers || []
        ],
        onFirstUpdate: this.onPopperUpdate
      };
    },
    isVisible() {
      return !!(this.ref && this.content);
    },
    direction() {
      return this.placement && this.placement.split("-")[0] || "bottom";
    },
    alignment() {
      const t = this.direction === "left" || this.direction === "right";
      let e = this.placement.split("-");
      return e = e.length > 1 ? e[1] : "", ["start", "top", "left"].includes(e) ? t ? "top" : "left" : ["end", "bottom", "right"].includes(e) ? t ? "bottom" : "right" : t ? "middle" : "center";
    }
  },
  watch: {
    opts(t, e) {
      e && e.callback && e.callback(
        a5(j({}, e), {
          completed: !t,
          reason: t ? "Overridden by action" : null
        })
      );
    }
  },
  mounted() {
    this.popoverEl = this.$refs.popover, this.addEvents();
  },
  beforeUnmount() {
    this.destroyPopper(), this.removeEvents(), this.popoverEl = null;
  },
  methods: {
    addEvents() {
      E5(this.popoverEl, "click", this.onClick), E5(this.popoverEl, "mouseover", this.onMouseOver), E5(this.popoverEl, "mouseleave", this.onMouseLeave), E5(this.popoverEl, "focusin", this.onFocusIn), E5(this.popoverEl, "focusout", this.onFocusOut), E5(document, "keydown", this.onDocumentKeydown), E5(document, "click", this.onDocumentClick), E5(document, "show-popover", this.onDocumentShowPopover), E5(document, "hide-popover", this.onDocumentHidePopover), E5(document, "toggle-popover", this.onDocumentTogglePopover), E5(document, "update-popover", this.onDocumentUpdatePopover);
    },
    removeEvents() {
      A5(this.popoverEl, "click", this.onClick), A5(this.popoverEl, "mouseover", this.onMouseOver), A5(this.popoverEl, "mouseleave", this.onMouseLeave), A5(this.popoverEl, "focusin", this.onFocusIn), A5(this.popoverEl, "focusout", this.onFocusOut), A5(document, "keydown", this.onDocumentKeydown), A5(document, "click", this.onDocumentClick), A5(document, "show-popover", this.onDocumentShowPopover), A5(document, "hide-popover", this.onDocumentHidePopover), A5(document, "toggle-popover", this.onDocumentTogglePopover), A5(document, "update-popover", this.onDocumentUpdatePopover);
    },
    onClick(t) {
      t.stopPropagation();
    },
    onMouseOver() {
      this.isHovered = !0, this.isInteractive && this.show();
    },
    onMouseLeave() {
      this.isHovered = !1, this.autoHide && !this.isFocused && (!this.ref || this.ref !== document.activeElement) && this.hide();
    },
    onFocusIn() {
      this.isFocused = !0, this.isInteractive && this.show();
    },
    onFocusOut(t) {
      (!t.relatedTarget || !rt(this.popoverEl, t.relatedTarget)) && (this.isFocused = !1, !this.isHovered && this.autoHide && this.hide());
    },
    onDocumentClick(t) {
      !this.$refs.popover || !this.ref || rt(this.popoverEl, t.target) || rt(this.ref, t.target) || this.hide();
    },
    onDocumentKeydown(t) {
      (t.key === "Esc" || t.key === "Escape") && this.hide();
    },
    onDocumentShowPopover({ detail: t }) {
      !t.id || t.id !== this.id || this.show(t);
    },
    onDocumentHidePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.hide(t);
    },
    onDocumentTogglePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.toggle(t);
    },
    onDocumentUpdatePopover({ detail: t }) {
      !t.id || t.id !== this.id || this.update(t);
    },
    show(t = {}) {
      t.action = "show";
      const e = t.ref || this.ref, r = t.showDelay >= 0 ? t.showDelay : this.showDelay;
      if (!e) {
        t.callback && t.callback({
          completed: !1,
          reason: "Invalid reference element provided"
        });
        return;
      }
      clearTimeout(this.timeout), this.opts = t;
      const L = () => {
        Object.assign(this, a2(t, ["id"])), this.setupPopper(), this.opts = null;
      };
      r > 0 ? this.timeout = setTimeout(() => L(), r) : L();
    },
    hide(t = {}) {
      t.action = "hide";
      const e = t.ref || this.ref, r = t.hideDelay >= 0 ? t.hideDelay : this.hideDelay;
      if (!this.ref || e !== this.ref) {
        t.callback && t.callback(
          a5(j({}, t), {
            completed: !1,
            reason: this.ref ? "Invalid reference element provided" : "Popover already hidden"
          })
        );
        return;
      }
      const L = () => {
        this.ref = null, this.opts = null;
      };
      clearTimeout(this.timeout), this.opts = t, r > 0 ? this.timeout = setTimeout(L, r) : L();
    },
    toggle(t = {}) {
      this.isVisible && t.ref === this.ref ? this.hide(t) : this.show(t);
    },
    update(t = {}) {
      Object.assign(this, a2(t, ["id"])), this.setupPopper();
    },
    setupPopper() {
      this.$nextTick(() => {
        !this.ref || !this.$refs.popover || (this.popper && this.popper.reference !== this.ref && this.destroyPopper(), this.popper ? this.popper.update() : this.popper = $s(
          this.ref,
          this.popoverEl,
          this.popperOptions
        ));
      });
    },
    onPopperUpdate(t) {
      t.placement ? this.placement = t.placement : t.state && (this.placement = t.state.placement);
    },
    beforeEnter(t) {
      this.$emit("before-show", t);
    },
    afterEnter(t) {
      this.$emit("after-show", t);
    },
    beforeLeave(t) {
      this.$emit("before-hide", t);
    },
    afterLeave(t) {
      this.destroyPopper(), this.$emit("after-hide", t);
    },
    destroyPopper() {
      this.popper && (this.popper.destroy(), this.popper = null);
    }
  }
}, fy = {
  inject: ["sharedState"],
  computed: {
    masks() {
      return this.sharedState.masks;
    },
    theme() {
      return this.sharedState.theme;
    },
    locale() {
      return this.sharedState.locale;
    },
    dayPopoverId() {
      return this.sharedState.dayPopoverId;
    }
  },
  methods: {
    format(t, e) {
      return this.locale.format(t, e);
    },
    pageForDate(t) {
      return this.locale.getDateParts(this.locale.normalizeDate(t));
    }
  }
}, py = ["base", "start", "end", "startEnd"], my = [
  "class",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], gy = {
  color: "blue",
  isDark: !1,
  highlight: {
    base: { fillMode: "light" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  dot: {
    base: { fillMode: "solid" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  bar: {
    base: { fillMode: "solid" },
    start: { fillMode: "solid" },
    end: { fillMode: "solid" }
  },
  content: {
    base: {},
    start: {},
    end: {}
  }
};
class Z6 {
  constructor(e) {
    Object.assign(this, gy, e);
  }
  normalizeAttr({ config: e, type: r }) {
    let L = this.color, o = {};
    const n = this[r];
    if (e === !0 || R1(e))
      L = R1(e) ? e : L, o = j({}, n);
    else if (e1(e))
      i2(e, py) ? o = j({}, e) : o = {
        base: j({}, e),
        start: j({}, e),
        end: j({}, e)
      };
    else
      return null;
    return et(o, { start: o.startEnd, end: o.startEnd }, n), Bt(o).forEach(([a, s]) => {
      let i = L;
      s === !0 || R1(s) ? (i = R1(s) ? s : i, o[a] = { color: i }) : e1(s) && (i2(s, my) ? o[a] = j({}, s) : o[a] = {}), e4(o, `${a}.color`) || r8(o, `${a}.color`, i);
    }), o;
  }
  normalizeHighlight(e) {
    const r = this.normalizeAttr({
      config: e,
      type: "highlight"
    });
    return Bt(r).forEach(([L, o]) => {
      const n = et(o, {
        isDark: this.isDark,
        color: this.color
      });
      o.style = j(
        j({}, this.getHighlightBgStyle(n)),
        o.style
      ), o.contentStyle = j(
        j({}, this.getHighlightContentStyle(n)),
        o.contentStyle
      );
    }), r;
  }
  getHighlightBgStyle({ fillMode: e, color: r, isDark: L }) {
    switch (e) {
      case "outline":
      case "none":
        return {
          backgroundColor: L ? "var(--gray-900)" : "var(--white)",
          border: "2px solid",
          borderColor: L ? `var(--${r}-200)` : `var(--${r}-700)`,
          borderRadius: "var(--rounded-full)"
        };
      case "light":
        return {
          backgroundColor: L ? `var(--${r}-800)` : `var(--${r}-200)`,
          opacity: L ? 0.75 : 1,
          borderRadius: "var(--rounded-full)"
        };
      case "solid":
        return {
          backgroundColor: L ? `var(--${r}-500)` : `var(--${r}-600)`,
          borderRadius: "var(--rounded-full)"
        };
      default:
        return {
          borderRadius: "var(--rounded-full)"
        };
    }
  }
  getHighlightContentStyle({ fillMode: e, color: r, isDark: L }) {
    switch (e) {
      case "outline":
      case "none":
        return {
          fontWeight: "var(--font-bold)",
          color: L ? `var(--${r}-100)` : `var(--${r}-900)`
        };
      case "light":
        return {
          fontWeight: "var(--font-bold)",
          color: L ? `var(--${r}-100)` : `var(--${r}-900)`
        };
      case "solid":
        return {
          fontWeight: "var(--font-bold)",
          color: "var(--white)"
        };
      default:
        return "";
    }
  }
  bgAccentHigh({ color: e, isDark: r }) {
    return {
      backgroundColor: r ? `var(--${e}-500)` : `var(--${e}-600)`
    };
  }
  contentAccent({ color: e, isDark: r }) {
    return e ? {
      fontWeight: "var(--font-bold)",
      color: r ? `var(--${e}-100)` : `var(--${e}-900)`
    } : null;
  }
  normalizeDot(e) {
    return this.normalizeNonHighlight("dot", e, this.bgAccentHigh);
  }
  normalizeBar(e) {
    return this.normalizeNonHighlight("bar", e, this.bgAccentHigh);
  }
  normalizeContent(e) {
    return this.normalizeNonHighlight("content", e, this.contentAccent);
  }
  normalizeNonHighlight(e, r, L) {
    const o = this.normalizeAttr({ type: e, config: r });
    return Bt(o).forEach(([n, a]) => {
      et(a, { isDark: this.isDark, color: this.color }), a.style = j(
        j({}, L(a)),
        a.style
      );
    }), o;
  }
}
const Rt = 6e4;
function E6(t) {
  return t.getTime() % Rt;
}
function Jt(t) {
  const e = new Date(t.getTime()), r = Math.ceil(e.getTimezoneOffset());
  e.setSeconds(0, 0);
  const o = r > 0 ? (Rt + E6(e)) % Rt : E6(e);
  return r * Rt + o;
}
function vy(t, e) {
  const r = xy(e);
  return r.formatToParts ? wy(r, t) : by(r, t);
}
const yy = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function wy(t, e) {
  const r = t.formatToParts(e), L = [];
  for (let o = 0; o < r.length; o++) {
    const n = yy[r[o].type];
    n >= 0 && (L[n] = parseInt(r[o].value, 10));
  }
  return L;
}
function by(t, e) {
  const r = t.format(e).replace(/\u200E/g, ""), L = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [L[3], L[1], L[2], L[4], L[5], L[6]];
}
const P0 = {};
function xy(t) {
  if (!P0[t]) {
    const e = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = e === "06/25/2014, 00:00:00" || e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    P0[t] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return P0[t];
}
const A6 = 36e5, ky = 6e4, zt = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/,
  timezoneIANA: /(UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/
};
function N6(t, e) {
  let r, L;
  if (r = zt.timezoneZ.exec(t), r)
    return 0;
  let o;
  if (r = zt.timezoneHH.exec(t), r)
    return o = parseInt(r[2], 10), H6() ? (L = o * A6, r[1] === "+" ? -L : L) : NaN;
  if (r = zt.timezoneHHMM.exec(t), r) {
    o = parseInt(r[2], 10);
    const n = parseInt(r[3], 10);
    return H6(o, n) ? (L = o * A6 + n * ky, r[1] === "+" ? -L : L) : NaN;
  }
  if (r = zt.timezoneIANA.exec(t), r) {
    const n = vy(e, t), a = Date.UTC(
      n[0],
      n[1] - 1,
      n[2],
      n[3],
      n[4],
      n[5]
    ), s = e.getTime() - e.getTime() % 1e3;
    return -(a - s);
  }
  return 0;
}
function H6(t, e) {
  return !(e != null && (e < 0 || e > 59));
}
const Z0 = 36e5, B6 = 6e4, My = 2, z5 = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/],
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  timezone: /([Z+-].*| UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/
};
function V6(t, e) {
  if (arguments.length < 1)
    throw new TypeError(
      "1 argument required, but only " + arguments.length + " present"
    );
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const r = e || {}, L = r.additionalDigits == null ? My : $1(r.additionalDigits);
  if (L !== 2 && L !== 1 && L !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  const o = _y(t), n = $y(o.date, L), a = n.year, s = n.restDateString, i = Sy(s, a);
  if (isNaN(i))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    const l = i.getTime();
    let u = 0, c;
    if (o.time && (u = Cy(o.time), isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (o.timezone || r.timeZone) {
      if (c = N6(
        o.timezone || r.timeZone,
        new Date(l + u)
      ), isNaN(c))
        return /* @__PURE__ */ new Date(NaN);
      if (c = N6(
        o.timezone || r.timeZone,
        new Date(l + u + c)
      ), isNaN(c))
        return /* @__PURE__ */ new Date(NaN);
    } else
      c = Jt(new Date(l + u)), c = Jt(
        new Date(l + u + c)
      );
    return new Date(l + u + c);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function _y(t) {
  const e = {}, r = t.split(z5.dateTimeDelimeter);
  let L;
  if (z5.plainTime.test(r[0]) ? (e.date = null, L = r[0]) : (e.date = r[0], L = r[1], e.timezone = r[2], z5.timeZoneDelimeter.test(e.date) && (e.date = t.split(z5.timeZoneDelimeter)[0], L = t.substr(e.date.length, t.length))), L) {
    const o = z5.timezone.exec(L);
    o ? (e.time = L.replace(o[1], ""), e.timezone = o[1]) : e.time = L;
  }
  return e;
}
function $y(t, e) {
  const r = z5.YYY[e], L = z5.YYYYY[e];
  let o;
  if (o = z5.YYYY.exec(t) || L.exec(t), o) {
    const n = o[1];
    return {
      year: parseInt(n, 10),
      restDateString: t.slice(n.length)
    };
  }
  if (o = z5.YY.exec(t) || r.exec(t), o) {
    const n = o[1];
    return {
      year: parseInt(n, 10) * 100,
      restDateString: t.slice(n.length)
    };
  }
  return {
    year: null
  };
}
function Sy(t, e) {
  if (e === null)
    return null;
  let r, L, o, n;
  if (t.length === 0)
    return L = /* @__PURE__ */ new Date(0), L.setUTCFullYear(e), L;
  if (r = z5.MM.exec(t), r)
    return L = /* @__PURE__ */ new Date(0), o = parseInt(r[1], 10) - 1, Y6(e, o) ? (L.setUTCFullYear(e, o), L) : /* @__PURE__ */ new Date(NaN);
  if (r = z5.DDD.exec(t), r) {
    L = /* @__PURE__ */ new Date(0);
    const a = parseInt(r[1], 10);
    return Iy(e, a) ? (L.setUTCFullYear(e, 0, a), L) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = z5.MMDD.exec(t), r) {
    L = /* @__PURE__ */ new Date(0), o = parseInt(r[1], 10) - 1;
    const a = parseInt(r[2], 10);
    return Y6(e, o, a) ? (L.setUTCFullYear(e, o, a), L) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = z5.Www.exec(t), r)
    return n = parseInt(r[1], 10) - 1, F6(e, n) ? R6(e, n) : /* @__PURE__ */ new Date(NaN);
  if (r = z5.WwwD.exec(t), r) {
    n = parseInt(r[1], 10) - 1;
    const a = parseInt(r[2], 10) - 1;
    return F6(e, n, a) ? R6(e, n, a) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Cy(t) {
  let e, r, L;
  if (e = z5.HH.exec(t), e)
    return r = parseFloat(e[1].replace(",", ".")), E0(r) ? r % 24 * Z0 : NaN;
  if (e = z5.HHMM.exec(t), e)
    return r = parseInt(e[1], 10), L = parseFloat(e[2].replace(",", ".")), E0(r, L) ? r % 24 * Z0 + L * B6 : NaN;
  if (e = z5.HHMMSS.exec(t), e) {
    r = parseInt(e[1], 10), L = parseInt(e[2], 10);
    const o = parseFloat(e[3].replace(",", "."));
    return E0(r, L, o) ? r % 24 * Z0 + L * B6 + o * 1e3 : NaN;
  }
  return null;
}
function R6(t, e, r) {
  e = e || 0, r = r || 0;
  const L = /* @__PURE__ */ new Date(0);
  L.setUTCFullYear(t, 0, 4);
  const o = L.getUTCDay() || 7, n = e * 7 + r + 1 - o;
  return L.setUTCDate(L.getUTCDate() + n), L;
}
const Dy = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], zy = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Hr(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Y6(t, e, r) {
  if (e < 0 || e > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    const L = Hr(t);
    if (L && r > zy[e] || !L && r > Dy[e])
      return !1;
  }
  return !0;
}
function Iy(t, e) {
  if (e < 1)
    return !1;
  const r = Hr(t);
  return !(r && e > 366 || !r && e > 365);
}
function F6(t, e, r) {
  return !(e < 0 || e > 52 || r != null && (r < 0 || r > 6));
}
function E0(t, e, r) {
  return !(t != null && (t < 0 || t >= 25) || e != null && (e < 0 || e >= 60) || r != null && (r < 0 || r >= 60));
}
function oe(t, e) {
  P5(1, arguments);
  const r = e || {}, L = r.locale, o = L && L.options && L.options.weekStartsOn, n = o == null ? 0 : $1(o), a = r.weekStartsOn == null ? n : $1(r.weekStartsOn);
  if (!(a >= 0 && a <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  const s = Z1(t), i = s.getDay(), l = (i < a ? 7 : 0) + i - a;
  return s.setDate(s.getDate() - l), s.setHours(0, 0, 0, 0), s;
}
function Qt(t) {
  return P5(1, arguments), oe(t, {
    weekStartsOn: 1
  });
}
function Ty(t) {
  P5(1, arguments);
  const e = Z1(t), r = e.getFullYear(), L = /* @__PURE__ */ new Date(0);
  L.setFullYear(r + 1, 0, 4), L.setHours(0, 0, 0, 0);
  const o = Qt(L), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0);
  const a = Qt(n);
  return e.getTime() >= o.getTime() ? r + 1 : e.getTime() >= a.getTime() ? r : r - 1;
}
function Oy(t) {
  P5(1, arguments);
  const e = Ty(t), r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), Qt(r);
}
const Py = 6048e5;
function Zy(t) {
  P5(1, arguments);
  const e = Z1(t), r = Qt(e).getTime() - Oy(e).getTime();
  return Math.round(r / Py) + 1;
}
function Ey(t, e) {
  P5(1, arguments);
  const r = Z1(t), L = r.getFullYear(), o = e || {}, n = o.locale, a = n && n.options && n.options.firstWeekContainsDate, s = a == null ? 1 : $1(a), i = o.firstWeekContainsDate == null ? s : $1(o.firstWeekContainsDate);
  if (!(i >= 1 && i <= 7))
    throw new RangeError(
      "firstWeekContainsDate must be between 1 and 7 inclusively"
    );
  const l = /* @__PURE__ */ new Date(0);
  l.setFullYear(L + 1, 0, i), l.setHours(0, 0, 0, 0);
  const u = oe(l, e), c = /* @__PURE__ */ new Date(0);
  c.setFullYear(L, 0, i), c.setHours(0, 0, 0, 0);
  const v = oe(c, e);
  return r.getTime() >= u.getTime() ? L + 1 : r.getTime() >= v.getTime() ? L : L - 1;
}
function Ay(t, e) {
  P5(1, arguments);
  const r = e || {}, L = r.locale, o = L && L.options && L.options.firstWeekContainsDate, n = o == null ? 1 : $1(o), a = r.firstWeekContainsDate == null ? n : $1(r.firstWeekContainsDate), s = Ey(t, e), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(s, 0, a), i.setHours(0, 0, 0, 0), oe(i, e);
}
const Ny = 6048e5;
function Hy(t, e) {
  P5(1, arguments);
  const r = Z1(t), L = oe(r, e).getTime() - Ay(r, e).getTime();
  return Math.round(L / Ny) + 1;
}
const By = 6048e5;
function Vy(t, e, r) {
  P5(2, arguments);
  const L = oe(t, r), o = oe(e, r), n = L.getTime() - Jt(L), a = o.getTime() - Jt(o);
  return Math.round((n - a) / By);
}
function Ry(t) {
  P5(1, arguments);
  const e = Z1(t), r = e.getMonth();
  return e.setFullYear(e.getFullYear(), r + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function Yy(t) {
  P5(1, arguments);
  const e = Z1(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function Fy(t, e) {
  return P5(1, arguments), Vy(
    Ry(t),
    Yy(t),
    e
  ) + 1;
}
const jy = 24 * 60 * 60 * 1e3;
class $5 {
  constructor(e, { order: r = 0, locale: L, isFullDay: o } = {}) {
    if (this.isDateInfo = !0, this.order = r, this.locale = L instanceof e0 ? L : new e0(L), this.firstDayOfWeek = this.locale.firstDayOfWeek, !e1(e)) {
      const i = this.locale.normalizeDate(e);
      o ? e = {
        start: i,
        end: i
      } : e = {
        startOn: i,
        endOn: i
      };
    }
    let n = null, a = null;
    if (e.start ? n = this.locale.normalizeDate(
      e.start,
      a5(j({}, this.opts), {
        time: "00:00:00"
      })
    ) : e.startOn && (n = this.locale.normalizeDate(e.startOn, this.opts)), e.end ? a = this.locale.normalizeDate(
      e.end,
      a5(j({}, this.opts), {
        time: "23:59:59"
      })
    ) : e.endOn && (a = this.locale.normalizeDate(e.endOn, this.opts)), n && a && n > a) {
      const i = n;
      n = a, a = i;
    } else
      n && e.span >= 1 && (a = k1(n, e.span - 1));
    this.start = n, this.startTime = n ? n.getTime() : NaN, this.end = a, this.endTime = a ? a.getTime() : NaN, this.isDate = this.startTime && this.startTime === this.endTime, this.isRange = !this.isDate;
    const s = P6(e, {}, $5.patternProps);
    if (s.assigned && (this.on = { and: s.target }), e.on) {
      const i = (V5(e.on) ? e.on : [e.on]).map((l) => {
        if (O1(l))
          return l;
        const u = P6(l, {}, $5.patternProps);
        return u.assigned ? u.target : null;
      }).filter((l) => l);
      i.length && (this.on = a5(j({}, this.on), { or: i }));
    }
    this.isComplex = !!this.on;
  }
  get opts() {
    return {
      order: this.order,
      locale: this.locale
    };
  }
  toDateInfo(e) {
    return e.isDateInfo ? e : new $5(e, this.opts);
  }
  startOfWeek(e) {
    const r = e.getDay() + 1, L = r >= this.firstDayOfWeek ? this.firstDayOfWeek - r : -(7 - (this.firstDayOfWeek - r));
    return k1(e, L);
  }
  diffInDays(e, r) {
    return Math.round((r - e) / jy);
  }
  diffInWeeks(e, r) {
    return this.diffInDays(this.startOfWeek(e), this.startOfWeek(r));
  }
  diffInYears(e, r) {
    return r.getUTCFullYear() - e.getUTCFullYear();
  }
  diffInMonths(e, r) {
    return this.diffInYears(e, r) * 12 + (r.getMonth() - e.getMonth());
  }
  static get patterns() {
    return {
      dailyInterval: {
        test: (e, r, L) => L.diffInDays(L.start || /* @__PURE__ */ new Date(), e.date) % r === 0
      },
      weeklyInterval: {
        test: (e, r, L) => L.diffInWeeks(L.start || /* @__PURE__ */ new Date(), e.date) % r === 0
      },
      monthlyInterval: {
        test: (e, r, L) => L.diffInMonths(L.start || /* @__PURE__ */ new Date(), e.date) % r === 0
      },
      yearlyInterval: {
        test: () => (e, r, L) => L.diffInYears(L.start || /* @__PURE__ */ new Date(), e.date) % r === 0
      },
      days: {
        validate: (e) => V5(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.day) || r.includes(-e.dayFromEnd)
      },
      weekdays: {
        validate: (e) => V5(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.weekday)
      },
      ordinalWeekdays: {
        validate: (e) => Object.keys(e).reduce((r, L) => {
          const o = e[L];
          return o && (r[L] = V5(o) ? o : [parseInt(o, 10)]), r;
        }, {}),
        test: (e, r) => Object.keys(r).map((L) => parseInt(L, 10)).find(
          (L) => r[L].includes(e.weekday) && (L === e.weekdayOrdinal || L === -e.weekdayOrdinalFromEnd)
        )
      },
      weekends: {
        validate: (e) => e,
        test: (e) => e.weekday === 1 || e.weekday === 7
      },
      workweek: {
        validate: (e) => e,
        test: (e) => e.weekday >= 2 && e.weekday <= 6
      },
      weeks: {
        validate: (e) => V5(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.week) || r.includes(-e.weekFromEnd)
      },
      months: {
        validate: (e) => V5(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.month)
      },
      years: {
        validate: (e) => V5(e) ? e : [parseInt(e, 10)],
        test: (e, r) => r.includes(e.year)
      }
    };
  }
  static get patternProps() {
    return Object.keys($5.patterns).map((e) => ({
      name: e,
      validate: $5.patterns[e].validate
    }));
  }
  static testConfig(e, r, L) {
    return O1(e) ? e(r) : e1(e) ? Object.keys(e).every(
      (o) => $5.patterns[o].test(r, e[o], L)
    ) : null;
  }
  iterateDatesInRange({ start: e, end: r }, L) {
    if (!e || !r || !O1(L))
      return null;
    e = this.locale.normalizeDate(
      e,
      a5(j({}, this.opts), {
        time: "00:00:00"
      })
    );
    const o = {
      i: 0,
      date: e,
      day: this.locale.getDateParts(e),
      finished: !1
    };
    let n = null;
    for (; !o.finished && o.date <= r; o.i++)
      n = L(o), o.date = k1(o.date, 1), o.day = this.locale.getDateParts(o.date);
    return n;
  }
  shallowIntersectingRange(e) {
    return this.rangeShallowIntersectingRange(this, this.toDateInfo(e));
  }
  rangeShallowIntersectingRange(e, r) {
    if (!this.dateShallowIntersectsDate(e, r))
      return null;
    const L = e.toRange(), o = r.toRange();
    let n = null, a = null;
    return L.start ? o.start ? n = L.start > o.start ? L.start : o.start : n = L.start : o.start && (n = o.start), L.end ? o.end ? a = L.end < o.end ? L.end : o.end : a = L.end : o.end && (a = o.end), { start: n, end: a };
  }
  intersectsDate(e) {
    const r = this.toDateInfo(e);
    if (!this.shallowIntersectsDate(r))
      return null;
    if (!this.on)
      return this;
    const L = this.rangeShallowIntersectingRange(this, r);
    let o = !1;
    return this.iterateDatesInRange(L, (n) => {
      this.matchesDay(n.day) && (o = o || r.matchesDay(n.day), n.finished = o);
    }), o;
  }
  shallowIntersectsDate(e) {
    return this.dateShallowIntersectsDate(this, this.toDateInfo(e));
  }
  dateShallowIntersectsDate(e, r) {
    return e.isDate ? r.isDate ? e.startTime === r.startTime : this.dateShallowIncludesDate(r, e) : r.isDate ? this.dateShallowIncludesDate(e, r) : !(e.start && r.end && e.start > r.end || e.end && r.start && e.end < r.start);
  }
  includesDate(e) {
    const r = this.toDateInfo(e);
    if (!this.shallowIncludesDate(r))
      return !1;
    if (!this.on)
      return !0;
    const L = this.rangeShallowIntersectingRange(this, r);
    let o = !0;
    return this.iterateDatesInRange(L, (n) => {
      this.matchesDay(n.day) && (o = o && r.matchesDay(n.day), n.finished = !o);
    }), o;
  }
  shallowIncludesDate(e) {
    return this.dateShallowIncludesDate(
      this,
      e.isDate ? e : new $5(e, this.opts)
    );
  }
  dateShallowIncludesDate(e, r) {
    return e.isDate ? r.isDate ? e.startTime === r.startTime : !r.startTime || !r.endTime ? !1 : e.startTime === r.startTime && e.startTime === r.endTime : r.isDate ? !(e.start && r.start < e.start || e.end && r.start > e.end) : !(e.start && (!r.start || r.start < e.start) || e.end && (!r.end || r.end > e.end));
  }
  intersectsDay(e) {
    return this.shallowIntersectsDate(e.range) && this.matchesDay(e) ? this : null;
  }
  matchesDay(e) {
    return this.on ? !(this.on.and && !$5.testConfig(this.on.and, e, this) || this.on.or && !this.on.or.some((r) => $5.testConfig(r, e, this))) : !0;
  }
  toRange() {
    return new $5(
      {
        start: this.start,
        end: this.end
      },
      this.opts
    );
  }
  compare(e) {
    if (this.order !== e.order)
      return this.order - e.order;
    if (this.isDate !== e.isDate)
      return this.isDate ? 1 : -1;
    if (this.isDate)
      return 0;
    const r = this.start - e.start;
    return r !== 0 ? r : this.end - e.end;
  }
}
const s1 = {
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  bg: { dow: 2, L: "D.MM.YYYY" },
  ca: { dow: 2, L: "DD/MM/YYYY" },
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  hr: { dow: 2, L: "DD.MM.YYYY" },
  cs: { dow: 2, L: "DD.MM.YYYY" },
  da: { dow: 2, L: "DD.MM.YYYY" },
  nl: { dow: 2, L: "DD-MM-YYYY" },
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  eo: { dow: 2, L: "YYYY-MM-DD" },
  et: { dow: 2, L: "DD.MM.YYYY" },
  fi: { dow: 2, L: "DD.MM.YYYY" },
  fr: { dow: 2, L: "DD/MM/YYYY" },
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  de: { dow: 2, L: "DD.MM.YYYY" },
  he: { dow: 1, L: "DD.MM.YYYY" },
  id: { dow: 2, L: "DD/MM/YYYY" },
  it: { dow: 2, L: "DD/MM/YYYY" },
  ja: { dow: 1, L: "YYYY年M月D日" },
  ko: { dow: 1, L: "YYYY.MM.DD" },
  lv: { dow: 2, L: "DD.MM.YYYY" },
  lt: { dow: 2, L: "DD.MM.YYYY" },
  mk: { dow: 2, L: "D.MM.YYYY" },
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  pl: { dow: 2, L: "DD.MM.YYYY" },
  pt: { dow: 2, L: "DD/MM/YYYY" },
  ro: { dow: 2, L: "DD.MM.YYYY" },
  ru: { dow: 2, L: "DD.MM.YYYY" },
  sk: { dow: 2, L: "DD.MM.YYYY" },
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  sv: { dow: 2, L: "YYYY-MM-DD" },
  th: { dow: 1, L: "DD/MM/YYYY" },
  tr: { dow: 2, L: "DD.MM.YYYY" },
  uk: { dow: 2, L: "DD.MM.YYYY" },
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
s1.en = s1["en-US"];
s1.es = s1["es-ES"];
s1.no = s1.nb;
s1.zh = s1["zh-CN"];
Bt(s1).forEach(([t, { dow: e, L: r }]) => {
  s1[t] = {
    id: t,
    firstDayOfWeek: e,
    masks: { L: r }
  };
});
const H1 = {
  DATE_TIME: 1,
  DATE: 2,
  TIME: 3
}, Wy = {
  1: ["year", "month", "day", "hours", "minutes", "seconds", "milliseconds"],
  2: ["year", "month", "day"],
  3: ["hours", "minutes", "seconds", "milliseconds"]
}, j6 = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, B1 = /\d\d?/, Uy = /\d{3}/, Gy = /\d{4}/, We = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, Ky = /\[([^]*?)\]/gm, W6 = () => {
}, U6 = (t) => (e, r, L) => {
  const o = L[t].indexOf(
    r.charAt(0).toUpperCase() + r.substring(1).toLowerCase()
  );
  ~o && (e.month = o);
}, qy = ["L", "iso"], Z5 = 7, Xy = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Jy = [
  { value: 0, label: "00" },
  { value: 1, label: "01" },
  { value: 2, label: "02" },
  { value: 3, label: "03" },
  { value: 4, label: "04" },
  { value: 5, label: "05" },
  { value: 6, label: "06" },
  { value: 7, label: "07" },
  { value: 8, label: "08" },
  { value: 9, label: "09" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" }
], G6 = {
  D(t) {
    return t.day;
  },
  DD(t) {
    return l5(t.day);
  },
  Do(t, e) {
    return e.DoFn(t.day);
  },
  d(t) {
    return t.weekday - 1;
  },
  dd(t) {
    return l5(t.weekday - 1);
  },
  W(t, e) {
    return e.dayNamesNarrow[t.weekday - 1];
  },
  WW(t, e) {
    return e.dayNamesShorter[t.weekday - 1];
  },
  WWW(t, e) {
    return e.dayNamesShort[t.weekday - 1];
  },
  WWWW(t, e) {
    return e.dayNames[t.weekday - 1];
  },
  M(t) {
    return t.month;
  },
  MM(t) {
    return l5(t.month);
  },
  MMM(t, e) {
    return e.monthNamesShort[t.month - 1];
  },
  MMMM(t, e) {
    return e.monthNames[t.month - 1];
  },
  YY(t) {
    return String(t.year).substring(2);
  },
  YYYY(t) {
    return l5(t.year, 4);
  },
  h(t) {
    return t.hours % 12 || 12;
  },
  hh(t) {
    return l5(t.hours % 12 || 12);
  },
  H(t) {
    return t.hours;
  },
  HH(t) {
    return l5(t.hours);
  },
  m(t) {
    return t.minutes;
  },
  mm(t) {
    return l5(t.minutes);
  },
  s(t) {
    return t.seconds;
  },
  ss(t) {
    return l5(t.seconds);
  },
  S(t) {
    return Math.round(t.milliseconds / 100);
  },
  SS(t) {
    return l5(Math.round(t.milliseconds / 10), 2);
  },
  SSS(t) {
    return l5(t.milliseconds, 3);
  },
  a(t, e) {
    return t.hours < 12 ? e.amPm[0] : e.amPm[1];
  },
  A(t, e) {
    return t.hours < 12 ? e.amPm[0].toUpperCase() : e.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${l5(Math.floor(Math.abs(e) / 60), 2)}`;
  },
  ZZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${l5(
      Math.floor(Math.abs(e) / 60) * 100 + Math.abs(e) % 60,
      4
    )}`;
  },
  ZZZZ(t) {
    const e = t.timezoneOffset;
    return `${e > 0 ? "-" : "+"}${l5(Math.floor(Math.abs(e) / 60), 2)}:${l5(
      Math.abs(e) % 60,
      2
    )}`;
  }
}, m5 = {
  D: [
    B1,
    (t, e) => {
      t.day = e;
    }
  ],
  Do: [
    new RegExp(B1.source + We.source),
    (t, e) => {
      t.day = parseInt(e, 10);
    }
  ],
  d: [B1, W6],
  W: [We, W6],
  M: [
    B1,
    (t, e) => {
      t.month = e - 1;
    }
  ],
  MMM: [We, U6("monthNamesShort")],
  MMMM: [We, U6("monthNames")],
  YY: [
    B1,
    (t, e) => {
      const L = +(/* @__PURE__ */ new Date()).getFullYear().toString().substring(0, 2);
      t.year = `${e > 68 ? L - 1 : L}${e}`;
    }
  ],
  YYYY: [
    Gy,
    (t, e) => {
      t.year = e;
    }
  ],
  S: [
    /\d/,
    (t, e) => {
      t.millisecond = e * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (t, e) => {
      t.millisecond = e * 10;
    }
  ],
  SSS: [
    Uy,
    (t, e) => {
      t.millisecond = e;
    }
  ],
  h: [
    B1,
    (t, e) => {
      t.hour = e;
    }
  ],
  m: [
    B1,
    (t, e) => {
      t.minute = e;
    }
  ],
  s: [
    B1,
    (t, e) => {
      t.second = e;
    }
  ],
  a: [
    We,
    (t, e, r) => {
      const L = e.toLowerCase();
      L === r.amPm[0] ? t.isPm = !1 : L === r.amPm[1] && (t.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (t, e) => {
      e === "Z" && (e = "+00:00");
      const r = `${e}`.match(/([+-]|\d\d)/gi);
      if (r) {
        const L = +(r[1] * 60) + parseInt(r[2], 10);
        t.timezoneOffset = r[0] === "+" ? L : -L;
      }
    }
  ]
};
m5.DD = m5.D;
m5.dd = m5.d;
m5.WWWW = m5.WWW = m5.WW = m5.W;
m5.MM = m5.M;
m5.mm = m5.m;
m5.hh = m5.H = m5.HH = m5.h;
m5.ss = m5.s;
m5.A = m5.a;
m5.ZZZZ = m5.ZZZ = m5.ZZ = m5.Z;
function Qy(t, e) {
  const r = new Intl.DateTimeFormat().resolvedOptions().locale;
  let L;
  R1(t) ? L = t : e4(t, "id") && (L = t.id), L = (L || r).toLowerCase();
  const o = Object.keys(e), n = (s) => o.find((i) => i.toLowerCase() === s);
  L = n(L) || n(L.substring(0, 2)) || r;
  const a = a5(
    j(j({}, e["en-IE"]), e[L]),
    { id: L }
  );
  return t = e1(t) ? Q2(t, a) : a, t;
}
class e0 {
  constructor(e, { locales: r = s1, timezone: L } = {}) {
    const {
      id: o,
      firstDayOfWeek: n,
      masks: a
    } = Qy(e, r);
    this.id = o, this.daysInWeek = Z5, this.firstDayOfWeek = ra(n, 1, Z5), this.masks = a, this.timezone = L || void 0, this.dayNames = this.getDayNames("long"), this.dayNamesShort = this.getDayNames("short"), this.dayNamesShorter = this.dayNamesShort.map((s) => s.substring(0, 2)), this.dayNamesNarrow = this.getDayNames("narrow"), this.monthNames = this.getMonthNames("long"), this.monthNamesShort = this.getMonthNames("short"), this.amPm = ["am", "pm"], this.monthData = {}, this.getMonthComps = this.getMonthComps.bind(this), this.parse = this.parse.bind(this), this.format = this.format.bind(this), this.toPage = this.toPage.bind(this);
  }
  format(e, r) {
    if (e = this.normalizeDate(e), !e)
      return "";
    r = this.normalizeMasks(r)[0];
    const L = [];
    r = r.replace(Ky, (a, s) => (L.push(s), "??"));
    const o = /Z$/.test(r) ? "utc" : this.timezone, n = this.getDateParts(e, o);
    return r = r.replace(
      j6,
      (a) => a in G6 ? G6[a](n, this) : a.slice(1, a.length - 1)
    ), r.replace(/\?\?/g, () => L.shift());
  }
  parse(e, r) {
    return this.normalizeMasks(r).map((o) => {
      if (typeof o != "string")
        throw new Error("Invalid mask in fecha.parse");
      let n = e;
      if (n.length > 1e3)
        return !1;
      let a = !0;
      const s = {};
      if (o.replace(j6, (u) => {
        if (m5[u]) {
          const c = m5[u], v = n.search(c[0]);
          ~v ? n.replace(c[0], (p) => (c[1](s, p, this), n = n.substring(v + p.length), p)) : a = !1;
        }
        return m5[u] ? "" : u.slice(1, u.length - 1);
      }), !a)
        return !1;
      const i = /* @__PURE__ */ new Date();
      s.isPm === !0 && s.hour != null && +s.hour != 12 ? s.hour = +s.hour + 12 : s.isPm === !1 && +s.hour == 12 && (s.hour = 0);
      let l;
      return s.timezoneOffset != null ? (s.minute = +(s.minute || 0) - +s.timezoneOffset, l = new Date(
        Date.UTC(
          s.year || i.getFullYear(),
          s.month || 0,
          s.day || 1,
          s.hour || 0,
          s.minute || 0,
          s.second || 0,
          s.millisecond || 0
        )
      )) : l = this.getDateFromParts({
        year: s.year || i.getFullYear(),
        month: (s.month || 0) + 1,
        day: s.day || 1,
        hours: s.hour || 0,
        minutes: s.minute || 0,
        seconds: s.second || 0,
        milliseconds: s.millisecond || 0
      }), l;
    }).find((o) => o) || new Date(e);
  }
  normalizeMasks(e) {
    return (Q5(e) && e || [
      R1(e) && e || "YYYY-MM-DD"
    ]).map(
      (r) => qy.reduce(
        (L, o) => L.replace(o, this.masks[o] || ""),
        r
      )
    );
  }
  normalizeDate(e, r = {}) {
    let L = null, { type: o, fillDate: n } = r;
    const { mask: a, patch: s, time: i } = r, l = o === "auto" || !o;
    if (Qe(e) ? (o = "number", L = /* @__PURE__ */ new Date(+e)) : R1(e) ? (o = "string", L = e ? this.parse(e, a || "iso") : null) : e1(e) ? (o = "object", L = this.getDateFromParts(e)) : (o = "date", L = F1(e) ? new Date(e.getTime()) : null), L && s) {
      n = n == null ? /* @__PURE__ */ new Date() : this.normalizeDate(n);
      const u = j(
        j({}, this.getDateParts(n)),
        Ap(this.getDateParts(L), Wy[s])
      );
      L = this.getDateFromParts(u);
    }
    return l && (r.type = o), L && !isNaN(L.getTime()) ? (i && (L = this.adjustTimeForDate(L, {
      timeAdjust: i
    })), L) : null;
  }
  denormalizeDate(e, { type: r, mask: L } = {}) {
    switch (r) {
      case "number":
        return e ? e.getTime() : NaN;
      case "string":
        return e ? this.format(e, L || "iso") : "";
      default:
        return e ? new Date(e) : null;
    }
  }
  hourIsValid(e, r, L) {
    if (!r)
      return !0;
    if (V5(r))
      return r.includes(e);
    if (e1(r)) {
      const o = r.min || 0, n = r.max || 24;
      return o <= e && n >= e;
    }
    return r(e, L);
  }
  getHourOptions(e, r) {
    return Jy.filter(
      (L) => this.hourIsValid(L.value, e, r)
    );
  }
  getMinuteOptions(e) {
    const r = [];
    e = e > 0 ? e : 1;
    for (let L = 0; L <= 59; L += e)
      r.push({
        value: L,
        label: l5(L, 2)
      });
    return r;
  }
  nearestOptionValue(e, r) {
    if (e == null)
      return e;
    const L = r.reduce((o, n) => {
      if (n.disabled)
        return o;
      if (isNaN(o))
        return n.value;
      const a = Math.abs(o - e);
      return Math.abs(n.value - e) < a ? n.value : o;
    }, NaN);
    return isNaN(L) ? e : L;
  }
  adjustTimeForDate(e, { timeAdjust: r, validHours: L, minuteIncrement: o }) {
    if (!r && !L && !o)
      return e;
    const n = this.getDateParts(e);
    if (r)
      if (r === "now") {
        const a = this.getDateParts(/* @__PURE__ */ new Date());
        n.hours = a.hours, n.minutes = a.minutes, n.seconds = a.seconds, n.milliseconds = a.milliseconds;
      } else {
        const a = /* @__PURE__ */ new Date(`2000-01-01T${r}Z`);
        n.hours = a.getUTCHours(), n.minutes = a.getUTCMinutes(), n.seconds = a.getUTCSeconds(), n.milliseconds = a.getUTCMilliseconds();
      }
    if (L) {
      const a = this.getHourOptions(L, n);
      n.hours = this.nearestOptionValue(n.hours, a);
    }
    if (o) {
      const a = this.getMinuteOptions(o);
      n.minutes = this.nearestOptionValue(n.minutes, a);
    }
    return e = this.getDateFromParts(n), e;
  }
  normalizeDates(e, r) {
    return r = r || {}, r.locale = this, (V5(e) ? e : [e]).map((L) => L && (L instanceof $5 ? L : new $5(L, r))).filter((L) => L);
  }
  getDateParts(e, r = this.timezone) {
    if (!e)
      return null;
    let L = e;
    if (r) {
      const g = new Date(
        e.toLocaleString("en-US", { timeZone: r })
      );
      g.setMilliseconds(e.getMilliseconds());
      const h = g.getTime() - e.getTime();
      L = new Date(e.getTime() + h);
    }
    const o = L.getMilliseconds(), n = L.getSeconds(), a = L.getMinutes(), s = L.getHours(), i = L.getMonth() + 1, l = L.getFullYear(), u = this.getMonthComps(i, l), c = L.getDate(), v = u.days - c + 1, p = L.getDay() + 1, m = Math.floor((c - 1) / 7 + 1), f = Math.floor((u.days - c) / 7 + 1), x = Math.ceil(
      (c + Math.abs(u.firstWeekday - u.firstDayOfWeek)) / 7
    ), y = u.weeks - x + 1, w = {
      milliseconds: o,
      seconds: n,
      minutes: a,
      hours: s,
      day: c,
      dayFromEnd: v,
      weekday: p,
      weekdayOrdinal: m,
      weekdayOrdinalFromEnd: f,
      week: x,
      weekFromEnd: y,
      month: i,
      year: l,
      date: e,
      isValid: !0
    };
    return w.timezoneOffset = this.getTimezoneOffset(w), w;
  }
  getDateFromParts(e) {
    if (!e)
      return null;
    const r = /* @__PURE__ */ new Date(), {
      year: L = r.getFullYear(),
      month: o = r.getMonth() + 1,
      day: n = r.getDate(),
      hours: a = 0,
      minutes: s = 0,
      seconds: i = 0,
      milliseconds: l = 0
    } = e;
    if (this.timezone) {
      const u = `${l5(L, 4)}-${l5(o, 2)}-${l5(n, 2)}T${l5(
        a,
        2
      )}:${l5(s, 2)}:${l5(i, 2)}.${l5(l, 3)}`;
      return V6(u, { timeZone: this.timezone });
    }
    return new Date(L, o - 1, n, a, s, i, l);
  }
  getTimezoneOffset(e) {
    const {
      year: r,
      month: L,
      day: o,
      hours: n = 0,
      minutes: a = 0,
      seconds: s = 0,
      milliseconds: i = 0
    } = e;
    let l;
    const u = new Date(Date.UTC(r, L - 1, o, n, a, s, i));
    if (this.timezone) {
      const c = `${l5(r, 4)}-${l5(L, 2)}-${l5(o, 2)}T${l5(
        n,
        2
      )}:${l5(a, 2)}:${l5(s, 2)}.${l5(i, 3)}`;
      l = V6(c, { timeZone: this.timezone });
    } else
      l = new Date(r, L - 1, o, n, a, s, i);
    return (l - u) / 6e4;
  }
  toPage(e, r) {
    return Qe(e) ? I1(r, e) : R1(e) ? this.getDateParts(this.normalizeDate(e)) : F1(e) ? this.getDateParts(e) : e1(e) ? e : null;
  }
  getMonthDates(e = 2e3) {
    const r = [];
    for (let L = 0; L < 12; L++)
      r.push(new Date(e, L, 15));
    return r;
  }
  getMonthNames(e) {
    const r = new Intl.DateTimeFormat(this.id, {
      month: e,
      timezome: "UTC"
    });
    return this.getMonthDates().map((L) => r.format(L));
  }
  getWeekdayDates(e = this.firstDayOfWeek) {
    const r = [], n = 5 + e - 1;
    for (let a = 0; a < Z5; a++)
      r.push(
        this.getDateFromParts({
          year: 2020,
          month: 1,
          day: n + a,
          hours: 12
        })
      );
    return r;
  }
  getDayNames(e) {
    const r = new Intl.DateTimeFormat(this.id, {
      weekday: e,
      timeZone: this.timezone
    });
    return this.getWeekdayDates(1).map((L) => r.format(L));
  }
  getMonthComps(e, r) {
    const L = `${e}-${r}`;
    let o = this.monthData[L];
    if (!o) {
      const n = r % 4 === 0 && r % 100 !== 0 || r % 400 === 0, a = new Date(r, e - 1, 1), s = a.getDay() + 1, i = e === 2 && n ? 29 : Xy[e - 1], l = this.firstDayOfWeek - 1, u = Fy(a, {
        weekStartsOn: l
      }), c = [], v = [];
      for (let p = 0; p < u; p++) {
        const m = k1(a, p * 7);
        c.push(Hy(m, { weekStartsOn: l })), v.push(Zy(m));
      }
      o = {
        firstDayOfWeek: this.firstDayOfWeek,
        inLeapYear: n,
        firstWeekday: s,
        days: i,
        weeks: u,
        month: e,
        year: r,
        weeknumbers: c,
        isoWeeknumbers: v
      }, this.monthData[L] = o;
    }
    return o;
  }
  getThisMonthComps() {
    const { month: e, year: r } = this.getDateParts(/* @__PURE__ */ new Date());
    return this.getMonthComps(e, r);
  }
  getPrevMonthComps(e, r) {
    return e === 1 ? this.getMonthComps(12, r - 1) : this.getMonthComps(e - 1, r);
  }
  getNextMonthComps(e, r) {
    return e === 12 ? this.getMonthComps(1, r + 1) : this.getMonthComps(e + 1, r);
  }
  getDayId(e) {
    return this.format(e, "YYYY-MM-DD");
  }
  getCalendarDays({ weeks: e, monthComps: r, prevMonthComps: L, nextMonthComps: o }) {
    const n = [], { firstDayOfWeek: a, firstWeekday: s, isoWeeknumbers: i, weeknumbers: l } = r, u = s + (s < a ? Z5 : 0) - a;
    let c = !0, v = !1, p = !1;
    const m = new Intl.DateTimeFormat(this.id, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    let f = L.days - u + 1, x = L.days - f + 1, y = Math.floor((f - 1) / Z5 + 1), w = 1, g = L.weeks, h = 1, k = L.month, M = L.year;
    const $ = /* @__PURE__ */ new Date(), C = $.getDate(), D = $.getMonth() + 1, S = $.getFullYear(), T = (B, I, R) => (N, H, G, e5) => this.normalizeDate({
      year: B,
      month: I,
      day: R,
      hours: N,
      minutes: H,
      seconds: G,
      milliseconds: e5
    });
    for (let B = 1; B <= e; B++) {
      for (let I = 1, R = a; I <= Z5; I++, R += R === Z5 ? 1 - Z5 : 1) {
        c && R === s && (f = 1, x = r.days, y = Math.floor((f - 1) / Z5 + 1), w = Math.floor(
          (r.days - f) / Z5 + 1
        ), g = 1, h = r.weeks, k = r.month, M = r.year, c = !1, v = !0);
        const N = T(M, k, f), H = {
          start: N(0, 0, 0),
          end: N(23, 59, 59, 999)
        }, G = H.start, e5 = `${l5(M, 4)}-${l5(k, 2)}-${l5(f, 2)}`, t5 = I, J = Z5 - I, h5 = l[B - 1], n5 = i[B - 1], _5 = f === C && k === D && M === S, o5 = v && f === 1, i5 = v && f === r.days, k5 = B === 1, f5 = B === e, E = I === 1, L5 = I === Z5;
        n.push({
          id: e5,
          label: f.toString(),
          ariaLabel: m.format(new Date(M, k - 1, f)),
          day: f,
          dayFromEnd: x,
          weekday: R,
          weekdayPosition: t5,
          weekdayPositionFromEnd: J,
          weekdayOrdinal: y,
          weekdayOrdinalFromEnd: w,
          week: g,
          weekFromEnd: h,
          weeknumber: h5,
          isoWeeknumber: n5,
          month: k,
          year: M,
          dateFromTime: N,
          date: G,
          range: H,
          isToday: _5,
          isFirstDay: o5,
          isLastDay: i5,
          inMonth: v,
          inPrevMonth: c,
          inNextMonth: p,
          onTop: k5,
          onBottom: f5,
          onLeft: E,
          onRight: L5,
          classes: [
            `id-${e5}`,
            `day-${f}`,
            `day-from-end-${x}`,
            `weekday-${R}`,
            `weekday-position-${t5}`,
            `weekday-ordinal-${y}`,
            `weekday-ordinal-from-end-${w}`,
            `week-${g}`,
            `week-from-end-${h}`,
            {
              "is-today": _5,
              "is-first-day": o5,
              "is-last-day": i5,
              "in-month": v,
              "in-prev-month": c,
              "in-next-month": p,
              "on-top": k5,
              "on-bottom": f5,
              "on-left": E,
              "on-right": L5
            }
          ]
        }), v && i5 ? (v = !1, p = !0, f = 1, x = o.days, y = 1, w = Math.floor(
          (o.days - f) / Z5 + 1
        ), g = 1, h = o.weeks, k = o.month, M = o.year) : (f++, x--, y = Math.floor((f - 1) / Z5 + 1), w = Math.floor(
          (r.days - f) / Z5 + 1
        ));
      }
      g++, h--;
    }
    return n;
  }
}
class Br {
  constructor({
    key: e,
    hashcode: r,
    highlight: L,
    content: o,
    dot: n,
    bar: a,
    popover: s,
    dates: i,
    excludeDates: l,
    excludeMode: u,
    customData: c,
    order: v,
    pinPage: p
  }, m, f) {
    this.key = D7(e) ? Xt() : e, this.hashcode = r, this.customData = c, this.order = v || 0, this.dateOpts = { order: v, locale: f }, this.pinPage = p, L && (this.highlight = m.normalizeHighlight(L)), o && (this.content = m.normalizeContent(o)), n && (this.dot = m.normalizeDot(n)), a && (this.bar = m.normalizeBar(a)), s && (this.popover = s), this.dates = f.normalizeDates(i, this.dateOpts), this.hasDates = !!Q5(this.dates), this.excludeDates = f.normalizeDates(l, this.dateOpts), this.hasExcludeDates = !!Q5(this.excludeDates), this.excludeMode = u || "intersects", this.hasExcludeDates && !this.hasDates && (this.dates.push(new $5({}, this.dateOpts)), this.hasDates = !0), this.isComplex = iy(this.dates, (x) => x.isComplex);
  }
  intersectsDate(e) {
    return e = e instanceof $5 ? e : new $5(e, this.dateOpts), !this.excludesDate(e) && (this.dates.find((r) => r.intersectsDate(e)) || !1);
  }
  includesDate(e) {
    return e = e instanceof $5 ? e : new $5(e, this.dateOpts), !this.excludesDate(e) && (this.dates.find((r) => r.includesDate(e)) || !1);
  }
  excludesDate(e) {
    return e = e instanceof $5 ? e : new $5(e, this.dateOpts), this.hasExcludeDates && this.excludeDates.find(
      (r) => this.excludeMode === "intersects" && r.intersectsDate(e) || this.excludeMode === "includes" && r.includesDate(e)
    );
  }
  intersectsDay(e) {
    return !this.excludesDay(e) && (this.dates.find((r) => r.intersectsDay(e)) || !1);
  }
  excludesDay(e) {
    return this.hasExcludeDates && this.excludeDates.find((r) => r.intersectsDay(e));
  }
}
const ew = 300, tw = 60, rw = 80, Lw = {
  maxSwipeTime: ew,
  minHorizontalSwipeDistance: tw,
  maxVerticalSwipeDistance: rw
}, nw = "MMMM YYYY", ow = "W", sw = "MMM", aw = ["L", "YYYY-MM-DD", "YYYY/MM/DD"], iw = ["L h:mm A", "YYYY-MM-DD h:mm A", "YYYY/MM/DD h:mm A"], lw = ["L HH:mm", "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm"], uw = ["h:mm A"], dw = ["HH:mm"], cw = "WWW, MMM D, YYYY", hw = ["L", "YYYY-MM-DD", "YYYY/MM/DD"], fw = "iso", pw = "YYYY-MM-DDTHH:mm:ss.SSSZ", mw = {
  title: nw,
  weekdays: ow,
  navMonths: sw,
  input: aw,
  inputDateTime: iw,
  inputDateTime24hr: lw,
  inputTime: uw,
  inputTime24hr: dw,
  dayPopover: cw,
  data: hw,
  model: fw,
  iso: pw
}, gw = "640px", vw = "768px", yw = "1024px", ww = "1280px", bw = {
  sm: gw,
  md: vw,
  lg: yw,
  xl: ww
}, xw = {
  componentPrefix: "v",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: Lw,
  masks: mw,
  screens: bw,
  locales: s1,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      keepVisibleOnInput: !1,
      isInteractive: !0
    }
  }
}, u2 = st(xw), kw = U(() => Rc(u2.locales, (t) => (t.masks = Q2(t.masks, u2.masks), t))), j1 = (t) => window && e4(window.__vcalendar__, t) ? lt(window.__vcalendar__, t) : lt(u2, t), Mw = {
  props: {
    color: {
      type: String,
      default: () => j1("color")
    },
    isDark: {
      type: Boolean,
      default: () => j1("isDark")
    },
    firstDayOfWeek: Number,
    masks: Object,
    locale: [String, Object],
    timezone: String,
    minDate: null,
    maxDate: null,
    minDateExact: null,
    maxDateExact: null,
    disabledDates: null,
    availableDates: null,
    theme: null
  },
  computed: {
    $theme() {
      return this.theme instanceof Z6 ? this.theme : new Z6({
        color: this.color,
        isDark: this.isDark
      });
    },
    $locale() {
      if (this.locale instanceof e0)
        return this.locale;
      const t = e1(this.locale) ? this.locale : {
        id: this.locale,
        firstDayOfWeek: this.firstDayOfWeek,
        masks: this.masks
      };
      return new e0(t, {
        locales: kw.value,
        timezone: this.timezone
      });
    },
    disabledDates_() {
      const t = this.normalizeDates(this.disabledDates), { minDate: e, minDateExact: r, maxDate: L, maxDateExact: o } = this;
      if (r || e) {
        const n = r ? this.normalizeDate(r) : this.normalizeDate(e, { time: "00:00:00" });
        t.push({
          start: null,
          end: new Date(n.getTime() - 1e3)
        });
      }
      if (o || L) {
        const n = o ? this.normalizeDate(o) : this.normalizeDate(L, { time: "23:59:59" });
        t.push({
          start: new Date(n.getTime() + 1e3),
          end: null
        });
      }
      return t;
    },
    availableDates_() {
      return this.normalizeDates(this.availableDates);
    },
    disabledAttribute() {
      return new Br(
        {
          key: "disabled",
          dates: this.disabledDates_,
          excludeDates: this.availableDates_,
          excludeMode: "includes",
          order: 100
        },
        this.$theme,
        this.$locale
      );
    }
  },
  methods: {
    formatDate(t, e) {
      return this.$locale ? this.$locale.format(t, e) : "";
    },
    parseDate(t, e) {
      if (!this.$locale)
        return null;
      const r = this.$locale.parse(t, e);
      return F1(r) ? r : null;
    },
    normalizeDate(t, e) {
      return this.$locale ? this.$locale.normalizeDate(t, e) : t;
    },
    normalizeDates(t) {
      return this.$locale.normalizeDates(t, {
        isFullDay: !0
      });
    },
    pageForDate(t) {
      return this.$locale.getDateParts(this.normalizeDate(t));
    },
    pageForThisMonth() {
      return this.pageForDate(/* @__PURE__ */ new Date());
    }
  }
}, _w = {
  methods: {
    safeSlot(t, e, r = null) {
      return O1(this.$slots[t]) ? this.$slots[t](e) : r;
    }
  }
}, y0 = fy, Vr = Mw, t4 = _w, $w = {
  name: "PopoverRow",
  mixins: [y0],
  props: {
    attribute: Object
  },
  computed: {
    indicator() {
      const { highlight: t, dot: e, bar: r, popover: L } = this.attribute;
      if (L && L.hideIndicator)
        return null;
      if (t) {
        const { color: o, isDark: n } = t.start;
        return {
          style: a5(
            j(
              {},
              this.theme.bgAccentHigh({
                color: o,
                isDark: !n
              })
            ),
            {
              width: "10px",
              height: "5px",
              borderRadius: "3px"
            }
          )
        };
      }
      if (e) {
        const { color: o, isDark: n } = e.start;
        return {
          style: a5(
            j(
              {},
              this.theme.bgAccentHigh({
                color: o,
                isDark: !n
              })
            ),
            {
              width: "5px",
              height: "5px",
              borderRadius: "50%"
            }
          )
        };
      }
      if (r) {
        const { color: o, isDark: n } = r.start;
        return {
          style: a5(
            j(
              {},
              this.theme.bgAccentHigh({
                color: o,
                isDark: !n
              })
            ),
            {
              width: "10px",
              height: "3px"
            }
          )
        };
      }
      return null;
    }
  }
}, Sw = { class: "vc-day-popover-row" }, Cw = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, Dw = { class: "vc-day-popover-row-content" };
function zw(t, e, r, L, o, n) {
  return b(), _("div", Sw, [
    n.indicator ? (b(), _("div", Cw, [
      d(
        "span",
        {
          style: R5(n.indicator.style),
          class: F(n.indicator.class)
        },
        null,
        6
      )
    ])) : X("", !0),
    d("div", Dw, [
      u5(t.$slots, "default", {}, () => [
        c1(
          V(
            r.attribute.popover ? r.attribute.popover.label : "No content provided"
          ),
          1
        )
      ])
    ])
  ]);
}
const Iw = /* @__PURE__ */ He($w, [
  ["render", zw]
]), It = "26px", Tw = "0 0 32 32", Ow = {
  "left-arrow": {
    viewBox: "0 -1 16 34",
    path: "M11.196 10c0 0.143-0.071 0.304-0.179 0.411l-7.018 7.018 7.018 7.018c0.107 0.107 0.179 0.268 0.179 0.411s-0.071 0.304-0.179 0.411l-0.893 0.893c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-8.321-8.321c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l8.321-8.321c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l0.893 0.893c0.107 0.107 0.179 0.25 0.179 0.411z"
  },
  "right-arrow": {
    viewBox: "-5 -1 16 34",
    path: "M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z"
  }
}, Pw = {
  props: ["name"],
  data() {
    return {
      width: It,
      height: It,
      viewBox: Tw,
      path: "",
      isBaseline: !1
    };
  },
  mounted() {
    this.updateIcon();
  },
  watch: {
    name() {
      this.updateIcon();
    }
  },
  methods: {
    updateIcon() {
      const t = Ow[this.name];
      t && (this.width = t.width || It, this.height = t.height || It, this.viewBox = t.viewBox, this.path = t.path);
    }
  }
}, Zw = ["width", "height", "viewBox"], Ew = ["d"];
function Aw(t, e, r, L, o, n) {
  return b(), _(
    "svg",
    {
      class: "vc-svg-icon",
      width: o.width,
      height: o.height,
      viewBox: o.viewBox
    },
    [d("path", { d: o.path }, null, 8, Ew)],
    8,
    Zw
  );
}
const Rr = /* @__PURE__ */ He(Pw, [
  ["render", Aw]
]), A0 = 12, Nw = {
  name: "CalendarNav",
  emits: ["input"],
  components: {
    SvgIcon: Rr
  },
  mixins: [y0],
  props: {
    value: { type: Object, default: () => ({ month: 0, year: 0 }) },
    validator: { type: Function, default: () => () => !0 }
  },
  data() {
    return {
      monthMode: !0,
      yearIndex: 0,
      yearGroupIndex: 0,
      onSpaceOrEnter: Ar
    };
  },
  computed: {
    month() {
      return this.value && this.value.month || 0;
    },
    year() {
      return this.value && this.value.year || 0;
    },
    title() {
      return this.monthMode ? this.yearIndex : `${this.firstYear} - ${this.lastYear}`;
    },
    monthItems() {
      return this.getMonthItems(this.yearIndex);
    },
    yearItems() {
      return this.getYearItems(this.yearGroupIndex);
    },
    prevItemsEnabled() {
      return this.monthMode ? this.prevMonthItemsEnabled : this.prevYearItemsEnabled;
    },
    nextItemsEnabled() {
      return this.monthMode ? this.nextMonthItemsEnabled : this.nextYearItemsEnabled;
    },
    prevMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex - 1).some((t) => !t.isDisabled);
    },
    nextMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex + 1).some((t) => !t.isDisabled);
    },
    prevYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex - 1).some(
        (t) => !t.isDisabled
      );
    },
    nextYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex + 1).some(
        (t) => !t.isDisabled
      );
    },
    activeItems() {
      return this.monthMode ? this.monthItems : this.yearItems;
    },
    firstYear() {
      return Pr(this.yearItems.map((t) => t.year));
    },
    lastYear() {
      return ut(this.yearItems.map((t) => t.year));
    }
  },
  watch: {
    year() {
      this.yearIndex = this.year;
    },
    yearIndex(t) {
      this.yearGroupIndex = this.getYearGroupIndex(t);
    },
    value() {
      this.focusFirstItem();
    }
  },
  created() {
    this.yearIndex = this.year;
  },
  mounted() {
    this.focusFirstItem();
  },
  methods: {
    focusFirstItem() {
      this.$nextTick(() => {
        const t = this.$refs.navContainer.querySelector(
          ".vc-nav-item:not(.is-disabled)"
        );
        t && t.focus();
      });
    },
    getItemClasses({ isActive: t, isCurrent: e, isDisabled: r }) {
      const L = ["vc-nav-item"];
      return t ? L.push("is-active") : e && L.push("is-current"), r && L.push("is-disabled"), L;
    },
    getYearGroupIndex(t) {
      return Math.floor(t / A0);
    },
    getMonthItems(t) {
      const { month: e, year: r } = this.pageForDate(/* @__PURE__ */ new Date());
      return this.locale.getMonthDates().map((L, o) => {
        const n = o + 1;
        return {
          month: n,
          year: t,
          id: `${t}.${l5(n, 2)}`,
          label: this.locale.format(L, this.masks.navMonths),
          ariaLabel: this.locale.format(L, "MMMM YYYY"),
          isActive: n === this.month && t === this.year,
          isCurrent: n === e && t === r,
          isDisabled: !this.validator({ month: n, year: t }),
          click: () => this.monthClick(n, t)
        };
      });
    },
    getYearItems(t) {
      const { _: e, year: r } = this.pageForDate(/* @__PURE__ */ new Date()), L = t * A0, o = L + A0, n = [];
      for (let a = L; a < o; a += 1) {
        let s = !1;
        for (let i = 1; i < 12 && (s = this.validator({ month: i, year: a }), !s); i++)
          ;
        n.push({
          year: a,
          id: a,
          label: a,
          ariaLabel: a,
          isActive: a === this.year,
          isCurrent: a === r,
          isDisabled: !s,
          click: () => this.yearClick(a)
        });
      }
      return n;
    },
    monthClick(t, e) {
      this.validator({ month: t, year: e }) && this.$emit("input", { month: t, year: e });
    },
    yearClick(t) {
      this.yearIndex = t, this.monthMode = !0, this.focusFirstItem();
    },
    toggleMode() {
      this.monthMode = !this.monthMode;
    },
    movePrev() {
      this.prevItemsEnabled && (this.monthMode && this.movePrevYear(), this.movePrevYearGroup());
    },
    moveNext() {
      this.nextItemsEnabled && (this.monthMode && this.moveNextYear(), this.moveNextYearGroup());
    },
    movePrevYear() {
      this.yearIndex--;
    },
    moveNextYear() {
      this.yearIndex++;
    },
    movePrevYearGroup() {
      this.yearGroupIndex--;
    },
    moveNextYearGroup() {
      this.yearGroupIndex++;
    }
  }
}, Hw = {
  class: "vc-nav-container",
  ref: "navContainer"
}, Bw = { class: "vc-nav-header" }, Vw = ["tabindex"], Rw = ["tabindex"], Yw = { class: "vc-nav-items" }, Fw = [
  "data-id",
  "aria-label",
  "tabindex",
  "onClick",
  "onKeydown"
];
function jw(t, e, r, L, o, n) {
  const a = o0("svg-icon");
  return b(), _(
    "div",
    Hw,
    [
      d("div", Bw, [
        d(
          "span",
          {
            role: "button",
            class: F([
              "vc-nav-arrow is-left",
              { "is-disabled": !n.prevItemsEnabled }
            ]),
            tabindex: n.prevItemsEnabled ? 0 : void 0,
            onClick: e[0] || (e[0] = (...s) => n.movePrev && n.movePrev(...s)),
            onKeydown: e[1] || (e[1] = (s) => o.onSpaceOrEnter(s, n.movePrev))
          },
          [
            u5(t.$slots, "nav-left-button", {}, () => [
              Z(a, {
                name: "left-arrow",
                width: "20px",
                height: "24px"
              })
            ])
          ],
          42,
          Vw
        ),
        d(
          "span",
          {
            role: "button",
            class: "vc-nav-title vc-grid-focus",
            style: { whiteSpace: "nowrap" },
            tabindex: "0",
            onClick: e[2] || (e[2] = (...s) => n.toggleMode && n.toggleMode(...s)),
            onKeydown: e[3] || (e[3] = (s) => o.onSpaceOrEnter(s, n.toggleMode))
          },
          V(n.title),
          33
        ),
        d(
          "span",
          {
            role: "button",
            class: F([
              "vc-nav-arrow is-right",
              { "is-disabled": !n.nextItemsEnabled }
            ]),
            tabindex: n.nextItemsEnabled ? 0 : void 0,
            onClick: e[4] || (e[4] = (...s) => n.moveNext && n.moveNext(...s)),
            onKeydown: e[5] || (e[5] = (s) => o.onSpaceOrEnter(s, n.moveNext))
          },
          [
            u5(t.$slots, "nav-right-button", {}, () => [
              Z(a, {
                name: "right-arrow",
                width: "20px",
                height: "24px"
              })
            ])
          ],
          42,
          Rw
        )
      ]),
      d("div", Yw, [
        (b(!0), _(
          p5,
          null,
          S5(n.activeItems, (s) => (b(), _(
            "span",
            {
              key: s.label,
              role: "button",
              "data-id": s.id,
              "aria-label": s.ariaLabel,
              class: F(n.getItemClasses(s)),
              tabindex: s.isDisabled ? void 0 : 0,
              onClick: s.click,
              onKeydown: (i) => o.onSpaceOrEnter(i, s.click)
            },
            V(s.label),
            43,
            Fw
          ))),
          128
        ))
      ])
    ],
    512
  );
}
const Ww = /* @__PURE__ */ He(Nw, [
  ["render", jw]
]);
function d2(t) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: t
    })
  );
}
function c2(t) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: t
    })
  );
}
function Yr(t) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: t
    })
  );
}
function Uw(t) {
  document && document.dispatchEvent(
    new CustomEvent("update-popover", {
      detail: t
    })
  );
}
function t0(t) {
  const { visibility: e } = t, r = e === "click", L = e === "hover", o = e === "hover-focus", n = e === "focus";
  t.autoHide = !r;
  let a = !1, s = !1;
  const { isRenderFn: i } = t, l = {
    click: i ? "onClick" : "click",
    mousemove: i ? "onMousemove" : "mousemove",
    mouseleave: i ? "onMouseleave" : "mouseleave",
    focusin: i ? "onFocusin" : "focusin",
    focusout: i ? "onFocusout" : "focusout"
  };
  return {
    [l.click](u) {
      r && (t.ref = u.target, Yr(t), u.stopPropagation());
    },
    [l.mousemove](u) {
      t.ref = u.currentTarget, a || (a = !0, (L || o) && d2(t));
    },
    [l.mouseleave](u) {
      t.ref = u.target, a && (a = !1, (L || o && !s) && c2(t));
    },
    [l.focusin](u) {
      t.ref = u.currentTarget, s || (s = !0, (n || o) && d2(t));
    },
    [l.focusout](u) {
      t.ref = u.currentTarget, s && !rt(t.ref, u.relatedTarget) && (s = !1, (n || o && !a) && c2(t));
    }
  };
}
const Gw = {
  name: "CalendarDay",
  emits: [
    "dayclick",
    "daymouseenter",
    "daymouseleave",
    "dayfocusin",
    "dayfocusout",
    "daykeydown"
  ],
  mixins: [y0, t4],
  inheritAttrs: !1,
  render() {
    const t = () => this.hasBackgrounds && Q(
      "div",
      {
        class: "vc-highlights vc-day-layer"
      },
      this.backgrounds.map(
        ({ key: o, wrapperClass: n, class: a, style: s }) => Q(
          "div",
          {
            key: o,
            class: n
          },
          [
            Q("div", {
              class: a,
              style: s
            })
          ]
        )
      )
    ), e = () => this.safeSlot("day-content", {
      day: this.day,
      attributes: this.day.attributes,
      attributesMap: this.day.attributesMap,
      dayProps: this.dayContentProps,
      dayEvents: this.dayContentEvents
    }) || Q(
      "span",
      a5(
        j(
          a5(j({}, this.dayContentProps), {
            class: this.dayContentClass,
            style: this.dayContentStyle
          }),
          this.dayContentEvents
        ),
        {
          ref: "content"
        }
      ),
      [this.day.label]
    ), r = () => this.hasDots && Q(
      "div",
      {
        class: "vc-day-layer vc-day-box-center-bottom"
      },
      [
        Q(
          "div",
          {
            class: "vc-dots"
          },
          this.dots.map(
            ({ key: o, class: n, style: a }) => Q("span", {
              key: o,
              class: n,
              style: a
            })
          )
        )
      ]
    ), L = () => this.hasBars && Q(
      "div",
      {
        class: "vc-day-layer vc-day-box-center-bottom"
      },
      [
        Q(
          "div",
          {
            class: "vc-bars"
          },
          this.bars.map(
            ({ key: o, class: n, style: a }) => Q("span", {
              key: o,
              class: n,
              style: a
            })
          )
        )
      ]
    );
    return Q(
      "div",
      {
        class: [
          "vc-day",
          ...this.day.classes,
          { "vc-day-box-center-center": !this.$slots["day-content"] },
          { "is-not-in-month": !this.inMonth }
        ]
      },
      [t(), e(), r(), L()]
    );
  },
  inject: ["sharedState"],
  props: {
    day: { type: Object, required: !0 }
  },
  data() {
    return {
      glyphs: {},
      dayContentEvents: {}
    };
  },
  computed: {
    label() {
      return this.day.label;
    },
    startTime() {
      return this.day.range.start.getTime();
    },
    endTime() {
      return this.day.range.end.getTime();
    },
    inMonth() {
      return this.day.inMonth;
    },
    isDisabled() {
      return this.day.isDisabled;
    },
    backgrounds() {
      return this.glyphs.backgrounds;
    },
    hasBackgrounds() {
      return !!Q5(this.backgrounds);
    },
    content() {
      return this.glyphs.content;
    },
    dots() {
      return this.glyphs.dots;
    },
    hasDots() {
      return !!Q5(this.dots);
    },
    bars() {
      return this.glyphs.bars;
    },
    hasBars() {
      return !!Q5(this.bars);
    },
    popovers() {
      return this.glyphs.popovers;
    },
    hasPopovers() {
      return !!Q5(this.popovers);
    },
    dayContentClass() {
      return [
        "vc-day-content vc-focusable",
        { "is-disabled": this.isDisabled },
        lt(ut(this.content), "class") || ""
      ];
    },
    dayContentStyle() {
      return lt(ut(this.content), "style");
    },
    dayContentProps() {
      let t;
      return this.day.isFocusable ? t = "0" : this.day.inMonth && (t = "-1"), {
        tabindex: t,
        "aria-label": this.day.ariaLabel,
        "aria-disabled": this.day.isDisabled ? "true" : "false",
        role: "button"
      };
    },
    dayEvent() {
      return a5(j({}, this.day), {
        el: this.$refs.content,
        popovers: this.popovers
      });
    }
  },
  watch: {
    theme() {
      this.refresh();
    },
    popovers() {
      this.refreshPopovers();
    },
    "day.shouldRefresh"() {
      this.refresh();
    }
  },
  mounted() {
    this.refreshPopovers(), this.refresh();
  },
  methods: {
    getDayEvent(t) {
      return a5(j({}, this.dayEvent), {
        event: t
      });
    },
    click(t) {
      this.$emit("dayclick", this.getDayEvent(t));
    },
    mouseenter(t) {
      this.$emit("daymouseenter", this.getDayEvent(t));
    },
    mouseleave(t) {
      this.$emit("daymouseleave", this.getDayEvent(t));
    },
    focusin(t) {
      this.$emit("dayfocusin", this.getDayEvent(t));
    },
    focusout(t) {
      this.$emit("dayfocusout", this.getDayEvent(t));
    },
    keydown(t) {
      this.$emit("daykeydown", this.getDayEvent(t));
    },
    refresh() {
      if (!this.day.shouldRefresh)
        return;
      this.day.shouldRefresh = !1;
      const t = {
        backgrounds: [],
        dots: [],
        bars: [],
        popovers: [],
        content: []
      };
      this.day.attributes = Object.values(this.day.attributesMap || {}).sort(
        (e, r) => e.order - r.order
      ), this.day.attributes.forEach((e) => {
        const { targetDate: r } = e, { isDate: L, isComplex: o, startTime: n, endTime: a } = r, s = this.startTime <= n, i = this.endTime >= a, c = {
          isDate: L,
          isComplex: o,
          onStart: s,
          onEnd: i,
          onStartAndEnd: s && i,
          onStartOrEnd: s || i
        };
        this.processHighlight(e, c, t), this.processNonHighlight(e, "content", c, t.content), this.processNonHighlight(e, "dot", c, t.dots), this.processNonHighlight(e, "bar", c, t.bars), this.processPopover(e, t);
      }), this.glyphs = t;
    },
    processHighlight({ key: t, highlight: e }, { isDate: r, isComplex: L, onStart: o, onEnd: n, onStartAndEnd: a }, { backgrounds: s, content: i }) {
      if (!e)
        return;
      const { base: l, start: u, end: c } = e;
      r || L ? (s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", u.class],
        style: u.style
      }), i.push({
        key: `${t}-content`,
        class: u.contentClass,
        style: u.contentStyle
      })) : a ? (s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", u.class],
        style: u.style
      }), i.push({
        key: `${t}-content`,
        class: u.contentClass,
        style: u.contentStyle
      })) : o ? (s.push({
        key: `${t}-base`,
        wrapperClass: "vc-day-layer vc-day-box-right-center",
        class: ["vc-highlight vc-highlight-base-start", l.class],
        style: l.style
      }), s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", u.class],
        style: u.style
      }), i.push({
        key: `${t}-content`,
        class: u.contentClass,
        style: u.contentStyle
      })) : n ? (s.push({
        key: `${t}-base`,
        wrapperClass: "vc-day-layer vc-day-box-left-center",
        class: ["vc-highlight vc-highlight-base-end", l.class],
        style: l.style
      }), s.push({
        key: t,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight", c.class],
        style: c.style
      }), i.push({
        key: `${t}-content`,
        class: c.contentClass,
        style: c.contentStyle
      })) : (s.push({
        key: `${t}-middle`,
        wrapperClass: "vc-day-layer vc-day-box-center-center",
        class: ["vc-highlight vc-highlight-base-middle", l.class],
        style: l.style
      }), i.push({
        key: `${t}-content`,
        class: l.contentClass,
        style: l.contentStyle
      }));
    },
    processNonHighlight(t, e, { isDate: r, onStart: L, onEnd: o }, n) {
      if (!t[e])
        return;
      const { key: a } = t, s = `vc-${e}`, { base: i, start: l, end: u } = t[e];
      r || L ? n.push({
        key: a,
        class: [s, l.class],
        style: l.style
      }) : o ? n.push({
        key: a,
        class: [s, u.class],
        style: u.style
      }) : n.push({
        key: a,
        class: [s, i.class],
        style: i.style
      });
    },
    processPopover(t, { popovers: e }) {
      const { key: r, customData: L, popover: o } = t;
      if (!o)
        return;
      const n = et(
        {
          key: r,
          customData: L,
          attribute: t
        },
        j({}, o),
        {
          visibility: o.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !o.label
        }
      );
      e.splice(0, 0, n);
    },
    refreshPopovers() {
      let t = {};
      Q5(this.popovers) && (t = t0(
        et(
          { id: this.dayPopoverId, data: this.day, isRenderFn: !0 },
          ...this.popovers
        )
      )), this.dayContentEvents = ly(
        {
          onClick: this.click,
          onMouseenter: this.mouseenter,
          onMouseleave: this.mouseleave,
          onFocusin: this.focusin,
          onFocusout: this.focusout,
          onKeydown: this.keydown
        },
        t
      ), Uw({
        id: this.dayPopoverId,
        data: this.day
      });
    }
  }
}, Kw = {
  name: "CalendarPane",
  emits: ["update:page", "weeknumberclick"],
  mixins: [y0, t4],
  inheritAttrs: !1,
  render() {
    const t = this.safeSlot("header", this.page) || Q("div", { class: `vc-header align-${this.titlePosition}` }, [
      Q(
        "div",
        j(
          {
            class: "vc-title"
          },
          this.navPopoverEvents
        ),
        [this.safeSlot("header-title", this.page, this.page.title)]
      )
    ]), e = this.weekdayLabels.map(
      (i, l) => Q(
        "div",
        {
          key: l + 1,
          class: "vc-weekday"
        },
        [i]
      )
    ), r = this.showWeeknumbers_.startsWith("left"), L = this.showWeeknumbers_.startsWith("right");
    r ? e.unshift(
      Q("div", {
        class: "vc-weekday"
      })
    ) : L && e.push(
      Q("div", {
        class: "vc-weekday"
      })
    );
    const o = (i) => Q(
      "div",
      {
        class: ["vc-weeknumber"]
      },
      [
        Q(
          "span",
          {
            class: ["vc-weeknumber-content", `is-${this.showWeeknumbers_}`],
            onClick: (l) => {
              this.$emit("weeknumberclick", {
                weeknumber: i,
                days: this.page.days.filter(
                  (u) => u[this.weeknumberKey] === i
                ),
                event: l
              });
            }
          },
          [i]
        )
      ]
    ), n = [], { daysInWeek: a } = this.locale;
    this.page.days.forEach((i, l) => {
      const u = l % a;
      (r && u === 0 || L && u === a) && n.push(o(i[this.weeknumberKey])), n.push(
        Q(
          Gw,
          a5(j({}, this.$attrs), {
            day: i
          }),
          this.$slots
        )
      ), L && u === a - 1 && n.push(o(i[this.weeknumberKey]));
    });
    const s = Q(
      "div",
      {
        class: {
          "vc-weeks": !0,
          "vc-show-weeknumbers": this.showWeeknumbers_,
          "is-left": r,
          "is-right": L
        }
      },
      [e, n]
    );
    return Q(
      "div",
      {
        class: [
          "vc-pane",
          `row-from-end-${this.rowFromEnd}`,
          `column-from-end-${this.columnFromEnd}`
        ],
        ref: "pane"
      },
      [t, s]
    );
  },
  props: {
    page: Object,
    position: Number,
    row: Number,
    rowFromEnd: Number,
    column: Number,
    columnFromEnd: Number,
    titlePosition: String,
    navVisibility: {
      type: String,
      default: () => j1("navVisibility")
    },
    showWeeknumbers: [Boolean, String],
    showIsoWeeknumbers: [Boolean, String]
  },
  computed: {
    weeknumberKey() {
      return this.showWeeknumbers ? "weeknumber" : "isoWeeknumber";
    },
    showWeeknumbers_() {
      const t = this.showWeeknumbers || this.showIsoWeeknumbers;
      return t == null ? "" : t7(t) ? t ? "left" : "" : t.startsWith("right") ? this.columnFromEnd > 1 ? "right" : t : this.column > 1 ? "left" : t;
    },
    navPlacement() {
      switch (this.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    },
    navPopoverEvents() {
      const { sharedState: t, navVisibility: e, navPlacement: r, page: L, position: o } = this;
      return t0({
        id: t.navPopoverId,
        visibility: e,
        placement: r,
        modifiers: [
          { name: "flip", options: { fallbackPlacements: ["bottom"] } }
        ],
        data: { page: L, position: o },
        isInteractive: !0,
        isRenderFn: !0
      });
    },
    weekdayLabels() {
      return this.locale.getWeekdayDates().map((t) => this.format(t, this.masks.weekdays));
    }
  }
};
class qw {
  constructor(e, r, L) {
    this.theme = e, this.locale = r, this.map = {}, this.refresh(L, !0);
  }
  destroy() {
    this.theme = null, this.locale = null, this.map = {}, this.list = [], this.pinAttr = null;
  }
  refresh(e, r) {
    const L = {}, o = [];
    let n = null;
    const a = [], s = r ? /* @__PURE__ */ new Set() : new Set(Object.keys(this.map));
    return Q5(e) && e.forEach((i, l) => {
      if (!i || !i.dates)
        return;
      const u = i.key ? i.key.toString() : l.toString(), c = i.order || 0, v = dy(JSON.stringify(i));
      let p = this.map[u];
      !r && p && p.hashcode === v ? s.delete(u) : (p = new Br(
        j(
          {
            key: u,
            order: c,
            hashcode: v
          },
          i
        ),
        this.theme,
        this.locale
      ), a.push(p)), p && p.pinPage && (n = p), L[u] = p, o.push(p);
    }), this.map = L, this.list = o, this.pinAttr = n, { adds: a, deletes: Array.from(s) };
  }
}
const Xw = (t, e, {
  maxSwipeTime: r,
  minHorizontalSwipeDistance: L,
  maxVerticalSwipeDistance: o
}) => {
  if (!t || !t.addEventListener || !O1(e))
    return null;
  let n = 0, a = 0, s = null, i = !1;
  function l(c) {
    const v = c.changedTouches[0];
    n = v.screenX, a = v.screenY, s = (/* @__PURE__ */ new Date()).getTime(), i = !0;
  }
  function u(c) {
    if (!i)
      return;
    i = !1;
    const v = c.changedTouches[0], p = v.screenX - n, m = v.screenY - a;
    if ((/* @__PURE__ */ new Date()).getTime() - s < r && Math.abs(p) >= L && Math.abs(m) <= o) {
      const x = { toLeft: !1, toRight: !1 };
      p < 0 ? x.toLeft = !0 : x.toRight = !0, e(x);
    }
  }
  return E5(t, "touchstart", l, { passive: !0 }), E5(t, "touchend", u, { passive: !0 }), () => {
    A5(t, "touchstart", l), A5(t, "touchend", u);
  };
}, Jw = {
  name: "Calendar",
  emits: [
    "dayfocusin",
    "dayfocusout",
    "transition-start",
    "transition-end",
    "update:from-page",
    "update:to-page"
  ],
  render() {
    const t = this.pages.map((o, n) => {
      const a = n + 1, s = Math.ceil((n + 1) / this.columns), i = this.rows - s + 1, l = a % this.columns || this.columns, u = this.columns - l + 1;
      return Q(
        Kw,
        a5(j({}, this.$attrs), {
          key: o.key,
          attributes: this.store,
          page: o,
          position: a,
          row: s,
          rowFromEnd: i,
          column: l,
          columnFromEnd: u,
          titlePosition: this.titlePosition,
          canMove: this.canMove,
          "onUpdate:page": (c) => this.move(c, { position: n + 1 }),
          onDayfocusin: (c) => {
            this.lastFocusedDay = c, this.$emit("dayfocusin", c);
          },
          onDayfocusout: (c) => {
            this.lastFocusedDay = null, this.$emit("dayfocusout", c);
          }
        }),
        this.$slots
      );
    }), e = (o) => {
      const n = () => this.move(o ? -this.step_ : this.step_), a = (i) => Ar(i, n), s = o ? !this.canMovePrev : !this.canMoveNext;
      return Q(
        "div",
        {
          class: [
            "vc-arrow",
            `is-${o ? "left" : "right"}`,
            { "is-disabled": s }
          ],
          role: "button",
          onClick: n,
          onKeydown: a
        },
        [
          (o ? this.safeSlot("header-left-button", { click: n }) : this.safeSlot("header-right-button", { click: n })) || Q(Rr, {
            name: o ? "left-arrow" : "right-arrow"
          })
        ]
      );
    }, r = () => Q(
      l2,
      {
        id: this.sharedState.navPopoverId,
        contentClass: "vc-nav-popover-container",
        ref: "navPopover"
      },
      {
        default: ({ data: o }) => {
          const { position: n, page: a } = o;
          return Q(
            Ww,
            {
              value: a,
              position: n,
              validator: (s) => this.canMove(s, { position: n }),
              onInput: (s) => this.move(s)
            },
            j({}, this.$slots)
          );
        }
      }
    ), L = () => Q(
      l2,
      {
        id: this.sharedState.dayPopoverId,
        contentClass: "vc-day-popover-container"
      },
      {
        default: ({ data: o, updateLayout: n, hide: a }) => {
          const s = Object.values(o.attributes).filter(
            (c) => c.popover
          ), i = this.$locale.masks, l = this.formatDate, u = l(o.date, i.dayPopover);
          return this.safeSlot(
            "day-popover",
            {
              day: o,
              attributes: s,
              masks: i,
              format: l,
              dayTitle: u,
              updateLayout: n,
              hide: a
            },
            Q("div", [
              i.dayPopover && Q(
                "div",
                {
                  class: ["vc-day-popover-header"]
                },
                [u]
              ),
              s.map(
                (c) => Q(Iw, {
                  key: c.key,
                  attribute: c
                })
              )
            ])
          );
        }
      }
    );
    return Q(
      "div",
      {
        "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year",
        class: [
          "vc-container",
          `vc-${this.$theme.color}`,
          {
            "vc-is-expanded": this.isExpanded,
            "vc-is-dark": this.$theme.isDark
          }
        ],
        onKeydown: this.handleKeydown,
        onMouseup: (o) => o.preventDefault(),
        ref: "container"
      },
      [
        r(),
        Q(
          "div",
          {
            class: [
              "vc-pane-container",
              { "in-transition": this.inTransition }
            ]
          },
          [
            Q(
              Nr,
              {
                name: this.transitionName,
                "on-before-enter": () => {
                  this.inTransition = !0;
                },
                "on-after-enter": () => {
                  this.inTransition = !1;
                }
              },
              {
                default: () => Q(
                  "div",
                  a5(j({}, this.$attrs), {
                    class: "vc-pane-layout",
                    style: {
                      gridTemplateColumns: `repeat(${this.columns}, 1fr)`
                    },
                    key: this.firstPage ? this.firstPage.key : ""
                  }),
                  t
                )
              }
            ),
            Q(
              "div",
              {
                class: [`vc-arrows-container title-${this.titlePosition}`]
              },
              [e(!0), e(!1)]
            ),
            this.$slots.footer && this.$slots.footer()
          ]
        ),
        L()
      ]
    );
  },
  mixins: [Vr, t4],
  provide() {
    return {
      sharedState: this.sharedState
    };
  },
  props: {
    rows: {
      type: Number,
      default: 1
    },
    columns: {
      type: Number,
      default: 1
    },
    step: Number,
    titlePosition: {
      type: String,
      default: () => j1("titlePosition")
    },
    isExpanded: Boolean,
    fromDate: Date,
    toDate: Date,
    fromPage: Object,
    toPage: Object,
    minPage: Object,
    maxPage: Object,
    transition: String,
    attributes: [Object, Array],
    trimWeeks: Boolean,
    disablePageSwipe: Boolean
  },
  data() {
    return {
      pages: [],
      store: null,
      lastFocusedDay: null,
      focusableDay: (/* @__PURE__ */ new Date()).getDate(),
      transitionName: "",
      inTransition: !1,
      sharedState: {
        navPopoverId: Xt(),
        dayPopoverId: Xt(),
        theme: {},
        masks: {},
        locale: {}
      }
    };
  },
  computed: {
    firstPage() {
      return Pr(this.pages);
    },
    lastPage() {
      return ut(this.pages);
    },
    minPage_() {
      return this.minPage || this.pageForDate(this.minDate);
    },
    maxPage_() {
      return this.maxPage || this.pageForDate(this.maxDate);
    },
    count() {
      return this.rows * this.columns;
    },
    step_() {
      return this.step || this.count;
    },
    canMovePrev() {
      return this.canMove(-this.step_);
    },
    canMoveNext() {
      return this.canMove(this.step_);
    }
  },
  watch: {
    $locale() {
      this.refreshLocale(), this.refreshPages({ page: this.firstPage, ignoreCache: !0 }), this.initStore();
    },
    $theme() {
      this.refreshTheme(), this.initStore();
    },
    fromDate() {
      this.refreshPages();
    },
    fromPage(t) {
      const e = this.pages && this.pages[0];
      T0(t, e) || this.refreshPages();
    },
    toPage(t) {
      const e = this.pages && this.pages[this.pages.length - 1];
      T0(t, e) || this.refreshPages();
    },
    count() {
      this.refreshPages();
    },
    attributes: {
      handler(t) {
        const { adds: e, deletes: r } = this.store.refresh(t);
        this.refreshAttrs(this.pages, e, r);
      },
      deep: !0
    },
    pages(t) {
      this.refreshAttrs(t, this.store.list, null, !0);
    },
    disabledAttribute() {
      this.refreshDisabledDays();
    },
    lastFocusedDay(t) {
      t && (this.focusableDay = t.day, this.refreshFocusableDays());
    },
    inTransition(t) {
      t ? this.$emit("transition-start") : (this.$emit("transition-end"), this.transitionPromise && (this.transitionPromise.resolve(!0), this.transitionPromise = null));
    }
  },
  created() {
    this.refreshLocale(), this.refreshTheme(), this.initStore(), this.refreshPages();
  },
  mounted() {
    this.disablePageSwipe || (this.removeHandlers = Xw(
      this.$refs.container,
      ({ toLeft: t, toRight: e }) => {
        t ? this.moveNext() : e && this.movePrev();
      },
      j1("touch")
    ));
  },
  beforeUnmount() {
    this.pages = [], this.store.destroy(), this.store = null, this.sharedState = null, this.removeHandlers && this.removeHandlers();
  },
  methods: {
    refreshLocale() {
      this.sharedState.locale = this.$locale, this.sharedState.masks = this.$locale.masks;
    },
    refreshTheme() {
      this.sharedState.theme = this.$theme;
    },
    canMove(t, e = {}) {
      const r = this.firstPage && this.$locale.toPage(t, this.firstPage);
      if (!r)
        return !1;
      let { position: L } = e;
      if (Qe(t) && (L = 1), !L)
        if (Ke(r, this.firstPage))
          L = -1;
        else if (tt(r, this.lastPage))
          L = 1;
        else
          return !0;
      return Object.assign(
        e,
        this.getTargetPageRange(r, {
          position: L,
          force: !0
        })
      ), uy(e.fromPage, e.toPage).some(
        (o) => Er(o, this.minPage_, this.maxPage_)
      );
    },
    movePrev(t) {
      return this.move(-this.step_, t);
    },
    moveNext(t) {
      return this.move(this.step_, t);
    },
    move(t, e = {}) {
      const r = this.canMove(t, e);
      return !e.force && !r ? Promise.reject(
        new Error(`Move target is disabled: ${JSON.stringify(e)}`)
      ) : (this.$refs.navPopover.hide({ hideDelay: 0 }), e.fromPage && !T0(e.fromPage, this.firstPage) ? this.refreshPages(
        a5(j({}, e), {
          page: e.fromPage,
          position: 1,
          force: !0
        })
      ) : Promise.resolve(!0));
    },
    focusDate(t, e = {}) {
      return this.move(t, e).then(() => {
        const r = this.$el.querySelector(
          `.id-${this.$locale.getDayId(t)}.in-month .vc-focusable`
        );
        return r ? (r.focus(), Promise.resolve(!0)) : Promise.resolve(!1);
      });
    },
    showPageRange(t, e) {
      let r, L;
      if (F1(t))
        r = this.pageForDate(t);
      else if (e1(t)) {
        const { month: a, year: s } = t, { from: i, to: l } = t;
        Qe(a) && Qe(s) ? r = t : (i || l) && (r = F1(i) ? this.pageForDate(i) : i, L = F1(l) ? this.pageForDate(l) : l);
      } else
        return Promise.reject(new Error("Invalid page range provided."));
      const o = this.lastPage;
      let n = r;
      return tt(L, o) && (n = I1(L, -(this.pages.length - 1))), Ke(n, r) && (n = r), this.refreshPages(
        a5(j({}, e), { page: n })
      );
    },
    getTargetPageRange(t, { position: e, force: r } = {}) {
      let L = null, o = null;
      if (U5(t)) {
        let n = 0;
        e = +e, isNaN(e) || (n = e > 0 ? 1 - e : -(this.count + e)), L = I1(t, n);
      } else
        L = this.getDefaultInitialPage();
      return o = I1(L, this.count - 1), r || (Ke(L, this.minPage_) ? L = this.minPage_ : tt(o, this.maxPage_) && (L = I1(this.maxPage_, 1 - this.count)), o = I1(L, this.count - 1)), { fromPage: L, toPage: o };
    },
    getDefaultInitialPage() {
      let t = this.fromPage || this.pageForDate(this.fromDate);
      if (!U5(t)) {
        const e = this.toPage || this.pageForDate(this.toPage);
        U5(e) && (t = I1(e, 1 - this.count));
      }
      return U5(t) || (t = this.getPageForAttributes()), U5(t) || (t = this.pageForThisMonth()), t;
    },
    refreshPages({ page: t, position: e = 1, force: r, transition: L, ignoreCache: o } = {}) {
      return new Promise((n, a) => {
        const { fromPage: s, toPage: i } = this.getTargetPageRange(t, {
          position: e,
          force: r
        }), l = [];
        for (let u = 0; u < this.count; u++)
          l.push(this.buildPage(I1(s, u), o));
        this.refreshDisabledDays(l), this.refreshFocusableDays(l), this.transitionName = this.getPageTransition(
          this.pages[0],
          l[0],
          L
        ), this.pages = l, this.$emit("update:from-page", s), this.$emit("update:to-page", i), this.transitionName && this.transitionName !== "none" ? this.transitionPromise = {
          resolve: n,
          reject: a
        } : n(!0);
      });
    },
    refreshDisabledDays(t) {
      this.getPageDays(t).forEach((e) => {
        e.isDisabled = !!this.disabledAttribute && this.disabledAttribute.intersectsDay(e);
      });
    },
    refreshFocusableDays(t) {
      this.getPageDays(t).forEach((e) => {
        e.isFocusable = e.inMonth && e.day === this.focusableDay;
      });
    },
    getPageDays(t = this.pages) {
      return t.reduce((e, r) => e.concat(r.days), []);
    },
    getPageTransition(t, e, r = this.transition) {
      if (r === "none")
        return r;
      if (r === "fade" || !r && this.count > 1 || !U5(t) || !U5(e))
        return "fade";
      const L = Ke(e, t);
      return r === "slide-v" ? L ? "slide-down" : "slide-up" : L ? "slide-right" : "slide-left";
    },
    getPageForAttributes() {
      let t = null;
      const e = this.store.pinAttr;
      if (e && e.hasDates) {
        let [r] = e.dates;
        r = r.start || r.date, t = this.pageForDate(r);
      }
      return t;
    },
    buildPage({ month: t, year: e }, r) {
      const L = `${e.toString()}-${t.toString()}`;
      let o = this.pages.find((n) => n.key === L);
      if (!o || r) {
        const n = new Date(e, t - 1, 15), a = this.$locale.getMonthComps(t, e), s = this.$locale.getPrevMonthComps(t, e), i = this.$locale.getNextMonthComps(t, e);
        o = {
          key: L,
          month: t,
          year: e,
          weeks: this.trimWeeks ? a.weeks : 6,
          title: this.$locale.format(n, this.$locale.masks.title),
          shortMonthLabel: this.$locale.format(n, "MMM"),
          monthLabel: this.$locale.format(n, "MMMM"),
          shortYearLabel: e.toString().substring(2),
          yearLabel: e.toString(),
          monthComps: a,
          prevMonthComps: s,
          nextMonthComps: i,
          canMove: (l) => this.canMove(l),
          move: (l) => this.move(l),
          moveThisMonth: () => this.moveThisMonth(),
          movePrevMonth: () => this.move(s),
          moveNextMonth: () => this.move(i),
          refresh: !0
        }, o.days = this.$locale.getCalendarDays(o);
      }
      return o;
    },
    initStore() {
      this.store = new qw(
        this.$theme,
        this.$locale,
        this.attributes
      ), this.refreshAttrs(this.pages, this.store.list, [], !0);
    },
    refreshAttrs(t = [], e = [], r = [], L) {
      Q5(t) && t.forEach((o) => {
        o.days.forEach((n) => {
          let a = !1, s = {};
          L ? a = !0 : i2(n.attributesMap, r) ? (s = a2(n.attributesMap, r), a = !0) : s = n.attributesMap || {}, e.forEach((i) => {
            const l = i.intersectsDay(n);
            if (l) {
              const u = a5(j({}, i), {
                targetDate: l
              });
              s[i.key] = u, a = !0;
            }
          }), a && (n.attributesMap = s, n.shouldRefresh = !0);
        });
      });
    },
    handleKeydown(t) {
      const e = this.lastFocusedDay;
      e != null && (e.event = t, this.handleDayKeydown(e));
    },
    handleDayKeydown(t) {
      const { dateFromTime: e, event: r } = t, L = e(12);
      let o = null;
      switch (r.key) {
        case "ArrowLeft": {
          o = k1(L, -1);
          break;
        }
        case "ArrowRight": {
          o = k1(L, 1);
          break;
        }
        case "ArrowUp": {
          o = k1(L, -7);
          break;
        }
        case "ArrowDown": {
          o = k1(L, 7);
          break;
        }
        case "Home": {
          o = k1(L, -t.weekdayPosition + 1);
          break;
        }
        case "End": {
          o = k1(L, t.weekdayPositionFromEnd);
          break;
        }
        case "PageUp": {
          r.altKey ? o = P4(L, -1) : o = t2(L, -1);
          break;
        }
        case "PageDown": {
          r.altKey ? o = P4(L, 1) : o = t2(L, 1);
          break;
        }
      }
      o && (r.preventDefault(), this.focusDate(o).catch());
    }
  }
}, Qw = {
  inheritAttrs: !1,
  emits: ["update:modelValue"],
  props: {
    options: Array,
    modelValue: null
  }
}, eb = { class: "vc-select" }, tb = ["value"], rb = ["value", "disabled"], Lb = /* @__PURE__ */ d(
  "div",
  { class: "vc-select-arrow" },
  [
    /* @__PURE__ */ d(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20"
      },
      [
        /* @__PURE__ */ d("path", {
          d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        })
      ]
    )
  ],
  -1
);
function nb(t, e, r, L, o, n) {
  return b(), _("div", eb, [
    d(
      "select",
      C2(t.$attrs, {
        value: r.modelValue,
        onChange: e[0] || (e[0] = (a) => t.$emit("update:modelValue", a.target.value))
      }),
      [
        (b(!0), _(
          p5,
          null,
          S5(r.options, (a) => (b(), _(
            "option",
            {
              key: a.value,
              value: a.value,
              disabled: a.disabled
            },
            V(a.label),
            9,
            rb
          ))),
          128
        ))
      ],
      16,
      tb
    ),
    Lb
  ]);
}
const ob = /* @__PURE__ */ He(Qw, [
  ["render", nb]
]), sb = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], ab = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
], ib = {
  name: "TimePicker",
  components: { TimeSelect: ob },
  emits: ["update:modelValue"],
  props: {
    modelValue: { type: Object, required: !0 },
    locale: { type: Object, required: !0 },
    theme: { type: Object, required: !0 },
    is24hr: { type: Boolean, default: !0 },
    showBorder: Boolean,
    hourOptions: Array,
    minuteOptions: Array
  },
  computed: {
    date() {
      let t = this.locale.normalizeDate(this.modelValue);
      return this.modelValue.hours === 24 && (t = new Date(t.getTime() - 1)), t;
    },
    hours: {
      get() {
        return this.modelValue.hours;
      },
      set(t) {
        this.updateValue(t, this.minutes);
      }
    },
    minutes: {
      get() {
        return this.modelValue.minutes;
      },
      set(t) {
        this.updateValue(this.hours, t);
      }
    },
    isAM: {
      get() {
        return this.modelValue.hours < 12;
      },
      set(t) {
        let e = this.hours;
        t && e >= 12 ? e -= 12 : !t && e < 12 && (e += 12), this.updateValue(e, this.minutes);
      }
    },
    amHourOptions() {
      return sb.filter(
        (t) => this.hourOptions.some((e) => e.value === t.value)
      );
    },
    pmHourOptions() {
      return ab.filter(
        (t) => this.hourOptions.some((e) => e.value === t.value)
      );
    },
    hourOptions_() {
      return this.is24hr ? this.hourOptions : this.isAM ? this.amHourOptions : this.pmHourOptions;
    },
    amDisabled() {
      return !Q5(this.amHourOptions);
    },
    pmDisabled() {
      return !Q5(this.pmHourOptions);
    }
  },
  methods: {
    updateValue(t, e = this.minutes) {
      (t !== this.hours || e !== this.minutes) && this.$emit(
        "update:modelValue",
        a5(j({}, this.modelValue), {
          hours: t,
          minutes: e,
          seconds: 0,
          milliseconds: 0
        })
      );
    }
  }
}, lb = /* @__PURE__ */ d(
  "div",
  null,
  [
    /* @__PURE__ */ d(
      "svg",
      {
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        viewBox: "0 0 24 24",
        class: "vc-time-icon",
        stroke: "currentColor"
      },
      [
        /* @__PURE__ */ d("path", {
          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        })
      ]
    )
  ],
  -1
), ub = { class: "vc-time-content" }, db = {
  key: 0,
  class: "vc-time-date"
}, cb = { class: "vc-time-weekday" }, hb = { class: "vc-time-month" }, fb = { class: "vc-time-day" }, pb = { class: "vc-time-year" }, mb = { class: "vc-time-select" }, gb = /* @__PURE__ */ d(
  "span",
  { style: { margin: "0 4px" } },
  ":",
  -1
), vb = {
  key: 0,
  class: "vc-am-pm"
};
function yb(t, e, r, L, o, n) {
  const a = o0("time-select");
  return b(), _(
    "div",
    {
      class: F([
        "vc-time-picker",
        [
          {
            "vc-invalid": !r.modelValue.isValid,
            "vc-bordered": r.showBorder
          }
        ]
      ])
    },
    [
      lb,
      d("div", ub, [
        n.date ? (b(), _("div", db, [
          d(
            "span",
            cb,
            V(r.locale.format(n.date, "WWW")),
            1
          ),
          d(
            "span",
            hb,
            V(r.locale.format(n.date, "MMM")),
            1
          ),
          d(
            "span",
            fb,
            V(r.locale.format(n.date, "D")),
            1
          ),
          d(
            "span",
            pb,
            V(r.locale.format(n.date, "YYYY")),
            1
          )
        ])) : X("", !0),
        d("div", mb, [
          Z(
            a,
            {
              modelValue: n.hours,
              "onUpdate:modelValue": e[0] || (e[0] = (s) => n.hours = s),
              modelModifiers: { number: !0 },
              options: n.hourOptions_
            },
            null,
            8,
            ["modelValue", "options"]
          ),
          gb,
          Z(
            a,
            {
              modelValue: n.minutes,
              "onUpdate:modelValue": e[1] || (e[1] = (s) => n.minutes = s),
              modelModifiers: { number: !0 },
              options: r.minuteOptions
            },
            null,
            8,
            ["modelValue", "options"]
          ),
          r.is24hr ? X("", !0) : (b(), _("div", vb, [
            d(
              "button",
              {
                class: F({
                  active: n.isAM,
                  "vc-disabled": n.amDisabled
                }),
                onClick: e[2] || (e[2] = re(
                  (s) => n.isAM = !0,
                  ["prevent"]
                )),
                type: "button"
              },
              " AM ",
              2
            ),
            d(
              "button",
              {
                class: F({
                  active: !n.isAM,
                  "vc-disabled": n.pmDisabled
                }),
                onClick: e[3] || (e[3] = re(
                  (s) => n.isAM = !1,
                  ["prevent"]
                )),
                type: "button"
              },
              " PM ",
              2
            )
          ]))
        ])
      ])
    ],
    2
  );
}
const wb = /* @__PURE__ */ He(ib, [
  ["render", yb]
]), K6 = {
  type: "auto",
  mask: "iso",
  timeAdjust: ""
}, bb = [K6, K6], Tt = {
  DATE: "date",
  DATE_TIME: "datetime",
  TIME: "time"
}, W5 = {
  NONE: 0,
  START: 1,
  END: 2,
  BOTH: 3
}, q6 = {
  name: "DatePicker",
  emits: [
    "update:modelValue",
    "drag",
    "dayclick",
    "daykeydown",
    "popover-will-show",
    "popover-did-show",
    "popover-will-hide",
    "popover-did-hide"
  ],
  render() {
    const t = (o, n) => {
      if (!this.$slots.footer)
        return o;
      const a = [o, this.$slots.footer()];
      return n ? Q(n, a) : a;
    }, e = () => {
      if (!this.dateParts)
        return null;
      const o = this.isRange ? this.dateParts : [this.dateParts[0]];
      return Q(
        "div",
        {},
        a5(j({}, this.$slots), {
          default: () => o.map((n, a) => {
            const s = this.$locale.getHourOptions(
              this.modelConfig_[a].validHours,
              n
            ), i = this.$locale.getMinuteOptions(
              this.modelConfig_[a].minuteIncrement,
              n
            );
            return Q(wb, {
              modelValue: n,
              locale: this.$locale,
              theme: this.$theme,
              is24hr: this.is24hr,
              showBorder: !this.isTime,
              isDisabled: this.isDateTime && !n.isValid || this.isDragging,
              hourOptions: s,
              minuteOptions: i,
              "onUpdate:modelValue": (l) => this.onTimeInput(l, a === 0)
            });
          })
        })
      );
    }, r = () => Q(
      Jw,
      a5(j({}, this.$attrs), {
        attributes: this.attributes_,
        theme: this.$theme,
        locale: this.$locale,
        minDate: this.minDateExact || this.minDate,
        maxDate: this.maxDateExact || this.maxDate,
        disabledDates: this.disabledDates,
        availableDates: this.availableDates,
        onDayclick: this.onDayClick,
        onDaykeydown: this.onDayKeydown,
        onDaymouseenter: this.onDayMouseEnter,
        ref: "calendar"
      }),
      a5(j({}, this.$slots), {
        footer: () => this.isDateTime ? t(e()) : t()
      })
    ), L = () => this.isTime ? Q(
      "div",
      {
        class: [
          "vc-container",
          `vc-${this.$theme.color}`,
          { "vc-is-dark": this.$theme.isDark }
        ]
      },
      t(e(), "div")
    ) : r();
    return this.$slots.default ? Q("div", [
      this.$slots.default(this.slotArgs),
      Q(
        l2,
        {
          id: this.datePickerPopoverId,
          placement: "bottom-start",
          contentClass: `vc-container${this.isDark ? " vc-is-dark" : ""}`,
          onBeforeShow: this.onBeforeShowHandler,
          onAfterShow: this.onAfterShowHandler,
          onBeforeHide: this.onBeforeHideHandler,
          onAfterHide: this.onAfterHideHandler,
          ref: "popover"
        },
        {
          default: L
        }
      )
    ]) : L();
  },
  mixins: [Vr],
  props: {
    mode: { type: String, default: Tt.DATE },
    modelValue: { type: null, required: !0 },
    modelConfig: { type: Object, default: () => ({}) },
    is24hr: Boolean,
    minuteIncrement: Number,
    isRequired: Boolean,
    isRange: Boolean,
    updateOnInput: {
      type: Boolean,
      default: () => j1("datePicker.updateOnInput")
    },
    inputDebounce: {
      type: Number,
      default: () => j1("datePicker.inputDebounce")
    },
    popover: { type: Object, default: () => ({}) },
    dragAttribute: Object,
    selectAttribute: Object,
    attributes: Array,
    validHours: [Object, Array, Function]
  },
  data() {
    return {
      value_: null,
      dateParts: null,
      activeDate: "",
      dragValue: null,
      inputValues: ["", ""],
      updateTimeout: null,
      watchValue: !0,
      datePickerPopoverId: Xt()
    };
  },
  computed: {
    isDate() {
      return this.mode.toLowerCase() === Tt.DATE;
    },
    isDateTime() {
      return this.mode.toLowerCase() === Tt.DATE_TIME;
    },
    isTime() {
      return this.mode.toLowerCase() === Tt.TIME;
    },
    isDragging() {
      return !!this.dragValue;
    },
    modelConfig_() {
      return this.normalizeConfig(this.modelConfig, bb);
    },
    inputMask() {
      const t = this.$locale.masks;
      return this.isTime ? this.is24hr ? t.inputTime24hr : t.inputTime : this.isDateTime ? this.is24hr ? t.inputDateTime24hr : t.inputDateTime : this.$locale.masks.input;
    },
    inputMaskHasTime() {
      return /[Hh]/g.test(this.inputMask);
    },
    inputMaskHasDate() {
      return /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(this.inputMask);
    },
    inputMaskPatch() {
      if (this.inputMaskHasTime && this.inputMaskHasDate)
        return H1.DATE_TIME;
      if (this.inputMaskHasDate)
        return H1.DATE;
      if (this.inputMaskHasTime)
        return H1.TIME;
    },
    slotArgs() {
      const {
        isRange: t,
        isDragging: e,
        updateValue: r,
        showPopover: L,
        hidePopover: o,
        togglePopover: n
      } = this, a = t ? {
        start: this.inputValues[0],
        end: this.inputValues[1]
      } : this.inputValues[0], s = [!0, !1].map(
        (l) => j(
          {
            input: this.onInputInput(l),
            change: this.onInputChange(l),
            keyup: this.onInputKeyup
          },
          t0(
            a5(j({}, this.popover_), {
              id: this.datePickerPopoverId,
              callback: (u) => {
                u.action === "show" && u.completed && this.onInputShow(l);
              }
            })
          )
        )
      ), i = t ? {
        start: s[0],
        end: s[1]
      } : s[0];
      return {
        inputValue: a,
        inputEvents: i,
        isDragging: e,
        updateValue: r,
        showPopover: L,
        hidePopover: o,
        togglePopover: n,
        getPopoverTriggerEvents: t0
      };
    },
    popover_() {
      return Q2(this.popover, j1("datePicker.popover"));
    },
    selectAttribute_() {
      if (!this.hasValue(this.value_))
        return null;
      const t = a5(
        j(
          {
            key: "select-drag"
          },
          this.selectAttribute
        ),
        {
          dates: this.value_,
          pinPage: !0
        }
      ), { dot: e, bar: r, highlight: L, content: o } = t;
      return !e && !r && !L && !o && (t.highlight = !0), t;
    },
    dragAttribute_() {
      if (!this.isRange || !this.hasValue(this.dragValue))
        return null;
      const t = a5(
        j(
          {
            key: "select-drag"
          },
          this.dragAttribute
        ),
        {
          dates: this.dragValue
        }
      ), { dot: e, bar: r, highlight: L, content: o } = t;
      return !e && !r && !L && !o && (t.highlight = {
        startEnd: {
          fillMode: "outline"
        }
      }), t;
    },
    attributes_() {
      const t = V5(this.attributes) ? [...this.attributes] : [];
      return this.dragAttribute_ ? t.push(this.dragAttribute_) : this.selectAttribute_ && t.push(this.selectAttribute_), t;
    }
  },
  watch: {
    inputMask() {
      this.formatInput();
    },
    modelValue(t) {
      this.watchValue && this.forceUpdateValue(t, {
        config: this.modelConfig_,
        formatInput: !0,
        hidePopover: !1
      });
    },
    value_() {
      this.refreshDateParts();
    },
    dragValue() {
      this.refreshDateParts();
    },
    timezone() {
      this.refreshDateParts(), this.forceUpdateValue(this.value_, { formatInput: !0 });
    }
  },
  created() {
    this.value_ = this.normalizeValue(
      this.modelValue,
      this.modelConfig_,
      H1.DATE_TIME,
      W5.BOTH
    ), this.forceUpdateValue(this.modelValue, {
      config: this.modelConfig_,
      formatInput: !0,
      hidePopover: !1
    }), this.refreshDateParts();
  },
  mounted() {
    E5(document, "keydown", this.onDocumentKeyDown), E5(document, "click", this.onDocumentClick);
  },
  beforeUnmount() {
    A5(document, "keydown", this.onDocumentKeyDown), A5(document, "click", this.onDocumentClick);
  },
  methods: {
    onBeforeShowHandler(t) {
      this.$emit("popover-will-show", t);
    },
    onAfterShowHandler(t) {
      this.$emit("popover-did-show", t);
    },
    onBeforeHideHandler(t) {
      this.$emit("popover-will-hide", t);
    },
    onAfterHideHandler(t) {
      this.$emit("popover-did-hide", t);
    },
    getDateParts(t) {
      return this.$locale.getDateParts(t);
    },
    getDateFromParts(t) {
      return this.$locale.getDateFromParts(t);
    },
    refreshDateParts() {
      const t = this.dragValue || this.value_, e = [];
      this.isRange ? (t && t.start ? e.push(this.getDateParts(t.start)) : e.push({}), t && t.end ? e.push(this.getDateParts(t.end)) : e.push({})) : t ? e.push(this.getDateParts(t)) : e.push({}), this.$nextTick(() => this.dateParts = e);
    },
    onDocumentKeyDown(t) {
      this.dragValue && t.key === "Escape" && (this.dragValue = null);
    },
    onDocumentClick(t) {
      document.body.contains(t.target) && !rt(this.$el, t.target) && (this.dragValue = null, this.formatInput());
    },
    onDayClick(t) {
      this.handleDayClick(t), this.$emit("dayclick", t);
    },
    onDayKeydown(t) {
      switch (t.event.key) {
        case " ":
        case "Enter": {
          this.handleDayClick(t), t.event.preventDefault();
          break;
        }
        case "Escape":
          this.hidePopover();
      }
      this.$emit("daykeydown", t);
    },
    handleDayClick(t) {
      const { keepVisibleOnInput: e, visibility: r } = this.popover_, L = {
        patch: H1.DATE,
        adjustTime: !0,
        formatInput: !0,
        hidePopover: this.isDate && !e && r !== "visible"
      };
      this.isRange ? (this.isDragging ? this.dragTrackingValue.end = t.date : this.dragTrackingValue = j({}, t.range), L.isDragging = !this.isDragging, L.rangePriority = L.isDragging ? W5.NONE : W5.BOTH, L.hidePopover = L.hidePopover && !L.isDragging, this.updateValue(this.dragTrackingValue, L)) : (L.clearIfEqual = !this.isRequired, this.updateValue(t.date, L));
    },
    onDayMouseEnter(t) {
      this.isDragging && (this.dragTrackingValue.end = t.date, this.updateValue(this.dragTrackingValue, {
        patch: H1.DATE,
        adjustTime: !0,
        formatInput: !0,
        hidePriority: !1,
        rangePriority: W5.NONE
      }));
    },
    onTimeInput(t, e) {
      let r = null;
      if (this.isRange) {
        const L = e ? t : this.dateParts[0], o = e ? this.dateParts[1] : t;
        r = { start: L, end: o };
      } else
        r = t;
      this.updateValue(r, {
        patch: H1.TIME,
        rangePriority: e ? W5.START : W5.END
      }).then(() => this.adjustPageRange(e));
    },
    onInputInput(t) {
      return (e) => {
        this.updateOnInput && this.onInputUpdate(e.target.value, t, {
          formatInput: !1,
          hidePopover: !1,
          debounce: this.inputDebounce
        });
      };
    },
    onInputChange(t) {
      return (e) => {
        this.onInputUpdate(e.target.value, t, {
          formatInput: !0,
          hidePopover: !1
        });
      };
    },
    onInputUpdate(t, e, r) {
      this.inputValues.splice(e ? 0 : 1, 1, t);
      const L = this.isRange ? {
        start: this.inputValues[0],
        end: this.inputValues[1] || this.inputValues[0]
      } : t, o = {
        type: "string",
        mask: this.inputMask
      };
      this.updateValue(
        L,
        a5(j({}, r), {
          config: o,
          patch: this.inputMaskPatch,
          rangePriority: e ? W5.START : W5.END
        })
      ).then(() => this.adjustPageRange(e));
    },
    onInputShow(t) {
      this.adjustPageRange(t);
    },
    onInputKeyup(t) {
      t.key === "Escape" && this.updateValue(this.value_, {
        formatInput: !0,
        hidePopover: !0
      });
    },
    updateValue(t, e = {}) {
      return clearTimeout(this.updateTimeout), new Promise((r) => {
        const L = e, { debounce: o } = L, n = zs(L, ["debounce"]);
        o > 0 ? this.updateTimeout = setTimeout(() => {
          this.forceUpdateValue(t, n), r(this.value_);
        }, o) : (this.forceUpdateValue(t, n), r(this.value_));
      });
    },
    normalizeConfig(t, e = this.modelConfig_) {
      return t = V5(t) ? t : [t.start || t, t.end || t], e.map(
        (r, L) => j(
          j(
            {
              validHours: this.validHours,
              minuteIncrement: this.minuteIncrement
            },
            r
          ),
          t[L]
        )
      );
    },
    forceUpdateValue(t, {
      config: e = this.modelConfig_,
      patch: r = H1.DATE_TIME,
      clearIfEqual: L = !1,
      formatInput: o = !0,
      hidePopover: n = !1,
      isDragging: a = this.isDragging,
      rangePriority: s = W5.BOTH
    } = {}) {
      e = this.normalizeConfig(e);
      let i = this.normalizeValue(
        t,
        e,
        r,
        s
      );
      !i && this.isRequired && (i = this.value_), i = this.adjustTimeForValue(i, e);
      const l = this.valueIsDisabled(i);
      if (l) {
        if (a)
          return;
        i = this.value_, n = !1;
      }
      const u = a ? "dragValue" : "value_";
      let c = !this.valuesAreEqual(this[u], i);
      if (!l && !c && L && (i = null, c = !0), c) {
        this[u] = i, a || (this.dragValue = null);
        const v = this.denormalizeValue(i), p = this.isDragging ? "drag" : "update:modelValue";
        this.watchValue = !1, this.$emit(p, v), this.$nextTick(() => this.watchValue = !0);
      }
      n && this.hidePopover(), o && this.formatInput();
    },
    hasValue(t) {
      return this.isRange ? e1(t) && !!t.start && !!t.end : !!t;
    },
    normalizeValue(t, e, r, L) {
      if (!this.hasValue(t))
        return null;
      if (this.isRange) {
        const o = {}, n = t.start > t.end ? t.end : t.start;
        o.start = this.normalizeDate(
          n,
          a5(j({}, e[0]), {
            fillDate: this.value_ && this.value_.start || e[0].fillDate,
            patch: r
          })
        );
        const a = t.start > t.end ? t.start : t.end;
        return o.end = this.normalizeDate(
          a,
          a5(j({}, e[1]), {
            fillDate: this.value_ && this.value_.end || e[1].fillDate,
            patch: r
          })
        ), this.sortRange(o, L);
      }
      return this.normalizeDate(
        t,
        a5(j({}, e[0]), {
          fillDate: this.value_ || e[0].fillDate,
          patch: r
        })
      );
    },
    adjustTimeForValue(t, e) {
      return this.hasValue(t) ? this.isRange ? {
        start: this.$locale.adjustTimeForDate(t.start, e[0]),
        end: this.$locale.adjustTimeForDate(t.end, e[1])
      } : this.$locale.adjustTimeForDate(t, e[0]) : null;
    },
    sortRange(t, e = W5.NONE) {
      const { start: r, end: L } = t;
      if (r > L)
        switch (e) {
          case W5.START:
            return { start: r, end: r };
          case W5.END:
            return { start: L, end: L };
          case W5.BOTH:
            return { start: L, end: r };
        }
      return { start: r, end: L };
    },
    denormalizeValue(t, e = this.modelConfig_) {
      return this.isRange ? this.hasValue(t) ? {
        start: this.$locale.denormalizeDate(t.start, e[0]),
        end: this.$locale.denormalizeDate(t.end, e[1])
      } : null : this.$locale.denormalizeDate(t, e[0]);
    },
    valuesAreEqual(t, e) {
      if (this.isRange) {
        const r = this.hasValue(t), L = this.hasValue(e);
        return !r && !L ? !0 : r !== L ? !1 : O0(t.start, e.start) && O0(t.end, e.end);
      }
      return O0(t, e);
    },
    valueIsDisabled(t) {
      return this.hasValue(t) && this.disabledAttribute && this.disabledAttribute.intersectsDate(t);
    },
    formatInput() {
      this.$nextTick(() => {
        const t = this.normalizeConfig({
          type: "string",
          mask: this.inputMask
        }), e = this.denormalizeValue(
          this.dragValue || this.value_,
          t
        );
        this.isRange ? this.inputValues = [e && e.start, e && e.end] : this.inputValues = [e, ""];
      });
    },
    showPopover(t = {}) {
      d2(
        a5(
          j(
            j(
              {
                ref: this.$el
              },
              this.popover_
            ),
            t
          ),
          {
            isInteractive: !0,
            id: this.datePickerPopoverId
          }
        )
      );
    },
    hidePopover(t = {}) {
      c2(
        a5(
          j(
            j(
              {
                hideDelay: 10
              },
              this.showPopover_
            ),
            t
          ),
          {
            id: this.datePickerPopoverId
          }
        )
      );
    },
    togglePopover(t) {
      Yr(
        a5(
          j(
            j(
              {
                ref: this.$el
              },
              this.popover_
            ),
            t
          ),
          {
            isInteractive: !0,
            id: this.datePickerPopoverId
          }
        )
      );
    },
    adjustPageRange(t) {
      this.$nextTick(() => {
        const e = this.$refs.calendar, r = this.getPageForValue(t), L = t ? 1 : -1;
        r && e && !Er(r, e.firstPage, e.lastPage) && e.move(r, {
          position: L,
          transition: "fade"
        });
      });
    },
    getPageForValue(t) {
      return this.hasValue(this.value_) ? this.pageForDate(
        this.isRange ? this.value_[t ? "start" : "end"] : this.value_
      ) : null;
    },
    move(t, e) {
      return this.$refs.calendar ? this.$refs.calendar.move(t, e) : Promise.reject(
        new Error("Navigation disabled while calendar is not yet displayed")
      );
    },
    focusDate(t, e) {
      return this.$refs.calendar ? this.$refs.calendar.focusDate(t, e) : Promise.reject(
        new Error("Navigation disabled while calendar is not yet displayed")
      );
    }
  }
};
const xb = {}, kb = { d: "M12.7,4.8V15.4a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V4.8a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V14.9H11.7V4.8a.5.5,0,0,1,.5-.5A.5.5,0,0,1,12.7,4.8Zm-8.5,0v8a.5.5,0,0,0,.5.5.6.6,0,0,0,.5-.5v-8a.5.5,0,0,0-.5-.5A.5.5,0,0,0,4.2,4.8Zm3.4,0v8a.5.5,0,0,0,1,0v-8a.5.5,0,1,0-1,0ZM.5,2.7H12.2a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H9.6L8,0H4.8L3.1,1.7H.5a.5.5,0,0,0-.5.5A.5.5,0,0,0,.5,2.7Z" };
function Mb(t, e) {
  return b(), _("path", kb);
}
const h2 = /* @__PURE__ */ K(xb, [["render", Mb]]), _b = {
  class: "relative stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color fill-bl-panel-color dark:fill-bl-dk-panel-color",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, $b = /* @__PURE__ */ O5('<g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="icon-calendar" x="0.5" y="1.9" width="15" height="13.58" rx="2"></rect><path d="M13.5,1.4h-1V.6a.7.7,0,0,0-.7-.6h0a.6.6,0,0,0-.6.6v.8H8.6V.6A.6.6,0,0,0,8,0H8a.6.6,0,0,0-.6.6v.8H4.8V.6A.6.6,0,0,0,4.2,0h0a.7.7,0,0,0-.7.6v.8h-1A2.5,2.5,0,0,0,0,3.9v9.6A2.5,2.5,0,0,0,2.5,16h11A2.5,2.5,0,0,0,16,13.5V3.9A2.5,2.5,0,0,0,13.5,1.4ZM15,13.5A1.5,1.5,0,0,1,13.5,15H2.5A1.5,1.5,0,0,1,1,13.5V3.9A1.5,1.5,0,0,1,2.5,2.4h1v.8a.7.7,0,0,0,.7.6h0a.6.6,0,0,0,.6-.6V2.4H7.4v.8a.6.6,0,0,0,.6.6H8a.6.6,0,0,0,.6-.6V2.4h2.6v.8a.6.6,0,0,0,.6.6h0a.7.7,0,0,0,.7-.6V2.4h1A1.5,1.5,0,0,1,15,3.9Z"></path><path d="M4.2,5.6a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.6.6.6,0,0,0,.6-.6A.7.7,0,0,0,4.2,5.6Z"></path><path d="M8,5.6c-.4,0-.6.3-.6.7a.6.6,0,1,0,1.2,0C8.6,5.9,8.4,5.6,8,5.6Z"></path><path d="M11.8,5.6a.7.7,0,0,0-.6.7.6.6,0,0,0,.6.6.7.7,0,0,0,.7-.6A.7.7,0,0,0,11.8,5.6Z"></path><path d="M4.2,8.7a.7.7,0,0,0-.7.6.7.7,0,0,0,.7.7.7.7,0,0,0,.6-.7A.6.6,0,0,0,4.2,8.7Z"></path><path d="M8,8.7a.6.6,0,0,0-.6.6c0,.4.2.7.6.7s.6-.3.6-.7A.6.6,0,0,0,8,8.7Z"></path><path d="M11.8,8.7a.6.6,0,0,0-.6.6.7.7,0,0,0,.6.7.7.7,0,0,0,.7-.7A.7.7,0,0,0,11.8,8.7Z"></path><path d="M4.2,11.8a.7.7,0,0,0-.7.6.7.7,0,0,0,.7.7.7.7,0,0,0,.6-.7A.6.6,0,0,0,4.2,11.8Z"></path><path d="M8,11.8a.6.6,0,0,0-.6.6c0,.4.2.7.6.7s.6-.3.6-.7A.6.6,0,0,0,8,11.8Z"></path><path d="M11.8,11.8a.6.6,0,0,0-.6.6.7.7,0,0,0,.6.7.7.7,0,0,0,.7-.7A.7.7,0,0,0,11.8,11.8Z"></path></g></g>', 1), Sb = [
  $b
], f2 = /* @__PURE__ */ r5({
  __name: "IconCalendar",
  props: {
    hide: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, r) => b5((b(), _("svg", _b, Sb, 512)), [
      [T1, !e.hide]
    ]);
  }
}), Cb = {}, Db = { d: "M5.8,12.8.6,7.8a2.1,2.1,0,0,1,0-2.9,1.9,1.9,0,0,1,2.8,0L5.8,7.2,12.6.6a1.9,1.9,0,0,1,2.8,0,1.9,1.9,0,0,1,0,2.8Z" };
function zb(t, e) {
  return b(), _("path", Db);
}
const Ib = /* @__PURE__ */ K(Cb, [["render", zb]]), Tb = /* @__PURE__ */ d("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
}, null, -1), Ob = [
  Tb
], Pb = /* @__PURE__ */ r5({
  __name: "IconChevronDown",
  props: {
    invert: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, r = P(null);
    return s5(
      () => e.invert,
      (L, o) => {
        L !== o && r.value.classList.toggle("inverted");
      }
    ), (L, o) => (b(), _("svg", {
      ref_key: "refSvg",
      ref: r,
      class: "invertible",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, Ob, 512));
  }
});
const Zb = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  viewBox: "0 0 23 23"
}, Eb = {
  id: "Group_990",
  "data-name": "Group 990",
  transform: "translate(-198.994 -796.994)"
}, Ab = {
  id: "Ellipse_140",
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  "data-name": "Ellipse 140",
  cx: "11.5",
  cy: "11.5",
  r: "11.5",
  transform: "translate(198.994 796.994)"
}, Nb = {
  id: "Group_959",
  "data-name": "Group 959",
  transform: "translate(206.543 805.142)"
}, pT = /* @__PURE__ */ r5({
  __name: "IconChevronDoubleDown",
  props: {
    hideBackground: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, r = U(
      () => e.hideBackground ? "stroke-bl-text-color dark:stroke-bl-dk-text-color" : "stroke-bl-panel-color dark:stroke-bl-dk-panel-color"
    );
    return (L, o) => (b(), _("svg", Zb, [
      d("g", Eb, [
        b5(d("circle", Ab, null, 512), [
          [T1, !L.hideBackground]
        ]),
        d("g", Nb, [
          d("path", {
            id: "Path_3",
            class: F(r.value),
            "data-name": "Path 3",
            d: "M725.4,810.077l3.951,3.569,3.951-3.569",
            transform: "translate(-725.397 -804.976)",
            fill: "none",
            "stroke-linecap": "round",
            "stroke-width": "2"
          }, null, 2),
          d("path", {
            id: "Path_386",
            class: F(r.value),
            "data-name": "Path 386",
            d: "M725.4,810.077l3.951,3.569,3.951-3.569",
            transform: "translate(-725.397 -810.077)",
            fill: "none",
            "stroke-linecap": "round",
            "stroke-width": "2"
          }, null, 2)
        ])
      ])
    ]));
  }
}), Hb = {}, Bb = { d: "M5.3,11.8.4,7a1.7,1.7,0,0,1,0-2.1,1.6,1.6,0,0,1,2.2,0L5.3,7.6,12.4.4a1.7,1.7,0,0,1,2.1,0,1.6,1.6,0,0,1,0,2.2Z" };
function Vb(t, e) {
  return b(), _("path", Bb);
}
const mT = /* @__PURE__ */ K(Hb, [["render", Vb]]), Rb = {}, Yb = { d: "M7.2,7.8.2,1.3A.8.8,0,0,1,.2.2.8.8,0,0,1,1.3.2L7.2,5.7l6-5.5a.8.8,0,0,1,1.1,0,.8.8,0,0,1,0,1.1Z" };
function Fb(t, e) {
  return b(), _("path", Yb);
}
const gT = /* @__PURE__ */ K(Rb, [["render", Fb]]), jb = {}, Wb = { d: "M1.5,9.5A1.5,1.5,0,0,1,.4,9.1,1.6,1.6,0,0,1,.5,6.9L8,0l7.5,6.9a1.6,1.6,0,0,1,.1,2.2,1.4,1.4,0,0,1-2.1,0L8,4.1l-5.5,5A1.3,1.3,0,0,1,1.5,9.5Z" };
function Ub(t, e) {
  return b(), _("path", Wb);
}
const vT = /* @__PURE__ */ K(jb, [["render", Ub]]), Gb = {}, Kb = {
  id: "Pfad_7045",
  "data-name": "Pfad 7045",
  d: "M12.4,5.6,5.9,12.1,3,9,9.4,2.6ZM0,15l5.2-2.4-2.8-3ZM14.7,1.7,13.3.3a1.2,1.2,0,0,0-1.6,0h-.1L11,1h0L10,2.1,12.9,5l.9-.8h0l.8-.8h.1a1.2,1.2,0,0,0,0-1.6Z"
};
function qb(t, e) {
  return b(), _("path", Kb);
}
const yT = /* @__PURE__ */ K(Gb, [["render", qb]]), Xb = {}, Jb = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, Qb = /* @__PURE__ */ d("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z"
}, null, -1), ex = [
  Qb
];
function tx(t, e) {
  return b(), _("svg", Jb, ex);
}
const rx = /* @__PURE__ */ K(Xb, [["render", tx]]), Lx = {}, nx = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "55.372",
  height: "38.491",
  viewBox: "0 0 55.372 38.491"
}, ox = /* @__PURE__ */ O5('<g id="Group_1059" data-name="Group 1059" transform="translate(0.707 0.707)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1056" data-name="Group 1056" transform="translate(11.691 3.925)"><rect id="Rectangle_204" data-name="Rectangle 204" width="43" height="1" rx="0.5" transform="translate(-0.026 13.721)"></rect><rect id="Rectangle_206" data-name="Rectangle 206" width="43" height="1" rx="0.5" transform="translate(-0.026 27.721)"></rect><rect id="Rectangle_205" data-name="Rectangle 205" width="43" height="1" rx="0.5" transform="translate(-0.026 -0.279)"></rect></g><g id="Group_1048" data-name="Group 1048" transform="translate(0 37.076) rotate(-90)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1025" data-name="Group 1025" transform="translate(22.212 6.525) rotate(-90)"><path id="Path_391" data-name="Path 391" d="M0,3.263,3.263,0,6.525,3.263" transform="translate(6.525 14.864) rotate(180)" fill="none" stroke-linecap="round" stroke-width="1"></path><path id="Path_392" data-name="Path 392" d="M0,14.864V0" transform="translate(3.263)" fill="none" stroke-linecap="round" stroke-width="1"></path></g><g id="Group_1026" data-name="Group 1026" transform="translate(0 6.525) rotate(-90)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><path id="Path_391-2" data-name="Path 391" d="M0,0,3.263,3.263,6.525,0" transform="translate(6.525 3.263) rotate(180)" fill="none" stroke-linecap="round" stroke-width="1"></path><path id="Path_392-2" data-name="Path 392" d="M0,0V14.864" transform="translate(3.263)" fill="none" stroke-linecap="round" stroke-width="1"></path></g></g></g>', 1), sx = [
  ox
];
function ax(t, e) {
  return b(), _("svg", nx, sx);
}
const ix = /* @__PURE__ */ K(Lx, [["render", ax]]), lx = {}, ux = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "55.372",
  height: "28.126",
  viewBox: "0 0 55.372 28.126"
}, dx = /* @__PURE__ */ O5('<g id="Group_1058" data-name="Group 1058" transform="translate(0.707 0.725)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1057" data-name="Group 1057" transform="translate(11.691 6.015)"><rect id="Rectangle_204" data-name="Rectangle 204" width="43" height="1" rx="0.5" transform="translate(-0.026 6.761)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><rect id="Rectangle_206" data-name="Rectangle 206" width="43" height="1" rx="0.5" transform="translate(-0.026 12.761)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><rect id="Rectangle_205" data-name="Rectangle 205" width="43" height="1" rx="0.5" transform="translate(-0.026 0.761)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect></g><g id="Group_1051" data-name="Group 1051" transform="translate(0 -0.225)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1027" data-name="Group 1027" transform="translate(6.525 10.76) rotate(180)"><path id="Path_391" data-name="Path 391" d="M0,0,3.263,3.263,6.525,0" transform="translate(6.525 3.263) rotate(180)" stroke-linecap="round" stroke-width="1" fill="none"></path><path id="Path_392" data-name="Path 392" d="M0,0V10.76" transform="translate(3.263)" stroke-linecap="round" stroke-width="1" fill="none"></path></g><g id="Group_1050" data-name="Group 1050" transform="translate(6.525 27.126) rotate(180)"><path id="Path_391-2" data-name="Path 391" d="M0,3.263,3.263,0,6.525,3.263" transform="translate(6.525 10.76) rotate(180)" stroke-linecap="round" stroke-width="1" fill="none"></path><path id="Path_392-2" data-name="Path 392" d="M0,10.76V0" transform="translate(3.263 0)" stroke-linecap="round" stroke-width="1" fill="none"></path></g></g></g>', 1), cx = [
  dx
];
function hx(t, e) {
  return b(), _("svg", ux, cx);
}
const fx = /* @__PURE__ */ K(lx, [["render", hx]]), px = {}, mx = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "53",
  height: "19",
  viewBox: "0 0 53 19"
}, gx = /* @__PURE__ */ O5('<g id="Group_1055" data-name="Group 1055" transform="translate(-0.496 -0.991)" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><g id="Group_1014" data-name="Group 1014" transform="translate(10.522 1.169)"><rect id="Rectangle_204" data-name="Rectangle 204" width="43" height="2" rx="1" transform="translate(-0.026 7.822)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><rect id="Rectangle_206" data-name="Rectangle 206" width="43" height="2" rx="1" transform="translate(-0.026 16.822)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><rect id="Rectangle_205" data-name="Rectangle 205" width="43" height="2" rx="1" transform="translate(-0.026 -0.178)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect></g><g id="Group_1046" data-name="Group 1046" class="stroke-bl-icon-default-color dark:stroke-bl-dk-icon-default-color"><rect id="Rectangle_207" data-name="Rectangle 207" width="14.096" height="0.01" rx="1" transform="translate(2.5 17.57) rotate(-90)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></rect><circle id="Ellipse_244" data-name="Ellipse 244" cx="2" cy="2" r="2" transform="translate(0.496 0.991)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></circle><circle id="Ellipse_245" data-name="Ellipse 245" cx="2" cy="2" r="2" transform="translate(0.496 15.991)" class="fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color"></circle></g></g>', 1), vx = [
  gx
];
function yx(t, e) {
  return b(), _("svg", mx, vx);
}
const wx = /* @__PURE__ */ K(px, [["render", yx]]), bx = {}, xx = /* @__PURE__ */ d("path", { d: "M15.6,11.7a1.6,1.6,0,0,0-1.1-.5,1.3,1.3,0,0,0-1,.4L8,16.7,2.5,11.6a1.5,1.5,0,0,0-2.1.1,1.5,1.5,0,0,0,.1,2.1L8,20.7l7.5-6.9A1.5,1.5,0,0,0,15.6,11.7Z" }, null, -1), kx = /* @__PURE__ */ d("path", { d: "M8,3.5A1.7,1.7,0,0,0,9.8,1.8a1.8,1.8,0,0,0-3.6,0A1.7,1.7,0,0,0,8,3.5Z" }, null, -1), Mx = /* @__PURE__ */ d("circle", {
  cx: "8",
  cy: "6.7",
  r: "1"
}, null, -1), _x = /* @__PURE__ */ d("circle", {
  cx: "8",
  cy: "11.7",
  r: "1"
}, null, -1), $x = [
  xx,
  kx,
  Mx,
  _x
];
function Sx(t, e) {
  return b(), _("g", null, $x);
}
const wT = /* @__PURE__ */ K(bx, [["render", Sx]]), Cx = {}, Dx = { d: "M13,6.5A1.5,1.5,0,0,1,11.5,8H8v3.5A1.5,1.5,0,0,1,6.5,13,1.5,1.5,0,0,1,5,11.5V8H1.5A1.5,1.5,0,0,1,0,6.5,1.5,1.5,0,0,1,1.5,5H5V1.5A1.5,1.5,0,0,1,6.5,0,1.5,1.5,0,0,1,8,1.5V5h3.5A1.5,1.5,0,0,1,13,6.5Z" };
function zx(t, e) {
  return b(), _("path", Dx);
}
const Ix = /* @__PURE__ */ K(Cx, [["render", zx]]);
const Tx = {}, Ox = (t) => (g1("data-v-463ee35e"), t = t(), v1(), t), Px = {
  id: "Layer_2",
  "data-name": "Layer 2"
}, Zx = /* @__PURE__ */ Ox(() => /* @__PURE__ */ d("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, [
  /* @__PURE__ */ d("g", {
    id: "Gruppe_3132",
    "data-name": "Gruppe 3132"
  }, [
    /* @__PURE__ */ d("g", {
      id: "Gruppe_2333",
      "data-name": "Gruppe 2333"
    }, [
      /* @__PURE__ */ d("path", {
        id: "Polygon_4",
        "data-name": "Polygon 4",
        d: "M8,0l2,1.4h2.4l.9,2.3,2,1.2-.4,2.4L16,9.3l-1.7,1.8-.2,2.4-2.3.6L10.3,16,8,15.2,5.7,16,4.2,14.1l-2.3-.6-.3-2.4L0,9.3,1.1,7.2.6,4.8,2.7,3.5l.9-2.2H6Z"
      })
    ]),
    /* @__PURE__ */ d("g", {
      id: "Gruppe_3131",
      "data-name": "Gruppe 3131"
    }, [
      /* @__PURE__ */ d("g", {
        id: "Gruppe_2995",
        "data-name": "Gruppe 2995"
      }, [
        /* @__PURE__ */ d("path", {
          id: "Pfad_7041",
          "data-name": "Pfad 7041",
          class: "cls-1",
          d: "M5.6,8.2,7.2,9.8l3.5-3.4"
        })
      ])
    ])
  ])
], -1)), Ex = [
  Zx
];
function Ax(t, e) {
  return b(), _("g", Px, Ex);
}
const bT = /* @__PURE__ */ K(Tx, [["render", Ax], ["__scopeId", "data-v-463ee35e"]]), Nx = {}, Hx = {
  id: "Pfad_6962",
  "data-name": "Pfad 6962",
  d: "M20,0,10,10,0,0Z"
};
function Bx(t, e) {
  return b(), _("path", Hx);
}
const xT = /* @__PURE__ */ K(Nx, [["render", Bx]]), Vx = {}, Rx = /* @__PURE__ */ d("path", {
  id: "Pfad_7083",
  "data-name": "Pfad 7083",
  d: "M7.5,0C3.3,0,0,3.4,0,4.8a.6.6,0,0,0,.6.6h0a.6.6,0,0,0,.6-.6h0c.1-.6,2.6-3.6,6.3-3.6s6.2,3,6.3,3.6a.6.6,0,0,0,.6.6.6.6,0,0,0,.6-.6C15,3.7,11.8,0,7.5,0Z"
}, null, -1), Yx = /* @__PURE__ */ d("path", {
  id: "Pfad_7084",
  "data-name": "Pfad 7084",
  d: "M8.7,4a2.7,2.7,0,0,0-1.2-.3h0A2.1,2.1,0,0,0,6.4,4L7.7,6.1,5.5,4.8a2.3,2.3,0,0,0,.8,3.1A2.3,2.3,0,1,0,8.7,4Z"
}, null, -1), Fx = /* @__PURE__ */ d("path", {
  id: "Pfad_7085",
  "data-name": "Pfad 7085",
  d: "M7.5,2.5c-3.3,0-5.9,2.7-5.9,3.7S4.2,10,7.5,10s6-2.9,6-3.8S10.9,2.5,7.5,2.5Zm0,6.6a5.8,5.8,0,0,1-5-2.9,5.9,5.9,0,0,1,5-2.8,6.2,6.2,0,0,1,5.1,2.8A6,6,0,0,1,7.5,9.1Z"
}, null, -1), jx = [
  Rx,
  Yx,
  Fx
];
function Wx(t, e) {
  return b(), _("g", null, jx);
}
const kT = /* @__PURE__ */ K(Vx, [["render", Wx]]);
const Ux = {}, Gx = (t) => (g1("data-v-ae3924d8"), t = t(), v1(), t), Kx = {
  id: "Layer_2",
  "data-name": "Layer 2"
}, qx = /* @__PURE__ */ Gx(() => /* @__PURE__ */ d("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, [
  /* @__PURE__ */ d("circle", {
    class: "cls-1",
    cx: "7.4",
    cy: "7.3",
    r: "6.9"
  }),
  /* @__PURE__ */ d("path", {
    class: "cls-2",
    d: "M7.4,0a7.4,7.4,0,1,0,7.3,7.3A7.4,7.4,0,0,0,7.4,0Zm0,13.7A6.3,6.3,0,0,1,1,7.3,6.3,6.3,0,0,1,7.4,1a6.3,6.3,0,0,1,6.3,6.3A6.3,6.3,0,0,1,7.4,13.7Z"
  }),
  /* @__PURE__ */ d("path", {
    class: "cls-2",
    d: "M10.9,6.8H8.4V3.3a1.1,1.1,0,0,0-1-1,1,1,0,0,0-1,1V7.8a.9.9,0,0,0,1,1h3.5a1,1,0,0,0,1-1A1.1,1.1,0,0,0,10.9,6.8Z"
  })
], -1)), Xx = [
  qx
];
function Jx(t, e) {
  return b(), _("g", Kx, Xx);
}
const MT = /* @__PURE__ */ K(Ux, [["render", Jx], ["__scopeId", "data-v-ae3924d8"]]), Qx = {
  id: "Layer_2",
  "data-name": "Layer 2"
}, ek = {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, _T = /* @__PURE__ */ r5({
  __name: "IconUploadCloud",
  props: {
    backgroundClasses: { default: void 0 },
    textClasses: { default: void 0 }
  },
  setup(t) {
    const e = t, r = U(() => {
      const o = "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color ease-in duration-200 hover:fill-bl-icon-hover-default-color dark:hover:fill-bl-dk-icon-hover-default-color";
      return e.backgroundClasses ? T5(
        o,
        C5().toString(e.backgroundClasses)
      ) : o;
    }), L = U(() => {
      const o = "fill-bl-text-color dark:fill-bl-dk-text-color";
      return e.textClasses ? T5(o, C5().toString(e.textClasses)) : o;
    });
    return (o, n) => (b(), _("g", Qx, [
      d("g", ek, [
        d("path", {
          class: F(r.value),
          d: "M27.8,7.2a8.1,8.1,0,0,0-3.3-5,11.6,11.6,0,0,0-7-2.2,12.2,12.2,0,0,0-7.1,2.2,8.4,8.4,0,0,0-3.2,5A7.1,7.1,0,0,0,0,14.1,7.3,7.3,0,0,0,7.4,21H27.6A7.3,7.3,0,0,0,35,14.1,7.2,7.2,0,0,0,27.8,7.2Z"
        }, null, 2),
        d("path", {
          id: "Pfad_6593",
          "data-name": "Pfad 6593",
          class: F(L.value),
          d: "M23.1,13.1a.7.7,0,0,0-.6.7v2h-10v-2a.7.7,0,0,0-.6-.7.7.7,0,0,0-.7.7v2.6c0,.4.3.6.7.6H23.1c.4,0,.7-.2.7-.6V13.8a.7.7,0,0,0-.6-.7Z"
        }, null, 2),
        d("path", {
          id: "Pfad_6594",
          "data-name": "Pfad 6594",
          class: F(L.value),
          d: "M15.4,7.2a.4.4,0,0,0,.4-.2l1.1-1v6.9a.6.6,0,0,0,1.2,0v-7L19.2,7a.6.6,0,0,0,.9,0,.7.7,0,0,0,0-.9L17.5,3.5,14.9,6.1a.7.7,0,0,0,0,.9C15,7.2,15.2,7.2,15.4,7.2Z"
        }, null, 2)
      ])
    ]));
  }
});
const tk = {}, rk = (t) => (g1("data-v-ab2654bf"), t = t(), v1(), t), Lk = {
  id: "Layer_2",
  "data-name": "Layer 2"
}, nk = /* @__PURE__ */ rk(() => /* @__PURE__ */ d("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, [
  /* @__PURE__ */ d("path", {
    class: "cls-1",
    d: "M27.8,7.2a8.1,8.1,0,0,0-3.3-5,11.6,11.6,0,0,0-7-2.2,12.2,12.2,0,0,0-7.1,2.2,8.4,8.4,0,0,0-3.2,5A7.1,7.1,0,0,0,0,14.1,7.3,7.3,0,0,0,7.4,21H27.6A7.3,7.3,0,0,0,35,14.1,7.2,7.2,0,0,0,27.8,7.2Z"
  }),
  /* @__PURE__ */ d("path", {
    id: "Pfad_6593",
    "data-name": "Pfad 6593",
    d: "M23.1,13.1a.7.7,0,0,0-.6.7v2h-10v-2a.7.7,0,0,0-.6-.7.7.7,0,0,0-.7.7v2.6c0,.4.3.6.7.6H23.1c.4,0,.7-.2.7-.6V13.8a.7.7,0,0,0-.6-.7Z"
  }),
  /* @__PURE__ */ d("path", {
    id: "Pfad_6594",
    "data-name": "Pfad 6594",
    d: "M15.4,7.2a.4.4,0,0,0,.4-.2l1.1-1v6.9a.6.6,0,0,0,1.2,0v-7L19.2,7a.6.6,0,0,0,.9,0,.7.7,0,0,0,0-.9L17.5,3.5,14.9,6.1a.7.7,0,0,0,0,.9C15,7.2,15.2,7.2,15.4,7.2Z"
  })
], -1)), ok = [
  nk
];
function sk(t, e) {
  return b(), _("g", Lk, ok);
}
const $T = /* @__PURE__ */ K(tk, [["render", sk], ["__scopeId", "data-v-ab2654bf"]]), ak = {}, ik = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, lk = /* @__PURE__ */ O5('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1120.45,571.25L1121.05,573.25L1120.35,576.35L1121.25,579.35L1120.35,581.75L1120.75,583.95L1109.05,583.85L1108.25,604.35L1111.85,609.55L1115.45,613.55L1105.05,616.15L1091.55,615.25L1087.75,612.25L1065.05,612.45L1064.25,612.95L1060.95,610.05L1057.35,609.85L1053.95,610.95L1051.25,612.15L1050.75,608.15L1051.65,602.45L1053.65,596.55L1053.95,593.85L1055.85,588.05L1057.25,585.45L1060.55,581.25L1062.45,578.35L1063.05,573.65L1062.75,569.95L1061.15,567.65L1059.65,563.75L1058.35,559.95L1058.65,558.55L1060.35,556.05L1058.75,549.85L1057.55,545.55L1054.75,541.45L1055.35,540.25L1057.65,539.35L1059.35,539.45L1061.35,538.75L1078.05,538.85L1079.35,543.55L1080.95,547.45L1082.25,549.55L1084.35,552.85L1088.15,552.35L1089.95,551.45L1093.05,552.35L1093.95,550.75L1095.45,547.05L1098.95,546.75L1099.25,545.65L1102.15,545.65L1101.65,547.95L1108.45,547.85L1108.55,551.95L1109.65,554.35L1108.75,558.25L1109.15,562.25L1110.95,564.65L1110.55,572.25L1111.95,571.65L1114.35,571.85L1117.85,570.85L1120.45,571.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1054.55,538.25L1053.05,533.45L1055.35,530.65L1057.05,529.55L1059.15,531.75L1057.15,533.15L1056.15,534.75L1055.95,537.55L1054.55,538.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BJ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1005.95,426.25L1005.75,428.35L1007.05,432.15L1005.95,434.75L1006.55,436.45L1003.75,440.45L1002.05,442.45L1000.95,446.45L1001.15,450.55L1000.85,460.85L996.15,461.65L994.75,457.25L995.05,442.45L993.85,441.15L993.65,437.95L991.65,435.75L989.95,433.85L990.65,430.45L992.65,429.75L993.75,426.95L996.55,426.35L997.75,424.45L999.65,422.55L1001.65,422.55L1005.95,426.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BF" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M987.75,405.25L987.25,408.35L988.05,411.25L991.15,415.45L991.35,418.55L997.85,420.05L997.75,424.45L996.55,426.35L993.75,426.95L992.65,429.75L990.65,430.45L985.75,430.35L983.15,429.85L981.35,430.85L978.85,430.35L969.05,430.65L968.85,434.35L969.65,439.15L965.75,437.55L963.15,437.75L961.15,439.35L958.65,438.05L957.65,435.85L955.15,434.45L954.75,430.75L956.35,428.05L956.15,425.85L960.65,420.55L961.55,416.15L963.05,414.55L965.75,415.45L968.15,414.15L968.95,412.45L973.25,409.65L974.35,407.65L979.65,404.95L982.75,404.05L984.15,405.25L987.75,405.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BW" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1126.85,614.95L1128.75,620.05L1129.85,621.25L1131.45,624.95L1137.55,631.95L1139.85,632.65L1139.75,634.95L1141.25,639.05L1145.55,640.05L1148.95,642.95L1140.85,647.65L1135.65,652.45L1133.65,656.75L1131.85,659.15L1128.85,659.65L1127.65,662.75L1127.05,664.75L1123.45,666.15L1118.95,665.85L1116.45,664.05L1114.15,663.35L1111.35,664.75L1109.85,667.85L1107.15,669.75L1104.35,672.65L1100.35,673.35L1099.25,671.05L1099.85,667.15L1096.85,661.05L1095.45,660.05L1096.05,641.35L1101.55,641.15L1102.35,618.25L1106.55,618.05L1115.25,615.75L1117.25,618.45L1120.95,615.95L1122.65,615.95L1125.85,614.45L1126.85,614.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CF" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1120.55,445.75L1124.45,448.25L1127.55,450.85L1127.65,452.95L1131.55,456.25L1133.95,459.05L1135.35,462.85L1139.65,465.45L1140.55,467.45L1138.75,468.15L1135.05,468.05L1130.85,467.35L1128.75,467.85L1127.85,469.45L1126.05,469.65L1123.85,468.25L1117.55,471.45L1114.95,470.85L1114.15,471.35L1112.55,475.25L1108.25,473.95L1104.15,473.35L1100.55,470.95L1095.85,468.75L1092.85,470.85L1090.65,474.05L1090.15,478.55L1086.55,478.25L1082.65,477.15L1079.35,480.55L1076.35,486.55L1075.75,484.65L1075.45,481.75L1072.85,479.65L1070.75,476.35L1070.25,474.05L1067.55,470.65L1068.05,468.75L1067.45,466.05L1067.85,461.05L1069.25,459.95L1072.05,453.45L1076.65,452.95L1077.65,451.25L1078.65,451.45L1080.05,452.85L1087.15,450.45L1089.55,447.95L1092.45,445.65L1091.85,443.45L1093.45,442.85L1098.95,443.25L1104.15,440.25L1108.15,433.25L1110.95,430.65L1114.55,429.55L1115.25,432.25L1118.55,436.25L1118.55,438.95L1117.75,441.55L1118.15,443.55L1120.05,445.45L1120.55,445.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CI" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M955.15,434.45L957.65,435.85L958.65,438.05L961.15,439.35L963.15,437.75L965.75,437.55L969.65,439.15L971.15,448.35L968.75,453.65L967.25,460.95L969.65,466.45L969.45,469.05L966.85,469.05L962.95,467.85L959.25,467.85L952.55,469.05L948.65,470.85L943.05,473.25L941.95,473.05L942.35,467.75L942.95,466.95L942.75,464.45L940.35,461.75L938.55,461.35L936.95,459.55L938.15,456.65L937.65,453.55L937.85,451.75L938.75,451.75L939.15,448.95L938.75,447.65L939.25,446.75L941.35,446.05L939.95,440.85L938.65,438.25L939.15,436.05L940.25,435.55L941.05,434.95L942.55,435.95L946.95,435.95L947.95,434.15L948.95,434.25L950.55,433.55L951.45,436.25L952.75,435.45L955.15,434.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CM" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1072.05,453.45L1069.25,459.95L1067.85,461.05L1067.45,466.05L1068.05,468.75L1067.55,470.65L1070.25,474.05L1070.75,476.35L1072.85,479.65L1075.45,481.75L1075.75,484.65L1076.35,486.55L1075.95,489.95L1071.45,488.45L1066.85,486.75L1059.75,486.55L1059.05,486.15L1055.65,486.95L1052.25,486.15L1049.55,486.55L1040.25,486.45L1041.15,481.35L1038.85,477.05L1036.25,476.05L1035.15,473.15L1033.65,472.25L1033.75,470.45L1035.15,465.85L1037.85,459.65L1039.45,459.65L1042.85,455.85L1044.95,455.75L1048.15,458.45L1052.05,456.25L1052.55,453.55L1053.85,450.95L1054.65,447.75L1057.65,445.15L1058.75,440.65L1059.95,439.15L1060.75,435.85L1062.15,431.75L1066.85,426.75L1067.15,424.65L1067.75,423.45L1065.45,420.95L1065.65,418.85L1067.15,418.55L1069.45,422.65L1069.95,426.85L1069.75,431.15L1072.95,436.95L1069.75,436.95L1068.15,437.35L1065.55,436.75L1064.35,439.75L1067.75,443.55L1070.25,444.65L1071.05,447.25L1072.85,451.65L1072.05,453.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CD" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1140.55,467.45L1144.05,472.75L1146.65,473.55L1148.15,472.45L1150.75,472.85L1153.85,471.55L1155.25,474.25L1160.35,478.55L1160.05,486.05L1162.35,486.95L1160.45,489.15L1158.35,490.95L1156.15,494.25L1154.95,497.25L1154.65,502.35L1153.35,504.85L1153.25,509.65L1151.65,511.45L1151.45,515.25L1150.65,515.75L1150.05,519.35L1151.45,522.25L1151.55,523.25L1150.35,533.55L1151.85,537.15L1150.85,539.85L1152.65,544.45L1156.05,547.95L1156.75,551.45L1158.35,553.15L1158.05,554.25L1157.15,553.95L1149.45,555.05L1147.95,555.85L1146.25,559.95L1147.45,562.75L1146.35,570.35L1145.45,576.75L1146.95,577.95L1150.85,580.45L1152.45,579.25L1152.65,586.15L1148.35,586.15L1146.15,582.65L1144.15,579.85L1139.85,578.95L1138.65,575.65L1135.15,577.65L1130.75,576.75L1128.85,573.85L1125.35,573.25L1122.65,573.35L1122.35,571.35L1120.45,571.25L1117.85,570.85L1114.35,571.85L1111.95,571.65L1110.55,572.25L1110.95,564.65L1109.15,562.25L1108.75,558.25L1109.65,554.35L1108.55,551.95L1108.45,547.85L1101.65,547.95L1102.15,545.65L1099.25,545.65L1098.95,546.75L1095.45,547.05L1093.95,550.75L1093.05,552.35L1089.95,551.45L1088.15,552.35L1084.35,552.85L1082.25,549.55L1080.95,547.45L1079.35,543.55L1078.05,538.85L1061.35,538.75L1059.35,539.45L1057.65,539.35L1055.35,540.25L1054.55,538.25L1055.95,537.55L1056.15,534.75L1057.15,533.15L1059.15,531.75L1060.65,532.45L1062.65,529.95L1065.75,530.05L1066.05,531.85L1068.15,532.95L1071.55,528.95L1074.85,525.85L1076.25,523.75L1076.15,518.45L1078.65,512.25L1081.25,508.95L1084.95,505.85L1085.65,503.85L1085.75,501.45L1086.65,499.25L1086.35,495.55L1087.05,489.85L1088.15,485.85L1089.85,482.45L1090.15,478.55L1090.65,474.05L1092.85,470.85L1095.85,468.75L1100.55,470.95L1104.15,473.35L1108.25,473.95L1112.55,475.25L1114.15,471.35L1114.95,470.85L1117.55,471.45L1123.85,468.25L1126.05,469.65L1127.85,469.45L1128.75,467.85L1130.85,467.35L1135.05,468.05L1138.75,468.15L1140.55,467.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1090.15,478.55L1089.85,482.45L1088.15,485.85L1087.05,489.85L1086.35,495.55L1086.65,499.25L1085.75,501.45L1085.65,503.85L1084.95,505.85L1081.25,508.95L1078.65,512.25L1076.15,518.45L1076.25,523.75L1074.85,525.85L1071.55,528.95L1068.15,532.95L1066.05,531.85L1065.75,530.05L1062.65,529.95L1060.65,532.45L1059.15,531.75L1057.05,529.55L1055.35,530.65L1053.05,533.45L1048.45,526.65L1052.75,523.05L1050.65,518.85L1052.65,517.25L1056.45,516.45L1056.85,513.55L1059.95,516.65L1064.95,516.95L1066.65,513.95L1067.35,509.65L1066.75,504.65L1064.05,500.85L1066.55,493.35L1065.15,492.15L1060.95,492.65L1059.35,489.35L1059.75,486.55L1066.85,486.75L1071.45,488.45L1075.95,489.95L1076.35,486.55L1079.35,480.55L1082.65,477.15L1086.55,478.25L1090.15,478.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DJ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1228.75,427.45L1226.85,430.95L1225.55,429.75L1224.25,430.25L1221.05,430.15L1220.85,428.15L1220.35,426.35L1222.15,423.35L1224.05,420.55L1226.45,421.15L1228.15,419.55L1229.55,421.55L1229.45,424.15L1226.35,425.75L1228.75,427.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DZ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1030.25,263.85L1029.25,267.15L1030.25,273.25L1029.15,278.55L1025.95,282.15L1026.55,286.95L1031.05,290.85L1031.15,292.35L1034.55,294.95L1037.15,306.45L1039.05,312.15L1039.45,315.15L1038.65,320.35L1039.05,323.35L1038.45,326.85L1039.05,330.85L1036.85,333.55L1040.25,338.25L1040.45,340.95L1042.55,344.55L1045.05,343.35L1049.55,346.35L1052.05,350.35L1033.25,362.65L1017.25,375.25L1009.45,378.05L1003.25,378.75L1003.15,374.65L1000.55,373.55L997.05,371.75L995.75,368.75L977.05,354.75L958.45,340.75L937.95,325.15L938.05,323.95L938.15,323.55L938.25,315.95L947.15,311.15L952.55,310.15L957.05,308.45L959.15,305.25L965.55,302.75L965.85,297.95L968.95,297.35L971.45,295.05L978.55,293.95L979.55,291.45L978.15,290.05L976.25,283.25L975.95,279.35L974.05,275.25L979.15,271.75L984.95,270.65L988.25,268.05L993.35,266.05L1002.35,264.95L1011.15,264.45L1013.85,265.35L1018.75,262.85L1024.45,262.75L1026.65,264.25L1030.25,263.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1171.35,300.65L1175.25,310.05L1175.95,311.65L1174.65,314.25L1173.95,319.05L1172.75,322.45L1171.55,323.55L1169.55,321.45L1166.85,318.65L1162.15,309.45L1161.65,310.05L1164.45,316.75L1168.35,323.25L1173.25,333.25L1175.55,336.75L1177.55,340.35L1182.95,347.45L1181.95,348.55L1182.35,352.75L1189.15,358.55L1190.25,359.85L1124.35,359.85L1123.35,336.15L1122.05,313.35L1120.05,308.15L1121.15,304.25L1120.15,301.45L1121.85,298.35L1129.05,298.25L1134.45,299.95L1139.95,301.85L1142.55,302.85L1146.55,300.85L1148.65,299.05L1153.35,298.45L1157.25,299.25L1159.05,302.45L1160.15,300.35L1164.55,301.85L1168.85,302.25L1171.35,300.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ER" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1228.15,419.55L1226.45,421.15L1224.05,420.55L1222.05,418.45L1219.55,414.75L1216.95,412.65L1215.45,410.45L1210.45,407.85L1206.55,407.75L1205.15,406.45L1201.95,407.95L1198.35,405.05L1196.85,409.85L1190.25,408.45L1189.55,405.95L1191.55,396.45L1191.85,392.25L1193.55,390.25L1197.55,389.15L1200.25,385.55L1203.85,392.95L1205.75,398.85L1208.95,401.95L1216.95,408.05L1220.25,411.65L1223.45,415.45L1225.25,417.65L1228.15,419.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ET" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1206.55,407.75L1210.45,407.85L1215.45,410.45L1216.95,412.65L1219.55,414.75L1222.05,418.45L1224.05,420.55L1222.15,423.35L1220.35,426.35L1220.85,428.15L1221.05,430.15L1224.25,430.25L1225.55,429.75L1226.85,430.95L1225.65,433.15L1227.85,436.75L1230.05,439.85L1232.25,442.15L1250.95,449.75L1255.75,449.65L1240.15,468.95L1232.85,469.25L1227.85,473.75L1224.25,473.85L1222.75,475.95L1218.85,475.95L1216.55,473.75L1211.35,476.45L1209.75,479.15L1205.95,478.55L1204.65,477.85L1203.35,478.05L1201.55,477.95L1194.35,472.55L1190.35,472.55L1188.45,470.45L1188.35,466.85L1185.45,465.75L1181.95,458.75L1179.35,457.25L1178.35,454.65L1175.35,451.55L1171.85,451.05L1173.75,447.45L1176.75,447.25L1177.55,445.35L1177.35,440.35L1177.35,439.55L1178.85,432.85L1181.45,431.05L1181.95,428.45L1184.25,423.45L1187.55,420.35L1189.55,413.95L1190.25,408.45L1196.85,409.85L1198.35,405.05L1201.95,407.95L1205.15,406.45L1206.55,407.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GA" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1059.75,486.55L1059.35,489.35L1060.95,492.65L1065.15,492.15L1066.55,493.35L1064.05,500.85L1066.75,504.65L1067.35,509.65L1066.65,513.95L1064.95,516.95L1059.95,516.65L1056.85,513.55L1056.45,516.45L1052.65,517.25L1050.65,518.85L1052.75,523.05L1048.45,526.65L1042.65,520.15L1038.95,514.85L1035.45,508.25L1035.65,506.05L1036.95,504.05L1038.25,499.35L1039.45,494.55L1041.35,494.25L1049.55,494.25L1049.55,486.55L1052.25,486.15L1055.65,486.95L1059.05,486.15L1059.75,486.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GH" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M985.75,430.35L985.35,432.35L987.65,435.65L987.65,440.35L988.25,445.35L989.65,447.75L988.35,453.45L988.85,456.65L990.35,460.75L991.65,463.05L982.75,466.75L979.55,468.95L974.45,470.85L969.45,469.05L969.65,466.45L967.25,460.95L968.75,453.65L971.15,448.35L969.65,439.15L968.85,434.35L969.05,430.65L978.85,430.35L981.35,430.85L983.15,429.85L985.75,430.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GN" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M920.75,421.15L921.05,423.55L921.95,423.55L923.45,422.65L924.35,422.85L925.95,424.55L928.35,425.05L929.85,423.65L931.75,422.75L933.05,421.85L934.15,422.05L935.45,423.45L936.05,425.25L938.35,427.95L937.25,429.55L936.95,431.65L938.15,431.05L938.85,431.75L938.55,433.65L940.25,435.55L939.15,436.05L938.65,438.25L939.95,440.85L941.35,446.05L939.25,446.75L938.75,447.65L939.15,448.95L938.75,451.75L937.85,451.75L936.25,451.55L935.15,454.15L933.55,454.15L932.45,452.75L932.85,450.15L930.45,446.25L929.05,446.95L927.75,447.15L926.25,447.45L926.35,445.15L925.45,443.45L925.65,441.55L924.45,438.85L922.85,436.55L918.35,436.55L917.05,437.75L915.45,437.95L914.45,439.35L913.85,441.05L910.75,443.95L908.35,440.15L906.15,437.65L904.75,436.75L903.35,435.45L902.75,432.65L901.95,431.25L900.25,430.15L902.85,427.05L904.55,427.15L906.05,426.15L907.25,426.05L908.15,425.25L907.75,423.15L908.35,422.45L908.45,420.25L911.15,420.35L915.25,421.85L916.45,421.75L916.85,421.05L919.95,421.55L920.75,421.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GM" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M890.85,416.65L891.65,413.75L897.75,413.65L899.05,412.05L900.85,411.95L903.05,413.55L904.75,413.55L906.65,412.55L907.75,414.35L905.25,415.85L902.85,415.65L900.45,414.35L898.35,415.85L897.35,415.85L895.95,416.75L890.85,416.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GW" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M908.45,420.25L908.35,422.45L907.75,423.15L908.15,425.25L907.25,426.05L906.05,426.15L904.55,427.15L902.85,427.05L900.25,430.15L897.35,427.55L894.95,427.05L893.65,425.25L893.75,424.25L892.05,422.95L891.65,421.55L894.65,420.55L896.55,420.75L898.05,419.95L908.45,420.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GQ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1049.55,486.55L1049.55,494.25L1041.35,494.25L1039.45,494.55L1038.35,493.65L1040.25,486.45L1049.55,486.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KE" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1222.75,475.95L1217.85,483.15L1218.05,506.55L1221.35,511.85L1217.35,514.45L1215.95,517.15L1213.75,517.55L1212.95,522.15L1211.05,524.75L1209.95,528.95L1207.65,531.05L1199.55,524.65L1199.25,520.95L1178.75,507.85L1179.15,503.15L1177.75,500.65L1177.75,500.35L1179.35,497.75L1182.15,493.55L1184.25,488.85L1181.65,481.45L1180.95,478.25L1178.25,473.75L1181.65,469.95L1185.45,465.75L1188.35,466.85L1188.45,470.45L1190.35,472.55L1194.35,472.55L1201.55,477.95L1203.35,478.05L1204.65,477.85L1205.95,478.55L1209.75,479.15L1211.35,476.45L1216.55,473.75L1218.85,475.95L1222.75,475.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LR" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M937.85,451.75L937.65,453.55L938.15,456.65L936.95,459.55L938.55,461.35L940.35,461.75L942.75,464.45L942.95,466.95L942.35,467.75L941.95,473.05L940.45,473.15L934.65,470.05L929.45,465.15L924.65,461.65L920.85,457.55L922.25,455.45L922.55,453.55L925.15,450.15L927.75,447.15L929.05,446.95L930.45,446.25L932.85,450.15L932.45,452.75L933.55,454.15L935.15,454.15L936.25,451.55L937.85,451.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LY" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1121.85,298.35L1120.15,301.45L1121.15,304.25L1120.05,308.15L1122.05,313.35L1123.35,336.15L1124.35,359.85L1124.85,372.65L1118.45,372.65L1118.45,375.35L1095.85,363.05L1073.35,350.75L1067.85,354.25L1064.05,356.65L1060.85,353.15L1052.05,350.35L1049.55,346.35L1045.05,343.35L1042.55,344.55L1040.45,340.95L1040.25,338.25L1036.85,333.55L1039.05,330.85L1038.45,326.85L1039.05,323.35L1038.65,320.35L1039.45,315.15L1039.05,312.15L1037.15,306.45L1039.75,305.05L1040.15,302.25L1039.55,299.65L1043.15,297.15L1044.75,295.05L1047.35,293.25L1047.45,288.35L1053.85,290.55L1056.15,289.95L1060.65,291.05L1067.95,293.95L1070.75,299.65L1075.65,300.85L1083.45,303.55L1089.45,306.75L1091.95,305.05L1094.45,302.15L1092.85,297.25L1094.35,294.05L1098.05,291.05L1101.75,290.25L1109.15,291.55L1111.15,294.35L1113.15,294.45L1114.95,295.55L1120.35,296.25L1121.85,298.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LS" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1138.35,697.15L1136.35,697.85L1132.65,692.85L1135.85,688.85L1138.95,686.35L1141.65,684.95L1143.85,686.95L1145.55,688.95L1143.65,692.05L1142.55,694.15L1139.45,695.15L1138.35,697.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MA" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M974.05,275.25L975.95,279.35L976.25,283.25L978.15,290.05L979.55,291.45L978.55,293.95L971.45,295.05L968.95,297.35L965.85,297.95L965.55,302.75L959.15,305.25L957.05,308.45L952.55,310.15L947.15,311.15L938.25,315.95L938.15,323.55L937.25,323.55L937.35,326.95L933.95,327.15L932.15,328.65L929.65,328.65L927.65,327.75L923.05,328.45L921.15,333.45L919.35,333.95L916.65,342.05L908.75,348.95L906.75,357.85L904.35,360.75L903.65,363.05L891.15,363.55L891.05,363.55L891.35,360.55L893.55,358.85L895.45,355.45L895.15,353.25L897.15,348.75L900.35,344.65L902.25,343.65L903.85,339.95L904.05,336.45L906.15,332.55L909.95,330.15L913.55,323.65L913.65,323.55L916.55,321.05L921.65,320.35L926.05,315.95L928.85,314.25L933.55,308.85L932.35,300.95L934.55,295.35L935.45,291.95L939.05,287.65L944.45,284.75L948.55,282.05L952.25,275.45L954.05,271.45L957.95,271.55L961.05,274.25L966.15,273.85L971.65,275.25L974.05,275.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1267.15,588.15L1267.55,595.85L1268.85,598.85L1268.15,601.95L1266.95,603.75L1265.35,600.05L1264.15,601.95L1264.95,606.65L1264.25,609.45L1262.55,610.85L1261.85,616.35L1259.15,623.85L1255.75,632.65L1251.45,644.85L1248.55,653.75L1245.45,661.25L1240.85,662.75L1235.75,665.45L1232.75,663.85L1228.55,661.55L1227.35,658.15L1227.35,652.45L1225.85,647.35L1225.65,642.65L1226.95,638.05L1229.55,636.95L1229.75,634.85L1232.65,629.95L1233.45,625.85L1232.35,622.85L1231.55,618.75L1231.45,612.85L1233.65,609.25L1234.65,605.15L1237.45,604.95L1240.65,603.65L1242.85,602.45L1245.25,602.35L1248.65,598.75L1253.55,594.75L1255.35,591.55L1254.75,588.75L1257.15,589.55L1260.45,585.15L1260.75,581.25L1262.75,578.35L1264.55,581.15L1265.95,583.85L1267.15,588.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ML" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1009.45,378.05L1009.55,392.85L1006.45,397.15L1006.05,401.15L1001.05,402.15L993.35,402.65L991.35,404.95L987.75,405.25L984.15,405.25L982.75,404.05L979.65,404.95L974.35,407.65L973.25,409.65L968.95,412.45L968.15,414.15L965.75,415.45L963.05,414.55L961.55,416.15L960.65,420.55L956.15,425.85L956.35,428.05L954.75,430.75L955.15,434.45L952.75,435.45L951.45,436.25L950.55,433.55L948.95,434.25L947.95,434.15L946.95,435.95L942.55,435.95L941.05,434.95L940.25,435.55L938.55,433.65L938.85,431.75L938.15,431.05L936.95,431.65L937.25,429.55L938.35,427.95L936.05,425.25L935.45,423.45L934.15,422.05L933.05,421.85L931.75,422.75L929.85,423.65L928.35,425.05L925.95,424.55L924.35,422.85L923.45,422.65L921.95,423.55L921.05,423.55L920.75,421.15L921.05,419.15L920.55,416.75L918.55,414.95L917.45,411.25L917.25,407.25L919.15,406.05L920.15,402.25L921.95,402.15L925.85,403.95L929.05,402.65L931.15,403.05L932.05,401.65L954.55,401.55L955.85,397.05L954.85,396.25L952.35,368.55L949.95,340.85L958.45,340.75L977.05,354.75L995.75,368.75L997.05,371.75L1000.55,373.55L1003.15,374.65L1003.25,378.75L1009.45,378.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MZ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1165.95,672.75L1161.85,672.75L1161.55,669.85L1160.95,666.95L1160.55,664.65L1161.95,657.55L1160.85,652.95L1158.65,643.95L1164.85,636.65L1166.55,632.05L1167.35,631.45L1168.25,627.65L1167.45,625.75L1167.85,620.95L1169.15,616.55L1169.55,608.35L1166.75,606.35L1164.05,605.85L1162.95,604.25L1160.35,602.95L1155.65,603.05L1155.45,600.65L1155.05,596.05L1172.25,590.75L1175.45,593.85L1176.95,593.25L1179.15,594.85L1179.35,597.45L1178.05,600.45L1178.25,604.95L1181.75,608.95L1183.65,604.45L1186.15,603.15L1186.05,594.85L1183.85,590.25L1181.95,588.15L1181.55,588.15L1180.95,580.85L1182.45,574.75L1184.65,574.55L1191.35,576.35L1192.85,575.55L1196.75,575.35L1198.85,573.45L1202.25,573.55L1208.45,571.05L1213.05,567.35L1213.95,570.15L1213.45,576.55L1213.95,582.25L1213.75,592.25L1214.55,595.35L1212.65,599.95L1210.25,604.45L1206.55,608.45L1201.25,610.85L1194.75,613.95L1188.15,620.85L1185.95,622.05L1181.75,626.65L1179.45,628.05L1178.65,632.65L1181.05,637.55L1181.95,641.25L1181.95,643.25L1182.95,642.85L1182.45,649.15L1181.35,652.15L1182.55,653.25L1181.55,655.95L1179.15,658.25L1174.45,660.35L1167.55,663.85L1165.05,666.25L1165.35,668.95L1166.65,669.35L1165.95,672.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MR" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M958.45,340.75L949.95,340.85L952.35,368.55L954.85,396.25L955.85,397.05L954.55,401.55L932.05,401.65L931.15,403.05L929.05,402.65L925.85,403.95L921.95,402.15L920.15,402.25L919.15,406.05L917.25,407.25L913.65,402.85L910.25,398.05L906.65,396.35L903.95,394.55L900.85,394.55L898.05,395.95L895.35,395.45L893.35,397.45L892.95,394.05L894.55,390.85L895.35,384.85L894.95,378.45L894.35,375.25L894.95,372.05L893.55,369.05L890.75,366.25L892.05,364.15L913.75,364.15L912.85,354.85L914.35,351.55L919.55,351.05L919.75,334.55L937.75,334.95L937.95,325.15L958.45,340.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NA" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1115.45,613.55L1120.05,612.15L1123.65,612.45L1125.85,613.95L1125.85,614.45L1122.65,615.95L1120.95,615.95L1117.25,618.45L1115.25,615.75L1106.55,618.05L1102.35,618.25L1101.55,641.15L1096.05,641.35L1095.45,660.05L1094.35,683.75L1089.35,687.05L1086.45,687.55L1083.05,686.35L1080.55,685.85L1079.75,683.15L1077.75,681.35L1074.95,684.55L1071.05,679.65L1069.05,675.05L1068.05,668.75L1066.85,664.15L1065.25,654.25L1065.35,646.55L1064.75,643.05L1062.65,640.35L1059.85,635.05L1057.05,627.35L1055.95,623.35L1051.55,617.05L1051.25,612.15L1053.95,610.95L1057.35,609.85L1060.95,610.05L1064.25,612.95L1065.05,612.45L1087.75,612.25L1091.55,615.25L1105.05,616.15L1115.45,613.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NE" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1067.85,354.25L1069.45,364.25L1071.65,365.95L1071.75,367.95L1074.15,370.15L1072.95,372.95L1071.15,385.95L1070.95,394.35L1063.95,400.35L1061.65,408.85L1064.05,411.25L1064.05,415.35L1067.75,415.45L1067.15,418.55L1065.65,418.85L1065.45,420.95L1064.45,421.05L1060.55,414.05L1059.15,413.75L1054.85,417.35L1050.45,415.45L1047.45,415.15L1045.85,416.05L1042.55,415.85L1039.25,418.55L1036.35,418.75L1029.55,415.45L1026.85,416.95L1023.95,416.85L1021.85,414.45L1016.25,412.05L1010.15,412.85L1008.75,414.15L1007.95,417.85L1006.35,420.45L1005.95,426.25L1001.65,422.55L999.65,422.55L997.75,424.45L997.85,420.05L991.35,418.55L991.15,415.45L988.05,411.25L987.25,408.35L987.75,405.25L991.35,404.95L993.35,402.65L1001.05,402.15L1006.05,401.15L1006.45,397.15L1009.55,392.85L1009.45,378.05L1017.25,375.25L1033.25,362.65L1052.05,350.35L1060.85,353.15L1064.05,356.65L1067.85,354.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1065.45,420.95L1067.75,423.45L1067.15,424.65L1066.85,426.75L1062.15,431.75L1060.75,435.85L1059.95,439.15L1058.75,440.65L1057.65,445.15L1054.65,447.75L1053.85,450.95L1052.55,453.55L1052.05,456.25L1048.15,458.45L1044.95,455.75L1042.85,455.85L1039.45,459.65L1037.85,459.65L1035.15,465.85L1033.75,470.45L1027.85,472.75L1025.75,472.45L1023.55,473.85L1019.05,473.75L1015.95,469.65L1014.05,465.05L1010.05,460.85L1000.85,460.85L1001.15,450.55L1000.95,446.45L1002.05,442.45L1003.75,440.45L1006.55,436.45L1005.95,434.75L1007.05,432.15L1005.75,428.35L1005.95,426.25L1006.35,420.45L1007.95,417.85L1008.75,414.15L1010.15,412.85L1016.25,412.05L1021.85,414.45L1023.95,416.85L1026.85,416.95L1029.55,415.45L1036.35,418.75L1039.25,418.55L1042.55,415.85L1045.85,416.05L1047.45,415.15L1050.45,415.45L1054.85,417.35L1059.15,413.75L1060.55,414.05L1064.45,421.05L1065.45,420.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RW" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1158.05,508.35L1160.25,511.95L1159.95,515.75L1158.35,516.55L1155.25,516.15L1153.55,519.85L1150.05,519.35L1150.65,515.75L1151.45,515.25L1151.65,511.45L1153.25,509.65L1154.65,510.35L1158.05,508.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EH" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M938.15,323.55L938.05,323.95L937.95,325.15L937.75,334.95L919.75,334.55L919.55,351.05L914.35,351.55L912.85,354.85L913.75,364.15L892.05,364.15L890.75,366.25L891.05,363.55L891.15,363.55L903.65,363.05L904.35,360.75L906.75,357.85L908.75,348.95L916.65,342.05L919.35,333.95L921.15,333.45L923.05,328.45L927.65,327.75L929.65,328.65L932.15,328.65L933.95,327.15L937.35,326.95L937.25,323.55L938.15,323.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SD" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1190.25,408.45L1189.55,413.95L1187.55,420.35L1184.25,423.45L1181.95,428.45L1181.45,431.05L1178.85,432.85L1177.35,439.55L1177.35,440.35L1176.55,440.15L1176.65,436.95L1175.85,434.75L1172.95,432.25L1172.05,427.65L1172.65,422.85L1170.05,422.45L1169.65,423.85L1166.25,424.25L1167.75,426.05L1168.25,429.95L1165.25,433.45L1162.55,438.05L1159.65,438.75L1154.85,435.05L1152.75,436.35L1152.25,438.15L1149.35,439.45L1149.15,440.75L1143.55,440.75L1142.75,439.45L1138.65,439.15L1136.65,440.25L1135.05,439.75L1132.15,435.95L1131.15,434.25L1127.05,435.15L1125.55,438.05L1124.25,443.85L1122.25,445.05L1120.55,445.75L1120.05,445.45L1118.15,443.55L1117.75,441.55L1118.55,438.95L1118.55,436.25L1115.25,432.25L1114.55,429.55L1114.55,427.95L1112.45,426.05L1112.35,422.35L1111.05,419.85L1109.15,420.25L1109.65,417.85L1111.05,415.25L1110.35,412.55L1112.15,410.55L1110.95,409.05L1112.25,405.15L1114.75,400.35L1119.55,400.85L1118.45,375.35L1118.45,372.65L1124.85,372.65L1124.35,359.85L1190.25,359.85L1192.35,366.15L1191.15,367.25L1192.35,373.95L1194.85,381.55L1197.05,383.15L1200.25,385.55L1197.55,389.15L1193.55,390.25L1191.85,392.25L1191.55,396.45L1189.55,405.95L1190.25,408.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SS" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1177.35,440.35L1177.55,445.35L1176.75,447.25L1173.75,447.45L1171.85,451.05L1175.35,451.55L1178.35,454.65L1179.35,457.25L1181.95,458.75L1185.45,465.75L1181.65,469.95L1178.25,473.75L1174.75,476.75L1170.75,476.75L1166.25,478.25L1162.65,476.75L1160.35,478.55L1155.25,474.25L1153.85,471.55L1150.75,472.85L1148.15,472.45L1146.65,473.55L1144.05,472.75L1140.55,467.45L1139.65,465.45L1135.35,462.85L1133.95,459.05L1131.55,456.25L1127.65,452.95L1127.55,450.85L1124.45,448.25L1120.55,445.75L1122.25,445.05L1124.25,443.85L1125.55,438.05L1127.05,435.15L1131.15,434.25L1132.15,435.95L1135.05,439.75L1136.65,440.25L1138.65,439.15L1142.75,439.45L1143.55,440.75L1149.15,440.75L1149.35,439.45L1152.25,438.15L1152.75,436.35L1154.85,435.05L1159.65,438.75L1162.55,438.05L1165.25,433.45L1168.25,429.95L1167.75,426.05L1166.25,424.25L1169.65,423.85L1170.05,422.45L1172.65,422.85L1172.05,427.65L1172.95,432.25L1175.85,434.75L1176.65,436.95L1176.55,440.15L1177.35,440.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SN" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M917.25,407.25L917.45,411.25L918.55,414.95L920.55,416.75L921.05,419.15L920.75,421.15L919.95,421.55L916.85,421.05L916.45,421.75L915.25,421.85L911.15,420.35L908.45,420.25L898.05,419.95L896.55,420.75L894.65,420.55L891.65,421.55L890.85,416.65L895.95,416.75L897.35,415.85L898.35,415.85L900.45,414.35L902.85,415.65L905.25,415.85L907.75,414.35L906.65,412.55L904.75,413.55L903.05,413.55L900.85,411.95L899.05,412.05L897.75,413.65L891.65,413.75L889.35,408.75L886.65,406.55L889.15,405.25L891.95,400.75L893.35,397.45L895.35,395.45L898.05,395.95L900.85,394.55L903.95,394.55L906.65,396.35L910.25,398.05L913.65,402.85L917.25,407.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SL" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M927.75,447.15L925.15,450.15L922.55,453.55L922.25,455.45L920.85,457.55L919.35,457.05L915.35,454.45L912.35,451.05L911.45,448.65L910.75,443.95L913.85,441.05L914.45,439.35L915.45,437.95L917.05,437.75L918.35,436.55L922.85,436.55L924.45,438.85L925.65,441.55L925.45,443.45L926.35,445.15L926.25,447.45L927.75,447.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SZ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1160.95,666.95L1161.55,669.85L1161.85,672.75L1160.45,675.55L1157.25,676.25L1154.15,672.75L1154.25,670.55L1155.95,668.15L1156.55,666.25L1158.25,665.85L1160.95,666.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TD" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1118.45,375.35L1119.55,400.85L1114.75,400.35L1112.25,405.15L1110.95,409.05L1112.15,410.55L1110.35,412.55L1111.05,415.25L1109.65,417.85L1109.15,420.25L1111.05,419.85L1112.35,422.35L1112.45,426.05L1114.55,427.95L1114.55,429.55L1110.95,430.65L1108.15,433.25L1104.15,440.25L1098.95,443.25L1093.45,442.85L1091.85,443.45L1092.45,445.65L1089.55,447.95L1087.15,450.45L1080.05,452.85L1078.65,451.45L1077.65,451.25L1076.65,452.95L1072.05,453.45L1072.85,451.65L1071.05,447.25L1070.25,444.65L1067.75,443.55L1064.35,439.75L1065.55,436.75L1068.15,437.35L1069.75,436.95L1072.95,436.95L1069.75,431.15L1069.95,426.85L1069.45,422.65L1067.15,418.55L1067.75,415.45L1064.05,415.35L1064.05,411.25L1061.65,408.85L1063.95,400.35L1070.95,394.35L1071.15,385.95L1072.95,372.95L1074.15,370.15L1071.75,367.95L1071.65,365.95L1069.45,364.25L1067.85,354.25L1073.35,350.75L1095.85,363.05L1118.45,375.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M990.65,430.45L989.95,433.85L991.65,435.75L993.65,437.95L993.85,441.15L995.05,442.45L994.75,457.25L996.15,461.65L991.65,463.05L990.35,460.75L988.85,456.65L988.35,453.45L989.65,447.75L988.25,445.35L987.65,440.35L987.65,435.65L985.35,432.35L985.75,430.35L990.65,430.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TN" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1047.45,288.35L1047.35,293.25L1044.75,295.05L1043.15,297.15L1039.55,299.65L1040.15,302.25L1039.75,305.05L1037.15,306.45L1034.55,294.95L1031.15,292.35L1031.05,290.85L1026.55,286.95L1025.95,282.15L1029.15,278.55L1030.25,273.25L1029.25,267.15L1030.25,263.85L1035.95,261.35L1039.65,262.05L1039.65,265.35L1044.05,262.95L1044.45,264.15L1041.95,267.35L1042.05,270.25L1043.95,271.85L1043.45,277.45L1039.95,280.65L1041.15,284.15L1043.95,284.25L1045.35,287.35L1047.45,288.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TZ" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1166.25,507.65L1166.05,511.55L1164.95,516.05L1166.55,518.55L1169.05,517.05L1172.35,516.65L1173.05,517.45L1176.35,515.85L1174.05,513.65L1175.95,510.75L1178.75,507.85L1199.25,520.95L1199.55,524.65L1207.65,531.05L1204.85,539.05L1205.15,542.65L1208.65,544.95L1208.85,546.65L1207.15,550.55L1207.45,552.45L1207.05,555.55L1208.85,559.55L1211.05,565.95L1213.05,567.35L1208.45,571.05L1202.25,573.55L1198.85,573.45L1196.75,575.35L1192.85,575.55L1191.35,576.35L1184.65,574.55L1182.45,574.75L1182.55,574.65L1180.75,572.25L1180.45,565.45L1177.55,562.05L1177.15,563.25L1176.15,561.55L1170.65,560.35L1167.45,558.45L1163.85,557.35L1161.65,556.25L1161.35,556.05L1158.65,549.45L1158.25,545.55L1153.75,541.15L1155.15,538.75L1154.05,536.15L1154.25,533.45L1153.25,532.55L1153.55,529.75L1154.15,529.65L1156.15,527.35L1158.45,523.95L1159.85,522.65L1159.85,520.55L1158.65,519.05L1158.35,516.55L1159.95,515.75L1160.25,511.95L1158.05,508.35L1160.05,507.55L1166.25,507.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UG" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1178.25,473.75L1180.95,478.25L1181.65,481.45L1184.25,488.85L1182.15,493.55L1179.35,497.75L1177.75,500.35L1177.75,500.65L1177.55,500.25L1174.55,498.95L1172.15,500.55L1168.55,501.45L1165.95,505.15L1166.25,507.65L1160.05,507.55L1158.05,508.35L1154.65,510.35L1153.25,509.65L1153.35,504.85L1154.65,502.35L1154.95,497.25L1156.15,494.25L1158.35,490.95L1160.45,489.15L1162.35,486.95L1160.05,486.05L1160.35,478.55L1162.65,476.75L1166.25,478.25L1170.75,476.75L1174.75,476.75L1178.25,473.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZM" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1161.35,556.05L1161.65,556.25L1163.85,557.35L1167.45,558.45L1170.65,560.35L1173.25,563.25L1174.55,568.65L1173.55,570.35L1172.25,575.55L1173.15,580.95L1171.35,583.15L1169.35,589.15L1172.25,590.75L1155.05,596.05L1155.45,600.65L1151.15,601.55L1147.85,604.05L1147.05,606.25L1145.05,606.85L1139.95,612.05L1136.75,616.25L1134.85,616.35L1133.05,615.65L1126.85,614.95L1125.85,614.45L1125.85,613.95L1123.65,612.45L1120.05,612.15L1115.45,613.55L1111.85,609.55L1108.25,604.35L1109.05,583.85L1120.75,583.95L1120.35,581.75L1121.25,579.35L1120.35,576.35L1121.05,573.25L1120.45,571.25L1122.35,571.35L1122.65,573.35L1125.35,573.25L1128.85,573.85L1130.75,576.75L1135.15,577.65L1138.65,575.65L1139.85,578.95L1144.15,579.85L1146.15,582.65L1148.35,586.15L1152.65,586.15L1152.45,579.25L1150.85,580.45L1146.95,577.95L1145.45,576.75L1146.35,570.35L1147.45,562.75L1146.25,559.95L1147.95,555.85L1149.45,555.05L1157.15,553.95L1158.05,554.25L1157.75,555.65L1159.65,556.15L1160.85,557.45L1161.85,557.15L1161.35,556.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZW" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1158.65,643.95L1155.75,643.25L1153.85,644.05L1151.15,642.95L1148.95,642.95L1145.55,640.05L1141.25,639.05L1139.75,634.95L1139.85,632.65L1137.55,631.95L1131.45,624.95L1129.85,621.25L1128.75,620.05L1126.85,614.95L1133.05,615.65L1134.85,616.35L1136.75,616.25L1139.95,612.05L1145.05,606.85L1147.05,606.25L1147.85,604.05L1151.15,601.55L1155.45,600.65L1155.65,603.05L1160.35,602.95L1162.95,604.25L1164.05,605.85L1166.75,606.35L1169.55,608.35L1169.15,616.55L1167.85,620.95L1167.45,625.75L1168.25,627.65L1167.35,631.45L1166.55,632.05L1164.85,636.65L1158.65,643.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SO" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1221.35,511.85L1218.05,506.55L1217.85,483.15L1222.75,475.95L1224.25,473.85L1227.85,473.75L1232.85,469.25L1240.15,468.95L1255.75,449.65L1250.95,449.75L1232.25,442.15L1230.05,439.85L1227.85,436.75L1225.65,433.15L1226.85,430.95L1228.75,427.45L1230.65,428.65L1231.85,431.35L1234.55,434.05L1237.35,434.05L1242.55,432.35L1248.65,431.65L1253.55,429.65L1256.35,429.25L1258.35,428.05L1261.55,427.85L1263.35,427.65L1265.85,426.75L1268.85,426.05L1271.35,423.85L1273.55,423.85L1273.75,425.65L1273.35,429.35L1273.55,432.75L1272.45,435.05L1271.05,442.05L1268.65,449.15L1265.35,457.35L1260.75,466.75L1256.05,473.95L1249.45,482.75L1243.85,487.95L1235.45,494.35L1230.15,499.15L1223.95,506.95L1222.65,510.35L1221.35,511.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZA" transform="matrix(4.42046,0,0,4.42046,-3750.98,-1155.29)"><path d="M1158.65,643.95L1160.85,652.95L1161.95,657.55L1160.55,664.65L1160.95,666.95L1158.25,665.85L1156.55,666.25L1155.95,668.15L1154.25,670.55L1154.15,672.75L1157.25,676.25L1160.45,675.55L1161.85,672.75L1165.95,672.75L1164.25,677.45L1163.25,682.75L1161.55,685.65L1157.55,688.95L1156.45,689.85L1153.85,693.15L1152.05,696.45L1148.55,701.05L1141.85,707.65L1137.75,711.45L1133.45,714.45L1127.55,716.85L1124.85,717.25L1123.95,719.05L1120.75,718.05L1118.05,719.25L1112.35,718.05L1109.05,718.85L1106.85,718.45L1101.05,721.05L1096.45,722.05L1092.95,724.45L1090.55,724.65L1088.45,722.35L1086.65,722.25L1084.45,719.35L1084.15,720.25L1083.55,718.55L1083.85,714.75L1082.35,710.45L1084.15,709.25L1084.25,704.35L1080.95,698.35L1078.55,692.95L1078.55,692.85L1074.95,684.55L1077.75,681.35L1079.75,683.15L1080.55,685.85L1083.05,686.35L1086.45,687.55L1089.35,687.05L1094.35,683.75L1095.45,660.05L1096.85,661.05L1099.85,667.15L1099.25,671.05L1100.35,673.35L1104.35,672.65L1107.15,669.75L1109.85,667.85L1111.35,664.75L1114.15,663.35L1116.45,664.05L1118.95,665.85L1123.45,666.15L1127.05,664.75L1127.65,662.75L1128.85,659.65L1131.85,659.15L1133.65,656.75L1135.65,652.45L1140.85,647.65L1148.95,642.95L1151.15,642.95L1153.85,644.05L1155.75,643.25L1158.65,643.95ZM1138.35,697.15L1139.45,695.15L1142.55,694.15L1143.65,692.05L1145.55,688.95L1143.85,686.95L1141.65,684.95L1138.95,686.35L1135.85,688.85L1132.65,692.85L1136.35,697.85L1138.35,697.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), uk = [
  lk
];
function dk(t, e) {
  return b(), _("svg", ik, uk);
}
const ck = /* @__PURE__ */ K(ak, [["render", dk]]), hk = {}, fk = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, pk = /* @__PURE__ */ O5('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1601.45,381.15L1597.15,384.25L1592.25,382.25L1591.25,376.75L1593.45,373.85L1599.25,372.05L1602.55,372.15L1604.15,374.65L1602.15,377.45L1601.45,381.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1624.85,184.75L1633.85,189.25L1639.85,195.05L1647.45,195.05L1650.05,192.65L1656.95,190.75L1658.25,196.45L1657.95,198.75L1660.75,205.55L1661.35,211.75L1654.45,210.65L1651.55,212.85L1656.25,218.25L1660.15,225.75L1657.65,225.85L1659.55,229.15L1654.05,225.35L1654.05,228.95L1647.65,231.65L1650.45,235.05L1645.85,234.75L1642.25,232.75L1641.15,237.35L1637.25,240.75L1635.15,244.85L1628.85,246.65L1626.45,249.65L1621.65,251.45L1622.95,248.45L1620.65,245.95L1622.65,241.65L1618.15,238.35L1614.75,240.55L1611.15,245.05L1609.85,249.15L1604.85,249.45L1603.55,252.45L1608.35,256.75L1613.15,257.85L1614.55,260.65L1619.65,262.55L1623.45,257.95L1629.35,260.45L1632.85,260.65L1635.15,263.95L1628.45,265.75L1627.45,269.25L1623.65,272.45L1622.75,276.95L1629.85,280.45L1634.45,286.75L1639.95,292.65L1645.45,297.55L1647.05,302.35L1644.25,304.15L1646.65,307.55L1650.55,309.55L1651.35,314.75L1651.45,319.85L1648.65,320.45L1646.55,327.35L1644.25,335.85L1640.85,343.45L1634.45,349.35L1627.85,354.85L1621.75,355.55L1618.85,358.35L1616.55,356.35L1614.05,359.45L1606.85,362.75L1601.05,363.65L1600.35,370.45L1597.25,370.85L1595.05,366.15L1595.95,363.75L1588.15,361.65L1585.75,362.75L1579.85,361.05L1576.75,358.45L1577.05,354.75L1571.75,353.55L1568.65,351.15L1564.55,354.55L1559.25,355.35L1554.85,355.25L1552.15,356.85L1549.45,357.75L1551.45,365.15L1548.45,364.95L1547.65,363.45L1547.15,360.75L1543.35,362.65L1540.75,361.45L1536.25,359.05L1537.05,353.75L1533.35,352.45L1530.95,346.55L1525.35,347.65L1524.65,340.05L1528.85,334.65L1527.95,329.35L1526.65,324.45L1523.95,322.95L1521.25,319.15L1518.15,319.65L1512.05,318.65L1513.25,315.95L1509.65,311.95L1506.45,314.65L1501.55,313.15L1496.15,317.15L1492.25,321.95L1488.05,322.75L1485.25,321.05L1482.35,320.85L1478.05,319.45L1475.45,321.05L1472.85,325.85L1471.35,320.75L1468.25,322.15L1461.75,321.45L1455.25,320.05L1450.25,317.15L1445.75,315.95L1443.25,312.85L1439.95,311.95L1433.55,307.75L1428.75,305.75L1426.85,307.25L1418.25,302.75L1412.05,298.75L1408.85,291.65L1412.95,292.55L1412.35,289.25L1409.35,285.95L1408.55,280.75L1400.85,273.15L1391.35,270.65L1388.45,265.65L1383.75,262.65L1382.25,260.85L1380.45,257.25L1379.95,254.75L1376.25,253.25L1374.75,253.95L1371.65,247.95L1372.75,246.55L1371.55,245.05L1375.65,242.05L1378.85,240.75L1384.65,241.65L1385.25,237.55L1391.65,236.85L1392.65,234.25L1399.55,230.85L1399.75,229.45L1398.05,225.75L1400.95,224.15L1392.15,213.15L1401.25,210.65L1403.25,209.25L1402.25,197.95L1413.05,200.05L1414.65,197.15L1412.15,190.95L1415.95,190.35L1417.85,186.15L1419.55,185.65L1422.85,190.05L1428.55,193.35L1436.75,195.65L1442.55,200.75L1443.95,208.05L1446.95,210.85L1453.45,211.95L1460.65,212.75L1468.65,216.75L1472.05,217.45L1477.05,223.25L1481.75,227.05L1487.35,226.85L1498.65,228.35L1505.05,227.45L1510.65,228.35L1520.05,232.25L1526.25,232.25L1529.55,234.15L1533.95,230.75L1541.15,228.55L1548.75,228.35L1553.65,226.15L1555.65,222.75L1558.05,220.55L1556.15,218.45L1553.25,216.05L1553.75,211.95L1556.95,212.55L1562.85,213.85L1566.05,210.45L1572.45,208.05L1573.75,203.85L1576.25,202.05L1583.05,201.25L1587.45,201.95L1586.65,199.75L1579.45,195.35L1574.25,193.35L1571.75,195.65L1566.25,194.65L1563.95,195.45L1561.15,192.95L1560.85,186.65L1560.25,181.95L1567.65,184.35L1572.05,180.45L1570.15,177.65L1569.95,171.15L1571.25,169.15L1568.75,165.75L1565.05,164.35L1566.75,161.25L1571.85,160.15L1578.05,159.95L1586.65,161.85L1592.65,164.05L1600.35,170.25L1604.15,172.95L1608.65,176.75L1614.85,182.75L1624.85,184.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1707.75,281.85L1709.35,284.05L1708.05,287.95L1704.95,285.85L1702.85,287.35L1702.95,291.05L1698.65,289.25L1697.45,286.25L1698.75,282.35L1702.15,283.15L1703.15,280.45L1707.75,281.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1732.35,262.65L1732.95,267.75L1735.45,270.95L1734.85,275.45L1729.45,278.45L1720.25,278.85L1715.85,286.25L1711.15,283.75L1708.75,278.95L1700.15,280.35L1695.05,283.35L1688.85,283.55L1696.25,288.25L1697.05,299.15L1694.55,301.85L1690.95,299.35L1690.05,293.55L1685.95,291.75L1681.95,287.35L1686.25,285.35L1687.35,281.25L1691.25,277.95L1693.25,273.55L1702.95,271.65L1709.25,272.95L1709.25,261.55L1714.35,264.65L1718.85,258.25L1720.55,255.75L1719.55,247.95L1714.45,240.75L1714.25,236.75L1719.05,235.55L1727.25,244.45L1730.05,249.55L1728.75,256.05L1732.35,262.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1720.45,217.85L1724.95,219.15L1726.75,216.55L1732.75,223.65L1726.35,225.35L1725.95,231.65L1715.05,227.35L1716.65,234.25L1710.95,234.35L1706.25,228.05L1705.65,223.15L1710.85,222.85L1706.45,214.05L1704.65,209.15L1715.15,215.75L1720.45,217.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KR" transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1652.15,258.75L1652.15,258.15L1654.65,258.35L1655.25,255.55L1658.85,255.15L1660.85,254.75L1660.85,253.25L1669.15,260.75L1672.45,264.95L1675.85,272.35L1675.35,275.85L1671.05,277.05L1667.95,279.75L1663.35,280.25L1661.25,276.75L1660.15,271.95L1654.85,265.35L1658.25,264.25L1652.15,258.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MN" transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1495.45,180.75L1499.45,179.55L1505.15,178.75L1510.55,179.65L1517.15,182.55L1522.05,185.75L1526.65,185.75L1533.45,186.75L1537.05,185.15L1542.95,184.15L1547.35,179.75L1550.75,180.45L1554.65,182.55L1560.25,181.95L1560.85,186.65L1561.15,192.95L1563.95,195.45L1566.25,194.65L1571.75,195.65L1574.25,193.35L1579.45,195.35L1586.65,199.75L1587.45,201.95L1583.05,201.25L1576.25,202.05L1573.75,203.85L1572.45,208.05L1566.05,210.45L1562.85,213.85L1556.95,212.55L1553.75,211.95L1553.25,216.05L1556.15,218.45L1558.05,220.55L1555.65,222.75L1553.65,226.15L1548.75,228.35L1541.15,228.55L1533.95,230.75L1529.55,234.15L1526.25,232.25L1520.05,232.25L1510.65,228.35L1505.05,227.45L1498.65,228.35L1487.35,226.85L1481.75,227.05L1477.05,223.25L1472.05,217.45L1468.65,216.75L1460.65,212.75L1453.45,211.95L1446.95,210.85L1443.95,208.05L1442.55,200.75L1436.75,195.65L1428.55,193.35L1422.85,190.05L1419.55,185.65L1424.25,184.55L1430.95,179.25L1436.85,176.35L1442.15,178.25L1447.35,178.35L1452.15,181.25L1457.15,181.45L1465.15,183.05L1467.55,178.65L1463.55,175.05L1464.85,168.65L1471.85,171.15L1476.65,171.95L1483.35,173.55L1486.95,178.15L1495.45,180.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KP" transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1659.55,229.15L1660.95,230.25L1658.75,229.85L1657.75,232.05L1657.45,234.15L1660.25,238.75L1658.35,240.15L1658.05,241.25L1657.15,243.15L1654.25,244.25L1652.85,245.95L1654.15,248.65L1653.85,249.35L1656.45,250.45L1660.85,253.25L1660.85,254.75L1658.85,255.15L1655.25,255.55L1654.65,258.35L1652.15,258.15L1652.15,258.75L1648.95,257.55L1648.85,258.75L1647.55,259.25L1646.85,258.05L1645.15,257.45L1643.25,256.45L1643.35,253.65L1644.25,252.85L1643.25,251.75L1642.85,248.25L1641.95,247.25L1638.55,246.55L1635.15,244.85L1637.25,240.75L1641.15,237.35L1642.25,232.75L1645.85,234.75L1650.45,235.05L1647.65,231.65L1654.05,228.95L1654.05,225.35L1659.55,229.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TW" transform="matrix(5.62792,0,0,5.62792,-7718.97,-507.357)"><path d="M1657.15,354.75L1655.75,360.05L1651.75,354.55L1650.25,349.85L1652.15,343.55L1655.45,338.65L1658.45,340.55L1658.35,344.45L1657.15,354.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), mk = [
  pk
];
function gk(t, e) {
  return b(), _("svg", fk, mk);
}
const vk = /* @__PURE__ */ K(hk, [["render", gk]]), yk = {}, wk = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, bk = /* @__PURE__ */ O5('<g transform="matrix(0.32,0,0,0.32,0,0)"><g id="AL" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1087.25,227.25L1087.65,228.45L1089.05,227.85L1090.25,229.55L1091.55,230.25L1092.15,232.55L1091.65,234.75L1092.65,237.45L1094.95,238.95L1095.05,240.65L1093.35,241.55L1093.25,243.65L1091.05,246.75L1090.15,246.35L1089.95,244.95L1086.85,242.75L1086.15,239.75L1086.25,235.35L1086.75,233.45L1085.85,232.45L1085.35,230.35L1087.25,227.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AT" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1069.85,190.05L1069.55,190.85L1070.25,192.95L1070.05,195.55L1067.25,195.55L1068.35,196.95L1067.05,200.95L1066.15,202.05L1061.75,202.15L1059.35,203.65L1055.15,203.15L1047.85,201.45L1046.55,199.35L1041.65,200.45L1041.15,201.65L1038.05,200.75L1035.45,200.55L1033.15,199.35L1033.85,197.85L1033.65,196.75L1035.05,196.45L1037.75,198.15L1038.35,196.45L1042.75,196.75L1046.25,195.65L1048.65,195.85L1050.35,197.15L1050.75,196.05L1049.75,191.95L1051.45,191.15L1053.05,188.25L1056.85,190.35L1059.45,187.75L1061.15,187.25L1065.15,189.15L1067.45,188.85L1069.85,190.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1015.75,176.35L1015.35,180.55L1014.05,180.75L1013.65,184.25L1009.25,181.35L1006.75,181.85L1003.25,178.95L1000.85,176.45L998.65,176.35L997.85,174.15L1001.75,172.95L1005.35,173.45L1009.85,172.15L1012.95,174.85L1015.75,176.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BG" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1131.85,220.85L1129.55,223.45L1128.25,227.95L1130.35,231.55L1125.75,230.75L1120.75,232.75L1121.05,235.95L1116.45,236.55L1112.55,234.25L1108.55,236.05L1104.75,235.85L1103.95,231.65L1101.15,229.55L1101.85,228.75L1101.25,227.95L1101.85,225.95L1103.65,223.95L1100.85,221.25L1100.15,218.85L1101.25,217.45L1103.05,220.05L1104.95,219.65L1108.95,220.55L1116.55,220.95L1118.85,219.35L1124.75,217.85L1128.75,220.15L1131.85,220.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BA" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1082.25,213.55L1084.15,213.45L1083.05,216.25L1085.75,218.75L1085.25,221.65L1084.15,221.95L1083.25,222.55L1081.65,224.05L1081.25,227.55L1076.45,225.15L1074.35,222.45L1072.25,221.05L1069.75,218.65L1068.45,216.75L1065.75,213.75L1066.55,211.15L1068.55,212.65L1069.55,211.25L1071.85,211.15L1076.35,212.25L1079.85,212.15L1082.25,213.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BY" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1140.85,161.95L1136.95,161.75L1136.15,162.35L1137.65,164.35L1139.65,168.35L1135.55,168.65L1134.25,170.05L1134.55,173.15L1132.45,172.55L1128.15,172.85L1126.65,171.35L1124.95,172.45L1123.05,171.55L1119.15,171.45L1113.45,169.95L1108.55,169.45L1104.75,169.65L1102.35,171.25L1100.05,171.55L1099.55,168.75L1097.65,165.95L1100.45,164.65L1100.05,162.25L1098.35,159.95L1097.75,157.25L1102.45,157.25L1107.25,154.95L1107.75,151.55L1111.35,149.55L1110.35,146.85L1113.05,145.85L1117.65,143.55L1122.95,145.05L1123.85,146.55L1126.25,145.85L1131.05,147.25L1132.15,150.15L1131.45,151.75L1135.25,155.75L1137.35,156.85L1137.35,157.95L1140.75,159.05L1142.45,160.65L1140.85,161.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CH" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1033.65,196.75L1033.85,197.85L1033.15,199.35L1035.45,200.55L1038.05,200.75L1037.75,203.25L1035.65,204.35L1031.85,203.55L1030.85,206.05L1028.45,206.25L1027.55,205.25L1024.85,207.45L1022.35,207.75L1020.15,206.35L1018.35,203.65L1015.95,204.65L1015.95,201.75L1019.55,198.25L1019.35,196.65L1021.65,197.25L1022.95,196.15L1027.15,196.15L1028.15,194.85L1033.65,196.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CZ" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1058.95,174.45L1061.45,176.45L1065.15,176.95L1064.95,178.65L1067.75,179.95L1068.35,178.35L1071.75,179.05L1072.45,181.05L1076.15,181.35L1078.75,184.45L1077.25,184.45L1076.55,185.55L1075.45,185.85L1075.25,187.25L1074.35,187.55L1074.25,188.15L1072.65,188.75L1070.45,188.65L1069.85,190.05L1067.45,188.85L1065.15,189.15L1061.15,187.25L1059.45,187.75L1056.85,190.35L1053.05,188.25L1050.05,185.65L1047.45,184.15L1046.75,181.45L1045.75,179.65L1049.15,178.35L1050.85,176.75L1054.35,175.55L1055.45,174.35L1056.75,175.05L1058.95,174.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1053.15,158.15L1054.55,161.25L1053.35,162.95L1055.25,165.05L1056.75,168.35L1056.55,170.55L1058.95,174.45L1056.75,175.05L1055.45,174.35L1054.35,175.55L1050.85,176.75L1049.15,178.35L1045.75,179.65L1046.75,181.45L1047.45,184.15L1050.05,185.65L1053.05,188.25L1051.45,191.15L1049.75,191.95L1050.75,196.05L1050.35,197.15L1048.65,195.85L1046.25,195.65L1042.75,196.75L1038.35,196.45L1037.75,198.15L1035.05,196.45L1033.65,196.75L1028.15,194.85L1027.15,196.15L1022.95,196.15L1023.35,191.65L1025.75,187.45L1018.55,186.25L1016.15,184.65L1016.35,181.95L1015.35,180.55L1015.75,176.35L1014.65,169.85L1017.55,169.85L1018.75,167.55L1019.65,161.95L1018.75,159.85L1019.55,158.55L1023.55,158.25L1024.55,159.55L1027.65,156.55L1026.35,154.25L1025.95,150.85L1029.65,151.65L1032.55,150.75L1032.85,153.05L1037.75,154.45L1037.85,156.65L1042.55,155.45L1045.15,153.85L1050.75,156.25L1053.15,158.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1045.35,146.95L1042.95,151.85L1037.75,148.35L1036.85,145.85L1043.65,143.85L1045.35,146.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1032.55,150.75L1029.65,151.65L1025.95,150.85L1023.85,147.45L1023.45,141.35L1024.05,139.65L1025.35,137.85L1029.35,137.55L1030.95,135.85L1034.55,134.15L1034.55,137.25L1033.35,139.25L1034.05,140.85L1036.65,141.75L1035.65,144.05L1034.25,143.45L1031.15,147.75L1032.55,150.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1112.95,123.85L1113.85,124.85L1111.25,128.25L1113.65,133.85L1112.05,135.75L1108.25,135.65L1103.85,133.45L1101.75,132.75L1097.95,133.75L1097.85,130.25L1096.35,131.05L1093.05,128.95L1092.05,125.55L1097.55,123.85L1103.15,123.05L1108.25,123.95L1112.95,123.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="FI" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1103.35,69.35L1103.75,73.15L1111.05,76.85L1108.15,81.05L1114.65,87.35L1112.95,92.15L1117.85,96.35L1116.95,100.15L1124.35,104.05L1123.45,106.95L1120.05,110.35L1112.05,117.75L1104.05,118.25L1096.45,120.35L1089.35,121.65L1086.15,118.45L1081.45,116.55L1081.55,110.75L1078.55,105.55L1080.15,102.15L1083.45,98.65L1092.25,92.45L1094.85,91.25L1093.95,88.85L1087.45,86.25L1085.65,84.05L1083.85,75.55L1076.65,71.85L1070.65,69.15L1072.85,67.75L1077.95,70.55L1083.25,70.35L1087.95,71.65L1091.35,69.25L1092.45,65.25L1098.35,63.45L1104.15,65.55L1103.35,69.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M955.95,157.45L952.45,156.25L949.45,156.35L950.65,153.05L949.75,149.85L953.75,149.55L958.65,153.35L955.95,157.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M971.85,128.75L966.75,135.25L971.45,134.45L976.55,134.45L975.25,139.35L970.95,144.75L975.85,145.05L976.15,145.75L980.35,152.85L983.55,153.85L986.45,160.85L987.85,163.25L993.75,164.35L993.15,168.35L990.75,170.15L992.65,173.35L988.25,176.55L981.75,176.45L973.35,178.25L971.15,176.95L967.85,179.85L963.35,179.15L959.75,181.55L957.25,180.35L964.55,173.85L968.95,172.45L961.35,171.45L960.05,168.95L965.15,167.05L962.65,163.75L963.65,159.75L970.75,160.35L971.55,156.75L968.45,153.05L968.35,152.95L962.65,151.85L961.55,150.25L963.35,147.55L961.85,145.85L959.25,148.75L959.15,142.85L956.95,139.85L958.85,133.65L962.65,128.85L966.25,129.25L971.85,128.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1121.15,239.15L1117.95,238.95L1115.25,238.35L1109.05,239.95L1113.05,243.55L1110.55,244.65L1107.65,244.65L1104.55,241.35L1103.65,242.75L1105.25,246.55L1108.15,249.55L1106.25,250.95L1109.45,253.85L1112.25,255.75L1112.65,259.35L1107.65,257.65L1109.45,260.95L1106.15,261.55L1108.65,267.25L1105.15,267.35L1100.55,264.55L1098.15,259.45L1096.85,255.15L1094.55,252.25L1091.55,248.55L1091.05,246.75L1093.25,243.65L1093.35,241.55L1095.05,240.65L1094.95,238.95L1098.35,238.45L1100.15,237.05L1102.95,237.15L1103.75,236.05L1104.75,235.85L1108.55,236.05L1112.55,234.25L1116.45,236.55L1121.05,235.95L1120.75,232.75L1123.45,234.45L1122.35,238.45L1121.15,239.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HR" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1080.75,206.85L1082.25,209.35L1083.95,211.15L1082.25,213.55L1079.85,212.15L1076.35,212.25L1071.85,211.15L1069.55,211.25L1068.55,212.65L1066.55,211.15L1065.75,213.75L1068.45,216.75L1069.75,218.65L1072.25,221.05L1074.35,222.45L1076.45,225.15L1081.25,227.55L1080.75,228.55L1075.75,226.25L1072.55,223.95L1067.75,222.05L1063.05,217.45L1064.05,216.95L1061.55,214.25L1061.25,212.15L1057.95,211.15L1056.55,213.85L1054.95,211.75L1054.95,209.55L1055.05,209.45L1058.65,209.65L1059.45,208.65L1061.25,209.65L1063.25,209.75L1063.15,208.05L1064.85,207.35L1065.15,204.85L1069.05,203.15L1070.65,203.95L1074.65,206.65L1078.95,207.85L1080.75,206.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HU" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1095.45,191.15L1098.45,192.85L1098.95,194.55L1096.05,195.85L1094.15,200.05L1091.55,204.35L1087.65,205.55L1084.45,205.25L1080.75,206.85L1078.95,207.85L1074.65,206.65L1070.65,203.95L1069.05,203.15L1067.85,201.05L1067.05,200.95L1068.35,196.95L1067.25,195.55L1070.05,195.55L1070.25,192.95L1072.95,194.65L1074.85,195.25L1078.95,194.55L1079.25,193.25L1081.15,193.05L1083.45,192.15L1084.05,192.55L1086.35,191.75L1087.35,190.25L1088.95,189.85L1094.45,191.75L1095.45,191.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M955.95,157.45L956.65,161.85L952.75,167.35L943.95,170.95L937.15,170.05L941.45,163.65L939.35,157.45L946.05,152.65L949.75,149.85L950.65,153.05L949.45,156.35L952.45,156.25L955.95,157.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1067.45,255.65L1065.75,260.75L1066.65,262.65L1065.75,265.95L1061.55,263.55L1058.85,262.85L1051.35,259.65L1051.85,256.35L1058.05,256.95L1063.45,256.25L1067.45,255.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1033.45,236.65L1036.75,241.15L1036.35,249.65L1033.95,249.25L1031.85,251.35L1029.85,249.65L1029.35,241.95L1028.05,238.35L1030.95,238.65L1033.45,236.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1055.15,203.15L1054.75,206.25L1056.15,208.95L1052.05,207.95L1048.15,210.25L1048.55,213.35L1048.05,215.15L1049.95,218.35L1054.95,221.55L1057.85,226.85L1063.95,231.95L1067.95,231.85L1069.35,233.25L1067.95,234.55L1072.75,236.85L1076.75,238.75L1081.45,242.15L1082.05,243.25L1081.25,245.55L1078.15,242.55L1073.55,241.55L1071.65,245.65L1075.55,248.05L1075.15,251.35L1073.05,251.75L1070.55,257.25L1068.35,257.75L1068.25,255.75L1069.15,252.35L1070.25,250.95L1067.95,247.25L1066.15,244.05L1063.95,243.25L1062.15,240.55L1058.75,239.35L1056.35,236.75L1052.55,236.35L1048.25,233.55L1043.35,229.35L1039.65,225.75L1037.75,219.45L1035.15,218.75L1030.95,216.65L1028.65,217.45L1025.75,220.45L1023.65,220.85L1024.15,218.15L1021.35,217.35L1019.85,212.45L1021.55,210.55L1020.05,208.15L1020.15,206.35L1022.35,207.75L1024.85,207.45L1027.55,205.25L1028.45,206.25L1030.85,206.05L1031.85,203.55L1035.65,204.35L1037.75,203.25L1038.05,200.75L1041.15,201.65L1041.65,200.45L1046.55,199.35L1047.85,201.45L1055.15,203.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LT" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1110.35,146.85L1111.35,149.55L1107.75,151.55L1107.25,154.95L1102.45,157.25L1097.75,157.25L1096.35,155.35L1093.85,154.65L1093.25,153.15L1093.45,151.45L1091.25,150.55L1086.15,149.45L1084.45,144.35L1089.55,142.55L1097.45,142.95L1101.95,142.35L1102.85,143.55L1105.35,143.95L1110.35,146.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LV" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1112.05,135.75L1114.55,137.05L1115.55,139.95L1117.65,143.55L1113.05,145.85L1110.35,146.85L1105.35,143.95L1102.85,143.55L1101.95,142.35L1097.45,142.95L1089.55,142.55L1084.45,144.35L1083.95,139.85L1085.65,136.05L1089.75,134.05L1094.15,138.55L1097.85,138.35L1097.95,133.75L1101.75,132.75L1103.85,133.45L1108.25,135.65L1112.05,135.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MD" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1128.65,209.55L1127.35,206.65L1127.55,203.95L1126.95,201.25L1123.55,197.45L1121.55,194.85L1119.75,193.05L1118.15,192.35L1119.25,191.45L1122.45,190.85L1126.45,192.75L1128.45,193.05L1131.05,194.75L1130.95,196.85L1132.95,197.85L1134.05,200.45L1136.05,202.05L1135.85,203.05L1136.85,203.65L1135.55,204.15L1132.55,203.95L1131.95,203.05L1130.95,203.55L1131.55,204.65L1130.45,206.75L1129.85,208.85L1128.65,209.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MK" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1104.75,235.85L1103.75,236.05L1102.95,237.15L1100.15,237.05L1098.35,238.45L1094.95,238.95L1092.65,237.45L1091.65,234.75L1092.15,232.55L1092.85,232.65L1092.95,231.35L1095.85,230.35L1097.05,230.05L1098.75,229.75L1101.15,229.55L1103.95,231.65L1104.75,235.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ME" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1089.85,226.45L1089.05,227.85L1087.65,228.45L1087.25,227.25L1085.35,230.35L1085.85,232.45L1084.75,231.95L1083.05,229.85L1080.75,228.55L1081.25,227.55L1081.65,224.05L1083.25,222.55L1084.15,221.95L1085.55,223.05L1086.45,223.95L1088.15,224.65L1090.25,225.95L1089.85,226.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1112.95,66.75L1106.55,68.85L1103.35,69.35L1104.15,65.55L1098.35,63.45L1092.45,65.25L1091.35,69.25L1087.95,71.65L1083.25,70.35L1077.95,70.55L1072.85,67.75L1070.65,69.15L1068.05,69.35L1068.15,72.95L1060.15,72.05L1059.55,75.15L1055.55,75.15L1053.25,79.05L1049.85,85.15L1044.15,93.05L1045.95,95.05L1044.65,97.25L1040.35,97.15L1037.95,102.55L1038.95,110.25L1042.05,113.15L1041.25,120.05L1037.85,124.05L1036.05,127.45L1032.75,123.85L1024.15,130.65L1018.05,132.05L1011.55,129.05L1009.75,122.75L1007.75,109.25L1011.75,105.55L1023.05,100.65L1031.15,94.75L1038.35,86.95L1047.25,76.25L1053.65,72.15L1063.95,65.35L1072.45,62.95L1079.15,63.25L1084.35,58.85L1091.75,59.05L1098.75,58.05L1112.45,61.95L1107.55,63.35L1112.95,66.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PL" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1079.15,154.05L1085.05,154.75L1093.85,154.65L1096.35,155.35L1097.75,157.25L1098.35,159.95L1100.05,162.25L1100.45,164.65L1097.65,165.95L1099.55,168.75L1100.05,171.55L1103.25,176.95L1102.95,178.65L1100.65,179.35L1096.85,184.55L1098.45,187.35L1097.35,186.95L1092.35,184.55L1088.85,185.45L1086.45,184.85L1083.65,186.15L1080.95,183.95L1079.05,184.85L1078.75,184.45L1076.15,181.35L1072.45,181.05L1071.75,179.05L1068.35,178.35L1067.75,179.95L1064.95,178.65L1065.15,176.95L1061.45,176.45L1058.95,174.45L1056.55,170.55L1056.75,168.35L1055.25,165.05L1053.35,162.95L1054.55,161.25L1053.15,158.15L1056.25,156.35L1063.35,153.55L1069.15,151.55L1073.95,152.55L1074.55,154.05L1079.15,154.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RO" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1118.15,192.35L1119.75,193.05L1121.55,194.85L1123.55,197.45L1126.95,201.25L1127.55,203.95L1127.35,206.65L1128.65,209.55L1131.05,210.75L1133.35,209.65L1135.75,210.75L1136.15,212.45L1133.85,213.75L1132.25,213.15L1131.85,220.85L1128.75,220.15L1124.75,217.85L1118.85,219.35L1116.55,220.95L1108.95,220.55L1104.95,219.65L1103.05,220.05L1101.25,217.45L1100.25,216.35L1101.25,215.25L1099.95,214.55L1098.45,215.95L1095.35,214.05L1094.65,211.45L1091.45,210.05L1090.65,207.95L1087.65,205.55L1091.55,204.35L1094.15,200.05L1096.05,195.85L1098.95,194.55L1100.95,193.15L1104.15,193.85L1107.35,193.85L1109.85,195.45L1111.45,194.45L1115.05,193.85L1116.05,192.35L1118.15,192.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RS" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1101.25,217.45L1100.15,218.85L1100.85,221.25L1103.65,223.95L1101.85,225.95L1101.25,227.95L1101.85,228.75L1101.15,229.55L1098.75,229.75L1097.05,230.05L1096.75,229.55L1097.35,228.85L1097.75,227.25L1097.05,227.35L1095.95,226.15L1095.05,225.85L1094.25,224.85L1093.25,224.45L1092.45,223.55L1091.55,223.95L1091.05,226.05L1089.85,226.45L1090.25,225.95L1088.15,224.65L1086.45,223.95L1085.55,223.05L1084.15,221.95L1085.25,221.65L1085.75,218.75L1083.05,216.25L1084.15,213.45L1082.25,213.55L1083.95,211.15L1082.25,209.35L1080.75,206.85L1084.45,205.25L1087.65,205.55L1090.65,207.95L1091.45,210.05L1094.65,211.45L1095.35,214.05L1098.45,215.95L1099.95,214.55L1101.25,215.25L1100.25,216.35L1101.25,217.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SK" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1097.35,186.95L1096.15,188.65L1095.45,191.15L1094.45,191.75L1088.95,189.85L1087.35,190.25L1086.35,191.75L1084.05,192.55L1083.45,192.15L1081.15,193.05L1079.25,193.25L1078.95,194.55L1074.85,195.25L1072.95,194.65L1070.25,192.95L1069.55,190.85L1069.85,190.05L1070.45,188.65L1072.65,188.75L1074.25,188.15L1074.35,187.55L1075.25,187.25L1075.45,185.85L1076.55,185.55L1077.25,184.45L1078.75,184.45L1079.05,184.85L1080.95,183.95L1083.65,186.15L1086.45,184.85L1088.85,185.45L1092.35,184.55L1097.35,186.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SI" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1069.05,203.15L1065.15,204.85L1064.85,207.35L1063.15,208.05L1063.25,209.75L1061.25,209.65L1059.45,208.65L1058.65,209.65L1055.05,209.45L1056.15,208.95L1054.75,206.25L1055.15,203.15L1059.35,203.65L1061.75,202.15L1066.15,202.05L1067.05,200.95L1067.85,201.05L1069.05,203.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SE" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1087.45,86.25L1080.45,87.85L1076.95,91.75L1078.25,95.25L1072.05,99.75L1064.25,104.75L1062.15,112.85L1065.85,116.95L1070.65,120.25L1067.35,126.85L1062.75,128.25L1062.15,138.25L1060.05,143.95L1054.35,143.35L1052.15,148.15L1046.65,148.45L1044.75,142.75L1040.25,135.85L1036.05,127.45L1037.85,124.05L1041.25,120.05L1042.05,113.15L1038.95,110.25L1037.95,102.55L1040.35,97.15L1044.65,97.25L1045.95,95.05L1044.15,93.05L1049.85,85.15L1053.25,79.05L1055.55,75.15L1059.55,75.15L1060.15,72.05L1068.15,72.95L1068.05,69.35L1070.65,69.15L1076.65,71.85L1083.85,75.55L1085.65,84.05L1087.45,86.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1121.15,239.15L1122.35,238.45L1123.45,234.45L1120.75,232.75L1125.75,230.75L1130.35,231.55L1131.25,234.05L1136.05,236.05L1135.35,237.65L1129.15,237.95L1127.15,239.95L1123.25,243.35L1121.25,240.45L1121.15,239.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UA" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1156.45,173.85L1158.75,176.55L1158.85,177.75L1165.55,179.95L1169.15,178.95L1172.75,181.85L1175.65,181.75L1183.35,183.75L1183.75,185.65L1182.45,188.85L1184.25,192.35L1183.95,194.45L1179.15,194.85L1176.95,196.65L1177.35,199.35L1173.45,199.85L1170.45,201.95L1165.85,202.25L1161.85,204.65L1162.85,208.55L1165.65,210.05L1170.75,209.65L1170.15,211.95L1164.75,213.05L1158.45,216.65L1155.35,215.35L1156.05,212.45L1150.15,210.55L1150.85,209.35L1155.45,207.25L1153.75,205.85L1145.65,204.25L1144.85,201.85L1140.35,202.65L1139.05,206.15L1135.75,210.75L1133.35,209.65L1131.05,210.75L1128.65,209.55L1129.85,208.85L1130.45,206.75L1131.55,204.65L1130.95,203.55L1131.95,203.05L1132.55,203.95L1135.55,204.15L1136.85,203.65L1135.85,203.05L1136.05,202.05L1134.05,200.45L1132.95,197.85L1130.95,196.85L1131.05,194.75L1128.45,193.05L1126.45,192.75L1122.45,190.85L1119.25,191.45L1118.15,192.35L1116.05,192.35L1115.05,193.85L1111.45,194.45L1109.85,195.45L1107.35,193.85L1104.15,193.85L1100.95,193.15L1098.95,194.55L1098.45,192.85L1095.45,191.15L1096.15,188.65L1097.35,186.95L1098.45,187.35L1096.85,184.55L1100.65,179.35L1102.95,178.65L1103.25,176.95L1100.05,171.55L1102.35,171.25L1104.75,169.65L1108.55,169.45L1113.45,169.95L1119.15,171.45L1123.05,171.55L1124.95,172.45L1126.65,171.35L1128.15,172.85L1132.45,172.55L1134.55,173.15L1134.25,170.05L1135.55,168.65L1139.65,168.35L1141.45,168.55L1142.45,167.15L1143.95,167.45L1148.85,166.85L1152.65,170.35L1151.75,171.65L1152.55,173.55L1156.45,173.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="XK" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1097.05,230.05L1095.85,230.35L1092.95,231.35L1092.85,232.65L1092.15,232.55L1091.55,230.25L1090.25,229.55L1089.05,227.85L1089.85,226.45L1091.05,226.05L1091.55,223.95L1092.45,223.55L1093.25,224.45L1094.25,224.85L1095.05,225.85L1095.95,226.15L1097.05,227.35L1097.75,227.25L1097.35,228.85L1096.75,229.55L1097.05,230.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NL" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1015.75,176.35L1012.95,174.85L1009.85,172.15L1005.35,173.45L1001.75,172.95L1004.25,171.25L1008.25,162.25L1014.75,159.65L1018.75,159.85L1019.65,161.95L1018.75,167.55L1017.55,169.85L1014.65,169.85L1015.75,176.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PT" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M946.15,262.95L943.95,264.55L941.15,263.65L938.45,264.35L939.35,259.35L939.05,255.45L936.65,254.85L935.55,252.45L936.05,248.25L938.25,245.95L938.75,243.35L939.95,239.55L939.95,236.85L939.05,234.55L938.85,232.35L940.75,230.75L942.95,229.85L944.15,232.95L947.15,232.95L948.05,232.15L951.15,232.35L952.45,235.55L950.05,237.25L949.75,242.25L948.95,243.15L948.65,246.25L946.35,246.75L948.35,250.55L946.75,254.75L948.55,256.65L947.75,258.35L945.75,260.75L946.15,262.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1093.85,154.65L1085.05,154.75L1079.15,154.05L1079.85,151.45L1086.15,149.45L1091.25,150.55L1093.45,151.45L1093.25,153.15L1093.85,154.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ES" transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M975.85,222.65L977.85,225.05L987.35,227.95L989.25,226.55L995.05,229.45L1000.95,228.65L1001.35,232.35L996.45,236.55L989.85,237.95L989.35,240.05L986.15,243.55L984.15,248.75L986.15,252.45L983.15,255.25L981.95,259.45L977.95,260.75L974.25,265.65L967.45,265.75L962.45,265.65L959.05,267.85L956.95,270.25L954.35,269.75L952.45,267.55L951.05,263.95L946.15,262.95L945.75,260.75L947.75,258.35L948.55,256.65L946.75,254.75L948.35,250.55L946.35,246.75L948.65,246.25L948.95,243.15L949.75,242.25L950.05,237.25L952.45,235.55L951.15,232.35L948.05,232.15L947.15,232.95L944.15,232.95L942.95,229.85L940.75,230.75L938.85,232.35L939.35,227.85L937.35,225.15L944.75,220.55L950.95,221.65L957.85,221.65L963.25,222.75L967.55,222.35L975.85,222.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1034.95,230.65L1033.45,235.55L1031.05,234.25L1029.75,230.05L1030.65,227.65L1033.85,225.25L1034.95,230.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.23482,0,0,8.23482,-7704.09,-327.746)"><path d="M1013.65,184.25L1014.75,184.75L1016.15,184.65L1018.55,186.25L1025.75,187.45L1023.35,191.65L1022.95,196.15L1021.65,197.25L1019.35,196.65L1019.55,198.25L1015.95,201.75L1015.95,204.65L1018.35,203.65L1020.15,206.35L1020.05,208.15L1021.55,210.55L1019.85,212.45L1021.35,217.35L1024.15,218.15L1023.65,220.85L1019.15,224.45L1008.95,222.75L1001.55,224.85L1000.95,228.65L995.05,229.45L989.25,226.55L987.35,227.95L977.85,225.05L975.85,222.65L978.55,218.85L979.55,206.25L974.45,199.65L970.75,196.45L963.15,194.05L962.75,189.45L969.25,188.15L977.55,189.75L976.05,182.65L980.75,185.35L992.15,180.55L993.65,175.45L997.85,174.15L998.65,176.35L1000.85,176.45L1003.25,178.95L1006.75,181.85L1009.25,181.35L1013.65,184.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), xk = [
  bk
];
function kk(t, e) {
  return b(), _("svg", wk, xk);
}
const Mk = /* @__PURE__ */ K(yk, [["render", kk]]), _k = {}, $k = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, Sk = /* @__PURE__ */ O5('<g transform="matrix(0.32,0,0,0.32,0,0)"><g id="AE" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1295.45,335.95L1296.75,341.05L1293.95,341.05L1293.95,345.25L1295.05,346.15L1292.65,347.45L1292.85,350.05L1291.55,352.65L1291.55,355.25L1290.55,356.65L1273.65,353.45L1270.95,346.85L1270.65,345.45L1271.55,345.05L1271.95,346.85L1276.15,345.85L1280.75,346.05L1284.15,346.25L1287.45,341.85L1291.15,337.75L1294.15,333.75L1295.45,335.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DZ" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1030.25,263.85L1029.25,267.15L1030.25,273.25L1029.15,278.55L1025.95,282.15L1026.55,286.95L1031.05,290.85L1031.15,292.35L1034.55,294.95L1037.15,306.45L1039.05,312.15L1039.45,315.15L1038.65,320.35L1039.05,323.35L1038.45,326.85L1039.05,330.85L1036.85,333.55L1040.25,338.25L1040.45,340.95L1042.55,344.55L1045.05,343.35L1049.55,346.35L1052.05,350.35L1033.25,362.65L1017.25,375.25L1009.45,378.05L1003.25,378.75L1003.15,374.65L1000.55,373.55L997.05,371.75L995.75,368.75L977.05,354.75L958.45,340.75L937.95,325.15L938.05,323.95L938.15,323.55L938.25,315.95L947.15,311.15L952.55,310.15L957.05,308.45L959.15,305.25L965.55,302.75L965.85,297.95L968.95,297.35L971.45,295.05L978.55,293.95L979.55,291.45L978.15,290.05L976.25,283.25L975.95,279.35L974.05,275.25L979.15,271.75L984.95,270.65L988.25,268.05L993.35,266.05L1002.35,264.95L1011.15,264.45L1013.85,265.35L1018.75,262.85L1024.45,262.75L1026.65,264.25L1030.25,263.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EG" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1171.35,300.65L1175.25,310.05L1175.95,311.65L1174.65,314.25L1173.95,319.05L1172.75,322.45L1171.55,323.55L1169.55,321.45L1166.85,318.65L1162.15,309.45L1161.65,310.05L1164.45,316.75L1168.35,323.25L1173.25,333.25L1175.55,336.75L1177.55,340.35L1182.95,347.45L1181.95,348.55L1182.35,352.75L1189.15,358.55L1190.25,359.85L1124.35,359.85L1123.35,336.15L1122.05,313.35L1120.05,308.15L1121.15,304.25L1120.15,301.45L1121.85,298.35L1129.05,298.25L1134.45,299.95L1139.95,301.85L1142.55,302.85L1146.55,300.85L1148.65,299.05L1153.35,298.45L1157.25,299.25L1159.05,302.45L1160.15,300.35L1164.55,301.85L1168.85,302.25L1171.35,300.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IR" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1228.25,252.45L1230.05,252.25L1235.35,247.55L1237.25,247.05L1239.15,248.95L1237.95,252.05L1241.85,255.45L1243.15,255.05L1245.65,259.85L1250.95,261.15L1255.25,264.35L1262.95,265.45L1270.95,263.75L1271.15,262.25L1275.55,261.05L1278.55,257.35L1282.15,257.55L1284.15,256.35L1288.05,256.95L1294.65,260.25L1298.95,260.95L1306.25,266.55L1310.25,266.85L1311.95,272.15L1311.35,280.15L1310.85,284.85L1313.35,285.85L1311.75,289.35L1314.45,294.45L1315.65,298.55L1319.95,299.65L1321.05,303.75L1317.15,309.55L1320.35,312.95L1323.15,316.85L1328.85,319.65L1329.85,325.25L1332.55,326.35L1333.45,329.25L1325.95,332.65L1324.85,340.05L1314.25,338.15L1308.05,336.65L1301.75,335.85L1298.45,327.95L1295.65,326.85L1291.55,327.95L1286.45,331.05L1279.45,328.95L1273.35,323.95L1267.85,322.15L1263.45,316.05L1258.25,307.55L1255.45,308.55L1251.75,306.45L1250.05,308.95L1246.55,305.55L1246.05,302.15L1244.35,302.15L1244.55,297.45L1241.05,292.65L1233.95,289.05L1229.35,282.95L1229.85,277.95L1232.15,275.75L1231.25,272.05L1227.45,270.05L1222.75,262.45L1218.95,257.35L1219.65,255.35L1216.75,248.05L1220.05,246.15L1221.25,248.65L1224.45,251.55L1228.25,252.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IQ" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1222.75,262.45L1227.45,270.05L1231.25,272.05L1232.15,275.75L1229.85,277.95L1229.35,282.95L1233.95,289.05L1241.05,292.65L1244.55,297.45L1244.35,302.15L1246.05,302.15L1246.55,305.55L1250.05,308.95L1246.75,308.65L1243.05,308.05L1239.75,314.25L1229.55,313.75L1212.75,300.85L1204.15,296.35L1197.35,294.55L1194.25,286.75L1205.25,280.05L1206.25,272.35L1205.05,267.65L1207.75,266.05L1209.85,262.05L1211.95,261.05L1218.25,261.95L1220.35,263.55L1222.75,262.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IL" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1178.35,287.45L1178.75,290.05L1178.15,291.05L1178.25,291.05L1177.55,293.05L1175.45,292.25L1174.75,296.45L1176.25,297.15L1174.95,298.05L1174.85,299.75L1177.35,298.95L1177.75,301.45L1175.95,311.65L1175.25,310.05L1171.35,300.65L1172.75,298.55L1172.35,298.15L1173.45,295.15L1174.05,290.35L1174.65,288.65L1176.55,288.65L1176.95,287.55L1178.35,287.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="JO" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1197.35,294.55L1196.45,295.55L1186.05,298.75L1192.05,305.25L1190.45,306.25L1189.75,308.45L1185.65,309.35L1184.55,311.65L1182.45,313.65L1176.25,312.55L1175.95,311.65L1177.75,301.45L1177.35,298.95L1177.95,297.05L1177.55,293.05L1178.25,291.05L1184.55,293.65L1194.25,286.75L1197.35,294.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LB" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1178.35,287.45L1176.95,287.55L1176.55,288.65L1174.75,288.65L1176.05,283.35L1178.25,278.85L1178.25,278.65L1180.75,278.95L1181.95,281.45L1179.25,283.95L1178.35,287.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LY" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1121.85,298.35L1120.15,301.45L1121.15,304.25L1120.05,308.15L1122.05,313.35L1123.35,336.15L1124.35,359.85L1124.85,372.65L1118.45,372.65L1118.45,375.35L1095.85,363.05L1073.35,350.75L1067.85,354.25L1064.05,356.65L1060.85,353.15L1052.05,350.35L1049.55,346.35L1045.05,343.35L1042.55,344.55L1040.45,340.95L1040.25,338.25L1036.85,333.55L1039.05,330.85L1038.45,326.85L1039.05,323.35L1038.65,320.35L1039.45,315.15L1039.05,312.15L1037.15,306.45L1039.75,305.05L1040.15,302.25L1039.55,299.65L1043.15,297.15L1044.75,295.05L1047.35,293.25L1047.45,288.35L1053.85,290.55L1056.15,289.95L1060.65,291.05L1067.95,293.95L1070.75,299.65L1075.65,300.85L1083.45,303.55L1089.45,306.75L1091.95,305.05L1094.45,302.15L1092.85,297.25L1094.35,294.05L1098.05,291.05L1101.75,290.25L1109.15,291.55L1111.15,294.35L1113.15,294.45L1114.95,295.55L1120.35,296.25L1121.85,298.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MA" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M974.05,275.25L975.95,279.35L976.25,283.25L978.15,290.05L979.55,291.45L978.55,293.95L971.45,295.05L968.95,297.35L965.85,297.95L965.55,302.75L959.15,305.25L957.05,308.45L952.55,310.15L947.15,311.15L938.25,315.95L938.15,323.55L937.25,323.55L937.35,326.95L933.95,327.15L932.15,328.65L929.65,328.65L927.65,327.75L923.05,328.45L921.15,333.45L919.35,333.95L916.65,342.05L908.75,348.95L906.75,357.85L904.35,360.75L903.65,363.05L891.15,363.55L891.05,363.55L891.35,360.55L893.55,358.85L895.45,355.45L895.15,353.25L897.15,348.75L900.35,344.65L902.25,343.65L903.85,339.95L904.05,336.45L906.15,332.55L909.95,330.15L913.55,323.65L913.65,323.55L916.55,321.05L921.65,320.35L926.05,315.95L928.85,314.25L933.55,308.85L932.35,300.95L934.55,295.35L935.45,291.95L939.05,287.65L944.45,284.75L948.55,282.05L952.25,275.45L954.05,271.45L957.95,271.55L961.05,274.25L966.15,273.85L971.65,275.25L974.05,275.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1283.05,394.15L1280.85,389.65L1275.65,379.05L1291.95,372.65L1294.55,359.85L1291.55,355.25L1291.55,352.65L1292.85,350.05L1292.65,347.45L1295.05,346.15L1293.95,345.25L1293.95,341.05L1296.75,341.05L1299.75,345.45L1303.05,347.75L1307.15,348.65L1310.55,349.75L1313.45,353.45L1315.15,355.55L1317.15,356.45L1317.35,357.85L1315.65,361.65L1314.95,363.45L1312.75,365.55L1311.05,369.95L1308.55,369.55L1307.55,371.15L1306.85,374.35L1307.95,378.65L1307.45,379.45L1304.95,379.45L1301.65,381.85L1301.35,384.95L1300.15,386.35L1296.65,386.25L1294.65,387.85L1294.85,390.45L1292.25,392.25L1289.15,391.65L1285.55,393.85L1283.05,394.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PS" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1177.55,293.05L1177.95,297.05L1177.35,298.95L1174.85,299.75L1174.95,298.05L1176.25,297.15L1174.75,296.45L1175.45,292.25L1177.55,293.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="QA" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1269.35,342.95L1267.85,343.45L1266.05,342.15L1265.25,337.45L1266.35,334.15L1267.85,333.45L1269.65,335.45L1270.15,339.15L1269.35,342.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SA" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1239.75,314.25L1244.75,314.85L1246.45,317.95L1250.35,317.75L1253.05,323.35L1255.95,324.75L1257.15,327.05L1261.15,329.75L1261.85,332.35L1261.45,334.55L1262.35,336.65L1264.15,338.45L1265.05,340.55L1266.05,342.15L1267.85,343.45L1269.35,342.95L1270.65,345.45L1270.95,346.85L1273.65,353.45L1290.55,356.65L1291.55,355.25L1294.55,359.85L1291.95,372.65L1275.65,379.05L1259.75,381.55L1254.75,384.45L1251.25,391.15L1248.65,392.25L1247.15,390.15L1245.05,390.45L1239.55,389.75L1238.45,389.15L1232.05,389.25L1230.55,389.85L1228.15,388.25L1226.85,391.35L1227.65,394.05L1225.25,396.15L1224.35,393.35L1222.55,391.45L1222.05,388.85L1218.95,386.55L1215.65,381.15L1213.75,375.95L1209.65,371.55L1207.15,370.45L1203.05,364.35L1202.15,359.95L1202.15,356.15L1198.55,348.95L1195.75,346.45L1192.75,345.15L1190.65,341.45L1190.85,340.05L1189.05,336.65L1187.35,335.25L1184.85,330.45L1181.05,325.35L1177.95,320.95L1175.25,320.95L1175.75,317.45L1175.85,315.15L1176.25,312.55L1182.45,313.65L1184.55,311.65L1185.65,309.35L1189.75,308.45L1190.45,306.25L1192.05,305.25L1186.05,298.75L1196.45,295.55L1197.35,294.55L1204.15,296.35L1212.75,300.85L1229.55,313.75L1239.75,314.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SY" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1194.25,286.75L1184.55,293.65L1178.25,291.05L1178.15,291.05L1178.75,290.05L1178.35,287.45L1179.25,283.95L1181.95,281.45L1180.75,278.95L1178.25,278.65L1177.15,273.75L1178.15,271.05L1179.45,269.65L1180.65,268.25L1180.45,264.75L1182.35,265.95L1187.95,264.15L1190.95,265.35L1195.35,265.35L1201.05,262.95L1203.95,263.05L1209.85,262.05L1207.75,266.05L1205.05,267.65L1206.25,272.35L1205.25,280.05L1194.25,286.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TN" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1047.45,288.35L1047.35,293.25L1044.75,295.05L1043.15,297.15L1039.55,299.65L1040.15,302.25L1039.75,305.05L1037.15,306.45L1034.55,294.95L1031.15,292.35L1031.05,290.85L1026.55,286.95L1025.95,282.15L1029.15,278.55L1030.25,273.25L1029.25,267.15L1030.25,263.85L1035.95,261.35L1039.65,262.05L1039.65,265.35L1044.05,262.95L1044.45,264.15L1041.95,267.35L1042.05,270.25L1043.95,271.85L1043.45,277.45L1039.95,280.65L1041.15,284.15L1043.95,284.25L1045.35,287.35L1047.45,288.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="YE" transform="matrix(4.62929,0,0,4.62929,-4124.93,-518.481)"><path d="M1283.05,394.15L1279.05,395.85L1278.15,398.75L1278.15,400.95L1272.75,403.65L1263.95,406.65L1259.25,411.15L1256.75,411.55L1255.05,411.15L1251.85,413.85L1248.35,415.05L1243.65,415.35L1242.25,415.75L1241.15,417.45L1239.65,417.95L1238.85,419.55L1236.05,419.35L1234.35,420.25L1230.35,419.95L1228.75,416.15L1228.75,412.65L1227.75,410.75L1226.45,406.05L1224.65,403.45L1225.75,403.05L1225.05,400.15L1225.65,398.95L1225.25,396.15L1227.65,394.05L1226.85,391.35L1228.15,388.25L1230.55,389.85L1232.05,389.25L1238.45,389.15L1239.55,389.75L1245.05,390.45L1247.15,390.15L1248.65,392.25L1251.25,391.15L1254.75,384.45L1259.75,381.55L1275.65,379.05L1280.85,389.65L1283.05,394.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), Ck = [
  Sk
];
function Dk(t, e) {
  return b(), _("svg", $k, Ck);
}
const zk = /* @__PURE__ */ K(_k, [["render", Dk]]), Ik = {}, Tk = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, Ok = /* @__PURE__ */ O5('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1867.35,544.85L1865.75,545.55L1863.45,543.05L1861.25,538.95L1860.45,534.05L1861.25,533.45L1861.75,535.35L1863.35,536.85L1865.75,540.85L1868.25,543.05L1867.35,544.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1845.95,536.25L1842.95,536.75L1841.95,538.55L1835.75,541.65L1832.65,541.65L1828.15,539.75L1825.05,537.95L1825.65,535.95L1830.65,536.95L1833.85,536.45L1834.85,533.35L1835.75,533.15L1836.05,536.55L1839.25,536.15L1841.05,533.95L1844.35,531.65L1843.95,527.85L1847.35,527.75L1848.45,528.75L1848.05,532.35L1845.95,536.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1782.15,559.65L1783.75,538.65L1784.75,517.75L1794.35,522.15L1804.65,525.85L1808.35,529.15L1811.35,532.35L1811.95,536.15L1821.15,540.15L1822.25,543.55L1817.05,544.25L1817.95,548.55L1822.65,552.75L1825.65,559.55L1828.95,559.35L1828.35,562.15L1832.65,563.25L1830.85,564.45L1836.55,567.15L1835.65,569.05L1831.85,569.45L1830.65,567.85L1825.95,567.05L1820.35,566.15L1816.35,562.05L1813.55,558.45L1811.05,552.85L1803.95,550.05L1799.05,551.85L1795.35,554.05L1795.65,558.75L1791.05,560.95L1787.95,559.85L1782.15,559.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1852.85,529.95L1851.05,531.65L1850.15,527.85L1849.05,525.45L1846.55,523.35L1843.45,520.55L1839.45,518.65L1841.05,517.15L1844.05,518.95L1845.95,520.35L1848.25,521.85L1850.35,524.55L1852.45,526.65L1852.85,529.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1914.45,646.15L1914.25,646.25L1914.05,646.65L1913.65,646.45L1913.85,645.95L1913.95,645.75L1914.25,645.85L1914.45,646.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1918.85,638.35L1918.75,638.45L1918.95,638.85L1919.25,638.85L1919.65,638.65L1919.55,639.25L1919.35,639.45L1919.25,639.85L1918.75,640.15L1918.35,639.95L1918.35,639.85L1918.05,639.55L1918.15,639.35L1917.95,639.15L1918.05,638.75L1917.95,638.35L1918.05,638.35L1918.45,638.45L1918.85,638.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1916.15,634.05L1915.95,634.55L1915.95,634.95L1915.75,635.25L1916.05,635.45L1916.25,635.55L1916.35,635.75L1916.25,635.95L1916.55,636.35L1916.35,636.35L1916.15,636.85L1915.95,637.05L1915.65,636.95L1915.45,636.65L1915.35,636.45L1914.75,636.35L1914.45,635.85L1914.45,635.65L1914.35,635.35L1914.65,635.35L1914.95,635.15L1915.35,634.85L1915.45,634.55L1915.05,634.35L1914.65,634.45L1914.85,634.05L1915.15,633.95L1915.35,634.05L1915.75,633.75L1916.15,634.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1912.75,632.45L1912.45,633.05L1912.35,633.35L1912.65,633.35L1911.95,634.05L1911.85,633.85L1912.15,633.45L1912.35,632.95L1912.75,632.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1912.75,632.45L1912.55,632.05L1912.95,632.05L1913.05,632.45L1912.75,632.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1898.85,630.05L1899.05,630.15L1899.55,631.05L1899.85,631.35L1900.15,631.25L1900.35,630.95L1901.25,631.45L1901.55,631.95L1902.25,632.55L1902.55,632.95L1902.65,633.25L1903.05,633.65L1903.15,633.85L1903.35,633.85L1903.65,634.15L1904.55,634.35L1904.65,634.65L1904.65,635.05L1904.95,635.45L1905.35,635.55L1905.05,636.05L1905.15,636.25L1905.55,636.75L1905.65,636.75L1906.05,637.25L1905.95,637.65L1906.65,637.85L1907.05,638.35L1907.35,638.35L1907.65,638.55L1908.15,638.95L1908.05,639.25L1908.35,639.25L1908.75,639.75L1909.35,640.15L1909.35,640.35L1909.65,640.45L1909.95,640.75L1909.95,640.95L1910.25,641.55L1910.65,641.95L1910.75,641.85L1911.15,642.45L1911.65,642.55L1911.95,642.85L1911.95,643.25L1912.05,643.65L1912.15,643.75L1911.95,644.35L1911.25,644.75L1911.15,644.45L1910.85,644.55L1910.55,644.85L1909.95,644.05L1909.55,644.05L1909.45,643.85L1909.25,643.85L1909.05,644.15L1908.15,643.25L1907.95,643.25L1907.55,642.75L1907.65,641.95L1906.95,641.95L1906.65,641.75L1906.55,641.55L1906.35,641.45L1906.05,641.45L1906.05,641.15L1905.85,640.65L1905.45,640.75L1904.65,640.25L1904.55,640.05L1904.55,639.75L1904.25,639.95L1903.65,639.65L1903.55,639.25L1903.15,638.95L1902.95,638.45L1902.45,638.35L1902.65,638.15L1902.35,637.85L1902.05,637.75L1901.75,637.05L1901.75,636.65L1901.55,636.35L1901.25,636.35L1901.05,635.75L1901.15,635.55L1900.45,635.15L1900.15,634.95L1899.75,634.35L1900.05,634.15L1899.85,633.95L1899.65,633.65L1899.65,633.15L1899.15,632.85L1899.15,632.25L1898.95,631.95L1899.25,631.95L1899.35,631.65L1899.25,631.45L1898.65,631.45L1898.45,631.15L1898.95,630.45L1898.65,630.15L1898.85,630.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1899.95,630.35L1899.65,630.25L1899.75,629.85L1899.95,630.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1897.65,627.95L1897.45,628.15L1897.35,627.75L1897.55,627.55L1897.65,627.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NR" transform="matrix(8.90109,0,0,8.90109,-15863.1,-4098.13)"><path d="M1932.25,504.55L1932.05,504.55L1931.95,504.25L1932.25,504.25L1932.25,504.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1926.05,575.45L1926.35,575.65L1926.25,576.05L1926.55,576.05L1926.55,576.25L1925.75,576.25L1925.45,575.75L1925.65,575.45L1926.05,575.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1887.75,574.85L1887.95,574.85L1888.95,575.65L1889.45,575.95L1890.35,576.65L1890.25,576.95L1890.05,576.95L1889.85,577.15L1889.65,576.85L1889.55,576.85L1889.35,576.65L1889.25,576.25L1888.85,576.15L1888.85,575.85L1888.55,575.75L1888.45,575.85L1888.25,575.85L1887.35,575.45L1887.15,575.05L1887.45,574.65L1887.75,574.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1924.65,573.35L1924.45,573.65L1924.15,573.45L1924.15,573.25L1924.45,573.05L1924.65,573.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1922.35,569.45L1922.45,569.55L1922.75,569.55L1922.65,569.95L1922.15,570.15L1921.85,570.15L1921.45,570.25L1921.05,570.85L1920.95,570.55L1920.65,570.65L1920.45,570.45L1920.45,570.15L1920.95,570.05L1920.95,569.85L1921.25,569.45L1921.95,569.55L1922.35,569.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1896.05,566.65L1896.35,566.55L1896.95,566.85L1897.75,567.65L1897.95,567.65L1898.15,567.85L1898.35,567.85L1898.65,568.15L1898.95,568.05L1899.35,568.15L1899.55,568.35L1899.95,568.35L1900.25,568.25L1900.45,568.55L1900.65,569.35L1900.95,569.65L1900.95,570.15L1900.75,570.35L1900.85,570.65L1900.45,570.45L1900.15,570.65L1899.85,570.55L1899.35,570.25L1899.15,570.25L1898.55,570.05L1898.15,569.95L1897.95,569.65L1897.65,569.45L1897.35,569.35L1897.15,569.05L1896.75,568.85L1896.95,568.45L1896.85,568.05L1896.85,567.65L1896.65,567.55L1896.05,567.35L1895.75,567.45L1895.65,567.25L1895.85,566.65L1896.05,566.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1900.05,563.25L1899.95,563.45L1899.95,564.15L1899.75,563.95L1899.75,563.45L1900.05,563.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1897.15,561.45L1897.45,562.35L1897.65,562.75L1897.65,563.15L1897.75,563.65L1897.55,563.95L1897.15,563.25L1897.05,563.55L1896.75,563.05L1896.85,562.05L1896.95,561.85L1896.95,561.55L1897.15,561.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1888.75,561.65L1889.05,561.65L1889.35,561.55L1889.75,561.65L1889.85,561.55L1891.15,561.55L1891.35,561.85L1891.65,561.95L1891.85,562.25L1892.05,562.25L1892.25,562.35L1892.65,562.75L1892.65,563.35L1892.85,563.35L1893.25,563.55L1893.35,563.85L1893.35,564.45L1893.25,564.55L1892.55,564.75L1892.35,564.85L1891.95,564.75L1891.55,564.55L1891.15,564.55L1891.05,564.35L1890.55,564.05L1889.95,564.05L1889.45,564.15L1888.95,564.15L1888.45,564.05L1888.15,563.85L1887.85,563.95L1887.55,563.55L1887.25,563.35L1886.95,562.55L1886.75,562.15L1886.95,561.95L1886.85,561.75L1886.85,561.05L1886.95,560.75L1887.55,560.45L1887.95,560.65L1888.35,561.15L1888.45,561.45L1888.75,561.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1891.05,559.25L1891.55,559.75L1891.25,560.05L1890.95,559.85L1890.95,559.75L1891.05,559.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1891.05,559.25L1890.85,559.65L1890.75,559.65L1890.35,559.35L1890.05,559.45L1889.85,559.35L1889.75,559.15L1890.05,559.05L1890.25,558.85L1890.75,558.95L1891.05,559.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1884.45,558.75L1884.55,558.95L1884.75,559.05L1884.55,559.45L1884.15,559.65L1883.85,559.25L1884.45,558.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1875.95,556.95L1876.15,557.25L1876.05,557.55L1875.25,557.15L1875.75,556.85L1875.95,556.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1879.35,557.75L1879.05,557.55L1879.15,557.25L1879.45,556.95L1879.45,557.45L1879.55,557.65L1879.35,557.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1878.45,555.95L1878.65,555.85L1879.05,555.85L1879.05,556.05L1878.65,556.35L1878.85,556.55L1878.85,556.85L1878.45,557.25L1878.25,557.35L1877.95,557.25L1877.55,556.85L1877.65,556.25L1877.95,556.15L1878.15,555.75L1878.45,555.65L1878.45,555.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1874.85,556.05L1874.65,556.15L1874.45,556.65L1874.85,557.15L1874.35,556.95L1874.35,556.75L1874.25,556.45L1873.85,556.05L1873.85,555.85L1874.25,555.65L1874.35,555.35L1874.75,555.05L1875.05,555.25L1875.05,555.65L1874.85,556.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1887.75,555.55L1887.95,555.75L1887.85,555.95L1887.65,555.85L1887.05,555.35L1887.25,554.95L1887.55,554.85L1887.75,555.05L1887.65,555.35L1887.75,555.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1894.25,554.75L1894.65,555.55L1895.25,556.35L1895.25,556.65L1894.85,556.85L1894.85,557.65L1894.95,557.85L1895.15,557.85L1895.35,558.15L1895.85,558.55L1895.95,559.05L1896.05,559.35L1896.25,559.55L1896.05,559.75L1896.35,560.05L1896.25,560.15L1896.35,560.65L1896.15,560.85L1896.45,561.15L1896.55,561.65L1896.75,562.15L1896.75,562.75L1896.65,562.85L1896.35,562.55L1896.05,562.05L1896.05,561.75L1895.75,561.35L1895.35,561.05L1895.05,560.75L1894.55,560.15L1894.15,559.85L1893.85,558.95L1893.65,557.95L1893.45,557.25L1893.45,556.75L1893.35,556.35L1893.75,555.95L1893.65,555.65L1893.15,554.95L1893.05,554.65L1893.15,554.55L1893.55,554.65L1893.75,554.75L1894.05,554.45L1894.25,554.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1873.55,554.45L1873.35,554.05L1873.05,553.75L1873.45,553.75L1873.55,554.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1873.45,553.45L1873.85,553.55L1873.95,553.65L1874.05,554.15L1873.85,554.15L1873.65,553.75L1873.45,553.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1876.55,553.65L1876.45,553.95L1877.15,553.95L1877.55,554.65L1877.55,554.85L1877.75,555.15L1877.85,555.65L1877.65,555.85L1877.65,556.15L1877.05,555.95L1876.85,555.75L1876.55,555.75L1876.15,555.45L1876.05,555.25L1875.95,554.95L1876.35,555.05L1876.05,554.25L1875.95,554.05L1875.45,554.15L1875.25,554.25L1874.85,554.25L1874.55,554.65L1874.15,554.45L1874.15,553.85L1874.35,553.65L1874.75,553.65L1874.75,553.25L1875.15,552.65L1875.55,552.35L1875.85,552.15L1876.25,552.45L1876.45,552.85L1876.35,553.55L1876.55,553.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1870.65,553.65L1870.55,553.65L1870.35,552.85L1870.45,552.55L1870.45,552.15L1870.65,552.25L1870.75,552.65L1870.75,553.35L1870.65,553.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1874.05,553.15L1873.75,553.35L1873.65,553.25L1873.25,553.25L1872.95,552.95L1872.75,552.35L1872.85,552.05L1873.15,551.65L1873.65,551.45L1873.85,551.65L1874.15,552.15L1874.15,552.75L1874.05,553.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1871.05,549.65L1871.45,550.15L1871.45,550.25L1872.15,550.65L1872.05,550.95L1871.45,551.65L1871.45,551.95L1871.15,552.05L1871.15,551.65L1870.95,551.65L1870.95,551.25L1870.75,550.85L1870.45,550.65L1870.35,550.35L1870.45,550.05L1870.85,549.65L1871.05,549.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1881.35,549.75L1881.65,549.95L1881.45,550.05L1880.95,550.15L1880.85,549.85L1881.05,549.65L1881.35,549.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1882.25,549.75L1882.45,549.65L1882.95,549.95L1883.25,550.05L1883.45,550.25L1883.75,550.75L1884.05,550.85L1884.35,551.15L1884.35,551.45L1884.85,551.55L1884.85,551.85L1885.15,551.95L1885.45,551.85L1885.55,551.95L1885.95,552.15L1886.05,552.35L1886.35,552.25L1886.65,552.35L1886.75,552.65L1887.15,552.95L1887.45,553.25L1887.85,553.55L1888.85,554.55L1888.55,554.95L1888.85,555.45L1888.95,556.05L1888.65,555.95L1888.35,555.55L1887.65,554.75L1887.25,554.65L1886.75,554.25L1886.15,554.15L1886.05,553.85L1885.45,553.65L1884.95,553.15L1884.75,553.15L1883.95,552.55L1883.45,552.25L1883.45,552.05L1883.05,551.85L1882.85,551.65L1882.65,551.25L1882.25,550.95L1882.15,550.75L1882.15,550.35L1881.75,549.85L1881.55,549.75L1881.55,549.45L1882.25,549.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1880.75,549.15L1880.95,549.35L1881.15,549.25L1881.45,549.45L1881.35,549.65L1881.05,549.55L1880.75,549.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1876.25,548.55L1876.75,548.55L1876.55,548.75L1876.25,548.65L1876.25,548.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1880.55,548.55L1880.35,549.05L1880.25,548.85L1880.55,548.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1877.85,548.95L1877.35,549.05L1877.15,548.85L1877.45,548.45L1877.75,548.55L1877.85,548.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1865.35,548.05L1865.55,548.35L1865.35,548.55L1865.05,548.45L1864.95,548.35L1865.35,548.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1866.85,546.15L1867.15,546.35L1867.05,546.65L1866.35,546.85L1866.05,546.55L1866.35,545.95L1866.55,545.85L1866.85,546.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1868.55,545.25L1868.55,545.75L1868.35,545.55L1868.35,545.35L1868.55,545.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1871.45,543.75L1871.75,543.85L1872.15,544.35L1872.45,544.55L1872.75,544.65L1873.05,544.95L1873.85,545.35L1874.25,545.85L1874.25,546.25L1874.35,546.85L1874.85,547.35L1875.05,547.35L1875.15,547.75L1875.85,548.05L1876.25,547.95L1876.35,548.05L1876.35,548.35L1876.05,548.45L1875.85,548.75L1875.35,548.55L1874.55,548.15L1874.05,548.15L1873.75,547.75L1873.05,547.35L1871.85,545.35L1871.35,545.05L1870.65,544.35L1870.65,543.65L1870.95,543.45L1871.25,543.55L1871.45,543.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TV" transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1998.15,555.85L1998.15,555.65L1998.25,555.65L1998.25,555.75L1998.15,555.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1931.05,631.05L1930.55,630.85L1930.75,630.45L1931.25,630.35L1931.45,630.75L1931.35,630.95L1931.05,631.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1929.85,627.25L1929.65,627.25L1929.35,627.15L1928.95,626.65L1928.85,626.25L1928.85,625.85L1929.05,625.65L1929.15,625.25L1929.45,625.15L1929.85,625.15L1929.65,625.45L1929.65,625.95L1930.35,626.45L1930.05,626.75L1929.85,627.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1929.85,621.35L1930.15,621.35L1930.25,621.55L1929.75,621.65L1929.85,621.95L1930.25,622.15L1930.35,622.45L1930.25,622.85L1929.85,622.95L1929.45,622.65L1929.05,622.65L1928.85,622.45L1928.55,622.25L1928.65,621.85L1928.65,621.55L1928.85,621.05L1929.15,620.65L1929.65,620.65L1929.85,620.75L1929.75,621.15L1929.85,621.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1926.85,613.75L1927.45,613.65L1927.55,613.75L1927.75,614.35L1927.95,614.65L1928.05,614.75L1927.65,615.35L1926.85,615.55L1926.55,615.25L1926.45,614.75L1926.15,614.65L1925.75,614.95L1925.65,614.85L1925.85,614.45L1926.25,614.15L1926.65,613.65L1926.85,613.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1929.15,609.85L1929.05,609.55L1929.35,609.55L1929.15,609.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1927.55,607.45L1927.65,607.95L1927.65,608.15L1928.05,608.25L1928.25,608.75L1928.75,608.75L1928.75,609.15L1928.65,609.25L1928.35,608.95L1928.05,608.85L1927.45,609.05L1927.15,608.95L1927.05,608.75L1926.95,608.35L1927.15,607.85L1927.35,607.55L1927.55,607.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1928.45,607.25L1928.35,607.25L1928.25,606.95L1928.45,606.95L1928.45,607.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1928.65,605.85L1928.45,606.05L1927.85,606.05L1927.55,606.15L1927.35,605.95L1926.95,605.85L1926.45,605.45L1926.55,605.25L1927.05,605.05L1927.45,604.95L1927.85,604.65L1927.95,604.35L1928.15,604.35L1928.25,604.65L1928.25,605.25L1928.75,605.65L1928.65,605.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1923.95,604.55L1924.15,604.85L1924.75,605.25L1925.55,606.05L1925.55,606.45L1925.75,606.75L1925.45,606.95L1925.05,607.35L1925.05,607.15L1924.75,607.05L1924.35,607.05L1924.15,607.15L1924.15,607.35L1923.75,607.55L1923.45,607.45L1923.45,606.75L1923.35,606.15L1923.45,605.55L1923.55,605.05L1923.35,604.55L1922.75,604.85L1922.55,604.65L1922.45,604.35L1922.45,604.05L1922.75,603.75L1922.75,603.35L1922.85,603.05L1923.15,602.95L1923.75,603.25L1923.65,603.45L1923.85,603.95L1923.75,604.15L1923.95,604.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1923.35,602.15L1923.05,602.15L1922.55,601.85L1922.55,601.75L1922.75,601.45L1922.95,601.35L1923.45,601.45L1923.35,601.85L1923.35,602.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1922.85,601.15L1923.25,600.85L1923.35,600.95L1923.45,601.25L1922.95,601.25L1922.85,601.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1928.55,603.75L1928.35,603.65L1928.45,602.45L1928.35,602.15L1928.45,601.65L1928.75,600.85L1928.85,600.35L1929.05,600.95L1928.95,601.25L1928.95,602.85L1928.85,603.45L1928.55,603.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1927.25,600.45L1926.55,600.45L1926.25,600.35L1926.25,600.15L1927.15,599.45L1927.65,599.25L1928.15,599.15L1928.15,599.35L1927.85,599.75L1927.65,600.05L1927.25,600.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1929.15,599.75L1929.15,599.95L1928.85,599.95L1928.95,599.65L1929.15,598.35L1929.15,598.25L1929.25,597.05L1929.45,597.15L1929.35,598.45L1929.45,598.75L1929.35,599.25L1929.15,599.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1922.85,601.15L1921.95,601.05L1921.35,601.35L1921.25,601.55L1921.05,601.55L1920.95,600.95L1920.75,600.85L1920.35,599.85L1920.75,599.05L1920.75,598.65L1920.65,598.45L1920.65,597.05L1920.55,596.75L1920.55,596.25L1920.75,595.95L1920.75,595.65L1920.95,595.35L1920.95,595.15L1921.25,595.05L1921.35,595.55L1921.55,595.95L1921.75,596.25L1921.85,597.55L1921.75,598.35L1921.75,598.45L1922.35,598.35L1922.65,598.05L1922.85,597.25L1922.85,597.05L1923.15,596.85L1923.45,596.95L1923.35,597.35L1923.35,598.25L1923.65,598.35L1923.65,598.85L1923.45,598.95L1923.75,599.35L1923.55,599.55L1923.55,600.05L1923.75,600.55L1923.65,600.75L1923.35,600.75L1922.85,601.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1927.05,591.85L1927.45,592.15L1927.35,592.55L1926.85,593.05L1926.25,593.05L1926.25,592.65L1926.35,592.25L1926.55,591.95L1927.05,591.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1927.65,589.95L1927.35,590.15L1927.15,590.25L1927.15,590.45L1926.95,590.55L1926.95,590.25L1926.75,590.05L1926.65,589.75L1926.75,589.35L1927.35,589.05L1927.45,589.25L1927.55,589.65L1927.55,589.75L1927.65,589.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1922.65,585.75L1922.55,585.65L1922.65,585.15L1922.85,585.35L1922.65,585.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1988.35,624.15L1988.05,624.25L1988.15,623.85L1988.35,624.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1980.85,622.55L1981.05,622.75L1981.35,622.85L1981.35,623.15L1980.85,623.35L1980.35,623.05L1979.85,623.35L1979.55,623.35L1979.35,623.65L1979.45,623.95L1979.05,623.85L1978.95,624.05L1978.55,623.95L1978.45,624.05L1978.05,623.85L1978.35,623.75L1978.55,623.65L1978.75,623.45L1979.15,623.55L1979.45,623.25L1979.65,622.95L1980.15,622.85L1980.65,622.55L1980.85,622.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1981.75,622.45L1981.55,622.55L1981.35,622.45L1981.55,622.25L1981.75,622.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1987.65,616.35L1987.75,616.85L1987.55,617.45L1987.45,617.25L1987.35,616.85L1987.15,616.85L1987.25,616.35L1987.45,616.25L1987.65,616.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1985.05,614.95L1984.95,614.95L1984.85,614.55L1985.05,614.35L1985.45,614.25L1985.45,614.65L1985.25,614.85L1985.05,614.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1982.85,612.45L1982.75,612.85L1983.05,613.05L1983.15,613.35L1983.45,613.75L1983.75,613.85L1983.85,614.15L1984.05,614.15L1984.15,614.55L1983.85,615.05L1983.95,615.25L1984.05,615.75L1983.75,615.95L1983.75,616.45L1983.95,616.45L1984.05,616.95L1983.75,617.25L1983.15,617.45L1983.05,617.25L1982.75,617.35L1982.65,617.55L1982.35,617.25L1981.55,617.55L1980.75,618.25L1980.45,618.15L1980.05,618.35L1979.75,618.25L1979.15,618.35L1978.85,618.15L1977.65,617.75L1977.05,617.65L1976.85,617.55L1976.35,617.35L1976.15,616.35L1976.45,615.65L1976.75,615.65L1977.05,615.55L1977.15,615.05L1977.45,614.95L1977.55,614.55L1977.35,614.35L1977.95,613.95L1978.35,613.45L1978.45,613.55L1979.05,613.05L1979.25,613.05L1980.15,612.65L1980.75,612.85L1981.05,612.75L1981.55,612.55L1982.15,612.45L1982.45,612.15L1982.85,612.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1989.15,612.65L1988.95,612.75L1989.15,611.85L1989.55,611.85L1989.45,612.25L1989.15,612.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1977.75,610.65L1977.55,610.95L1977.05,611.25L1977.05,610.95L1977.45,610.55L1977.75,610.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1992.65,610.25L1992.45,610.05L1992.55,609.85L1993.05,609.35L1993.35,608.85L1993.05,609.95L1992.65,610.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.50334,0,0,8.50334,-15154.2,-3840.93)"><path d="M1993.65,605.25L1993.25,605.65L1992.45,606.75L1992.15,606.85L1991.45,607.25L1991.25,607.85L1990.85,608.05L1990.65,608.35L1990.55,608.55L1990.85,608.65L1991.45,608.35L1991.85,607.95L1992.05,607.65L1992.65,607.35L1992.95,607.05L1993.55,606.75L1993.55,607.05L1993.05,607.75L1992.85,607.85L1992.95,608.45L1992.65,608.75L1992.35,608.45L1991.95,608.45L1991.45,608.55L1991.05,608.85L1990.35,608.95L1989.35,608.95L1989.85,608.45L1989.45,608.25L1988.85,608.45L1988.45,608.65L1988.45,608.85L1988.15,608.95L1987.95,609.05L1987.85,609.45L1987.65,609.75L1987.35,609.65L1987.35,609.45L1986.95,609.35L1986.55,609.55L1986.35,610.05L1986.05,610.25L1985.75,610.25L1985.75,609.55L1985.55,609.15L1985.65,608.95L1985.55,608.85L1984.95,609.05L1984.95,608.65L1985.35,608.35L1985.45,608.35L1985.35,607.85L1985.65,607.75L1986.15,608.05L1986.75,607.65L1986.95,607.65L1987.25,607.35L1987.45,607.35L1987.75,607.05L1987.75,606.85L1988.55,606.75L1989.75,606.35L1990.15,606.45L1990.65,606.25L1990.85,605.85L1991.05,605.85L1991.25,605.45L1991.65,605.55L1991.75,605.35L1991.95,605.45L1992.95,604.95L1993.05,605.25L1993.25,605.15L1993.45,605.25L1993.75,604.95L1994.25,604.75L1994.35,604.85L1993.85,605.25L1993.65,605.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M118.05,378.55L116.95,379.65L115.75,378.75L116.35,376.95L115.95,374.55L116.45,373.85L117.65,372.85L117.55,371.55L117.95,370.95L118.35,371.05L120.25,372.15L121.15,372.75L121.85,373.55L122.75,375.85L122.55,376.15L120.05,377.55L118.05,378.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M117.35,368.55L115.35,368.95L114.75,367.65L114.25,367.15L114.25,366.75L114.95,366.15L116.75,366.75L117.95,367.75L117.35,368.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M114.35,365.15L114.05,365.85L111.05,365.65L111.65,364.85L114.35,365.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M109.65,364.15L109.25,364.55L108.85,364.45L106.95,364.25L106.65,362.75L106.45,362.55L108.15,361.65L108.55,362.05L109.65,364.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(8.38731,0,0,8.38731,1018.46,-2769.36)"><path d="M101.25,359.95L100.45,360.55L98.85,359.45L99.25,358.95L100.25,358.35L101.55,358.45L101.25,359.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), Pk = [
  Ok
];
function Zk(t, e) {
  return b(), _("svg", Tk, Pk);
}
const Ek = /* @__PURE__ */ K(Ik, [["render", Zk]]), Ak = {}, Nk = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, Hk = /* @__PURE__ */ O5('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M668.35,850.95L665.35,850.75L660.35,850.75L654.35,837.15L657.45,839.95L661.75,844.55L669.55,848.25L676.85,849.75L676.05,852.75L671.65,853.05L668.35,850.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M637.85,643.95L649.15,654.35L653.75,655.35L661.05,660.15L666.95,662.65L668.05,665.45L663.85,675.25L669.65,676.95L675.95,677.95L680.15,676.95L684.45,671.95L684.75,666.35L687.35,665.05L690.55,668.85L690.95,673.95L686.75,677.45L683.45,680.05L678.15,686.35L672.15,695.05L671.65,700.25L671.25,706.85L672.45,713.25L671.55,714.65L671.95,718.75L672.25,722.15L680.05,727.65L680.25,732.05L684.15,734.85L684.45,737.95L681.15,746.15L674.15,749.65L663.95,750.95L657.95,750.25L660.05,754.15L660.15,758.85L661.95,762.05L659.45,764.35L654.35,765.25L648.75,762.85L647.25,764.55L649.75,770.85L653.75,772.75L656.05,770.75L658.55,774.05L654.35,776.05L651.45,780.05L652.65,786.35L652.55,789.75L647.75,789.75L644.75,792.95L644.85,797.75L651.35,802.35L656.55,803.55L656.75,809.25L652.15,812.75L651.55,820.05L648.05,822.45L647.15,825.35L651.35,831.85L655.95,835.35L653.85,835.05L648.95,834.05L636.85,833.25L633.35,829.65L631.45,825.05L628.35,825.45L625.75,823.15L622.65,816.65L625.35,813.85L625.45,809.95L623.65,806.75L624.35,801.35L623.25,793.05L621.45,789.35L623.25,788.15L621.85,785.75L619.05,784.55L619.85,781.85L616.75,779.45L613.05,772.15L614.75,770.85L611.45,763.05L610.65,756.55L610.45,750.85L612.95,748.55L609.65,742.25L608.05,736.45L611.05,732.25L609.65,726.85L611.25,720.65L609.85,714.75L608.25,713.55L603.35,702.45L605.45,695.85L603.75,689.65L604.65,683.75L607.25,677.75L610.55,673.75L608.55,671.25L609.35,669.15L607.75,658.45L613.35,655.35L614.55,648.65L613.65,647.05L617.65,641.25L625.15,642.85L628.85,647.45L630.45,642.25L636.85,642.55L637.85,643.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BO" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M661.75,630.65L661.45,628.65L656.05,625.35L650.85,625.25L641.25,627.15L639.15,632.75L639.35,636.25L637.85,643.95L636.85,642.55L630.45,642.25L628.85,647.45L625.15,642.85L617.65,641.25L613.65,647.05L609.75,647.95L606.65,639.05L602.95,631.85L604.05,625.65L600.85,622.95L599.65,618.35L596.45,613.95L599.35,607.05L596.45,601.65L597.55,599.45L596.35,597.05L598.25,593.85L597.95,588.45L597.95,583.85L599.05,581.75L593.55,571.35L597.75,571.95L600.65,571.75L601.75,569.85L606.55,567.25L609.45,564.85L616.75,563.75L616.35,568.55L617.25,571.05L616.95,575.35L623.45,581.05L629.85,582.15L632.15,584.55L636.05,585.85L638.55,587.65L642.05,587.65L645.45,589.55L645.95,593.25L647.15,595.15L647.45,597.85L645.75,597.95L648.55,605.45L659.25,605.75L658.75,609.45L659.55,611.95L662.75,613.75L664.45,617.75L663.85,622.85L662.55,625.65L663.35,629.25L661.75,630.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BR" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M665.05,488.85L668.15,489.45L668.75,488.05L667.75,486.85L668.35,484.95L670.65,485.55L673.35,484.85L676.55,486.25L679.05,487.55L680.75,485.85L682.05,486.05L682.85,487.85L685.55,487.45L687.75,484.95L689.55,480.25L692.95,474.35L694.95,474.05L696.25,477.65L699.25,488.85L702.35,489.95L702.45,494.35L698.15,499.65L699.85,501.55L709.95,502.55L710.15,509.05L714.45,504.85L721.55,507.15L731.05,511.05L733.85,514.75L732.95,518.35L739.55,516.35L750.55,519.75L759.05,519.55L767.45,524.85L774.85,532.05L779.25,533.85L784.05,534.15L786.15,536.15L788.15,544.35L789.25,548.25L787.15,558.85L784.45,563.05L776.75,571.95L773.35,579.25L769.35,584.75L767.95,584.95L766.65,589.65L767.55,601.65L766.45,611.55L766.15,615.75L764.55,618.35L764.05,626.95L758.85,635.25L758.35,641.95L754.05,644.65L752.95,648.55L746.95,648.55L738.45,650.95L734.75,653.85L728.75,655.75L722.65,660.85L718.55,667.25L718.25,672.05L719.55,675.55L719.25,682.05L718.45,685.15L715.05,688.75L710.55,700.05L706.55,705.05L703.35,708.15L701.85,714.25L698.95,717.85L696.85,714.25L698.65,711.15L694.85,706.85L690.05,703.25L683.75,699.15L681.85,699.35L675.55,694.35L672.15,695.05L678.15,686.35L683.45,680.05L686.75,677.45L690.95,673.95L690.55,668.85L687.35,665.05L684.75,666.35L685.45,662.65L685.75,658.85L685.45,655.25L683.35,654.15L681.35,655.15L679.25,654.85L678.45,652.45L677.35,646.55L676.15,644.65L672.25,642.85L670.05,644.15L664.15,642.85L663.75,634.15L661.75,630.65L663.35,629.25L662.55,625.65L663.85,622.85L664.45,617.75L662.75,613.75L659.55,611.95L658.75,609.45L659.25,605.75L648.55,605.45L645.75,597.95L647.45,597.85L647.15,595.15L645.95,593.25L645.45,589.55L642.05,587.65L638.55,587.65L636.05,585.85L632.15,584.55L629.85,582.15L623.45,581.05L616.95,575.35L617.25,571.05L616.35,568.55L616.75,563.75L609.45,564.85L606.55,567.25L601.75,569.85L600.65,571.75L597.75,571.95L593.55,571.35L590.35,572.45L587.75,571.75L587.65,562.05L583.25,565.75L578.25,565.65L575.95,562.15L572.15,561.85L573.15,559.05L569.85,555.15L567.25,549.35L568.75,548.25L568.55,545.45L571.95,543.65L571.25,540.15L572.65,537.95L572.95,534.95L579.25,530.55L583.85,529.35L584.65,528.35L589.75,528.65L591.95,511.05L592.05,508.25L591.15,504.65L588.55,502.25L588.65,497.55L591.85,496.55L592.95,497.25L593.15,494.75L589.85,494.05L589.85,490.05L600.85,490.25L602.75,487.95L604.35,490.05L605.35,493.85L606.45,493.05L609.55,496.45L613.95,496.05L615.05,494.05L619.25,492.55L621.65,491.45L622.35,488.75L626.45,486.95L626.15,485.55L621.35,485.05L620.65,480.95L620.95,476.65L618.45,475.05L619.55,474.45L623.65,475.25L628.15,476.85L629.85,475.35L633.95,474.35L640.35,471.95L642.45,469.45L641.75,467.65L644.75,467.45L645.95,468.85L645.15,471.75L647.15,472.65L648.35,475.65L646.75,477.95L645.75,483.35L647.15,486.65L647.45,489.65L650.95,492.65L653.75,492.95L654.35,491.65L656.15,491.35L658.75,490.25L660.55,488.55L663.75,489.15L665.05,488.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CO" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M583.65,425.45L579.95,426.55L578.35,429.75L576.05,431.55L574.25,433.95L573.35,438.55L571.55,442.35L574.45,442.75L575.05,445.65L576.25,447.15L576.55,449.65L575.85,452.05L575.95,453.45L577.35,453.95L578.55,456.15L585.85,455.55L589.15,456.35L592.95,461.95L595.25,461.25L599.35,461.55L602.55,460.85L604.55,461.95L603.35,465.35L602.05,467.55L601.45,472.15L602.55,476.45L604.05,478.35L604.25,479.75L601.35,482.95L603.35,484.35L604.85,486.65L606.45,493.05L605.35,493.85L604.35,490.05L602.75,487.95L600.85,490.25L589.85,490.05L589.85,494.05L593.15,494.75L592.95,497.25L591.85,496.55L588.65,497.55L588.55,502.25L591.15,504.65L592.05,508.25L591.95,511.05L589.75,528.65L586.85,525.25L585.15,525.15L588.65,518.55L584.25,515.55L580.85,516.15L578.75,515.05L575.65,516.75L571.45,515.85L567.95,509.15L565.35,507.55L563.55,504.45L559.75,501.45L558.25,502.05L555.85,500.55L553.05,498.45L551.45,499.45L546.65,498.55L545.25,495.75L544.15,495.85L538.55,492.25L537.85,490.25L539.95,489.75L539.75,486.55L541.15,484.15L543.95,483.75L546.45,479.75L548.65,476.35L546.65,474.85L547.85,471.15L546.75,465.25L548.05,463.55L547.35,458.15L545.15,454.65L546.05,451.55L547.85,452.05L548.95,450.15L547.85,446.35L548.55,445.45L551.45,445.65L555.95,441.15L558.35,440.45L558.45,438.35L559.85,432.85L563.25,429.95L566.75,429.75L567.35,428.45L571.75,428.95L576.35,425.75L578.65,424.35L581.55,421.25L583.55,421.65L584.85,423.35L583.65,425.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EC" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M558.25,502.05L559.05,506.95L557.35,511.05L551.25,517.85L544.55,520.35L541.15,525.95L540.25,530.25L537.15,532.95L534.65,529.65L532.35,528.95L530.05,529.45L529.75,527.15L531.35,525.65L530.65,522.95L533.55,518.15L532.25,515.35L530.15,518.35L526.65,515.45L527.75,513.65L526.75,507.85L528.75,506.85L529.75,502.85L531.85,498.75L531.55,496.15L534.65,494.75L538.55,492.25L544.15,495.85L545.25,495.75L546.65,498.55L551.45,499.45L553.05,498.45L555.85,500.55L558.25,502.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GY" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M662.15,462.75L661.15,468.55L657.65,470.15L657.95,471.65L656.85,475.05L659.25,479.65L661.05,479.65L661.75,483.25L665.05,488.85L663.75,489.15L660.55,488.55L658.75,490.25L656.15,491.35L654.35,491.65L653.75,492.95L650.95,492.65L647.45,489.65L647.15,486.65L645.75,483.35L646.75,477.95L648.35,475.65L647.15,472.65L645.15,471.75L645.95,468.85L644.75,467.45L641.75,467.65L638.05,462.85L639.65,461.05L639.65,458.05L643.15,457.05L644.55,455.85L642.75,453.45L643.25,451.15L647.95,447.35L651.55,449.75L654.85,453.85L654.95,457.25L657.05,457.35L660.05,460.45L662.15,462.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PE" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M589.75,528.65L584.65,528.35L583.85,529.35L579.25,530.55L572.95,534.95L572.65,537.95L571.25,540.15L571.95,543.65L568.55,545.45L568.75,548.25L567.25,549.35L569.85,555.15L573.15,559.05L572.15,561.85L575.95,562.15L578.25,565.65L583.25,565.75L587.65,562.05L587.75,571.75L590.35,572.45L593.55,571.35L599.05,581.75L597.95,583.85L597.95,588.45L598.25,593.85L596.35,597.05L597.55,599.45L596.45,601.65L599.35,607.05L596.45,613.95L595.35,617.25L592.55,618.85L586.65,615.15L585.85,612.55L574.15,606.15L563.45,599.05L558.75,595.15L555.95,589.85L556.75,587.95L551.35,579.55L544.95,567.75L538.95,554.95L536.55,551.95L534.55,547.25L529.95,543.05L525.85,540.45L527.55,537.65L524.55,531.45L526.25,526.95L530.65,522.95L531.35,525.65L529.75,527.15L530.05,529.45L532.35,528.95L534.65,529.65L537.15,532.95L540.25,530.25L541.15,525.95L544.55,520.35L551.25,517.85L557.35,511.05L559.05,506.95L558.25,502.05L559.75,501.45L563.55,504.45L565.35,507.55L567.95,509.15L571.45,515.85L575.65,516.75L578.75,515.05L580.85,516.15L584.25,515.55L588.65,518.55L585.15,525.15L586.85,525.25L589.75,528.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PY" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M661.75,630.65L663.75,634.15L664.15,642.85L670.05,644.15L672.25,642.85L676.15,644.65L677.35,646.55L678.45,652.45L679.25,654.85L681.35,655.15L683.35,654.15L685.45,655.25L685.75,658.85L685.45,662.65L684.75,666.35L684.45,671.95L680.15,676.95L675.95,677.95L669.65,676.95L663.85,675.25L668.05,665.45L666.95,662.65L661.05,660.15L653.75,655.35L649.15,654.35L637.85,643.95L639.35,636.25L639.15,632.75L641.25,627.15L650.85,625.25L656.05,625.35L661.45,628.65L661.75,630.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SR" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M680.25,464.15L677.15,469.65L677.45,474.05L679.65,477.85L678.55,480.55L678.05,483.55L676.55,486.25L673.35,484.85L670.65,485.55L668.35,484.95L667.75,486.85L668.75,488.05L668.15,489.45L665.05,488.85L661.75,483.25L661.05,479.65L659.25,479.65L656.85,475.05L657.95,471.65L657.65,470.15L661.15,468.55L662.15,462.75L668.95,464.05L669.55,462.85L674.15,462.35L680.25,464.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UY" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M698.95,717.85L697.35,721.95L691.95,725.45L687.75,724.15L684.95,724.85L679.45,722.15L675.85,722.35L671.95,718.75L671.55,714.65L672.45,713.25L671.25,706.85L671.65,700.25L672.15,695.05L675.55,694.35L681.85,699.35L683.75,699.15L690.05,703.25L694.85,706.85L698.65,711.15L696.85,714.25L698.95,717.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VE" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M647.95,447.35L643.25,451.15L642.75,453.45L644.55,455.85L643.15,457.05L639.65,458.05L639.65,461.05L638.05,462.85L641.75,467.65L642.45,469.45L640.35,471.95L633.95,474.35L629.85,475.35L628.15,476.85L623.65,475.25L619.55,474.45L618.45,475.05L620.95,476.65L620.65,480.95L621.35,485.05L626.15,485.55L626.45,486.95L622.35,488.75L621.65,491.45L619.25,492.55L615.05,494.05L613.95,496.05L609.55,496.45L606.45,493.05L604.85,486.65L603.35,484.35L601.35,482.95L604.25,479.75L604.05,478.35L602.55,476.45L601.45,472.15L602.05,467.55L603.35,465.35L604.55,461.95L602.55,460.85L599.35,461.55L595.25,461.25L592.95,461.95L589.15,456.35L585.85,455.55L578.55,456.15L577.35,453.95L575.95,453.45L575.85,452.05L576.55,449.65L576.25,447.15L575.05,445.65L574.45,442.75L571.55,442.35L573.35,438.55L574.25,433.95L576.05,431.55L578.35,429.75L579.95,426.55L583.65,425.45L583.45,426.95L580.05,427.75L581.75,430.65L581.45,434.05L578.75,437.75L580.65,442.85L583.15,442.45L584.65,437.75L582.95,435.55L582.95,430.65L590.15,428.05L589.55,425.05L591.65,422.95L593.35,427.55L597.35,427.65L600.75,431.15L600.95,433.35L605.95,433.35L612.05,432.75L615.15,435.55L619.35,436.35L622.65,434.35L622.75,432.75L629.85,432.35L636.55,432.25L631.65,434.15L633.45,437.25L637.95,437.65L642.15,440.85L642.85,445.95L645.75,445.85L647.95,447.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M654.35,837.15L660.35,850.75L665.35,850.75L668.35,850.95L667.85,853.35L664.65,855.25L662.25,855.05L659.15,854.55L654.95,852.75L649.55,851.85L642.05,848.45L635.65,845.25L625.85,838.35L630.45,839.65L639.05,843.75L646.35,845.95L647.55,843.15L647.25,838.95L650.65,836.35L654.35,837.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M613.65,647.05L614.55,648.65L613.35,655.35L607.75,658.45L609.35,669.15L608.55,671.25L610.55,673.75L607.25,677.75L604.65,683.75L603.75,689.65L605.45,695.85L603.35,702.45L608.25,713.55L609.85,714.75L611.25,720.65L609.65,726.85L611.05,732.25L608.05,736.45L609.65,742.25L612.95,748.55L610.45,750.85L610.65,756.55L611.45,763.05L614.75,770.85L613.05,772.15L616.75,779.45L619.85,781.85L619.05,784.55L621.85,785.75L623.25,788.15L621.45,789.35L623.25,793.05L624.35,801.35L623.65,806.75L625.45,809.95L625.35,813.85L622.65,816.65L625.75,823.15L628.35,825.45L631.45,825.05L633.35,829.65L636.85,833.25L648.95,834.05L653.85,835.05L649.55,835.05L647.85,836.55L644.45,838.75L646.15,844.45L644.25,844.55L637.95,842.65L630.45,838.35L622.85,834.85L619.65,830.95L619.35,827.35L615.15,823.15L610.15,812.55L609.95,806.55L613.35,801.75L605.05,799.85L607.75,794.35L605.75,783.85L612.25,786.05L610.45,772.95L606.45,771.25L607.45,779.15L603.95,778.25L602.45,769.25L600.45,757.45L601.55,753.05L598.25,746.85L595.85,739.65L598.05,739.35L598.65,729.05L599.85,718.75L599.95,709.25L596.65,699.55L597.25,694.25L595.15,686.35L596.95,678.55L596.05,666.15L596.05,652.75L596.15,638.45L594.65,627.95L592.55,618.85L595.35,617.25L596.45,613.95L599.65,618.35L600.85,622.95L604.05,625.65L602.95,631.85L606.65,639.05L609.75,647.95L613.65,647.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GF" transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M676.55,486.25L678.05,483.45L678.55,480.55L679.55,477.85L677.45,474.05L677.15,469.65L680.25,464.15L682.15,464.85L686.25,466.35L692.15,471.75L692.95,474.35L689.55,480.25L687.75,484.95L685.55,487.45L682.85,487.85L682.05,486.05L680.75,485.85L679.05,487.55L676.55,486.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M692.95,831.05L692.55,830.85L692.05,830.55L691.25,830.25L691.35,829.85L690.65,829.75L690.35,829.65L690.05,829.25L690.25,829.15L691.05,829.45L691.85,829.85L692.35,829.95L692.75,830.05L693.05,829.75L693.15,829.45L693.35,829.55L693.75,829.35L693.85,829.55L694.35,829.55L694.35,829.85L694.65,829.85L695.55,829.65L695.65,829.85L695.95,829.85L696.35,829.75L696.05,829.55L695.95,829.25L696.35,829.25L696.95,829.45L697.05,829.85L696.65,830.35L696.75,830.65L696.55,830.85L696.15,830.85L695.85,831.65L695.55,831.95L695.25,832.55L695.15,832.85L694.65,833.15L694.55,832.95L694.15,832.95L694.15,833.25L693.35,833.15L693.25,833.25L693.55,833.65L693.45,833.75L693.25,834.15L692.85,834.15L692.55,834.55L692.25,834.65L692.05,834.65L691.85,834.35L691.45,834.05L691.45,833.85L690.95,833.85L691.55,834.25L691.15,834.25L690.65,833.95L690.05,833.65L689.75,833.45L689.75,833.25L690.45,833.45L691.05,833.25L690.55,833.05L690.45,832.95L691.35,832.95L691.75,833.05L692.05,833.25L692.05,833.05L692.45,832.95L692.55,832.65L692.15,832.45L691.95,831.95L692.05,831.75L692.65,831.75L692.85,831.85L693.25,831.75L693.15,831.45L692.35,831.45L692.35,831.55L691.95,831.75L691.35,831.75L690.85,831.45L690.85,831.15L691.55,831.35L692.15,831.15L692.45,831.15L692.95,831.05L693.35,831.25L693.35,831.15L692.95,831.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(4.71889,0,0,4.71889,-2075.84,-1987.83)"><path d="M699.35,829.05L699.95,829.05L700.05,828.95L700.55,828.85L700.95,829.05L701.35,829.35L701.45,829.65L701.45,829.75L700.95,829.85L700.75,829.55L700.55,829.45L700.45,829.75L700.65,829.85L700.75,830.15L701.05,829.95L701.25,830.05L701.35,830.45L701.65,830.55L701.75,830.45L702.25,830.75L702.35,830.35L701.55,830.15L701.65,829.65L701.95,829.45L703.45,829.35L704.15,829.95L704.35,830.05L704.35,830.45L703.75,830.35L703.25,830.15L702.65,830.35L702.95,830.55L703.35,830.65L704.25,830.75L704.55,830.85L704.65,831.05L704.45,831.55L703.95,831.55L703.85,831.65L703.15,831.75L702.65,831.95L702.95,832.15L702.05,832.55L701.65,832.45L701.15,832.55L700.45,832.55L699.85,832.35L699.25,831.95L699.25,832.25L699.55,832.45L700.15,832.65L700.45,832.95L700.65,832.85L701.05,832.95L701.45,833.25L701.25,833.35L701.45,833.85L701.25,833.85L700.95,833.55L700.55,833.45L700.05,833.85L699.85,833.55L699.55,833.35L699.25,833.35L698.75,833.15L698.55,833.25L698.75,833.65L699.05,833.65L699.25,833.85L699.05,833.95L699.75,834.55L699.55,834.65L699.15,834.45L698.85,834.45L698.55,834.15L697.95,833.95L697.85,834.55L698.35,834.65L698.35,834.95L698.25,835.15L697.85,835.05L697.75,834.85L697.25,834.65L697.15,834.45L696.95,834.45L696.55,833.95L696.85,833.55L696.85,833.35L696.45,832.85L696.45,832.65L696.95,832.45L696.85,832.25L697.35,832.15L697.25,831.85L697.85,831.45L698.45,831.25L698.85,831.65L698.85,832.05L699.15,831.95L698.65,831.35L698.75,831.05L698.15,830.85L697.75,830.55L697.85,830.35L698.25,830.55L698.35,830.05L697.65,829.85L697.75,829.55L697.95,829.65L698.25,829.45L698.55,829.45L698.75,829.15L698.45,828.85L698.85,828.85L699.35,829.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), Bk = [
  Hk
];
function Vk(t, e) {
  return b(), _("svg", Nk, Bk);
}
const Rk = /* @__PURE__ */ K(Ak, [["render", Vk]]), Yk = {}, Fk = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, jk = /* @__PURE__ */ O5('<g transform="matrix(0.32,0,0,0.32,0,0)"><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1666.75,566.85L1664.35,566.95L1657.25,562.45L1662.65,561.15L1665.45,563.15L1667.25,565.05L1666.75,566.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1691.55,558.15L1692.05,559.45L1691.95,561.35L1687.85,566.15L1682.85,567.55L1682.25,566.85L1682.95,564.65L1685.75,560.75L1691.55,558.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1651.95,553.05L1653.85,554.75L1657.45,554.25L1658.65,556.95L1651.95,558.25L1648.05,559.15L1644.95,559.05L1647.15,555.35L1650.35,555.35L1651.95,553.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1680.25,553.05L1679.15,556.65L1670.55,558.45L1663.05,557.65L1663.25,555.25L1667.85,553.95L1671.25,555.85L1675.05,555.35L1680.25,553.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1600.05,544.55L1610.85,545.25L1612.25,542.55L1622.55,545.65L1624.35,549.85L1632.75,551.05L1639.45,554.85L1632.85,557.25L1626.75,554.65L1621.65,554.85L1615.85,554.35L1610.65,553.25L1604.25,550.75L1600.15,550.15L1597.75,550.95L1587.55,548.25L1586.75,545.55L1581.65,545.05L1585.85,538.95L1592.65,539.35L1597.05,541.85L1599.45,542.35L1600.05,544.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1747.95,540.95L1744.75,545.35L1744.55,540.55L1745.65,538.25L1746.95,536.05L1748.15,537.95L1747.95,540.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1706.55,523.25L1704.35,525.45L1700.55,524.25L1699.55,521.45L1705.25,521.15L1706.55,523.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1724.95,520.95L1726.75,525.85L1722.15,523.15L1717.45,522.65L1714.15,523.05L1710.25,522.85L1711.75,519.35L1718.75,519.05L1724.95,520.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1784.75,517.75L1783.75,538.65L1782.15,559.65L1777.55,554.35L1771.95,553.05L1770.45,554.85L1763.25,555.05L1766.05,549.85L1769.75,548.05L1768.75,541.05L1766.45,535.75L1755.75,530.25L1751.15,529.75L1742.85,523.75L1741.05,526.95L1738.85,527.45L1737.75,525.15L1737.85,522.35L1733.65,519.15L1739.85,516.85L1743.85,516.95L1743.45,515.25L1735.15,515.25L1732.95,511.45L1727.95,510.25L1725.65,507.05L1733.25,505.55L1736.15,503.45L1745.25,506.05L1746.15,508.45L1747.45,518.85L1753.15,522.65L1758.15,515.85L1764.75,512.05L1769.75,512.05L1774.55,514.25L1778.65,516.55L1784.75,517.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1695.65,491.95L1691.15,498.35L1686.85,499.55L1681.45,498.35L1671.95,498.65L1667.05,499.55L1666.25,504.45L1671.25,510.15L1674.35,507.25L1684.95,505.05L1684.45,507.95L1681.95,507.05L1679.45,510.85L1674.35,513.35L1679.45,521.55L1678.35,523.75L1683.15,531.15L1682.85,535.35L1679.75,537.25L1677.65,534.95L1680.65,529.75L1674.95,532.25L1673.65,530.45L1674.45,527.95L1670.55,524.15L1671.25,517.95L1667.35,519.85L1667.55,527.35L1667.35,536.55L1663.65,537.45L1661.35,535.65L1663.25,529.75L1662.65,523.55L1660.25,523.45L1658.65,519.05L1661.15,514.85L1662.05,509.75L1665.05,500.05L1666.15,497.45L1670.95,492.65L1675.45,494.55L1682.55,495.45L1689.05,495.15L1694.65,490.55L1695.65,491.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1715.25,493.85L1714.95,499.45L1712.05,498.75L1711.15,502.65L1713.45,506.05L1711.85,506.85L1709.65,502.75L1707.95,494.55L1708.95,489.45L1710.75,487.15L1711.25,490.65L1714.65,491.15L1715.25,493.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1607.25,488.15L1608.25,492.45L1612.15,496.15L1615.85,494.85L1619.45,495.25L1622.75,492.05L1625.45,491.45L1630.85,493.25L1635.45,491.85L1638.05,482.95L1640.15,480.75L1641.85,473.45L1648.35,473.45L1653.35,474.55L1650.35,480.35L1654.75,486.35L1653.85,489.35L1660.25,495.25L1653.55,496.05L1651.75,500.45L1651.95,506.25L1646.45,510.65L1646.05,517.05L1643.55,526.85L1642.85,524.55L1636.25,527.45L1634.15,523.55L1630.15,523.15L1627.35,521.05L1620.55,523.45L1618.65,520.25L1614.85,520.65L1610.25,519.95L1609.65,511.35L1606.85,509.55L1604.15,504.05L1603.35,498.45L1603.95,492.45L1607.25,488.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1584.45,538.65L1578.25,538.75L1573.75,533.45L1566.65,528.15L1564.35,524.25L1560.25,519.05L1557.55,514.25L1553.35,505.25L1548.45,499.85L1546.75,494.35L1544.55,489.35L1539.35,485.35L1536.25,479.85L1531.85,476.25L1525.65,469.15L1525.05,465.85L1528.65,466.15L1537.55,467.35L1542.75,473.65L1547.35,478.05L1550.55,480.65L1556.05,487.55L1561.85,487.65L1566.65,492.05L1570.05,497.45L1574.35,500.45L1572.05,505.65L1575.35,507.85L1577.35,508.05L1578.25,512.55L1580.15,516.05L1584.25,516.65L1586.85,520.75L1585.15,528.75L1584.45,538.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KH" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1589.05,409.85L1590.85,414.15L1590.95,421.85L1581.95,426.85L1584.75,430.65L1578.85,431.15L1574.25,433.75L1569.45,432.85L1566.85,429.45L1563.35,422.85L1561.25,415.05L1564.35,409.75L1571.45,408.55L1576.75,409.45L1581.75,411.95L1583.75,407.55L1589.05,409.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LA" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1589.05,409.85L1583.75,407.55L1581.75,411.95L1576.75,409.45L1578.25,406.55L1577.85,401.15L1572.55,395.55L1571.25,389.15L1566.25,383.95L1561.95,383.55L1561.15,385.75L1557.95,385.95L1556.05,384.85L1550.75,388.65L1549.75,382.85L1550.15,376.15L1546.35,375.85L1545.45,371.95L1542.75,369.95L1543.55,367.65L1547.65,363.45L1548.45,364.95L1551.45,365.15L1549.45,357.75L1552.15,356.85L1556.15,361.95L1559.65,367.75L1566.45,367.75L1569.45,373.35L1566.15,375.05L1564.95,377.35L1572.25,381.25L1577.95,388.85L1582.35,394.45L1587.25,398.95L1589.25,403.45L1589.05,409.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MM" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1547.65,363.45L1543.55,367.65L1542.75,369.95L1539.75,371.45L1536.95,374.25L1533.05,374.55L1531.55,381.45L1529.35,382.65L1532.85,388.25L1536.95,392.95L1539.85,397.25L1538.45,402.75L1536.65,403.95L1538.45,407.15L1542.75,412.25L1543.75,415.85L1543.95,418.85L1546.65,424.75L1544.05,430.75L1541.85,437.35L1540.95,432.55L1542.25,427.65L1540.05,423.85L1539.85,416.85L1537.25,413.45L1534.55,405.85L1532.55,397.75L1529.45,392.35L1526.25,395.65L1520.45,400.15L1517.15,399.65L1513.55,398.15L1514.45,390.15L1512.45,384.15L1507.15,376.75L1507.45,374.45L1504.05,373.55L1499.45,368.35L1498.35,363.15L1500.45,364.15L1499.85,359.55L1502.35,358.05L1501.35,355.35L1502.35,353.15L1501.45,346.45L1506.05,347.95L1507.65,342.65L1507.35,339.55L1509.35,334.15L1508.45,330.45L1514.65,326.05L1518.85,327.15L1517.45,323.25L1519.15,322.05L1518.15,319.65L1521.25,319.15L1523.95,322.95L1526.65,324.45L1527.95,329.35L1528.85,334.65L1524.65,340.05L1525.35,347.65L1530.95,346.55L1533.35,352.45L1537.05,353.75L1536.25,359.05L1540.75,361.45L1543.35,362.65L1547.15,360.75L1547.65,363.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1563.55,461.15L1564.95,461.75L1568.45,465.65L1570.95,469.95L1571.55,474.25L1571.05,477.15L1571.65,479.35L1572.15,483.15L1574.25,484.95L1576.55,490.65L1576.55,492.75L1572.55,493.25L1567.05,488.45L1560.25,483.35L1559.45,480.05L1556.05,475.75L1555.05,470.45L1552.85,466.95L1553.25,462.25L1551.85,459.55L1552.75,458.45L1557.55,461.25L1558.15,464.55L1561.85,463.75L1563.55,461.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1653.35,474.55L1648.35,473.45L1641.85,473.45L1640.15,480.75L1638.05,482.95L1635.45,491.85L1630.85,493.25L1625.45,491.45L1622.75,492.05L1619.45,495.25L1615.85,494.85L1612.15,496.15L1608.25,492.45L1607.25,488.15L1611.45,490.35L1615.75,489.15L1616.75,483.75L1619.15,482.55L1625.95,481.15L1629.75,476.05L1632.35,472.05L1635.15,475.35L1636.25,473.15L1638.95,473.35L1639.05,469.25L1639.15,466.05L1643.25,461.65L1645.85,456.65L1648.15,456.55L1651.25,459.85L1651.65,462.65L1655.45,464.45L1660.25,466.35L1660.05,468.85L1656.25,469.15L1657.35,472.35L1653.35,474.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1699.75,447.05L1700.65,451.35L1701.25,454.95L1699.65,460.75L1697.15,454.25L1694.75,457.55L1696.85,462.25L1695.45,465.25L1688.55,461.55L1686.65,456.85L1688.15,453.85L1684.35,450.75L1682.75,453.45L1680.15,453.15L1676.15,456.75L1675.15,454.85L1676.95,449.45L1680.35,447.65L1683.25,445.25L1685.45,448.15L1689.65,446.45L1690.35,443.55L1694.35,443.35L1693.55,438.45L1698.45,441.45L1699.15,444.65L1699.75,447.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1685.15,435.05L1683.35,437.15L1681.95,441.25L1680.35,443.15L1676.45,438.75L1677.45,436.95L1678.75,435.15L1678.95,431.25L1682.05,430.85L1681.55,435.15L1685.15,428.95L1685.15,435.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1654.85,441.25L1647.75,447.35L1650.15,442.85L1653.95,438.85L1656.95,434.45L1659.25,428.05L1660.85,433.35L1657.35,436.85L1654.85,441.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1672.35,424.75L1675.95,426.75L1679.45,426.75L1679.65,429.35L1677.35,432.15L1673.95,434.05L1673.45,431.05L1673.55,427.75L1672.35,424.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1692.45,422.95L1694.85,430.15L1690.35,428.45L1690.65,430.65L1692.45,434.55L1689.85,436.05L1689.25,431.45L1687.45,431.15L1686.25,427.25L1689.55,427.75L1689.25,425.35L1685.25,420.45L1690.65,420.55L1692.45,422.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1669.45,417.15L1668.55,422.75L1665.85,419.55L1662.35,414.65L1667.15,414.85L1669.45,417.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1662.95,382.25L1666.75,384.15L1668.15,382.45L1668.95,384.05L1668.55,386.75L1671.15,391.35L1670.55,396.65L1667.65,398.75L1667.55,403.95L1669.55,409.05L1672.55,409.75L1674.95,409.05L1682.45,412.55L1682.35,416.05L1684.45,417.65L1684.15,420.55L1679.45,417.45L1676.95,414.05L1675.75,416.45L1671.75,412.55L1666.75,413.55L1663.75,412.15L1663.65,409.45L1665.25,407.85L1663.35,406.35L1662.95,408.65L1659.65,404.95L1658.35,402.15L1657.25,396.05L1659.85,398.15L1658.75,388.05L1659.55,382.25L1662.95,382.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TH" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1576.75,409.45L1571.45,408.55L1564.35,409.75L1561.25,415.05L1563.35,422.85L1558.05,419.85L1553.25,420.05L1553.55,414.95L1548.65,414.95L1548.85,422.05L1546.65,431.45L1545.25,437.15L1545.95,441.75L1549.65,441.95L1552.35,447.85L1553.65,453.35L1557.05,457.05L1560.45,457.75L1563.55,461.15L1561.85,463.75L1558.15,464.55L1557.55,461.25L1552.75,458.45L1551.85,459.55L1549.55,457.15L1548.35,453.95L1545.15,450.35L1542.25,447.25L1541.55,451.05L1540.25,447.45L1540.65,443.45L1541.85,437.35L1544.05,430.75L1546.65,424.75L1543.95,418.85L1543.75,415.85L1542.75,412.25L1538.45,407.15L1536.65,403.95L1538.45,402.75L1539.85,397.25L1536.95,392.95L1532.85,388.25L1529.35,382.65L1531.55,381.45L1533.05,374.55L1536.95,374.25L1539.75,371.45L1542.75,369.95L1545.45,371.95L1546.35,375.85L1550.15,376.15L1549.75,382.85L1550.75,388.65L1556.05,384.85L1557.95,385.95L1561.15,385.75L1561.95,383.55L1566.25,383.95L1571.25,389.15L1572.55,395.55L1577.85,401.15L1578.25,406.55L1576.75,409.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TL" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1691.95,561.35L1692.05,559.45L1691.55,558.15L1692.35,556.65L1697.25,555.25L1701.25,554.95L1703.05,554.15L1705.15,554.95L1702.95,556.75L1696.85,559.55L1691.95,561.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VN" transform="matrix(7.15084,0,0,7.15084,-10714.5,-2146.32)"><path d="M1585.75,362.75L1579.25,368.15L1575.55,374.25L1574.95,378.75L1580.25,385.45L1586.75,393.85L1592.45,397.85L1596.55,402.95L1600.55,414.85L1600.95,426.15L1596.65,430.35L1590.55,434.55L1586.35,439.85L1579.75,445.85L1577.45,441.75L1578.65,437.35L1574.25,433.75L1578.85,431.15L1584.75,430.65L1581.95,426.85L1590.95,421.85L1590.85,414.15L1589.05,409.85L1589.25,403.45L1587.25,398.95L1582.35,394.45L1577.95,388.85L1572.25,381.25L1564.95,377.35L1566.15,375.05L1569.45,373.35L1566.45,367.75L1559.65,367.75L1556.15,361.95L1552.15,356.85L1554.85,355.25L1559.25,355.35L1564.55,354.55L1568.65,351.15L1571.75,353.55L1577.05,354.75L1576.75,358.45L1579.85,361.05L1585.75,362.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), Wk = [
  jk
];
function Uk(t, e) {
  return b(), _("svg", Fk, Wk);
}
const Gk = /* @__PURE__ */ K(Yk, [["render", Uk]]), Kk = {}, qk = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 656 656",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xml:space": "preserve",
  "xmlns:serif": "http://www.serif.com/",
  style: { "fill-rule": "evenodd", "clip-rule": "evenodd", "stroke-linecap": "round", "stroke-linejoin": "round" }
}, Xk = /* @__PURE__ */ O5('<g transform="matrix(0.32,0,0,0.32,0,0)"><g id="AF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1382.25,260.85L1383.75,262.65L1380.85,263.45L1378.45,264.55L1372.55,265.35L1367.25,266.65L1364.85,269.45L1366.75,272.15L1368.15,275.35L1366.15,278.05L1366.95,280.55L1366.05,282.85L1360.85,282.65L1363.95,286.85L1360.85,288.55L1359.45,292.35L1360.55,296.25L1358.75,298.05L1356.65,297.45L1352.65,298.35L1352.45,300.05L1348.35,300.05L1346.05,303.75L1346.85,309.15L1340.25,311.85L1336.35,311.25L1335.45,312.65L1332.05,311.85L1326.75,312.85L1317.15,309.55L1321.05,303.75L1319.95,299.65L1315.65,298.55L1314.45,294.45L1311.75,289.35L1313.35,285.85L1310.85,284.85L1311.35,280.15L1311.95,272.15L1317.85,274.65L1321.75,273.75L1322.15,270.85L1326.15,269.95L1328.75,267.95L1328.55,262.85L1332.75,261.55L1333.05,259.35L1335.95,261.05L1337.55,261.25L1340.55,261.25L1344.85,262.65L1346.65,263.35L1350.05,261.35L1352.15,262.55L1353.05,259.65L1356.25,259.75L1356.85,258.85L1356.65,256.25L1358.35,254.05L1361.65,255.45L1361.55,257.45L1363.25,257.75L1364.15,263.15L1366.85,265.25L1368.35,263.85L1370.55,263.25L1373.05,260.35L1376.85,260.85L1382.25,260.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1120.45,571.25L1121.05,573.25L1120.35,576.35L1121.25,579.35L1120.35,581.75L1120.75,583.95L1109.05,583.85L1108.25,604.35L1111.85,609.55L1115.45,613.55L1105.05,616.15L1091.55,615.25L1087.75,612.25L1065.05,612.45L1064.25,612.95L1060.95,610.05L1057.35,609.85L1053.95,610.95L1051.25,612.15L1050.75,608.15L1051.65,602.45L1053.65,596.55L1053.95,593.85L1055.85,588.05L1057.25,585.45L1060.55,581.25L1062.45,578.35L1063.05,573.65L1062.75,569.95L1061.15,567.65L1059.65,563.75L1058.35,559.95L1058.65,558.55L1060.35,556.05L1058.75,549.85L1057.55,545.55L1054.75,541.45L1055.35,540.25L1057.65,539.35L1059.35,539.45L1061.35,538.75L1078.05,538.85L1079.35,543.55L1080.95,547.45L1082.25,549.55L1084.35,552.85L1088.15,552.35L1089.95,551.45L1093.05,552.35L1093.95,550.75L1095.45,547.05L1098.95,546.75L1099.25,545.65L1102.15,545.65L1101.65,547.95L1108.45,547.85L1108.55,551.95L1109.65,554.35L1108.75,558.25L1109.15,562.25L1110.95,564.65L1110.55,572.25L1111.95,571.65L1114.35,571.85L1117.85,570.85L1120.45,571.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1054.55,538.25L1053.05,533.45L1055.35,530.65L1057.05,529.55L1059.15,531.75L1057.15,533.15L1056.15,534.75L1055.95,537.55L1054.55,538.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1087.25,227.25L1087.65,228.45L1089.05,227.85L1090.25,229.55L1091.55,230.25L1092.15,232.55L1091.65,234.75L1092.65,237.45L1094.95,238.95L1095.05,240.65L1093.35,241.55L1093.25,243.65L1091.05,246.75L1090.15,246.35L1089.95,244.95L1086.85,242.75L1086.15,239.75L1086.25,235.35L1086.75,233.45L1085.85,232.45L1085.35,230.35L1087.25,227.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1295.45,335.95L1296.75,341.05L1293.95,341.05L1293.95,345.25L1295.05,346.15L1292.65,347.45L1292.85,350.05L1291.55,352.65L1291.55,355.25L1290.55,356.65L1273.65,353.45L1270.95,346.85L1270.65,345.45L1271.55,345.05L1271.95,346.85L1276.15,345.85L1280.75,346.05L1284.15,346.25L1287.45,341.85L1291.15,337.75L1294.15,333.75L1295.45,335.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M668.35,850.95L665.35,850.75L660.35,850.75L654.35,837.15L657.45,839.95L661.75,844.55L669.55,848.25L676.85,849.75L676.05,852.75L671.65,853.05L668.35,850.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M637.85,643.95L649.15,654.35L653.75,655.35L661.05,660.15L666.95,662.65L668.05,665.45L663.85,675.25L669.65,676.95L675.95,677.95L680.15,676.95L684.45,671.95L684.75,666.35L687.35,665.05L690.55,668.85L690.95,673.95L686.75,677.45L683.45,680.05L678.15,686.35L672.15,695.05L671.65,700.25L671.25,706.85L672.45,713.25L671.55,714.65L671.95,718.75L672.25,722.15L680.05,727.65L680.25,732.05L684.15,734.85L684.45,737.95L681.15,746.15L674.15,749.65L663.95,750.95L657.95,750.25L660.05,754.15L660.15,758.85L661.95,762.05L659.45,764.35L654.35,765.25L648.75,762.85L647.25,764.55L649.75,770.85L653.75,772.75L656.05,770.75L658.55,774.05L654.35,776.05L651.45,780.05L652.65,786.35L652.55,789.75L647.75,789.75L644.75,792.95L644.85,797.75L651.35,802.35L656.55,803.55L656.75,809.25L652.15,812.75L651.55,820.05L648.05,822.45L647.15,825.35L651.35,831.85L655.95,835.35L653.85,835.05L648.95,834.05L636.85,833.25L633.35,829.65L631.45,825.05L628.35,825.45L625.75,823.15L622.65,816.65L625.35,813.85L625.45,809.95L623.65,806.75L624.35,801.35L623.25,793.05L621.45,789.35L623.25,788.15L621.85,785.75L619.05,784.55L619.85,781.85L616.75,779.45L613.05,772.15L614.75,770.85L611.45,763.05L610.65,756.55L610.45,750.85L612.95,748.55L609.65,742.25L608.05,736.45L611.05,732.25L609.65,726.85L611.25,720.65L609.85,714.75L608.25,713.55L603.35,702.45L605.45,695.85L603.75,689.65L604.65,683.75L607.25,677.75L610.55,673.75L608.55,671.25L609.35,669.15L607.75,658.45L613.35,655.35L614.55,648.65L613.65,647.05L617.65,641.25L625.15,642.85L628.85,647.45L630.45,642.25L636.85,642.55L637.85,643.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1230.05,252.25L1228.25,252.45L1225.45,248.75L1225.25,247.75L1222.95,247.75L1221.05,246.05L1220.05,246.15L1217.65,244.35L1213.45,242.75L1213.35,239.65L1212.05,237.45L1219.05,236.45L1220.45,238.05L1222.65,239.15L1221.95,240.75L1225.15,242.95L1224.05,245.05L1226.65,246.75L1229.15,247.75L1230.05,252.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1742.25,762.85L1745.95,765.05L1749.25,764.15L1754.15,762.95L1756.95,763.35L1752.45,770.95L1749.15,773.05L1745.15,778.25L1744.55,776.45L1737.95,780.85L1737.15,780.55L1734.15,780.35L1734.65,774.95L1736.65,770.75L1737.25,765.15L1739.25,762.25L1742.25,762.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1792.75,589.45L1793.95,594.45L1797.95,592.05L1799.35,594.75L1801.65,597.25L1800.55,600.15L1800.75,605.65L1800.95,608.85L1802.25,609.65L1802.65,615.15L1801.45,618.45L1802.25,622.75L1807.65,626.15L1810.85,629.15L1814.05,631.95L1812.95,633.55L1815.25,637.55L1815.75,644.55L1818.35,643.15L1819.85,645.85L1821.45,644.95L1820.75,651.75L1823.65,655.65L1825.55,658.05L1828.35,663.25L1828.35,668.45L1827.35,672.15L1825.55,676.05L1826.25,681.55L1823.75,687.25L1821.65,690.25L1817.85,695.95L1816.35,699.65L1813.25,704.25L1808.25,710.05L1802.75,713.25L1798.35,718.15L1795.05,721.35L1790.65,726.85L1786.95,730.05L1783.05,734.85L1779.95,739.25L1779.15,741.35L1774.85,743.55L1768.75,743.75L1762.45,746.45L1758.65,748.85L1753.85,751.65L1751.15,748.75L1748.55,747.65L1751.15,744.35L1747.65,745.55L1740.45,750.15L1736.85,748.45L1734.45,747.45L1731.65,746.95L1727.55,745.15L1726.25,741.15L1727.75,736.35L1728.15,733.05L1726.75,730.45L1722.05,729.75L1725.25,726.55L1726.15,721.85L1721.45,726.25L1716.15,727.45L1720.65,723.95L1723.15,720.25L1726.65,717.05L1728.25,712.35L1721.45,717.75L1717.15,719.95L1712.85,725.05L1709.85,722.45L1711.55,719.05L1710.15,714.35L1708.35,711.95L1709.95,710.45L1704.65,706.55L1700.85,706.45L1696.85,703.25L1686.95,703.85L1679.05,706.15L1672.15,708.35L1667.15,707.95L1660.15,711.25L1654.85,712.65L1652.55,716.05L1649.55,718.65L1644.85,718.85L1641.25,719.35L1637.05,718.25L1632.85,718.95L1629.05,719.25L1624.55,722.65L1623.05,722.35L1619.65,724.15L1616.25,726.15L1612.45,725.95L1608.95,725.95L1604.85,721.85L1602.45,720.65L1603.95,716.95L1606.85,716.05L1608.35,714.65L1608.95,712.35L1611.25,707.85L1611.95,704.05L1611.25,697.55L1611.45,693.85L1612.85,690.25L1611.95,686.05L1612.25,684.15L1610.55,681.55L1611.25,676.55L1609.35,671.45L1609.25,668.75L1611.05,671.55L1610.55,665.55L1612.85,667.45L1613.95,669.95L1614.55,666.65L1612.95,661.55L1612.85,659.55L1612.05,657.65L1613.35,653.95L1614.85,652.35L1616.15,649.15L1616.25,645.35L1619.35,640.75L1618.95,645.65L1622.05,641.25L1626.95,639.05L1630.15,636.35L1634.85,633.95L1637.45,633.45L1638.85,634.25L1643.65,631.85L1647.15,631.15L1648.25,629.75L1649.75,629.15L1652.85,629.35L1659.05,627.45L1662.55,624.55L1664.55,621.15L1668.45,617.95L1669.15,615.35L1669.85,611.85L1674.75,606.35L1676.15,611.95L1678.75,610.65L1677.25,607.65L1679.55,604.55L1681.75,605.95L1683.25,601.05L1686.75,597.85L1688.55,595.35L1691.45,594.25L1691.85,592.45L1694.15,593.15L1694.55,591.55L1697.15,590.65L1699.95,589.75L1703.65,592.75L1706.25,596.55L1709.75,596.55L1713.25,597.15L1712.55,593.65L1716.05,588.55L1718.75,586.85L1718.15,585.25L1721.05,581.55L1724.75,579.25L1727.45,580.05L1732.35,578.85L1732.65,575.55L1728.75,573.45L1731.85,572.55L1735.45,574.15L1738.15,576.75L1742.65,578.35L1744.35,577.75L1747.65,579.75L1751.15,577.85L1753.15,578.45L1754.65,577.15L1756.85,580.35L1754.85,583.85L1752.35,586.45L1750.45,586.65L1750.75,589.15L1748.55,592.35L1746.05,595.55L1746.25,597.35L1750.05,600.95L1754.05,602.95L1756.55,605.15L1759.85,608.95L1761.45,608.95L1764.05,610.65L1764.55,612.65L1769.45,614.75L1773.55,612.55L1775.35,609.15L1777.05,606.25L1778.35,602.75L1780.95,597.65L1780.75,594.55L1781.45,592.65L1781.35,589.05L1782.75,584.15L1784.05,582.85L1783.45,580.75L1785.25,577.35L1786.75,573.85L1787.15,571.95L1789.45,569.55L1790.75,572.75L1790.65,576.75L1791.95,577.55L1791.85,580.25L1793.45,583.45L1793.35,587.15L1792.75,589.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1069.85,190.05L1069.55,190.85L1070.25,192.95L1070.05,195.55L1067.25,195.55L1068.35,196.95L1067.05,200.95L1066.15,202.05L1061.75,202.15L1059.35,203.65L1055.15,203.15L1047.85,201.45L1046.55,199.35L1041.65,200.45L1041.15,201.65L1038.05,200.75L1035.45,200.55L1033.15,199.35L1033.85,197.85L1033.65,196.75L1035.05,196.45L1037.75,198.15L1038.35,196.45L1042.75,196.75L1046.25,195.65L1048.65,195.85L1050.35,197.15L1050.75,196.05L1049.75,191.95L1051.45,191.15L1053.05,188.25L1056.85,190.35L1059.45,187.75L1061.15,187.25L1065.15,189.15L1067.45,188.85L1069.85,190.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1228.25,252.45L1224.45,251.55L1221.25,248.65L1220.05,246.15L1221.05,246.05L1222.95,247.75L1225.25,247.75L1225.45,248.75L1228.25,252.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1234.55,235.45L1237.05,232.85L1240.55,236.15L1244.15,240.75L1246.65,241.05L1248.55,242.75L1244.35,243.25L1244.45,248.25L1244.05,250.45L1242.35,251.95L1243.15,255.05L1241.85,255.45L1237.95,252.05L1239.15,248.95L1237.25,247.05L1235.35,247.55L1230.05,252.25L1229.15,247.75L1226.65,246.75L1224.05,245.05L1225.15,242.95L1221.95,240.75L1222.65,239.15L1220.45,238.05L1219.05,236.45L1220.15,235.35L1224.35,237.25L1227.25,237.55L1227.85,236.85L1224.55,233.35L1225.75,232.55L1227.25,232.75L1231.55,236.55L1233.95,237.05L1234.55,235.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1154.15,529.65L1153.55,529.75L1153.55,529.45L1151.55,523.35L1151.55,523.29L1151.45,522.25L1150.05,519.35L1153.55,519.85L1155.25,516.15L1158.35,516.55L1158.65,519.05L1159.85,520.55L1159.85,522.65L1158.45,523.95L1156.15,527.35L1154.15,529.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1015.75,176.35L1015.35,180.55L1014.05,180.75L1013.65,184.25L1009.25,181.35L1006.75,181.85L1003.25,178.95L1000.85,176.45L998.65,176.35L997.85,174.15L1001.75,172.95L1005.35,173.45L1009.85,172.15L1012.95,174.85L1015.75,176.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BJ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1005.95,426.25L1005.75,428.35L1007.05,432.15L1005.95,434.75L1006.55,436.45L1003.75,440.45L1002.05,442.45L1000.95,446.45L1001.15,450.55L1000.85,460.85L996.15,461.65L994.75,457.25L995.05,442.45L993.85,441.15L993.65,437.95L991.65,435.75L989.95,433.85L990.65,430.45L992.65,429.75L993.75,426.95L996.55,426.35L997.75,424.45L999.65,422.55L1001.65,422.55L1005.95,426.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M987.75,405.25L987.25,408.35L988.05,411.25L991.15,415.45L991.35,418.55L997.85,420.05L997.75,424.45L996.55,426.35L993.75,426.95L992.65,429.75L990.65,430.45L985.75,430.35L983.15,429.85L981.35,430.85L978.85,430.35L969.05,430.65L968.85,434.35L969.65,439.15L965.75,437.55L963.15,437.75L961.15,439.35L958.65,438.05L957.65,435.85L955.15,434.45L954.75,430.75L956.35,428.05L956.15,425.85L960.65,420.55L961.55,416.15L963.05,414.55L965.75,415.45L968.15,414.15L968.95,412.45L973.25,409.65L974.35,407.65L979.65,404.95L982.75,404.05L984.15,405.25L987.75,405.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1499.85,359.55L1500.45,364.15L1498.35,363.15L1499.45,368.35L1497.35,365.05L1496.55,361.75L1495.05,358.65L1492.25,354.95L1487.05,354.65L1487.95,357.35L1486.75,360.85L1484.15,359.55L1483.55,360.75L1481.85,360.05L1479.65,359.45L1478.05,354.15L1475.45,349.35L1475.75,345.45L1472.05,343.75L1472.95,341.45L1475.95,339.05L1471.35,335.65L1472.55,331.25L1477.45,334.05L1480.15,334.35L1481.35,338.85L1486.75,339.75L1491.85,339.65L1495.25,340.75L1493.65,346.15L1491.25,346.55L1490.05,350.15L1493.65,353.55L1493.95,349.35L1495.45,349.35L1499.85,359.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1131.85,220.85L1129.55,223.45L1128.25,227.95L1130.35,231.55L1125.75,230.75L1120.75,232.75L1121.05,235.95L1116.45,236.55L1112.55,234.25L1108.55,236.05L1104.75,235.85L1103.95,231.65L1101.15,229.55L1101.85,228.75L1101.25,227.95L1101.85,225.95L1103.65,223.95L1100.85,221.25L1100.15,218.85L1101.25,217.45L1103.05,220.05L1104.95,219.65L1108.95,220.55L1116.55,220.95L1118.85,219.35L1124.75,217.85L1128.75,220.15L1131.85,220.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1082.25,213.55L1084.15,213.45L1083.05,216.25L1085.75,218.75L1085.25,221.65L1084.15,221.95L1083.25,222.55L1081.65,224.05L1081.25,227.55L1076.45,225.15L1074.35,222.45L1072.25,221.05L1069.75,218.65L1068.45,216.75L1065.75,213.75L1066.55,211.15L1068.55,212.65L1069.55,211.25L1071.85,211.15L1076.35,212.25L1079.85,212.15L1082.25,213.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1140.85,161.95L1136.95,161.75L1136.15,162.35L1137.65,164.35L1139.65,168.35L1135.55,168.65L1134.25,170.05L1134.55,173.15L1132.45,172.55L1128.15,172.85L1126.65,171.35L1124.95,172.45L1123.05,171.55L1119.15,171.45L1113.45,169.95L1108.55,169.45L1104.75,169.65L1102.35,171.25L1100.05,171.55L1099.55,168.75L1097.65,165.95L1100.45,164.65L1100.05,162.25L1098.35,159.95L1097.75,157.25L1102.45,157.25L1107.25,154.95L1107.75,151.55L1111.35,149.55L1110.35,146.85L1113.05,145.85L1117.65,143.55L1122.95,145.05L1123.85,146.55L1126.25,145.85L1131.05,147.25L1132.15,150.15L1131.45,151.75L1135.25,155.75L1137.35,156.85L1137.35,157.95L1140.75,159.05L1142.45,160.65L1140.85,161.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M487.05,399.05L485.35,399.05L486.65,391.85L487.35,386.75L487.45,385.75L488.15,385.45L489.05,386.25L491.55,382.35L492.65,382.25L492.55,383.25L493.55,383.25L493.25,385.05L491.95,387.75L492.35,388.75L491.45,391.05L491.75,391.65L490.75,394.95L489.45,396.65L488.35,396.85L487.05,399.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M661.75,630.65L661.45,628.65L656.05,625.35L650.85,625.25L641.25,627.15L639.15,632.75L639.35,636.25L637.85,643.95L636.85,642.55L630.45,642.25L628.85,647.45L625.15,642.85L617.65,641.25L613.65,647.05L609.75,647.95L606.65,639.05L602.95,631.85L604.05,625.65L600.85,622.95L599.65,618.35L596.45,613.95L599.35,607.05L596.45,601.65L597.55,599.45L596.35,597.05L598.25,593.85L597.95,588.45L597.95,583.85L599.05,581.75L593.55,571.35L597.75,571.95L600.65,571.75L601.75,569.85L606.55,567.25L609.45,564.85L616.75,563.75L616.35,568.55L617.25,571.05L616.95,575.35L623.45,581.05L629.85,582.15L632.15,584.55L636.05,585.85L638.55,587.65L642.05,587.65L645.45,589.55L645.95,593.25L647.15,595.15L647.45,597.85L645.75,597.95L648.55,605.45L659.25,605.75L658.75,609.45L659.55,611.95L662.75,613.75L664.45,617.75L663.85,622.85L662.55,625.65L663.35,629.25L661.75,630.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M665.05,488.85L668.15,489.45L668.75,488.05L667.75,486.85L668.35,484.95L670.65,485.55L673.35,484.85L676.55,486.25L679.05,487.55L680.75,485.85L682.05,486.05L682.85,487.85L685.55,487.45L687.75,484.95L689.55,480.25L692.95,474.35L694.95,474.05L696.25,477.65L699.25,488.85L702.35,489.95L702.45,494.35L698.15,499.65L699.85,501.55L709.95,502.55L710.15,509.05L714.45,504.85L721.55,507.15L731.05,511.05L733.85,514.75L732.95,518.35L739.55,516.35L750.55,519.75L759.05,519.55L767.45,524.85L774.85,532.05L779.25,533.85L784.05,534.15L786.15,536.15L788.15,544.35L789.25,548.25L787.15,558.85L784.45,563.05L776.75,571.95L773.35,579.25L769.35,584.75L767.95,584.95L766.65,589.65L767.55,601.65L766.45,611.55L766.15,615.75L764.55,618.35L764.05,626.95L758.85,635.25L758.35,641.95L754.05,644.65L752.95,648.55L746.95,648.55L738.45,650.95L734.75,653.85L728.75,655.75L722.65,660.85L718.55,667.25L718.25,672.05L719.55,675.55L719.25,682.05L718.45,685.15L715.05,688.75L710.55,700.05L706.55,705.05L703.35,708.15L701.85,714.25L698.95,717.85L696.85,714.25L698.65,711.15L694.85,706.85L690.05,703.25L683.75,699.15L681.85,699.35L675.55,694.35L672.15,695.05L678.15,686.35L683.45,680.05L686.75,677.45L690.95,673.95L690.55,668.85L687.35,665.05L684.75,666.35L685.45,662.65L685.75,658.85L685.45,655.25L683.35,654.15L681.35,655.15L679.25,654.85L678.45,652.45L677.35,646.55L676.15,644.65L672.25,642.85L670.05,644.15L664.15,642.85L663.75,634.15L661.75,630.65L663.35,629.25L662.55,625.65L663.85,622.85L664.45,617.75L662.75,613.75L659.55,611.95L658.75,609.45L659.25,605.75L648.55,605.45L645.75,597.95L647.45,597.85L647.15,595.15L645.95,593.25L645.45,589.55L642.05,587.65L638.55,587.65L636.05,585.85L632.15,584.55L629.85,582.15L623.45,581.05L616.95,575.35L617.25,571.05L616.35,568.55L616.75,563.75L609.45,564.85L606.55,567.25L601.75,569.85L600.65,571.75L597.75,571.95L593.55,571.35L590.35,572.45L587.75,571.75L587.65,562.05L583.25,565.75L578.25,565.65L575.95,562.15L572.15,561.85L573.15,559.05L569.85,555.15L567.25,549.35L568.75,548.25L568.55,545.45L571.95,543.65L571.25,540.15L572.65,537.95L572.95,534.95L579.25,530.55L583.85,529.35L584.65,528.35L589.75,528.65L591.95,511.05L592.05,508.25L591.15,504.65L588.55,502.25L588.65,497.55L591.85,496.55L592.95,497.25L593.15,494.75L589.85,494.05L589.85,490.05L600.85,490.25L602.75,487.95L604.35,490.05L605.35,493.85L606.45,493.05L609.55,496.45L613.95,496.05L615.05,494.05L619.25,492.55L621.65,491.45L622.35,488.75L626.45,486.95L626.15,485.55L621.35,485.05L620.65,480.95L620.95,476.65L618.45,475.05L619.55,474.45L623.65,475.25L628.15,476.85L629.85,475.35L633.95,474.35L640.35,471.95L642.45,469.45L641.75,467.65L644.75,467.45L645.95,468.85L645.15,471.75L647.15,472.65L648.35,475.65L646.75,477.95L645.75,483.35L647.15,486.65L647.45,489.65L650.95,492.65L653.75,492.95L654.35,491.65L656.15,491.35L658.75,490.25L660.55,488.55L663.75,489.15L665.05,488.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1632.35,472.05L1634.55,469.65L1639.15,466.05L1639.05,469.25L1638.95,473.35L1636.25,473.15L1635.15,475.35L1632.35,472.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1488.05,322.75L1490.65,324.85L1491.15,328.75L1486.65,328.95L1481.95,328.55L1478.75,329.55L1473.25,327.05L1472.85,325.85L1475.45,321.05L1478.05,319.45L1482.35,320.85L1485.25,321.05L1488.05,322.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1126.85,614.95L1128.75,620.05L1129.85,621.25L1131.45,624.95L1137.55,631.95L1139.85,632.65L1139.75,634.95L1141.25,639.05L1145.55,640.05L1148.95,642.95L1140.85,647.65L1135.65,652.45L1133.65,656.75L1131.85,659.15L1128.85,659.65L1127.65,662.75L1127.05,664.75L1123.45,666.15L1118.95,665.85L1116.45,664.05L1114.15,663.35L1111.35,664.75L1109.85,667.85L1107.15,669.75L1104.35,672.65L1100.35,673.35L1099.25,671.05L1099.85,667.15L1096.85,661.05L1095.45,660.05L1096.05,641.35L1101.55,641.15L1102.35,618.25L1106.55,618.05L1115.25,615.75L1117.25,618.45L1120.95,615.95L1122.65,615.95L1125.85,614.45L1126.85,614.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1120.55,445.75L1124.45,448.25L1127.55,450.85L1127.65,452.95L1131.55,456.25L1133.95,459.05L1135.35,462.85L1139.65,465.45L1140.55,467.45L1138.75,468.15L1135.05,468.05L1130.85,467.35L1128.75,467.85L1127.85,469.45L1126.05,469.65L1123.85,468.25L1117.55,471.45L1114.95,470.85L1114.15,471.35L1112.55,475.25L1108.25,473.95L1104.15,473.35L1100.55,470.95L1095.85,468.75L1092.85,470.85L1090.65,474.05L1090.15,478.55L1086.55,478.25L1082.65,477.15L1079.35,480.55L1076.35,486.55L1075.75,484.65L1075.45,481.75L1072.85,479.65L1070.75,476.35L1070.25,474.05L1067.55,470.65L1068.05,468.75L1067.45,466.05L1067.85,461.05L1069.25,459.95L1072.05,453.45L1076.65,452.95L1077.65,451.25L1078.65,451.45L1080.05,452.85L1087.15,450.45L1089.55,447.95L1092.45,445.65L1091.85,443.45L1093.45,442.85L1098.95,443.25L1104.15,440.25L1108.15,433.25L1110.95,430.65L1114.55,429.55L1115.25,432.25L1118.55,436.25L1118.55,438.95L1117.75,441.55L1118.15,443.55L1120.05,445.45L1120.55,445.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M665.15,202.85L668.55,203.75L673.25,203.55L669.95,206.15L667.95,206.55L662.45,203.85L661.85,201.75L664.35,199.85L665.15,202.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M679.55,186.85L677.15,186.95L671.35,185.05L667.85,182.05L669.75,181.55L675.65,183.15L679.85,185.75L679.55,186.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M371.65,190.55L368.55,191.45L362.25,188.65L362.25,186.45L359.35,184.25L359.65,182.45L355.35,181.35L355.95,177.95L357.45,176.55L361.55,177.85L363.95,178.85L368.05,179.45L368.25,181.65L368.65,184.55L371.85,187.15L371.65,190.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M710.75,177.05L705.75,182.45L709.65,180.35L712.55,181.75L710.15,183.85L713.95,185.55L716.75,184.05L721.05,185.95L718.25,190.55L722.05,189.45L721.75,192.75L722.25,196.65L718.65,202.25L716.25,202.45L713.35,201.25L715.85,196.15L714.65,195.35L707.35,200.75L704.35,200.55L708.75,197.55L704.35,196.05L698.85,196.45L689.25,196.25L689.05,194.45L692.85,192.15L691.15,190.55L696.55,186.75L704.75,176.85L708.95,173.35L713.95,171.25L716.05,171.45L714.55,173.15L710.75,177.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M350.75,155.65L352.25,156.45L357.25,155.95L350.05,162.85L350.35,167.85L348.45,167.85L347.75,165.05L348.25,162.15L347.45,160.25L348.75,157.55L350.75,155.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M634.15,108.15L630.55,111.15L628.85,110.65L628.75,108.95L629.15,108.55L631.95,106.85L633.65,106.95L634.15,108.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M624.45,104.95L617.25,108.15L614.25,107.95L614.25,106.45L619.25,103.75L625.25,103.85L624.45,104.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M621.35,88.15L620.45,90.65L623.15,89.75L624.65,91.25L628.15,93.25L631.95,94.95L630.55,97.65L634.05,97.25L635.95,99.15L630.95,100.95L625.05,99.55L624.25,96.95L617.95,100.05L609.75,102.95L610.45,99.65L604.15,100.15L609.85,97.35L613.45,92.85L618.55,87.75L621.35,88.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M666.25,79.85L661.35,80.15L662.05,77.45L665.85,74.35L670.15,73.65L672.45,75.15L670.95,77.45L670.05,78.25L666.25,79.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M591.75,69.15L587.65,71.05L583.45,69.45L579.55,69.95L576.15,67.55L581.15,65.85L586.05,63.55L589.05,65.05L590.65,66.05L591.05,67.05L591.75,69.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M644.75,211.75L642.55,208.15L645.45,199.65L643.85,197.85L640.15,198.85L639.05,197.25L633.55,201.95L630.35,206.85L627.55,209.75L625.05,210.75L623.35,211.05L622.25,212.55L612.95,212.55L605.15,212.65L602.45,213.75L595.65,218.15L595.65,218.05L594.75,217.65L592.75,218.55L590.85,219.85L589.05,218.75L584.35,219.55L580.45,220.45L578.55,221.25L576.25,223.35L578.05,224.05L579.75,223.65L580.05,223.65L579.75,225.55L574.95,226.25L572.15,227.05L570.45,228.05L567.85,227.45L566.25,227.75L563.35,229.55L558.75,231.55L556.05,231.15L558.05,228.95L561.75,225.45L565.85,223.35L566.95,221.55L567.85,218.55L571.65,215.05L572.55,211.05L573.65,214.95L577.45,215.85L579.85,213.75L578.45,208.95L577.55,206.95L573.55,205.75L569.75,205.05L565.85,205.05L562.45,204.25L562.05,202.85L560.65,203.75L559.45,203.55L561.35,201.45L559.55,200.65L561.45,198.25L560.25,196.45L561.95,194.65L556.75,193.75L556.65,190.15L555.85,189.35L552.55,189.15L548.45,187.95L546.95,188.75L545.15,190.25L541.85,191.25L538.75,193.75L533.35,192.05L528.95,192.85L525.05,190.95L520.45,189.95L517.15,189.55L516.15,188.55L517.05,185.15L515.35,185.15L514.05,187.55L376.25,187.55L370.85,181.45L369.25,178.75L362.25,176.15L363.55,170.65L367.15,166.95L363.05,164.25L366.15,159.35L364.05,154.95L366.55,151.75L371.65,148.85L374.85,145.05L370.25,141.25L371.65,134.35L372.75,130.15L371.15,127.45L370.35,125.05L370.95,121.95L364.45,123.85L356.85,127.15L356.55,123.35L356.05,120.75L353.25,119.15L349.05,118.95L384.65,86.25L409.25,65.85L415.25,67.15L418.55,69.75L422.25,70.25L428.55,68.05L435.55,66.35L440.85,66.95L449.75,64.65L457.95,63.35L458.15,65.55L462.65,64.25L466.55,61.75L468.65,62.35L470.05,67.15L479.55,63.45L475.65,67.55L481.65,66.65L484.85,65.15L489.45,65.45L493.35,67.65L500.85,69.65L505.55,70.55L509.95,70.25L512.85,73.05L504.35,75.75L510.75,76.85L522.65,76.25L527.05,75.25L528.45,78.55L535.55,75.85L533.45,73.45L537.95,71.65L543.15,71.35L547.05,70.85L549.15,72.15L550.65,75.05L555.65,74.65L560.95,77.15L568.15,76.25L574.15,76.35L576.55,72.95L581.05,72.05L585.95,73.85L581.65,79.05L587.85,74.65L591.05,74.85L597.45,69.35L595.85,66.05L592.95,63.85L598.45,57.95L606.65,54.15L611.15,55.05L613.15,57.35L613.55,63.35L607.75,65.95L614.45,67.05L610.05,72.55L618.95,68.35L621.15,71.85L616.85,75.85L618.15,79.55L625.45,75.65L631.95,70.85L636.65,64.95L642.15,65.35L647.55,66.15L651.15,68.85L649.45,71.55L644.35,74.45L645.25,77.35L642.85,80.05L631.95,83.95L625.45,84.85L622.25,83.15L618.95,85.95L611.55,90.65L608.55,93.15L600.85,96.95L594.35,97.35L589.25,99.75L586.35,103.55L580.65,104.25L571.95,108.95L562.55,115.45L557.55,120.05L552.65,126.95L558.65,127.95L557.15,133.45L556.35,138.05L563.65,136.85L570.65,139.45L573.95,141.75L575.65,144.55L580.55,146.25L584.15,148.75L591.75,149.15L596.55,149.75L592.95,154.95L591.25,161.05L591.35,167.95L595.75,173.85L600.45,171.85L606.05,165.45L608.35,155.85L606.65,152.65L615.65,149.75L623.15,145.55L627.95,141.35L629.65,137.35L629.25,132.25L626.05,127.75L634.95,121.55L635.95,116.25L639.85,107.25L643.65,105.85L650.35,107.45L654.55,108.05L659.05,106.45L662.15,108.45L665.75,111.85L665.95,114.05L673.65,114.55L671.05,119.45L668.75,126.85L672.55,127.85L674.15,131.35L682.35,128.05L689.85,121.45L694.05,118.75L695.15,124.05L697.75,131.55L699.75,138.75L696.35,142.55L701.15,145.95L704.05,149.35L710.95,150.95L713.35,152.85L713.35,158.05L716.75,158.85L717.85,161.15L715.85,168.05L711.55,170.35L707.35,172.55L698.55,174.75L690.65,179.75L682.05,180.85L671.95,179.45L664.65,179.45L659.35,179.85L653.65,184.35L646.25,187.15L636.15,195.35L628.25,201.15L632.95,200.15L643.85,191.85L656.15,186.65L663.75,186.05L667.05,189.15L660.95,193.35L660.35,200.05L660.45,204.85L666.05,207.95L674.65,207.05L681.85,199.95L680.85,204.55L683.35,206.85L675.95,210.95L663.55,214.75L657.75,217.25L650.55,221.85L646.85,221.35L648.35,216.05L658.75,210.75L650.65,210.95L644.75,211.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M538.25,47.95L533.55,50.35L544.05,48.85L546.65,51.45L553.95,48.75L555.75,50.45L553.55,55.55L557.85,53.45L560.65,48.15L564.95,47.35L567.95,48.15L570.15,50.25L567.45,55.35L565.05,59.05L569.25,61.65L574.25,64.25L571.65,66.55L564.55,67.05L565.35,69.05L562.15,71.05L555.45,70.25L549.75,68.75L544.65,69.05L535.15,70.95L523.85,71.75L515.95,72.25L516.25,69.65L512.15,68.25L507.85,68.85L507.25,64.55L510.55,63.95L517.85,63.05L523.35,63.35L529.55,62.35L523.05,61.15L513.95,61.55L508.25,61.45L508.25,59.55L519.95,57.35L513.65,57.45L508.25,56.05L516.05,52.15L521.25,50.05L535.45,46.95L538.25,47.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M577.75,46.45L570.75,49.85L568.45,46.25L570.55,45.45L576.05,45.25L577.75,46.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M686.35,48.05L685.65,49.45L677.45,49.25L672.55,49.95L671.65,49.55L669.55,46.85L671.25,45.05L673.45,44.65L681.85,45.25L686.35,48.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M646.55,47.75L646.85,50.95L654.05,46.85L665.75,44.75L668.05,50.05L664.85,53.45L673.85,51.95L679.15,49.85L685.95,52.45L689.65,54.95L688.55,57.25L696.75,56.05L698.65,59.45L707.05,61.55L709.25,63.65L710.15,68.75L701.05,71.25L708.75,74.85L714.65,76.05L717.95,81.05L724.45,81.45L721.15,85.35L710.25,91.85L706.25,89.45L702.45,84.05L696.55,84.75L694.25,88.05L696.95,91.25L701.45,93.85L702.45,95.35L702.35,101.05L698.75,105.15L694.05,103.55L685.45,99.05L689.05,103.95L691.85,107.45L691.55,109.45L680.65,107.15L673.05,103.75L669.25,101.05L671.65,99.35L666.85,96.45L662.15,93.75L661.25,95.35L648.15,96.25L645.75,94.35L651.15,90.15L659.25,90.05L668.55,89.35L668.35,87.35L671.45,84.55L680.25,79.15L680.65,76.65L680.15,74.85L675.45,72.15L668.35,70.35L671.85,68.95L669.85,65.55L666.45,65.25L664.55,63.45L661.25,65.05L653.35,65.75L639.35,64.55L631.95,62.95L626.05,62.15L624.15,60.25L630.45,57.85L624.75,57.85L628.05,52.55L635.15,47.95L641.15,45.85L652.35,44.45L646.55,47.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M596.15,44.25L599.75,45.35L607.35,44.65L606.85,46.15L600.75,48.65L604.55,50.85L599.35,55.55L590.95,57.55L587.55,57.15L586.65,55.15L580.75,51.15L582.45,49.45L589.85,50.05L588.95,46.75L596.15,44.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M618.75,49.75L610.95,53.65L606.55,53.45L608.35,48.85L610.95,46.35L615.15,44.15L620.35,42.75L628.25,42.95L634.45,44.15L624.35,48.75L618.75,49.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M502.95,56.95L489.45,59.55L490.05,57.25L484.05,54.45L488.45,52.25L495.95,48.45L503.55,45.05L503.95,41.95L517.95,41.15L522.15,42.25L531.65,42.55L533.55,43.95L535.15,46.15L528.65,47.45L514.75,51.05L505.55,54.75L502.95,56.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M628.15,38.55L624.05,40.45L618.85,40.05L615.65,38.75L620.15,36.55L627.05,35.15L628.45,36.95L628.15,38.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M619.35,29.85L619.55,32.15L616.75,34.65L610.95,38.45L604.05,38.95L600.85,38.15L604.25,35.25L597.65,35.55L601.95,31.75L605.75,31.95L613.45,30.25L618.35,30.55L619.35,29.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M579.95,32.45L579.25,34.15L583.65,33.35L587.25,33.55L584.95,36.05L579.85,38.35L565.95,39.15L553.65,41.35L547.65,41.45L549.15,39.85L559.85,37.55L541.95,38.15L537.75,37.25L549.45,32.45L554.85,31.05L563.15,32.75L566.05,35.65L572.15,36.05L572.85,31.35L578.65,29.55L581.75,30.05L579.95,32.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M635.65,28.05L637.95,29.65L645.35,29.65L646.75,31.25L643.95,33.05L647.05,34.15L648.25,35.35L653.15,35.55L658.25,35.95L665.35,34.95L673.45,34.45L679.25,34.85L681.55,36.75L680.55,38.75L676.95,40.15L670.25,41.25L665.95,40.55L654.15,41.35L646.15,41.45L640.55,40.85L631.95,39.25L633.55,36.45L635.65,34.05L634.25,31.85L627.25,31.25L624.65,29.75L628.45,27.75L635.65,28.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M559.95,25.45L554.15,29.15L548.85,30.85L545.05,31.05L535.15,33.15L528.05,33.95L524.45,32.85L536.15,29.15L548.35,26.05L553.85,26.15L559.95,25.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M641.15,26.05L639.35,26.15L632.75,25.85L633.45,24.55L640.65,24.65L642.25,25.45L641.15,26.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M582.35,25.15L573.55,26.55L570.25,25.05L575.35,23.55L581.35,23.05L585.45,23.75L582.35,25.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M590.15,20.95L584.45,21.85L578.45,21.85L579.45,21.15L585.15,19.85L586.85,20.05L590.15,20.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M636.95,23.45L630.35,24.45L628.75,23.35L629.35,21.65L631.55,19.75L635.95,19.95L637.65,20.25L639.95,21.85L636.95,23.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M623.15,22.25L622.05,24.15L616.75,23.65L612.75,22.15L604.95,21.95L610.25,20.65L607.45,19.55L609.65,17.75L615.75,18.35L623.25,20.05L623.15,22.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M677.25,16.15L679.95,17.65L673.45,18.95L662.85,22.45L656.05,22.75L649.25,22.15L647.65,20.25L649.75,18.65L654.05,17.45L647.45,17.45L645.45,15.95L645.85,14.05L650.75,12.15L654.85,10.85L658.85,10.55L658.55,9.55L666.85,9.35L668.45,11.55L673.15,12.45L677.95,13.35L677.25,16.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M756.45,2.15L765.15,2.45L771.85,2.95L777.05,3.95L775.95,4.95L766.15,6.65L757.15,7.45L753.15,8.35L760.65,8.35L750.15,10.85L743.35,12.05L734.05,15.55L725.95,16.25L722.85,17.25L711.55,17.65L715.95,18.25L712.65,19.05L713.35,21.35L708.35,22.95L701.45,24.25L697.95,26.05L691.35,27.55L690.85,28.65L697.35,28.45L696.25,29.65L683.55,32.55L675.05,31.15L663.35,31.95L658.35,31.35L651.55,31.05L653.65,28.75L661.65,27.65L663.65,24.25L666.25,23.95L673.75,25.95L672.05,22.95L667.15,22.05L672.15,20.25L679.75,19.15L682.55,17.55L679.55,15.85L680.65,13.65L690.05,13.75L692.25,14.25L699.55,12.65L692.25,12.15L679.65,12.45L675.25,11.05L674.45,9.35L671.95,8.15L673.05,6.85L679.05,6.05L683.25,5.95L690.65,5.35L697.45,3.85L701.35,4.05L703.75,5.15L708.75,3.15L713.95,2.55L720.45,2.15L730.85,1.95L732.15,2.35L742.45,1.75L756.45,2.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1033.65,196.75L1033.85,197.85L1033.15,199.35L1035.45,200.55L1038.05,200.75L1037.75,203.25L1035.65,204.35L1031.85,203.55L1030.85,206.05L1028.45,206.25L1027.55,205.25L1024.85,207.45L1022.35,207.75L1020.15,206.35L1018.35,203.65L1015.95,204.65L1015.95,201.75L1019.55,198.25L1019.35,196.65L1021.65,197.25L1022.95,196.15L1027.15,196.15L1028.15,194.85L1033.65,196.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1601.45,381.15L1597.15,384.25L1592.25,382.25L1591.25,376.75L1593.45,373.85L1599.25,372.05L1602.55,372.15L1604.15,374.65L1602.15,377.45L1601.45,381.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1624.85,184.75L1633.85,189.25L1639.85,195.05L1647.45,195.05L1650.05,192.65L1656.95,190.75L1658.25,196.45L1657.95,198.75L1660.75,205.55L1661.35,211.75L1654.45,210.65L1651.55,212.85L1656.25,218.25L1660.15,225.75L1657.65,225.85L1659.55,229.15L1654.05,225.35L1654.05,228.95L1647.65,231.65L1650.45,235.05L1645.85,234.75L1642.25,232.75L1641.15,237.35L1637.25,240.75L1635.15,244.85L1628.85,246.65L1626.45,249.65L1621.65,251.45L1622.95,248.45L1620.65,245.95L1622.65,241.65L1618.15,238.35L1614.75,240.55L1611.15,245.05L1609.85,249.15L1604.85,249.45L1603.55,252.45L1608.35,256.75L1613.15,257.85L1614.55,260.65L1619.65,262.55L1623.45,257.95L1629.35,260.45L1632.85,260.65L1635.15,263.95L1628.45,265.75L1627.45,269.25L1623.65,272.45L1622.75,276.95L1629.85,280.45L1634.45,286.75L1639.95,292.65L1645.45,297.55L1647.05,302.35L1644.25,304.15L1646.65,307.55L1650.55,309.55L1651.35,314.75L1651.45,319.85L1648.65,320.45L1646.55,327.35L1644.25,335.85L1640.85,343.45L1634.45,349.35L1627.85,354.85L1621.75,355.55L1618.85,358.35L1616.55,356.35L1614.05,359.45L1606.85,362.75L1601.05,363.65L1600.35,370.45L1597.25,370.85L1595.05,366.15L1595.95,363.75L1588.15,361.65L1585.75,362.75L1579.85,361.05L1576.75,358.45L1577.05,354.75L1571.75,353.55L1568.65,351.15L1564.55,354.55L1559.25,355.35L1554.85,355.25L1552.15,356.85L1549.45,357.75L1551.45,365.15L1548.45,364.95L1547.65,363.45L1547.15,360.75L1543.35,362.65L1540.75,361.45L1536.25,359.05L1537.05,353.75L1533.35,352.45L1530.95,346.55L1525.35,347.65L1524.65,340.05L1528.85,334.65L1527.95,329.35L1526.65,324.45L1523.95,322.95L1521.25,319.15L1518.15,319.65L1512.05,318.65L1513.25,315.95L1509.65,311.95L1506.45,314.65L1501.55,313.15L1496.15,317.15L1492.25,321.95L1488.05,322.75L1485.25,321.05L1482.35,320.85L1478.05,319.45L1475.45,321.05L1472.85,325.85L1471.35,320.75L1468.25,322.15L1461.75,321.45L1455.25,320.05L1450.25,317.15L1445.75,315.95L1443.25,312.85L1439.95,311.95L1433.55,307.75L1428.75,305.75L1426.85,307.25L1418.25,302.75L1412.05,298.75L1408.85,291.65L1412.95,292.55L1412.35,289.25L1409.35,285.95L1408.55,280.75L1400.85,273.15L1391.35,270.65L1388.45,265.65L1383.75,262.65L1382.25,260.85L1380.45,257.25L1379.95,254.75L1376.25,253.25L1374.75,253.95L1371.65,247.95L1372.75,246.55L1371.55,245.05L1375.65,242.05L1378.85,240.75L1384.65,241.65L1385.25,237.55L1391.65,236.85L1392.65,234.25L1399.55,230.85L1399.75,229.45L1398.05,225.75L1400.95,224.15L1392.15,213.15L1401.25,210.65L1403.25,209.25L1402.25,197.95L1413.05,200.05L1414.65,197.15L1412.15,190.95L1415.95,190.35L1417.85,186.15L1419.55,185.65L1422.85,190.05L1428.55,193.35L1436.75,195.65L1442.55,200.75L1443.95,208.05L1446.95,210.85L1453.45,211.95L1460.65,212.75L1468.65,216.75L1472.05,217.45L1477.05,223.25L1481.75,227.05L1487.35,226.85L1498.65,228.35L1505.05,227.45L1510.65,228.35L1520.05,232.25L1526.25,232.25L1529.55,234.15L1533.95,230.75L1541.15,228.55L1548.75,228.35L1553.65,226.15L1555.65,222.75L1558.05,220.55L1556.15,218.45L1553.25,216.05L1553.75,211.95L1556.95,212.55L1562.85,213.85L1566.05,210.45L1572.45,208.05L1573.75,203.85L1576.25,202.05L1583.05,201.25L1587.45,201.95L1586.65,199.75L1579.45,195.35L1574.25,193.35L1571.75,195.65L1566.25,194.65L1563.95,195.45L1561.15,192.95L1560.85,186.65L1560.25,181.95L1567.65,184.35L1572.05,180.45L1570.15,177.65L1569.95,171.15L1571.25,169.15L1568.75,165.75L1565.05,164.35L1566.75,161.25L1571.85,160.15L1578.05,159.95L1586.65,161.85L1592.65,164.05L1600.35,170.25L1604.15,172.95L1608.65,176.75L1614.85,182.75L1624.85,184.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.15,434.45L957.65,435.85L958.65,438.05L961.15,439.35L963.15,437.75L965.75,437.55L969.65,439.15L971.15,448.35L968.75,453.65L967.25,460.95L969.65,466.45L969.45,469.05L966.85,469.05L962.95,467.85L959.25,467.85L952.55,469.05L948.65,470.85L943.05,473.25L941.95,473.05L942.35,467.75L942.95,466.95L942.75,464.45L940.35,461.75L938.55,461.35L936.95,459.55L938.15,456.65L937.65,453.55L937.85,451.75L938.75,451.75L939.15,448.95L938.75,447.65L939.25,446.75L941.35,446.05L939.95,440.85L938.65,438.25L939.15,436.05L940.25,435.55L941.05,434.95L942.55,435.95L946.95,435.95L947.95,434.15L948.95,434.25L950.55,433.55L951.45,436.25L952.75,435.45L955.15,434.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1072.05,453.45L1069.25,459.95L1067.85,461.05L1067.45,466.05L1068.05,468.75L1067.55,470.65L1070.25,474.05L1070.75,476.35L1072.85,479.65L1075.45,481.75L1075.75,484.65L1076.35,486.55L1075.95,489.95L1071.45,488.45L1066.85,486.75L1059.75,486.55L1059.05,486.15L1055.65,486.95L1052.25,486.15L1049.55,486.55L1040.25,486.45L1041.15,481.35L1038.85,477.05L1036.25,476.05L1035.15,473.15L1033.65,472.25L1033.75,470.45L1035.15,465.85L1037.85,459.65L1039.45,459.65L1042.85,455.85L1044.95,455.75L1048.15,458.45L1052.05,456.25L1052.55,453.55L1053.85,450.95L1054.65,447.75L1057.65,445.15L1058.75,440.65L1059.95,439.15L1060.75,435.85L1062.15,431.75L1066.85,426.75L1067.15,424.65L1067.75,423.45L1065.45,420.95L1065.65,418.85L1067.15,418.55L1069.45,422.65L1069.95,426.85L1069.75,431.15L1072.95,436.95L1069.75,436.95L1068.15,437.35L1065.55,436.75L1064.35,439.75L1067.75,443.55L1070.25,444.65L1071.05,447.25L1072.85,451.65L1072.05,453.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1140.55,467.45L1144.05,472.75L1146.65,473.55L1148.15,472.45L1150.75,472.85L1153.85,471.55L1155.25,474.25L1160.35,478.55L1160.05,486.05L1162.35,486.95L1160.45,489.15L1158.35,490.95L1156.15,494.25L1154.95,497.25L1154.65,502.35L1153.35,504.85L1153.25,509.65L1151.65,511.45L1151.45,515.25L1150.65,515.75L1150.05,519.35L1151.45,522.25L1151.55,523.25L1150.35,533.55L1151.85,537.15L1150.85,539.85L1152.65,544.45L1156.05,547.95L1156.75,551.45L1158.35,553.15L1158.05,554.25L1157.15,553.95L1149.45,555.05L1147.95,555.85L1146.25,559.95L1147.45,562.75L1146.35,570.35L1145.45,576.75L1146.95,577.95L1150.85,580.45L1152.45,579.25L1152.65,586.15L1148.35,586.15L1146.15,582.65L1144.15,579.85L1139.85,578.95L1138.65,575.65L1135.15,577.65L1130.75,576.75L1128.85,573.85L1125.35,573.25L1122.65,573.35L1122.35,571.35L1120.45,571.25L1117.85,570.85L1114.35,571.85L1111.95,571.65L1110.55,572.25L1110.95,564.65L1109.15,562.25L1108.75,558.25L1109.65,554.35L1108.55,551.95L1108.45,547.85L1101.65,547.95L1102.15,545.65L1099.25,545.65L1098.95,546.75L1095.45,547.05L1093.95,550.75L1093.05,552.35L1089.95,551.45L1088.15,552.35L1084.35,552.85L1082.25,549.55L1080.95,547.45L1079.35,543.55L1078.05,538.85L1061.35,538.75L1059.35,539.45L1057.65,539.35L1055.35,540.25L1054.55,538.25L1055.95,537.55L1056.15,534.75L1057.15,533.15L1059.15,531.75L1060.65,532.45L1062.65,529.95L1065.75,530.05L1066.05,531.85L1068.15,532.95L1071.55,528.95L1074.85,525.85L1076.25,523.75L1076.15,518.45L1078.65,512.25L1081.25,508.95L1084.95,505.85L1085.65,503.85L1085.75,501.45L1086.65,499.25L1086.35,495.55L1087.05,489.85L1088.15,485.85L1089.85,482.45L1090.15,478.55L1090.65,474.05L1092.85,470.85L1095.85,468.75L1100.55,470.95L1104.15,473.35L1108.25,473.95L1112.55,475.25L1114.15,471.35L1114.95,470.85L1117.55,471.45L1123.85,468.25L1126.05,469.65L1127.85,469.45L1128.75,467.85L1130.85,467.35L1135.05,468.05L1138.75,468.15L1140.55,467.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1090.15,478.55L1089.85,482.45L1088.15,485.85L1087.05,489.85L1086.35,495.55L1086.65,499.25L1085.75,501.45L1085.65,503.85L1084.95,505.85L1081.25,508.95L1078.65,512.25L1076.15,518.45L1076.25,523.75L1074.85,525.85L1071.55,528.95L1068.15,532.95L1066.05,531.85L1065.75,530.05L1062.65,529.95L1060.65,532.45L1059.15,531.75L1057.05,529.55L1055.35,530.65L1053.05,533.45L1048.45,526.65L1052.75,523.05L1050.65,518.85L1052.65,517.25L1056.45,516.45L1056.85,513.55L1059.95,516.65L1064.95,516.95L1066.65,513.95L1067.35,509.65L1066.75,504.65L1064.05,500.85L1066.55,493.35L1065.15,492.15L1060.95,492.65L1059.35,489.35L1059.75,486.55L1066.85,486.75L1071.45,488.45L1075.95,489.95L1076.35,486.55L1079.35,480.55L1082.65,477.15L1086.55,478.25L1090.15,478.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M583.65,425.45L579.95,426.55L578.35,429.75L576.05,431.55L574.25,433.95L573.35,438.55L571.55,442.35L574.45,442.75L575.05,445.65L576.25,447.15L576.55,449.65L575.85,452.05L575.95,453.45L577.35,453.95L578.55,456.15L585.85,455.55L589.15,456.35L592.95,461.95L595.25,461.25L599.35,461.55L602.55,460.85L604.55,461.95L603.35,465.35L602.05,467.55L601.45,472.15L602.55,476.45L604.05,478.35L604.25,479.75L601.35,482.95L603.35,484.35L604.85,486.65L606.45,493.05L605.35,493.85L604.35,490.05L602.75,487.95L600.85,490.25L589.85,490.05L589.85,494.05L593.15,494.75L592.95,497.25L591.85,496.55L588.65,497.55L588.55,502.25L591.15,504.65L592.05,508.25L591.95,511.05L589.75,528.65L586.85,525.25L585.15,525.15L588.65,518.55L584.25,515.55L580.85,516.15L578.75,515.05L575.65,516.75L571.45,515.85L567.95,509.15L565.35,507.55L563.55,504.45L559.75,501.45L558.25,502.05L555.85,500.55L553.05,498.45L551.45,499.45L546.65,498.55L545.25,495.75L544.15,495.85L538.55,492.25L537.85,490.25L539.95,489.75L539.75,486.55L541.15,484.15L543.95,483.75L546.45,479.75L548.65,476.35L546.65,474.85L547.85,471.15L546.75,465.25L548.05,463.55L547.35,458.15L545.15,454.65L546.05,451.55L547.85,452.05L548.95,450.15L547.85,446.35L548.55,445.45L551.45,445.65L555.95,441.15L558.35,440.45L558.45,438.35L559.85,432.85L563.25,429.95L566.75,429.75L567.35,428.45L571.75,428.95L576.35,425.75L578.65,424.35L581.55,421.25L583.55,421.65L584.85,423.35L583.65,425.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M513.85,430.85L515.05,434.35L517.05,436.95L519.55,439.65L517.35,440.25L517.25,442.85L518.35,443.75L517.45,444.55L517.65,445.65L517.05,446.95L516.75,448.25L513.75,446.85L512.65,445.45L513.35,444.35L513.25,442.95L511.75,441.45L509.55,440.15L507.75,439.35L507.45,437.45L506.05,436.35L506.25,438.15L505.05,439.75L503.85,437.95L502.15,437.25L501.45,436.05L501.55,434.05L502.45,432.05L500.95,431.15L502.35,429.85L503.25,429.05L506.85,430.75L508.15,429.95L509.95,430.45L510.75,431.75L512.45,432.25L513.85,430.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CU" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M544.05,354.95L545.95,357.25L551.15,356.55L552.95,358.05L557.15,362.05L560.35,364.95L562.15,364.85L565.35,366.15L564.75,367.95L568.75,368.25L572.65,370.85L571.85,372.35L568.05,373.15L564.25,373.45L560.55,372.95L552.45,373.55L556.65,370.05L554.55,368.35L550.95,367.95L549.25,366.05L548.45,362.45L545.25,362.65L540.25,360.95L538.75,359.55L531.65,358.55L529.85,357.35L532.15,355.75L526.75,355.45L522.35,358.75L520.05,358.85L519.05,360.45L516.25,361.15L513.95,360.45L517.15,358.55L518.65,356.15L521.35,354.75L524.35,353.55L528.65,352.95L530.05,352.15L534.75,352.65L539.15,352.75L544.05,354.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1058.95,174.45L1061.45,176.45L1065.15,176.95L1064.95,178.65L1067.75,179.95L1068.35,178.35L1071.75,179.05L1072.45,181.05L1076.15,181.35L1078.75,184.45L1077.25,184.45L1076.55,185.55L1075.45,185.85L1075.25,187.25L1074.35,187.55L1074.25,188.15L1072.65,188.75L1070.45,188.65L1069.85,190.05L1067.45,188.85L1065.15,189.15L1061.15,187.25L1059.45,187.75L1056.85,190.35L1053.05,188.25L1050.05,185.65L1047.45,184.15L1046.75,181.45L1045.75,179.65L1049.15,178.35L1050.85,176.75L1054.35,175.55L1055.45,174.35L1056.75,175.05L1058.95,174.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1053.15,158.15L1054.55,161.25L1053.35,162.95L1055.25,165.05L1056.75,168.35L1056.55,170.55L1058.95,174.45L1056.75,175.05L1055.45,174.35L1054.35,175.55L1050.85,176.75L1049.15,178.35L1045.75,179.65L1046.75,181.45L1047.45,184.15L1050.05,185.65L1053.05,188.25L1051.45,191.15L1049.75,191.95L1050.75,196.05L1050.35,197.15L1048.65,195.85L1046.25,195.65L1042.75,196.75L1038.35,196.45L1037.75,198.15L1035.05,196.45L1033.65,196.75L1028.15,194.85L1027.15,196.15L1022.95,196.15L1023.35,191.65L1025.75,187.45L1018.55,186.25L1016.15,184.65L1016.35,181.95L1015.35,180.55L1015.75,176.35L1014.65,169.85L1017.55,169.85L1018.75,167.55L1019.65,161.95L1018.75,159.85L1019.55,158.55L1023.55,158.25L1024.55,159.55L1027.65,156.55L1026.35,154.25L1025.95,150.85L1029.65,151.65L1032.55,150.75L1032.85,153.05L1037.75,154.45L1037.85,156.65L1042.55,155.45L1045.15,153.85L1050.75,156.25L1053.15,158.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DJ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1228.75,427.45L1226.85,430.95L1225.55,429.75L1224.25,430.25L1221.05,430.15L1220.85,428.15L1220.35,426.35L1222.15,423.35L1224.05,420.55L1226.45,421.15L1228.15,419.55L1229.55,421.55L1229.45,424.15L1226.35,425.75L1228.75,427.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1045.35,146.95L1042.95,151.85L1037.75,148.35L1036.85,145.85L1043.65,143.85L1045.35,146.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1032.55,150.75L1029.65,151.65L1025.95,150.85L1023.85,147.45L1023.45,141.35L1024.05,139.65L1025.35,137.85L1029.35,137.55L1030.95,135.85L1034.55,134.15L1034.55,137.25L1033.35,139.25L1034.05,140.85L1036.65,141.75L1035.65,144.05L1034.25,143.45L1031.15,147.75L1032.55,150.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M584.95,385.25L585.25,383.45L583.95,381.55L585.45,380.45L586.15,377.95L586.05,374.55L586.85,373.45L591.15,373.45L594.35,375.05L595.85,374.95L596.55,377.25L599.65,377.05L599.25,378.95L601.75,379.25L604.25,381.55L601.95,384.15L599.35,382.75L596.75,383.05L594.95,382.75L593.85,383.95L591.65,384.35L590.95,382.75L589.05,383.65L586.35,388.05L585.05,387.05L584.95,385.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1030.25,263.85L1029.25,267.15L1030.25,273.25L1029.15,278.55L1025.95,282.15L1026.55,286.95L1031.05,290.85L1031.15,292.35L1034.55,294.95L1037.15,306.45L1039.05,312.15L1039.45,315.15L1038.65,320.35L1039.05,323.35L1038.45,326.85L1039.05,330.85L1036.85,333.55L1040.25,338.25L1040.45,340.95L1042.55,344.55L1045.05,343.35L1049.55,346.35L1052.05,350.35L1033.25,362.65L1017.25,375.25L1009.45,378.05L1003.25,378.75L1003.15,374.65L1000.55,373.55L997.05,371.75L995.75,368.75L977.05,354.75L958.45,340.75L937.95,325.15L938.05,323.95L938.15,323.55L938.25,315.95L947.15,311.15L952.55,310.15L957.05,308.45L959.15,305.25L965.55,302.75L965.85,297.95L968.95,297.35L971.45,295.05L978.55,293.95L979.55,291.45L978.15,290.05L976.25,283.25L975.95,279.35L974.05,275.25L979.15,271.75L984.95,270.65L988.25,268.05L993.35,266.05L1002.35,264.95L1011.15,264.45L1013.85,265.35L1018.75,262.85L1024.45,262.75L1026.65,264.25L1030.25,263.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EC" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M558.25,502.05L559.05,506.95L557.35,511.05L551.25,517.85L544.55,520.35L541.15,525.95L540.25,530.25L537.15,532.95L534.65,529.65L532.35,528.95L530.05,529.45L529.75,527.15L531.35,525.65L530.65,522.95L533.55,518.15L532.25,515.35L530.15,518.35L526.65,515.45L527.75,513.65L526.75,507.85L528.75,506.85L529.75,502.85L531.85,498.75L531.55,496.15L534.65,494.75L538.55,492.25L544.15,495.85L545.25,495.75L546.65,498.55L551.45,499.45L553.05,498.45L555.85,500.55L558.25,502.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1171.35,300.65L1175.25,310.05L1175.95,311.65L1174.65,314.25L1173.95,319.05L1172.75,322.45L1171.55,323.55L1169.55,321.45L1166.85,318.65L1162.15,309.45L1161.65,310.05L1164.45,316.75L1168.35,323.25L1173.25,333.25L1175.55,336.75L1177.55,340.35L1182.95,347.45L1181.95,348.55L1182.35,352.75L1189.15,358.55L1190.25,359.85L1124.35,359.85L1123.35,336.15L1122.05,313.35L1120.05,308.15L1121.15,304.25L1120.15,301.45L1121.85,298.35L1129.05,298.25L1134.45,299.95L1139.95,301.85L1142.55,302.85L1146.55,300.85L1148.65,299.05L1153.35,298.45L1157.25,299.25L1159.05,302.45L1160.15,300.35L1164.55,301.85L1168.85,302.25L1171.35,300.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ER" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1228.15,419.55L1226.45,421.15L1224.05,420.55L1222.05,418.45L1219.55,414.75L1216.95,412.65L1215.45,410.45L1210.45,407.85L1206.55,407.75L1205.15,406.45L1201.95,407.95L1198.35,405.05L1196.85,409.85L1190.25,408.45L1189.55,405.95L1191.55,396.45L1191.85,392.25L1193.55,390.25L1197.55,389.15L1200.25,385.55L1203.85,392.95L1205.75,398.85L1208.95,401.95L1216.95,408.05L1220.25,411.65L1223.45,415.45L1225.25,417.65L1228.15,419.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1112.95,123.85L1113.85,124.85L1111.25,128.25L1113.65,133.85L1112.05,135.75L1108.25,135.65L1103.85,133.45L1101.75,132.75L1097.95,133.75L1097.85,130.25L1096.35,131.05L1093.05,128.95L1092.05,125.55L1097.55,123.85L1103.15,123.05L1108.25,123.95L1112.95,123.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ET" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1206.55,407.75L1210.45,407.85L1215.45,410.45L1216.95,412.65L1219.55,414.75L1222.05,418.45L1224.05,420.55L1222.15,423.35L1220.35,426.35L1220.85,428.15L1221.05,430.15L1224.25,430.25L1225.55,429.75L1226.85,430.95L1225.65,433.15L1227.85,436.75L1230.05,439.85L1232.25,442.15L1250.95,449.75L1255.75,449.65L1240.15,468.95L1232.85,469.25L1227.85,473.75L1224.25,473.85L1222.75,475.95L1218.85,475.95L1216.55,473.75L1211.35,476.45L1209.75,479.15L1205.95,478.55L1204.65,477.85L1203.35,478.05L1201.55,477.95L1194.35,472.55L1190.35,472.55L1188.45,470.45L1188.35,466.85L1185.45,465.75L1181.95,458.75L1179.35,457.25L1178.35,454.65L1175.35,451.55L1171.85,451.05L1173.75,447.45L1176.75,447.25L1177.55,445.35L1177.35,440.35L1177.35,439.55L1178.85,432.85L1181.45,431.05L1181.95,428.45L1184.25,423.45L1187.55,420.35L1189.55,413.95L1190.25,408.45L1196.85,409.85L1198.35,405.05L1201.95,407.95L1205.15,406.45L1206.55,407.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="FI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1103.35,69.35L1103.75,73.15L1111.05,76.85L1108.15,81.05L1114.65,87.35L1112.95,92.15L1117.85,96.35L1116.95,100.15L1124.35,104.05L1123.45,106.95L1120.05,110.35L1112.05,117.75L1104.05,118.25L1096.45,120.35L1089.35,121.65L1086.15,118.45L1081.45,116.55L1081.55,110.75L1078.55,105.55L1080.15,102.15L1083.45,98.65L1092.25,92.45L1094.85,91.25L1093.95,88.85L1087.45,86.25L1085.65,84.05L1083.85,75.55L1076.65,71.85L1070.65,69.15L1072.85,67.75L1077.95,70.55L1083.25,70.35L1087.95,71.65L1091.35,69.25L1092.45,65.25L1098.35,63.45L1104.15,65.55L1103.35,69.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1059.75,486.55L1059.35,489.35L1060.95,492.65L1065.15,492.15L1066.55,493.35L1064.05,500.85L1066.75,504.65L1067.35,509.65L1066.65,513.95L1064.95,516.95L1059.95,516.65L1056.85,513.55L1056.45,516.45L1052.65,517.25L1050.65,518.85L1052.75,523.05L1048.45,526.65L1042.65,520.15L1038.95,514.85L1035.45,508.25L1035.65,506.05L1036.95,504.05L1038.25,499.35L1039.45,494.55L1041.35,494.25L1049.55,494.25L1049.55,486.55L1052.25,486.15L1055.65,486.95L1059.05,486.15L1059.75,486.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.95,157.45L952.45,156.25L949.45,156.35L950.65,153.05L949.75,149.85L953.75,149.55L958.65,153.35L955.95,157.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M971.85,128.75L966.75,135.25L971.45,134.45L976.55,134.45L975.25,139.35L970.95,144.75L975.85,145.05L976.15,145.75L980.35,152.85L983.55,153.85L986.45,160.85L987.85,163.25L993.75,164.35L993.15,168.35L990.75,170.15L992.65,173.35L988.25,176.55L981.75,176.45L973.35,178.25L971.15,176.95L967.85,179.85L963.35,179.15L959.75,181.55L957.25,180.35L964.55,173.85L968.95,172.45L961.35,171.45L960.05,168.95L965.15,167.05L962.65,163.75L963.65,159.75L970.75,160.35L971.55,156.75L968.45,153.05L968.35,152.95L962.65,151.85L961.55,150.25L963.35,147.55L961.85,145.85L959.25,148.75L959.15,142.85L956.95,139.85L958.85,133.65L962.65,128.85L966.25,129.25L971.85,128.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1214.95,227.15L1220.05,228.45L1222.15,231.05L1225.75,232.55L1224.55,233.35L1227.85,236.85L1227.25,237.55L1224.35,237.25L1220.15,235.35L1219.05,236.45L1212.05,237.45L1206.45,234.25L1200.95,234.55L1201.25,231.85L1199.15,227.55L1195.75,225.15L1192.75,224.45L1190.55,222.55L1190.95,221.75L1195.55,222.85L1203.25,223.85L1210.85,226.95L1212.05,228.15L1214.95,227.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M985.75,430.35L985.35,432.35L987.65,435.65L987.65,440.35L988.25,445.35L989.65,447.75L988.35,453.45L988.85,456.65L990.35,460.75L991.65,463.05L982.75,466.75L979.55,468.95L974.45,470.85L969.45,469.05L969.65,466.45L967.25,460.95L968.75,453.65L971.15,448.35L969.65,439.15L968.85,434.35L969.05,430.65L978.85,430.35L981.35,430.85L983.15,429.85L985.75,430.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M920.75,421.15L921.05,423.55L921.95,423.55L923.45,422.65L924.35,422.85L925.95,424.55L928.35,425.05L929.85,423.65L931.75,422.75L933.05,421.85L934.15,422.05L935.45,423.45L936.05,425.25L938.35,427.95L937.25,429.55L936.95,431.65L938.15,431.05L938.85,431.75L938.55,433.65L940.25,435.55L939.15,436.05L938.65,438.25L939.95,440.85L941.35,446.05L939.25,446.75L938.75,447.65L939.15,448.95L938.75,451.75L937.85,451.75L936.25,451.55L935.15,454.15L933.55,454.15L932.45,452.75L932.85,450.15L930.45,446.25L929.05,446.95L927.75,447.15L926.25,447.45L926.35,445.15L925.45,443.45L925.65,441.55L924.45,438.85L922.85,436.55L918.35,436.55L917.05,437.75L915.45,437.95L914.45,439.35L913.85,441.05L910.75,443.95L908.35,440.15L906.15,437.65L904.75,436.75L903.35,435.45L902.75,432.65L901.95,431.25L900.25,430.15L902.85,427.05L904.55,427.15L906.05,426.15L907.25,426.05L908.15,425.25L907.75,423.15L908.35,422.45L908.45,420.25L911.15,420.35L915.25,421.85L916.45,421.75L916.85,421.05L919.95,421.55L920.75,421.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M890.85,416.65L891.65,413.75L897.75,413.65L899.05,412.05L900.85,411.95L903.05,413.55L904.75,413.55L906.65,412.55L907.75,414.35L905.25,415.85L902.85,415.65L900.45,414.35L898.35,415.85L897.35,415.85L895.95,416.75L890.85,416.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M908.45,420.25L908.35,422.45L907.75,423.15L908.15,425.25L907.25,426.05L906.05,426.15L904.55,427.15L902.85,427.05L900.25,430.15L897.35,427.55L894.95,427.05L893.65,425.25L893.75,424.25L892.05,422.95L891.65,421.55L894.65,420.55L896.55,420.75L898.05,419.95L908.45,420.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GQ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1049.55,486.55L1049.55,494.25L1041.35,494.25L1039.45,494.55L1038.35,493.65L1040.25,486.45L1049.55,486.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1111.95,271.85L1115.05,274.05L1119.15,273.65L1123.15,274.05L1123.15,275.25L1125.95,274.45L1125.45,276.35L1117.85,276.85L1117.75,275.85L1111.15,274.55L1111.95,271.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1121.15,239.15L1117.95,238.95L1115.25,238.35L1109.05,239.95L1113.05,243.55L1110.55,244.65L1107.65,244.65L1104.55,241.35L1103.65,242.75L1105.25,246.55L1108.15,249.55L1106.25,250.95L1109.45,253.85L1112.25,255.75L1112.65,259.35L1107.65,257.65L1109.45,260.95L1106.15,261.55L1108.65,267.25L1105.15,267.35L1100.55,264.55L1098.15,259.45L1096.85,255.15L1094.55,252.25L1091.55,248.55L1091.05,246.75L1093.25,243.65L1093.35,241.55L1095.05,240.65L1094.95,238.95L1098.35,238.45L1100.15,237.05L1102.95,237.15L1103.75,236.05L1104.75,235.85L1108.55,236.05L1112.55,234.25L1116.45,236.55L1121.05,235.95L1120.75,232.75L1123.45,234.45L1122.35,238.45L1121.15,239.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M895.55,0.65L915.45,3.65L908.75,5.05L895.75,5.25L877.25,5.65L878.65,6.35L890.95,5.85L900.65,7.25L907.65,6.05L910.05,7.45L905.55,9.85L914.75,8.25L931.85,6.75L941.85,7.55L943.55,9.25L928.75,12.15L926.55,13.15L915.15,13.95L923.25,14.15L918.35,17.35L914.75,20.25L913.55,25.45L917.25,28.65L911.35,28.75L904.85,30.35L911.15,32.95L911.05,37.15L906.85,37.65L910.95,41.95L902.25,42.35L906.25,44.35L904.65,46.15L898.95,46.95L893.45,47.05L897.65,50.45L897.15,52.85L889.85,50.65L887.45,52.05L892.45,53.35L897.05,56.55L897.65,60.85L890.25,61.85L887.55,59.75L883.35,56.75L883.85,60.35L878.45,63.15L889.15,63.35L894.65,63.65L882.75,68.35L870.55,72.65L857.85,74.45L853.25,74.55L848.35,76.65L840.85,82.45L830.65,86.35L827.65,86.65L821.55,87.95L814.95,89.35L810.15,92.75L808.75,96.75L805.35,100.55L796.75,105.15L797.05,109.65L793.45,114.45L789.35,120.15L782.85,120.55L777.85,115.75L768.85,115.65L765.65,112.45L764.85,106.85L760.05,99.65L759.35,95.95L760.85,90.85L757.15,85.75L760.45,81.65L758.55,79.65L765.55,73.25L772.75,71.15L775.35,68.95L778.15,64.75L772.65,66.65L770.05,67.45L765.95,68.15L761.75,66.45L763.25,62.75L766.25,59.95L770.05,59.85L777.65,61.35L772.35,57.95L769.65,56.15L765.25,56.85L762.65,55.55L769.65,50.75L768.35,48.75L767.25,45.25L765.85,39.85L762.25,37.95L763.65,35.85L755.55,32.95L747.85,32.55L737.75,32.75L728.25,33.15L725.15,31.55L721.35,28.45L732.35,26.95L739.95,26.75L725.35,25.45L718.85,23.55L721.05,21.75L736.75,19.55L751.75,17.35L754.55,15.75L746.45,14.15L751.05,12.45L765.75,9.55L771.15,9.15L771.35,7.35L780.35,6.25L791.35,5.65L801.75,5.65L804.55,6.85L815.15,4.65L822.25,6.15L826.85,6.45L833.05,7.75L826.35,5.65L827.95,3.95L840.65,1.75L852.25,1.95L857.35,0.55L869.25,0.25L895.55,0.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M487.35,386.75L486.65,391.85L485.35,399.05L487.05,399.05L488.75,400.25L489.35,399.25L490.85,400.05L488.05,402.55L485.15,404.35L484.65,405.55L484.95,406.85L483.65,408.45L482.25,408.85L482.55,409.65L481.35,410.35L479.35,411.95L479.05,412.85L476.25,411.75L472.75,411.65L470.35,410.35L467.55,407.75L467.95,405.85L468.75,404.35L468.05,403.15L471.35,397.95L478.55,397.95L478.95,395.75L478.15,395.35L477.65,393.95L475.75,392.45L473.95,390.35L476.45,390.25L476.95,386.65L482.15,386.65L487.35,386.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M662.15,462.75L661.15,468.55L657.65,470.15L657.95,471.65L656.85,475.05L659.25,479.65L661.05,479.65L661.75,483.25L665.05,488.85L663.75,489.15L660.55,488.55L658.75,490.25L656.15,491.35L654.35,491.65L653.75,492.95L650.95,492.65L647.45,489.65L647.15,486.65L645.75,483.35L646.75,477.95L648.35,475.65L647.15,472.65L645.15,471.75L645.95,468.85L644.75,467.45L641.75,467.65L638.05,462.85L639.65,461.05L639.65,458.05L643.15,457.05L644.55,455.85L642.75,453.45L643.25,451.15L647.95,447.35L651.55,449.75L654.85,453.85L654.95,457.25L657.05,457.35L660.05,460.45L662.15,462.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M518.85,404.75L516.95,404.65L516.05,405.55L514.05,406.35L512.65,406.35L511.35,407.15L510.25,406.95L509.35,405.95L508.75,406.15L507.85,407.65L507.35,407.55L507.15,408.95L505.05,410.65L503.85,411.45L503.25,412.25L501.75,410.95L500.35,412.65L499.15,412.65L497.85,412.75L497.65,415.95L496.85,415.95L496.05,417.45L494.25,417.75L493.45,415.75L491.75,415.15L492.45,412.55L491.75,411.85L490.55,411.45L488.05,412.15L487.95,411.35L486.35,410.25L485.25,409.05L483.65,408.45L484.95,406.85L484.65,405.55L485.15,404.35L488.05,402.55L490.85,400.05L491.45,400.35L492.75,399.25L494.35,399.15L494.85,399.65L495.75,399.35L498.35,399.95L500.95,399.75L502.75,399.05L503.55,398.35L505.25,398.65L506.55,399.05L508.05,398.95L509.25,398.35L511.75,399.25L512.55,399.45L514.15,400.65L515.65,402.05L517.55,403.05L518.85,404.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1080.75,206.85L1082.25,209.35L1083.95,211.15L1082.25,213.55L1079.85,212.15L1076.35,212.25L1071.85,211.15L1069.55,211.25L1068.55,212.65L1066.55,211.15L1065.75,213.75L1068.45,216.75L1069.75,218.65L1072.25,221.05L1074.35,222.45L1076.45,225.15L1081.25,227.55L1080.75,228.55L1075.75,226.25L1072.55,223.95L1067.75,222.05L1063.05,217.45L1064.05,216.95L1061.55,214.25L1061.25,212.15L1057.95,211.15L1056.55,213.85L1054.95,211.75L1054.95,209.55L1055.05,209.45L1058.65,209.65L1059.45,208.65L1061.25,209.65L1063.25,209.75L1063.15,208.05L1064.85,207.35L1065.15,204.85L1069.05,203.15L1070.65,203.95L1074.65,206.65L1078.95,207.85L1080.75,206.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M586.05,374.55L586.15,377.95L585.45,380.45L583.95,381.55L585.25,383.45L584.95,385.25L581.35,384.15L578.65,384.55L575.25,384.15L572.55,385.35L569.75,383.35L570.45,381.25L575.55,382.15L579.65,382.65L581.85,381.25L579.55,378.45L579.95,375.95L576.45,374.95L577.95,373.25L581.35,373.45L586.05,374.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="HU" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1095.45,191.15L1098.45,192.85L1098.95,194.55L1096.05,195.85L1094.15,200.05L1091.55,204.35L1087.65,205.55L1084.45,205.25L1080.75,206.85L1078.95,207.85L1074.65,206.65L1070.65,203.95L1069.05,203.15L1067.85,201.05L1067.05,200.95L1068.35,196.95L1067.25,195.55L1070.05,195.55L1070.25,192.95L1072.95,194.65L1074.85,195.25L1078.95,194.55L1079.25,193.25L1081.15,193.05L1083.45,192.15L1084.05,192.55L1086.35,191.75L1087.35,190.25L1088.95,189.85L1094.45,191.75L1095.45,191.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1666.75,566.85L1664.35,566.95L1657.25,562.45L1662.65,561.15L1665.45,563.15L1667.25,565.05L1666.75,566.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1691.55,558.15L1692.05,559.45L1691.95,561.35L1687.85,566.15L1682.85,567.55L1682.25,566.85L1682.95,564.65L1685.75,560.75L1691.55,558.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1651.95,553.05L1653.85,554.75L1657.45,554.25L1658.65,556.95L1651.95,558.25L1648.05,559.15L1644.95,559.05L1647.15,555.35L1650.35,555.35L1651.95,553.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1680.25,553.05L1679.15,556.65L1670.55,558.45L1663.05,557.65L1663.25,555.25L1667.85,553.95L1671.25,555.85L1675.05,555.35L1680.25,553.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1600.05,544.55L1610.85,545.25L1612.25,542.55L1622.55,545.65L1624.35,549.85L1632.75,551.05L1639.45,554.85L1632.85,557.25L1626.75,554.65L1621.65,554.85L1615.85,554.35L1610.65,553.25L1604.25,550.75L1600.15,550.15L1597.75,550.95L1587.55,548.25L1586.75,545.55L1581.65,545.05L1585.85,538.95L1592.65,539.35L1597.05,541.85L1599.45,542.35L1600.05,544.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1747.95,540.95L1744.75,545.35L1744.55,540.55L1745.65,538.25L1746.95,536.05L1748.15,537.95L1747.95,540.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1706.55,523.25L1704.35,525.45L1700.55,524.25L1699.55,521.45L1705.25,521.15L1706.55,523.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1724.95,520.95L1726.75,525.85L1722.15,523.15L1717.45,522.65L1714.15,523.05L1710.25,522.85L1711.75,519.35L1718.75,519.05L1724.95,520.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1784.75,517.75L1783.75,538.65L1782.15,559.65L1777.55,554.35L1771.95,553.05L1770.45,554.85L1763.25,555.05L1766.05,549.85L1769.75,548.05L1768.75,541.05L1766.45,535.75L1755.75,530.25L1751.15,529.75L1742.85,523.75L1741.05,526.95L1738.85,527.45L1737.75,525.15L1737.85,522.35L1733.65,519.15L1739.85,516.85L1743.85,516.95L1743.45,515.25L1735.15,515.25L1732.95,511.45L1727.95,510.25L1725.65,507.05L1733.25,505.55L1736.15,503.45L1745.25,506.05L1746.15,508.45L1747.45,518.85L1753.15,522.65L1758.15,515.85L1764.75,512.05L1769.75,512.05L1774.55,514.25L1778.65,516.55L1784.75,517.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1695.65,491.95L1691.15,498.35L1686.85,499.55L1681.45,498.35L1671.95,498.65L1667.05,499.55L1666.25,504.45L1671.25,510.15L1674.35,507.25L1684.95,505.05L1684.45,507.95L1681.95,507.05L1679.45,510.85L1674.35,513.35L1679.45,521.55L1678.35,523.75L1683.15,531.15L1682.85,535.35L1679.75,537.25L1677.65,534.95L1680.65,529.75L1674.95,532.25L1673.65,530.45L1674.45,527.95L1670.55,524.15L1671.25,517.95L1667.35,519.85L1667.55,527.35L1667.35,536.55L1663.65,537.45L1661.35,535.65L1663.25,529.75L1662.65,523.55L1660.25,523.45L1658.65,519.05L1661.15,514.85L1662.05,509.75L1665.05,500.05L1666.15,497.45L1670.95,492.65L1675.45,494.55L1682.55,495.45L1689.05,495.15L1694.65,490.55L1695.65,491.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1715.25,493.85L1714.95,499.45L1712.05,498.75L1711.15,502.65L1713.45,506.05L1711.85,506.85L1709.65,502.75L1707.95,494.55L1708.95,489.45L1710.75,487.15L1711.25,490.65L1714.65,491.15L1715.25,493.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1607.25,488.15L1608.25,492.45L1612.15,496.15L1615.85,494.85L1619.45,495.25L1622.75,492.05L1625.45,491.45L1630.85,493.25L1635.45,491.85L1638.05,482.95L1640.15,480.75L1641.85,473.45L1648.35,473.45L1653.35,474.55L1650.35,480.35L1654.75,486.35L1653.85,489.35L1660.25,495.25L1653.55,496.05L1651.75,500.45L1651.95,506.25L1646.45,510.65L1646.05,517.05L1643.55,526.85L1642.85,524.55L1636.25,527.45L1634.15,523.55L1630.15,523.15L1627.35,521.05L1620.55,523.45L1618.65,520.25L1614.85,520.65L1610.25,519.95L1609.65,511.35L1606.85,509.55L1604.15,504.05L1603.35,498.45L1603.95,492.45L1607.25,488.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1584.45,538.65L1578.25,538.75L1573.75,533.45L1566.65,528.15L1564.35,524.25L1560.25,519.05L1557.55,514.25L1553.35,505.25L1548.45,499.85L1546.75,494.35L1544.55,489.35L1539.35,485.35L1536.25,479.85L1531.85,476.25L1525.65,469.15L1525.05,465.85L1528.65,466.15L1537.55,467.35L1542.75,473.65L1547.35,478.05L1550.55,480.65L1556.05,487.55L1561.85,487.65L1566.65,492.05L1570.05,497.45L1574.35,500.45L1572.05,505.65L1575.35,507.85L1577.35,508.05L1578.25,512.55L1580.15,516.05L1584.25,516.65L1586.85,520.75L1585.15,528.75L1584.45,538.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1426.85,307.25L1424.05,310.25L1423.15,316.25L1428.95,318.65L1434.75,321.75L1442.55,325.35L1450.25,326.25L1454.05,329.45L1458.35,330.05L1465.25,331.55L1469.85,331.45L1469.95,328.95L1468.45,324.85L1468.25,322.15L1471.35,320.75L1472.85,325.85L1473.25,327.05L1478.75,329.55L1481.95,328.55L1486.65,328.95L1491.15,328.75L1490.65,324.85L1488.05,322.75L1492.25,321.95L1496.15,317.15L1501.55,313.15L1506.45,314.65L1509.65,311.95L1513.25,315.95L1512.05,318.65L1518.15,319.65L1519.15,322.05L1517.45,323.25L1518.85,327.15L1514.65,326.05L1508.45,330.45L1509.35,334.15L1507.35,339.55L1507.65,342.65L1506.05,347.95L1501.45,346.45L1502.35,353.15L1501.35,355.35L1502.35,358.05L1499.85,359.55L1495.45,349.35L1493.95,349.35L1493.65,353.55L1490.05,350.15L1491.25,346.55L1493.65,346.15L1495.25,340.75L1491.85,339.65L1486.75,339.75L1481.35,338.85L1480.15,334.35L1477.45,334.05L1472.55,331.25L1471.35,335.65L1475.95,339.05L1472.95,341.45L1472.05,343.75L1475.75,345.45L1475.45,349.35L1478.05,354.15L1479.65,359.45L1479.15,361.85L1475.35,361.75L1468.75,363.05L1469.65,367.85L1467.25,371.65L1459.75,376.05L1454.45,383.55L1450.65,387.65L1445.65,391.85L1445.95,394.75L1443.35,396.35L1438.55,398.65L1435.95,398.95L1434.75,403.85L1436.65,412.25L1437.35,417.55L1435.45,423.65L1436.15,434.55L1433.25,434.85L1430.95,439.75L1432.85,441.95L1427.75,443.75L1426.05,448.05L1423.85,449.95L1418.25,443.95L1415.15,434.95L1412.65,428.45L1410.45,425.45L1407.05,419.25L1405.05,411.25L1403.65,407.25L1397.75,398.45L1394.25,385.95L1391.65,377.75L1390.85,369.95L1389.15,363.95L1381.45,367.85L1377.45,367.05L1369.35,359.25L1371.75,356.95L1369.85,354.45L1362.75,348.95L1365.95,344.65L1378.05,344.65L1376.25,339.15L1372.75,335.95L1371.35,330.95L1367.35,328.15L1372.25,321.35L1378.75,321.85L1383.25,315.15L1385.45,308.65L1389.35,302.15L1388.35,297.55L1392.15,293.85L1387.05,290.75L1384.15,286.35L1380.85,280.75L1382.85,277.95L1391.35,279.55L1397.05,278.55L1400.85,273.15L1408.55,280.75L1409.35,285.95L1412.35,289.25L1412.95,292.55L1408.85,291.65L1412.05,298.75L1418.25,302.75L1426.85,307.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.95,157.45L956.65,161.85L952.75,167.35L943.95,170.95L937.15,170.05L941.45,163.65L939.35,157.45L946.05,152.65L949.75,149.85L950.65,153.05L949.45,156.35L952.45,156.25L955.95,157.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1228.25,252.45L1230.05,252.25L1235.35,247.55L1237.25,247.05L1239.15,248.95L1237.95,252.05L1241.85,255.45L1243.15,255.05L1245.65,259.85L1250.95,261.15L1255.25,264.35L1262.95,265.45L1270.95,263.75L1271.15,262.25L1275.55,261.05L1278.55,257.35L1282.15,257.55L1284.15,256.35L1288.05,256.95L1294.65,260.25L1298.95,260.95L1306.25,266.55L1310.25,266.85L1311.95,272.15L1311.35,280.15L1310.85,284.85L1313.35,285.85L1311.75,289.35L1314.45,294.45L1315.65,298.55L1319.95,299.65L1321.05,303.75L1317.15,309.55L1320.35,312.95L1323.15,316.85L1328.85,319.65L1329.85,325.25L1332.55,326.35L1333.45,329.25L1325.95,332.65L1324.85,340.05L1314.25,338.15L1308.05,336.65L1301.75,335.85L1298.45,327.95L1295.65,326.85L1291.55,327.95L1286.45,331.05L1279.45,328.95L1273.35,323.95L1267.85,322.15L1263.45,316.05L1258.25,307.55L1255.45,308.55L1251.75,306.45L1250.05,308.95L1246.55,305.55L1246.05,302.15L1244.35,302.15L1244.55,297.45L1241.05,292.65L1233.95,289.05L1229.35,282.95L1229.85,277.95L1232.15,275.75L1231.25,272.05L1227.45,270.05L1222.75,262.45L1218.95,257.35L1219.65,255.35L1216.75,248.05L1220.05,246.15L1221.25,248.65L1224.45,251.55L1228.25,252.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IQ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1222.75,262.45L1227.45,270.05L1231.25,272.05L1232.15,275.75L1229.85,277.95L1229.35,282.95L1233.95,289.05L1241.05,292.65L1244.55,297.45L1244.35,302.15L1246.05,302.15L1246.55,305.55L1250.05,308.95L1246.75,308.65L1243.05,308.05L1239.75,314.25L1229.55,313.75L1212.75,300.85L1204.15,296.35L1197.35,294.55L1194.25,286.75L1205.25,280.05L1206.25,272.35L1205.05,267.65L1207.75,266.05L1209.85,262.05L1211.95,261.05L1218.25,261.95L1220.35,263.55L1222.75,262.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M924.05,83.75L922.65,87.35L927.05,91.15L920.95,95.45L907.85,99.35L903.95,100.45L898.35,99.55L886.45,97.75L891.25,95.25L882.25,92.55L890.15,91.45L890.25,89.75L881.45,88.45L885.05,84.75L891.65,83.95L897.65,87.75L904.65,84.75L909.75,86.25L917.05,83.35L924.05,83.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="IL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1178.35,287.45L1178.75,290.05L1178.15,291.05L1178.25,291.05L1177.55,293.05L1175.45,292.25L1174.75,296.45L1176.25,297.15L1174.95,298.05L1174.85,299.75L1177.35,298.95L1177.75,301.45L1175.95,311.65L1175.25,310.05L1171.35,300.65L1172.75,298.55L1172.35,298.15L1173.45,295.15L1174.05,290.35L1174.65,288.65L1176.55,288.65L1176.95,287.55L1178.35,287.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1067.45,255.65L1065.75,260.75L1066.65,262.65L1065.75,265.95L1061.55,263.55L1058.85,262.85L1051.35,259.65L1051.85,256.35L1058.05,256.95L1063.45,256.25L1067.45,255.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1033.45,236.65L1036.75,241.15L1036.35,249.65L1033.95,249.25L1031.85,251.35L1029.85,249.65L1029.35,241.95L1028.05,238.35L1030.95,238.65L1033.45,236.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1055.15,203.15L1054.75,206.25L1056.15,208.95L1052.05,207.95L1048.15,210.25L1048.55,213.35L1048.05,215.15L1049.95,218.35L1054.95,221.55L1057.85,226.85L1063.95,231.95L1067.95,231.85L1069.35,233.25L1067.95,234.55L1072.75,236.85L1076.75,238.75L1081.45,242.15L1082.05,243.25L1081.25,245.55L1078.15,242.55L1073.55,241.55L1071.65,245.65L1075.55,248.05L1075.15,251.35L1073.05,251.75L1070.55,257.25L1068.35,257.75L1068.25,255.75L1069.15,252.35L1070.25,250.95L1067.95,247.25L1066.15,244.05L1063.95,243.25L1062.15,240.55L1058.75,239.35L1056.35,236.75L1052.55,236.35L1048.25,233.55L1043.35,229.35L1039.65,225.75L1037.75,219.45L1035.15,218.75L1030.95,216.65L1028.65,217.45L1025.75,220.45L1023.65,220.85L1024.15,218.15L1021.35,217.35L1019.85,212.45L1021.55,210.55L1020.05,208.15L1020.15,206.35L1022.35,207.75L1024.85,207.45L1027.55,205.25L1028.45,206.25L1030.85,206.05L1031.85,203.55L1035.65,204.35L1037.75,203.25L1038.05,200.75L1041.15,201.65L1041.65,200.45L1046.55,199.35L1047.85,201.45L1055.15,203.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="JM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M555.75,386.35L553.95,387.45L550.95,386.35L548.05,384.05L548.85,382.55L551.25,382.15L552.55,382.35L556.25,382.95L558.95,384.45L559.75,386.25L555.75,386.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="JO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1197.35,294.55L1196.45,295.55L1186.05,298.75L1192.05,305.25L1190.45,306.25L1189.75,308.45L1185.65,309.35L1184.55,311.65L1182.45,313.65L1176.25,312.55L1175.95,311.65L1177.75,301.45L1177.35,298.95L1177.95,297.05L1177.55,293.05L1178.25,291.05L1184.55,293.65L1194.25,286.75L1197.35,294.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1707.75,281.85L1709.35,284.05L1708.05,287.95L1704.95,285.85L1702.85,287.35L1702.95,291.05L1698.65,289.25L1697.45,286.25L1698.75,282.35L1702.15,283.15L1703.15,280.45L1707.75,281.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1732.35,262.65L1732.95,267.75L1735.45,270.95L1734.85,275.45L1729.45,278.45L1720.25,278.85L1715.85,286.25L1711.15,283.75L1708.75,278.95L1700.15,280.35L1695.05,283.35L1688.85,283.55L1696.25,288.25L1697.05,299.15L1694.55,301.85L1690.95,299.35L1690.05,293.55L1685.95,291.75L1681.95,287.35L1686.25,285.35L1687.35,281.25L1691.25,277.95L1693.25,273.55L1702.95,271.65L1709.25,272.95L1709.25,261.55L1714.35,264.65L1718.85,258.25L1720.55,255.75L1719.55,247.95L1714.45,240.75L1714.25,236.75L1719.05,235.55L1727.25,244.45L1730.05,249.55L1728.75,256.05L1732.35,262.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1720.45,217.85L1724.95,219.15L1726.75,216.55L1732.75,223.65L1726.35,225.35L1725.95,231.65L1715.05,227.35L1716.65,234.25L1710.95,234.35L1706.25,228.05L1705.65,223.15L1710.85,222.85L1706.45,214.05L1704.65,209.15L1715.15,215.75L1720.45,217.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1337.55,159.75L1341.95,159.45L1351.15,153.65L1350.35,155.65L1358.75,160.35L1377.05,175.95L1378.15,172.75L1386.55,176.25L1392.75,174.65L1396.05,175.75L1400.15,179.35L1404.15,180.55L1407.45,183.25L1413.45,182.35L1417.85,186.15L1415.95,190.35L1412.15,190.95L1414.65,197.15L1413.05,200.05L1402.25,197.95L1403.25,209.25L1401.25,210.65L1392.15,213.15L1400.95,224.15L1398.05,225.75L1399.75,229.45L1396.25,228.45L1392.85,226.15L1384.95,225.55L1376.35,225.35L1374.75,226.05L1366.55,223.35L1364.05,224.75L1364.55,228.45L1355.35,226.25L1352.25,227.15L1351.95,229.95L1349.35,231.15L1343.95,235.55L1343.05,240.15L1341.05,240.15L1338.75,237.15L1332.05,236.95L1329.55,231.75L1326.95,231.65L1325.45,225.25L1317.85,220.65L1309.25,221.15L1303.55,222.05L1296.95,216.35L1292.15,213.95L1282.95,209.45L1281.85,208.95L1269.85,212.65L1276.05,236.05L1273.45,236.35L1268.65,231.35L1264.75,229.55L1259.15,230.85L1257.35,233.05L1256.75,231.45L1257.35,228.85L1255.85,226.65L1249.35,224.45L1245.65,218.75L1242.45,217.15L1241.85,215.05L1246.95,215.65L1245.95,211.05L1250.05,210.05L1254.75,210.95L1254.05,204.85L1252.15,200.95L1247.15,201.25L1242.45,199.75L1237.35,202.45L1232.95,203.85L1230.15,202.75L1229.95,199.55L1225.65,195.35L1222.05,195.55L1216.75,191.35L1218.45,186.55L1216.65,185.35L1218.85,178.45L1224.85,182.05L1224.25,177.55L1232.35,170.85L1239.95,170.65L1251.95,174.95L1258.55,177.45L1262.95,174.85L1270.65,174.75L1277.95,177.95L1278.75,176.05L1285.75,176.35L1285.95,173.45L1276.55,169.15L1280.05,166.15L1278.55,164.55L1282.55,162.95L1277.45,158.75L1278.85,156.65L1295.85,154.55L1297.55,153.05L1308.45,150.75L1311.55,148.25L1320.65,149.55L1325.05,155.85L1329.35,154.35L1336.45,156.45L1337.55,159.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1222.75,475.95L1217.85,483.15L1218.05,506.55L1221.35,511.85L1217.35,514.45L1215.95,517.15L1213.75,517.55L1212.95,522.15L1211.05,524.75L1209.95,528.95L1207.65,531.05L1199.55,524.65L1199.25,520.95L1178.75,507.85L1179.15,503.15L1177.75,500.65L1177.75,500.35L1179.35,497.75L1182.15,493.55L1184.25,488.85L1181.65,481.45L1180.95,478.25L1178.25,473.75L1181.65,469.95L1185.45,465.75L1188.35,466.85L1188.45,470.45L1190.35,472.55L1194.35,472.55L1201.55,477.95L1203.35,478.05L1204.65,477.85L1205.95,478.55L1209.75,479.15L1211.35,476.45L1216.55,473.75L1218.85,475.95L1222.75,475.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1399.75,229.45L1399.55,230.85L1392.65,234.25L1391.65,236.85L1385.25,237.55L1384.65,241.65L1378.85,240.75L1375.65,242.05L1371.55,245.05L1372.75,246.55L1371.65,247.95L1362.05,248.95L1354.95,246.85L1349.45,247.35L1348.85,243.75L1354.85,244.75L1356.25,242.85L1360.35,243.45L1365.65,238.85L1358.45,235.45L1355.25,237.05L1350.65,234.65L1353.65,230.55L1351.95,229.95L1352.25,227.15L1355.35,226.25L1364.55,228.45L1364.05,224.75L1366.55,223.35L1374.75,226.05L1376.35,225.35L1384.95,225.55L1392.85,226.15L1396.25,228.45L1399.75,229.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1589.05,409.85L1590.85,414.15L1590.95,421.85L1581.95,426.85L1584.75,430.65L1578.85,431.15L1574.25,433.75L1569.45,432.85L1566.85,429.45L1563.35,422.85L1561.25,415.05L1564.35,409.75L1571.45,408.55L1576.75,409.45L1581.75,411.95L1583.75,407.55L1589.05,409.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1652.15,258.75L1652.15,258.15L1654.65,258.35L1655.25,255.55L1658.85,255.15L1660.85,254.75L1660.85,253.25L1669.15,260.75L1672.45,264.95L1675.85,272.35L1675.35,275.85L1671.05,277.05L1667.95,279.75L1663.35,280.25L1661.25,276.75L1660.15,271.95L1654.85,265.35L1658.25,264.25L1652.15,258.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1246.75,308.65L1248.25,311.45L1247.95,312.95L1250.35,317.75L1246.45,317.95L1244.75,314.85L1239.75,314.25L1243.05,308.05L1246.75,308.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1589.05,409.85L1583.75,407.55L1581.75,411.95L1576.75,409.45L1578.25,406.55L1577.85,401.15L1572.55,395.55L1571.25,389.15L1566.25,383.95L1561.95,383.55L1561.15,385.75L1557.95,385.95L1556.05,384.85L1550.75,388.65L1549.75,382.85L1550.15,376.15L1546.35,375.85L1545.45,371.95L1542.75,369.95L1543.55,367.65L1547.65,363.45L1548.45,364.95L1551.45,365.15L1549.45,357.75L1552.15,356.85L1556.15,361.95L1559.65,367.75L1566.45,367.75L1569.45,373.35L1566.15,375.05L1564.95,377.35L1572.25,381.25L1577.95,388.85L1582.35,394.45L1587.25,398.95L1589.25,403.45L1589.05,409.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LB" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1178.35,287.45L1176.95,287.55L1176.55,288.65L1174.75,288.65L1176.05,283.35L1178.25,278.85L1178.25,278.65L1180.75,278.95L1181.95,281.45L1179.25,283.95L1178.35,287.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M937.85,451.75L937.65,453.55L938.15,456.65L936.95,459.55L938.55,461.35L940.35,461.75L942.75,464.45L942.95,466.95L942.35,467.75L941.95,473.05L940.45,473.15L934.65,470.05L929.45,465.15L924.65,461.65L920.85,457.55L922.25,455.45L922.55,453.55L925.15,450.15L927.75,447.15L929.05,446.95L930.45,446.25L932.85,450.15L932.45,452.75L933.55,454.15L935.15,454.15L936.25,451.55L937.85,451.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1121.85,298.35L1120.15,301.45L1121.15,304.25L1120.05,308.15L1122.05,313.35L1123.35,336.15L1124.35,359.85L1124.85,372.65L1118.45,372.65L1118.45,375.35L1095.85,363.05L1073.35,350.75L1067.85,354.25L1064.05,356.65L1060.85,353.15L1052.05,350.35L1049.55,346.35L1045.05,343.35L1042.55,344.55L1040.45,340.95L1040.25,338.25L1036.85,333.55L1039.05,330.85L1038.45,326.85L1039.05,323.35L1038.65,320.35L1039.45,315.15L1039.05,312.15L1037.15,306.45L1039.75,305.05L1040.15,302.25L1039.55,299.65L1043.15,297.15L1044.75,295.05L1047.35,293.25L1047.45,288.35L1053.85,290.55L1056.15,289.95L1060.65,291.05L1067.95,293.95L1070.75,299.65L1075.65,300.85L1083.45,303.55L1089.45,306.75L1091.95,305.05L1094.45,302.15L1092.85,297.25L1094.35,294.05L1098.05,291.05L1101.75,290.25L1109.15,291.55L1111.15,294.35L1113.15,294.45L1114.95,295.55L1120.35,296.25L1121.85,298.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1445.15,461.25L1440.35,462.75L1437.45,457.65L1436.05,448.45L1438.05,438.05L1442.15,441.55L1444.95,446.05L1448.05,452.75L1447.45,459.45L1445.15,461.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1138.35,697.15L1136.35,697.85L1132.65,692.85L1135.85,688.85L1138.95,686.35L1141.65,684.95L1143.85,686.95L1145.55,688.95L1143.65,692.05L1142.55,694.15L1139.45,695.15L1138.35,697.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1110.35,146.85L1111.35,149.55L1107.75,151.55L1107.25,154.95L1102.45,157.25L1097.75,157.25L1096.35,155.35L1093.85,154.65L1093.25,153.15L1093.45,151.45L1091.25,150.55L1086.15,149.45L1084.45,144.35L1089.55,142.55L1097.45,142.95L1101.95,142.35L1102.85,143.55L1105.35,143.95L1110.35,146.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LU" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1016.15,184.65L1014.75,184.75L1013.65,184.25L1014.05,180.75L1015.35,180.55L1016.35,181.95L1016.15,184.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LV" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1112.05,135.75L1114.55,137.05L1115.55,139.95L1117.65,143.55L1113.05,145.85L1110.35,146.85L1105.35,143.95L1102.85,143.55L1101.95,142.35L1097.45,142.95L1089.55,142.55L1084.45,144.35L1083.95,139.85L1085.65,136.05L1089.75,134.05L1094.15,138.55L1097.85,138.35L1097.95,133.75L1101.75,132.75L1103.85,133.45L1108.25,135.65L1112.05,135.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M974.05,275.25L975.95,279.35L976.25,283.25L978.15,290.05L979.55,291.45L978.55,293.95L971.45,295.05L968.95,297.35L965.85,297.95L965.55,302.75L959.15,305.25L957.05,308.45L952.55,310.15L947.15,311.15L938.25,315.95L938.15,323.55L937.25,323.55L937.35,326.95L933.95,327.15L932.15,328.65L929.65,328.65L927.65,327.75L923.05,328.45L921.15,333.45L919.35,333.95L916.65,342.05L908.75,348.95L906.75,357.85L904.35,360.75L903.65,363.05L891.15,363.55L891.05,363.55L891.35,360.55L893.55,358.85L895.45,355.45L895.15,353.25L897.15,348.75L900.35,344.65L902.25,343.65L903.85,339.95L904.05,336.45L906.15,332.55L909.95,330.15L913.55,323.65L913.65,323.55L916.55,321.05L921.65,320.35L926.05,315.95L928.85,314.25L933.55,308.85L932.35,300.95L934.55,295.35L935.45,291.95L939.05,287.65L944.45,284.75L948.55,282.05L952.25,275.45L954.05,271.45L957.95,271.55L961.05,274.25L966.15,273.85L971.65,275.25L974.05,275.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1128.65,209.55L1127.35,206.65L1127.55,203.95L1126.95,201.25L1123.55,197.45L1121.55,194.85L1119.75,193.05L1118.15,192.35L1119.25,191.45L1122.45,190.85L1126.45,192.75L1128.45,193.05L1131.05,194.75L1130.95,196.85L1132.95,197.85L1134.05,200.45L1136.05,202.05L1135.85,203.05L1136.85,203.65L1135.55,204.15L1132.55,203.95L1131.95,203.05L1130.95,203.55L1131.55,204.65L1130.45,206.75L1129.85,208.85L1128.65,209.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1267.15,588.15L1267.55,595.85L1268.85,598.85L1268.15,601.95L1266.95,603.75L1265.35,600.05L1264.15,601.95L1264.95,606.65L1264.25,609.45L1262.55,610.85L1261.85,616.35L1259.15,623.85L1255.75,632.65L1251.45,644.85L1248.55,653.75L1245.45,661.25L1240.85,662.75L1235.75,665.45L1232.75,663.85L1228.55,661.55L1227.35,658.15L1227.35,652.45L1225.85,647.35L1225.65,642.65L1226.95,638.05L1229.55,636.95L1229.75,634.85L1232.65,629.95L1233.45,625.85L1232.35,622.85L1231.55,618.75L1231.45,612.85L1233.65,609.25L1234.65,605.15L1237.45,604.95L1240.65,603.65L1242.85,602.45L1245.25,602.35L1248.65,598.75L1253.55,594.75L1255.35,591.55L1254.75,588.75L1257.15,589.55L1260.45,585.15L1260.75,581.25L1262.75,578.35L1264.55,581.15L1265.95,583.85L1267.15,588.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MX" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M448.55,335.15L450.75,334.95L447.55,340.65L445.75,345.25L443.95,353.85L442.85,356.95L443.25,360.45L444.55,363.65L444.95,368.55L447.95,373.35L448.75,377.05L450.45,380.15L456.15,381.85L458.05,384.55L463.25,382.75L467.55,382.15L471.95,380.95L475.55,379.85L479.45,377.25L481.25,373.55L482.45,368.15L483.65,366.25L487.65,364.55L493.75,363.05L498.65,363.35L502.05,362.75L503.25,364.15L502.65,367.25L499.15,371.05L497.35,374.95L498.25,376.05L497.05,378.85L494.95,383.85L493.75,382.15L491.55,382.35L489.05,386.25L488.15,385.45L487.45,385.75L487.35,386.75L482.15,386.65L476.95,386.65L476.45,390.25L473.95,390.35L475.75,392.45L477.65,393.95L478.15,395.35L478.95,395.75L478.55,397.95L471.35,397.95L468.05,403.15L468.75,404.35L467.95,405.85L467.55,407.75L461.95,400.85L459.35,398.75L454.95,397.05L451.75,397.55L446.95,399.95L444.05,400.55L440.35,398.85L436.25,397.65L431.45,394.75L427.35,393.85L421.45,390.85L417.15,387.75L416.05,386.05L412.95,385.65L407.55,383.65L405.65,380.75L400.25,377.05L398.05,373.05L397.25,369.85L399.15,369.25L398.85,367.45L400.45,365.75L400.85,363.55L399.35,360.65L399.35,358.15L398.05,354.85L394.25,348.45L389.65,343.45L387.75,339.45L383.65,336.85L382.95,335.25L384.65,331.35L382.25,329.85L379.75,326.65L379.55,322.25L376.75,321.65L374.45,318.35L372.75,315.15L373.05,313.15L371.55,308.35L371.25,303.45L372.05,300.95L368.95,298.35L367.05,298.65L364.65,296.95L362.85,299.55L362.75,302.55L361.75,307.45L362.75,310.05L365.55,314.45L365.95,316.05L366.65,316.45L366.75,318.65L367.75,318.55L367.75,322.75L369.05,324.35L369.55,326.65L372.25,329.85L372.65,335.85L373.65,338.65L374.55,341.65L374.25,345.05L376.85,345.25L378.45,348.15L379.95,351.05L379.65,352.25L376.85,354.55L375.85,354.55L375.15,350.65L372.25,346.95L368.85,343.85L366.35,342.25L367.55,337.55L367.45,334.05L365.35,332.05L362.25,329.25L361.35,330.05L360.35,328.35L357.35,326.85L355.15,323.05L355.65,322.65L357.75,322.95L360.45,320.55L361.45,317.65L358.55,313.05L355.95,311.35L355.15,307.35L354.55,303.05L353.75,297.95L353.55,292.15L359.85,291.65L366.95,290.95L366.05,292.25L373.05,295.35L383.95,299.85L399.05,299.85L399.85,297.15L409.25,297.15L410.55,299.45L412.65,301.55L415.05,304.35L415.85,307.65L416.25,311.25L418.55,313.15L422.55,315.05L427.35,310.05L431.85,309.85L435.05,312.45L436.65,316.85L437.55,320.65L439.95,324.25L440.15,328.75L441.05,331.75L444.95,333.75L448.55,335.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1104.75,235.85L1103.75,236.05L1102.95,237.15L1100.15,237.05L1098.35,238.45L1094.95,238.95L1092.65,237.45L1091.65,234.75L1092.15,232.55L1092.85,232.65L1092.95,231.35L1095.85,230.35L1097.05,230.05L1098.75,229.75L1101.15,229.55L1103.95,231.65L1104.75,235.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ML" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1009.45,378.05L1009.55,392.85L1006.45,397.15L1006.05,401.15L1001.05,402.15L993.35,402.65L991.35,404.95L987.75,405.25L984.15,405.25L982.75,404.05L979.65,404.95L974.35,407.65L973.25,409.65L968.95,412.45L968.15,414.15L965.75,415.45L963.05,414.55L961.55,416.15L960.65,420.55L956.15,425.85L956.35,428.05L954.75,430.75L955.15,434.45L952.75,435.45L951.45,436.25L950.55,433.55L948.95,434.25L947.95,434.15L946.95,435.95L942.55,435.95L941.05,434.95L940.25,435.55L938.55,433.65L938.85,431.75L938.15,431.05L936.95,431.65L937.25,429.55L938.35,427.95L936.05,425.25L935.45,423.45L934.15,422.05L933.05,421.85L931.75,422.75L929.85,423.65L928.35,425.05L925.95,424.55L924.35,422.85L923.45,422.65L921.95,423.55L921.05,423.55L920.75,421.15L921.05,419.15L920.55,416.75L918.55,414.95L917.45,411.25L917.25,407.25L919.15,406.05L920.15,402.25L921.95,402.15L925.85,403.95L929.05,402.65L931.15,403.05L932.05,401.65L954.55,401.55L955.85,397.05L954.85,396.25L952.35,368.55L949.95,340.85L958.45,340.75L977.05,354.75L995.75,368.75L997.05,371.75L1000.55,373.55L1003.15,374.65L1003.25,378.75L1009.45,378.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1547.65,363.45L1543.55,367.65L1542.75,369.95L1539.75,371.45L1536.95,374.25L1533.05,374.55L1531.55,381.45L1529.35,382.65L1532.85,388.25L1536.95,392.95L1539.85,397.25L1538.45,402.75L1536.65,403.95L1538.45,407.15L1542.75,412.25L1543.75,415.85L1543.95,418.85L1546.65,424.75L1544.05,430.75L1541.85,437.35L1540.95,432.55L1542.25,427.65L1540.05,423.85L1539.85,416.85L1537.25,413.45L1534.55,405.85L1532.55,397.75L1529.45,392.35L1526.25,395.65L1520.45,400.15L1517.15,399.65L1513.55,398.15L1514.45,390.15L1512.45,384.15L1507.15,376.75L1507.45,374.45L1504.05,373.55L1499.45,368.35L1498.35,363.15L1500.45,364.15L1499.85,359.55L1502.35,358.05L1501.35,355.35L1502.35,353.15L1501.45,346.45L1506.05,347.95L1507.65,342.65L1507.35,339.55L1509.35,334.15L1508.45,330.45L1514.65,326.05L1518.85,327.15L1517.45,323.25L1519.15,322.05L1518.15,319.65L1521.25,319.15L1523.95,322.95L1526.65,324.45L1527.95,329.35L1528.85,334.65L1524.65,340.05L1525.35,347.65L1530.95,346.55L1533.35,352.45L1537.05,353.75L1536.25,359.05L1540.75,361.45L1543.35,362.65L1547.15,360.75L1547.65,363.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ME" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1089.85,226.45L1089.05,227.85L1087.65,228.45L1087.25,227.25L1085.35,230.35L1085.85,232.45L1084.75,231.95L1083.05,229.85L1080.75,228.55L1081.25,227.55L1081.65,224.05L1083.25,222.55L1084.15,221.95L1085.55,223.05L1086.45,223.95L1088.15,224.65L1090.25,225.95L1089.85,226.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1495.45,180.75L1499.45,179.55L1505.15,178.75L1510.55,179.65L1517.15,182.55L1522.05,185.75L1526.65,185.75L1533.45,186.75L1537.05,185.15L1542.95,184.15L1547.35,179.75L1550.75,180.45L1554.65,182.55L1560.25,181.95L1560.85,186.65L1561.15,192.95L1563.95,195.45L1566.25,194.65L1571.75,195.65L1574.25,193.35L1579.45,195.35L1586.65,199.75L1587.45,201.95L1583.05,201.25L1576.25,202.05L1573.75,203.85L1572.45,208.05L1566.05,210.45L1562.85,213.85L1556.95,212.55L1553.75,211.95L1553.25,216.05L1556.15,218.45L1558.05,220.55L1555.65,222.75L1553.65,226.15L1548.75,228.35L1541.15,228.55L1533.95,230.75L1529.55,234.15L1526.25,232.25L1520.05,232.25L1510.65,228.35L1505.05,227.45L1498.65,228.35L1487.35,226.85L1481.75,227.05L1477.05,223.25L1472.05,217.45L1468.65,216.75L1460.65,212.75L1453.45,211.95L1446.95,210.85L1443.95,208.05L1442.55,200.75L1436.75,195.65L1428.55,193.35L1422.85,190.05L1419.55,185.65L1424.25,184.55L1430.95,179.25L1436.85,176.35L1442.15,178.25L1447.35,178.35L1452.15,181.25L1457.15,181.45L1465.15,183.05L1467.55,178.65L1463.55,175.05L1464.85,168.65L1471.85,171.15L1476.65,171.95L1483.35,173.55L1486.95,178.15L1495.45,180.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1165.95,672.75L1161.85,672.75L1161.55,669.85L1160.95,666.95L1160.55,664.65L1161.95,657.55L1160.85,652.95L1158.65,643.95L1164.85,636.65L1166.55,632.05L1167.35,631.45L1168.25,627.65L1167.45,625.75L1167.85,620.95L1169.15,616.55L1169.55,608.35L1166.75,606.35L1164.05,605.85L1162.95,604.25L1160.35,602.95L1155.65,603.05L1155.45,600.65L1155.05,596.05L1172.25,590.75L1175.45,593.85L1176.95,593.25L1179.15,594.85L1179.35,597.45L1178.05,600.45L1178.25,604.95L1181.75,608.95L1183.65,604.45L1186.15,603.15L1186.05,594.85L1183.85,590.25L1181.95,588.15L1181.55,588.15L1180.95,580.85L1182.45,574.75L1184.65,574.55L1191.35,576.35L1192.85,575.55L1196.75,575.35L1198.85,573.45L1202.25,573.55L1208.45,571.05L1213.05,567.35L1213.95,570.15L1213.45,576.55L1213.95,582.25L1213.75,592.25L1214.55,595.35L1212.65,599.95L1210.25,604.45L1206.55,608.45L1201.25,610.85L1194.75,613.95L1188.15,620.85L1185.95,622.05L1181.75,626.65L1179.45,628.05L1178.65,632.65L1181.05,637.55L1181.95,641.25L1181.95,643.25L1182.95,642.85L1182.45,649.15L1181.35,652.15L1182.55,653.25L1181.55,655.95L1179.15,658.25L1174.45,660.35L1167.55,663.85L1165.05,666.25L1165.35,668.95L1166.65,669.35L1165.95,672.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M958.45,340.75L949.95,340.85L952.35,368.55L954.85,396.25L955.85,397.05L954.55,401.55L932.05,401.65L931.15,403.05L929.05,402.65L925.85,403.95L921.95,402.15L920.15,402.25L919.15,406.05L917.25,407.25L913.65,402.85L910.25,398.05L906.65,396.35L903.95,394.55L900.85,394.55L898.05,395.95L895.35,395.45L893.35,397.45L892.95,394.05L894.55,390.85L895.35,384.85L894.95,378.45L894.35,375.25L894.95,372.05L893.55,369.05L890.75,366.25L892.05,364.15L913.75,364.15L912.85,354.85L914.35,351.55L919.55,351.05L919.75,334.55L937.75,334.95L937.95,325.15L958.45,340.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1181.55,588.15L1181.95,588.15L1183.85,590.25L1186.05,594.85L1186.15,603.15L1183.65,604.45L1181.75,608.95L1178.25,604.95L1178.05,600.45L1179.35,597.45L1179.15,594.85L1176.95,593.25L1175.45,593.85L1172.25,590.75L1169.35,589.15L1171.35,583.15L1173.15,580.95L1172.25,575.55L1173.55,570.35L1174.55,568.65L1173.25,563.25L1170.65,560.35L1176.15,561.55L1177.15,563.25L1177.05,564.05L1178.85,568.15L1179.05,575.85L1177.25,579.45L1178.85,584.15L1178.65,586.95L1179.85,588.85L1179.75,591.25L1180.65,592.65L1181.65,591.05L1183.55,593.55L1183.75,592.75L1182.75,589.35L1181.65,589.05L1181.55,588.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1563.55,461.15L1564.95,461.75L1568.45,465.65L1570.95,469.95L1571.55,474.25L1571.05,477.15L1571.65,479.35L1572.15,483.15L1574.25,484.95L1576.55,490.65L1576.55,492.75L1572.55,493.25L1567.05,488.45L1560.25,483.35L1559.45,480.05L1556.05,475.75L1555.05,470.45L1552.85,466.95L1553.25,462.25L1551.85,459.55L1552.75,458.45L1557.55,461.25L1558.15,464.55L1561.85,463.75L1563.55,461.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1653.35,474.55L1648.35,473.45L1641.85,473.45L1640.15,480.75L1638.05,482.95L1635.45,491.85L1630.85,493.25L1625.45,491.45L1622.75,492.05L1619.45,495.25L1615.85,494.85L1612.15,496.15L1608.25,492.45L1607.25,488.15L1611.45,490.35L1615.75,489.15L1616.75,483.75L1619.15,482.55L1625.95,481.15L1629.75,476.05L1632.35,472.05L1635.15,475.35L1636.25,473.15L1638.95,473.35L1639.05,469.25L1639.15,466.05L1643.25,461.65L1645.85,456.65L1648.15,456.55L1651.25,459.85L1651.65,462.65L1655.45,464.45L1660.25,466.35L1660.05,468.85L1656.25,469.15L1657.35,472.35L1653.35,474.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1115.45,613.55L1120.05,612.15L1123.65,612.45L1125.85,613.95L1125.85,614.45L1122.65,615.95L1120.95,615.95L1117.25,618.45L1115.25,615.75L1106.55,618.05L1102.35,618.25L1101.55,641.15L1096.05,641.35L1095.45,660.05L1094.35,683.75L1089.35,687.05L1086.45,687.55L1083.05,686.35L1080.55,685.85L1079.75,683.15L1077.75,681.35L1074.95,684.55L1071.05,679.65L1069.05,675.05L1068.05,668.75L1066.85,664.15L1065.25,654.25L1065.35,646.55L1064.75,643.05L1062.65,640.35L1059.85,635.05L1057.05,627.35L1055.95,623.35L1051.55,617.05L1051.25,612.15L1053.95,610.95L1057.35,609.85L1060.95,610.05L1064.25,612.95L1065.05,612.45L1087.75,612.25L1091.55,615.25L1105.05,616.15L1115.45,613.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1067.85,354.25L1069.45,364.25L1071.65,365.95L1071.75,367.95L1074.15,370.15L1072.95,372.95L1071.15,385.95L1070.95,394.35L1063.95,400.35L1061.65,408.85L1064.05,411.25L1064.05,415.35L1067.75,415.45L1067.15,418.55L1065.65,418.85L1065.45,420.95L1064.45,421.05L1060.55,414.05L1059.15,413.75L1054.85,417.35L1050.45,415.45L1047.45,415.15L1045.85,416.05L1042.55,415.85L1039.25,418.55L1036.35,418.75L1029.55,415.45L1026.85,416.95L1023.95,416.85L1021.85,414.45L1016.25,412.05L1010.15,412.85L1008.75,414.15L1007.95,417.85L1006.35,420.45L1005.95,426.25L1001.65,422.55L999.65,422.55L997.75,424.45L997.85,420.05L991.35,418.55L991.15,415.45L988.05,411.25L987.25,408.35L987.75,405.25L991.35,404.95L993.35,402.65L1001.05,402.15L1006.05,401.15L1006.45,397.15L1009.55,392.85L1009.45,378.05L1017.25,375.25L1033.25,362.65L1052.05,350.35L1060.85,353.15L1064.05,356.65L1067.85,354.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1065.45,420.95L1067.75,423.45L1067.15,424.65L1066.85,426.75L1062.15,431.75L1060.75,435.85L1059.95,439.15L1058.75,440.65L1057.65,445.15L1054.65,447.75L1053.85,450.95L1052.55,453.55L1052.05,456.25L1048.15,458.45L1044.95,455.75L1042.85,455.85L1039.45,459.65L1037.85,459.65L1035.15,465.85L1033.75,470.45L1027.85,472.75L1025.75,472.45L1023.55,473.85L1019.05,473.75L1015.95,469.65L1014.05,465.05L1010.05,460.85L1000.85,460.85L1001.15,450.55L1000.95,446.45L1002.05,442.45L1003.75,440.45L1006.55,436.45L1005.95,434.75L1007.05,432.15L1005.75,428.35L1005.95,426.25L1006.35,420.45L1007.95,417.85L1008.75,414.15L1010.15,412.85L1016.25,412.05L1021.85,414.45L1023.95,416.85L1026.85,416.95L1029.55,415.45L1036.35,418.75L1039.25,418.55L1042.55,415.85L1045.85,416.05L1047.45,415.15L1050.45,415.45L1054.85,417.35L1059.15,413.75L1060.55,414.05L1064.45,421.05L1065.45,420.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M518.85,404.75L518.35,405.45L517.85,406.85L518.25,409.15L516.75,411.35L515.95,413.95L515.45,416.75L515.65,418.45L515.55,421.35L514.65,421.95L513.95,424.75L514.15,426.45L512.95,428.05L513.05,429.75L513.85,430.85L512.45,432.25L510.75,431.75L509.95,430.45L508.15,429.95L506.85,430.75L503.25,429.05L502.35,429.85L500.55,427.85L498.05,425.25L496.95,423.15L494.75,421.05L492.25,418.15L492.95,417.15L493.75,418.15L494.25,417.75L496.05,417.45L496.85,415.95L497.65,415.95L497.85,412.75L499.15,412.65L500.35,412.65L501.75,410.95L503.25,412.25L503.85,411.45L505.05,410.65L507.15,408.95L507.35,407.55L507.85,407.65L508.75,406.15L509.35,405.95L510.25,406.95L511.35,407.15L512.65,406.35L514.05,406.35L516.05,405.55L516.95,404.65L518.85,404.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1112.95,66.75L1106.55,68.85L1103.35,69.35L1104.15,65.55L1098.35,63.45L1092.45,65.25L1091.35,69.25L1087.95,71.65L1083.25,70.35L1077.95,70.55L1072.85,67.75L1070.65,69.15L1068.05,69.35L1068.15,72.95L1060.15,72.05L1059.55,75.15L1055.55,75.15L1053.25,79.05L1049.85,85.15L1044.15,93.05L1045.95,95.05L1044.65,97.25L1040.35,97.15L1037.95,102.55L1038.95,110.25L1042.05,113.15L1041.25,120.05L1037.85,124.05L1036.05,127.45L1032.75,123.85L1024.15,130.65L1018.05,132.05L1011.55,129.05L1009.75,122.75L1007.75,109.25L1011.75,105.55L1023.05,100.65L1031.15,94.75L1038.35,86.95L1047.25,76.25L1053.65,72.15L1063.95,65.35L1072.45,62.95L1079.15,63.25L1084.35,58.85L1091.75,59.05L1098.75,58.05L1112.45,61.95L1107.55,63.35L1112.95,66.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1075.85,24.45L1068.25,26.35L1061.45,25.25L1063.65,24.05L1061.05,22.55L1068.35,21.65L1070.25,23.35L1075.85,24.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1050.25,15.95L1062.85,19.35L1054.25,21.15L1053.05,24.55L1050.05,25.45L1049.15,29.45L1044.75,29.65L1036.25,26.75L1039.25,25.05L1033.55,23.65L1025.85,19.75L1022.65,16.25L1031.95,14.65L1034.25,16.15L1039.25,16.15L1040.25,14.65L1045.45,14.45L1050.25,15.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1074.65,12.95L1082.05,14.45L1077.65,16.85L1067.55,17.35L1056.85,16.55L1055.85,15.35L1050.75,15.35L1046.45,13.35L1056.95,12.15L1062.35,13.15L1065.45,11.85L1074.65,12.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NP" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1468.25,322.15L1468.45,324.85L1469.95,328.95L1469.85,331.45L1465.25,331.55L1458.35,330.05L1454.05,329.45L1450.25,326.25L1442.55,325.35L1434.75,321.75L1428.95,318.65L1423.15,316.25L1424.05,310.25L1426.85,307.25L1428.75,305.75L1433.55,307.75L1439.95,311.95L1443.25,312.85L1445.75,315.95L1450.25,317.15L1455.25,320.05L1461.75,321.45L1468.25,322.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1283.05,394.15L1280.85,389.65L1275.65,379.05L1291.95,372.65L1294.55,359.85L1291.55,355.25L1291.55,352.65L1292.85,350.05L1292.65,347.45L1295.05,346.15L1293.95,345.25L1293.95,341.05L1296.75,341.05L1299.75,345.45L1303.05,347.75L1307.15,348.65L1310.55,349.75L1313.45,353.45L1315.15,355.55L1317.15,356.45L1317.35,357.85L1315.65,361.65L1314.95,363.45L1312.75,365.55L1311.05,369.95L1308.55,369.55L1307.55,371.15L1306.85,374.35L1307.95,378.65L1307.45,379.45L1304.95,379.45L1301.65,381.85L1301.35,384.95L1300.15,386.35L1296.65,386.25L1294.65,387.85L1294.85,390.45L1292.25,392.25L1289.15,391.65L1285.55,393.85L1283.05,394.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1295.45,335.95L1294.15,333.75L1295.55,331.65L1296.25,332.15L1296.05,334.85L1295.45,335.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1400.85,273.15L1397.05,278.55L1391.35,279.55L1382.85,277.95L1380.85,280.75L1384.15,286.35L1387.05,290.75L1392.15,293.85L1388.35,297.55L1389.35,302.15L1385.45,308.65L1383.25,315.15L1378.75,321.85L1372.25,321.35L1367.35,328.15L1371.35,330.95L1372.75,335.95L1376.25,339.15L1378.05,344.65L1365.95,344.65L1362.75,348.95L1358.55,347.35L1356.35,342.75L1351.45,337.85L1341.45,339.05L1332.45,339.15L1324.85,340.05L1325.95,332.65L1333.45,329.25L1332.55,326.35L1329.85,325.25L1328.85,319.65L1323.15,316.85L1320.35,312.95L1317.15,309.55L1326.75,312.85L1332.05,311.85L1335.45,312.65L1336.35,311.25L1340.25,311.85L1346.85,309.15L1346.05,303.75L1348.35,300.05L1352.45,300.05L1352.65,298.35L1356.65,297.45L1358.75,298.05L1360.55,296.25L1359.45,292.35L1360.85,288.55L1363.95,286.85L1360.85,282.65L1366.05,282.85L1366.95,280.55L1366.15,278.05L1368.15,275.35L1366.75,272.15L1364.85,269.45L1367.25,266.65L1372.55,265.35L1378.45,264.55L1380.85,263.45L1383.75,262.65L1388.45,265.65L1391.35,270.65L1400.85,273.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M548.55,445.45L547.85,446.35L548.95,450.15L547.85,452.05L546.05,451.55L545.15,454.65L543.35,452.85L542.35,449.35L543.75,447.65L542.35,447.25L541.45,445.15L538.65,443.35L536.25,443.75L534.95,445.95L532.55,447.55L531.35,447.75L530.75,449.15L533.25,452.65L531.65,453.45L530.85,454.35L528.15,454.75L527.35,450.85L526.55,451.95L524.75,451.55L523.75,449.05L521.45,448.55L519.95,447.85L517.55,447.85L517.35,449.25L516.75,448.25L517.05,446.95L517.65,445.65L517.45,444.55L518.35,443.75L517.25,442.85L517.35,440.25L519.55,439.65L521.45,441.95L521.25,443.35L523.45,443.65L524.05,443.05L525.55,444.65L528.35,444.15L530.85,442.55L534.35,441.25L536.35,439.35L539.45,439.75L539.25,440.35L542.35,440.55L544.75,441.75L546.55,443.65L548.55,445.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M589.75,528.65L584.65,528.35L583.85,529.35L579.25,530.55L572.95,534.95L572.65,537.95L571.25,540.15L571.95,543.65L568.55,545.45L568.75,548.25L567.25,549.35L569.85,555.15L573.15,559.05L572.15,561.85L575.95,562.15L578.25,565.65L583.25,565.75L587.65,562.05L587.75,571.75L590.35,572.45L593.55,571.35L599.05,581.75L597.95,583.85L597.95,588.45L598.25,593.85L596.35,597.05L597.55,599.45L596.45,601.65L599.35,607.05L596.45,613.95L595.35,617.25L592.55,618.85L586.65,615.15L585.85,612.55L574.15,606.15L563.45,599.05L558.75,595.15L555.95,589.85L556.75,587.95L551.35,579.55L544.95,567.75L538.95,554.95L536.55,551.95L534.55,547.25L529.95,543.05L525.85,540.45L527.55,537.65L524.55,531.45L526.25,526.95L530.65,522.95L531.35,525.65L529.75,527.15L530.05,529.45L532.35,528.95L534.65,529.65L537.15,532.95L540.25,530.25L541.15,525.95L544.55,520.35L551.25,517.85L557.35,511.05L559.05,506.95L558.25,502.05L559.75,501.45L563.55,504.45L565.35,507.55L567.95,509.15L571.45,515.85L575.65,516.75L578.75,515.05L580.85,516.15L584.25,515.55L588.65,518.55L585.15,525.15L586.85,525.25L589.75,528.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1699.75,447.05L1700.65,451.35L1701.25,454.95L1699.65,460.75L1697.15,454.25L1694.75,457.55L1696.85,462.25L1695.45,465.25L1688.55,461.55L1686.65,456.85L1688.15,453.85L1684.35,450.75L1682.75,453.45L1680.15,453.15L1676.15,456.75L1675.15,454.85L1676.95,449.45L1680.35,447.65L1683.25,445.25L1685.45,448.15L1689.65,446.45L1690.35,443.55L1694.35,443.35L1693.55,438.45L1698.45,441.45L1699.15,444.65L1699.75,447.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1685.15,435.05L1683.35,437.15L1681.95,441.25L1680.35,443.15L1676.45,438.75L1677.45,436.95L1678.75,435.15L1678.95,431.25L1682.05,430.85L1681.55,435.15L1685.15,428.95L1685.15,435.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1654.85,441.25L1647.75,447.35L1650.15,442.85L1653.95,438.85L1656.95,434.45L1659.25,428.05L1660.85,433.35L1657.35,436.85L1654.85,441.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1672.35,424.75L1675.95,426.75L1679.45,426.75L1679.65,429.35L1677.35,432.15L1673.95,434.05L1673.45,431.05L1673.55,427.75L1672.35,424.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1692.45,422.95L1694.85,430.15L1690.35,428.45L1690.65,430.65L1692.45,434.55L1689.85,436.05L1689.25,431.45L1687.45,431.15L1686.25,427.25L1689.55,427.75L1689.25,425.35L1685.25,420.45L1690.65,420.55L1692.45,422.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1669.45,417.15L1668.55,422.75L1665.85,419.55L1662.35,414.65L1667.15,414.85L1669.45,417.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1662.95,382.25L1666.75,384.15L1668.15,382.45L1668.95,384.05L1668.55,386.75L1671.15,391.35L1670.55,396.65L1667.65,398.75L1667.55,403.95L1669.55,409.05L1672.55,409.75L1674.95,409.05L1682.45,412.55L1682.35,416.05L1684.45,417.65L1684.15,420.55L1679.45,417.45L1676.95,414.05L1675.75,416.45L1671.75,412.55L1666.75,413.55L1663.75,412.15L1663.65,409.45L1665.25,407.85L1663.35,406.35L1662.95,408.65L1659.65,404.95L1658.35,402.15L1657.25,396.05L1659.85,398.15L1658.75,388.05L1659.55,382.25L1662.95,382.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1867.35,544.85L1865.75,545.55L1863.45,543.05L1861.25,538.95L1860.45,534.05L1861.25,533.45L1861.75,535.35L1863.35,536.85L1865.75,540.85L1868.25,543.05L1867.35,544.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1845.95,536.25L1842.95,536.75L1841.95,538.55L1835.75,541.65L1832.65,541.65L1828.15,539.75L1825.05,537.95L1825.65,535.95L1830.65,536.95L1833.85,536.45L1834.85,533.35L1835.75,533.15L1836.05,536.55L1839.25,536.15L1841.05,533.95L1844.35,531.65L1843.95,527.85L1847.35,527.75L1848.45,528.75L1848.05,532.35L1845.95,536.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1782.15,559.65L1783.75,538.65L1784.75,517.75L1794.35,522.15L1804.65,525.85L1808.35,529.15L1811.35,532.35L1811.95,536.15L1821.15,540.15L1822.25,543.55L1817.05,544.25L1817.95,548.55L1822.65,552.75L1825.65,559.55L1828.95,559.35L1828.35,562.15L1832.65,563.25L1830.85,564.45L1836.55,567.15L1835.65,569.05L1831.85,569.45L1830.65,567.85L1825.95,567.05L1820.35,566.15L1816.35,562.05L1813.55,558.45L1811.05,552.85L1803.95,550.05L1799.05,551.85L1795.35,554.05L1795.65,558.75L1791.05,560.95L1787.95,559.85L1782.15,559.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1852.85,529.95L1851.05,531.65L1850.15,527.85L1849.05,525.45L1846.55,523.35L1843.45,520.55L1839.45,518.65L1841.05,517.15L1844.05,518.95L1845.95,520.35L1848.25,521.85L1850.35,524.55L1852.45,526.65L1852.85,529.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1079.15,154.05L1085.05,154.75L1093.85,154.65L1096.35,155.35L1097.75,157.25L1098.35,159.95L1100.05,162.25L1100.45,164.65L1097.65,165.95L1099.55,168.75L1100.05,171.55L1103.25,176.95L1102.95,178.65L1100.65,179.35L1096.85,184.55L1098.45,187.35L1097.35,186.95L1092.35,184.55L1088.85,185.45L1086.45,184.85L1083.65,186.15L1080.95,183.95L1079.05,184.85L1078.75,184.45L1076.15,181.35L1072.45,181.05L1071.75,179.05L1068.35,178.35L1067.75,179.95L1064.95,178.65L1065.15,176.95L1061.45,176.45L1058.95,174.45L1056.55,170.55L1056.75,168.35L1055.25,165.05L1053.35,162.95L1054.55,161.25L1053.15,158.15L1056.25,156.35L1063.35,153.55L1069.15,151.55L1073.95,152.55L1074.55,154.05L1079.15,154.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="KP" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1659.55,229.15L1660.95,230.25L1658.75,229.85L1657.75,232.05L1657.45,234.15L1660.25,238.75L1658.35,240.15L1658.05,241.25L1657.15,243.15L1654.25,244.25L1652.85,245.95L1654.15,248.65L1653.85,249.35L1656.45,250.45L1660.85,253.25L1660.85,254.75L1658.85,255.15L1655.25,255.55L1654.65,258.35L1652.15,258.15L1652.15,258.75L1648.95,257.55L1648.85,258.75L1647.55,259.25L1646.85,258.05L1645.15,257.45L1643.25,256.45L1643.35,253.65L1644.25,252.85L1643.25,251.75L1642.85,248.25L1641.95,247.25L1638.55,246.55L1635.15,244.85L1637.25,240.75L1641.15,237.35L1642.25,232.75L1645.85,234.75L1650.45,235.05L1647.65,231.65L1654.05,228.95L1654.05,225.35L1659.55,229.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M661.75,630.65L663.75,634.15L664.15,642.85L670.05,644.15L672.25,642.85L676.15,644.65L677.35,646.55L678.45,652.45L679.25,654.85L681.35,655.15L683.35,654.15L685.45,655.25L685.75,658.85L685.45,662.65L684.75,666.35L684.45,671.95L680.15,676.95L675.95,677.95L669.65,676.95L663.85,675.25L668.05,665.45L666.95,662.65L661.05,660.15L653.75,655.35L649.15,654.35L637.85,643.95L639.35,636.25L639.15,632.75L641.25,627.15L650.85,625.25L656.05,625.35L661.45,628.65L661.75,630.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1177.55,293.05L1177.95,297.05L1177.35,298.95L1174.85,299.75L1174.95,298.05L1176.25,297.15L1174.75,296.45L1175.45,292.25L1177.55,293.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="QA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1269.35,342.95L1267.85,343.45L1266.05,342.15L1265.25,337.45L1266.35,334.15L1267.85,333.45L1269.65,335.45L1270.15,339.15L1269.35,342.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1118.15,192.35L1119.75,193.05L1121.55,194.85L1123.55,197.45L1126.95,201.25L1127.55,203.95L1127.35,206.65L1128.65,209.55L1131.05,210.75L1133.35,209.65L1135.75,210.75L1136.15,212.45L1133.85,213.75L1132.25,213.15L1131.85,220.85L1128.75,220.15L1124.75,217.85L1118.85,219.35L1116.55,220.95L1108.95,220.55L1104.95,219.65L1103.05,220.05L1101.25,217.45L1100.25,216.35L1101.25,215.25L1099.95,214.55L1098.45,215.95L1095.35,214.05L1094.65,211.45L1091.45,210.05L1090.65,207.95L1087.65,205.55L1091.55,204.35L1094.15,200.05L1096.05,195.85L1098.95,194.55L1100.95,193.15L1104.15,193.85L1107.35,193.85L1109.85,195.45L1111.45,194.45L1115.05,193.85L1116.05,192.35L1118.15,192.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1158.05,508.35L1160.25,511.95L1159.95,515.75L1158.35,516.55L1155.25,516.15L1153.55,519.85L1150.05,519.35L1150.65,515.75L1151.45,515.25L1151.65,511.45L1153.25,509.65L1154.65,510.35L1158.05,508.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="EH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M938.15,323.55L938.05,323.95L937.95,325.15L937.75,334.95L919.75,334.55L919.55,351.05L914.35,351.55L912.85,354.85L913.75,364.15L892.05,364.15L890.75,366.25L891.05,363.55L891.15,363.55L903.65,363.05L904.35,360.75L906.75,357.85L908.75,348.95L916.65,342.05L919.35,333.95L921.15,333.45L923.05,328.45L927.65,327.75L929.65,328.65L932.15,328.65L933.95,327.15L937.35,326.95L937.25,323.55L938.15,323.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1239.75,314.25L1244.75,314.85L1246.45,317.95L1250.35,317.75L1253.05,323.35L1255.95,324.75L1257.15,327.05L1261.15,329.75L1261.85,332.35L1261.45,334.55L1262.35,336.65L1264.15,338.45L1265.05,340.55L1266.05,342.15L1267.85,343.45L1269.35,342.95L1270.65,345.45L1270.95,346.85L1273.65,353.45L1290.55,356.65L1291.55,355.25L1294.55,359.85L1291.95,372.65L1275.65,379.05L1259.75,381.55L1254.75,384.45L1251.25,391.15L1248.65,392.25L1247.15,390.15L1245.05,390.45L1239.55,389.75L1238.45,389.15L1232.05,389.25L1230.55,389.85L1228.15,388.25L1226.85,391.35L1227.65,394.05L1225.25,396.15L1224.35,393.35L1222.55,391.45L1222.05,388.85L1218.95,386.55L1215.65,381.15L1213.75,375.95L1209.65,371.55L1207.15,370.45L1203.05,364.35L1202.15,359.95L1202.15,356.15L1198.55,348.95L1195.75,346.45L1192.75,345.15L1190.65,341.45L1190.85,340.05L1189.05,336.65L1187.35,335.25L1184.85,330.45L1181.05,325.35L1177.95,320.95L1175.25,320.95L1175.75,317.45L1175.85,315.15L1176.25,312.55L1182.45,313.65L1184.55,311.65L1185.65,309.35L1189.75,308.45L1190.45,306.25L1192.05,305.25L1186.05,298.75L1196.45,295.55L1197.35,294.55L1204.15,296.35L1212.75,300.85L1229.55,313.75L1239.75,314.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1190.25,408.45L1189.55,413.95L1187.55,420.35L1184.25,423.45L1181.95,428.45L1181.45,431.05L1178.85,432.85L1177.35,439.55L1177.35,440.35L1176.55,440.15L1176.65,436.95L1175.85,434.75L1172.95,432.25L1172.05,427.65L1172.65,422.85L1170.05,422.45L1169.65,423.85L1166.25,424.25L1167.75,426.05L1168.25,429.95L1165.25,433.45L1162.55,438.05L1159.65,438.75L1154.85,435.05L1152.75,436.35L1152.25,438.15L1149.35,439.45L1149.15,440.75L1143.55,440.75L1142.75,439.45L1138.65,439.15L1136.65,440.25L1135.05,439.75L1132.15,435.95L1131.15,434.25L1127.05,435.15L1125.55,438.05L1124.25,443.85L1122.25,445.05L1120.55,445.75L1120.05,445.45L1118.15,443.55L1117.75,441.55L1118.55,438.95L1118.55,436.25L1115.25,432.25L1114.55,429.55L1114.55,427.95L1112.45,426.05L1112.35,422.35L1111.05,419.85L1109.15,420.25L1109.65,417.85L1111.05,415.25L1110.35,412.55L1112.15,410.55L1110.95,409.05L1112.25,405.15L1114.75,400.35L1119.55,400.85L1118.45,375.35L1118.45,372.65L1124.85,372.65L1124.35,359.85L1190.25,359.85L1192.35,366.15L1191.15,367.25L1192.35,373.95L1194.85,381.55L1197.05,383.15L1200.25,385.55L1197.55,389.15L1193.55,390.25L1191.85,392.25L1191.55,396.45L1189.55,405.95L1190.25,408.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1177.35,440.35L1177.55,445.35L1176.75,447.25L1173.75,447.45L1171.85,451.05L1175.35,451.55L1178.35,454.65L1179.35,457.25L1181.95,458.75L1185.45,465.75L1181.65,469.95L1178.25,473.75L1174.75,476.75L1170.75,476.75L1166.25,478.25L1162.65,476.75L1160.35,478.55L1155.25,474.25L1153.85,471.55L1150.75,472.85L1148.15,472.45L1146.65,473.55L1144.05,472.75L1140.55,467.45L1139.65,465.45L1135.35,462.85L1133.95,459.05L1131.55,456.25L1127.65,452.95L1127.55,450.85L1124.45,448.25L1120.55,445.75L1122.25,445.05L1124.25,443.85L1125.55,438.05L1127.05,435.15L1131.15,434.25L1132.15,435.95L1135.05,439.75L1136.65,440.25L1138.65,439.15L1142.75,439.45L1143.55,440.75L1149.15,440.75L1149.35,439.45L1152.25,438.15L1152.75,436.35L1154.85,435.05L1159.65,438.75L1162.55,438.05L1165.25,433.45L1168.25,429.95L1167.75,426.05L1166.25,424.25L1169.65,423.85L1170.05,422.45L1172.65,422.85L1172.05,427.65L1172.95,432.25L1175.85,434.75L1176.65,436.95L1176.55,440.15L1177.35,440.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M917.25,407.25L917.45,411.25L918.55,414.95L920.55,416.75L921.05,419.15L920.75,421.15L919.95,421.55L916.85,421.05L916.45,421.75L915.25,421.85L911.15,420.35L908.45,420.25L898.05,419.95L896.55,420.75L894.65,420.55L891.65,421.55L890.85,416.65L895.95,416.75L897.35,415.85L898.35,415.85L900.45,414.35L902.85,415.65L905.25,415.85L907.75,414.35L906.65,412.55L904.75,413.55L903.05,413.55L900.85,411.95L899.05,412.05L897.75,413.65L891.65,413.75L889.35,408.75L886.65,406.55L889.15,405.25L891.95,400.75L893.35,397.45L895.35,395.45L898.05,395.95L900.85,394.55L903.95,394.55L906.65,396.35L910.25,398.05L913.65,402.85L917.25,407.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M927.75,447.15L925.15,450.15L922.55,453.55L922.25,455.45L920.85,457.55L919.35,457.05L915.35,454.45L912.35,451.05L911.45,448.65L910.75,443.95L913.85,441.05L914.45,439.35L915.45,437.95L917.05,437.75L918.35,436.55L922.85,436.55L924.45,438.85L925.65,441.55L925.45,443.45L926.35,445.15L926.25,447.45L927.75,447.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SV" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M491.75,415.15L491.05,416.65L487.75,416.55L485.75,415.95L483.55,414.65L480.55,414.25L479.05,412.85L479.35,411.95L481.35,410.35L482.55,409.65L482.25,408.85L483.65,408.45L485.25,409.05L486.35,410.25L487.95,411.35L488.05,412.15L490.55,411.45L491.75,411.85L492.45,412.55L491.75,415.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1101.25,217.45L1100.15,218.85L1100.85,221.25L1103.65,223.95L1101.85,225.95L1101.25,227.95L1101.85,228.75L1101.15,229.55L1098.75,229.75L1097.05,230.05L1096.75,229.55L1097.35,228.85L1097.75,227.25L1097.05,227.35L1095.95,226.15L1095.05,225.85L1094.25,224.85L1093.25,224.45L1092.45,223.55L1091.55,223.95L1091.05,226.05L1089.85,226.45L1090.25,225.95L1088.15,224.65L1086.45,223.95L1085.55,223.05L1084.15,221.95L1085.25,221.65L1085.75,218.75L1083.05,216.25L1084.15,213.45L1082.25,213.55L1083.95,211.15L1082.25,209.35L1080.75,206.85L1084.45,205.25L1087.65,205.55L1090.65,207.95L1091.45,210.05L1094.65,211.45L1095.35,214.05L1098.45,215.95L1099.95,214.55L1101.25,215.25L1100.25,216.35L1101.25,217.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M680.25,464.15L677.15,469.65L677.45,474.05L679.65,477.85L678.55,480.55L678.05,483.55L676.55,486.25L673.35,484.85L670.65,485.55L668.35,484.95L667.75,486.85L668.75,488.05L668.15,489.45L665.05,488.85L661.75,483.25L661.05,479.65L659.25,479.65L656.85,475.05L657.95,471.65L657.65,470.15L661.15,468.55L662.15,462.75L668.95,464.05L669.55,462.85L674.15,462.35L680.25,464.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1097.35,186.95L1096.15,188.65L1095.45,191.15L1094.45,191.75L1088.95,189.85L1087.35,190.25L1086.35,191.75L1084.05,192.55L1083.45,192.15L1081.15,193.05L1079.25,193.25L1078.95,194.55L1074.85,195.25L1072.95,194.65L1070.25,192.95L1069.55,190.85L1069.85,190.05L1070.45,188.65L1072.65,188.75L1074.25,188.15L1074.35,187.55L1075.25,187.25L1075.45,185.85L1076.55,185.55L1077.25,184.45L1078.75,184.45L1079.05,184.85L1080.95,183.95L1083.65,186.15L1086.45,184.85L1088.85,185.45L1092.35,184.55L1097.35,186.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1069.05,203.15L1065.15,204.85L1064.85,207.35L1063.15,208.05L1063.25,209.75L1061.25,209.65L1059.45,208.65L1058.65,209.65L1055.05,209.45L1056.15,208.95L1054.75,206.25L1055.15,203.15L1059.35,203.65L1061.75,202.15L1066.15,202.05L1067.05,200.95L1067.85,201.05L1069.05,203.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1087.45,86.25L1080.45,87.85L1076.95,91.75L1078.25,95.25L1072.05,99.75L1064.25,104.75L1062.15,112.85L1065.85,116.95L1070.65,120.25L1067.35,126.85L1062.75,128.25L1062.15,138.25L1060.05,143.95L1054.35,143.35L1052.15,148.15L1046.65,148.45L1044.75,142.75L1040.25,135.85L1036.05,127.45L1037.85,124.05L1041.25,120.05L1042.05,113.15L1038.95,110.25L1037.95,102.55L1040.35,97.15L1044.65,97.25L1045.95,95.05L1044.15,93.05L1049.85,85.15L1053.25,79.05L1055.55,75.15L1059.55,75.15L1060.15,72.05L1068.15,72.95L1068.05,69.35L1070.65,69.15L1076.65,71.85L1083.85,75.55L1085.65,84.05L1087.45,86.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1160.95,666.95L1161.55,669.85L1161.85,672.75L1160.45,675.55L1157.25,676.25L1154.15,672.75L1154.25,670.55L1155.95,668.15L1156.55,666.25L1158.25,665.85L1160.95,666.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1194.25,286.75L1184.55,293.65L1178.25,291.05L1178.15,291.05L1178.75,290.05L1178.35,287.45L1179.25,283.95L1181.95,281.45L1180.75,278.95L1178.25,278.65L1177.15,273.75L1178.15,271.05L1179.45,269.65L1180.65,268.25L1180.45,264.75L1182.35,265.95L1187.95,264.15L1190.95,265.35L1195.35,265.35L1201.05,262.95L1203.95,263.05L1209.85,262.05L1207.75,266.05L1205.05,267.65L1206.25,272.35L1205.25,280.05L1194.25,286.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1118.45,375.35L1119.55,400.85L1114.75,400.35L1112.25,405.15L1110.95,409.05L1112.15,410.55L1110.35,412.55L1111.05,415.25L1109.65,417.85L1109.15,420.25L1111.05,419.85L1112.35,422.35L1112.45,426.05L1114.55,427.95L1114.55,429.55L1110.95,430.65L1108.15,433.25L1104.15,440.25L1098.95,443.25L1093.45,442.85L1091.85,443.45L1092.45,445.65L1089.55,447.95L1087.15,450.45L1080.05,452.85L1078.65,451.45L1077.65,451.25L1076.65,452.95L1072.05,453.45L1072.85,451.65L1071.05,447.25L1070.25,444.65L1067.75,443.55L1064.35,439.75L1065.55,436.75L1068.15,437.35L1069.75,436.95L1072.95,436.95L1069.75,431.15L1069.95,426.85L1069.45,422.65L1067.15,418.55L1067.75,415.45L1064.05,415.35L1064.05,411.25L1061.65,408.85L1063.95,400.35L1070.95,394.35L1071.15,385.95L1072.95,372.95L1074.15,370.15L1071.75,367.95L1071.65,365.95L1069.45,364.25L1067.85,354.25L1073.35,350.75L1095.85,363.05L1118.45,375.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M990.65,430.45L989.95,433.85L991.65,435.75L993.65,437.95L993.85,441.15L995.05,442.45L994.75,457.25L996.15,461.65L991.65,463.05L990.35,460.75L988.85,456.65L988.35,453.45L989.65,447.75L988.25,445.35L987.65,440.35L987.65,435.65L985.35,432.35L985.75,430.35L990.65,430.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1576.75,409.45L1571.45,408.55L1564.35,409.75L1561.25,415.05L1563.35,422.85L1558.05,419.85L1553.25,420.05L1553.55,414.95L1548.65,414.95L1548.85,422.05L1546.65,431.45L1545.25,437.15L1545.95,441.75L1549.65,441.95L1552.35,447.85L1553.65,453.35L1557.05,457.05L1560.45,457.75L1563.55,461.15L1561.85,463.75L1558.15,464.55L1557.55,461.25L1552.75,458.45L1551.85,459.55L1549.55,457.15L1548.35,453.95L1545.15,450.35L1542.25,447.25L1541.55,451.05L1540.25,447.45L1540.65,443.45L1541.85,437.35L1544.05,430.75L1546.65,424.75L1543.95,418.85L1543.75,415.85L1542.75,412.25L1538.45,407.15L1536.65,403.95L1538.45,402.75L1539.85,397.25L1536.95,392.95L1532.85,388.25L1529.35,382.65L1531.55,381.45L1533.05,374.55L1536.95,374.25L1539.75,371.45L1542.75,369.95L1545.45,371.95L1546.35,375.85L1550.15,376.15L1549.75,382.85L1550.75,388.65L1556.05,384.85L1557.95,385.95L1561.15,385.75L1561.95,383.55L1566.25,383.95L1571.25,389.15L1572.55,395.55L1577.85,401.15L1578.25,406.55L1576.75,409.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TJ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1356.25,242.85L1354.85,244.75L1348.85,243.75L1349.45,247.35L1354.95,246.85L1362.05,248.95L1371.65,247.95L1374.75,253.95L1376.25,253.25L1379.95,254.75L1380.45,257.25L1382.25,260.85L1376.85,260.85L1373.05,260.35L1370.55,263.25L1368.35,263.85L1366.85,265.25L1364.15,263.15L1363.25,257.75L1361.55,257.45L1361.65,255.45L1358.35,254.05L1356.65,256.25L1356.85,258.85L1356.25,259.75L1353.05,259.65L1352.15,262.55L1350.05,261.35L1346.65,263.35L1344.85,262.65L1346.15,256.15L1343.75,251.35L1339.55,249.85L1340.15,247.05L1344.55,247.35L1346.05,243.85L1346.55,239.75L1353.05,238.25L1352.85,241.25L1354.15,242.95L1356.25,242.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1337.55,261.25L1335.95,261.05L1333.05,259.35L1332.75,261.55L1328.55,262.85L1328.75,267.95L1326.15,269.95L1322.15,270.85L1321.75,273.75L1317.85,274.65L1311.95,272.15L1310.25,266.85L1306.25,266.55L1298.95,260.95L1294.65,260.25L1288.05,256.95L1284.15,256.35L1282.15,257.55L1278.55,257.35L1275.55,261.05L1271.15,262.25L1269.25,257.75L1268.65,251.05L1264.05,248.85L1264.45,244.55L1260.95,244.15L1260.85,238.75L1266.15,240.35L1270.25,238.35L1265.55,234.45L1263.15,230.85L1259.35,232.45L1259.95,237.15L1257.35,233.05L1259.15,230.85L1264.75,229.55L1268.65,231.35L1273.45,236.35L1276.05,236.05L1281.95,235.95L1280.25,232.75L1284.05,230.55L1287.45,226.85L1295.35,230.25L1297.25,235.25L1299.55,236.55L1305.05,236.25L1307.15,237.45L1311.45,244.05L1318.55,248.45L1322.75,251.45L1329.05,254.55L1336.75,257.35L1337.55,261.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1691.95,561.35L1692.05,559.45L1691.55,558.15L1692.35,556.65L1697.25,555.25L1701.25,554.95L1703.05,554.15L1705.15,554.95L1702.95,556.75L1696.85,559.55L1691.95,561.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1047.45,288.35L1047.35,293.25L1044.75,295.05L1043.15,297.15L1039.55,299.65L1040.15,302.25L1039.75,305.05L1037.15,306.45L1034.55,294.95L1031.15,292.35L1031.05,290.85L1026.55,286.95L1025.95,282.15L1029.15,278.55L1030.25,273.25L1029.25,267.15L1030.25,263.85L1035.95,261.35L1039.65,262.05L1039.65,265.35L1044.05,262.95L1044.45,264.15L1041.95,267.35L1042.05,270.25L1043.95,271.85L1043.45,277.45L1039.95,280.65L1041.15,284.15L1043.95,284.25L1045.35,287.35L1047.45,288.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1200.95,234.55L1206.45,234.25L1212.05,237.45L1213.35,239.65L1213.45,242.75L1217.65,244.35L1220.05,246.15L1216.75,248.05L1219.65,255.35L1218.95,257.35L1222.75,262.45L1220.35,263.55L1218.25,261.95L1211.95,261.05L1209.85,262.05L1203.95,263.05L1201.05,262.95L1195.35,265.35L1190.95,265.35L1187.95,264.15L1182.35,265.95L1180.45,264.75L1180.65,268.25L1179.45,269.65L1178.15,271.05L1175.85,268.15L1177.55,265.75L1174.35,266.35L1169.75,264.85L1166.55,268.55L1158.55,269.25L1153.85,265.85L1148.15,265.65L1147.15,268.25L1143.55,269.05L1138.15,265.65L1132.35,265.75L1128.55,259.35L1124.35,255.85L1126.35,250.85L1122.75,247.75L1127.85,241.65L1135.85,241.45L1137.45,236.55L1147.45,237.45L1153.05,233.35L1158.85,231.55L1167.35,231.35L1177.15,235.85L1185.05,238.35L1190.85,237.35L1195.45,237.95L1200.95,234.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1121.15,239.15L1122.35,238.45L1123.45,234.45L1120.75,232.75L1125.75,230.75L1130.35,231.55L1131.25,234.05L1136.05,236.05L1135.35,237.65L1129.15,237.95L1127.15,239.95L1123.25,243.35L1121.25,240.45L1121.15,239.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1657.15,354.75L1655.75,360.05L1651.75,354.55L1650.25,349.85L1652.15,343.55L1655.45,338.65L1658.45,340.55L1658.35,344.45L1657.15,354.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1166.25,507.65L1166.05,511.55L1164.95,516.05L1166.55,518.55L1169.05,517.05L1172.35,516.65L1173.05,517.45L1176.35,515.85L1174.05,513.65L1175.95,510.75L1178.75,507.85L1199.25,520.95L1199.55,524.65L1207.65,531.05L1204.85,539.05L1205.15,542.65L1208.65,544.95L1208.85,546.65L1207.15,550.55L1207.45,552.45L1207.05,555.55L1208.85,559.55L1211.05,565.95L1213.05,567.35L1208.45,571.05L1202.25,573.55L1198.85,573.45L1196.75,575.35L1192.85,575.55L1191.35,576.35L1184.65,574.55L1182.45,574.75L1182.55,574.65L1180.75,572.25L1180.45,565.45L1177.55,562.05L1177.15,563.25L1176.15,561.55L1170.65,560.35L1167.45,558.45L1163.85,557.35L1161.65,556.25L1161.35,556.05L1158.65,549.45L1158.25,545.55L1153.75,541.15L1155.15,538.75L1154.05,536.15L1154.25,533.45L1153.25,532.55L1153.55,529.75L1154.15,529.65L1156.15,527.35L1158.45,523.95L1159.85,522.65L1159.85,520.55L1158.65,519.05L1158.35,516.55L1159.95,515.75L1160.25,511.95L1158.05,508.35L1160.05,507.55L1166.25,507.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1178.25,473.75L1180.95,478.25L1181.65,481.45L1184.25,488.85L1182.15,493.55L1179.35,497.75L1177.75,500.35L1177.75,500.65L1177.55,500.25L1174.55,498.95L1172.15,500.55L1168.55,501.45L1165.95,505.15L1166.25,507.65L1160.05,507.55L1158.05,508.35L1154.65,510.35L1153.25,509.65L1153.35,504.85L1154.65,502.35L1154.95,497.25L1156.15,494.25L1158.35,490.95L1160.45,489.15L1162.35,486.95L1160.05,486.05L1160.35,478.55L1162.65,476.75L1166.25,478.25L1170.75,476.75L1174.75,476.75L1178.25,473.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1156.45,173.85L1158.75,176.55L1158.85,177.75L1165.55,179.95L1169.15,178.95L1172.75,181.85L1175.65,181.75L1183.35,183.75L1183.75,185.65L1182.45,188.85L1184.25,192.35L1183.95,194.45L1179.15,194.85L1176.95,196.65L1177.35,199.35L1173.45,199.85L1170.45,201.95L1165.85,202.25L1161.85,204.65L1162.85,208.55L1165.65,210.05L1170.75,209.65L1170.15,211.95L1164.75,213.05L1158.45,216.65L1155.35,215.35L1156.05,212.45L1150.15,210.55L1150.85,209.35L1155.45,207.25L1153.75,205.85L1145.65,204.25L1144.85,201.85L1140.35,202.65L1139.05,206.15L1135.75,210.75L1133.35,209.65L1131.05,210.75L1128.65,209.55L1129.85,208.85L1130.45,206.75L1131.55,204.65L1130.95,203.55L1131.95,203.05L1132.55,203.95L1135.55,204.15L1136.85,203.65L1135.85,203.05L1136.05,202.05L1134.05,200.45L1132.95,197.85L1130.95,196.85L1131.05,194.75L1128.45,193.05L1126.45,192.75L1122.45,190.85L1119.25,191.45L1118.15,192.35L1116.05,192.35L1115.05,193.85L1111.45,194.45L1109.85,195.45L1107.35,193.85L1104.15,193.85L1100.95,193.15L1098.95,194.55L1098.45,192.85L1095.45,191.15L1096.15,188.65L1097.35,186.95L1098.45,187.35L1096.85,184.55L1100.65,179.35L1102.95,178.65L1103.25,176.95L1100.05,171.55L1102.35,171.25L1104.75,169.65L1108.55,169.45L1113.45,169.95L1119.15,171.45L1123.05,171.55L1124.95,172.45L1126.65,171.35L1128.15,172.85L1132.45,172.55L1134.55,173.15L1134.25,170.05L1135.55,168.65L1139.65,168.35L1141.45,168.55L1142.45,167.15L1143.95,167.45L1148.85,166.85L1152.65,170.35L1151.75,171.65L1152.55,173.55L1156.45,173.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UY" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M698.95,717.85L697.35,721.95L691.95,725.45L687.75,724.15L684.95,724.85L679.45,722.15L675.85,722.35L671.95,718.75L671.55,714.65L672.45,713.25L671.25,706.85L671.65,700.25L672.15,695.05L675.55,694.35L681.85,699.35L683.75,699.15L690.05,703.25L694.85,706.85L698.65,711.15L696.85,714.25L698.95,717.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="UZ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1351.95,229.95L1353.65,230.55L1350.65,234.65L1355.25,237.05L1358.45,235.45L1365.65,238.85L1360.35,243.45L1356.25,242.85L1354.15,242.95L1352.85,241.25L1353.05,238.25L1346.55,239.75L1346.05,243.85L1344.55,247.35L1340.15,247.05L1339.55,249.85L1343.75,251.35L1346.15,256.15L1344.85,262.65L1340.55,261.25L1337.55,261.25L1336.75,257.35L1329.05,254.55L1322.75,251.45L1318.55,248.45L1311.45,244.05L1307.15,237.45L1305.05,236.25L1299.55,236.55L1297.25,235.25L1295.35,230.25L1287.45,226.85L1284.05,230.55L1280.25,232.75L1281.95,235.95L1276.05,236.05L1269.85,212.65L1281.85,208.95L1282.95,209.45L1292.15,213.95L1296.95,216.35L1303.55,222.05L1309.25,221.15L1317.85,220.65L1325.45,225.25L1326.95,231.65L1329.55,231.75L1332.05,236.95L1338.75,237.15L1341.05,240.15L1343.05,240.15L1343.95,235.55L1349.35,231.15L1351.95,229.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M647.95,447.35L643.25,451.15L642.75,453.45L644.55,455.85L643.15,457.05L639.65,458.05L639.65,461.05L638.05,462.85L641.75,467.65L642.45,469.45L640.35,471.95L633.95,474.35L629.85,475.35L628.15,476.85L623.65,475.25L619.55,474.45L618.45,475.05L620.95,476.65L620.65,480.95L621.35,485.05L626.15,485.55L626.45,486.95L622.35,488.75L621.65,491.45L619.25,492.55L615.05,494.05L613.95,496.05L609.55,496.45L606.45,493.05L604.85,486.65L603.35,484.35L601.35,482.95L604.25,479.75L604.05,478.35L602.55,476.45L601.45,472.15L602.05,467.55L603.35,465.35L604.55,461.95L602.55,460.85L599.35,461.55L595.25,461.25L592.95,461.95L589.15,456.35L585.85,455.55L578.55,456.15L577.35,453.95L575.95,453.45L575.85,452.05L576.55,449.65L576.25,447.15L575.05,445.65L574.45,442.75L571.55,442.35L573.35,438.55L574.25,433.95L576.05,431.55L578.35,429.75L579.95,426.55L583.65,425.45L583.45,426.95L580.05,427.75L581.75,430.65L581.45,434.05L578.75,437.75L580.65,442.85L583.15,442.45L584.65,437.75L582.95,435.55L582.95,430.65L590.15,428.05L589.55,425.05L591.65,422.95L593.35,427.55L597.35,427.65L600.75,431.15L600.95,433.35L605.95,433.35L612.05,432.75L615.15,435.55L619.35,436.35L622.65,434.35L622.75,432.75L629.85,432.35L636.55,432.25L631.65,434.15L633.45,437.25L637.95,437.65L642.15,440.85L642.85,445.95L645.75,445.85L647.95,447.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VN" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1585.75,362.75L1579.25,368.15L1575.55,374.25L1574.95,378.75L1580.25,385.45L1586.75,393.85L1592.45,397.85L1596.55,402.95L1600.55,414.85L1600.95,426.15L1596.65,430.35L1590.55,434.55L1586.35,439.85L1579.75,445.85L1577.45,441.75L1578.65,437.35L1574.25,433.75L1578.85,431.15L1584.75,430.65L1581.95,426.85L1590.95,421.85L1590.85,414.15L1589.05,409.85L1589.25,403.45L1587.25,398.95L1582.35,394.45L1577.95,388.85L1572.25,381.25L1564.95,377.35L1566.15,375.05L1569.45,373.35L1566.45,367.75L1559.65,367.75L1556.15,361.95L1552.15,356.85L1554.85,355.25L1559.25,355.35L1564.55,354.55L1568.65,351.15L1571.75,353.55L1577.05,354.75L1576.75,358.45L1579.85,361.05L1585.75,362.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="YE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1283.05,394.15L1279.05,395.85L1278.15,398.75L1278.15,400.95L1272.75,403.65L1263.95,406.65L1259.25,411.15L1256.75,411.55L1255.05,411.15L1251.85,413.85L1248.35,415.05L1243.65,415.35L1242.25,415.75L1241.15,417.45L1239.65,417.95L1238.85,419.55L1236.05,419.35L1234.35,420.25L1230.35,419.95L1228.75,416.15L1228.75,412.65L1227.75,410.75L1226.45,406.05L1224.65,403.45L1225.75,403.05L1225.05,400.15L1225.65,398.95L1225.25,396.15L1227.65,394.05L1226.85,391.35L1228.15,388.25L1230.55,389.85L1232.05,389.25L1238.45,389.15L1239.55,389.75L1245.05,390.45L1247.15,390.15L1248.65,392.25L1251.25,391.15L1254.75,384.45L1259.75,381.55L1275.65,379.05L1280.85,389.65L1283.05,394.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1161.35,556.05L1161.65,556.25L1163.85,557.35L1167.45,558.45L1170.65,560.35L1173.25,563.25L1174.55,568.65L1173.55,570.35L1172.25,575.55L1173.15,580.95L1171.35,583.15L1169.35,589.15L1172.25,590.75L1155.05,596.05L1155.45,600.65L1151.15,601.55L1147.85,604.05L1147.05,606.25L1145.05,606.85L1139.95,612.05L1136.75,616.25L1134.85,616.35L1133.05,615.65L1126.85,614.95L1125.85,614.45L1125.85,613.95L1123.65,612.45L1120.05,612.15L1115.45,613.55L1111.85,609.55L1108.25,604.35L1109.05,583.85L1120.75,583.95L1120.35,581.75L1121.25,579.35L1120.35,576.35L1121.05,573.25L1120.45,571.25L1122.35,571.35L1122.65,573.35L1125.35,573.25L1128.85,573.85L1130.75,576.75L1135.15,577.65L1138.65,575.65L1139.85,578.95L1144.15,579.85L1146.15,582.65L1148.35,586.15L1152.65,586.15L1152.45,579.25L1150.85,580.45L1146.95,577.95L1145.45,576.75L1146.35,570.35L1147.45,562.75L1146.25,559.95L1147.95,555.85L1149.45,555.05L1157.15,553.95L1158.05,554.25L1157.75,555.65L1159.65,556.15L1160.85,557.45L1161.85,557.15L1161.35,556.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1158.65,643.95L1155.75,643.25L1153.85,644.05L1151.15,642.95L1148.95,642.95L1145.55,640.05L1141.25,639.05L1139.75,634.95L1139.85,632.65L1137.55,631.95L1131.45,624.95L1129.85,621.25L1128.75,620.05L1126.85,614.95L1133.05,615.65L1134.85,616.35L1136.75,616.25L1139.95,612.05L1145.05,606.85L1147.05,606.25L1147.85,604.05L1151.15,601.55L1155.45,600.65L1155.65,603.05L1160.35,602.95L1162.95,604.25L1164.05,605.85L1166.75,606.35L1169.55,608.35L1169.15,616.55L1167.85,620.95L1167.45,625.75L1168.25,627.65L1167.35,631.45L1166.55,632.05L1164.85,636.65L1158.65,643.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1221.35,511.85L1218.05,506.55L1217.85,483.15L1222.75,475.95L1224.25,473.85L1227.85,473.75L1232.85,469.25L1240.15,468.95L1255.75,449.65L1250.95,449.75L1232.25,442.15L1230.05,439.85L1227.85,436.75L1225.65,433.15L1226.85,430.95L1228.75,427.45L1230.65,428.65L1231.85,431.35L1234.55,434.05L1237.35,434.05L1242.55,432.35L1248.65,431.65L1253.55,429.65L1256.35,429.25L1258.35,428.05L1261.55,427.85L1263.35,427.65L1265.85,426.75L1268.85,426.05L1271.35,423.85L1273.55,423.85L1273.75,425.65L1273.35,429.35L1273.55,432.75L1272.45,435.05L1271.05,442.05L1268.65,449.15L1265.35,457.35L1260.75,466.75L1256.05,473.95L1249.45,482.75L1243.85,487.95L1235.45,494.35L1230.15,499.15L1223.95,506.95L1222.65,510.35L1221.35,511.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="XK" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1097.05,230.05L1095.85,230.35L1092.95,231.35L1092.85,232.65L1092.15,232.55L1091.55,230.25L1090.25,229.55L1089.05,227.85L1089.85,226.45L1091.05,226.05L1091.55,223.95L1092.45,223.55L1093.25,224.45L1094.25,224.85L1095.05,225.85L1095.95,226.15L1097.05,227.35L1097.75,227.25L1097.35,228.85L1096.75,229.55L1097.05,230.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ZA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1158.65,643.95L1160.85,652.95L1161.95,657.55L1160.55,664.65L1160.95,666.95L1158.25,665.85L1156.55,666.25L1155.95,668.15L1154.25,670.55L1154.15,672.75L1157.25,676.25L1160.45,675.55L1161.85,672.75L1165.95,672.75L1164.25,677.45L1163.25,682.75L1161.55,685.65L1157.55,688.95L1156.45,689.85L1153.85,693.15L1152.05,696.45L1148.55,701.05L1141.85,707.65L1137.75,711.45L1133.45,714.45L1127.55,716.85L1124.85,717.25L1123.95,719.05L1120.75,718.05L1118.05,719.25L1112.35,718.05L1109.05,718.85L1106.85,718.45L1101.05,721.05L1096.45,722.05L1092.95,724.45L1090.55,724.65L1088.45,722.35L1086.65,722.25L1084.45,719.35L1084.15,720.25L1083.55,718.55L1083.85,714.75L1082.35,710.45L1084.15,709.25L1084.25,704.35L1080.95,698.35L1078.55,692.95L1078.55,692.85L1074.95,684.55L1077.75,681.35L1079.75,683.15L1080.55,685.85L1083.05,686.35L1086.45,687.55L1089.35,687.05L1094.35,683.75L1095.45,660.05L1096.85,661.05L1099.85,667.15L1099.25,671.05L1100.35,673.35L1104.35,672.65L1107.15,669.75L1109.85,667.85L1111.35,664.75L1114.15,663.35L1116.45,664.05L1118.95,665.85L1123.45,666.15L1127.05,664.75L1127.65,662.75L1128.85,659.65L1131.85,659.15L1133.65,656.75L1135.65,652.45L1140.85,647.65L1148.95,642.95L1151.15,642.95L1153.85,644.05L1155.75,643.25L1158.65,643.95ZM1138.35,697.15L1139.45,695.15L1142.55,694.15L1143.65,692.05L1145.55,688.95L1143.85,686.95L1141.65,684.95L1138.95,686.35L1135.85,688.85L1132.65,692.85L1136.35,697.85L1138.35,697.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1885.45,763.65L1884.65,766.25L1890.25,763.65L1889.75,766.35L1887.65,769.05L1883.45,771.95L1876.35,776.65L1871.65,779.25L1871.05,782.25L1867.05,782.35L1860.75,784.75L1856.05,788.85L1847.85,795.25L1841.55,798.05L1837.55,799.85L1832.95,799.75L1831.45,797.65L1826.35,797.25L1827.35,794.85L1833.85,790.25L1845.25,783.95L1849.55,782.75L1855.15,780.35L1862.15,777.05L1867.85,773.75L1873.85,769.05L1876.95,767.45L1880.45,763.85L1886.25,760.95L1885.45,763.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1914.45,733.15L1914.05,739.95L1916.95,735.55L1918.25,737.35L1915.85,742.15L1918.75,744.25L1921.95,744.75L1926.65,742.35L1928.85,743.05L1923.65,748.75L1919.45,752.45L1915.55,752.35L1912.75,754.25L1911.25,757.05L1909.65,758.15L1905.05,761.65L1899.15,765.95L1893.15,768.55L1893.65,766.85L1892.15,765.95L1899.05,760.75L1899.95,757.15L1896.15,754.65L1897.95,752.35L1903.25,750.15L1907.45,745.15L1909.95,741.05L1910.55,736.75L1911.35,735.65L1910.45,732.95L1909.75,727.35L1910.15,722.75L1912.35,722.25L1913.25,725.85L1916.45,727.45L1914.45,733.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M654.35,837.15L660.35,850.75L665.35,850.75L668.35,850.95L667.85,853.35L664.65,855.25L662.25,855.05L659.15,854.55L654.95,852.75L649.55,851.85L642.05,848.45L635.65,845.25L625.85,838.35L630.45,839.65L639.05,843.75L646.35,845.95L647.55,843.15L647.25,838.95L650.65,836.35L654.35,837.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M613.65,647.05L614.55,648.65L613.35,655.35L607.75,658.45L609.35,669.15L608.55,671.25L610.55,673.75L607.25,677.75L604.65,683.75L603.75,689.65L605.45,695.85L603.35,702.45L608.25,713.55L609.85,714.75L611.25,720.65L609.65,726.85L611.05,732.25L608.05,736.45L609.65,742.25L612.95,748.55L610.45,750.85L610.65,756.55L611.45,763.05L614.75,770.85L613.05,772.15L616.75,779.45L619.85,781.85L619.05,784.55L621.85,785.75L623.25,788.15L621.45,789.35L623.25,793.05L624.35,801.35L623.65,806.75L625.45,809.95L625.35,813.85L622.65,816.65L625.75,823.15L628.35,825.45L631.45,825.05L633.35,829.65L636.85,833.25L648.95,834.05L653.85,835.05L649.55,835.05L647.85,836.55L644.45,838.75L646.15,844.45L644.25,844.55L637.95,842.65L630.45,838.35L622.85,834.85L619.65,830.95L619.35,827.35L615.15,823.15L610.15,812.55L609.95,806.55L613.35,801.75L605.05,799.85L607.75,794.35L605.75,783.85L612.25,786.05L610.45,772.95L606.45,771.25L607.45,779.15L603.95,778.25L602.45,769.25L600.45,757.45L601.55,753.05L598.25,746.85L595.85,739.65L598.05,739.35L598.65,729.05L599.85,718.75L599.95,709.25L596.65,699.55L597.25,694.25L595.15,686.35L596.95,678.55L596.05,666.15L596.05,652.75L596.15,638.45L594.65,627.95L592.55,618.85L595.35,617.25L596.45,613.95L599.65,618.35L600.85,622.95L604.05,625.65L602.95,631.85L606.65,639.05L609.75,647.95L613.65,647.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1015.75,176.35L1012.95,174.85L1009.85,172.15L1005.35,173.45L1001.75,172.95L1004.25,171.25L1008.25,162.25L1014.75,159.65L1018.75,159.85L1019.65,161.95L1018.75,167.55L1017.55,169.85L1014.65,169.85L1015.75,176.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M946.15,262.95L943.95,264.55L941.15,263.65L938.45,264.35L939.35,259.35L939.05,255.45L936.65,254.85L935.55,252.45L936.05,248.25L938.25,245.95L938.75,243.35L939.95,239.55L939.95,236.85L939.05,234.55L938.85,232.35L940.75,230.75L942.95,229.85L944.15,232.95L947.15,232.95L948.05,232.15L951.15,232.35L952.45,235.55L950.05,237.25L949.75,242.25L948.95,243.15L948.65,246.25L946.35,246.75L948.35,250.55L946.75,254.75L948.55,256.65L947.75,258.35L945.75,260.75L946.15,262.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1688.75,176.65L1702.45,187.65L1693.55,185.65L1697.25,194.65L1706.85,201.05L1709.85,205.45L1703.35,201.65L1703.45,206.55L1698.75,201.25L1694.95,195.15L1689.35,188.45L1686.95,183.65L1680.55,175.45L1672.55,169.35L1665.75,160.95L1667.65,158.15L1663.25,155.35L1664.55,154.45L1669.45,158.45L1676.35,164.35L1681.55,170.45L1688.75,176.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1093.85,154.65L1085.05,154.75L1079.15,154.05L1079.85,151.45L1086.15,149.45L1091.25,150.55L1093.45,151.45L1093.25,153.15L1093.85,154.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1547.65,47.45L1541.75,47.55L1532.85,46.95L1531.85,46.65L1532.55,44.65L1536.75,44.15L1545.15,46.15L1547.65,47.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1560.25,37.95L1559.15,39.95L1552.25,39.55L1541.95,37.55L1540.15,35.95L1548.45,36.65L1560.25,37.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1534.75,35.55L1537.85,39.35L1523.55,39.15L1518.95,40.35L1506.45,37.05L1503.05,33.65L1506.55,32.75L1516.75,32.95L1534.75,35.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1218.05,60.55L1215.85,60.95L1202.35,60.25L1200.05,57.95L1192.15,56.55L1190.15,53.65L1193.65,52.55L1192.05,49.75L1197.45,45.35L1193.45,44.75L1200.15,40.25L1197.65,37.95L1204.45,35.35L1214.75,32.15L1226.45,31.25L1231.45,29.45L1238.15,28.85L1242.35,30.75L1241.05,32.25L1229.65,34.75L1219.75,37.05L1211.05,41.85L1208.25,46.85L1204.95,51.85L1208.05,56.15L1218.05,60.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1660.95,230.25L1659.55,229.15L1657.65,225.85L1660.15,225.75L1656.25,218.25L1651.55,212.85L1654.45,210.65L1661.35,211.75L1660.75,205.55L1657.95,198.75L1658.25,196.45L1656.95,190.75L1650.05,192.65L1647.45,195.05L1639.85,195.05L1633.85,189.25L1624.85,184.75L1614.85,182.75L1608.65,176.75L1604.15,172.95L1600.35,170.25L1592.65,164.05L1586.65,161.85L1578.05,159.95L1571.85,160.15L1566.75,161.25L1565.05,164.35L1568.75,165.75L1571.25,169.15L1569.95,171.15L1570.15,177.65L1572.05,180.45L1567.65,184.35L1560.25,181.95L1554.65,182.55L1550.75,180.45L1547.35,179.75L1542.95,184.15L1537.05,185.15L1533.45,186.75L1526.65,185.75L1522.05,185.75L1517.15,182.55L1510.55,179.65L1505.15,178.75L1499.45,179.55L1495.45,180.75L1486.95,178.15L1483.35,173.55L1476.65,171.95L1471.85,171.15L1464.85,168.65L1463.55,175.05L1467.55,178.65L1465.15,183.05L1457.15,181.45L1452.15,181.25L1447.35,178.35L1442.15,178.25L1436.85,176.35L1430.95,179.25L1424.25,184.55L1419.55,185.65L1417.85,186.15L1413.45,182.35L1407.45,183.25L1404.15,180.55L1400.15,179.35L1396.05,175.75L1392.75,174.65L1386.55,176.25L1378.15,172.75L1377.05,175.95L1358.75,160.35L1350.35,155.65L1351.15,153.65L1341.95,159.45L1337.55,159.75L1336.45,156.45L1329.35,154.35L1325.05,155.85L1320.65,149.55L1311.55,148.25L1308.45,150.75L1297.55,153.05L1295.85,154.55L1278.85,156.65L1277.45,158.75L1282.55,162.95L1278.55,164.55L1280.05,166.15L1276.55,169.15L1285.95,173.45L1285.75,176.35L1278.75,176.05L1277.95,177.95L1270.65,174.75L1262.95,174.85L1258.55,177.45L1251.95,174.95L1239.95,170.65L1232.35,170.85L1224.25,177.55L1224.85,182.05L1218.85,178.45L1216.65,185.35L1218.45,186.55L1216.75,191.35L1222.05,195.55L1225.65,195.35L1229.95,199.55L1230.15,202.75L1232.95,203.85L1231.55,207.55L1226.95,208.55L1223.35,215.05L1229.35,221.15L1229.75,225.35L1237.05,232.85L1234.55,235.45L1233.95,237.05L1231.55,236.55L1227.25,232.75L1225.75,232.55L1222.15,231.05L1220.05,228.45L1214.95,227.15L1212.05,228.15L1210.85,226.95L1203.25,223.85L1195.55,222.85L1190.95,221.75L1190.55,222.55L1182.95,217.15L1176.75,214.75L1171.65,211.05L1175.25,210.05L1178.45,204.85L1175.15,202.35L1182.05,199.75L1181.65,198.35L1177.35,199.35L1176.95,196.65L1179.15,194.85L1183.95,194.45L1184.25,192.35L1182.45,188.85L1183.75,185.65L1183.35,183.75L1175.65,181.75L1172.75,181.85L1169.15,178.95L1165.55,179.95L1158.85,177.75L1158.75,176.55L1156.45,173.85L1152.55,173.55L1151.75,171.65L1152.65,170.35L1148.85,166.85L1143.95,167.45L1142.45,167.15L1141.45,168.55L1139.65,168.35L1137.65,164.35L1136.15,162.35L1136.95,161.75L1140.85,161.95L1142.45,160.65L1140.75,159.05L1137.35,157.95L1137.35,156.85L1135.25,155.75L1131.45,151.75L1132.15,150.15L1131.05,147.25L1126.25,145.85L1123.85,146.55L1122.95,145.05L1117.65,143.55L1115.55,139.95L1114.55,137.05L1112.05,135.75L1113.65,133.85L1111.25,128.25L1113.85,124.85L1112.95,123.85L1117.45,120.55L1112.05,117.75L1120.05,110.35L1123.45,106.95L1124.35,104.05L1116.95,100.15L1117.85,96.35L1112.95,92.15L1114.65,87.35L1108.15,81.05L1111.05,76.85L1103.75,73.15L1103.35,69.35L1106.55,68.85L1112.95,66.75L1116.65,64.85L1124.35,68.05L1136.05,69.35L1153.75,75.55L1157.85,78.15L1159.35,81.85L1155.65,84.75L1149.15,86.25L1128.95,82.05L1126.05,82.75L1134.15,86.85L1135.15,89.45L1137.05,95.25L1143.15,96.95L1146.95,98.45L1146.75,95.65L1143.35,93.25L1145.45,91.05L1157.05,94.65L1160.25,93.25L1155.95,89.05L1164.05,83.65L1168.15,83.95L1172.75,85.85L1173.85,82.05L1169.15,78.75L1169.95,75.45L1165.65,72.05L1177.95,73.85L1181.55,76.85L1176.45,77.55L1177.65,80.65L1181.75,82.55L1187.75,81.35L1187.35,77.85L1195.05,75.15L1207.45,70.55L1210.65,70.75L1208.15,74.05L1213.55,74.65L1215.65,72.75L1223.35,72.65L1228.35,70.35L1234.75,73.65L1237.55,70.05L1231.55,66.95L1232.75,65.15L1245.75,66.75L1252.35,68.45L1270.95,74.65L1272.05,71.85L1266.15,68.95L1265.35,67.85L1260.05,67.25L1259.85,64.75L1255.15,60.55L1254.05,58.85L1258.35,54.15L1257.75,49.35L1259.95,48.35L1271.35,49.75L1274.25,52.65L1273.35,56.85L1277.05,58.55L1280.85,62.25L1284.65,69.65L1291.35,72.95L1291.85,76.65L1288.35,84.45L1293.65,85.25L1294.15,83.25L1297.95,81.85L1297.45,79.15L1299.35,76.45L1294.95,73.35L1294.55,69.75L1289.75,69.35L1286.85,66.35L1286.45,60.95L1278.25,56.65L1282.95,53.15L1279.25,49.45L1281.15,49.35L1285.35,52.15L1287.45,57.25L1292.45,58.25L1287.85,54.45L1292.95,52.35L1301.05,52.05L1310.65,55.05L1303.75,50.75L1298.85,45.25L1304.75,44.25L1314.25,44.45L1322.05,43.75L1316.45,41.15L1317.75,37.85L1321.95,37.65L1326.85,35.25L1336.15,34.55L1335.95,33.15L1345.25,32.75L1349.55,33.85L1354.95,31.25L1361.95,31.35L1360.45,29.15L1361.35,27.15L1367.55,25.15L1375.85,26.75L1372.35,27.95L1381.75,28.65L1385.85,31.05L1387.75,29.85L1398.65,29.95L1410.25,32.35L1415.75,34.15L1418.25,36.75L1415.85,38.25L1409.25,41.05L1408.15,42.55L1413.75,43.25L1420.95,44.55L1423.35,43.55L1429.15,46.85L1429.35,45.55L1434.55,44.75L1448.15,45.55L1451.95,47.95L1469.35,48.75L1464.55,44.85L1474.05,45.75L1480.15,45.65L1490.05,48.35L1496.05,51.65L1496.45,53.85L1506.55,58.05L1515.55,60.15L1512.55,54.65L1521.95,56.95L1526.95,55.55L1536.75,57.15L1537.75,55.75L1545.35,56.45L1535.95,51.55L1538.05,49.35L1578.45,52.75L1586.35,55.85L1602.65,59.85L1617.45,58.85L1626.75,59.75L1633.35,61.95L1638.45,65.85L1645.75,67.35L1649.65,66.25L1656.65,66.15L1665.95,67.15L1672.85,66.55L1687.15,71.35L1689.65,69.65L1681.15,66.25L1679.35,63.85L1694.65,65.35L1702.65,65.05L1718.45,67.55L1727.95,69.95L1761.15,92.05L1759.15,94.55L1752.95,94.15L1761.15,97.15L1770.25,101.85L1774.45,103.35L1778.25,105.75L1779.25,107.25L1769.25,106.05L1762.65,110.35L1759.65,111.05L1758.05,115.15L1756.05,118.75L1757.75,121.45L1746.25,117.35L1740.15,121.95L1735.45,119.75L1734.05,122.35L1727.05,121.45L1730.15,125.35L1731.25,131.15L1734.15,133.55L1740.95,134.85L1750.05,143.55L1745.95,143.85L1749.35,148.85L1754.05,151.45L1749.05,154.55L1754.45,161.55L1748.75,163.05L1753.25,169.25L1751.55,175.05L1745.85,170.75L1735.35,161.85L1719.15,148.25L1712.65,139.95L1712.75,136.35L1709.95,133.55L1715.65,132.25L1715.45,124.75L1716.15,118.75L1718.65,114.05L1712.05,105.85L1707.35,106.35L1710.55,111.15L1706.95,117.55L1694.65,110.35L1685.55,112.35L1685.55,122.15L1693.25,125.75L1684.75,127.35L1678.35,127.95L1674.05,123.65L1666.05,122.75L1663.55,125.65L1648.45,124.65L1635.25,126.35L1631.75,138.05L1626.75,152.25L1634.95,153.05L1640.65,156.85L1646.45,158.15L1646.85,155.15L1652.45,155.55L1665.25,162.25L1669.95,167.45L1671.35,173.65L1676.85,181.05L1682.15,190.95L1681.15,200.05L1682.45,204.35L1680.45,211.75L1678.35,219.05L1677.45,222.75L1672.85,226.45L1669.75,226.55L1664.55,223.45L1660.45,228.15L1660.95,230.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1366.35,22.35L1348.25,24.15L1346.95,18.05L1349.15,17.55L1352.25,17.85L1364.85,20.45L1366.35,22.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1164.05,12.35L1159.75,12.85L1156.85,13.25L1156.85,13.95L1153.25,14.65L1148.75,13.65L1149.85,12.25L1142.05,12.15L1148.35,11.35L1153.55,11.35L1155.05,12.45L1156.35,11.45L1159.15,10.75L1164.95,11.65L1164.05,12.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1344.35,19.65L1337.25,20.25L1325.55,18.95L1317.45,17.25L1310.85,14.05L1304.95,13.25L1310.35,10.35L1316.55,9.45L1326.15,11.45L1339.85,15.65L1344.35,19.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="ES" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M975.85,222.65L977.85,225.05L987.35,227.95L989.25,226.55L995.05,229.45L1000.95,228.65L1001.35,232.35L996.45,236.55L989.85,237.95L989.35,240.05L986.15,243.55L984.15,248.75L986.15,252.45L983.15,255.25L981.95,259.45L977.95,260.75L974.25,265.65L967.45,265.75L962.45,265.65L959.05,267.85L956.95,270.25L954.35,269.75L952.45,267.55L951.05,263.95L946.15,262.95L945.75,260.75L947.75,258.35L948.55,256.65L946.75,254.75L948.35,250.55L946.35,246.75L948.65,246.25L948.95,243.15L949.75,242.25L950.05,237.25L952.45,235.55L951.15,232.35L948.05,232.15L947.15,232.95L944.15,232.95L942.95,229.85L940.75,230.75L938.85,232.35L939.35,227.85L937.35,225.15L944.75,220.55L950.95,221.65L957.85,221.65L963.25,222.75L967.55,222.35L975.85,222.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1034.95,230.65L1033.45,235.55L1031.05,234.25L1029.75,230.05L1030.65,227.65L1033.85,225.25L1034.95,230.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1013.65,184.25L1014.75,184.75L1016.15,184.65L1018.55,186.25L1025.75,187.45L1023.35,191.65L1022.95,196.15L1021.65,197.25L1019.35,196.65L1019.55,198.25L1015.95,201.75L1015.95,204.65L1018.35,203.65L1020.15,206.35L1020.05,208.15L1021.55,210.55L1019.85,212.45L1021.35,217.35L1024.15,218.15L1023.65,220.85L1019.15,224.45L1008.95,222.75L1001.55,224.85L1000.95,228.65L995.05,229.45L989.25,226.55L987.35,227.95L977.85,225.05L975.85,222.65L978.55,218.85L979.55,206.25L974.45,199.65L970.75,196.45L963.15,194.05L962.75,189.45L969.25,188.15L977.55,189.75L976.05,182.65L980.75,185.35L992.15,180.55L993.65,175.45L997.85,174.15L998.65,176.35L1000.85,176.45L1003.25,178.95L1006.75,181.85L1009.25,181.35L1013.65,184.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M538.75,193.75L532.65,195.75L527.95,198.25L523.35,200.95L522.85,201.85L528.55,200.55L530.65,202.65L535.25,201.15L540.15,199.05L545.55,196.95L542.45,200.25L544.95,201.05L547.45,203.45L552.55,202.05L557.65,201.55L557.95,203.35L559.45,203.55L560.65,203.75L562.15,206.25L557.45,206.85L557.35,206.85L553.65,206.15L549.15,207.35L545.45,207.95L540.75,212.05L537.75,214.35L538.15,215.05L543.65,210.95L544.35,210.95L539.65,215.85L536.75,220.25L534.25,223.85L533.65,226.95L532.85,228.45L532.25,230.15L532.35,233.45L532.65,233.95L534.45,233.85L536.05,233.15L537.45,232.35L540.75,229.25L542.55,225.05L542.45,221.15L543.85,218.45L546.45,215.35L548.55,213.15L551.25,211.65L550.85,213.75L553.05,210.65L554.35,210.05L556.05,207.65L559.85,208.95L562.65,211.35L561.85,214.25L560.25,217.15L556.45,219.65L556.05,221.25L557.05,221.25L561.35,218.55L562.95,219.15L562.45,222.85L561.75,225.45L558.05,228.95L556.05,231.15L553.35,233.55L556.05,234.85L558.55,235.25L562.55,234.35L566.25,232.65L569.25,231.75L573.85,229.95L579.65,226.15L579.75,225.55L580.05,223.65L582.75,222.85L586.65,223.15L590.65,223.65L595.25,221.55L595.85,219.05L595.65,218.15L602.45,213.75L605.15,212.65L612.95,212.55L622.25,212.55L623.35,211.05L625.05,210.75L627.55,209.75L630.35,206.85L633.55,201.95L639.05,197.25L640.15,198.85L643.85,197.85L645.45,199.65L642.55,208.15L644.75,211.75L644.95,213.85L638.55,216.85L632.55,219.05L626.55,220.95L622.55,224.75L621.25,226.15L620.05,229.55L620.75,232.85L622.85,233.05L623.05,230.75L624.15,232.15L623.15,233.95L619.35,234.95L616.85,234.85L612.65,235.95L610.35,236.25L607.25,236.55L602.25,238.45L610.35,237.25L611.45,238.45L603.55,240.35L600.25,240.35L600.65,239.55L598.55,241.35L599.95,241.65L597.45,246.25L592.15,251.15L592.25,249.45L591.15,249.15L589.95,247.55L589.95,251.05L590.95,252.15L590.35,254.55L587.95,257.05L583.45,262.15L583.05,261.95L585.95,257.55L583.95,255.15L584.95,249.75L583.05,252.55L583.05,256.65L579.85,255.65L582.85,257.65L581.35,263.75L582.75,264.25L582.75,266.45L581.75,272.85L577.15,277.55L571.05,279.45L566.65,283.25L563.85,283.65L560.45,286.05L559.15,288.15L552.25,292.35L548.45,295.45L544.95,299.25L543.05,303.75L543.05,308.25L543.65,313.75L545.15,318.25L544.65,321.05L545.95,328.45L544.95,332.85L544.35,335.35L542.35,339.25L540.55,340.05L537.95,339.25L537.55,336.45L535.75,334.95L533.75,329.45L532.15,324.55L531.75,322.05L533.75,317.75L532.95,314.25L529.85,308.85L527.95,307.85L521.85,310.85L520.95,310.45L518.95,307.45L515.95,305.85L509.55,306.75L504.95,305.95L500.65,306.45L498.15,307.45L498.75,309.15L498.05,311.75L498.85,313.05L497.65,313.85L495.85,312.95L493.55,314.15L489.65,313.95L486.35,310.55L481.45,311.35L477.85,309.85L474.35,310.35L469.35,311.85L463.25,316.55L457.15,319.35L453.45,322.35L451.55,325.25L450.55,329.75L450.15,332.75L450.75,334.95L448.55,335.15L444.95,333.75L441.05,331.75L440.15,328.75L439.95,324.25L437.55,320.65L436.65,316.85L435.05,312.45L431.85,309.85L427.35,310.05L422.55,315.05L418.55,313.15L416.25,311.25L415.85,307.65L415.05,304.35L412.65,301.55L410.55,299.45L409.25,297.15L399.85,297.15L399.05,299.85L383.95,299.85L373.05,295.35L366.05,292.25L366.95,290.95L359.85,291.65L353.55,292.15L353.85,288.95L351.75,285.25L349.55,284.45L349.65,282.65L346.75,282.25L345.55,280.55L340.75,279.95L339.85,278.85L340.65,275.35L338.15,268.95L337.65,260.05L338.55,258.55L337.25,256.45L335.75,251.05L337.55,245.85L336.65,242.35L340.55,237.05L343.35,231.65L344.45,226.75L349.95,220.75L357.95,209.35L362.25,200.85L364.05,195.55L364.45,192.65L365.85,191.35L371.65,193.55L370.65,199.45L372.85,197.75L375.35,192.65L376.95,187.55L514.05,187.55L515.35,185.15L517.05,185.15L516.15,188.55L517.15,189.55L520.45,189.95L525.05,190.95L528.95,192.85L533.35,192.05L538.75,193.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M274.25,137.85L267.25,140.15L266.45,138.55L268.75,135.75L275.15,133.65L278.65,132.75L281.25,133.15L281.25,135.05L274.25,137.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M235.25,121.25L231.35,122.15L229.65,121.05L228.85,119.45L234.55,118.45L237.55,119.05L235.25,121.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M236.45,98.85L237.65,99.85L241.15,99.35L242.75,100.85L246.05,101.55L244.85,102.25L239.95,103.45L238.25,102.15L237.95,101.15L233.65,101.45L233.35,100.95L236.45,98.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M409.25,65.85L384.65,86.25L349.05,118.95L353.25,119.15L356.05,120.75L356.55,123.35L356.85,127.15L364.45,123.85L370.95,121.95L370.35,125.05L371.15,127.45L372.75,130.15L371.65,134.35L370.25,141.25L374.85,145.05L371.65,148.85L366.55,151.75L365.95,149.55L363.45,147.55L366.75,142.35L365.15,137.45L367.85,131.85L363.75,131.45L356.65,131.35L352.85,129.55L349.55,123.45L346.25,122.35L340.55,120.25L333.75,120.75L327.75,118.05L325.05,115.55L318.75,116.75L315.25,120.85L312.35,121.25L305.75,122.45L299.55,124.45L293.15,125.75L296.35,122.25L304.75,116.45L311.55,114.65L311.95,113.25L302.55,116.45L295.15,120.35L283.95,124.55L284.15,127.45L275.15,131.65L267.45,134.15L260.85,136.05L256.85,138.65L246.25,141.75L241.75,144.55L233.55,147.15L230.85,146.75L224.65,148.35L217.65,150.45L211.55,152.45L201.55,154.25L201.95,153.15L210.15,150.35L216.75,148.45L225.35,145.15L231.85,144.55L236.85,142.05L247.25,138.45L249.55,137.25L255.25,135.15L261.05,130.65L267.25,127.15L259.95,128.95L259.65,127.85L254.75,130.05L255.15,127.05L251.55,129.15L253.15,126.25L245.85,128.55L243.05,128.55L246.75,125.05L250.05,122.85L249.65,120.75L242.45,121.95L241.85,119.15L240.55,117.75L244.55,114.45L244.15,111.95L250.05,108.65L257.75,105.35L263.05,102.45L267.15,102.05L268.95,102.95L276.05,100.15L278.55,100.65L284.15,98.85L286.65,96.25L285.55,95.25L291.55,93.05L288.75,93.15L282.55,94.35L279.65,95.65L277.85,94.35L270.95,95.05L266.35,93.65L267.55,91.35L266.55,88.15L275.75,85.75L288.95,83.05L292.45,83.05L288.15,85.85L297.35,85.65L298.55,82.15L296.25,80.05L297.05,77.25L296.35,74.95L293.05,73.25L299.55,70.35L307.05,70.15L315.85,67.75L320.65,65.15L328.55,62.55L333.35,61.95L344.55,59.55L347.65,59.95L358.05,57.15L362.45,58.25L361.95,60.65L365.25,59.65L371.55,59.95L369.65,61.15L374.55,62.05L379.45,61.55L385.65,63.15L392.85,63.75L395.05,64.35L401.65,63.55L405.75,65.15L409.25,65.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M676.55,486.25L678.05,483.45L678.55,480.55L679.55,477.85L677.45,474.05L677.15,469.65L680.25,464.15L682.15,464.85L686.25,466.35L692.15,471.75L692.95,474.35L689.55,480.25L687.75,484.95L685.55,487.45L682.85,487.85L682.05,486.05L680.75,485.85L679.05,487.55L676.55,486.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M592.15,421.25L591.65,421.05L591.15,420.55L591.25,419.95L591.45,420.25L591.85,420.65L592.15,421.15L592.15,421.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="AI" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M633.45,384.15L633.25,384.15L633.55,383.75L633.85,383.75L633.65,384.05L633.45,384.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M639.95,391.15L640.55,391.45L640.35,391.75L640.15,391.75L639.45,391.85L639.25,391.75L639.25,391.25L639.55,391.15L639.65,390.85L639.85,390.85L639.95,391.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M639.95,387.45L640.15,387.45L640.35,387.65L640.45,388.05L640.35,388.35L640.15,388.45L640.05,388.25L639.75,388.05L639.75,387.55L639.95,387.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1263.35,332.55L1263.65,332.65L1263.85,332.55L1264.25,333.25L1264.15,333.45L1264.25,334.35L1264.25,335.05L1264.05,335.45L1263.95,335.05L1263.35,334.25L1263.45,333.85L1263.25,333.15L1263.25,332.75L1263.35,332.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M579.65,365.25L579.25,365.75L579.05,366.25L578.45,366.55L577.95,366.55L577.85,366.45L577.45,366.65L576.95,366.75L576.35,366.55L575.95,366.65L575.85,366.15L576.15,365.95L576.35,365.65L576.75,365.45L577.05,365.05L577.45,365.05L577.75,364.85L577.95,365.15L578.45,365.35L578.95,365.15L579.65,364.15L579.95,364.15L579.95,364.35L579.65,365.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M579.85,363.55L579.65,362.95L580.25,362.65L580.55,362.95L580.55,363.15L580.25,363.25L579.85,363.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M580.25,357.05L580.45,356.95L580.95,357.25L581.35,357.25L581.75,357.35L582.05,357.55L582.05,357.85L581.85,357.95L581.35,357.55L580.95,357.55L580.85,357.45L580.35,357.65L579.85,357.45L579.85,357.35L580.05,356.85L580.25,357.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M576.35,355.25L576.15,355.65L576.15,356.35L576.05,356.75L575.65,357.05L575.45,357.45L575.05,357.75L574.35,358.05L574.25,358.25L574.05,358.05L574.15,357.85L574.55,357.75L574.75,357.55L574.75,357.35L575.15,357.25L575.35,356.85L575.75,356.75L576.05,356.35L575.85,356.05L575.45,356.05L575.25,355.85L575.65,355.35L575.75,355.25L576.35,355.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M574.45,354.95L574.55,355.05L574.95,355.05L575.35,355.25L574.95,355.65L574.85,355.45L574.65,355.45L574.25,355.35L573.85,355.15L573.55,354.55L573.85,354.45L574.25,354.55L574.45,354.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M565.25,349.05L565.85,349.75L566.15,349.95L566.45,350.45L566.15,350.35L566.05,350.15L565.75,350.05L565.35,349.65L565.15,349.55L564.95,349.15L565.25,349.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M568.95,349.05L569.25,349.65L569.45,350.15L569.45,350.55L569.65,350.75L569.85,351.45L569.85,352.35L570.05,352.65L570.55,352.85L570.95,353.45L570.95,354.25L570.55,353.55L570.55,353.35L570.25,352.95L569.65,352.75L569.85,352.55L569.55,352.25L569.55,351.95L569.75,351.65L569.65,351.15L569.35,350.75L569.45,350.65L569.15,350.25L569.05,349.65L568.85,349.75L568.95,349.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M571.85,349.05L571.55,349.25L571.25,349.15L571.15,348.95L571.75,348.75L571.85,349.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M563.65,347.15L563.55,347.05L563.25,346.35L563.45,346.35L563.65,347.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M574.15,346.65L573.75,347.25L573.35,347.25L573.55,346.95L573.65,346.35L574.05,346.05L574.15,346.45L574.15,346.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M555.65,345.45L555.35,345.55L555.15,345.85L554.85,345.75L555.45,345.35L555.65,345.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M555.85,346.15L556.25,346.35L556.45,346.15L556.55,345.65L556.75,345.55L556.95,346.15L556.95,346.65L556.85,346.95L556.95,347.55L556.95,347.85L556.55,348.65L556.35,348.75L555.95,348.55L556.15,348.25L556.55,348.05L556.45,347.95L555.85,348.35L555.65,348.15L556.05,347.85L555.65,347.85L555.45,347.95L555.25,347.75L555.25,347.05L555.35,346.85L554.95,346.35L554.95,346.15L555.35,345.95L555.45,345.65L555.75,345.55L555.85,345.35L556.45,345.05L556.55,345.45L556.05,345.85L555.85,346.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M569.35,345.55L569.45,346.05L569.25,345.95L568.75,346.05L568.35,346.15L568.25,345.95L568.55,345.75L568.95,345.45L568.95,345.25L568.55,345.05L568.35,344.45L568.25,343.85L567.85,343.45L567.85,343.25L567.35,342.75L567.65,342.45L568.05,342.85L568.05,343.35L568.25,343.65L568.35,344.15L568.65,344.65L569.05,344.95L569.15,345.25L569.35,345.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M559.05,340.05L559.35,340.25L558.75,340.55L558.45,340.45L558.25,340.65L557.75,340.55L557.95,340.25L558.35,340.05L559.05,340.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M554.85,339.55L555.25,339.35L555.55,339.65L555.45,339.85L555.55,340.05L555.35,340.45L555.65,340.75L555.85,341.65L556.05,341.95L556.45,342.45L556.25,343.15L556.35,343.75L556.15,344.05L555.85,344.15L555.45,344.55L555.15,344.75L554.85,344.75L554.55,344.95L554.25,344.95L554.25,344.55L553.95,344.35L554.05,343.75L553.75,344.05L553.55,343.95L552.95,343.55L552.65,343.25L552.45,342.95L553.15,342.65L553.65,343.35L553.75,342.75L553.45,342.65L553.35,342.35L553.45,342.05L554.05,341.45L554.25,341.05L554.15,340.95L554.45,340.55L554.45,340.05L554.25,339.35L554.35,339.25L554.65,339.25L554.85,339.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M562.95,336.95L563.05,337.15L563.35,337.55L564.15,338.25L564.65,338.35L564.75,338.45L564.95,338.85L565.25,339.25L565.75,339.65L565.75,339.85L565.55,340.65L565.45,340.85L565.45,341.15L565.35,341.65L565.15,341.95L565.05,342.65L564.95,342.75L564.75,342.15L564.35,341.85L564.45,341.65L564.95,341.75L565.15,341.55L565.05,341.35L565.15,340.95L565.45,340.55L565.55,340.05L565.55,339.75L565.05,339.35L564.65,338.65L564.35,338.45L563.75,338.15L563.45,337.85L562.85,337.65L562.45,337.85L562.85,336.95L562.95,336.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M554.15,329.45L554.65,329.65L554.75,329.65L555.45,329.75L555.65,329.55L555.85,329.65L556.35,329.65L556.75,329.45L557.15,329.45L557.45,329.25L557.55,329.75L557.45,329.95L556.75,329.95L555.65,330.15L555.35,330.15L553.85,330.55L553.15,330.95L552.75,330.95L552.55,330.85L552.25,330.55L551.75,329.95L552.35,330.25L552.45,330.45L552.95,330.45L553.45,330.25L553.85,329.65L553.55,329.55L553.75,329.25L553.85,328.95L554.15,329.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M558.45,328.15L559.25,328.35L559.45,328.25L559.85,328.55L560.75,329.55L560.95,330.15L561.35,330.25L562.05,330.75L562.05,330.95L561.85,331.45L562.05,332.15L561.65,332.15L561.15,332.55L561.05,332.75L560.75,333.75L560.65,334.65L560.45,334.85L560.15,334.65L560.05,334.25L559.65,334.15L559.95,333.65L560.15,333.65L560.65,333.25L560.55,332.85L560.75,332.45L560.75,332.15L560.95,331.85L560.95,331.25L561.15,331.15L561.35,330.85L561.45,330.55L561.15,330.45L560.65,330.35L560.55,330.05L560.55,329.85L560.15,329.65L560.15,329.35L559.85,328.65L559.65,328.55L559.35,328.65L558.85,328.55L558.55,328.55L557.95,328.15L558.45,328.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BL" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M634.45,386.25L634.35,385.95L634.65,386.05L634.45,386.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M636.55,293.25L636.25,293.25L636.15,293.35L636.25,293.55L635.85,293.75L635.75,293.65L635.95,293.55L636.05,293.55L636.15,293.25L636.45,293.15L636.55,293.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BB" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M650.75,417.25L650.15,417.05L650.05,416.55L650.05,415.75L650.25,415.35L650.45,415.55L650.65,416.15L651.15,416.45L651.25,416.85L650.75,417.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1232.45,580.55L1231.55,580.45L1231.35,580.05L1231.35,579.75L1231.85,579.85L1232.55,580.35L1232.45,580.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1236.15,578.65L1236.35,579.65L1236.35,580.35L1236.25,580.55L1236.05,580.25L1235.65,579.95L1235.55,579.75L1235.25,579.65L1234.65,579.25L1234.75,579.15L1235.25,579.35L1235.55,579.25L1235.75,578.85L1235.75,578.65L1236.05,578.55L1236.15,578.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1230.45,577.65L1229.95,577.25L1229.65,577.15L1229.35,576.95L1229.15,576.35L1229.25,576.05L1229.25,575.85L1229.45,574.65L1229.35,574.55L1229.55,574.15L1230.05,574.05L1230.25,574.35L1230.05,575.55L1230.15,575.85L1230.35,576.25L1230.45,576.75L1230.65,577.35L1230.45,577.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M847.05,405.75L846.85,406.05L846.65,405.85L846.65,405.55L846.95,405.45L847.05,405.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M848.95,405.85L848.75,405.95L848.35,405.85L848.05,405.55L847.95,405.25L848.15,404.85L848.65,404.55L849.05,404.55L849.25,405.25L849.15,405.65L848.95,405.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M852.45,402.75L852.65,402.85L852.65,403.05L852.85,403.25L853.25,403.75L853.45,403.75L853.65,404.05L853.85,404.55L854.05,404.75L853.75,405.25L853.45,405.35L852.95,405.25L852.65,405.15L852.35,404.85L852.35,404.65L852.15,404.55L852.05,404.15L852.15,403.95L852.15,403.65L852.35,403.25L852.15,402.75L852.45,402.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M855.55,402.75L855.85,402.85L855.95,403.45L855.85,403.85L855.45,404.05L855.05,403.65L855.25,403.25L855.15,403.05L855.55,402.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M857.55,397.05L857.85,396.85L858.35,397.05L858.45,397.25L858.45,397.95L858.05,398.25L857.75,398.45L857.45,398.45L856.95,398.25L856.95,397.75L857.15,397.55L857.15,396.95L857.25,396.85L857.55,397.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M849.55,394.25L849.95,394.15L850.25,394.35L850.65,394.35L850.95,394.55L851.05,394.75L850.55,394.75L849.85,394.45L849.65,394.55L849.35,395.15L849.05,394.55L848.95,394.45L848.85,394.05L849.15,393.95L849.55,394.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M857.35,393.75L857.45,393.85L857.35,394.45L857.15,394.55L857.15,394.05L856.95,393.75L856.95,393.45L856.85,393.15L857.25,392.85L857.45,393.05L857.35,393.65L857.35,393.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M846.05,392.45L846.25,392.75L846.35,393.05L845.65,393.35L845.35,393.15L845.15,392.95L845.55,392.55L846.05,392.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M845.25,390.65L845.55,390.75L845.55,390.95L845.85,391.25L845.65,391.65L845.05,391.95L844.65,392.35L843.95,392.45L843.95,391.85L843.75,391.65L843.75,391.45L843.95,391.25L844.15,391.25L844.35,391.05L845.05,390.65L845.25,390.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="CW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M598.25,423.75L597.95,423.75L597.55,423.45L597.25,423.35L596.95,423.05L596.85,422.85L596.55,422.75L596.35,422.35L596.05,422.05L596.15,421.55L596.65,421.85L596.75,422.35L597.15,422.75L597.85,422.95L598.05,423.25L598.35,423.65L598.25,423.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M531.95,377.05L532.25,377.15L532.45,376.75L532.85,376.85L533.35,376.85L533.45,377.05L533.25,377.25L533.05,377.15L532.65,377.25L532.45,377.35L531.75,377.35L531.95,377.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M540.05,374.55L539.35,374.85L539.55,374.55L540.05,374.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M540.65,374.65L540.55,374.55L541.35,374.25L541.15,374.55L540.65,374.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1167.45,275.95L1167.55,276.15L1167.85,276.55L1167.45,276.45L1167.15,276.45L1166.75,276.65L1166.45,276.35L1166.45,276.05L1166.75,275.95L1166.95,276.05L1167.45,275.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1165.75,276.45L1165.75,276.55L1165.55,276.75L1165.45,277.35L1165.35,277.55L1165.05,277.55L1164.85,277.75L1164.35,277.95L1163.55,278.35L1163.15,278.25L1162.65,278.35L1162.35,278.75L1162.15,278.45L1161.85,278.55L1161.65,278.55L1161.35,278.25L1160.95,278.55L1160.45,278.55L1159.95,278.35L1159.45,278.25L1159.05,277.95L1158.75,277.35L1158.45,277.05L1158.25,276.35L1158.05,276.05L1158.15,275.75L1158.65,276.05L1159.05,275.95L1159.25,275.65L1159.35,275.35L1159.65,275.25L1159.85,275.35L1160.05,275.15L1160.25,275.15L1160.35,275.55L1160.85,275.75L1160.95,275.95L1161.55,275.95L1162.15,275.45L1162.55,275.55L1162.85,275.35L1163.15,275.45L1163.55,275.65L1163.75,275.35L1164.05,275.35L1164.35,275.75L1164.35,276.35L1164.65,276.15L1164.95,276.35L1165.05,276.25L1165.75,276.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="DM" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M641.25,400.95L641.75,401.05L641.95,401.55L641.95,402.15L641.85,402.95L641.75,403.15L641.15,403.45L641.25,403.05L641.15,402.85L641.05,402.15L640.75,401.65L640.75,401.35L640.85,401.05L640.85,400.75L641.05,400.75L641.25,400.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M696.65,835.45L697.05,835.35L697.05,835.75L696.25,835.45L696.55,835.15L696.75,835.05L696.65,835.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M695.95,834.05L696.15,834.25L696.55,834.35L696.65,834.75L696.35,834.85L696.25,834.45L696.05,834.25L695.95,834.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M702.15,833.25L702.35,833.35L702.25,833.75L701.95,833.65L701.75,833.35L702.05,833.15L702.15,833.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M690.05,832.35L690.05,832.55L690.15,832.85L689.75,832.95L689.45,832.85L689.25,832.65L688.95,832.55L688.85,832.15L689.05,832.15L689.15,831.95L689.45,831.85L689.65,831.95L689.35,832.25L689.65,832.35L689.95,832.05L690.05,832.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M692.95,831.05L692.55,830.85L692.05,830.55L691.25,830.25L691.35,829.85L690.65,829.75L690.35,829.65L690.05,829.25L690.25,829.15L691.05,829.45L691.85,829.85L692.35,829.95L692.75,830.05L693.05,829.75L693.15,829.45L693.35,829.55L693.75,829.35L693.85,829.55L694.35,829.55L694.35,829.85L694.65,829.85L695.55,829.65L695.65,829.85L695.95,829.85L696.35,829.75L696.05,829.55L695.95,829.25L696.35,829.25L696.95,829.45L697.05,829.85L696.65,830.35L696.75,830.65L696.55,830.85L696.15,830.85L695.85,831.65L695.55,831.95L695.25,832.55L695.15,832.85L694.65,833.15L694.55,832.95L694.15,832.95L694.15,833.25L693.35,833.15L693.25,833.25L693.55,833.65L693.45,833.75L693.25,834.15L692.85,834.15L692.55,834.55L692.25,834.65L692.05,834.65L691.85,834.35L691.45,834.05L691.45,833.85L690.95,833.85L691.55,834.25L691.15,834.25L690.65,833.95L690.05,833.65L689.75,833.45L689.75,833.25L690.45,833.45L691.05,833.25L690.55,833.05L690.45,832.95L691.35,832.95L691.75,833.05L692.05,833.25L692.05,833.05L692.45,832.95L692.55,832.65L692.15,832.45L691.95,831.95L692.05,831.75L692.65,831.75L692.85,831.85L693.25,831.75L693.15,831.45L692.35,831.45L692.35,831.55L691.95,831.75L691.35,831.75L690.85,831.45L690.85,831.15L691.55,831.35L692.15,831.15L692.45,831.15L692.95,831.05L693.35,831.25L693.35,831.15L692.95,831.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M694.55,829.15L694.85,829.15L695.15,829.45L694.85,829.55L694.55,829.55L694.55,829.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M693.55,829.15L693.25,829.15L693.15,828.85L693.55,828.95L693.55,829.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M692.15,828.95L692.75,828.85L692.95,829.15L692.65,829.55L692.45,829.45L692.15,829.55L691.85,829.35L692.15,829.15L692.45,829.35L692.55,829.15L692.05,829.05L692.15,828.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M699.35,829.05L699.95,829.05L700.05,828.95L700.55,828.85L700.95,829.05L701.35,829.35L701.45,829.65L701.45,829.75L700.95,829.85L700.75,829.55L700.55,829.45L700.45,829.75L700.65,829.85L700.75,830.15L701.05,829.95L701.25,830.05L701.35,830.45L701.65,830.55L701.75,830.45L702.25,830.75L702.35,830.35L701.55,830.15L701.65,829.65L701.95,829.45L703.45,829.35L704.15,829.95L704.35,830.05L704.35,830.45L703.75,830.35L703.25,830.15L702.65,830.35L702.95,830.55L703.35,830.65L704.25,830.75L704.55,830.85L704.65,831.05L704.45,831.55L703.95,831.55L703.85,831.65L703.15,831.75L702.65,831.95L702.95,832.15L702.05,832.55L701.65,832.45L701.15,832.55L700.45,832.55L699.85,832.35L699.25,831.95L699.25,832.25L699.55,832.45L700.15,832.65L700.45,832.95L700.65,832.85L701.05,832.95L701.45,833.25L701.25,833.35L701.45,833.85L701.25,833.85L700.95,833.55L700.55,833.45L700.05,833.85L699.85,833.55L699.55,833.35L699.25,833.35L698.75,833.15L698.55,833.25L698.75,833.65L699.05,833.65L699.25,833.85L699.05,833.95L699.75,834.55L699.55,834.65L699.15,834.45L698.85,834.45L698.55,834.15L697.95,833.95L697.85,834.55L698.35,834.65L698.35,834.95L698.25,835.15L697.85,835.05L697.75,834.85L697.25,834.65L697.15,834.45L696.95,834.45L696.55,833.95L696.85,833.55L696.85,833.35L696.45,832.85L696.45,832.65L696.95,832.45L696.85,832.25L697.35,832.15L697.25,831.85L697.85,831.45L698.45,831.25L698.85,831.65L698.85,832.05L699.15,831.95L698.65,831.35L698.75,831.05L698.15,830.85L697.75,830.55L697.85,830.35L698.25,830.55L698.35,830.05L697.65,829.85L697.75,829.55L697.95,829.65L698.25,829.45L698.55,829.45L698.75,829.15L698.45,828.85L698.85,828.85L699.35,829.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M694.35,828.65L695.05,828.65L695.25,828.85L695.45,828.65L695.65,828.75L695.85,829.05L695.65,829.15L695.25,829.05L694.85,828.85L694.05,828.75L694.15,828.55L694.35,828.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M687.55,827.55L687.05,827.45L687.15,827.25L687.55,827.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M954.85,111.25L955.25,111.45L955.55,111.45L955.65,111.65L955.65,112.05L955.85,112.35L955.75,112.55L955.15,112.15L954.95,111.75L954.75,111.55L954.55,111.25L954.85,111.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.15,109.65L955.95,109.85L956.15,110.05L956.05,110.45L955.95,110.55L955.55,110.05L955.05,109.95L954.85,109.55L955.15,109.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M953.87,108.29L953.95,108.45L954.25,108.45L954.25,108.75L953.85,108.75L953.65,108.95L953.05,108.75L952.85,108.65L952.65,108.35L953.15,108.25L953.25,108.15L953.81,108.24L953.55,108.05L953.75,107.25L954.25,107.35L954.55,107.85L954.55,107.95L955.15,108.15L955.45,108.65L955.75,108.85L955.65,109.45L955.15,109.05L954.95,108.85L954.75,108.75L954.65,108.55L954.45,108.35L953.95,108.35L953.87,108.29Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M957.55,107.65L957.35,107.45L957.65,107.25L957.55,107.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M955.15,108.15L954.75,107.95L954.45,107.65L954.35,107.35L954.45,107.25L954.85,107.15L955.15,107.15L955.75,107.55L955.65,107.75L955.75,107.95L956.35,108.15L956.35,108.35L955.95,108.65L955.15,108.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M957.35,107.55L957.05,107.95L956.75,107.75L956.45,107.75L956.65,107.45L956.55,107.05L956.65,106.95L956.85,107.35L957.35,107.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M956.45,107.55L956.25,107.55L956.05,107.15L956.15,106.85L956.35,107.25L956.45,107.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1908.65,466.95L1908.45,467.25L1907.95,467.15L1907.95,466.95L1908.45,466.55L1908.65,466.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1880.45,456.35L1880.85,456.35L1881.15,456.55L1881.25,456.95L1881.05,457.05L1881.15,457.25L1881.05,457.45L1880.45,457.45L1880.25,457.25L1880.25,457.05L1880.05,456.75L1880.05,456.45L1880.45,456.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1765.75,439.75L1765.85,440.05L1765.55,440.05L1765.25,440.55L1765.15,440.45L1765.45,439.65L1765.85,439.55L1765.75,439.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GD" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M638.45,423.75L638.05,424.05L637.85,423.95L637.75,423.45L637.95,422.95L638.25,422.55L638.55,422.55L638.65,422.85L638.55,423.55L638.45,423.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="GU" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1800.05,414.75L1799.95,415.15L1799.95,415.75L1799.85,416.05L1799.55,416.05L1799.35,415.75L1799.25,415.25L1799.25,414.75L1799.85,414.25L1799.95,414.05L1800.05,413.55L1800.25,413.45L1800.35,413.65L1800.75,413.75L1800.55,414.25L1800.05,414.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M635.55,391.25L635.25,391.25L635.15,391.05L635.35,390.65L635.55,390.65L635.65,390.85L635.55,391.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M634.85,389.75L634.75,390.05L634.55,390.05L634.15,389.85L633.95,389.65L634.25,389.25L634.75,389.65L634.85,389.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="LC" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M642.95,413.05L642.75,412.85L642.35,412.65L642.25,412.45L642.25,411.85L642.35,411.65L643.05,410.55L643.35,410.75L643.35,411.45L643.25,412.25L643.15,412.65L642.95,413.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MF" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M633.45,385.25L633.05,385.15L633.25,384.85L633.55,384.75L633.45,385.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MV" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1402.15,473.95L1402.15,474.25L1401.95,474.15L1402.15,473.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MH" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1953.05,455.25L1954.05,455.65L1953.85,455.65L1953.05,455.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1063.15,270.95L1062.95,271.25L1062.45,271.05L1061.95,270.75L1061.95,270.25L1061.85,270.15L1062.45,270.15L1062.85,270.45L1063.05,270.65L1063.15,270.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1061.55,269.85L1061.05,269.75L1061.05,269.55L1061.45,269.45L1061.85,269.75L1061.55,269.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1801.75,410.35L1801.65,410.45L1801.45,410.35L1801.35,410.15L1801.85,409.95L1802.05,410.15L1801.75,410.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1803.25,405.25L1803.05,405.25L1802.75,404.65L1802.85,404.35L1803.15,404.35L1803.15,404.65L1803.35,404.85L1803.25,405.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1803.75,403.65L1803.55,403.85L1803.65,404.15L1803.25,404.15L1803.25,403.45L1803.35,403.25L1803.75,403.05L1803.65,403.55L1803.75,403.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1801.85,396.15L1801.55,396.15L1801.45,395.95L1801.85,395.95L1801.85,396.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1799.95,385.15L1799.85,384.95L1799.85,384.45L1800.15,384.35L1800.35,384.65L1799.95,385.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1798.75,380.85L1798.35,380.75L1798.35,380.45L1798.55,380.35L1798.75,380.55L1798.75,380.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MS" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M637.45,393.15L637.65,393.55L637.65,393.85L637.45,394.05L637.25,393.95L637.15,393.65L637.45,393.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1306.95,630.05L1307.35,630.95L1307.15,631.55L1306.75,631.95L1306.85,632.25L1306.55,632.55L1306.05,632.75L1305.55,632.75L1304.95,632.65L1304.85,632.75L1304.55,632.45L1304.75,632.25L1304.85,631.85L1304.95,631.15L1305.15,630.75L1305.65,630.35L1305.75,630.15L1305.95,629.65L1306.35,629.35L1306.75,629.45L1306.95,630.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1338.75,627.95L1338.45,627.65L1338.85,627.45L1339.15,627.35L1339.35,627.45L1339.25,627.65L1338.75,627.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1914.45,646.15L1914.25,646.25L1914.05,646.65L1913.65,646.45L1913.85,645.95L1913.95,645.75L1914.25,645.85L1914.45,646.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1918.85,638.35L1918.75,638.45L1918.95,638.85L1919.25,638.85L1919.65,638.65L1919.55,639.25L1919.35,639.45L1919.25,639.85L1918.75,640.15L1918.35,639.95L1918.35,639.85L1918.05,639.55L1918.15,639.35L1917.95,639.15L1918.05,638.75L1917.95,638.35L1918.05,638.35L1918.45,638.45L1918.85,638.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1916.15,634.05L1915.95,634.55L1915.95,634.95L1915.75,635.25L1916.05,635.45L1916.25,635.55L1916.35,635.75L1916.25,635.95L1916.55,636.35L1916.35,636.35L1916.15,636.85L1915.95,637.05L1915.65,636.95L1915.45,636.65L1915.35,636.45L1914.75,636.35L1914.45,635.85L1914.45,635.65L1914.35,635.35L1914.65,635.35L1914.95,635.15L1915.35,634.85L1915.45,634.55L1915.05,634.35L1914.65,634.45L1914.85,634.05L1915.15,633.95L1915.35,634.05L1915.75,633.75L1916.15,634.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1912.75,632.45L1912.45,633.05L1912.35,633.35L1912.65,633.35L1911.95,634.05L1911.85,633.85L1912.15,633.45L1912.35,632.95L1912.75,632.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1912.75,632.45L1912.55,632.05L1912.95,632.05L1913.05,632.45L1912.75,632.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1898.85,630.05L1899.05,630.15L1899.55,631.05L1899.85,631.35L1900.15,631.25L1900.35,630.95L1901.25,631.45L1901.55,631.95L1902.25,632.55L1902.55,632.95L1902.65,633.25L1903.05,633.65L1903.15,633.85L1903.35,633.85L1903.65,634.15L1904.55,634.35L1904.65,634.65L1904.65,635.05L1904.95,635.45L1905.35,635.55L1905.05,636.05L1905.15,636.25L1905.55,636.75L1905.65,636.75L1906.05,637.25L1905.95,637.65L1906.65,637.85L1907.05,638.35L1907.35,638.35L1907.65,638.55L1908.15,638.95L1908.05,639.25L1908.35,639.25L1908.75,639.75L1909.35,640.15L1909.35,640.35L1909.65,640.45L1909.95,640.75L1909.95,640.95L1910.25,641.55L1910.65,641.95L1910.75,641.85L1911.15,642.45L1911.65,642.55L1911.95,642.85L1911.95,643.25L1912.05,643.65L1912.15,643.75L1911.95,644.35L1911.25,644.75L1911.15,644.45L1910.85,644.55L1910.55,644.85L1909.95,644.05L1909.55,644.05L1909.45,643.85L1909.25,643.85L1909.05,644.15L1908.15,643.25L1907.95,643.25L1907.55,642.75L1907.65,641.95L1906.95,641.95L1906.65,641.75L1906.55,641.55L1906.35,641.45L1906.05,641.45L1906.05,641.15L1905.85,640.65L1905.45,640.75L1904.65,640.25L1904.55,640.05L1904.55,639.75L1904.25,639.95L1903.65,639.65L1903.55,639.25L1903.15,638.95L1902.95,638.45L1902.45,638.35L1902.65,638.15L1902.35,637.85L1902.05,637.75L1901.75,637.05L1901.75,636.65L1901.55,636.35L1901.25,636.35L1901.05,635.75L1901.15,635.55L1900.45,635.15L1900.15,634.95L1899.75,634.35L1900.05,634.15L1899.85,633.95L1899.65,633.65L1899.65,633.15L1899.15,632.85L1899.15,632.25L1898.95,631.95L1899.25,631.95L1899.35,631.65L1899.25,631.45L1898.65,631.45L1898.45,631.15L1898.95,630.45L1898.65,630.15L1898.85,630.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1899.95,630.35L1899.65,630.25L1899.75,629.85L1899.95,630.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1897.65,627.95L1897.45,628.15L1897.35,627.75L1897.55,627.55L1897.65,627.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="NR" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1932.25,504.55L1932.05,504.55L1931.95,504.25L1932.25,504.25L1932.25,504.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="PW" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1746.95,452.35L1746.75,452.75L1746.85,452.85L1746.65,453.45L1746.75,453.65L1746.25,453.85L1746.05,453.15L1746.35,452.95L1746.15,452.75L1746.45,452.15L1746.75,452.05L1746.95,452.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M606.35,385.15L606.05,384.95L606.15,384.75L606.45,384.75L606.55,384.85L606.35,385.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M620.95,384.65L620.75,384.65L619.85,384.95L619.25,384.95L619.45,384.75L619.85,384.55L620.25,384.45L620.85,384.55L620.95,384.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M611.45,382.25L612.05,382.35L612.65,382.35L612.95,382.45L613.55,382.35L613.85,382.45L614.25,382.35L614.45,382.45L614.95,382.35L615.35,382.45L615.65,382.45L616.45,382.65L616.45,382.45L617.05,382.65L617.15,382.55L617.95,382.65L618.15,382.85L618.35,382.85L618.95,383.15L619.15,383.05L619.05,383.75L619.25,384.05L618.35,384.35L618.05,384.75L617.75,385.35L617.45,385.55L617.15,385.65L616.75,385.65L616.15,385.75L615.85,385.95L615.15,385.85L614.95,385.65L614.45,385.85L614.15,385.55L613.45,385.75L612.55,385.65L612.25,385.75L611.65,385.85L611.45,385.95L611.25,385.75L610.85,385.65L610.55,385.85L609.95,385.75L610.25,385.05L610.25,384.65L610.45,384.25L610.25,383.65L610.05,383.55L609.95,383.15L610.55,382.85L610.55,382.35L610.95,382.15L611.45,382.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M194.55,678.55L194.45,678.45L194.25,678.15L194.35,677.95L194.65,678.15L194.55,678.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M204.85,640.45L204.75,640.55L204.45,640.35L204.65,640.15L204.85,640.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M198.65,615.75L198.45,615.65L198.65,615.05L199.15,614.65L199.45,614.65L199.45,614.85L199.25,615.25L198.65,615.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M150.95,614.75L151.65,614.95L151.95,615.35L151.95,615.65L151.75,615.75L151.25,615.65L150.85,615.05L150.75,614.85L150.15,615.05L149.95,615.05L149.35,614.95L149.15,614.55L148.85,614.05L148.85,613.75L148.95,613.55L149.45,613.45L149.95,613.45L150.45,613.65L150.65,614.05L150.75,614.65L150.95,614.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M147.95,613.25L147.75,613.85L147.25,613.65L147.35,613.35L147.85,613.15L147.95,613.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M165.55,604.65L165.25,604.75L165.35,604.45L165.55,604.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M203.55,568.75L203.25,568.75L203.25,568.35L203.05,568.05L203.45,568.15L203.55,568.55L203.55,568.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M200.45,565.25L200.25,565.25L200.25,564.85L200.45,564.55L200.75,564.75L200.55,564.95L200.45,565.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M201.65,563.65L201.65,563.95L201.25,564.05L200.65,564.05L200.65,564.35L200.25,564.25L200.05,564.05L199.95,563.75L200.65,563.35L200.95,563.35L201.15,563.55L201.65,563.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M194.75,561.05L194.75,561.65L194.45,561.65L194.15,561.25L194.45,560.95L194.75,561.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M197.15,558.05L197.45,558.15L197.55,558.25L196.95,558.45L196.85,558.15L197.15,558.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M193.45,557.45L194.35,557.55L194.65,557.85L194.65,558.05L194.25,558.35L193.45,558.35L193.35,557.85L193.25,557.45L193.45,557.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1926.05,575.45L1926.35,575.65L1926.25,576.05L1926.55,576.05L1926.55,576.25L1925.75,576.25L1925.45,575.75L1925.65,575.45L1926.05,575.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1887.75,574.85L1887.95,574.85L1888.95,575.65L1889.45,575.95L1890.35,576.65L1890.25,576.95L1890.05,576.95L1889.85,577.15L1889.65,576.85L1889.55,576.85L1889.35,576.65L1889.25,576.25L1888.85,576.15L1888.85,575.85L1888.55,575.75L1888.45,575.85L1888.25,575.85L1887.35,575.45L1887.15,575.05L1887.45,574.65L1887.75,574.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1924.65,573.35L1924.45,573.65L1924.15,573.45L1924.15,573.25L1924.45,573.05L1924.65,573.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1922.35,569.45L1922.45,569.55L1922.75,569.55L1922.65,569.95L1922.15,570.15L1921.85,570.15L1921.45,570.25L1921.05,570.85L1920.95,570.55L1920.65,570.65L1920.45,570.45L1920.45,570.15L1920.95,570.05L1920.95,569.85L1921.25,569.45L1921.95,569.55L1922.35,569.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1896.05,566.65L1896.35,566.55L1896.95,566.85L1897.75,567.65L1897.95,567.65L1898.15,567.85L1898.35,567.85L1898.65,568.15L1898.95,568.05L1899.35,568.15L1899.55,568.35L1899.95,568.35L1900.25,568.25L1900.45,568.55L1900.65,569.35L1900.95,569.65L1900.95,570.15L1900.75,570.35L1900.85,570.65L1900.45,570.45L1900.15,570.65L1899.85,570.55L1899.35,570.25L1899.15,570.25L1898.55,570.05L1898.15,569.95L1897.95,569.65L1897.65,569.45L1897.35,569.35L1897.15,569.05L1896.75,568.85L1896.95,568.45L1896.85,568.05L1896.85,567.65L1896.65,567.55L1896.05,567.35L1895.75,567.45L1895.65,567.25L1895.85,566.65L1896.05,566.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1900.05,563.25L1899.95,563.45L1899.95,564.15L1899.75,563.95L1899.75,563.45L1900.05,563.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1897.15,561.45L1897.45,562.35L1897.65,562.75L1897.65,563.15L1897.75,563.65L1897.55,563.95L1897.15,563.25L1897.05,563.55L1896.75,563.05L1896.85,562.05L1896.95,561.85L1896.95,561.55L1897.15,561.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1888.75,561.65L1889.05,561.65L1889.35,561.55L1889.75,561.65L1889.85,561.55L1891.15,561.55L1891.35,561.85L1891.65,561.95L1891.85,562.25L1892.05,562.25L1892.25,562.35L1892.65,562.75L1892.65,563.35L1892.85,563.35L1893.25,563.55L1893.35,563.85L1893.35,564.45L1893.25,564.55L1892.55,564.75L1892.35,564.85L1891.95,564.75L1891.55,564.55L1891.15,564.55L1891.05,564.35L1890.55,564.05L1889.95,564.05L1889.45,564.15L1888.95,564.15L1888.45,564.05L1888.15,563.85L1887.85,563.95L1887.55,563.55L1887.25,563.35L1886.95,562.55L1886.75,562.15L1886.95,561.95L1886.85,561.75L1886.85,561.05L1886.95,560.75L1887.55,560.45L1887.95,560.65L1888.35,561.15L1888.45,561.45L1888.75,561.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1891.05,559.25L1891.55,559.75L1891.25,560.05L1890.95,559.85L1890.95,559.75L1891.05,559.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1891.05,559.25L1890.85,559.65L1890.75,559.65L1890.35,559.35L1890.05,559.45L1889.85,559.35L1889.75,559.15L1890.05,559.05L1890.25,558.85L1890.75,558.95L1891.05,559.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1884.45,558.75L1884.55,558.95L1884.75,559.05L1884.55,559.45L1884.15,559.65L1883.85,559.25L1884.45,558.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1875.95,556.95L1876.15,557.25L1876.05,557.55L1875.25,557.15L1875.75,556.85L1875.95,556.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1879.35,557.75L1879.05,557.55L1879.15,557.25L1879.45,556.95L1879.45,557.45L1879.55,557.65L1879.35,557.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1878.45,555.95L1878.65,555.85L1879.05,555.85L1879.05,556.05L1878.65,556.35L1878.85,556.55L1878.85,556.85L1878.45,557.25L1878.25,557.35L1877.95,557.25L1877.55,556.85L1877.65,556.25L1877.95,556.15L1878.15,555.75L1878.45,555.65L1878.45,555.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1874.85,556.05L1874.65,556.15L1874.45,556.65L1874.85,557.15L1874.35,556.95L1874.35,556.75L1874.25,556.45L1873.85,556.05L1873.85,555.85L1874.25,555.65L1874.35,555.35L1874.75,555.05L1875.05,555.25L1875.05,555.65L1874.85,556.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1887.75,555.55L1887.95,555.75L1887.85,555.95L1887.65,555.85L1887.05,555.35L1887.25,554.95L1887.55,554.85L1887.75,555.05L1887.65,555.35L1887.75,555.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1894.25,554.75L1894.65,555.55L1895.25,556.35L1895.25,556.65L1894.85,556.85L1894.85,557.65L1894.95,557.85L1895.15,557.85L1895.35,558.15L1895.85,558.55L1895.95,559.05L1896.05,559.35L1896.25,559.55L1896.05,559.75L1896.35,560.05L1896.25,560.15L1896.35,560.65L1896.15,560.85L1896.45,561.15L1896.55,561.65L1896.75,562.15L1896.75,562.75L1896.65,562.85L1896.35,562.55L1896.05,562.05L1896.05,561.75L1895.75,561.35L1895.35,561.05L1895.05,560.75L1894.55,560.15L1894.15,559.85L1893.85,558.95L1893.65,557.95L1893.45,557.25L1893.45,556.75L1893.35,556.35L1893.75,555.95L1893.65,555.65L1893.15,554.95L1893.05,554.65L1893.15,554.55L1893.55,554.65L1893.75,554.75L1894.05,554.45L1894.25,554.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1873.55,554.45L1873.35,554.05L1873.05,553.75L1873.45,553.75L1873.55,554.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1873.45,553.45L1873.85,553.55L1873.95,553.65L1874.05,554.15L1873.85,554.15L1873.65,553.75L1873.45,553.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1876.55,553.65L1876.45,553.95L1877.15,553.95L1877.55,554.65L1877.55,554.85L1877.75,555.15L1877.85,555.65L1877.65,555.85L1877.65,556.15L1877.05,555.95L1876.85,555.75L1876.55,555.75L1876.15,555.45L1876.05,555.25L1875.95,554.95L1876.35,555.05L1876.05,554.25L1875.95,554.05L1875.45,554.15L1875.25,554.25L1874.85,554.25L1874.55,554.65L1874.15,554.45L1874.15,553.85L1874.35,553.65L1874.75,553.65L1874.75,553.25L1875.15,552.65L1875.55,552.35L1875.85,552.15L1876.25,552.45L1876.45,552.85L1876.35,553.55L1876.55,553.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1870.65,553.65L1870.55,553.65L1870.35,552.85L1870.45,552.55L1870.45,552.15L1870.65,552.25L1870.75,552.65L1870.75,553.35L1870.65,553.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1874.05,553.15L1873.75,553.35L1873.65,553.25L1873.25,553.25L1872.95,552.95L1872.75,552.35L1872.85,552.05L1873.15,551.65L1873.65,551.45L1873.85,551.65L1874.15,552.15L1874.15,552.75L1874.05,553.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1871.05,549.65L1871.45,550.15L1871.45,550.25L1872.15,550.65L1872.05,550.95L1871.45,551.65L1871.45,551.95L1871.15,552.05L1871.15,551.65L1870.95,551.65L1870.95,551.25L1870.75,550.85L1870.45,550.65L1870.35,550.35L1870.45,550.05L1870.85,549.65L1871.05,549.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1881.35,549.75L1881.65,549.95L1881.45,550.05L1880.95,550.15L1880.85,549.85L1881.05,549.65L1881.35,549.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1882.25,549.75L1882.45,549.65L1882.95,549.95L1883.25,550.05L1883.45,550.25L1883.75,550.75L1884.05,550.85L1884.35,551.15L1884.35,551.45L1884.85,551.55L1884.85,551.85L1885.15,551.95L1885.45,551.85L1885.55,551.95L1885.95,552.15L1886.05,552.35L1886.35,552.25L1886.65,552.35L1886.75,552.65L1887.15,552.95L1887.45,553.25L1887.85,553.55L1888.85,554.55L1888.55,554.95L1888.85,555.45L1888.95,556.05L1888.65,555.95L1888.35,555.55L1887.65,554.75L1887.25,554.65L1886.75,554.25L1886.15,554.15L1886.05,553.85L1885.45,553.65L1884.95,553.15L1884.75,553.15L1883.95,552.55L1883.45,552.25L1883.45,552.05L1883.05,551.85L1882.85,551.65L1882.65,551.25L1882.25,550.95L1882.15,550.75L1882.15,550.35L1881.75,549.85L1881.55,549.75L1881.55,549.45L1882.25,549.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1880.75,549.15L1880.95,549.35L1881.15,549.25L1881.45,549.45L1881.35,549.65L1881.05,549.55L1880.75,549.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1876.25,548.55L1876.75,548.55L1876.55,548.75L1876.25,548.65L1876.25,548.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1880.55,548.55L1880.35,549.05L1880.25,548.85L1880.55,548.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1877.85,548.95L1877.35,549.05L1877.15,548.85L1877.45,548.45L1877.75,548.55L1877.85,548.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1865.35,548.05L1865.55,548.35L1865.35,548.55L1865.05,548.45L1864.95,548.35L1865.35,548.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1866.85,546.15L1867.15,546.35L1867.05,546.65L1866.35,546.85L1866.05,546.55L1866.35,545.95L1866.55,545.85L1866.85,546.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1868.55,545.25L1868.55,545.75L1868.35,545.55L1868.35,545.35L1868.55,545.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1871.45,543.75L1871.75,543.85L1872.15,544.35L1872.45,544.55L1872.75,544.65L1873.05,544.95L1873.85,545.35L1874.25,545.85L1874.25,546.25L1874.35,546.85L1874.85,547.35L1875.05,547.35L1875.15,547.75L1875.85,548.05L1876.25,547.95L1876.35,548.05L1876.35,548.35L1876.05,548.45L1875.85,548.75L1875.35,548.55L1874.55,548.15L1874.05,548.15L1873.75,547.75L1873.05,547.35L1871.85,545.35L1871.35,545.05L1870.65,544.35L1870.65,543.65L1870.95,543.45L1871.25,543.55L1871.45,543.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1023.15,500.55L1022.95,500.55L1022.75,500.85L1022.55,500.85L1022.25,499.65L1022.25,499.35L1022.65,498.85L1022.95,498.75L1023.25,498.45L1023.65,498.55L1023.85,498.95L1023.95,499.25L1023.85,499.65L1023.65,499.95L1023.35,500.35L1023.15,500.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1027.75,490.75L1027.65,491.05L1027.45,491.15L1027.15,491.05L1027.15,490.75L1027.35,490.65L1027.35,490.35L1027.55,490.15L1027.85,490.25L1027.75,490.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="SX" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M633.45,385.25L633.45,385.35L633.05,385.25L633.05,385.15L633.45,385.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1248.25,561.35L1247.95,561.55L1247.45,561.55L1247.05,561.75L1246.65,561.75L1246.65,561.55L1247.15,561.55L1247.55,561.45L1247.95,561.15L1248.15,561.15L1248.25,561.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1247.75,561.05L1247.55,561.15L1247.15,561.15L1247.15,560.95L1247.75,561.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1299.65,530.75L1300.05,531.15L1299.85,531.45L1299.65,531.15L1299.35,530.95L1299.55,530.45L1299.65,530.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M586.95,360.85L587.65,360.85L587.95,361.25L587.65,361.25L587.35,361.15L586.85,361.25L586.75,360.95L586.95,360.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M584.25,360.75L584.55,361.15L585.15,361.05L584.95,361.25L584.35,361.25L583.95,361.05L584.25,360.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M586.45,360.15L586.45,360.65L585.95,360.45L585.85,360.15L585.95,360.05L586.45,360.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M642.05,431.45L641.85,431.95L641.55,432.35L641.35,432.45L641.25,432.85L641.45,433.45L641.25,433.55L641.25,434.25L641.45,434.55L641.65,434.75L641.45,434.95L641.35,435.25L641.35,435.95L640.75,436.25L640.25,436.35L639.95,436.35L639.45,436.45L638.95,436.35L638.55,436.45L638.25,436.35L637.75,436.55L637.35,436.35L636.75,436.35L636.45,436.55L636.15,436.45L636.65,436.25L636.95,435.95L637.35,435.85L637.75,435.55L637.95,435.25L638.55,435.35L638.85,434.95L638.65,434.15L638.85,433.75L638.85,433.05L638.55,432.65L638.25,432.55L637.85,432.45L637.75,432.35L638.15,432.05L639.25,431.95L639.45,431.75L640.55,431.75L640.65,431.65L641.85,431.45L642.05,431.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M644.45,428.25L644.35,428.75L644.05,428.85L643.65,429.15L643.45,429.15L642.75,429.55L642.55,429.35L642.85,429.05L643.55,428.55L644.45,428.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="TV" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1998.15,555.85L1998.15,555.65L1998.25,555.65L1998.25,555.75L1998.15,555.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VC" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M641.65,416.45L641.35,416.75L640.85,416.45L640.85,416.05L641.05,415.75L641.25,415.25L641.65,415.25L641.75,415.65L641.65,416.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="VG" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M625.35,382.65L624.95,382.85L624.85,382.85L624.55,383.05L624.45,382.95L624.55,382.65L625.15,382.55L625.35,382.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M623.55,386.85L624.05,387.35L622.95,387.55L622.85,387.05L623.55,386.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M624.45,383.25L624.25,383.45L623.75,383.45L623.75,383.25L624.05,383.15L624.45,383.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M623.05,383.05L623.45,383.35L623.25,383.55L622.95,383.35L622.45,383.35L622.65,383.15L623.05,383.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1931.05,631.05L1930.55,630.85L1930.75,630.45L1931.25,630.35L1931.45,630.75L1931.35,630.95L1931.05,631.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1929.85,627.25L1929.65,627.25L1929.35,627.15L1928.95,626.65L1928.85,626.25L1928.85,625.85L1929.05,625.65L1929.15,625.25L1929.45,625.15L1929.85,625.15L1929.65,625.45L1929.65,625.95L1930.35,626.45L1930.05,626.75L1929.85,627.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1929.85,621.35L1930.15,621.35L1930.25,621.55L1929.75,621.65L1929.85,621.95L1930.25,622.15L1930.35,622.45L1930.25,622.85L1929.85,622.95L1929.45,622.65L1929.05,622.65L1928.85,622.45L1928.55,622.25L1928.65,621.85L1928.65,621.55L1928.85,621.05L1929.15,620.65L1929.65,620.65L1929.85,620.75L1929.75,621.15L1929.85,621.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1926.85,613.75L1927.45,613.65L1927.55,613.75L1927.75,614.35L1927.95,614.65L1928.05,614.75L1927.65,615.35L1926.85,615.55L1926.55,615.25L1926.45,614.75L1926.15,614.65L1925.75,614.95L1925.65,614.85L1925.85,614.45L1926.25,614.15L1926.65,613.65L1926.85,613.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1929.15,609.85L1929.05,609.55L1929.35,609.55L1929.15,609.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1927.55,607.45L1927.65,607.95L1927.65,608.15L1928.05,608.25L1928.25,608.75L1928.75,608.75L1928.75,609.15L1928.65,609.25L1928.35,608.95L1928.05,608.85L1927.45,609.05L1927.15,608.95L1927.05,608.75L1926.95,608.35L1927.15,607.85L1927.35,607.55L1927.55,607.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1928.45,607.25L1928.35,607.25L1928.25,606.95L1928.45,606.95L1928.45,607.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1928.65,605.85L1928.45,606.05L1927.85,606.05L1927.55,606.15L1927.35,605.95L1926.95,605.85L1926.45,605.45L1926.55,605.25L1927.05,605.05L1927.45,604.95L1927.85,604.65L1927.95,604.35L1928.15,604.35L1928.25,604.65L1928.25,605.25L1928.75,605.65L1928.65,605.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1923.95,604.55L1924.15,604.85L1924.75,605.25L1925.55,606.05L1925.55,606.45L1925.75,606.75L1925.45,606.95L1925.05,607.35L1925.05,607.15L1924.75,607.05L1924.35,607.05L1924.15,607.15L1924.15,607.35L1923.75,607.55L1923.45,607.45L1923.45,606.75L1923.35,606.15L1923.45,605.55L1923.55,605.05L1923.35,604.55L1922.75,604.85L1922.55,604.65L1922.45,604.35L1922.45,604.05L1922.75,603.75L1922.75,603.35L1922.85,603.05L1923.15,602.95L1923.75,603.25L1923.65,603.45L1923.85,603.95L1923.75,604.15L1923.95,604.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1923.35,602.15L1923.05,602.15L1922.55,601.85L1922.55,601.75L1922.75,601.45L1922.95,601.35L1923.45,601.45L1923.35,601.85L1923.35,602.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1922.85,601.15L1923.25,600.85L1923.35,600.95L1923.45,601.25L1922.95,601.25L1922.85,601.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1928.55,603.75L1928.35,603.65L1928.45,602.45L1928.35,602.15L1928.45,601.65L1928.75,600.85L1928.85,600.35L1929.05,600.95L1928.95,601.25L1928.95,602.85L1928.85,603.45L1928.55,603.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1927.25,600.45L1926.55,600.45L1926.25,600.35L1926.25,600.15L1927.15,599.45L1927.65,599.25L1928.15,599.15L1928.15,599.35L1927.85,599.75L1927.65,600.05L1927.25,600.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1929.15,599.75L1929.15,599.95L1928.85,599.95L1928.95,599.65L1929.15,598.35L1929.15,598.25L1929.25,597.05L1929.45,597.15L1929.35,598.45L1929.45,598.75L1929.35,599.25L1929.15,599.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1922.85,601.15L1921.95,601.05L1921.35,601.35L1921.25,601.55L1921.05,601.55L1920.95,600.95L1920.75,600.85L1920.35,599.85L1920.75,599.05L1920.75,598.65L1920.65,598.45L1920.65,597.05L1920.55,596.75L1920.55,596.25L1920.75,595.95L1920.75,595.65L1920.95,595.35L1920.95,595.15L1921.25,595.05L1921.35,595.55L1921.55,595.95L1921.75,596.25L1921.85,597.55L1921.75,598.35L1921.75,598.45L1922.35,598.35L1922.65,598.05L1922.85,597.25L1922.85,597.05L1923.15,596.85L1923.45,596.95L1923.35,597.35L1923.35,598.25L1923.65,598.35L1923.65,598.85L1923.45,598.95L1923.75,599.35L1923.55,599.55L1923.55,600.05L1923.75,600.55L1923.65,600.75L1923.35,600.75L1922.85,601.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1927.05,591.85L1927.45,592.15L1927.35,592.55L1926.85,593.05L1926.25,593.05L1926.25,592.65L1926.35,592.25L1926.55,591.95L1927.05,591.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1927.65,589.95L1927.35,590.15L1927.15,590.25L1927.15,590.45L1926.95,590.55L1926.95,590.25L1926.75,590.05L1926.65,589.75L1926.75,589.35L1927.35,589.05L1927.45,589.25L1927.55,589.65L1927.55,589.75L1927.65,589.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1922.65,585.75L1922.55,585.65L1922.65,585.15L1922.85,585.35L1922.65,585.75Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BQBO" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M601.25,423.85L601.05,423.85L600.95,423.35L601.05,423.05L600.95,422.75L600.55,422.65L600.25,422.35L600.35,422.05L601.55,422.65L601.45,422.85L601.45,423.25L601.25,423.45L601.25,423.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BQSE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M633.55,388.85L633.35,388.95L633.35,388.75L633.45,388.65L633.55,388.85Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="BQSA" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M632.05,387.95L631.95,387.95L632.05,387.75L632.15,387.85L632.05,387.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="MQ" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M643.25,406.15L643.25,406.35L643.65,406.25L643.45,406.75L643.65,406.95L643.65,407.15L643.85,407.35L644.05,408.25L643.75,408.55L643.65,408.15L643.55,408.25L642.95,408.15L642.55,408.15L642.35,407.85L642.95,407.35L642.55,407.35L642.15,406.95L642.05,406.45L641.85,405.95L642.15,405.55L642.55,405.65L643.05,405.95L643.25,406.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M887.65,322.65L887.35,323.15L886.95,323.65L886.65,323.25L886.25,323.25L886.05,323.05L886.25,322.75L886.65,322.85L887.05,322.45L887.35,322.25L887.55,322.35L887.65,322.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M901.25,320.35L901.25,320.85L901.45,321.25L901.25,321.95L901.35,322.25L900.95,322.65L900.45,322.85L900.25,323.05L899.65,322.85L899.15,322.35L898.95,321.95L898.95,321.35L899.55,320.95L899.65,320.45L899.65,320.25L900.25,320.35L900.65,320.35L900.95,320.45L901.25,320.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M891.55,321.15L891.15,321.15L890.85,320.95L890.65,320.65L890.75,320.25L890.85,319.95L891.45,319.95L891.95,320.35L892.05,320.65L891.55,321.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M897.45,317.65L897.45,317.85L896.85,318.15L896.45,318.65L896.15,318.85L896.15,319.25L895.75,319.95L895.65,320.35L895.15,320.95L895.05,321.15L894.85,321.15L894.25,321.35L894.15,321.25L894.05,320.85L893.75,320.45L893.65,320.25L893.45,319.95L893.45,319.65L893.05,319.05L893.55,318.75L893.85,318.95L894.45,318.75L894.85,318.75L895.35,318.55L895.85,318.15L895.85,317.95L896.45,317.65L897.05,317.65L897.35,317.55L897.45,317.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M907.65,320.45L907.35,320.85L906.95,320.95L906.65,320.85L906.25,320.85L906.25,320.65L906.55,320.65L907.15,320.45L907.55,320.15L907.85,319.85L907.95,319.35L908.05,319.05L908.25,318.55L908.55,318.15L908.85,317.55L909.05,316.75L909.25,316.55L909.65,316.45L909.95,316.75L910.05,317.25L909.85,318.25L909.85,318.75L909.75,318.85L909.45,319.55L909.15,319.85L908.55,319.95L907.85,320.25L907.65,320.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M888.05,315.95L888.35,315.85L888.55,316.15L888.75,316.65L888.55,316.95L888.65,317.35L888.05,318.35L887.95,318.25L887.85,317.85L887.45,316.95L887.35,316.65L887.25,316.45L887.45,316.05L887.75,315.85L888.05,315.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M912.15,313.95L912.15,314.35L911.95,314.85L911.25,315.35L910.75,315.45L910.35,315.95L909.85,315.75L909.85,315.65L910.05,315.25L910.05,314.85L910.25,314.55L910.55,314.35L910.85,314.35L911.15,314.05L911.65,314.05L911.75,313.95L911.95,313.45L912.15,313.35L912.35,313.55L912.15,313.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="YT" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1239.45,582.35L1239.65,582.65L1240.15,582.85L1240.15,583.15L1239.95,583.35L1240.05,583.55L1239.75,584.15L1239.85,584.35L1239.55,584.45L1239.35,584.15L1239.35,583.85L1239.55,583.65L1239.35,582.95L1239.25,582.85L1239.15,582.65L1239.45,582.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g id="RE" transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1293.75,635.05L1294.65,635.05L1295.05,635.25L1295.35,635.55L1295.35,635.85L1295.45,636.35L1295.75,636.55L1295.95,636.75L1296.05,636.95L1295.85,637.55L1295.75,637.95L1295.55,638.15L1295.15,638.25L1294.25,638.25L1294.05,638.05L1293.25,637.65L1292.95,637.15L1292.95,636.85L1292.65,636.25L1292.75,635.85L1292.95,635.65L1293.15,635.25L1293.25,635.25L1293.75,635.05Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M642.25,399.15L641.95,399.15L641.75,398.75L641.85,398.55L642.15,398.25L642.45,398.45L642.55,398.75L642.55,398.95L642.25,399.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M640.45,396.55L640.75,396.55L640.75,396.85L640.55,396.95L640.55,398.15L640.35,398.35L639.75,398.65L639.75,398.45L639.55,398.25L639.45,397.75L639.45,397.25L639.35,396.75L639.35,396.45L639.55,396.15L639.85,396.05L640.35,396.35L640.45,396.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M641.85,396.15L642.25,396.25L642.75,396.65L641.45,396.95L641.15,397.05L640.75,396.75L640.85,396.15L641.05,396.05L640.95,395.45L641.05,395.25L641.35,395.05L641.65,395.45L641.65,395.85L641.85,396.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1988.35,624.15L1988.05,624.25L1988.15,623.85L1988.35,624.15Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1980.85,622.55L1981.05,622.75L1981.35,622.85L1981.35,623.15L1980.85,623.35L1980.35,623.05L1979.85,623.35L1979.55,623.35L1979.35,623.65L1979.45,623.95L1979.05,623.85L1978.95,624.05L1978.55,623.95L1978.45,624.05L1978.05,623.85L1978.35,623.75L1978.55,623.65L1978.75,623.45L1979.15,623.55L1979.45,623.25L1979.65,622.95L1980.15,622.85L1980.65,622.55L1980.85,622.55Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1981.75,622.45L1981.55,622.55L1981.35,622.45L1981.55,622.25L1981.75,622.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1987.65,616.35L1987.75,616.85L1987.55,617.45L1987.45,617.25L1987.35,616.85L1987.15,616.85L1987.25,616.35L1987.45,616.25L1987.65,616.35Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1985.05,614.95L1984.95,614.95L1984.85,614.55L1985.05,614.35L1985.45,614.25L1985.45,614.65L1985.25,614.85L1985.05,614.95Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1982.85,612.45L1982.75,612.85L1983.05,613.05L1983.15,613.35L1983.45,613.75L1983.75,613.85L1983.85,614.15L1984.05,614.15L1984.15,614.55L1983.85,615.05L1983.95,615.25L1984.05,615.75L1983.75,615.95L1983.75,616.45L1983.95,616.45L1984.05,616.95L1983.75,617.25L1983.15,617.45L1983.05,617.25L1982.75,617.35L1982.65,617.55L1982.35,617.25L1981.55,617.55L1980.75,618.25L1980.45,618.15L1980.05,618.35L1979.75,618.25L1979.15,618.35L1978.85,618.15L1977.65,617.75L1977.05,617.65L1976.85,617.55L1976.35,617.35L1976.15,616.35L1976.45,615.65L1976.75,615.65L1977.05,615.55L1977.15,615.05L1977.45,614.95L1977.55,614.55L1977.35,614.35L1977.95,613.95L1978.35,613.45L1978.45,613.55L1979.05,613.05L1979.25,613.05L1980.15,612.65L1980.75,612.85L1981.05,612.75L1981.55,612.55L1982.15,612.45L1982.45,612.15L1982.85,612.45Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1989.15,612.65L1988.95,612.75L1989.15,611.85L1989.55,611.85L1989.45,612.25L1989.15,612.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1977.75,610.65L1977.55,610.95L1977.05,611.25L1977.05,610.95L1977.45,610.55L1977.75,610.65Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1992.65,610.25L1992.45,610.05L1992.55,609.85L1993.05,609.35L1993.35,608.85L1993.05,609.95L1992.65,610.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g><g transform="matrix(1.10024,0,0,1.10024,-156.277,553.374)"><path d="M1993.65,605.25L1993.25,605.65L1992.45,606.75L1992.15,606.85L1991.45,607.25L1991.25,607.85L1990.85,608.05L1990.65,608.35L1990.55,608.55L1990.85,608.65L1991.45,608.35L1991.85,607.95L1992.05,607.65L1992.65,607.35L1992.95,607.05L1993.55,606.75L1993.55,607.05L1993.05,607.75L1992.85,607.85L1992.95,608.45L1992.65,608.75L1992.35,608.45L1991.95,608.45L1991.45,608.55L1991.05,608.85L1990.35,608.95L1989.35,608.95L1989.85,608.45L1989.45,608.25L1988.85,608.45L1988.45,608.65L1988.45,608.85L1988.15,608.95L1987.95,609.05L1987.85,609.45L1987.65,609.75L1987.35,609.65L1987.35,609.45L1986.95,609.35L1986.55,609.55L1986.35,610.05L1986.05,610.25L1985.75,610.25L1985.75,609.55L1985.55,609.15L1985.65,608.95L1985.55,608.85L1984.95,609.05L1984.95,608.65L1985.35,608.35L1985.45,608.35L1985.35,607.85L1985.65,607.75L1986.15,608.05L1986.75,607.65L1986.95,607.65L1987.25,607.35L1987.45,607.35L1987.75,607.05L1987.75,606.85L1988.55,606.75L1989.75,606.35L1990.15,606.45L1990.65,606.25L1990.85,605.85L1991.05,605.85L1991.25,605.45L1991.65,605.55L1991.75,605.35L1991.95,605.45L1992.95,604.95L1993.05,605.25L1993.25,605.15L1993.45,605.25L1993.75,604.95L1994.25,604.75L1994.35,604.85L1993.85,605.25L1993.65,605.25Z" style="fill-rule:nonzero;stroke:white;stroke-width:0.5px;"></path></g></g>', 1), Jk = [
  Xk
];
function Qk(t, e) {
  return b(), _("svg", qk, Jk);
}
const eM = /* @__PURE__ */ K(Kk, [["render", Qk]]), ST = /* @__PURE__ */ r5({
  __name: "IconWorldMaps",
  props: {
    region: { default: "All" }
  },
  setup(t) {
    const e = t, r = U(() => {
      switch (e.region) {
        case "Caucasian":
          return Mk;
        case "Latino/Hispanic":
          return Rk;
        case "MENA":
          return zk;
        case "African":
          return ck;
        case "South Asian":
          return Gk;
        case "East Asian":
          return vk;
        case "Pacific Islander":
          return Ek;
        default:
          return eM;
      }
    });
    return (L, o) => (b(), x5(q0(r.value), { class: "opacity-30 fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color" }));
  }
}), tM = {}, rM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, LM = /* @__PURE__ */ d("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
}, null, -1), nM = [
  LM
];
function oM(t, e) {
  return b(), _("svg", rM, nM);
}
const CT = /* @__PURE__ */ K(tM, [["render", oM]]), sM = {}, aM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, iM = /* @__PURE__ */ d("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 224c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zm-96 32c0 53 43 96 96 96s96-43 96-96s-43-96-96-96s-96 43-96 96zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
}, null, -1), lM = [
  iM
];
function uM(t, e) {
  return b(), _("svg", aM, lM);
}
const DT = /* @__PURE__ */ K(sM, [["render", uM]]), dM = {}, cM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, hM = /* @__PURE__ */ d("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
}, null, -1), fM = [
  hM
];
function pM(t, e) {
  return b(), _("svg", cM, fM);
}
const zT = /* @__PURE__ */ K(dM, [["render", pM]]), mM = {}, gM = {
  "data-v-4f666550": "",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "exclamation-triangle",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  class: "incomplete-attempt-marker exclamation-mark svg-inline--fa fa-exclamation-triangle fa-w-18",
  style: {}
}, vM = /* @__PURE__ */ d("path", {
  "data-v-4f666550": "",
  fill: "currentColor",
  d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z",
  class: ""
}, null, -1), yM = [
  vM
];
function wM(t, e) {
  return b(), _("svg", gM, yM);
}
const IT = /* @__PURE__ */ K(mM, [["render", wM]]), bM = /* @__PURE__ */ r5({
  __name: "IconLoad",
  props: {
    size: { default: 50 }
  },
  setup(t) {
    const e = t, r = U(() => `height: ${e.size}px; width: ${e.size}px`);
    return (L, o) => (b(), _("span", {
      class: "loader",
      style: R5(r.value)
    }, null, 4));
  }
});
const TT = /* @__PURE__ */ K(bM, [["__scopeId", "data-v-b3f76107"]]), xM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, OT = /* @__PURE__ */ r5({
  __name: "IconMicrophone",
  props: {
    liveRecording: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, r) => (b(), _("svg", xM, [
      d("path", {
        class: F({
          "fill-bl-icon-default-color": !e.liveRecording,
          "dark:fill-bl-dk-icon-default-color": !e.liveRecording,
          "fill-bl-error-color": e.liveRecording,
          "dark:fill-bl-dk-error-color": e.liveRecording
        }),
        d: "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
      }, null, 2)
    ]));
  }
}), kM = {
  id: "profile",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384.07 383.9"
}, MM = { key: 0 }, _M = {
  id: "gradient",
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%"
}, $M = { id: "Layer_1-2" }, SM = /* @__PURE__ */ r5({
  __name: "IconPerson",
  props: {
    color: { default: "#ff0000" },
    gradient: {}
  },
  setup(t) {
    return (e, r) => (b(), _("svg", kM, [
      e.gradient ? (b(), _("defs", MM, [
        d("linearGradient", _M, [
          d("stop", {
            offset: "0%",
            style: R5({ stopColor: e.gradient.start, stopOpacity: 100 })
          }, null, 4),
          d("stop", {
            offset: "100%",
            style: R5({ stopColor: e.gradient.stop, stopOpacity: 100 })
          }, null, 4)
        ])
      ])) : X("", !0),
      d("g", $M, [
        d("path", {
          style: R5({ background: e.color }),
          d: "M192,383.8c-62.29,0-124.58-.04-186.88,.1-4.12,0-5.31-.87-5.11-5.1,.5-10.14,1.04-20.27,1.71-30.41,.57-8.6,4.9-14.61,11.27-19.64,10.12-8,21.61-13.62,33.27-18.91,24.38-11.05,49.74-19.5,75.09-27.98,19.59-6.55,21.52-9.37,21.51-30.18,0-4-.04-7.99-.05-11.99-.02-8.09-2.28-15.2-7.63-21.58-9.43-11.23-12.33-25.2-14.96-39.12-1.37-7.24-3.39-14.02-7.03-20.57-5.29-9.53-7.39-20.23-8.67-31.01-.21-1.78,.17-7.72,.85-9.33,4.57-10.93,2.24-18.33,.22-29.06C97.52,46.15,131.26,5.3,177.85,.78c22.38-2.17,44.01-.22,63.67,11.44,21.92,13.01,34.91,32.36,37.91,57.86,1.07,9.13-1.09,18.24-1.82,27.35-.6,7.62-2.82,12.5,.22,20.03,1.19,2.94,1.98,8.84,1.38,10.47-2.38,10.01-5.36,26.87-11.05,35.78-3.55,5.56-3.64,12.38-4.9,18.7-2.85,14.36-7.13,27.99-16.98,39.33-2.77,3.18-4.01,7.21-4.39,11.47-.82,9.31-.51,18.62-.29,27.94,.22,9.36,5.07,14.75,13.41,17.66,11.59,4.05,23.24,7.94,34.81,12.04,23.16,8.22,46.21,16.72,67.71,28.84,3.76,2.12,7.34,4.56,10.94,6.94,9.22,6.11,14.39,14.39,14.43,25.78,.03,8.99,.48,17.98,1.14,26.94,.29,3.94-1.09,4.52-4.66,4.52-62.46-.11-124.92-.08-187.38-.08Z"
        }, null, 4)
      ])
    ]));
  }
});
const PT = /* @__PURE__ */ K(SM, [["__scopeId", "data-v-158d97e5"]]), CM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, DM = {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64z"
}, ZT = /* @__PURE__ */ r5({
  __name: "IconSignal",
  props: {
    connected: { type: Boolean, default: !1 },
    interactive: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, r) => (b(), _("svg", CM, [
      b5(d("path", {
        class: F({
          "fill-bl-icon-default-color": !e.connected,
          "dark:fill-bl-dk-icon-default-color": !e.connected,
          "fill-bl-success-color": e.connected,
          "dark:fill-bl-dk-success-color": e.connected
        }),
        d: "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
      }, null, 2), [
        [T1, !e.interactive || e.interactive && e.connected]
      ]),
      b5(d("path", DM, null, 512), [
        [T1, e.interactive && !e.connected]
      ])
    ]));
  }
}), zM = {}, IM = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, TM = /* @__PURE__ */ d("path", {
  class: "fill-bl-icon-default-color dark:fill-bl-dk-icon-default-color",
  d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
}, null, -1), OM = [
  TM
];
function PM(t, e) {
  return b(), _("svg", IM, OM);
}
const ET = /* @__PURE__ */ K(zM, [["render", PM]]), ZM = ["id"], EM = {
  key: 0,
  class: "flex items-end relative input-container"
}, AM = { class: "input-wrapper flex items-end relative mr-0.5" }, NM = ["value", "placeholder"], HM = { class: "flex flex-col sm:flex-row justify-start datepicker-inputs-container" }, BM = { class: "input-wrapper flex items-end relative mr-0.5" }, VM = { class: "input-background" }, RM = ["value", "placeholder", "onChange", "onInput", "onKeyup", "onFocus", "onBlur"], YM = {
  name: "MfxDatePicker",
  components: { IconCalendar: f2 }
}, AT = /* @__PURE__ */ r5({
  ...YM,
  props: {
    modelValue: {
      type: [Date, String],
      default: "",
      required: !0
    },
    localeOverride: {
      type: String,
      default: void 0,
      required: !1
    },
    placeholder: {
      type: String,
      required: !1
    },
    hideSvg: {
      type: Boolean,
      default: !1,
      required: !1
    },
    showBlur: {
      type: Boolean,
      default: !0
    },
    useModal: {
      type: Boolean,
      default: !1
    },
    teleportId: {
      type: String,
      default: "body"
    },
    modalId: {
      type: String,
      required: !0
    }
  },
  emits: [
    "update:modelValue",
    "datePickerOpen",
    "datePickerClose"
  ],
  setup(t, { emit: e }) {
    const r = t, L = P(), o = P(), n = P(), { modelValue: a } = N5(r), { localValue: s } = y1(a, e), i = P(), l = P(), u = U(
      () => r.showBlur ? "backdrop-filter: blur(5px);" : "background-color: #0003;"
    ), c = U(() => {
      if (s.value) {
        const C = new Date(s.value);
        return r.localeOverride && C ? new Intl.DateTimeFormat(r.localeOverride).format(C) : s.value;
      }
      return s.value;
    }), v = st({
      weekdays: "WWW"
    }), p = st({
      enUS: "en-US",
      deDE: "de-DE"
    }), m = P(!1), f = P(""), x = P(""), y = U(
      () => r.localeOverride ? r.localeOverride : p.deDE
    ), w = () => {
      m.value = !0, e("datePickerOpen"), M();
    }, g = () => {
      m.value = !1, e("datePickerClose"), k();
    }, h = (C = "", D) => {
      const S = (B) => B instanceof KeyboardEvent;
      if (!i.value || !S(D))
        return;
      const T = D.keyCode;
      if (T === 13) {
        C.length < 10 && (i.value.value = "");
        return;
      }
      if (T > 31 && (T < 48 || T > 57) && T < 96 && T > 105 || T === 190)
        i.value.value = C.slice(0, C.length - 1);
      else if (C.length === 2 && C[1] !== "/" && C[1] !== "." && D.code !== "Backspace" && (f.value = +C > 31 ? "31" : C, i.value.value = f.value + "."), C.length === 5 && C[4] !== "/" && C[4] !== "." && D.code !== "Backspace") {
        const B = C.split(".")[1];
        x.value = +B > 12 ? "12" : B, i.value.value = `${f.value}.${x.value}.`;
      }
    }, k = () => {
      var C;
      r.showBlur && ((C = L.value) == null || C.classList.toggle("portrait-mode"));
    }, M = () => {
      var C, D, S;
      (C = L.value) == null || C.classList.toggle("datepicker-open"), (D = L.value) != null && D.classList.contains("portrait-mode") && ((S = L.value) == null || S.classList.toggle("portrait-mode"));
    }, $ = () => {
      o.value.classList.toggle("show"), o.value.classList.toggle("noShow"), n.value.classList.toggle("show"), n.value.classList.toggle("noShow");
    };
    return I5(() => {
      window.addEventListener("click", (C) => {
        n.value && C.target.id === n.value.id && $();
      });
    }), S2(() => {
      window.removeEventListener("click", () => {
      });
    }), s5(
      () => s.value,
      () => {
        o.value.classList.remove("show"), o.value.classList.add("noShow"), n.value.classList.remove("show"), n.value.classList.add("noShow");
      }
    ), (C, D) => (b(), _(p5, null, [
      (b(), x5(SL, { to: t.teleportId }, [
        b5(d("div", {
          id: t.modalId,
          ref_key: "refBlocker",
          ref: n,
          class: "blocker noShow datepicker-wrapper",
          style: R5(u.value)
        }, [
          b5(d("div", {
            id: "dateModal",
            ref_key: "refModal",
            ref: o,
            class: "flex items-center justify-center fixed noShow modalContainer"
          }, [
            Z(O(q6), {
              modelValue: O(s),
              "onUpdate:modelValue": D[0] || (D[0] = (S) => h1(s) ? s.value = S : null),
              style: { "z-index": "800" },
              locale: y.value,
              masks: v,
              "update-on-input": !0,
              "trim-weeks": ""
            }, null, 8, ["modelValue", "locale", "masks"])
          ], 512), [
            [T1, t.useModal]
          ])
        ], 12, ZM), [
          [T1, t.useModal]
        ])
      ], 8, ["to"])),
      t.useModal ? (b(), _("div", EM, [
        d("div", AM, [
          d("input", {
            ref_key: "dateInput",
            ref: i,
            class: "outline-none w-[144px] font-bold text-sm date-picker-input bg-transparent",
            maxlength: "10",
            value: c.value,
            placeholder: t.placeholder,
            readonly: "",
            onClick: $
          }, null, 8, NM),
          Z(O(f2), { hide: t.hideSvg }, null, 8, ["hide"])
        ])
      ])) : X("", !0),
      t.useModal ? X("", !0) : (b(), _("div", {
        key: 1,
        ref_key: "datepickerWrapper",
        ref: L,
        "test-name": "dp-name",
        class: "inline items-end justify-center datepicker-wrapper portrait-mode-focus date-picker"
      }, [
        Z(O(q6), {
          ref_key: "datepicker",
          ref: l,
          modelValue: O(s),
          "onUpdate:modelValue": D[2] || (D[2] = (S) => h1(s) ? s.value = S : null),
          "data-testid": "datePicker",
          locale: y.value,
          masks: v,
          "update-on-input": !0,
          "trim-weeks": "",
          onChange: D[3] || (D[3] = (S) => h(O(s).toString(), S)),
          onPopoverWillShow: w,
          onPopoverWillHide: g,
          onPopoverDidShow: k,
          onPopoverDidHide: M
        }, {
          default: c5(({
            inputValue: S,
            inputEvents: T,
            togglePopover: B,
            showPopover: I,
            hidePopover: R
          }) => [
            d("div", HM, [
              d("div", {
                class: F(["flex items-end relative input-container", { "input-state": m.value }])
              }, [
                d("div", BM, [
                  b5(d("div", VM, null, 512), [
                    [T1, m.value]
                  ]),
                  d("input", {
                    ref_key: "dateInput",
                    ref: i,
                    class: "outline-none w-[144px] font-bold text-sm date-picker-input bg-transparent",
                    maxlength: "10",
                    value: S,
                    placeholder: t.placeholder,
                    onChange: T.change,
                    onInput: T.input,
                    onKeyup: [
                      ee(B, ["enter"]),
                      D[1] || (D[1] = (N) => {
                        var H;
                        return h((H = i.value) == null ? void 0 : H.value, N);
                      })
                    ],
                    onFocus: I,
                    onBlur: R,
                    readonly: ""
                  }, null, 40, RM)
                ]),
                Z(O(f2))
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "locale", "masks"])
      ], 512))
    ], 64));
  }
});
const FM = (t) => (g1("data-v-42248f85"), t = t(), v1(), t), jM = ["tab-index", "type", "name"], WM = {
  key: 0,
  "data-test-id": "loading-spinner",
  class: "flex items-center justify-center absolute left-0 top-0 w-full h-full bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color"
}, UM = /* @__PURE__ */ FM(() => /* @__PURE__ */ d("svg", {
  class: "spinner text-black",
  viewBox: "0 0 50 50"
}, [
  /* @__PURE__ */ d("circle", {
    class: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    "stroke-width": "5",
    stroke: "currentColor"
  })
], -1)), GM = [
  UM
], KM = {
  name: "MfxButton"
}, qM = /* @__PURE__ */ r5({
  ...KM,
  props: {
    name: { default: "" },
    type: {},
    content: { default: "" },
    tabIndex: { default: 0 },
    isCloseButton: { type: Boolean, default: !1 },
    classes: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const r = t, L = $2(), o = U(() => !!(L != null && L.default)), n = U(() => {
      const i = r.content;
      return !i && !(i && i.length) && !o.value;
    }), a = U(() => {
      const i = {
        "bl-button--no-content": n.value,
        "modal-close-button": r.isCloseButton,
        "bl-button": !0,
        "text-bl-bold": !0,
        "font-bold": !0,
        flex: !0,
        "items-center": !0,
        "bg-bl-button-background-default-color": !0,
        "dark:bg-bl-dk-button-background-default-color": !0,
        "text-bl-text-color": !0,
        "dark:text-bl-dk-text-color": !0
      };
      let l = C5().toString(i);
      return r.classes && (l = T5(
        l,
        C5().toString(r.classes)
      )), l;
    }), s = (i) => {
      e("click", i);
    };
    return (i, l) => (b(), _("button", {
      "tab-index": i.tabIndex,
      type: i.type,
      name: i.name,
      class: F(["relative overflow-hidden", [a.value]]),
      onClick: s
    }, [
      i.$slots.default ? (b(), _("div", {
        key: 0,
        class: F(["flex items-center justify-center h-full", { "mr-1": !!i.content }])
      }, [
        u5(i.$slots, "default", {}, void 0, !0)
      ], 2)) : X("", !0),
      c1(" " + V(i.content) + " ", 1),
      u5(i.$slots, "loader", {}, () => [
        i.loading ? (b(), _("div", WM, GM)) : X("", !0)
      ], !0)
    ], 10, jM));
  }
});
const r0 = /* @__PURE__ */ K(qM, [["__scopeId", "data-v-42248f85"]]);
const XM = { class: "w-full modal__header" }, JM = {
  key: 0,
  class: "w-full flex justify-center items-center"
}, QM = { class: "w-full modal__body" }, e_ = {
  key: 0,
  class: "w-full flex justify-center items-center"
}, t_ = { class: "w-full modal__footer" }, r_ = {
  key: 0,
  class: "w-full flex justify-center items-center"
}, L_ = { class: "w-full modal__header" }, n_ = { class: "w-full modal__body" }, o_ = { class: "w-full modal__footer" }, s_ = {
  name: "MfxModal"
}, NT = /* @__PURE__ */ r5({
  ...s_,
  props: {
    showModal: { type: Boolean, default: !1 },
    type: { default: "default" },
    autoCloseOnClick: { type: Boolean, default: !0 },
    confirmContent: { default: "" }
  },
  emits: ["onHide", "onCancel", "onConfirm"],
  setup(t, { emit: e }) {
    const r = t, L = P(!1), o = () => {
      L.value = !1, e("onHide");
    }, n = () => {
      o(), e("onCancel");
    }, a = () => {
      o(), e("onConfirm");
    };
    return s5(
      () => r.showModal,
      (s) => {
        L.value = s;
      },
      {
        immediate: !0
      }
    ), (s, i) => (b(), x5(mt, { name: "fade" }, {
      default: c5(() => [
        L.value ? (b(), _("div", {
          key: 0,
          class: "backdrop flex items-center justify-center",
          onClick: i[1] || (i[1] = re(() => s.autoCloseOnClick && o(), ["prevent", "stop"]))
        }, [
          d("div", {
            class: F([{ "modal--confirm": s.type === "confirm" }, "modal flex flex-col rounded-panel shadow-md bg-bl-panel-color dark:bg-bl-dk-panel-color"]),
            onClick: i[0] || (i[0] = re(() => {
            }, ["stop"]))
          }, [
            s.type === "confirm" ? (b(), _(p5, { key: 0 }, [
              d("div", XM, [
                u5(s.$slots, "header"),
                s.$slots.header ? X("", !0) : (b(), _("div", JM, [
                  Z(ce, {
                    width: 12.7,
                    height: 15.9,
                    "view-box": "0 0 12.7 15.9"
                  }, {
                    default: c5(() => [
                      Z(h2)
                    ]),
                    _: 1
                  })
                ]))
              ]),
              d("div", QM, [
                u5(s.$slots, "body"),
                s.$slots.body ? X("", !0) : (b(), _("div", e_, [
                  d("p", null, V(s.confirmContent), 1)
                ]))
              ]),
              d("div", t_, [
                u5(s.$slots, "footer"),
                s.$slots.footer ? X("", !0) : (b(), _("div", r_, [
                  Z(r0, { onClick: n }, {
                    default: c5(() => [
                      u5(s.$slots, "cancelIcon")
                    ]),
                    _: 3
                  }),
                  Z(r0, { onClick: a }, {
                    default: c5(() => [
                      u5(s.$slots, "confirmIcon")
                    ]),
                    _: 3
                  })
                ]))
              ])
            ], 64)) : (b(), _(p5, { key: 1 }, [
              d("div", L_, [
                u5(s.$slots, "header")
              ]),
              d("div", n_, [
                u5(s.$slots, "body")
              ]),
              d("div", o_, [
                u5(s.$slots, "footer")
              ])
            ], 64))
          ], 2)
        ])) : X("", !0)
      ]),
      _: 3
    }));
  }
}), a_ = { class: "numeric--stepper flex items-center rounded-full" }, i_ = ["readonly"], l_ = {
  id: "Layer_1",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 30 30",
  style: { "enable-background": "new 0 0 30 30" },
  "xml:space": "preserve",
  class: "[ w-8 cursor-pointer ]"
}, u_ = /* @__PURE__ */ d("g", {
  id: "Gruppe_4535",
  transform: "translate(17772 8414)"
}, [
  /* @__PURE__ */ d("circle", {
    id: "Ellipse_433",
    class: "svgCircle",
    cx: "-17757",
    cy: "-8399",
    r: "15"
  }),
  /* @__PURE__ */ d("g", {
    id: "Gruppe_4221",
    transform: "translate(-17762 -8404)"
  }, [
    /* @__PURE__ */ d("line", {
      id: "Linie_216",
      class: "svgLines",
      x1: "10",
      y1: "5",
      x2: "0",
      y2: "5"
    })
  ])
], -1), d_ = [
  u_
], c_ = { class: "block relative mx-2.5 h-6 input-wrapper" }, h_ = ["id", "name", "min", "max", "step", "required", "readonly", "disabled", "placeholder"], f_ = ["readonly"], p_ = {
  id: "Layer_1",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 30 30",
  style: { "enable-background": "new 0 0 30 30" },
  "xml:space": "preserve",
  class: "[ w-8 cursor-pointer ]"
}, m_ = /* @__PURE__ */ O5('<g id="Gruppe_4535" transform="translate(17772 8414)"><circle id="Ellipse_433" class="svgCircle" cx="-17757" cy="-8399" r="15"></circle><g id="Gruppe_4221" transform="translate(-17762 -8404)"><line id="Linie_215" class="svgLines" x1="5" y1="0" x2="5" y2="10"></line><line id="Linie_216" class="svgLines" x1="10" y1="5" x2="0" y2="5"></line></g></g>', 1), g_ = [
  m_
], v_ = {
  name: "MfxNumericStepper"
}, y_ = /* @__PURE__ */ r5({
  ...v_,
  props: {
    attrs: {
      type: Object,
      required: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputtable: {
      type: Boolean,
      default: !0
    },
    placeholder: {
      type: String,
      default: "N/A"
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    step: {
      type: Number,
      default: 1
    },
    name: {
      type: String,
      required: !1
    },
    modelValue: {
      type: [String, Number],
      required: !0
    },
    maxCharacterWidth: {
      type: String,
      default: "10ch"
    },
    holdDetectionDelay: {
      type: Number,
      default: 250
    },
    increaseUpdateSpeedOnHold: {
      type: Boolean,
      default: !0
    },
    updateOnHoldDelay: {
      type: Number,
      default: 200,
      validator: (t) => t >= 0
    },
    updateOnHoldFactor: {
      type: Number,
      default: 0.96,
      validator: (t) => t > 0
    },
    instanceKey: {
      type: Number
    },
    enableScrollToQuestion: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "valueChanged"],
  setup(t, { expose: e, emit: r }) {
    const L = t, { modelValue: o } = N5(L), { localValue: n } = y1(o, r);
    let a, s = 0;
    const i = P(!1), l = P(), u = P("input-id"), c = P(`ku-${s++}`), v = Number.isNaN || window.isNaN, p = /\.\d*(?:0|9){10}\d*$/, m = U(() => v(n.value) || n.value >= L.min), f = U(() => v(n.value) || n.value < L.max), x = U(() => n.value || n.value === 0 ? `${n.value.toString().length + 4}ch` : "6ch"), y = (I, R = 1e11) => p.test(String(I)) ? Math.round(Number(I) * R) / R : I, w = (I, R = !1) => {
      let N = typeof I != "number" ? Number(I) : I;
      if (N < L.min && R && !L.required) {
        n.value = null;
        return;
      }
      v(N) || L.min <= L.max && (N = Math.min(L.max, Math.max(L.min, N))), n.value = N;
    };
    let g = 0;
    const h = (I) => {
      const R = Number(I.target.value);
      (!I.target.value || R < L.min || R > L.max) && l.value.reportValidity(), I.target.value && (w(R, R <= g), g = R);
    }, k = () => {
      m.value && (v(n.value) && (n.value = 0), w(
        y(Number(n.value) - L.step),
        !0
      ));
    }, M = () => {
      f.value && (v(n.value) && (n.value = 0), w(y(Number(n.value) + L.step)));
    }, $ = () => {
      clearTimeout(a), a = void 0, i.value = !1;
    }, C = (I) => {
      $(), a = setTimeout(() => {
        i.value = !0;
        let R = L.updateOnHoldDelay, N = setTimeout(H(I), R);
        function H(G) {
          return () => {
            clearTimeout(N), R >= 1 && L.increaseUpdateSpeedOnHold && (R = R * L.updateOnHoldFactor), G(), i.value && (N = setTimeout(H(G), R));
          };
        }
      }, L.holdDetectionDelay);
    }, D = () => {
      C(M);
    }, S = () => {
      C(k);
    };
    I5(() => {
      L.instanceKey && (u.value = `${u.value}-${L.instanceKey}`), L.required ? n.value = L.min : n.value = "";
    });
    const T = (I) => {
      const R = document.documentElement.getBoundingClientRect();
      if (L.enableScrollToQuestion && R.y === 0) {
        let N = l.value;
        for (let H = 0; H < 10; H++)
          if (N)
            if (N.className.includes("input-wrapper-label-group")) {
              const G = Array.from(N.children);
              for (const e5 of G) {
                const t5 = Array.from(e5.children);
                for (const J of t5)
                  J.tagName.toLowerCase() === "label" && J.scrollIntoView({ behavior: "smooth" });
              }
            } else
              N = N == null ? void 0 : N.parentElement;
      }
    }, B = (I) => {
      L.required && !I.target.value && (n.value = L.min, c.value = `ku-${s++}`);
    };
    return e({
      props: N5(L),
      increase: M,
      decrease: k,
      change: h,
      setValue: w,
      localValue: n.value
    }), (I, R) => (b(), _("div", a_, [
      d("button", {
        type: "button",
        tabindex: "-1",
        readonly: t.disabled || t.readonly || !m.value,
        class: "svg--container",
        onClick: k,
        onTouchstart: S,
        onMousedown: S,
        onMouseleave: $,
        onMouseup: $,
        onTouchend: $
      }, [
        (b(), _("svg", l_, d_))
      ], 40, i_),
      d("span", c_, [
        b5((b(), _("input", C2({
          id: u.value,
          key: c.value
        }, t.attrs, {
          ref_key: "inputRef",
          ref: l,
          "onUpdate:modelValue": R[0] || (R[0] = (N) => h1(n) ? n.value = N : null),
          type: "number",
          name: t.name,
          min: t.min,
          max: t.max,
          step: t.step,
          required: t.required,
          readonly: t.readonly || !t.inputtable,
          disabled: t.disabled || !m.value && !f.value,
          placeholder: t.placeholder,
          autocomplete: "off",
          pattern: "[0-9]*",
          style: {
            width: x.value,
            maxWidth: t.maxCharacterWidth
          },
          class: "numeric--stepper__input border-0 h-5 p-0 font-sans font-bold bg-transparent placeholder-bl-text-placeholder-color dark:placeholder-bl-dk-text-placeholder-color",
          onChange: h,
          onFocusin: T,
          onFocusout: B,
          onInput: h
        }), null, 16, h_)), [
          [qe, O(n)]
        ])
      ]),
      d("button", {
        type: "button",
        tabindex: "-1",
        readonly: t.disabled || t.readonly || !f.value,
        class: "svg--container",
        onClick: M,
        onTouchstart: D,
        onMousedown: D,
        onMouseleave: $,
        onMouseup: $,
        onTouchend: $
      }, [
        (b(), _("svg", p_, g_))
      ], 40, f_)
    ]));
  }
});
function p2(t, e, r) {
  var L, o, n, a, s;
  e == null && (e = 100);
  function i() {
    var u = Date.now() - a;
    u < e && u >= 0 ? L = setTimeout(i, e - u) : (L = null, r || (s = t.apply(n, o), n = o = null));
  }
  var l = function() {
    n = this, o = arguments, a = Date.now();
    var u = r && !L;
    return L || (L = setTimeout(i, e)), u && (s = t.apply(n, o), n = o = null), s;
  };
  return l.clear = function() {
    L && (clearTimeout(L), L = null);
  }, l.flush = function() {
    L && (s = t.apply(n, o), n = o = null, clearTimeout(L), L = null);
  }, l;
}
p2.debounce = p2;
var N0 = p2;
function w_(t, e, r) {
  h1(t) ? s5(t, (L, o) => {
    o == null || o.removeEventListener(e, r), L == null || L.addEventListener(e, r);
  }) : I5(() => {
    t.addEventListener(e, r);
  }), se(() => {
    var L;
    (L = O(t)) === null || L === void 0 || L.removeEventListener(e, r);
  });
}
function b_(t, e) {
  const r = "pointerdown";
  return typeof window > "u" || !window ? void 0 : w_(window, r, (o) => {
    const n = O(t);
    n && (n === o.target || o.composedPath().includes(n) || e(o));
  });
}
function x_(t, e, r) {
  let L = null;
  const o = P(!1);
  I5(() => {
    (t.content !== void 0 || r.value) && (o.value = !0), L = new MutationObserver(n), L.observe(e.value, {
      childList: !0,
      subtree: !0
    });
  }), se(() => L.disconnect()), s5(r, (a) => {
    a ? o.value = !0 : o.value = !1;
  });
  const n = () => {
    t.content ? o.value = !0 : o.value = !1;
  };
  return {
    hasContent: o
  };
}
function ye(t, e) {
  var r = t.getBoundingClientRect(), L = 1, o = 1;
  return {
    width: r.width / L,
    height: r.height / o,
    top: r.top / o,
    right: r.right / L,
    bottom: r.bottom / o,
    left: r.left / L,
    x: r.left / L,
    y: r.top / o
  };
}
function w1(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function r4(t) {
  var e = w1(t), r = e.pageXOffset, L = e.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: L
  };
}
function dt(t) {
  var e = w1(t).Element;
  return t instanceof e || t instanceof Element;
}
function t1(t) {
  var e = w1(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function Fr(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = w1(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function k_(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function M_(t) {
  return t === w1(t) || !t1(t) ? r4(t) : k_(t);
}
function S1(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function G1(t) {
  return ((dt(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function L4(t) {
  return ye(G1(t)).left + r4(t).scrollLeft;
}
function P1(t) {
  return w1(t).getComputedStyle(t);
}
function n4(t) {
  var e = P1(t), r = e.overflow, L = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + L);
}
function __(t) {
  var e = t.getBoundingClientRect(), r = e.width / t.offsetWidth || 1, L = e.height / t.offsetHeight || 1;
  return r !== 1 || L !== 1;
}
function $_(t, e, r) {
  r === void 0 && (r = !1);
  var L = t1(e);
  t1(e) && __(e);
  var o = G1(e), n = ye(t), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (L || !L && !r) && ((S1(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  n4(o)) && (a = M_(e)), t1(e) ? (s = ye(e), s.x += e.clientLeft, s.y += e.clientTop) : o && (s.x = L4(o))), {
    x: n.left + a.scrollLeft - s.x,
    y: n.top + a.scrollTop - s.y,
    width: n.width,
    height: n.height
  };
}
function o4(t) {
  var e = ye(t), r = t.offsetWidth, L = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - L) <= 1 && (L = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: r,
    height: L
  };
}
function w0(t) {
  return S1(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Fr(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    G1(t)
  );
}
function jr(t) {
  return ["html", "body", "#document"].indexOf(S1(t)) >= 0 ? t.ownerDocument.body : t1(t) && n4(t) ? t : jr(w0(t));
}
function Lt(t, e) {
  var r;
  e === void 0 && (e = []);
  var L = jr(t), o = L === ((r = t.ownerDocument) == null ? void 0 : r.body), n = w1(L), a = o ? [n].concat(n.visualViewport || [], n4(L) ? L : []) : L, s = e.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Lt(w0(a)))
  );
}
function S_(t) {
  return ["table", "td", "th"].indexOf(S1(t)) >= 0;
}
function X6(t) {
  return !t1(t) || // https://github.com/popperjs/popper-core/issues/837
  P1(t).position === "fixed" ? null : t.offsetParent;
}
function C_(t) {
  var e = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r = navigator.userAgent.indexOf("Trident") !== -1;
  if (r && t1(t)) {
    var L = P1(t);
    if (L.position === "fixed")
      return null;
  }
  for (var o = w0(t); t1(o) && ["html", "body"].indexOf(S1(o)) < 0; ) {
    var n = P1(o);
    if (n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].indexOf(n.willChange) !== -1 || e && n.willChange === "filter" || e && n.filter && n.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function bt(t) {
  for (var e = w1(t), r = X6(t); r && S_(r) && P1(r).position === "static"; )
    r = X6(r);
  return r && (S1(r) === "html" || S1(r) === "body" && P1(r).position === "static") ? e : r || C_(t) || e;
}
var r1 = "top", p1 = "bottom", m1 = "right", L1 = "left", s4 = "auto", xt = [r1, p1, m1, L1], we = "start", ct = "end", D_ = "clippingParents", Wr = "viewport", Ue = "popper", z_ = "reference", J6 = /* @__PURE__ */ xt.reduce(function(t, e) {
  return t.concat([e + "-" + we, e + "-" + ct]);
}, []), Ur = /* @__PURE__ */ [].concat(xt, [s4]).reduce(function(t, e) {
  return t.concat([e, e + "-" + we, e + "-" + ct]);
}, []), I_ = "beforeRead", T_ = "read", O_ = "afterRead", P_ = "beforeMain", Z_ = "main", E_ = "afterMain", A_ = "beforeWrite", N_ = "write", H_ = "afterWrite", B_ = [I_, T_, O_, P_, Z_, E_, A_, N_, H_];
function V_(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), L = [];
  t.forEach(function(n) {
    e.set(n.name, n);
  });
  function o(n) {
    r.add(n.name);
    var a = [].concat(n.requires || [], n.requiresIfExists || []);
    a.forEach(function(s) {
      if (!r.has(s)) {
        var i = e.get(s);
        i && o(i);
      }
    }), L.push(n);
  }
  return t.forEach(function(n) {
    r.has(n.name) || o(n);
  }), L;
}
function R_(t) {
  var e = V_(t);
  return B_.reduce(function(r, L) {
    return r.concat(e.filter(function(o) {
      return o.phase === L;
    }));
  }, []);
}
function Y_(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function M1(t) {
  return t.split("-")[0];
}
function F_(t) {
  var e = t.reduce(function(r, L) {
    var o = r[L.name];
    return r[L.name] = o ? Object.assign({}, o, L, {
      options: Object.assign({}, o.options, L.options),
      data: Object.assign({}, o.data, L.data)
    }) : L, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
function j_(t) {
  var e = w1(t), r = G1(t), L = e.visualViewport, o = r.clientWidth, n = r.clientHeight, a = 0, s = 0;
  return L && (o = L.width, n = L.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (a = L.offsetLeft, s = L.offsetTop)), {
    width: o,
    height: n,
    x: a + L4(t),
    y: s
  };
}
var W1 = Math.max, ht = Math.min, Ot = Math.round;
function W_(t) {
  var e, r = G1(t), L = r4(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, n = W1(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = W1(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -L.scrollLeft + L4(t), i = -L.scrollTop;
  return P1(o || r).direction === "rtl" && (s += W1(r.clientWidth, o ? o.clientWidth : 0) - n), {
    width: n,
    height: a,
    x: s,
    y: i
  };
}
function Gr(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (r && Fr(r)) {
    var L = e;
    do {
      if (L && t.isSameNode(L))
        return !0;
      L = L.parentNode || L.host;
    } while (L);
  }
  return !1;
}
function m2(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function U_(t) {
  var e = ye(t);
  return e.top = e.top + t.clientTop, e.left = e.left + t.clientLeft, e.bottom = e.top + t.clientHeight, e.right = e.left + t.clientWidth, e.width = t.clientWidth, e.height = t.clientHeight, e.x = e.left, e.y = e.top, e;
}
function Q6(t, e) {
  return e === Wr ? m2(j_(t)) : t1(e) ? U_(e) : m2(W_(G1(t)));
}
function G_(t) {
  var e = Lt(w0(t)), r = ["absolute", "fixed"].indexOf(P1(t).position) >= 0, L = r && t1(t) ? bt(t) : t;
  return dt(L) ? e.filter(function(o) {
    return dt(o) && Gr(o, L) && S1(o) !== "body";
  }) : [];
}
function K_(t, e, r) {
  var L = e === "clippingParents" ? G_(t) : [].concat(e), o = [].concat(L, [r]), n = o[0], a = o.reduce(function(s, i) {
    var l = Q6(t, i);
    return s.top = W1(l.top, s.top), s.right = ht(l.right, s.right), s.bottom = ht(l.bottom, s.bottom), s.left = W1(l.left, s.left), s;
  }, Q6(t, n));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function be(t) {
  return t.split("-")[1];
}
function a4(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Kr(t) {
  var e = t.reference, r = t.element, L = t.placement, o = L ? M1(L) : null, n = L ? be(L) : null, a = e.x + e.width / 2 - r.width / 2, s = e.y + e.height / 2 - r.height / 2, i;
  switch (o) {
    case r1:
      i = {
        x: a,
        y: e.y - r.height
      };
      break;
    case p1:
      i = {
        x: a,
        y: e.y + e.height
      };
      break;
    case m1:
      i = {
        x: e.x + e.width,
        y: s
      };
      break;
    case L1:
      i = {
        x: e.x - r.width,
        y: s
      };
      break;
    default:
      i = {
        x: e.x,
        y: e.y
      };
  }
  var l = o ? a4(o) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (n) {
      case we:
        i[l] = i[l] - (e[u] / 2 - r[u] / 2);
        break;
      case ct:
        i[l] = i[l] + (e[u] / 2 - r[u] / 2);
        break;
    }
  }
  return i;
}
function qr() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Xr(t) {
  return Object.assign({}, qr(), t);
}
function Jr(t, e) {
  return e.reduce(function(r, L) {
    return r[L] = t, r;
  }, {});
}
function i4(t, e) {
  e === void 0 && (e = {});
  var r = e, L = r.placement, o = L === void 0 ? t.placement : L, n = r.boundary, a = n === void 0 ? D_ : n, s = r.rootBoundary, i = s === void 0 ? Wr : s, l = r.elementContext, u = l === void 0 ? Ue : l, c = r.altBoundary, v = c === void 0 ? !1 : c, p = r.padding, m = p === void 0 ? 0 : p, f = Xr(typeof m != "number" ? m : Jr(m, xt)), x = u === Ue ? z_ : Ue, y = t.rects.popper, w = t.elements[v ? x : u], g = K_(dt(w) ? w : w.contextElement || G1(t.elements.popper), a, i), h = ye(t.elements.reference), k = Kr({
    reference: h,
    element: y,
    strategy: "absolute",
    placement: o
  }), M = m2(Object.assign({}, y, k)), $ = u === Ue ? M : h, C = {
    top: g.top - $.top + f.top,
    bottom: $.bottom - g.bottom + f.bottom,
    left: g.left - $.left + f.left,
    right: $.right - g.right + f.right
  }, D = t.modifiersData.offset;
  if (u === Ue && D) {
    var S = D[o];
    Object.keys(C).forEach(function(T) {
      var B = [m1, p1].indexOf(T) >= 0 ? 1 : -1, I = [r1, p1].indexOf(T) >= 0 ? "y" : "x";
      C[T] += S[I] * B;
    });
  }
  return C;
}
var e3 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function t3() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return !e.some(function(L) {
    return !(L && typeof L.getBoundingClientRect == "function");
  });
}
function q_(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, L = r === void 0 ? [] : r, o = e.defaultOptions, n = o === void 0 ? e3 : o;
  return function(s, i, l) {
    l === void 0 && (l = n);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, e3, n),
      modifiersData: {},
      elements: {
        reference: s,
        popper: i
      },
      attributes: {},
      styles: {}
    }, c = [], v = !1, p = {
      state: u,
      setOptions: function(y) {
        var w = typeof y == "function" ? y(u.options) : y;
        f(), u.options = Object.assign({}, n, u.options, w), u.scrollParents = {
          reference: dt(s) ? Lt(s) : s.contextElement ? Lt(s.contextElement) : [],
          popper: Lt(i)
        };
        var g = R_(F_([].concat(L, u.options.modifiers)));
        return u.orderedModifiers = g.filter(function(h) {
          return h.enabled;
        }), m(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!v) {
          var y = u.elements, w = y.reference, g = y.popper;
          if (t3(w, g)) {
            u.rects = {
              reference: $_(w, bt(g), u.options.strategy === "fixed"),
              popper: o4(g)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(S) {
              return u.modifiersData[S.name] = Object.assign({}, S.data);
            });
            for (var h = 0; h < u.orderedModifiers.length; h++) {
              if (u.reset === !0) {
                u.reset = !1, h = -1;
                continue;
              }
              var k = u.orderedModifiers[h], M = k.fn, $ = k.options, C = $ === void 0 ? {} : $, D = k.name;
              typeof M == "function" && (u = M({
                state: u,
                options: C,
                name: D,
                instance: p
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Y_(function() {
        return new Promise(function(x) {
          p.forceUpdate(), x(u);
        });
      }),
      destroy: function() {
        f(), v = !0;
      }
    };
    if (!t3(s, i))
      return p;
    p.setOptions(l).then(function(x) {
      !v && l.onFirstUpdate && l.onFirstUpdate(x);
    });
    function m() {
      u.orderedModifiers.forEach(function(x) {
        var y = x.name, w = x.options, g = w === void 0 ? {} : w, h = x.effect;
        if (typeof h == "function") {
          var k = h({
            state: u,
            name: y,
            instance: p,
            options: g
          }), M = function() {
          };
          c.push(k || M);
        }
      });
    }
    function f() {
      c.forEach(function(x) {
        return x();
      }), c = [];
    }
    return p;
  };
}
var Pt = {
  passive: !0
};
function X_(t) {
  var e = t.state, r = t.instance, L = t.options, o = L.scroll, n = o === void 0 ? !0 : o, a = L.resize, s = a === void 0 ? !0 : a, i = w1(e.elements.popper), l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return n && l.forEach(function(u) {
    u.addEventListener("scroll", r.update, Pt);
  }), s && i.addEventListener("resize", r.update, Pt), function() {
    n && l.forEach(function(u) {
      u.removeEventListener("scroll", r.update, Pt);
    }), s && i.removeEventListener("resize", r.update, Pt);
  };
}
var J_ = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: X_,
  data: {}
};
function Q_(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = Kr({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
var e$ = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Q_,
  data: {}
}, t$ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function r$(t) {
  var e = t.x, r = t.y, L = window, o = L.devicePixelRatio || 1;
  return {
    x: Ot(Ot(e * o) / o) || 0,
    y: Ot(Ot(r * o) / o) || 0
  };
}
function r3(t) {
  var e, r = t.popper, L = t.popperRect, o = t.placement, n = t.variation, a = t.offsets, s = t.position, i = t.gpuAcceleration, l = t.adaptive, u = t.roundOffsets, c = u === !0 ? r$(a) : typeof u == "function" ? u(a) : a, v = c.x, p = v === void 0 ? 0 : v, m = c.y, f = m === void 0 ? 0 : m, x = a.hasOwnProperty("x"), y = a.hasOwnProperty("y"), w = L1, g = r1, h = window;
  if (l) {
    var k = bt(r), M = "clientHeight", $ = "clientWidth";
    k === w1(r) && (k = G1(r), P1(k).position !== "static" && s === "absolute" && (M = "scrollHeight", $ = "scrollWidth")), k = k, (o === r1 || (o === L1 || o === m1) && n === ct) && (g = p1, f -= k[M] - L.height, f *= i ? 1 : -1), (o === L1 || (o === r1 || o === p1) && n === ct) && (w = m1, p -= k[$] - L.width, p *= i ? 1 : -1);
  }
  var C = Object.assign({
    position: s
  }, l && t$);
  if (i) {
    var D;
    return Object.assign({}, C, (D = {}, D[g] = y ? "0" : "", D[w] = x ? "0" : "", D.transform = (h.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + f + "px)" : "translate3d(" + p + "px, " + f + "px, 0)", D));
  }
  return Object.assign({}, C, (e = {}, e[g] = y ? f + "px" : "", e[w] = x ? p + "px" : "", e.transform = "", e));
}
function L$(t) {
  var e = t.state, r = t.options, L = r.gpuAcceleration, o = L === void 0 ? !0 : L, n = r.adaptive, a = n === void 0 ? !0 : n, s = r.roundOffsets, i = s === void 0 ? !0 : s, l = {
    placement: M1(e.placement),
    variation: be(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, r3(Object.assign({}, l, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a,
    roundOffsets: i
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, r3(Object.assign({}, l, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: i
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
var n$ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: L$,
  data: {}
};
function o$(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var L = e.styles[r] || {}, o = e.attributes[r] || {}, n = e.elements[r];
    !t1(n) || !S1(n) || (Object.assign(n.style, L), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? n.removeAttribute(a) : n.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function s$(t) {
  var e = t.state, r = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(L) {
      var o = e.elements[L], n = e.attributes[L] || {}, a = Object.keys(e.styles.hasOwnProperty(L) ? e.styles[L] : r[L]), s = a.reduce(function(i, l) {
        return i[l] = "", i;
      }, {});
      !t1(o) || !S1(o) || (Object.assign(o.style, s), Object.keys(n).forEach(function(i) {
        o.removeAttribute(i);
      }));
    });
  };
}
var a$ = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: o$,
  effect: s$,
  requires: ["computeStyles"]
}, i$ = [J_, e$, n$, a$], l$ = /* @__PURE__ */ q_({
  defaultModifiers: i$
});
function u$(t) {
  return t === "x" ? "y" : "x";
}
function Yt(t, e, r) {
  return W1(t, ht(e, r));
}
function d$(t) {
  var e = t.state, r = t.options, L = t.name, o = r.mainAxis, n = o === void 0 ? !0 : o, a = r.altAxis, s = a === void 0 ? !1 : a, i = r.boundary, l = r.rootBoundary, u = r.altBoundary, c = r.padding, v = r.tether, p = v === void 0 ? !0 : v, m = r.tetherOffset, f = m === void 0 ? 0 : m, x = i4(e, {
    boundary: i,
    rootBoundary: l,
    padding: c,
    altBoundary: u
  }), y = M1(e.placement), w = be(e.placement), g = !w, h = a4(y), k = u$(h), M = e.modifiersData.popperOffsets, $ = e.rects.reference, C = e.rects.popper, D = typeof f == "function" ? f(Object.assign({}, e.rects, {
    placement: e.placement
  })) : f, S = {
    x: 0,
    y: 0
  };
  if (M) {
    if (n || s) {
      var T = h === "y" ? r1 : L1, B = h === "y" ? p1 : m1, I = h === "y" ? "height" : "width", R = M[h], N = M[h] + x[T], H = M[h] - x[B], G = p ? -C[I] / 2 : 0, e5 = w === we ? $[I] : C[I], t5 = w === we ? -C[I] : -$[I], J = e.elements.arrow, h5 = p && J ? o4(J) : {
        width: 0,
        height: 0
      }, n5 = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : qr(), _5 = n5[T], o5 = n5[B], i5 = Yt(0, $[I], h5[I]), k5 = g ? $[I] / 2 - G - i5 - _5 - D : e5 - i5 - _5 - D, f5 = g ? -$[I] / 2 + G + i5 + o5 + D : t5 + i5 + o5 + D, E = e.elements.arrow && bt(e.elements.arrow), L5 = E ? h === "y" ? E.clientTop || 0 : E.clientLeft || 0 : 0, g5 = e.modifiersData.offset ? e.modifiersData.offset[e.placement][h] : 0, z = M[h] + k5 - g5 - L5, A = M[h] + f5 - g5;
      if (n) {
        var Y = Yt(p ? ht(N, z) : N, R, p ? W1(H, A) : H);
        M[h] = Y, S[h] = Y - R;
      }
      if (s) {
        var W = h === "x" ? r1 : L1, q = h === "x" ? p1 : m1, d5 = M[k], E1 = d5 + x[W], q1 = d5 - x[q], X1 = Yt(p ? ht(E1, z) : E1, d5, p ? W1(q1, A) : q1);
        M[k] = X1, S[k] = X1 - d5;
      }
    }
    e.modifiersData[L] = S;
  }
}
var c$ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: d$,
  requiresIfExists: ["offset"]
}, h$ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ft(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return h$[e];
  });
}
var f$ = {
  start: "end",
  end: "start"
};
function L3(t) {
  return t.replace(/start|end/g, function(e) {
    return f$[e];
  });
}
function p$(t, e) {
  e === void 0 && (e = {});
  var r = e, L = r.placement, o = r.boundary, n = r.rootBoundary, a = r.padding, s = r.flipVariations, i = r.allowedAutoPlacements, l = i === void 0 ? Ur : i, u = be(L), c = u ? s ? J6 : J6.filter(function(m) {
    return be(m) === u;
  }) : xt, v = c.filter(function(m) {
    return l.indexOf(m) >= 0;
  });
  v.length === 0 && (v = c);
  var p = v.reduce(function(m, f) {
    return m[f] = i4(t, {
      placement: f,
      boundary: o,
      rootBoundary: n,
      padding: a
    })[M1(f)], m;
  }, {});
  return Object.keys(p).sort(function(m, f) {
    return p[m] - p[f];
  });
}
function m$(t) {
  if (M1(t) === s4)
    return [];
  var e = Ft(t);
  return [L3(t), e, L3(e)];
}
function g$(t) {
  var e = t.state, r = t.options, L = t.name;
  if (!e.modifiersData[L]._skip) {
    for (var o = r.mainAxis, n = o === void 0 ? !0 : o, a = r.altAxis, s = a === void 0 ? !0 : a, i = r.fallbackPlacements, l = r.padding, u = r.boundary, c = r.rootBoundary, v = r.altBoundary, p = r.flipVariations, m = p === void 0 ? !0 : p, f = r.allowedAutoPlacements, x = e.options.placement, y = M1(x), w = y === x, g = i || (w || !m ? [Ft(x)] : m$(x)), h = [x].concat(g).reduce(function(o5, i5) {
      return o5.concat(M1(i5) === s4 ? p$(e, {
        placement: i5,
        boundary: u,
        rootBoundary: c,
        padding: l,
        flipVariations: m,
        allowedAutoPlacements: f
      }) : i5);
    }, []), k = e.rects.reference, M = e.rects.popper, $ = /* @__PURE__ */ new Map(), C = !0, D = h[0], S = 0; S < h.length; S++) {
      var T = h[S], B = M1(T), I = be(T) === we, R = [r1, p1].indexOf(B) >= 0, N = R ? "width" : "height", H = i4(e, {
        placement: T,
        boundary: u,
        rootBoundary: c,
        altBoundary: v,
        padding: l
      }), G = R ? I ? m1 : L1 : I ? p1 : r1;
      k[N] > M[N] && (G = Ft(G));
      var e5 = Ft(G), t5 = [];
      if (n && t5.push(H[B] <= 0), s && t5.push(H[G] <= 0, H[e5] <= 0), t5.every(function(o5) {
        return o5;
      })) {
        D = T, C = !1;
        break;
      }
      $.set(T, t5);
    }
    if (C)
      for (var J = m ? 3 : 1, h5 = function(i5) {
        var k5 = h.find(function(f5) {
          var E = $.get(f5);
          if (E)
            return E.slice(0, i5).every(function(L5) {
              return L5;
            });
        });
        if (k5)
          return D = k5, "break";
      }, n5 = J; n5 > 0; n5--) {
        var _5 = h5(n5);
        if (_5 === "break")
          break;
      }
    e.placement !== D && (e.modifiersData[L]._skip = !0, e.placement = D, e.reset = !0);
  }
}
var v$ = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: g$,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function y$(t, e, r) {
  var L = M1(t), o = [L1, r1].indexOf(L) >= 0 ? -1 : 1, n = typeof r == "function" ? r(Object.assign({}, e, {
    placement: t
  })) : r, a = n[0], s = n[1];
  return a = a || 0, s = (s || 0) * o, [L1, m1].indexOf(L) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function w$(t) {
  var e = t.state, r = t.options, L = t.name, o = r.offset, n = o === void 0 ? [0, 0] : o, a = Ur.reduce(function(u, c) {
    return u[c] = y$(c, e.rects, n), u;
  }, {}), s = a[e.placement], i = s.x, l = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += i, e.modifiersData.popperOffsets.y += l), e.modifiersData[L] = a;
}
var b$ = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: w$
}, x$ = function(e, r) {
  return e = typeof e == "function" ? e(Object.assign({}, r.rects, {
    placement: r.placement
  })) : e, Xr(typeof e != "number" ? e : Jr(e, xt));
};
function k$(t) {
  var e, r = t.state, L = t.name, o = t.options, n = r.elements.arrow, a = r.modifiersData.popperOffsets, s = M1(r.placement), i = a4(s), l = [L1, m1].indexOf(s) >= 0, u = l ? "height" : "width";
  if (!(!n || !a)) {
    var c = x$(o.padding, r), v = o4(n), p = i === "y" ? r1 : L1, m = i === "y" ? p1 : m1, f = r.rects.reference[u] + r.rects.reference[i] - a[i] - r.rects.popper[u], x = a[i] - r.rects.reference[i], y = bt(n), w = y ? i === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, g = f / 2 - x / 2, h = c[p], k = w - v[u] - c[m], M = w / 2 - v[u] / 2 + g, $ = Yt(h, M, k), C = i;
    r.modifiersData[L] = (e = {}, e[C] = $, e.centerOffset = $ - M, e);
  }
}
function M$(t) {
  var e = t.state, r = t.options, L = r.element, o = L === void 0 ? "[data-popper-arrow]" : L;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || Gr(e.elements.popper, o) && (e.elements.arrow = o));
}
var _$ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: k$,
  effect: M$,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
const H0 = (t) => parseInt(t, 10);
function $$({
  arrowPadding: t,
  emit: e,
  locked: r,
  offsetDistance: L,
  offsetSkid: o,
  placement: n,
  popperNode: a,
  triggerNode: s
}) {
  const i = st({
    isOpen: !1,
    popperInstance: null
  }), l = (f) => {
    var x;
    (x = i.popperInstance) === null || x === void 0 || x.setOptions((y) => ({
      ...y,
      modifiers: [...y.modifiers, {
        name: "eventListeners",
        enabled: f
      }]
    }));
  }, u = () => l(!0), c = () => l(!1), v = () => {
    i.isOpen && (i.isOpen = !1, e("close:popper"));
  }, p = () => {
    i.isOpen || (i.isOpen = !0, e("open:popper"));
  };
  s5([() => i.isOpen, n], async ([f]) => {
    f ? (await m(), u()) : c();
  });
  const m = async () => {
    await $e(), i.popperInstance = l$(s.value, a.value, {
      placement: n.value,
      modifiers: [c$, v$, {
        name: "flip",
        enabled: !r.value
      }, _$, {
        name: "arrow",
        options: {
          padding: H0(t.value)
        }
      }, b$, {
        name: "offset",
        options: {
          offset: [H0(o.value), H0(L.value)]
        }
      }]
    }), i.popperInstance.update();
  };
  return se(() => {
    var f;
    (f = i.popperInstance) === null || f === void 0 || f.destroy();
  }), {
    ...N5(i),
    open: p,
    close: v
  };
}
const S$ = {
  id: "arrow",
  "data-popper-arrow": ""
};
function C$(t, e) {
  return b(), _("div", S$);
}
function Qr(t, e) {
  e === void 0 && (e = {});
  var r = e.insertAt;
  if (!(!t || typeof document > "u")) {
    var L = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
    o.type = "text/css", r === "top" && L.firstChild ? L.insertBefore(o, L.firstChild) : L.appendChild(o), o.styleSheet ? o.styleSheet.cssText = t : o.appendChild(document.createTextNode(t));
  }
}
var D$ = `
#arrow[data-v-20b7fd4a],
  #arrow[data-v-20b7fd4a]::before {
    transition: background 250ms ease-in-out;
    position: absolute;
    width: calc(10px - var(--popper-theme-border-width, 0px));
    height: calc(10px - var(--popper-theme-border-width, 0px));
    box-sizing: border-box;
    background: var(--popper-theme-background-color);
}
#arrow[data-v-20b7fd4a] {
    visibility: hidden;
}
#arrow[data-v-20b7fd4a]::before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
}

  /* Top arrow */
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a] {
    bottom: -5px;
}
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-bottom: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Bottom arrow */
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a] {
    top: -5px;
}
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a]::before {
    border-left: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Left arrow */
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a] {
    right: -5px;
}
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Right arrow */
.popper[data-popper-placement^="right"] > #arrow[data-v-20b7fd4a] {
    left: -5px;
}
`;
Qr(D$);
const l4 = {};
l4.render = C$;
l4.__scopeId = "data-v-20b7fd4a";
var z$ = l4;
const I$ = ["onKeyup"];
var eL = {
  props: {
    /**
     * Preferred placement (the "auto" placements will choose the side with most space.)
     */
    placement: {
      type: String,
      default: "bottom",
      validator: function(t) {
        return ["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"].includes(t);
      }
    },
    /**
     * Disables automatically closing the popover when the user clicks away from it
     */
    disableClickAway: {
      type: Boolean,
      default: !1
    },
    /**
     * Offset in pixels along the trigger element
     */
    offsetSkid: {
      type: String,
      default: "0"
    },
    /**
     * Offset in pixels away from the trigger element
     */
    offsetDistance: {
      type: String,
      default: "12"
    },
    /**
     * Trigger the popper on hover
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually open/close the Popper, other events are ignored if this prop is set
     */
    show: {
      type: Boolean,
      default: null
    },
    /**
     * Disables the Popper. If it was already open, it will be closed.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Open the Popper after a delay (ms).
     */
    openDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * Close the Popper after a delay (ms).
     */
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * The z-index of the Popper.
     */
    zIndex: {
      type: [Number, String],
      default: 9999
    },
    /**
     * Display an arrow on the popper
     */
    arrow: {
      type: Boolean,
      default: !1
    },
    /**
     * Stop arrow from reaching the edge of the popper
     */
    arrowPadding: {
      type: String,
      default: "0"
    },
    /**
     * If the Popper should be interactive, it will close when clicked/hovered if false
     */
    interactive: {
      type: Boolean,
      default: !0
    },
    /**
     * Lock the Popper into place, it will not flip dynamically when it runs out of space if true
     */
    locked: {
      type: Boolean,
      default: !1
    },
    /**
     * If the content is just a simple string, it can be passed in as a prop
     */
    content: {
      type: String,
      default: null
    }
  },
  emits: ["open:popper", "close:popper"],
  setup(t, {
    emit: e
  }) {
    const r = t;
    CL((e5) => ({
      c81fc0a4: t.zIndex
    }));
    const L = $2(), o = P(null), n = P(null), a = P(null), s = P(!1);
    I5(() => {
      const e5 = L.default();
      if (e5 && e5.length > 1)
        return console.error(`[Popper]: The <Popper> component expects only one child element at its root. You passed ${e5.length} child nodes.`);
    });
    const {
      arrowPadding: i,
      closeDelay: l,
      content: u,
      disableClickAway: c,
      disabled: v,
      interactive: p,
      locked: m,
      offsetDistance: f,
      offsetSkid: x,
      openDelay: y,
      placement: w,
      show: g
    } = N5(r), {
      isOpen: h,
      open: k,
      close: M
    } = $$({
      arrowPadding: i,
      emit: e,
      locked: m,
      offsetDistance: f,
      offsetSkid: x,
      placement: w,
      popperNode: n,
      triggerNode: a
    }), {
      hasContent: $
    } = x_(L, n, u), C = U(() => g.value !== null), D = U(() => v.value || !$.value), S = U(() => h.value && !D.value), T = U(() => !c.value && !C.value), B = U(() => p.value ? `border: ${f.value}px solid transparent; margin: -${f.value}px;` : null), I = N0.debounce(k, y.value), R = N0.debounce(M, l.value), N = async () => {
      D.value || C.value || (R.clear(), I());
    }, H = async () => {
      C.value || (I.clear(), R());
    }, G = () => {
      h.value ? H() : N();
    };
    return s5([$, v], ([e5, t5]) => {
      h.value && (!e5 || t5) && M();
    }), s5(h, (e5) => {
      e5 ? s.value = !0 : N0.debounce(() => {
        s.value = !1;
      }, 200);
    }), v4(() => {
      C.value && (g.value ? I() : R());
    }), v4(() => {
      T.value && b_(o, H);
    }), (e5, t5) => (b(), _("div", {
      class: "inline-block",
      style: R5(O(B)),
      onMouseleave: t5[2] || (t5[2] = (J) => t.hover && H()),
      ref: (J, h5) => {
        h5.popperContainerNode = J, o.value = J;
      }
    }, [d("div", {
      ref: (J, h5) => {
        h5.triggerNode = J, a.value = J;
      },
      onMouseover: t5[0] || (t5[0] = (J) => t.hover && N()),
      onClick: G,
      onFocus: N,
      onKeyup: ee(H, ["esc"])
    }, [u5(e5.$slots, "default")], 40, I$), Z(mt, {
      name: "fade"
    }, {
      default: c5(() => [b5(d("div", {
        onClick: t5[1] || (t5[1] = (J) => !O(p) && H()),
        class: "popper",
        ref: (J, h5) => {
          h5.popperNode = J, n.value = J;
        }
      }, [u5(e5.$slots, "content", {
        close: O(M),
        isOpen: s.value
      }, () => [c1(V(O(u)), 1)]), t.arrow ? (b(), x5(z$, {
        key: 0
      })) : X("", !0)], 512), [[T1, O(S)]])]),
      _: 3
    })], 36));
  }
}, T$ = `
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.popper[data-v-5784ed69] {
    transition: background 250ms ease-in-out;
    background: var(--popper-theme-background-color);
    padding: var(--popper-theme-padding);
    color: var(--popper-theme-text-color);
    border-radius: var(--popper-theme-border-radius);
    border-width: var(--popper-theme-border-width);
    border-style: var(--popper-theme-border-style);
    border-color: var(--popper-theme-border-color);
    box-shadow: var(--popper-theme-box-shadow);
    z-index: var(--c81fc0a4);
}
.popper[data-v-5784ed69]:hover,
  .popper:hover > #arrow[data-v-5784ed69]::before {
    background: var(--popper-theme-background-color-hover);
}
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.fade-enter-active[data-v-5784ed69],
  .fade-leave-active[data-v-5784ed69] {
    transition: opacity 0.2s ease;
}
.fade-enter-from[data-v-5784ed69],
  .fade-leave-to[data-v-5784ed69] {
    opacity: 0;
}
`;
Qr(T$);
eL.__scopeId = "data-v-5784ed69";
var O$ = /* @__PURE__ */ (() => {
  const t = eL;
  return t.install = (e) => {
    e.component("Popper", t);
  }, t;
})();
const P$ = {
  class: "tooltip-wrapper",
  "data-testid": "tooltip"
}, Z$ = /* @__PURE__ */ d("button", { class: "tooltip__icon bg-bl-tooltip-icon-background-color dark:bg-bl-dk-tooltip-icon-background-color hover:bg-bl-tooltip-icon-background-hover-color dark:hover:bg-bl-dk-tooltip-icon-background-hover-color" }, [
  /* @__PURE__ */ d("span", { class: "text-bl-tooltip-icon-text-color dark:text-bl-dk-tooltip-icon-text-color" }, " ? ")
], -1), E$ = { style: { "max-width": "400px" } }, A$ = { key: 0 }, N$ = {
  key: 2,
  class: "w-full"
}, H$ = {
  name: "MfxTooltip"
}, ft = /* @__PURE__ */ r5({
  ...H$,
  props: {
    title: {},
    offSetDistance: {}
  },
  setup(t) {
    return (e, r) => (b(), _("div", P$, [
      Z(O(O$), {
        trigger: "clickToOpen",
        placement: "bottom",
        arrow: "",
        "offset-distance": e.offSetDistance
      }, {
        content: c5(() => [
          d("div", E$, [
            e.title ? (b(), _("p", A$, V(e.title), 1)) : e.$slots.default ? u5(e.$slots, "default", { key: 1 }) : X("", !0),
            e.$slots.footer ? (b(), _("footer", N$, [
              u5(e.$slots, "footer")
            ])) : X("", !0)
          ])
        ]),
        default: c5(() => [
          Z$
        ]),
        _: 3
      }, 8, ["offset-distance"])
    ]));
  }
});
function B$() {
  var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
  if (e > 0)
    return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
  var r = t.indexOf("Trident/");
  if (r > 0) {
    var L = t.indexOf("rv:");
    return parseInt(t.substring(L + 3, t.indexOf(".", L)), 10);
  }
  var o = t.indexOf("Edge/");
  return o > 0 ? parseInt(t.substring(o + 5, t.indexOf(".", o)), 10) : -1;
}
let jt;
function g2() {
  g2.init || (g2.init = !0, jt = B$() !== -1);
}
var b0 = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    g2(), $e(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const t = document.createElement("object");
    this._resizeObject = t, t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", -1), t.onload = this.addResizeHandlers, t.type = "text/html", jt && this.$el.appendChild(t), t.data = "about:blank", jt || this.$el.appendChild(t);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!jt && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const V$ = /* @__PURE__ */ DL("data-v-b329ee4c");
g1("data-v-b329ee4c");
const R$ = {
  class: "resize-observer",
  tabindex: "-1"
};
v1();
const Y$ = /* @__PURE__ */ V$((t, e, r, L, o, n) => (b(), x5("div", R$)));
b0.render = Y$;
b0.__scopeId = "data-v-b329ee4c";
b0.__file = "src/components/ResizeObserver.vue";
function Wt(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Wt = function(e) {
    return typeof e;
  } : Wt = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Wt(t);
}
function F$(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function n3(t, e) {
  for (var r = 0; r < e.length; r++) {
    var L = e[r];
    L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(t, L.key, L);
  }
}
function j$(t, e, r) {
  return e && n3(t.prototype, e), r && n3(t, r), t;
}
function o3(t) {
  return W$(t) || U$(t) || G$(t) || K$();
}
function W$(t) {
  if (Array.isArray(t))
    return v2(t);
}
function U$(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function G$(t, e) {
  if (t) {
    if (typeof t == "string")
      return v2(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return v2(t, e);
  }
}
function v2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, L = new Array(e); r < e; r++)
    L[r] = t[r];
  return L;
}
function K$() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function q$(t) {
  var e;
  return typeof t == "function" ? e = {
    callback: t
  } : e = t, e;
}
function X$(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, L, o, n, a = function(i) {
    for (var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), c = 1; c < l; c++)
      u[c - 1] = arguments[c];
    if (n = u, !(L && i === o)) {
      var v = r.leading;
      typeof v == "function" && (v = v(i, o)), (!L || i !== o) && v && t.apply(void 0, [i].concat(o3(n))), o = i, clearTimeout(L), L = setTimeout(function() {
        t.apply(void 0, [i].concat(o3(n))), L = 0;
      }, e);
    }
  };
  return a._clear = function() {
    clearTimeout(L), L = null;
  }, a;
}
function tL(t, e) {
  if (t === e)
    return !0;
  if (Wt(t) === "object") {
    for (var r in t)
      if (!tL(t[r], e[r]))
        return !1;
    return !0;
  }
  return !1;
}
var J$ = /* @__PURE__ */ function() {
  function t(e, r, L) {
    F$(this, t), this.el = e, this.observer = null, this.frozen = !1, this.createObserver(r, L);
  }
  return j$(t, [{
    key: "createObserver",
    value: function(r, L) {
      var o = this;
      if (this.observer && this.destroyObserver(), !this.frozen) {
        if (this.options = q$(r), this.callback = function(s, i) {
          o.options.callback(s, i), s && o.options.once && (o.frozen = !0, o.destroyObserver());
        }, this.callback && this.options.throttle) {
          var n = this.options.throttleOptions || {}, a = n.leading;
          this.callback = X$(this.callback, this.options.throttle, {
            leading: function(i) {
              return a === "both" || a === "visible" && i || a === "hidden" && !i;
            }
          });
        }
        this.oldResult = void 0, this.observer = new IntersectionObserver(function(s) {
          var i = s[0];
          if (s.length > 1) {
            var l = s.find(function(c) {
              return c.isIntersecting;
            });
            l && (i = l);
          }
          if (o.callback) {
            var u = i.isIntersecting && i.intersectionRatio >= o.threshold;
            if (u === o.oldResult)
              return;
            o.oldResult = u, o.callback(u, i);
          }
        }, this.options.intersection), $e(function() {
          o.observer && o.observer.observe(o.el);
        });
      }
    }
  }, {
    key: "destroyObserver",
    value: function() {
      this.observer && (this.observer.disconnect(), this.observer = null), this.callback && this.callback._clear && (this.callback._clear(), this.callback = null);
    }
  }, {
    key: "threshold",
    get: function() {
      return this.options.intersection && typeof this.options.intersection.threshold == "number" ? this.options.intersection.threshold : 0;
    }
  }]), t;
}();
function rL(t, e, r) {
  var L = e.value;
  if (L)
    if (typeof IntersectionObserver > "u")
      console.warn("[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill");
    else {
      var o = new J$(t, L, r);
      t._vue_visibilityState = o;
    }
}
function Q$(t, e, r) {
  var L = e.value, o = e.oldValue;
  if (!tL(L, o)) {
    var n = t._vue_visibilityState;
    if (!L) {
      LL(t);
      return;
    }
    n ? n.createObserver(L, r) : rL(t, {
      value: L
    }, r);
  }
}
function LL(t) {
  var e = t._vue_visibilityState;
  e && (e.destroyObserver(), delete t._vue_visibilityState);
}
var eS = {
  beforeMount: rL,
  updated: Q$,
  unmounted: LL
}, tS = {
  itemsLimit: 1e3
}, rS = /(auto|scroll)/;
function nL(t, e) {
  return t.parentNode === null ? e : nL(t.parentNode, e.concat([t]));
}
var B0 = function(e, r) {
  return getComputedStyle(e, null).getPropertyValue(r);
}, LS = function(e) {
  return B0(e, "overflow") + B0(e, "overflow-y") + B0(e, "overflow-x");
}, nS = function(e) {
  return rS.test(LS(e));
};
function s3(t) {
  if (t instanceof HTMLElement || t instanceof SVGElement) {
    for (var e = nL(t.parentNode, []), r = 0; r < e.length; r += 1)
      if (nS(e[r]))
        return e[r];
    return document.scrollingElement || document.documentElement;
  }
}
function y2(t) {
  "@babel/helpers - typeof";
  return y2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, y2(t);
}
var oS = {
  items: {
    type: Array,
    required: !0
  },
  keyField: {
    type: String,
    default: "id"
  },
  direction: {
    type: String,
    default: "vertical",
    validator: function(e) {
      return ["vertical", "horizontal"].includes(e);
    }
  },
  listTag: {
    type: String,
    default: "div"
  },
  itemTag: {
    type: String,
    default: "div"
  }
};
function sS() {
  return this.items.length && y2(this.items[0]) !== "object";
}
var w2 = !1;
if (typeof window < "u") {
  w2 = !1;
  try {
    var aS = Object.defineProperty({}, "passive", {
      get: function() {
        w2 = !0;
      }
    });
    window.addEventListener("test", null, aS);
  } catch {
  }
}
let iS = 0;
var u4 = {
  name: "RecycleScroller",
  components: {
    ResizeObserver: b0
  },
  directives: {
    ObserveVisibility: eS
  },
  props: {
    ...oS,
    itemSize: {
      type: Number,
      default: null
    },
    gridItems: {
      type: Number,
      default: void 0
    },
    itemSecondarySize: {
      type: Number,
      default: void 0
    },
    minItemSize: {
      type: [Number, String],
      default: null
    },
    sizeField: {
      type: String,
      default: "size"
    },
    typeField: {
      type: String,
      default: "type"
    },
    buffer: {
      type: Number,
      default: 200
    },
    pageMode: {
      type: Boolean,
      default: !1
    },
    prerender: {
      type: Number,
      default: 0
    },
    emitUpdate: {
      type: Boolean,
      default: !1
    },
    skipHover: {
      type: Boolean,
      default: !1
    },
    listTag: {
      type: String,
      default: "div"
    },
    itemTag: {
      type: String,
      default: "div"
    },
    listClass: {
      type: [String, Object, Array],
      default: ""
    },
    itemClass: {
      type: [String, Object, Array],
      default: ""
    }
  },
  emits: [
    "resize",
    "visible",
    "hidden",
    "update",
    "scroll-start",
    "scroll-end"
  ],
  data() {
    return {
      pool: [],
      totalSize: 0,
      ready: !1,
      hoverKey: null
    };
  },
  computed: {
    sizes() {
      if (this.itemSize === null) {
        const t = {
          "-1": { accumulator: 0 }
        }, e = this.items, r = this.sizeField, L = this.minItemSize;
        let o = 1e4, n = 0, a;
        for (let s = 0, i = e.length; s < i; s++)
          a = e[s][r] || L, a < o && (o = a), n += a, t[s] = { accumulator: n, size: a };
        return this.$_computedMinItemSize = o, t;
      }
      return [];
    },
    simpleArray: sS
  },
  watch: {
    items() {
      this.updateVisibleItems(!0);
    },
    pageMode() {
      this.applyPageMode(), this.updateVisibleItems(!1);
    },
    sizes: {
      handler() {
        this.updateVisibleItems(!1);
      },
      deep: !0
    },
    gridItems() {
      this.updateVisibleItems(!0);
    },
    itemSecondarySize() {
      this.updateVisibleItems(!0);
    }
  },
  created() {
    this.$_startIndex = 0, this.$_endIndex = 0, this.$_views = /* @__PURE__ */ new Map(), this.$_unusedViews = /* @__PURE__ */ new Map(), this.$_scrollDirty = !1, this.$_lastUpdateScrollPosition = 0, this.prerender && (this.$_prerender = !0, this.updateVisibleItems(!1)), this.gridItems && !this.itemSize && console.error("[vue-recycle-scroller] You must provide an itemSize when using gridItems");
  },
  mounted() {
    this.applyPageMode(), this.$nextTick(() => {
      this.$_prerender = !1, this.updateVisibleItems(!0), this.ready = !0;
    });
  },
  activated() {
    const t = this.$_lastUpdateScrollPosition;
    typeof t == "number" && this.$nextTick(() => {
      this.scrollToPosition(t);
    });
  },
  beforeUnmount() {
    this.removeListeners();
  },
  methods: {
    addView(t, e, r, L, o) {
      const n = zL({
        id: iS++,
        index: e,
        used: !0,
        key: L,
        type: o
      }), a = IL({
        item: r,
        position: 0,
        nr: n
      });
      return t.push(a), a;
    },
    unuseView(t, e = !1) {
      const r = this.$_unusedViews, L = t.nr.type;
      let o = r.get(L);
      o || (o = [], r.set(L, o)), o.push(t), e || (t.nr.used = !1, t.position = -9999, this.$_views.delete(t.nr.key));
    },
    handleResize() {
      this.$emit("resize"), this.ready && this.updateVisibleItems(!1);
    },
    handleScroll(t) {
      this.$_scrollDirty || (this.$_scrollDirty = !0, requestAnimationFrame(() => {
        this.$_scrollDirty = !1;
        const { continuous: e } = this.updateVisibleItems(!1, !0);
        e || (clearTimeout(this.$_refreshTimout), this.$_refreshTimout = setTimeout(this.handleScroll, 100));
      }));
    },
    handleVisibilityChange(t, e) {
      this.ready && (t || e.boundingClientRect.width !== 0 || e.boundingClientRect.height !== 0 ? (this.$emit("visible"), requestAnimationFrame(() => {
        this.updateVisibleItems(!1);
      })) : this.$emit("hidden"));
    },
    updateVisibleItems(t, e = !1) {
      const r = this.itemSize, L = this.gridItems || 1, o = this.itemSecondarySize || r, n = this.$_computedMinItemSize, a = this.typeField, s = this.simpleArray ? null : this.keyField, i = this.items, l = i.length, u = this.sizes, c = this.$_views, v = this.$_unusedViews, p = this.pool;
      let m, f, x, y, w;
      if (!l)
        m = f = y = w = x = 0;
      else if (this.$_prerender)
        m = y = 0, f = w = Math.min(this.prerender, i.length), x = null;
      else {
        const S = this.getScroll();
        if (e) {
          let I = S.start - this.$_lastUpdateScrollPosition;
          if (I < 0 && (I = -I), r === null && I < n || I < r)
            return {
              continuous: !0
            };
        }
        this.$_lastUpdateScrollPosition = S.start;
        const T = this.buffer;
        S.start -= T, S.end += T;
        let B = 0;
        if (this.$refs.before && (B = this.$refs.before.scrollHeight, S.start -= B), this.$refs.after) {
          const I = this.$refs.after.scrollHeight;
          S.end += I;
        }
        if (r === null) {
          let I, R = 0, N = l - 1, H = ~~(l / 2), G;
          do
            G = H, I = u[H].accumulator, I < S.start ? R = H : H < l - 1 && u[H + 1].accumulator > S.start && (N = H), H = ~~((R + N) / 2);
          while (H !== G);
          for (H < 0 && (H = 0), m = H, x = u[l - 1].accumulator, f = H; f < l && u[f].accumulator < S.end; f++)
            ;
          for (f === -1 ? f = i.length - 1 : (f++, f > l && (f = l)), y = m; y < l && B + u[y].accumulator < S.start; y++)
            ;
          for (w = y; w < l && B + u[w].accumulator < S.end; w++)
            ;
        } else {
          m = ~~(S.start / r * L);
          const I = m % L;
          m -= I, f = Math.ceil(S.end / r * L), y = Math.max(0, Math.floor((S.start - B) / r * L)), w = Math.floor((S.end - B) / r * L), m < 0 && (m = 0), f > l && (f = l), y < 0 && (y = 0), w > l && (w = l), x = Math.ceil(l / L) * r;
        }
      }
      f - m > tS.itemsLimit && this.itemsLimitError(), this.totalSize = x;
      let g;
      const h = m <= this.$_endIndex && f >= this.$_startIndex;
      if (this.$_continuous !== h) {
        if (h) {
          c.clear(), v.clear();
          for (let S = 0, T = p.length; S < T; S++)
            g = p[S], this.unuseView(g);
        }
        this.$_continuous = h;
      } else if (h)
        for (let S = 0, T = p.length; S < T; S++)
          g = p[S], g.nr.used && (t && (g.nr.index = i.indexOf(g.item)), (g.nr.index === -1 || g.nr.index < m || g.nr.index >= f) && this.unuseView(g));
      const k = h ? null : /* @__PURE__ */ new Map();
      let M, $, C, D;
      for (let S = m; S < f; S++) {
        M = i[S];
        const T = s ? M[s] : M;
        if (T == null)
          throw new Error(`Key is ${T} on item (keyField is '${s}')`);
        if (g = c.get(T), !r && !u[S].size) {
          g && this.unuseView(g);
          continue;
        }
        g ? (g.nr.used = !0, g.item = M) : (S === i.length - 1 && this.$emit("scroll-end"), S === 0 && this.$emit("scroll-start"), $ = M[a], C = v.get($), h ? C && C.length ? (g = C.pop(), g.item = M, g.nr.used = !0, g.nr.index = S, g.nr.key = T, g.nr.type = $) : g = this.addView(p, S, M, T, $) : (D = k.get($) || 0, (!C || D >= C.length) && (g = this.addView(p, S, M, T, $), this.unuseView(g, !0), C = v.get($)), g = C[D], g.item = M, g.nr.used = !0, g.nr.index = S, g.nr.key = T, g.nr.type = $, k.set($, D + 1), D++), c.set(T, g)), r === null ? (g.position = u[S - 1].accumulator, g.offset = 0) : (g.position = Math.floor(S / L) * r, g.offset = S % L * o);
      }
      return this.$_startIndex = m, this.$_endIndex = f, this.emitUpdate && this.$emit("update", m, f, y, w), clearTimeout(this.$_sortTimer), this.$_sortTimer = setTimeout(this.sortViews, 300), {
        continuous: h
      };
    },
    getListenerTarget() {
      let t = s3(this.$el);
      return window.document && (t === window.document.documentElement || t === window.document.body) && (t = window), t;
    },
    getScroll() {
      const { $el: t, direction: e } = this, r = e === "vertical";
      let L;
      if (this.pageMode) {
        const o = t.getBoundingClientRect(), n = r ? o.height : o.width;
        let a = -(r ? o.top : o.left), s = r ? window.innerHeight : window.innerWidth;
        a < 0 && (s += a, a = 0), a + s > n && (s = n - a), L = {
          start: a,
          end: a + s
        };
      } else
        r ? L = {
          start: t.scrollTop,
          end: t.scrollTop + t.clientHeight
        } : L = {
          start: t.scrollLeft,
          end: t.scrollLeft + t.clientWidth
        };
      return L;
    },
    applyPageMode() {
      this.pageMode ? this.addListeners() : this.removeListeners();
    },
    addListeners() {
      this.listenerTarget = this.getListenerTarget(), this.listenerTarget.addEventListener("scroll", this.handleScroll, w2 ? {
        passive: !0
      } : !1), this.listenerTarget.addEventListener("resize", this.handleResize);
    },
    removeListeners() {
      this.listenerTarget && (this.listenerTarget.removeEventListener("scroll", this.handleScroll), this.listenerTarget.removeEventListener("resize", this.handleResize), this.listenerTarget = null);
    },
    scrollToItem(t) {
      let e;
      this.itemSize === null ? e = t > 0 ? this.sizes[t - 1].accumulator : 0 : e = Math.floor(t / this.gridItems) * this.itemSize, this.scrollToPosition(e);
    },
    scrollToPosition(t) {
      const e = this.direction === "vertical" ? { scroll: "scrollTop", start: "top" } : { scroll: "scrollLeft", start: "left" };
      let r, L, o;
      if (this.pageMode) {
        const n = s3(this.$el), a = n.tagName === "HTML" ? 0 : n[e.scroll], s = n.getBoundingClientRect(), l = this.$el.getBoundingClientRect()[e.start] - s[e.start];
        r = n, L = e.scroll, o = t + a + l;
      } else
        r = this.$el, L = e.scroll, o = t;
      r[L] = o;
    },
    itemsLimitError() {
      throw setTimeout(() => {
        console.log("It seems the scroller element isn't scrolling, so it tries to render all the items at once.", "Scroller:", this.$el), console.log("Make sure the scroller has a fixed height (or width) and 'overflow-y' (or 'overflow-x') set to 'auto' so it can scroll correctly and only render the items visible in the scroll viewport.");
      }), new Error("Rendered items limit reached");
    },
    sortViews() {
      this.pool.sort((t, e) => t.index - e.index);
    }
  }
};
const lS = {
  key: 0,
  ref: "before",
  class: "vue-recycle-scroller__slot"
}, uS = {
  key: 1,
  ref: "after",
  class: "vue-recycle-scroller__slot"
};
function dS(t, e, r, L, o, n) {
  const a = o0("ResizeObserver"), s = D2("observe-visibility");
  return b5((b(), _(
    "div",
    {
      class: F(["vue-recycle-scroller", {
        ready: o.ready,
        "page-mode": r.pageMode,
        [`direction-${t.direction}`]: !0
      }]),
      onScrollPassive: e[0] || (e[0] = (...i) => n.handleScroll && n.handleScroll(...i))
    },
    [
      t.$slots.before ? (b(), _(
        "div",
        lS,
        [
          u5(t.$slots, "before")
        ],
        512
        /* NEED_PATCH */
      )) : X("v-if", !0),
      (b(), x5(q0(r.listTag), {
        ref: "wrapper",
        style: R5({ [t.direction === "vertical" ? "minHeight" : "minWidth"]: o.totalSize + "px" }),
        class: F(["vue-recycle-scroller__item-wrapper", r.listClass])
      }, {
        default: c5(() => [
          (b(!0), _(
            p5,
            null,
            S5(o.pool, (i) => (b(), x5(q0(r.itemTag), C2({
              key: i.nr.id,
              style: o.ready ? {
                transform: `translate${t.direction === "vertical" ? "Y" : "X"}(${i.position}px) translate${t.direction === "vertical" ? "X" : "Y"}(${i.offset}px)`,
                width: r.gridItems ? `${t.direction === "vertical" && r.itemSecondarySize || r.itemSize}px` : void 0,
                height: r.gridItems ? `${t.direction === "horizontal" && r.itemSecondarySize || r.itemSize}px` : void 0
              } : null,
              class: ["vue-recycle-scroller__item-view", [
                r.itemClass,
                {
                  hover: !r.skipHover && o.hoverKey === i.nr.key
                }
              ]]
            }, TL(r.skipHover ? {} : {
              mouseenter: () => {
                o.hoverKey = i.nr.key;
              },
              mouseleave: () => {
                o.hoverKey = null;
              }
            })), {
              default: c5(() => [
                u5(t.$slots, "default", {
                  item: i.item,
                  index: i.nr.index,
                  active: i.nr.used
                })
              ]),
              _: 2
              /* DYNAMIC */
            }, 1040, ["style", "class"]))),
            128
            /* KEYED_FRAGMENT */
          )),
          u5(t.$slots, "empty")
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["style", "class"])),
      t.$slots.after ? (b(), _(
        "div",
        uS,
        [
          u5(t.$slots, "after")
        ],
        512
        /* NEED_PATCH */
      )) : X("v-if", !0),
      Z(a, { onNotify: n.handleResize }, null, 8, ["onNotify"])
    ],
    34
    /* CLASS, HYDRATE_EVENTS */
  )), [
    [s, n.handleVisibilityChange]
  ]);
}
u4.render = dS;
u4.__file = "src/components/RecycleScroller.vue";
const oL = (t) => (g1("data-v-b2a81a00"), t = t(), v1(), t), cS = {
  key: 0,
  class: "bl-input-search"
}, hS = { class: "flex flex-1 flex-nowrap items-end bl-input-search__wrapper" }, fS = ["onClick"], pS = ["onKeydown"], mS = /* @__PURE__ */ oL(() => /* @__PURE__ */ d("span", null, null, -1)), gS = [
  mS
], vS = ["innerHTML"], yS = /* @__PURE__ */ oL(() => /* @__PURE__ */ d("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, [
  /* @__PURE__ */ d("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, [
    /* @__PURE__ */ d("path", {
      id: "Pfad_7045",
      class: "fill-bl-text-color dark:fill-bl-dk-text-color",
      "data-name": "Pfad 7045",
      d: "M12.4,5.6,5.9,12.1,3,9,9.4,2.6ZM0,15l5.2-2.4-2.8-3ZM14.7,1.7,13.3.3a1.2,1.2,0,0,0-1.6,0h-.1L11,1h0L10,2.1,12.9,5l.9-.8h0l.8-.8h.1a1.2,1.2,0,0,0,0-1.6Z"
    })
  ])
], -1)), wS = [
  yS
], bS = ["onMousemove", "onClick"], xS = ["innerHTML"], kS = { key: 1 }, MS = {
  name: "MfxCombobox"
}, _S = /* @__PURE__ */ r5({
  ...MS,
  props: {
    items: {
      type: Array,
      default: () => []
    },
    valueProp: {
      type: String,
      default: "id"
    },
    labelProp: {
      type: String,
      default: "name"
    },
    editData: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: [Object, Number],
      default: () => ({})
    }
  },
  emits: ["setActive", "setInactive", "selectedOption", "filedShouldBeUpdated", "valueSelected", "update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, { labelProp: L, valueProp: o, items: n, modelValue: a, editData: s } = N5(r), { localValue: i } = y1(a, e), l = P(null), u = P(), c = P(!1), v = P(!1), p = P(!1), m = P(null), f = P(""), x = P({}), y = P(-1), w = P(), g = P(null), h = P(), k = P(null), M = P({
      pageX: 0,
      pageY: 0
    }), $ = P(1), C = (E) => E ? E.toString().replace(/([.?*+^$[\]\\(){}|])/g, "\\$1") : "", D = () => {
      v.value = !0, p.value = !0, e("setActive");
    }, S = (E) => {
      E && E.target.blur(), v.value = !1, w.value = null, m.value = null, g.value = null, e("setInactive");
    }, T = (E) => {
      p.value = !1, f.value = E.target.innerText.trim();
    }, B = (E) => {
      E.target.innerText.trim() && (e("selectedOption", !1), e("filedShouldBeUpdated", L.value), e("valueSelected", {
        [L.value]: E.target.innerText.trim()
      }));
    };
    function I() {
      var E;
      f.value || i5(l.value), (E = l.value) == null || E.focus();
    }
    function R() {
      S();
    }
    function N(E, L5 = !1) {
      e("selectedOption", !0), x.value = E, !L5 && l.value && (y.value = f5.value.findIndex(
        (g5) => (g5 || g5[L.value]) === E
      ), f.value = E[L.value] || E, l.value.innerText = f.value), S();
    }
    function H(E) {
      w.value && l.value && (f.value = w.value[L.value], x.value = w.value, y.value = g.value || -1, l.value.innerText = f.value, i5(l.value), E.target.blur(), S()), h.value && l.value && (f.value = h.value[L.value], x.value = h.value, y.value = k.value || -1, l.value.innerText = f.value, i5(l.value), E.target.blur(), S());
    }
    function G(E) {
      return (x.value && x.value[o.value]) === (E && E[o.value]);
    }
    function e5(E) {
      if (!w.value)
        return E;
      const L5 = new RegExp(C(f.value), "gi");
      return E.toString().replace(L5, '<span style="background-color: #ECEBEB">$&</span>');
    }
    function t5() {
      m.value && m.value.length && (w.value || h.value) && l.value && (g.value = f5.value.findIndex(
        (E) => E[o.value] === (w.value && w.value[o.value] || h.value && h.value[o.value])
      ), f.value = f5.value[g.value][L.value], l.value.innerText = f.value, i5(l.value));
    }
    function J(E, L5) {
      if (E) {
        const { pageX: g5, pageY: z } = E;
        if (g5 === M.value.pageX || z === M.value.pageY)
          return;
        M.value = {
          pageX: g5,
          pageY: z
        };
      }
      if (L5) {
        const g5 = f5.value.find((A) => A === L5 || A[L.value] === L5[L.value]), z = f5.value.findIndex(
          (A) => A === L5 || A[L.value] === L5[L.value]
        );
        h.value = g5, y.value = z, k.value = z, g5 && (m.value = g5[L.value].toString().startsWith(f.value) ? g5[L.value].toString().replace(f.value, "") : null);
      } else
        m.value = null;
    }
    function h5() {
      h.value = null;
    }
    function n5(E) {
      E.preventDefault(), y.value < f5.value.length - 1 && (y.value = y.value + 1, w.value = null, k.value = y.value, h.value = f5.value[k.value], J(null, h.value), o5());
    }
    function _5(E) {
      E.preventDefault(), y.value > 0 && (y.value = y.value - 1, w.value = null, k.value = y.value, h.value = f5.value[k.value], J(null, h.value), o5());
    }
    function o5() {
      y.value !== void 0 && u.value && u.value.scrollToItem(y.value);
    }
    function i5(E) {
      if (E) {
        if (typeof window.getSelection < "u" && typeof document.createRange < "u") {
          const L5 = document.createRange();
          L5.selectNodeContents(E), L5.collapse(!1);
          const g5 = window.getSelection();
          g5 && (g5.removeAllRanges(), g5.addRange(L5));
        } else if (
          //@ts-expect-error
          document.selection && //@ts-expect-error
          typeof document.body.createTextRange < "u"
        ) {
          const L5 = document.body.createTextRange();
          L5.moveToElementText(E), L5.collapse(!1), L5.select();
        }
      }
    }
    const k5 = U(() => f.value && f.value.length), f5 = U(() => p.value ? n.value || [] : n.value && n.value.length ? n.value.filter((E) => new RegExp(
      C(f.value),
      "gi"
    ).test(E[L.value])) : []);
    return s5($, (E) => {
      N(E);
    }), s5(f, (E) => {
      const L5 = new RegExp(C(E), "uig"), g5 = new RegExp(`^${C(E)}`, "i");
      if (w.value = E && E.length && f5.value.find(
        (z) => L5.test(z && z[L.value])
      ), w.value) {
        if (typeof w.value[L.value] == "number")
          return w.value[L.value].toString();
        g.value = f5.value.findIndex(
          (z) => z === w.value
        ), m.value = g5.test(w.value[L.value]) && w.value[L.value].replace(g5, "");
      } else
        m.value = null, g.value = null;
    }), s5(x, (E) => {
      i.value = E, e("valueSelected", E);
    }), s5(s, (E) => {
      l.value && (E[L.value] ? l.value.innerText = E[L.value] : l.value.innerText = f.value, c.value = !0);
    }), I5(() => {
      L.value === "count" && $e(() => {
        N($.value, !0), $.value = 1;
      });
    }), (E, L5) => {
      const g5 = D2("click-away");
      return b(), _("div", null, [
        O(L) === "count" ? (b(), _("div", cS, [
          b5(d("input", {
            ref_key: "input",
            ref: l,
            "onUpdate:modelValue": L5[0] || (L5[0] = (z) => h1(i) ? i.value = z : null),
            type: "number",
            min: "1",
            max: "100",
            step: "1",
            class: "rounded border-transparent spinbutton"
          }, null, 512), [
            [qe, O(i)]
          ])
        ])) : b5((b(), _("div", {
          key: 1,
          "data-testid": "combobox",
          class: F([{
            "bl-input-search--active": v.value,
            "bl-input-search--has-value": k5.value || c.value
          }, "bl-input-search bl-input-search--primary flex items-end justify-center combobox"])
        }, [
          d("div", hS, [
            d("div", {
              class: "editable flex flex-nowrap mr-0.5",
              onClick: re(I, ["prevent"])
            }, [
              d("div", {
                ref_key: "input",
                ref: l,
                class: "editable__input",
                contenteditable: "true",
                onInput: T,
                onKeydown: [
                  ee(re(t5, ["prevent"]), ["tab"]),
                  ee(re(H, ["prevent"]), ["enter"]),
                  ee(S, ["esc"]),
                  ee(n5, ["down"]),
                  ee(_5, ["up"])
                ],
                onFocus: D,
                onBlur: B
              }, gS, 40, pS),
              m.value ? (b(), _("span", {
                key: 0,
                class: "editable__autocomplete",
                innerHTML: m.value
              }, null, 8, vS)) : X("", !0)
            ], 8, fS),
            (b(), _("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "15",
              height: "15",
              viewBox: "0 0 15 15",
              onClick: D
            }, wS))
          ]),
          Z(mt, { name: "fade" }, {
            default: c5(() => [
              v.value ? (b(), _("div", {
                key: 0,
                class: "items-list",
                onMouseleave: h5
              }, [
                Z(O(u4), {
                  ref_key: "scrollContainer",
                  ref: u,
                  class: "scroller",
                  items: f5.value,
                  "item-size": 43,
                  "key-field": "id"
                }, {
                  default: c5(({ item: z, index: A }) => [
                    d("p", {
                      ref: "options",
                      class: F([{
                        "items-list__item--selected": G(z),
                        "items-list__item--navigated": A === k.value
                      }, "items-list__item"]),
                      onMousemove: (Y) => J(Y, z),
                      onClick: (Y) => N(z)
                    }, [
                      d("span", {
                        innerHTML: e5(z[O(L)] || z)
                      }, null, 8, xS)
                    ], 42, bS)
                  ]),
                  _: 1
                }, 8, ["items"])
              ], 32)) : (b(), _("div", kS))
            ]),
            _: 1
          })
        ], 2)), [
          [g5, R]
        ])
      ]);
    };
  }
});
const $S = /* @__PURE__ */ K(_S, [["__scopeId", "data-v-b2a81a00"]]), SS = { class: "table-container flex flex-wrap" }, CS = { class: "table-container__heading flex justify-end" }, DS = { class: "table-auto" }, zS = { key: 0 }, IS = { key: 0 }, TS = ["colspan"], OS = ["onClick"], PS = {
  name: "MfxEditableTable"
}, ZS = /* @__PURE__ */ r5({
  ...PS,
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columnDefs: {
      type: Array,
      default: () => []
    },
    editData: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Object,
      default: () => ({})
    },
    articlesLength: {
      type: Number,
      default: 0
    },
    clearButtonText: {
      type: String,
      default: "clear"
    },
    addItemText: {
      type: String,
      default: "add item"
    }
  },
  emits: ["addItemToggled", "dataChanged", "editDataRefresh", "columnDataSelected", "itemRemoved", "listCleared", "selectedOption", "filedShouldBeUpdated", "updateFormFields"],
  setup(t, { emit: e }) {
    const r = t, L = P([]), o = P(null), n = P([]), a = P([]), s = U(
      () => r.columnDefs.filter((h) => h.required).map((h) => h.propName)
    );
    s5(
      () => r.data,
      (h) => {
        L.value = [...h];
      },
      { immediate: !0 }
    );
    function i() {
      r.articlesLength < 1 && e("addItemToggled");
    }
    function l(h, k, M) {
      const $ = k == "object" ? {} : [];
      for (const C in h) {
        if (M && C === M)
          continue;
        const D = r.columnDefs.find((S) => S.propName === C);
        D && D.linkId && h[C] && (Array.isArray($) ? $.push({
          linkId: D.linkId,
          response_value: h[C]
        }) : $[D.linkId] = h[C]);
      }
      return $;
    }
    function u() {
      o.value = {}, r.columnDefs.forEach((h) => {
        o.value && (o.value[h.propName] = null);
      }), r.articlesLength < 1 && e("addItemToggled");
    }
    function c() {
      if (n.value = [], r.editData && Object.keys(r.editData).length) {
        for (let h = 0; h < s.value.length; h++)
          r.editData[s.value[h]] || n.value.includes(s.value[h]) || n.value.push(s.value[h]);
        if (n.value.length)
          return;
      }
      if (o.value && r.editData) {
        let h = JSON.parse(JSON.stringify(r.editData)), k = [
          ...l(h, "array", "id")
        ];
        e("updateFormFields", { fields: k }), h = null, k = null, o.value = {
          catalog_number: r.editData.catalog_number,
          manufacturer: r.editData.manufacturer,
          classification: r.editData.classification,
          subClassification: r.editData.subClassification,
          family: r.editData.family,
          count: r.editData.count
        }, o.value = null, e("dataChanged", L.value), e("editDataRefresh");
      }
    }
    function v(h, k) {
      e("columnDataSelected", { data: h, column: k });
    }
    function p(h, k) {
      L.value = L.value.filter((M) => M !== h), e("itemRemoved", k), e("dataChanged", L.value);
    }
    function m() {
      const h = JSON.parse(JSON.stringify(L.value)).map(
        (k) => {
          const M = l(
            k,
            "object",
            "id"
          );
          if (Object.keys(M))
            return M;
        }
      );
      L.value = [], o.value = null, e("listCleared", h), e("dataChanged", L.value), e("editDataRefresh");
    }
    function f(h) {
      e("selectedOption", h);
    }
    function x(h) {
      e("filedShouldBeUpdated", h);
    }
    function y() {
      Object.prototype.hasOwnProperty.call(
        r.fields,
        r.columnDefs[0].linkId
      ) && r.fields[r.columnDefs[0].linkId].response_value && r.columnDefs.forEach((h) => {
        const k = r.fields[h.linkId].response_value;
        Array.isArray(k) && k.forEach((M, $) => {
          L.value[$] ? L.value[$] = {
            ...L.value[$],
            [h.propName]: M
          } : L.value[$] = { [h.propName]: M };
        });
      });
    }
    function w(h) {
      var k;
      return ((k = a.value.at(h)) == null ? void 0 : k.clientWidth) + "px";
    }
    function g(h, k) {
      var M;
      return k !== "count" ? ((M = a.value.at(h)) == null ? void 0 : M.clientWidth) + "px" : "";
    }
    return I5(() => {
      y();
    }), (h, k) => (b(), _("div", SS, [
      d("div", CS, [
        Z(O(r0), {
          content: t.clearButtonText,
          name: "clearButton",
          onClick: m
        }, {
          default: c5(() => [
            Z(O(ce), {
              width: 12.7,
              height: 15.9,
              "view-box": "0 0 12.7 15.9"
            }, {
              default: c5(() => [
                Z(O(h2))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      d("table", DS, [
        d("thead", null, [
          d("tr", null, [
            (b(!0), _(p5, null, S5(t.columnDefs, (M, $) => (b(), _("th", {
              ref_for: !0,
              ref: (C) => a.value[$] = C,
              key: $,
              class: "table-heading"
            }, [
              c1(V(M.headerName) + " ", 1),
              M.required ? (b(), _("span", {
                key: 0,
                class: F([
                  n.value.includes(M.propName) ? "[ text-red-500 ]" : "test"
                ])
              }, [
                c1(" * "),
                n.value.includes(M.propName) ? (b(), _("span", zS, "!")) : X("", !0)
              ], 2)) : X("", !0)
            ]))), 128))
          ])
        ]),
        d("tbody", null, [
          o.value ? X("", !0) : (b(), _("tr", IS, [
            d("td", {
              colspan: t.columnDefs && t.columnDefs.length
            }, [
              Z(O(r0), {
                class: "flex justify-center table-button",
                content: t.addItemText,
                onClick: u
              }, {
                default: c5(() => [
                  Z(O(ce), {
                    width: 13,
                    height: 13,
                    "view-box": "0 0 13 13"
                  }, {
                    default: c5(() => [
                      Z(O(Ix))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content"])
            ], 8, TS)
          ])),
          o.value ? (b(), _("tr", {
            key: 1,
            class: F([{ active: !!o.value }, "table-edit"])
          }, [
            (b(!0), _(p5, null, S5(t.columnDefs, (M, $) => (b(), _("td", {
              key: $,
              style: R5({
                maxWidth: g($, M.propName),
                width: w($)
              }),
              class: "table-data"
            }, [
              M.propName === "count" ? (b(), x5(O(y_), {
                key: 0,
                min: 0,
                "model-value": 1,
                max: 100,
                placeholder: "1",
                onValueChanged: (C) => v(Number(C) || 0, M)
              }, null, 8, ["onValueChanged"])) : (b(), x5(O($S), {
                key: 1,
                modelValue: o.value[M.propName],
                "onUpdate:modelValue": (C) => o.value[M.propName] = C,
                items: M.dataSource,
                "label-prop": M.propName || M.labelPropName,
                "value-prop": M.propName,
                "edit-data": t.editData,
                onValueSelected: (C) => v(C, M),
                onSelectedOption: f,
                onFiledShouldBeUpdated: x,
                onSetActive: i
              }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label-prop", "value-prop", "edit-data", "onValueSelected"])),
              $ === (t.columnDefs && t.columnDefs.length) - 1 ? (b(), _("div", {
                key: 2,
                class: "table-save flex items-center justify-center",
                onClick: c
              }, [
                Z(O(ce), {
                  "icon-color": "black",
                  width: 16,
                  height: 12.8,
                  "view-box": "0 0 16 12.8"
                }, {
                  default: c5(() => [
                    Z(O(Ib))
                  ]),
                  _: 1
                })
              ])) : X("", !0)
            ], 4))), 128))
          ], 2)) : X("", !0),
          (b(!0), _(p5, null, S5(L.value, (M, $) => (b(), _("tr", { key: $ }, [
            (b(!0), _(p5, null, S5(t.columnDefs, (C, D) => (b(), _("td", {
              key: D,
              class: "table-data"
            }, [
              d("span", null, V(M[C.propName]), 1),
              D === t.columnDefs.length - 1 ? (b(), _("div", {
                key: 0,
                class: "table-remove flex items-center justify-center",
                onClick: (S) => p(M, $)
              }, [
                Z(O(ce), {
                  width: 12.7,
                  height: 15.9,
                  "view-box": "0 0 12.7 15.9"
                }, {
                  default: c5(() => [
                    Z(O(h2))
                  ]),
                  _: 1
                })
              ], 8, OS)) : X("", !0)
            ]))), 128))
          ]))), 128))
        ])
      ])
    ]));
  }
});
const HT = /* @__PURE__ */ K(ZS, [["__scopeId", "data-v-359feaa6"]]);
function ES(t, e) {
  se(() => {
    window.removeEventListener(t, e);
  }), OL(() => {
    window.addEventListener(t, e);
  });
}
const AS = ["onClick"], NS = {
  key: 0,
  class: "grid grid-flow-col gap-x-2 items-center"
}, HS = ["innerHTML"], BS = {
  name: "MfxToggle"
}, VS = /* @__PURE__ */ r5({
  ...BS,
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsSpacing: {
      type: Number,
      default: 0
    },
    horizontal: {
      type: Boolean,
      default: !1
    },
    selectorClass: {
      type: String,
      default: ""
    },
    backgroundClass: {
      type: String,
      default: ""
    },
    activeToggleInnerTextClass: {
      type: String,
      default: ""
    },
    toggleOuterTextClass: {
      type: String,
      default: ""
    }
  },
  emits: ["valueSelected", "update:modelValue"],
  setup(t, { expose: e, emit: r }) {
    const L = t, o = P(), n = P([]), a = P(null), s = P(3), { localValue: i } = y1(a, r);
    function l(y) {
      var w;
      return ((w = y && y.display && y.display[0]) == null ? void 0 : w.toLocaleUpperCase()) || "";
    }
    function u(y) {
      a.value = y;
    }
    function c() {
      if (L.horizontal) {
        const y = a.value;
        a.value = { display: "", value: "", id: "" }, a.value = y;
      }
    }
    const v = U(() => {
      const y = "bg-bl-selected-color dark:bg-bl-dk-selected-color";
      return L.selectorClass ? T5(y, C5().toString(L.selectorClass)) : y;
    }), p = U(() => {
      const y = "bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color";
      return L.backgroundClass ? T5(y, C5().toString(L.backgroundClass)) : y;
    }), m = U(() => {
      const y = "";
      return L.backgroundClass ? T5(y, C5().toString(L.backgroundClass)) : y;
    }), f = U(() => {
      const y = "text-bl-icon-default-color dark:text-bl-dk-icon-default-color";
      return L.activeToggleInnerTextClass ? T5(
        y,
        C5().toString(L.activeToggleInnerTextClass)
      ) : y;
    }), x = U(() => {
      if (a.value && o.value && n.value) {
        const y = o.value.getBoundingClientRect(), w = n.value[L.items.findIndex((g) => {
          var h;
          return g.id === ((h = a.value) == null ? void 0 : h.id);
        })].getBoundingClientRect();
        if (L.horizontal) {
          const g = w.left - y.left;
          return g === 0 ? s.value : g + s.value;
        } else {
          const g = w.top - y.top;
          return g === 0 ? s.value : g + s.value;
        }
      }
      return 0;
    });
    return s5(a, (y) => {
      y && (i.value = y, r("valueSelected", y));
    }), I5(() => {
      if (i.value) {
        const y = L.items.find(
          (w) => {
            var g;
            return w.id === ((g = i.value) == null ? void 0 : g.id);
          }
        );
        y && u(y);
      }
      L.value.id && u(L.value);
    }), ES("resize", c), e({
      props: L,
      selectValue: u
    }), (y, w) => (b(), _("div", {
      ref_key: "container",
      ref: o,
      class: F(["toggle-container flex", [
        t.horizontal ? "toggle-horizontal" : "toggle-vertical items-stretch flex-wrap"
      ]])
    }, [
      d("span", {
        class: F(["background", [p.value]])
      }, null, 2),
      d("span", {
        class: F(["toggle-container__pointer", [
          v.value,
          { "toggle-container__pointer--active": !!a.value }
        ]]),
        style: R5([
          t.horizontal ? `left: ${x.value}px` : `top: ${x.value}px`,
          t.horizontal && `width: calc(100% / ${t.items.length} - 6px)`
        ])
      }, null, 6),
      (b(!0), _(p5, null, S5(t.items, (g, h) => (b(), _("div", {
        key: g.id,
        ref_for: !0,
        ref: (k) => k && n.value.push(k),
        class: F(["toggle-label flex", [
          {
            "toggle-label--selected": a.value && a.value.id === g.id
          }
        ]]),
        style: R5({
          paddingBottom: h !== t.items.length - 1 && !t.horizontal ? t.itemsSpacing + "px" : ""
        }),
        onClick: (k) => u(g)
      }, [
        d("i", {
          class: F([
            a.value && a.value.id === g.id && f.value
          ])
        }, V(t.horizontal ? g.display : l(g)), 3),
        t.horizontal ? X("", !0) : (b(), _("div", NS, [
          d("span", {
            class: F(["title", [m.value]])
          }, V(g.display), 3),
          g.helpText ? (b(), x5(O(ft), {
            key: 0,
            class: "flex toggle-tooltip",
            position: "top"
          }, {
            default: c5(() => [
              d("span", {
                innerHTML: g.helpText
              }, null, 8, HS)
            ]),
            _: 2
          }, 1024)) : X("", !0)
        ]))
      ], 14, AS))), 128))
    ], 2));
  }
});
const RS = /* @__PURE__ */ K(VS, [["__scopeId", "data-v-a1461dda"]]), YS = {
  name: "MfxDotify"
}, FS = /* @__PURE__ */ r5({
  ...YS,
  props: {
    vertical: {
      type: Boolean,
      default: !1
    },
    radius: {
      type: Number,
      default: 1
    },
    offset: {
      type: Number,
      default: 5
    },
    rotate: {
      type: Number,
      default: null
    },
    size: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: "#000"
    },
    isDarkMode: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = t, { vertical: r, radius: L, offset: o, rotate: n, size: a, color: s, isDarkMode: i } = N5(e), l = P(null), u = P(), c = P(null), v = U(
      () => c.value && c.value.getBoundingClientRect()
    ), p = U(() => r.value && r.value ? {
      width: "100%",
      height: a.value + "px"
    } : {
      width: a.value + "px"
    }), m = () => {
      const y = v.value, w = window.devicePixelRatio || 1;
      l.value && r && y && u.value && (l.value.width = Math.ceil(
        r.value ? y.width * w : a.value * w
      ), l.value.height = Math.ceil(
        r.value ? a.value * w : y.height * w
      ), u.value.scale(w, w));
    }, f = () => {
      const y = v.value;
      if (L.value && L.value && y) {
        const w = L.value + o.value, g = Math.floor(a.value / w);
        if (u.value) {
          u.value.clearRect(0, 0, y.width, y.height);
          for (let h = 0; h < g; h++) {
            let k = 0, M = 0;
            r.value && r.value ? (k = y.width / 2, M = h * w + o.value) : (k = h * w + o.value, M = y.height / 2), u.value.beginPath(), u.value.arc(k, M, L.value, 0, 2 * Math.PI, !1), n.value && n.value && u.value.rotate(n.value * Math.PI / 180), u.value.fillStyle = e.isDarkMode ? getComputedStyle(document.documentElement).getPropertyValue(
              "--bl-dk-text-color"
            ) : getComputedStyle(document.documentElement).getPropertyValue(
              "--bl-text-color"
            ), u.value.strokeStyle = e.isDarkMode ? getComputedStyle(document.documentElement).getPropertyValue(
              "--bl-dk-text-color"
            ) : getComputedStyle(document.documentElement).getPropertyValue(
              "--bl-text-color"
            ), u.value.lineWidth = 0, u.value.fill(), u.value.stroke();
          }
        }
      }
    }, x = () => {
      m(), f();
    };
    return I5(() => {
      if (window.addEventListener("resize", x), l.value = c.value, l.value) {
        l.value.style.willChange = "transform";
        const y = l.value.getContext("2d");
        y && (u.value = y);
      }
      m(), f();
    }), S2(() => {
      window.removeEventListener("resize", x);
    }), s5(
      [r, L, o, n, a, s, i],
      () => {
        l.value && (m(), f());
      },
      { deep: !0, immediate: !0 }
    ), (y, w) => (b(), _("canvas", {
      ref_key: "canvas",
      ref: c,
      style: R5(p.value)
    }, null, 4));
  }
});
const a3 = /* @__PURE__ */ K(FS, [["__scopeId", "data-v-a219de9f"]]), sL = (t) => (g1("data-v-58571249"), t = t(), v1(), t), jS = { class: "flex items-center" }, WS = /* @__PURE__ */ sL(() => /* @__PURE__ */ d("span", { class: "text-bl-text-color dark:text-bl-dk-text-color mx-1" }, "/", -1)), US = /* @__PURE__ */ sL(() => /* @__PURE__ */ d("span", { class: "text-bl-text-color dark:text-bl-dk-text-color mx-1" }, "/", -1)), GS = {
  key: 0,
  class: "font-bold text-bl-attention-color dark:text-bl—dk-attention-color",
  "data-testid": "requiredIndicator"
}, KS = {
  name: "MfxFuzzyDatePicker"
}, qS = /* @__PURE__ */ r5({
  ...KS,
  props: {
    modelValue: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, L = P(""), o = P(""), n = P(""), { modelValue: a } = N5(r), { localValue: s } = y1(a, e), i = () => {
      n.value && o.value && L.value ? s.value = [n.value, o.value, L.value].join("-") : n.value && o.value && !L.value ? s.value = [n.value, o.value].join("-") : n.value && !o.value && !L.value || n.value && !o.value && L.value ? s.value = n.value + "-01" : s.value = "";
    }, l = () => {
      if (!s.value)
        u();
      else {
        const w = s.value.split("-");
        n.value = w[0] && w[0], o.value = w[1] && w[1], L.value = w[2] && w[2];
      }
    }, u = () => {
      L.value = "", o.value = "", n.value = "";
    }, c = (w) => {
      const g = Number(w);
      return isNaN(g) ? !1 : g < 32 && g.toString().length < 3 && w !== "00";
    }, v = (w) => {
      const g = Number(w);
      return isNaN(g) ? !1 : g < 13 && g.toString().length < 3;
    }, p = (w) => {
      const g = Number(w);
      return isNaN(g) ? !1 : g < 9999 && g.toString().length < 5;
    }, m = () => {
      L.value = y(L.value);
    }, f = () => {
      o.value = y(o.value);
    }, x = () => {
      n.value = n.value.toString().length === 4 ? n.value : "";
    }, y = (w) => w.toString().length === 1 && +w != 0 ? "0" + w : w !== "" && +w == 0 ? "01" : w;
    return I5(() => {
      l();
    }), s5(s, (w) => {
      !w && u();
    }), s5(L, () => {
      i();
    }), s5(n, (w) => {
      w ? i() : (u(), s.value = "");
    }), (w, g) => (b(), _("div", jS, [
      Z(O(Nt), {
        modelValue: L.value,
        "onUpdate:modelValue": g[0] || (g[0] = (h) => L.value = h),
        class: "fuzzy-input-wrapper",
        type: "number",
        "min-width": "35",
        placeholder: "TT",
        "input-classes": "fuzzy-input",
        "hide-svg": "",
        expandable: !1,
        "is-valid": c,
        "data-testid": "fuzzyDatePickerDayInput",
        onFocusOut: m
      }, null, 8, ["modelValue"]),
      WS,
      Z(O(Nt), {
        modelValue: o.value,
        "onUpdate:modelValue": g[1] || (g[1] = (h) => o.value = h),
        class: "fuzzy-input-wrapper",
        type: "number",
        "min-width": "35",
        placeholder: "MM",
        "input-classes": "fuzzy-input",
        "hide-svg": "",
        expandable: !1,
        "is-valid": v,
        "data-testid": "fuzzyDatePickerMonthInput",
        onFocusOut: f
      }, null, 8, ["modelValue"]),
      US,
      Z(O(Nt), {
        modelValue: n.value,
        "onUpdate:modelValue": g[2] || (g[2] = (h) => n.value = h),
        class: "fuzzy-input-wrapper",
        type: "number",
        "min-width": "35",
        placeholder: "JJJJ",
        "input-classes": "fuzzy-input",
        "hide-svg": "",
        expandable: !1,
        "is-valid": p,
        "data-testid": "fuzzyDatePickerYearInput",
        onFocusOut: x
      }, null, 8, ["modelValue"]),
      w.required ? (b(), _("span", GS, " * ")) : X("", !0)
    ]));
  }
});
const BT = /* @__PURE__ */ K(qS, [["__scopeId", "data-v-58571249"]]), XS = { class: "lang--switcher shadow-sm" }, JS = /* @__PURE__ */ d("g", { id: "Rounded_Rectangle_33_copy_4_1_" }, [
  /* @__PURE__ */ d("path", {
    class: "fill-bl-text-color dark:fill-bl-dk-text-color",
    d: "M480,344.181L268.869,131.889c-15.756-15.859-41.3-15.859-57.054,0c-15.754,15.857-15.754,41.57,0,57.431l237.632,238.937   c8.395,8.451,19.562,12.254,30.553,11.698c10.993,0.556,22.159-3.247,30.555-11.698l237.631-238.937   c15.756-15.86,15.756-41.571,0-57.431s-41.299-15.859-57.051,0L480,344.181z"
  })
], -1), QS = [
  JS
], eC = ["onClick"], tC = {
  name: "MfxLanguageSwitcher"
}, VT = /* @__PURE__ */ r5({
  ...tC,
  props: {
    selectedLanguage: {},
    allLanguageOptions: {}
  },
  emits: ["selectActiveLanguage"],
  setup(t, { emit: e }) {
    const r = t, L = U(
      () => r.allLanguageOptions.filter(
        (i) => i.text !== r.selectedLanguage.text
      )
    ), o = P(!1), n = () => {
      o.value = !o.value;
    }, a = () => {
      o.value = !1;
    }, s = (i) => {
      e("selectActiveLanguage", i), n();
    };
    return (i, l) => {
      const u = D2("click-away");
      return b5((b(), _("div", XS, [
        d("span", {
          class: "lang--selected",
          onClick: n
        }, [
          c1(V(i.selectedLanguage.text) + " ", 1),
          (b(), _("svg", {
            id: "Capa_1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            version: "1.1",
            x: "0px",
            y: "0px",
            width: "30px",
            height: "30px",
            viewBox: "0 0 960 560",
            "enable-background": "new 0 0 960 560",
            "xml:space": "preserve",
            class: F(["dropDown--button", [{ selectorActive: o.value }]])
          }, QS, 2))
        ]),
        d("div", {
          class: F(["lang--selector", [{ selectorActive: o.value }]])
        }, [
          (b(!0), _(p5, null, S5(L.value, (c) => (b(), _("span", {
            key: c.value,
            class: "lang--selector__item",
            onClick: (v) => s(c)
          }, V(c.text), 9, eC))), 128))
        ], 2)
      ])), [
        [u, a]
      ]);
    };
  }
});
const rC = { class: "w-full rounded-full border-2 border-bl-panel-color dark:border-bl-dk-panel-color bg-bl-panel-color dark:bg-bl-dk-panel-color" }, LC = /* @__PURE__ */ r5({
  __name: "MfxProgressBar",
  props: {
    progress: { default: 0 },
    height: { default: 10 }
  },
  setup(t) {
    const e = t, r = P(null);
    return I5(() => {
      r.value.style.width = `${e.progress}%`, r.value.style.height = `${e.height}px`;
    }), s5(
      () => e.progress,
      (L) => {
        r.value.style.width = `${L}%`;
      }
    ), (L, o) => (b(), _("div", rC, [
      d("div", {
        id: "progressBar",
        ref_key: "refProgressBar",
        ref: r,
        class: F(["rounded-full border-2", {
          "bg-bl-progress-bar dark:bg-bl-dk-progress-bar": e.progress > 0,
          "bg-transparent": e.progress < 1,
          "border-bl-progress-bar dark:border-bl-dk-progress-bar": e.progress > 0,
          "border-none": e.progress < 1
        }])
      }, "   ", 2)
    ]));
  }
});
const RT = /* @__PURE__ */ K(LC, [["__scopeId", "data-v-2d4d2cb7"]]);
const nC = ["name", "value"], oC = { class: "baum-branch__image" }, sC = ["src"], aC = { class: "baum-branch__legend" }, iC = { class: "baum-branch__controls" }, lC = { class: "baum-branch__tooltip" }, uC = { key: 0 }, dC = ["name", "value"], cC = /* @__PURE__ */ d("span", null, null, -1), hC = {
  name: "TreeNode"
}, aL = /* @__PURE__ */ r5({
  ...hC,
  props: {
    node: {},
    eventBus: {}
  },
  setup(t) {
    return (e, r) => (b(), _("li", {
      class: F(["baum-branch", { "baum-branch--image-selection": e.node.imageSelect }])
    }, [
      e.node.imageSelect ? (b(), _("label", {
        key: 1,
        class: F(["flex", {
          "baum--has-selection": e.node.selected
        }])
      }, [
        d("div", oC, [
          d("img", {
            style: {},
            src: e.node.image,
            alt: ""
          }, null, 8, sC)
        ]),
        d("div", aC, [
          d("div", iC, [
            d("span", null, V(e.node.text), 1)
          ]),
          d("div", lC, [
            e.node.tooltip !== "" ? (b(), _("div", uC, [
              e.node.tooltip === "string" ? (b(), x5(ft, {
                key: 0,
                trigger: "hover"
              }, {
                default: c5(() => [
                  c1(V(e.node.tooltip), 1)
                ]),
                _: 1
              })) : Array.isArray(e.node.tooltip) ? (b(), x5(ft, {
                key: 1,
                trigger: "hover"
              }, {
                default: c5(() => [
                  (b(!0), _(p5, null, S5(e.node.tooltip, (L) => (b(), _("span", {
                    key: L,
                    class: "mb-2"
                  }, V(L), 1))), 128))
                ]),
                _: 1
              })) : X("", !0)
            ])) : X("", !0),
            b5(d("input", {
              "onUpdate:modelValue": r[2] || (r[2] = (L) => e.node.selected = L),
              type: "checkbox",
              name: e.node.linkId,
              value: e.node.value,
              onClick: r[3] || (r[3] = (L) => e.eventBus.emit("nodeSelected", e.node))
            }, null, 8, dC), [
              [ot, e.node.selected]
            ]),
            cC
          ])
        ])
      ], 2)) : (b(), _(p5, { key: 0 }, [
        d("label", {
          class: F({
            "baum--has-selection": e.node.selected
          })
        }, [
          b5(d("input", {
            "onUpdate:modelValue": r[0] || (r[0] = (L) => e.node.selected = L),
            type: "checkbox",
            name: e.node.linkId,
            value: e.node.value,
            onClick: r[1] || (r[1] = (L) => e.eventBus.emit("nodeSelected", e.node))
          }, null, 8, nC), [
            [ot, e.node.selected]
          ]),
          d("span", null, V(e.node.text), 1)
        ], 2),
        u5(e.$slots, "default")
      ], 64))
    ], 2));
  }
}), fC = { class: "baum" }, pC = {
  name: "TreeNodes"
}, iL = /* @__PURE__ */ r5({
  ...pC,
  props: {
    nodes: {},
    eventBus: {}
  },
  setup(t) {
    return (e, r) => (b(), _("ul", fC, [
      (b(!0), _(p5, null, S5(e.nodes, (L) => (b(), x5(aL, {
        key: L.linkId,
        node: L,
        "event-bus": e.eventBus
      }, {
        default: c5(() => [
          L.children && L.selected ? (b(), x5(iL, {
            key: 0,
            nodes: L.children,
            "event-bus": e.eventBus
          }, null, 8, ["nodes", "event-bus"])) : X("", !0)
        ]),
        _: 2
      }, 1032, ["node", "event-bus"]))), 128))
    ]));
  }
});
function mC(t) {
  return { all: t = t || /* @__PURE__ */ new Map(), on: function(e, r) {
    var L = t.get(e);
    L ? L.push(r) : t.set(e, [r]);
  }, off: function(e, r) {
    var L = t.get(e);
    L && (r ? L.splice(L.indexOf(r) >>> 0, 1) : t.set(e, []));
  }, emit: function(e, r) {
    var L = t.get(e);
    L && L.slice().map(function(o) {
      o(r);
    }), (L = t.get("*")) && L.slice().map(function(o) {
      o(e, r);
    });
  } };
}
const gC = { class: "baum baum--root baum--primary" }, vC = {
  name: "MfxTree"
}, YT = /* @__PURE__ */ r5({
  ...vC,
  props: {
    modelValue: {}
  },
  emits: ["change", "update:modelValue"],
  setup(t, { expose: e, emit: r }) {
    const L = t, o = mC();
    o.on("nodeSelected", (i) => {
      const l = st(L.modelValue);
      s(l, i), r("change", l), r("update:modelValue", l);
    });
    const n = (i) => {
      for (const l of i)
        l.selected = !1, l.children && n(l.children);
    }, a = (i) => {
      i.parent && (i.parent.selected = !0, a(i.parent));
    }, s = (i, l) => {
      n(i), a(l), l.selected = !0;
    };
    return e({
      deselectAll: n
    }), (i, l) => (b(), _("ul", gC, [
      (b(!0), _(p5, null, S5(i.modelValue, (u) => (b(), x5(aL, {
        key: u.linkId,
        node: u,
        "event-bus": O(o)
      }, {
        default: c5(() => [
          u.children && u.selected ? (b(), x5(iL, {
            key: 0,
            nodes: u.children,
            "event-bus": O(o)
          }, null, 8, ["nodes", "event-bus"])) : X("", !0)
        ]),
        _: 2
      }, 1032, ["node", "event-bus"]))), 128))
    ]));
  }
}), yC = { class: "bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color border-2 border-bl-border-color dark:bl-dk-border-color pt-3 pb-3 pr-6 pl-6 rounded-md" }, wC = /* @__PURE__ */ r5({
  __name: "MfxSelect",
  props: {
    items: {},
    initialValue: {},
    classes: {}
  },
  emits: ["update:selection"],
  setup(t, { emit: e }) {
    const r = t, L = P(null), o = P(null), n = P(null), a = P(!1), s = U(() => {
      const c = "flex justify-between items-center columns-2 dropdownContainer cursor-pointer bg-bl-button-background-default-color dark:bg-bl-dk-button-background-default-color pt-3 pb-3 pr-6 pl-6 rounded-full";
      return r.classes ? T5(c, C5().toString(r.classes)) : c;
    }), i = P(""), l = () => {
      const { width: c } = L.value.getBoundingClientRect();
      n.value.style.width = `${c}px`, a.value = !a.value, n.value.classList.toggle("show"), n.value.classList.toggle("noShow"), o.value.classList.toggle("show"), o.value.classList.toggle("noShow");
    }, u = (c) => {
      i.value = c.target.innerText, e("update:selection", c.target.innerText), n.value.classList.toggle("noShow"), o.value.classList.toggle("noShow"), a.value = !a.value;
    };
    return I5(() => {
      i.value = r.initialValue ? r.items.filter((c) => c === r.initialValue)[0] : r.items[0];
    }), (c, v) => (b(), _(p5, null, [
      d("div", {
        ref_key: "refDropdownContainer",
        ref: L,
        class: F(s.value),
        onClick: l
      }, [
        d("div", null, V(i.value), 1),
        d("div", null, [
          Z(O(Pb), {
            class: "w-5 pb-1 inline-block",
            invert: a.value
          }, null, 8, ["invert"])
        ])
      ], 2),
      d("div", {
        ref_key: "refBlocker",
        ref: o,
        class: "blocker noShow",
        onClick: l
      }, null, 512),
      d("div", {
        ref_key: "refDropdownItemList",
        ref: n,
        class: "dropdownItemList showable noShow mt-1"
      }, [
        d("div", yC, [
          (b(!0), _(p5, null, S5(r.items, (p, m) => (b(), _("div", {
            key: m,
            class: "item py-2",
            onClick: u
          }, V(p), 1))), 128))
        ])
      ], 512)
    ], 64));
  }
});
const bC = {
  name: "Repeater",
  props: {
    content: {
      type: String,
      default: "."
    },
    width: {
      type: String,
      default: ""
    },
    spaceBetween: {
      type: String,
      default: "3px"
    },
    vertical: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      canvas: void 0,
      contentWidth: this.width,
      contentSpacing: this.spaceBetween
    };
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      if (isNaN(parseFloat(this.contentWidth)))
        return;
      this.$el.style.setProperty("--repeater-width", this.contentWidth);
      const t = {
        style: getComputedStyle(this.$el),
        spaceBetween: parseFloat(this.spaceBetween),
        contentWidth: 0,
        unitWidth: 0
      }, r = (this.canvas || (this.canvas = document.createElement("canvas"))).getContext("2d");
      r.font = `${t.style.fontWeight} ${t.style.fontSize} ${t.style.fontFamily}`, t.contentWidth = r.measureText(this.content).width, t.unitWidth = t.contentWidth + t.spaceBetween;
      const L = parseFloat(t.style.width) - t.contentWidth, o = parseInt(L / t.unitWidth), n = L % t.unitWidth, a = parseFloat(this.spaceBetween) + n / o;
      this.$el.style.setProperty("--repeater-spacing", `${a}px`), this.contentSpacing = a;
      let s = "";
      for (let i = 0; i < o + 1; i++)
        s += `${this.content}`;
      this.$el.innerText = s;
    }
  }
};
function xC(t, e, r, L, o, n) {
  return b(), _("span", {
    class: F(["repeater", { "repeater--vertical": r.vertical }])
  }, null, 2);
}
const kC = /* @__PURE__ */ K(bC, [["render", xC]]);
class Zt {
  constructor() {
    this.startingColumn = 1, this.ranges = [];
  }
  get range() {
    return this.ranges;
  }
  set append(e) {
    this.ranges.push(e);
  }
  set prepend(e) {
    this.ranges.unshift(e);
  }
}
const MC = {
  name: "MfxSpine",
  components: { Repeater: kC },
  props: {
    name: {
      type: String,
      default: "spine"
    },
    unselectableSpineLocation: {
      type: Array,
      default() {
        return [];
      }
    },
    spineMap: {
      type: Object,
      default() {
        return {};
      }
    },
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      selectedValues: [],
      procedureLayout: {
        c: "",
        t: "",
        l: "",
        s: ""
      },
      spineLocations: {
        c: ["C0", "C1", "C2", "C3", "C4", "C5", "C6", "C7"],
        t: [
          "T1",
          "T2",
          "T3",
          "T4",
          "T5",
          "T6",
          "T7",
          "T8",
          "T9",
          "T10",
          "T11",
          "T12"
        ],
        l: ["L1", "L2", "L3", "L4", "L5"],
        s: ["S1", "S2", "S3", "S4", "S5", "Becken"]
      },
      reverseSpineMap: {}
    };
  },
  watch: {
    selectedValues: {
      handler(t) {
        const e = [...t];
        this.$emit("update:modelValue", e);
      },
      deep: !0
    }
  },
  mounted() {
    for (const t of this.unselectableSpineLocation) {
      const e = `spine-${t}`, r = `spine-label-${t}`;
      e in this.$refs && r in this.$refs && (this.$refs[e].classList.add("unselectable"), this.$refs[r].classList.add("unselectable"));
    }
    for (const t in this.spineMap) {
      let e = t.charAt(0).toLowerCase();
      e = e === "b" ? "s" : e, this.spineLocations[e].splice(
        this.spineLocations[e].indexOf(t),
        1,
        this.spineMap[t]
      ), this.reverseSpineMap[this.spineMap[t]] = {
        originalValue: t,
        category: e
      };
    }
    this.refresh(this.modelValue);
  },
  created() {
    window.addEventListener("resize", this.reDraw);
  },
  expose: ["clearSpine", "updateSpine"],
  methods: {
    reDraw() {
      this.$refs["spine-container"].style.setProperty(
        "--spine-height",
        getComputedStyle(this.$el).height
      );
    },
    refresh(t) {
      setTimeout(() => {
        this.updateSpine(t);
      }, 1), this.reDraw();
    },
    updateSpineMainDiagnoseIndicator(t) {
      for (const e in this.spineLocations)
        for (const r of this.spineLocations[e])
          this.$refs[`spine-main-diagnosis-${this.unconvertSpineLocation(r).originalValue}`].classList.toggle(
            "indicate",
            t.length === 0 ? !1 : t.includes(
              this.unconvertSpineLocation(r).originalValue
            )
          );
    },
    updateSpineStack(t, e, r) {
      const L = {};
      for (let a = e.length - 1; a >= 0; a--)
        if (!(!(t in e[a].raw) || e[a].raw[t].length === 0)) {
          L[e[a].id] = {
            action: e[a].id === r ? "prepend" : "append",
            c: [...this.spineLocations.c],
            t: [...this.spineLocations.t],
            l: [...this.spineLocations.l],
            s: [...this.spineLocations.s]
          };
          for (const s of e[a].raw[t]) {
            const i = this.unconvertSpineLocation(s).category;
            L[e[a].id][i].splice(
              L[e[a].id][i].indexOf(s),
              1,
              !0
            );
          }
        }
      function o(a, s, i) {
        const l = [];
        for (let u = 0; u < s[i].length; u++)
          if (s[i][u] === !0) {
            let c = u;
            for (; c < s[i].length && s[i][c] === !0; c++)
              ;
            l.push({
              title: a,
              start: u + 1,
              span: c - u,
              state: s[i].map((v) => v === !0)
            }), u = c;
          }
        return l;
      }
      const n = {
        c: new Zt(),
        t: new Zt(),
        l: new Zt(),
        s: new Zt()
      };
      for (const a in L)
        n.c[L[a].action] = o(
          a,
          L[a],
          "c"
        ), n.t[L[a].action] = o(
          a,
          L[a],
          "t"
        ), n.l[L[a].action] = o(
          a,
          L[a],
          "l"
        ), n.s[L[a].action] = o(
          a,
          L[a],
          "s"
        );
      for (const a in n) {
        this.procedureLayout[a] = "";
        let s = "", i, l = 0;
        for (let u = 0; u < n[a].ranges.length; u++) {
          for (let c = 0; c < n[a].ranges[u].length; c++) {
            const v = n[a].ranges[u][c];
            if (l === 0 && (i = {
              title: v.title,
              state: [...v.state]
            }), l > 0 && i.title !== v.title) {
              for (let p = 0; p < i.state.length; p++)
                l !== 0 && i.state[p] === !0 && v.state[p] === !0 && (n[a].startingColumn++, l = 0), i.state[p] = i.state[p] || v.state[p];
              i.title = v.title;
            }
            l++, s += `
              <span class="spine-stack-item ${v.title === r ? "selected-stack-item" : ""}" style="
                --grid-column-start: ${n[a].startingColumn};
                --grid-row-start: ${v.start};
                --grid-row-end: ${v.span}">
                  ${v.title}
              </span>`;
          }
          this.$refs[`spine-stack-${a}`].style.setProperty(
            "--grid-column-max",
            n[a].startingColumn
          ), this.procedureLayout[a] = s;
        }
      }
    },
    updateSpine(t) {
      if (t === void 0)
        return;
      const e = t.map(
        (r) => this.unconvertSpineLocation(r).originalValue
      );
      for (const r of e) {
        const L = `spine-${r}`;
        L in this.$refs && !this.selectedValues.includes(r) && this.$refs[L].dispatchEvent(new Event("click"));
      }
    },
    clearSpine() {
      this.selectedValues = [];
      for (const t in this.procedureLayout)
        this.procedureLayout[t] = "";
      for (const t in this.$refs)
        if (this.$refs[t].nodeName !== void 0)
          switch (this.$refs[t].nodeName.toLowerCase()) {
            case "path":
              this.$refs[t].classList.remove("selected");
              break;
            case "label":
              this.$refs[t].classList.remove(
                "selected",
                "sandwich-top",
                "sandwich-bottom"
              ), this.$refs[t].querySelector(
                'input[ type="checkbox" ]'
              ).checked = !1;
              break;
          }
    },
    spineGrouping(t) {
      const e = t.children;
      for (let r = 0; r < e.length; r++)
        if (e[r].classList.remove("sandwich-top", "sandwich-bottom"), e[r].classList.contains("selected")) {
          let L = r;
          for (; L < e.length && (e[L].classList.remove("sandwich-top", "sandwich-bottom"), !!e[L].classList.contains("selected")); ++L)
            ;
          e[r].classList.add("sandwich-top"), e[L - r === 1 ? r : L - 1].classList.add("sandwich-bottom"), r = L;
        }
    },
    unconvertSpineLocation(t) {
      return t in this.reverseSpineMap ? this.reverseSpineMap[t] : t.charAt(0) === "B" ? {
        originalValue: t,
        category: "s"
      } : {
        originalValue: t,
        category: t.charAt(0).toLowerCase()
      };
    },
    spineLabelSelected(t) {
      const e = t.target.getAttribute("value");
      if (this.unselectableSpineLocation.includes(e))
        return;
      const r = this.unconvertSpineLocation(e).originalValue, L = `spine-${r}`, o = `spine-label-${r}`, n = `spine-connector-from-label-${r}`, a = `spine-connector-from-spine-${r}`;
      t.target.checked ? this.selectedValues.push(e) : this.selectedValues.splice(
        this.selectedValues.indexOf(e),
        1
      ), this.$refs[o].classList.toggle(
        "selected",
        t.target.checked
      ), L in this.$refs && (this.$refs[L].classList.toggle("selected", t.target.checked), this.spineGrouping(t.target.parentElement.parentElement));
      const s = this.$refs[L].getBoundingClientRect(), i = this.$refs[o].getBoundingClientRect(), l = {
        spine: {
          x: 1,
          // Start at end
          y: 0.5
          // Start at half
        },
        label: {
          x: 1,
          // Start at end
          y: 0.5
          // Start at half
        }
      };
      a in this.$refs && (this.$refs[a].$el.hasAttribute(
        "data-anchor-x"
      ) && (l.spine.x = parseFloat(
        this.$refs[a].$el.getAttribute(
          "data-anchor-x"
        )
      )), this.$refs[a].$el.hasAttribute(
        "data-anchor-y"
      ) && (l.spine.y = parseFloat(
        this.$refs[a].$el.getAttribute(
          "data-anchor-y"
        )
      ))), n in this.$refs && (this.$refs[n].$el.hasAttribute(
        "data-anchor-x"
      ) && (l.label.x = parseFloat(
        this.$refs[n].$el.getAttribute(
          "data-anchor-x"
        )
      )), this.$refs[n].$el.hasAttribute(
        "data-anchor-y"
      ) && (l.label.y = parseFloat(
        this.$refs[n].$el.getAttribute(
          "data-anchor-y"
        )
      )));
      const u = {
        spine: {
          x: s.x + s.width * l.spine.x,
          y: s.y + s.height * l.spine.y
        },
        label: {
          x: i.x * l.label.x,
          y: i.y + i.height * l.label.y
        }
      };
      let c = 0, v = 0;
      if (a in this.$refs && (v = parseFloat(this.$refs[a].spaceBetween) || 0, this.$refs[a].$el.style.top = `${u.spine.y - u.label.y}px`, this.$refs[a].$el.style.left = `${u.spine.x - u.label.x + v}px`, this.$refs[a].render(), c = parseFloat(this.$refs[a].width) + parseFloat(this.$refs[a].contentSpacing) || 0), n in this.$refs) {
        const p = u.label.y - u.spine.y + v, m = u.label.x - u.spine.x - c - v, f = 180 + Math.atan2(p, m) * 180 / Math.PI, x = parseFloat(this.$refs[n].contentSpacing) * 2 - v, y = Math.hypot(m, p) - x;
        this.$refs[n].contentWidth = `${y}px`, this.$refs[n].$el.style.transform = `rotate( ${f}deg )`, this.$refs[n].render();
      }
    },
    spineSelected(t) {
      const r = `spine-label-${t.target.getAttribute("id")}`;
      r in this.$refs && (this.$refs[r].firstElementChild.checked = !this.$refs[r].firstElementChild.checked, this.spineLabelSelected({
        target: this.$refs[r].firstElementChild
      }));
    },
    // Highlight label or spine when hovering over the other
    spineHover(t) {
      this.unselectableSpineLocation.includes(t.spineLocation) || t.ref in this.$refs && this.$refs[t.ref].classList.toggle("hover", t.toggle);
    },
    spineHoverIn(t) {
      const e = t.target.getAttribute("id");
      this.spineHover({
        spineLocation: e,
        ref: `spine-label-${e}`,
        toggle: !0
      });
    },
    spineHoverOut(t) {
      const e = t.target.getAttribute("id");
      this.spineHover({
        spineLocation: e,
        ref: `spine-label-${e}`,
        toggle: !1
      });
    },
    spineLabelHoverIn(t) {
      const e = this.unconvertSpineLocation(
        t.target.firstElementChild.getAttribute("value")
      ).originalValue;
      this.spineHover({
        spineLocation: e,
        ref: `spine-${e}`,
        toggle: !0
      });
    },
    spineLabelHoverOut(t) {
      const e = this.unconvertSpineLocation(
        t.target.firstElementChild.getAttribute("value")
      ).originalValue;
      this.spineHover({
        spineLocation: e,
        ref: `spine-${e}`,
        toggle: !1
      });
    }
  },
  watch: {
    selectedValues: {
      handler(t) {
        const e = [...t];
        this.$emit("update:modelValue", e);
      },
      deep: !0
    },
    modelValue: {
      handler(t) {
        this.refresh(t);
      }
    }
  }
}, _C = { class: "flex overflow-x-auto" }, $C = {
  ref: "spine-container",
  viewBox: "0 0 200 900",
  width: "200px",
  height: "900px",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  class: "spine flex-none"
}, SC = {
  ref: "spine-main-diagnosis-Becken",
  x: "10",
  y: "848",
  class: "main-diagnosis"
}, CC = /* @__PURE__ */ O5('<path id="head" class="spine-misc" d="M116.1 143.4 C121.3 145.9 140.6 145.4 161.5 136.8 182.4 128.2 204.4 86.8 182.6 46.6 160.8 6.4 111.7 0.1 75.2 11 38.7 21.9 12.5 35.5 10 67.6 7.5 99.7 0.2 107.1 0.9 111.9 1.6 116.7 17 117.4 10.9 132.6 4.8 147.8 5.9 147.6 5.9 152.8 5.9 158 10.4 169.2 10 176.6 9.6 184 6.4 201.1 34.3 195 62.2 188.9 84.3 178 84.9 165.7 85.2 159.5 88.6 145.6 96 141.4 103.3 137.2 114.5 142.6 116.1 143.4 Z"></path><path class="spine-between" d="M124.3 739.4 C124.3 739.4 126 748.7 123.6 749.9 121.2 751.1 88.6 756.2 88.6 756.2 88.6 756.2 79.2 750.8 79.1 745.2 79 739.5 96.4 740.8 96.7 740.8 97 740.8 124.3 739.4 124.3 739.4 Z"></path><path class="spine-between" d="M118.4 702.1 C118.4 702.1 122.2 710.6 121.2 712 120.2 713.3 77.2 719.4 77.2 719.4 77.2 719.4 73.2 709 74.5 704.7 75.8 700.4 91.4 699.5 91.4 699.5 Z"></path><path class="spine-between" d="M114.2 666.2 C114.2 666.2 117.8 674.6 116.3 675.5 114.8 676.4 72.7 678.4 72.7 678.4 72.7 678.4 70.3 667.4 71.2 664.7 72.1 662 114.2 666.2 114.2 666.2 Z"></path><path class="spine-between" d="M114.8 632.5 C114.8 632.5 115.8 638.6 114.9 640.4 113.9 642.2 74.5 641.1 74.5 641.1 74.5 641.1 73.2 629.2 75 627.3 76.8 625.4 114.8 632.5 114.8 632.5 Z"></path><path class="spine-between" d="M120 601.6 C120 601.6 120.8 605.7 117.2 608.1 113.6 610.5 80.2 605.5 80.2 605.5 80.2 605.5 78.9 596.2 81.8 593.6 84.7 591.2 120 601.6 120 601.6 Z"></path><path class="spine-between" d="M128.5 570.3 C128.5 570.3 127.5 576.5 125.3 577.4 123.1 578.4 87.5 571.9 87.5 571.9 87.5 571.9 90 561.6 92.7 560.7 95.5 559.9 128.5 570.3 128.5 570.3 Z"></path><path class="spine-between" d="M137.4 537.5 C137.4 537.5 137.5 545.7 133.8 546.9 130 548.1 98.5 540.3 98.5 540.3 98.5 540.3 98.4 531.4 100.4 530.7 102.5 530.1 137.4 537.5 137.4 537.5 Z"></path><path class="spine-between" d="M144.9 505.2 C144.9 505.4 143.9 513.5 142.5 514 141.2 514.5 107.1 508.6 107.1 508.6 107.1 508.6 108.2 499.5 109.9 498.3 111.6 497.1 144.9 505.2 144.9 505.2 Z"></path><path class="spine-between" d="M152.1 475.3 C152.1 475.3 150.8 483.1 148.7 483.5 146.6 483.9 117 478.4 117 478.4 117 478.4 117 471 118.1 469.9 119.2 468.8 152.1 475.3 152.1 475.3 Z"></path><path class="spine-between" d="M158 447.9 C158 447.9 156.9 453.7 155.3 454.5 153.7 455.2 124.2 450.9 124.2 450.9 124.2 450.9 124.3 444.9 126.1 444.3 127.9 443.8 158 447.9 158 447.9 Z"></path><path class="spine-between" d="M160.4 420.6 C160.4 420.6 161.7 426.4 159.7 428.2 157.6 430 129.4 426.2 129.4 426.2 129.4 426.2 128 420.9 128.9 418.5 129.8 416.2 160.4 420.6 160.4 420.6 Z"></path><path class="spine-between" d="M160.3 393.6 C160.3 393.6 162.8 397.6 160.8 400.4 158.8 403.2 130.3 401.2 130.3 401.2 130.3 401.2 129 396.3 129.3 394.4 129.7 392.5 160.3 393.6 160.3 393.6 Z"></path><path class="spine-between" d="M158.8 367.9 C158.8 367.9 161.2 372.7 159 375.4 156.8 378.1 130.1 378.1 130.1 378.1 130.1 378.1 128.2 373.4 128.2 371.2 128.2 369 158.8 367.9 158.8 367.9 Z"></path><path class="spine-between" d="M151.9 341.6 C151.9 341.6 156.8 345.2 156.6 348.5 156.4 351.8 127.6 355.6 127.6 355.6 127.6 355.6 124.9 350 124.4 348 123.9 346 151.9 341.6 151.9 341.6 Z"></path><path class="spine-between" d="M144.9 320.5 C145 320.7 148.2 321.4 148.9 324.1 149.6 326.8 122.2 333.2 122.2 333.2 122.2 333.2 119.5 329 119.8 325.2 120.1 321.4 144.9 320.5 144.9 320.5 Z"></path><path class="spine-between" d="M142.9 299.5 C142.9 299.5 144.7 303.1 144.2 304.8 143.6 306.5 117.8 311.1 117.8 311.1 117.8 311.1 115.6 306.7 115.8 303.7 116 300.7 142.9 299.5 142.9 299.5 Z"></path><path class="spine-between" d="M138.2 278.2 C138.2 278.2 140.8 281.3 139.7 283.9 138.7 286.5 114.6 289.2 114.6 289.2 114.6 289.2 112 286.3 112 282.4 112 278.5 138.2 278.2 138.2 278.2 Z"></path><path class="spine-between" d="M110.6 261.7 L134.5 258.3 C134.5 258.3 136.6 261 136 263 135.3 265.1 110 268.9 110 268.9 110 268.9 108.2 263.8 108.2 261.9 108.3 260 110.6 261.7 110.6 261.7 Z"></path><path class="spine-between" d="M105.5 243.5 C105.5 243.7 104.8 247 107.4 248.6 110 250.2 130.8 243.3 130.8 243.3 130.8 243.3 130.4 240.2 129.2 239.5 128 238.8 105.5 243.5 105.5 243.5 Z"></path><path class="spine-between" d="M127.9 223.5 C127.9 223.5 127.5 227.5 127 228.8 126.5 230.1 105.5 231.7 105.5 231.7 105.5 231.7 103.4 230.2 103.7 224.8 104 219.4 127.9 223.5 127.9 223.5 Z"></path><path class="spine-between" d="M124.4 206.7 C124.4 206.7 125.9 206.3 126.1 207.2 126.3 208.1 126.5 209.4 126.3 210 126.2 210.6 104.1 212.3 104.1 212.3 104.1 212.3 102 211 102.8 207.4 103.6 203.7 124.4 206.7 124.4 206.7 Z"></path><path class="spine-between" d="M116.7 190.5 L123.6 191.1 C123.6 191.1 124.8 193.7 124.3 194.6 123.9 195.6 104 196.1 104 196.1 104 196.1 102.3 191.5 102.7 190.5 103.1 189.5 116.7 190.5 116.7 190.5 Z"></path><path class="spine-between" d="M103.7 174.9 C103.7 174.9 121.9 175.3 122.5 176.4 123.2 177.5 123.5 179.8 122.4 181.1 121.3 182.4 104.7 182.6 103.8 181.2 102.9 179.8 102.7 176 103.7 174.9 Z"></path><path class="spine-between" d="M104.5 159.6 C104.5 159.6 122.1 159.8 122.9 160.8 123.7 161.8 124.1 164.8 123.3 165.7 122.6 166.6 106.1 166.2 104.7 165.3 103.3 164.3 103.7 160.4 104.5 159.6 Z"></path>', 25), DC = {
  ref: "spine-main-diagnosis-C0",
  x: "145",
  y: "115",
  class: "main-diagnosis"
}, zC = {
  ref: "spine-main-diagnosis-C1",
  x: "92",
  y: "157",
  class: "main-diagnosis"
}, IC = {
  ref: "spine-main-diagnosis-C2",
  x: "92",
  y: "172",
  class: "main-diagnosis"
}, TC = {
  ref: "spine-main-diagnosis-C3",
  x: "92",
  y: "188",
  class: "main-diagnosis"
}, OC = {
  ref: "spine-main-diagnosis-C4",
  x: "92",
  y: "203",
  class: "main-diagnosis"
}, PC = {
  ref: "spine-main-diagnosis-C5",
  x: "92",
  y: "220",
  class: "main-diagnosis"
}, ZC = {
  ref: "spine-main-diagnosis-C6",
  x: "93",
  y: "240",
  class: "main-diagnosis"
}, EC = {
  ref: "spine-main-diagnosis-C7",
  x: "94",
  y: "259",
  class: "main-diagnosis"
}, AC = {
  ref: "spine-main-diagnosis-T1",
  x: "97",
  y: "279",
  class: "main-diagnosis"
}, NC = {
  ref: "spine-main-diagnosis-T2",
  x: "101",
  y: "300",
  class: "main-diagnosis"
}, HC = {
  ref: "spine-main-diagnosis-T3",
  x: "104",
  y: "320",
  class: "main-diagnosis"
}, BC = {
  ref: "spine-main-diagnosis-T4",
  x: "109",
  y: "343",
  class: "main-diagnosis"
}, VC = {
  ref: "spine-main-diagnosis-T5",
  x: "114",
  y: "365",
  class: "main-diagnosis"
}, RC = {
  ref: "spine-main-diagnosis-T6",
  x: "116",
  y: "389",
  class: "main-diagnosis"
}, YC = {
  ref: "spine-main-diagnosis-T7",
  x: "116",
  y: "412",
  class: "main-diagnosis"
}, FC = {
  ref: "spine-main-diagnosis-T8",
  x: "114",
  y: "437",
  class: "main-diagnosis"
}, jC = {
  ref: "spine-main-diagnosis-T9",
  x: "108",
  y: "463",
  class: "main-diagnosis"
}, WC = {
  ref: "spine-main-diagnosis-T10",
  x: "100",
  y: "490",
  class: "main-diagnosis"
}, UC = {
  ref: "spine-main-diagnosis-T11",
  x: "90",
  y: "521",
  class: "main-diagnosis"
}, GC = {
  ref: "spine-main-diagnosis-T12",
  x: "81",
  y: "553",
  class: "main-diagnosis"
}, KC = {
  ref: "spine-main-diagnosis-L1",
  x: "70",
  y: "583",
  class: "main-diagnosis"
}, qC = {
  ref: "spine-main-diagnosis-L2",
  x: "63",
  y: "618",
  class: "main-diagnosis"
}, XC = {
  ref: "spine-main-diagnosis-L3",
  x: "60",
  y: "655",
  class: "main-diagnosis"
}, JC = {
  ref: "spine-main-diagnosis-L4",
  x: "60",
  y: "695",
  class: "main-diagnosis"
}, QC = {
  ref: "spine-main-diagnosis-L5",
  x: "63",
  y: "735",
  class: "main-diagnosis"
}, eD = {
  ref: "spine-main-diagnosis-S1",
  x: "91",
  y: "774",
  class: "main-diagnosis"
}, tD = {
  ref: "spine-main-diagnosis-S2",
  x: "112",
  y: "795",
  class: "main-diagnosis"
}, rD = {
  ref: "spine-main-diagnosis-S3",
  x: "135",
  y: "807",
  class: "main-diagnosis"
}, LD = {
  ref: "spine-main-diagnosis-S4",
  x: "143",
  y: "822",
  class: "main-diagnosis"
}, nD = {
  ref: "spine-main-diagnosis-S5",
  x: "143",
  y: "842",
  class: "main-diagnosis"
}, oD = { class: "flex-none flex flex-col justify-between leading-5 mr-4 ml-14" }, sD = { class: "spine-category" }, aD = { class: "spine-selector" }, iD = ["name", "value"], lD = ["name", "value"], uD = ["name", "value"], dD = ["name", "value"], cD = ["name", "value"], hD = ["name", "value"], fD = ["name", "value"], pD = ["name", "value"], mD = ["innerHTML"], gD = { class: "spine-category" }, vD = { class: "spine-selector" }, yD = ["name", "value"], wD = ["name", "value"], bD = ["name", "value"], xD = ["name", "value"], kD = ["name", "value"], MD = ["name", "value"], _D = ["name", "value"], $D = ["name", "value"], SD = ["name", "value"], CD = ["name", "value"], DD = ["name", "value"], zD = ["name", "value"], ID = ["innerHTML"], TD = { class: "spine-category" }, OD = { class: "spine-selector" }, PD = ["name", "value"], ZD = ["name", "value"], ED = ["name", "value"], AD = ["name", "value"], ND = ["name", "value"], HD = ["innerHTML"], BD = { class: "spine-category" }, VD = { class: "spine-selector" }, RD = ["name", "value"], YD = ["name", "value"], FD = ["name", "value"], jD = ["name", "value"], WD = ["name", "value"], UD = ["name", "value"], GD = ["innerHTML"];
function KD(t, e, r, L, o, n) {
  const a = o0("Repeater");
  return b(), _("div", _C, [
    (b(), _("svg", $C, [
      d("path", {
        id: "Becken",
        ref: "spine-Becken",
        class: "spine-s",
        d: "M168.7 711.8 C163.8 695.7 144 670.6 125.1 664.1 106.3 657.6 83.9 678.5 81.8 681.8 79.7 685 48.2 711.8 35.3 720.7 22.3 729.5 15.6 748.1 27.1 756 38.6 764 41.8 772.8 46.5 785.7 51.2 798.7 58.9 806.9 54.5 810.4 50.1 813.9 52.4 817.5 51.8 825.4 51.2 833.4 28.5 841.3 21.8 849 15 856.7 25.9 870.8 39.5 879.9 53 889 69.8 899.9 103.4 892.6 137 885.2 134 862.9 130.8 855.5 127.6 848.1 122.8 843.4 132.3 832.2 141.8 821 134.1 821.9 121.7 811.9 109.3 801.9 112 786.9 114 777.4 116.1 768 121.4 764.4 147.3 771.8 173.1 779.2 172 755 172 755 172 755 173.7 727.8 168.7 711.8 Z M87.2 880.1 C70.6 879.4 67.3 877 62 870.4 56.7 863.8 54.9 860 51 855.4 47 850.8 50.8 841.9 57 841.3 63.2 840.6 69.6 841.7 69.6 841.7 69.6 841.7 91.7 847.9 97.2 859.4 102.7 870.8 103.8 880.7 87.2 880.1 Z",
        onClick: e[0] || (e[0] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[1] || (e[1] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[2] || (e[2] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", SC, " . ", 512),
      CC,
      d("path", {
        id: "C0",
        ref: "spine-C0",
        class: "spine-c",
        d: "M191 90.6 C182.2 93.5 157.2 115.9 147.2 128.8 137.8 141 117.4 130.4 110.6 135.2 107.5 137.3 107.1 139.1 107.6 140.4 111.8 141.3 115.2 143 116 143.3 121.2 145.8 140.5 145.3 161.4 136.7 174.5 131.4 188 113.3 191 90.6 Z",
        onClick: e[3] || (e[3] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[4] || (e[4] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[5] || (e[5] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", DC, " . ", 512),
      d("path", {
        id: "C1",
        ref: "spine-C1",
        class: "spine-c",
        d: "M124.4 148.4 C124.4 148.4 105 147.5 104.7 148.2 104.4 148.9 104 154.2 103.6 155.9 103.2 157.7 102.2 159.8 103.4 160.4 104.6 161 123.7 161.7 124.2 161.1 124.9 160.3 122.8 157.7 123.4 157.1 124.1 156.5 126.7 157.9 128.4 156.8 130.2 155.7 132.9 155 135.2 155.9 137.5 156.8 140.6 159.2 142.4 158.5 144.2 157.8 139.8 154.3 138.9 152.5 138 150.7 133.2 149.6 131.6 149.8 130 150 126.4 151.7 124.6 150.8 122.9 150 125.6 148.7 124.4 148.4 Z",
        onClick: e[6] || (e[6] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[7] || (e[7] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[8] || (e[8] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", zC, " . ", 512),
      d("path", {
        id: "C2",
        ref: "spine-C2",
        class: "spine-c",
        d: "M105.5 164 C105.5 164 124.1 164 124.4 164.2 124.7 164.4 123.5 165.6 124.5 166.3 125.5 167 132.3 164.4 135.7 166.4 139.1 168.4 143.4 173.2 142.5 173.9 141.6 174.6 138.6 174.1 136 172.6 133.3 171.1 131.3 171.1 129.4 171.9 127.5 172.7 125.4 172.8 124.1 172.5 122.8 172.2 122 172.7 122.9 174.7 123.8 176.6 124.4 177.2 121.7 177.1 118.9 176.9 105 177.2 103.5 176.8 102 176.4 103.5 172.3 103.6 170.8 103.7 169.3 103.8 164.9 104.4 164.5 104.9 163.9 105.5 164 105.5 164 Z",
        onClick: e[9] || (e[9] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[10] || (e[10] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[11] || (e[11] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", IC, " . ", 512),
      d("path", {
        id: "C3",
        ref: "spine-C3",
        class: "spine-c",
        d: "M118.4 178.7 C122.1 178.5 123.2 178.1 123.3 178.8 123.4 179.5 122.1 180.4 124.1 180.7 126.1 181 130.1 178.4 133.5 179.4 136.9 180.4 142.8 185.8 142.1 186.7 141.3 187.5 137.3 187 134.7 185.7 132.2 184.3 129.5 185.3 128 186.1 126.6 186.9 123.4 186.9 122.5 186.8 121.5 186.8 121.9 188.2 122.4 188.9 122.9 189.6 124.1 190.9 123.5 191.4 122.9 191.9 102.9 192.2 102.6 191.9 102.3 191.6 103.3 183.9 103.3 182.8 103.2 181.8 103 179.7 103.7 179.4 104.2 179.2 114.7 178.9 118.4 178.7 Z",
        onClick: e[12] || (e[12] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[13] || (e[13] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[14] || (e[14] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", TC, " . ", 512),
      d("path", {
        id: "C4",
        ref: "spine-C4",
        class: "spine-c",
        d: "M104.6 194.1 C104.6 194.1 118.4 193.4 121.1 193.3 123.8 193.2 125.8 192.5 125.8 193.2 125.8 193.9 124.6 195.9 127.5 195.8 130.3 195.7 135.2 193.1 138.9 194.8 142.6 196.5 146.6 201.3 146.7 202 146.8 202.7 144.5 203.9 140.4 201.8 136.3 199.7 133.6 200.2 131.5 201.3 129.4 202.4 127.2 202.5 126.4 202.4 125.7 202.3 123.5 202.2 124.6 204.1 125.7 206 126.8 208 125.3 207.8 123.8 207.6 104 208.6 102.8 207.9 101.7 207.2 103.4 197.4 103.4 196.6 103.4 195.8 103 194.8 103.7 194.5 104.3 194.1 104.6 194.1 104.6 194.1 Z",
        onClick: e[15] || (e[15] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[16] || (e[16] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[17] || (e[17] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", OC, " . ", 512),
      d("path", {
        id: "C5",
        ref: "spine-C5",
        class: "spine-c",
        d: "M104.6 211.4 C104.6 211.4 126.6 208.8 126.9 209.1 127.2 209.4 125.6 210.5 127.2 211.3 128.8 212.1 132.5 210.6 133.8 210.1 135.1 209.6 139.5 208.3 144.8 212.6 150.1 216.9 149.9 218.3 147.7 218.5 145.5 218.7 141.2 216.3 139.4 216.3 137.6 216.3 134.3 216.7 132.8 217.7 131.3 218.6 129.3 218.7 128 218.6 126.7 218.5 125.3 218.9 126.5 220.6 127.7 222.3 128.7 223.8 127.7 224.2 126.7 224.6 103.6 226.7 103.2 226.1 102.8 225.5 103.6 216.4 103.6 215.5 103.6 214.5 103.3 212.2 103.7 211.8 104.2 211.4 104.6 211.4 104.6 211.4 Z",
        onClick: e[18] || (e[18] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[19] || (e[19] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[20] || (e[20] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", PC, " . ", 512),
      d("path", {
        id: "C6",
        ref: "spine-C6",
        class: "spine-c",
        d: "M105.3 229.6 C105.3 229.6 127.6 225.3 127.7 225.9 127.8 226.5 126.3 228.5 128.5 228.5 130.7 228.5 134.7 226.1 136.6 225.7 138.5 225.3 142.7 225.5 146.7 229 150.7 232.6 151.4 232.8 149.3 233.5 147.2 234.2 142.1 232 140 232 137.9 232 135.8 233 134 234.4 132.2 235.8 128.8 234.9 127.9 235.7 126.9 236.5 128.7 238.1 129.1 238.8 129.5 239.5 130.7 241 128.3 241.2 125.9 241.5 105.9 244.8 105.1 244.3 104.3 243.8 105 233.6 104.8 233 104.6 232.5 104.1 229.9 105.3 229.6 Z",
        onClick: e[21] || (e[21] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[22] || (e[22] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[23] || (e[23] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", ZC, " . ", 512),
      d("path", {
        id: "C7",
        ref: "spine-C7",
        class: "spine-c",
        d: "M108 246.8 C108 246.8 132.3 242.2 132.6 242.4 132.9 242.6 131.8 244.1 132.6 244.8 133.3 245.4 134.6 246.4 140.3 243.4 146 240.4 150.5 244.1 153.6 246.1 156.7 248.1 159.1 249.4 157.8 250.6 156.5 251.8 154.6 251.3 150.3 250.3 146 249.3 143.6 249.2 141.6 250.6 139.6 252 137.4 253.3 135.5 253.3 133.5 253.3 131.5 253.4 132.4 254.7 133.3 256 135.9 259 134.7 259.2 133.5 259.4 108.5 263.7 107.9 263 107.3 262.3 107.6 251 107.3 250.1 107.1 249.2 106.2 247.1 108 246.8 Z",
        onClick: e[24] || (e[24] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[25] || (e[25] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[26] || (e[26] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", EC, " . ", 512),
      d("path", {
        id: "T1",
        ref: "spine-T1",
        class: "spine-t",
        d: "M112.1 266.1 C112.1 266.1 136.8 261.1 136.8 261.8 136.8 262.5 135.1 264.8 138.5 265.1 141.8 265.4 144.2 261.1 145.4 258.6 146.6 256.1 153.2 253.9 154.7 254.9 156.1 255.9 155.1 258.9 154.4 259.9 153.7 260.9 153.1 262.6 156.2 262.4 159.3 262.2 164.3 258.9 165.8 261.7 167.3 264.5 167.2 274.7 166.7 276.2 166.2 277.7 160.2 280.6 154.1 277.9 150.9 276.5 153.6 283.6 150.9 284.9 150 285.3 148.4 283.5 147.4 280.6 146.4 277.7 144.5 273.3 141.2 273.2 137.9 273.1 135.6 273.1 136.6 274.9 137.6 276.7 139.4 278.1 139.1 279 138.8 279.9 112.8 284.2 111.9 283.6 111 283 109.6 269.9 109.7 268.9 109.8 267.9 110.9 266.3 112.1 266.1 Z",
        onClick: e[27] || (e[27] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[28] || (e[28] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[29] || (e[29] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", AC, " . ", 512),
      d("path", {
        id: "T2",
        ref: "spine-T2",
        class: "spine-t",
        d: "M115.4 286.3 C115.4 286.3 140.2 281.6 140.8 282 141.4 282.4 139.6 283.6 141 284.8 142.4 286 145.9 286 147.2 284 148.5 282.1 151.7 276.2 157.4 275.3 163.1 274.4 159.9 279.4 158.9 281 157.9 282.6 160.9 282.9 165.5 281.9 170.1 281 172.5 281.3 173 287.6 173.5 293.8 173.1 298.6 169.3 299.7 162.7 301.5 160.4 297.1 158.9 298.1 157.6 299 159.2 306.4 156.8 306 154.4 305.6 153.9 305.3 151.7 301 149.5 296.7 148.2 293.9 145.1 293.8 142 293.6 139.6 293.9 141.1 296.6 142.6 299.3 143.8 300.4 142.3 300.7 140.8 301 115.6 305.2 114.8 304.6 114 304 114.6 292.3 114.1 291.2 113.6 290.1 113 286.8 115.4 286.3 Z",
        onClick: e[30] || (e[30] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[31] || (e[31] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[32] || (e[32] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", NC, " . ", 512),
      d("path", {
        id: "T3",
        ref: "spine-T3",
        class: "spine-t",
        d: "M118.9 307.9 C118.9 307.9 144.2 303.6 144.6 303.9 144.9 304.2 142.9 306.8 145.6 307.3 148.3 307.9 150.7 306.1 153.6 301.6 156.5 297.1 163.4 296.5 164.4 297.9 165.3 299.3 164.5 301.4 163.1 302.8 161.7 304.2 164 306.2 167.2 305.1 170.4 304 177 300.6 176.6 310.1 176.3 319.6 174.8 322.2 170.7 322.8 168.6 323.1 163.8 318.9 162.2 319.4 160.7 319.8 162.3 324.9 161.8 325.6 160.9 327.1 157.6 328.5 156.8 327.1 156 325.7 154.8 319.1 151.6 317.3 148.3 315.5 143.6 315.2 143.7 316.9 143.8 318.6 148.2 321.7 145.9 322.8 143.6 323.9 119.2 326.8 118.2 326.3 117.2 325.8 117.8 315.4 117.8 313.8 117.8 312.2 116.5 309.7 117.1 308.8 117.8 307.8 118.9 307.9 118.9 307.9 Z",
        onClick: e[33] || (e[33] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[34] || (e[34] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[35] || (e[35] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", HC, " . ", 512),
      d("path", {
        id: "T4",
        ref: "spine-T4",
        class: "spine-t",
        d: "M123.4 329.6 C123.4 329.6 149.3 323 149.5 323.6 149.7 324.2 147.7 327.1 151.8 327.1 155.9 327.1 158.4 319.8 160 318.3 161.7 316.8 168.9 312.2 170.3 316.9 171.1 319.5 163.7 323.1 170.7 323.4 175 323.6 178.9 317.8 181.6 322.2 184.3 326.6 184.6 336.5 182.8 338.4 181 340.3 176.5 342.2 175.2 341.6 173.9 341 171.6 338.5 169.3 339.3 167 340.1 167.6 343.9 168.5 346.7 169.4 349.5 165.7 352.1 164.9 351 164.1 350 163.4 342.3 159.3 338.4 155.2 334.5 149.2 335.6 149.5 337 149.8 338.3 154.2 342.2 152.6 342.9 151.1 343.6 124.6 349.3 123.7 349 122.8 348.7 121.9 340 121.9 337.1 121.9 334.2 120.8 331 121.3 330.4 122.1 329.7 123.4 329.6 123.4 329.6 Z",
        onClick: e[36] || (e[36] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[37] || (e[37] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[38] || (e[38] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", BC, " . ", 512),
      d("path", {
        id: "T5",
        ref: "spine-T5",
        class: "spine-t",
        d: "M128.5 352 C128.5 352 156.4 346.8 156.8 347.8 157.2 348.8 155.3 350.5 158.6 351.4 162 352.4 163.5 349.3 166 346 168.5 342.7 173.7 340 176.5 340.1 179.3 340.3 179.9 342.9 178 345.1 176.1 347.3 176.8 349.7 179.6 349.2 182.4 348.7 189.5 344.1 191.4 349.5 193.3 354.9 192.2 364.8 190.2 366.2 188.2 367.6 184.2 369 180.6 366.9 177 364.8 173.9 365 173.9 368.7 174 372.5 174.3 376 172.5 376.4 170.7 376.8 169.2 370.8 168.4 368.2 167.6 365.6 163.7 360.7 161 360.3 158.3 359.9 154.4 360.5 156.4 363.4 158.4 366.3 159.9 367.7 158.2 368.3 156.5 368.9 127.9 372.4 127.3 371.9 126.6 371.3 127.1 358.1 127.1 356.8 127.1 355.5 126.4 352.9 126.9 352.4 127.6 352 128.5 352 128.5 352 Z",
        onClick: e[39] || (e[39] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[40] || (e[40] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[41] || (e[41] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", VC, " . ", 512),
      d("path", {
        id: "T6",
        ref: "spine-T6",
        class: "spine-t",
        d: "M131 376.2 C131 376.2 159.3 373.1 159.9 373.8 160.5 374.5 158.3 376.2 160.6 377.4 162.9 378.6 166.3 378.2 167.6 375.5 168.9 372.8 174.2 367.5 180.1 367.8 186.1 368 180 373.5 179.7 374.8 179.4 376.1 181.1 377.3 185.3 376.8 189.4 376.4 193.6 373 194.6 379.5 195.6 386 193.8 394.1 190.8 395.6 187.8 397.1 183.8 396.4 182.3 395.2 180.8 394 179.4 392.2 177.2 393.6 175 395 175.5 398.8 175.5 399.8 175.5 400.8 172.7 406.5 171.7 403.2 170.8 399.9 170.9 392.5 166.8 389.4 162.7 386.3 157.5 386.7 158.3 388.7 159.1 390.7 162 393.9 160.2 394.6 158.4 395.3 130.1 397.1 128.7 396.2 127.4 395.3 129.8 380.7 129.6 379.9 129.6 379.1 129.1 376.6 131 376.2 Z",
        onClick: e[42] || (e[42] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[43] || (e[43] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[44] || (e[44] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", RC, " . ", 512),
      d("path", {
        id: "T7",
        ref: "spine-T7",
        class: "spine-t",
        d: "M131.4 399.5 C131.4 399.5 161.4 398.9 161.8 399.7 162.2 400.5 159.5 402.1 163.1 403.9 166.7 405.7 170.1 401.6 172.1 399.2 174.1 396.8 182.4 393.4 185 394.9 187.6 396.4 184.2 400.8 183.3 401.9 182.4 403 183.2 405.5 189.9 404.8 196.6 404.1 198.1 404.7 198 410.3 197.9 415.8 196.8 423.5 192.6 424.8 188.5 426.1 186 425.5 183.4 423.4 180.7 421.2 178.3 421.2 177.2 422.8 176.1 424.4 177.5 428.4 176.8 429.6 176.1 430.8 171.9 431.1 171.4 427.3 170.9 423.5 169.5 416.9 166.2 415 162.9 413.1 158.4 412.9 158.9 414.6 159.3 416.3 161.7 420.1 160.8 421.1 159.9 422.1 128.6 421.2 127.5 420.4 126.3 419.6 129.5 405.3 129.5 404.3 129.7 403.3 129.2 399.5 131.4 399.5 Z",
        onClick: e[45] || (e[45] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[46] || (e[46] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[47] || (e[47] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", YC, " . ", 512),
      d("path", {
        id: "T8",
        ref: "spine-T8",
        class: "spine-t",
        d: "M130.1 425.3 C130.1 425.3 160.9 426 160.9 427 161 427.9 158.9 429 161.2 430.8 163.6 432.6 167.2 431.7 169.7 428.2 172.2 424.7 179.5 422.6 183.8 423.4 188.1 424.2 182.8 429.4 181.5 430.5 180.2 431.6 182.3 434 185.6 433.4 188.9 432.8 193.8 431.2 195.6 436.1 197.5 441 193.1 451.8 192.2 452.7 191.4 453.6 183.4 455.2 181.9 453.5 180.4 451.8 178.8 449.9 176.8 449.9 174.8 449.9 173.9 452.4 173.9 454.7 173.9 457 168.5 458.7 168.5 454.3 168.5 449.9 166.2 444.2 164.9 442.7 163.5 441.2 157.9 440.3 156.9 441.3 156 442.2 158.9 445.8 158.8 447.4 158.7 449 157.3 448.5 155.7 448.5 154.1 448.5 125.6 447.2 124.8 445.8 124.1 444.4 128.1 429.7 128.1 428.7 128.1 427.7 128.5 425.3 130.1 425.3 Z",
        onClick: e[48] || (e[48] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[49] || (e[49] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[50] || (e[50] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", FC, " . ", 512),
      d("path", {
        id: "T9",
        ref: "spine-T9",
        class: "spine-t",
        d: "M124.3 450.1 C124.3 450.1 156.3 453 156.5 453.6 156.7 454.3 154.7 455 156 457 157.3 459 161.1 459.7 164.4 456.8 167.7 453.9 170 451.1 175.5 451 181 450.9 183.8 451.9 181.4 455.4 179 458.9 175.5 458.7 178.4 461 181.3 463.3 187 461.2 190.2 461.8 193.4 462.4 193.3 466.9 192.7 470.3 192.1 473.7 189.9 483 184.9 483.6 179.9 484.2 177.7 482.7 175.7 480.2 173.7 477.7 171.1 477.5 169.8 479.8 168.5 482 169.4 483.7 168.3 484.7 167.1 485.7 163.2 486 163.3 483.5 163.4 481 163.3 474.3 161.8 472.2 160.3 470 155.7 468.1 153.5 468.1 151.2 468.1 151.6 469.6 152.5 471.5 153.4 473.4 154.8 476.5 152 476.4 149.2 476.3 118.8 472.7 118.2 471.6 117.6 470.5 122.2 455.5 122.3 454.2 122.1 452.8 122.3 450.2 124.3 450.1 Z",
        onClick: e[51] || (e[51] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[52] || (e[52] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[53] || (e[53] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", jC, " . ", 512),
      d("path", {
        id: "T10",
        ref: "spine-T10",
        class: "spine-t",
        d: "M116.3 477.4 C116.3 477.4 149.6 481.9 150 482.6 150.4 483.3 148 483.5 148.8 485.5 149.6 487.5 154.6 490 157.5 487.2 160.4 484.4 164.6 481 169.1 481 173.6 481 177.9 481.1 176.8 484.8 175.7 488.4 169.8 489.2 172.9 491.4 176 493.7 184.8 492.1 186 493.2 187.3 494.3 189.4 495.1 187.5 501.8 185.6 508.5 183 515.1 179.8 515.7 176.5 516.3 173 516 170.7 513.4 168.4 510.8 167.2 509.8 164.9 509.9 162.6 510 161.9 515.6 161.4 517.2 160.9 518.9 156.2 519.4 156.2 515.2 156.2 511 155.6 504.1 154 501.6 152.4 499.1 146.4 497 145.1 497.6 143.8 498.2 145 501 145.4 502.4 145.8 503.8 146.4 506.9 144.2 506.3 141.9 505.7 109.3 500.8 108.9 499.4 108.5 498 114.3 482 114.3 481 114.1 480.1 114.6 477.5 116.3 477.4 Z",
        onClick: e[54] || (e[54] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[55] || (e[55] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[56] || (e[56] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", WC, " . ", 512),
      d("path", {
        id: "T11",
        ref: "spine-T11",
        class: "spine-t",
        d: "M107.9 508 C107.9 508 143.2 512.7 143.4 513.4 143.6 514.1 140 515.1 142.5 517.4 145 519.7 149.2 519.8 151.7 517.8 154.2 515.8 157.3 511.6 162.9 511.6 168.5 511.6 171.7 511 171.6 515.3 171.5 519.6 165.4 518.7 166.7 521.9 168 525.1 179.3 523 181.2 524.7 183.1 526.4 182.9 530.3 182.2 534.5 181.5 538.7 178.3 546.7 175 547.6 171.6 548.5 167.7 549.1 164 545.3 160.3 541.4 158.6 540.7 157.2 542.6 155.8 544.5 155.4 550.1 153.1 551.5 150.7 552.9 149 551.4 149.2 544.8 149.5 538.2 147 532.2 144.9 530.7 142.8 529.2 137 528.2 136.9 529.9 136.8 531.6 139.6 536.5 138.5 537.6 138 538.2 127.7 536.5 117.8 534.8 108.7 533.3 99.9 531.7 99.6 531.1 98.9 529.8 104.8 513.8 104.8 512.2 104.9 510.8 105.4 508 107.9 508 Z",
        onClick: e[57] || (e[57] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[58] || (e[58] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[59] || (e[59] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", UC, " . ", 512),
      d("path", {
        id: "T12",
        ref: "spine-T12",
        class: "spine-t",
        d: "M100 539.7 C100 539.7 134.9 545.7 135.3 546.5 135.7 547.3 132.6 548.1 133.9 549.9 135.2 551.7 139 554.5 142.5 551.7 146 548.9 150.6 545.3 156 545.5 161.5 545.7 164.8 546.3 163.3 549.9 161.8 553.5 156.6 552.2 158.1 555.5 159.6 558.8 167.2 558.3 169.1 558.3 171 558.3 175.2 558.3 174.2 565.9 173.2 573.5 168.8 581.3 165.8 582 162.8 582.7 158.6 582.8 156.2 580.8 153.8 578.9 149.5 575.1 148.4 576 147.3 576.9 147.8 583.8 145.3 584 142.8 584.2 140.3 581 139.8 574.6 139.2 568.1 137.3 564.9 134.3 563.6 131.3 562.3 128.1 561.4 128.1 563.2 128.1 565 130.9 570.2 129.1 571 128.3 571.4 119.8 569.5 111 567.6 101.3 565.6 91.2 563.6 90.8 562.7 90 561.2 96.8 546 96.8 544.4 96.8 542.8 97.3 539.7 100 539.7 Z",
        onClick: e[60] || (e[60] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[61] || (e[61] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[62] || (e[62] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", GC, " . ", 512),
      d("path", {
        id: "L1",
        ref: "spine-L1",
        class: "spine-l",
        d: "M89.3 570.4 C89.3 570.4 125.2 575.9 126.1 576.6 127 577.3 124.7 577.7 125 579.6 125.3 581.5 130.5 584.3 133.7 582 137 579.7 140.5 575.2 146.7 575.1 152.9 575 156 574.5 155.9 578.9 155.8 583.3 150.4 581.2 150.4 584.2 150.4 587.2 154.6 588.1 159 588 163.4 587.9 167.9 587.3 167.8 593.7 167.6 600 163.2 611.1 160.2 612.6 157.2 614.1 150.9 613.7 148.9 611.9 147 610.1 144.6 605.1 142.8 605.6 141 606.1 140.5 611.6 138.7 612.8 136.9 614.1 132.9 613.2 132.6 609.2 132.3 605.2 131.5 599 129.7 596.8 127.9 594.6 122 592.9 120.5 593 119 593.1 119.9 595.7 120.4 598.4 120.9 601.1 121.1 602.4 119.1 602.3 117.1 602.2 80.6 595.5 80.2 594.6 79.8 593.7 80.3 591.7 81 589.3 81.7 586.9 86 576.1 86 574.2 86 572.3 86.7 570 89.3 570.4 Z",
        onClick: e[63] || (e[63] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[64] || (e[64] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[65] || (e[65] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", KC, " . ", 512),
      d("path", {
        id: "L2",
        ref: "spine-L2",
        class: "spine-l",
        d: "M80.8 604 C80.8 604 117.7 605.9 118.7 607.1 119.6 608.4 116.7 608.7 117.8 610.5 119 612.3 124.3 615.2 128.4 610.6 132.5 606 138.2 602.9 142.6 603 147 603.1 149.1 603.1 149 606.6 148.9 610.1 143.2 611 143.9 613.8 144.6 616.6 152.8 616 154.6 615.8 156.3 615.6 161.8 614.5 162.2 620.3 162.6 626.2 159.1 639.6 155.1 640.9 151.1 642.2 147.5 642.3 145.3 641 143.1 639.7 138.5 637.3 136.7 639.7 134.9 642.1 134 647.8 130.7 647.2 127.3 646.5 127.6 636 126 630.7 124.3 625.4 117.5 623.9 115.6 623.9 113.7 624 113.2 624.8 114.5 627.9 115.8 631 116.8 634 113.9 633.8 112.5 633.7 103.4 632.5 94.3 631.6 84.5 630.6 74.6 630 74.3 629.3 73.7 628 78.4 610.6 78.4 608.8 78.4 607 78.3 604 80.8 604 Z",
        onClick: e[66] || (e[66] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[67] || (e[67] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[68] || (e[68] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", qC, " . ", 512),
      d("path", {
        id: "L3",
        ref: "spine-L3",
        class: "spine-l",
        d: "M76.8 638.6 C76.8 638.6 116.1 638 116.6 638.6 117 639.2 114.2 640.7 116.2 643.1 118.2 645.5 123.9 646 127.7 641.1 131.5 636.2 135.7 632.5 141.1 632.4 146.5 632.3 148.4 631.8 148.6 635.4 148.7 638.9 144.3 640.5 144 642.8 143.7 645.1 149.1 646.4 153.1 645.3 157.1 644.2 163.8 642.8 164.3 649.7 164.8 656.5 162.8 669.7 158 671.8 153.2 673.9 151.3 673.7 148 672.1 144.6 670.5 140.5 669.2 138.7 671.8 136.9 674.4 138.5 680 134.7 680.6 130.9 681.2 129.3 678.4 128.5 669.9 127.7 661.4 122.6 658.7 119.4 657.5 116.1 656.3 111.8 656.5 112.5 658.7 113.2 661 117.5 666.9 114.9 667.6 113.7 667.9 104.1 667.2 94.3 667 82.9 666.7 70.9 666.8 70.6 666.3 69.9 665.5 73.9 646.5 73.7 644.2 73.5 641.9 73.9 638.6 75.4 638.6 Z",
        onClick: e[69] || (e[69] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[70] || (e[70] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[71] || (e[71] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", XC, " . ", 512),
      d("path", {
        id: "L4",
        ref: "spine-L4",
        class: "spine-l",
        d: "M74.4 675.9 C74.4 675.9 91.6 675.5 99.7 674.5 107.8 673.5 118.6 672 118.4 673.3 118.2 674.6 116 676.9 118.5 678 121 679.2 127 680.6 130.6 674 134.2 667.4 141.4 664.2 146.8 664.2 152.2 664.2 152.7 667.9 150.7 670.4 148.7 672.9 145.6 674.9 148.1 676.7 150.6 678.5 157.3 676.7 159.4 676.3 161.4 675.9 167.5 674.5 168.4 680.1 169.3 685.7 169.7 701.5 164.4 704.4 159.1 707.3 155.5 707 152.9 705.6 150.3 704.2 145.9 703.2 145.2 704.3 144.5 705.4 142.3 713.7 139.8 715.1 137.3 716.5 134.4 715.4 134.1 711.1 133.7 706.7 131.1 698.1 127.2 694.6 123.3 691.1 116.4 692.2 115.5 692.8 114.6 693.4 115.7 695.9 116.7 697.4 117.7 698.8 119.5 701.7 118.9 702.9 118.6 703.5 107.5 703.7 96.4 704.2 85 704.8 73.5 705.7 73.1 705.5 72.4 705.2 71.8 705.9 71.9 700 72 694.1 72 681.4 71.8 679.6 71.7 677.9 71.4 676 74.4 675.9 Z",
        onClick: e[72] || (e[72] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[73] || (e[73] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[74] || (e[74] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", JC, " . ", 512),
      d("path", {
        id: "L5",
        ref: "spine-L5",
        class: "spine-l",
        d: "M79.3 716.5 C79.3 716.5 90.2 714.7 100.9 712.9 111.1 711.2 121.1 709.7 121.4 709.9 122 710.3 121.9 710.9 121.3 712.5 120.7 714.1 126.7 718.6 130.8 714.5 134.9 710.5 137.4 701.9 146.1 700.1 154.8 698.3 157.3 701.9 153.2 706.6 149.2 711.2 153.4 712.8 157.5 712 161.5 711.2 168.4 706.6 171.3 710.9 174.2 715.2 174.4 734.1 172.1 736.7 169.8 739.3 162.6 742.6 157.8 739.1 153 735.6 147.9 735.7 147.3 739.4 146.7 743.2 150.6 750.1 147.9 752.4 145.2 754.8 140.9 754.8 140.4 747.3 139.8 739.8 134.2 730.6 129.6 729.3 125 728 120.4 729 121 731.2 121.6 733.4 127.3 739.5 124.5 740.5 123.4 740.9 116.1 741.3 107.7 742.3 94.8 743.8 79.1 745.9 78.5 745.4 77.5 744.7 76.7 723 76.3 721.5 76 720.3 75.7 717 79.3 716.5 Z",
        onClick: e[75] || (e[75] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[76] || (e[76] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[77] || (e[77] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", QC, " . ", 512),
      d("path", {
        id: "S1",
        ref: "spine-S1",
        class: "spine-s",
        d: "M109.8 782.1 C109.8 782.1 134.4 771.9 134.7 764.2 134.6 764.2 134.6 764.1 134.5 764.1 133 762.9 133 758 134.7 753.6 136.4 749.2 128.5 747.6 128.5 747.6 128.5 747.6 127.6 747.4 126 747.5 125.5 747.6 124.8 747.8 124 748.2 124.1 747.6 117.7 750 111.7 751.9 105.7 753.8 89.5 754.8 89.5 754.8 89.5 754.8 87 755.6 87.8 757.1 88.6 758.6 92.3 760.4 98.6 763.5 104.9 766.6 104.8 773.5 104.9 774.2 105.1 775 106.3 778.8 109.8 782.1 Z",
        onClick: e[78] || (e[78] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[79] || (e[79] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[80] || (e[80] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", eD, " . ", 512),
      d("path", {
        id: "S2",
        ref: "spine-S2",
        class: "spine-s",
        d: "M154.5 771.3 C154.3 768.3 155.2 765.6 154.3 765.2 153.5 764.8 143.9 763.3 142.2 761.7 140.5 760.2 141 757.9 140.5 757.8 140.5 757.8 134.1 760.8 134.6 764.1 134.3 771.8 109.7 782 109.7 782 109.7 782 109.7 783.8 116.6 786.2 121.7 787.9 127.4 790.4 132.6 793.1 140.8 787.9 151.7 779 156.9 774.6 155.5 773.8 154.6 772.8 154.5 771.3 Z",
        onClick: e[81] || (e[81] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[82] || (e[82] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[83] || (e[83] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", tD, " . ", 512),
      d("path", {
        id: "S3",
        ref: "spine-S3",
        class: "spine-s",
        d: "M175.7 786.2 C172.7 780.2 168.5 779.9 163.2 777.5 160.6 776.4 158.5 775.6 157 774.7 151.8 779 140.9 788 132.7 793.2 136.6 795.3 140.2 797.6 143 799.8 146.4 802.5 149.4 805.5 151.5 808.8 158.9 805.1 168.9 798.5 174.1 794.9 174.2 792.3 178.1 791.1 175.7 786.2 Z",
        onClick: e[84] || (e[84] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[85] || (e[85] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[86] || (e[86] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", rD, " . ", 512),
      d("path", {
        id: "S4",
        ref: "spine-S4",
        class: "spine-s",
        d: "M156.3 827.1 L171.9 823.2 C173 821.7 176 816.3 176.1 810.6 176.3 804 177.8 801.6 174.9 797.1 174.3 796.2 174.1 795.5 174.2 794.9 169 798.5 159 805.2 151.6 808.8 153.6 811.8 154.8 815.1 154.8 818.6 154.7 822.2 155.4 825 156.3 827.1 Z",
        onClick: e[87] || (e[87] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[88] || (e[88] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[89] || (e[89] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", LD, " . ", 512),
      d("path", {
        id: "S5",
        ref: "spine-S5",
        class: "spine-s",
        d: "M156.3 827.1 C156.3 827.1 158.3 830.5 159.3 831.4 160.8 832.7 159.5 833.7 159.5 834.5 158.7 835.5 157.1 837.6 155.8 838.1 154 838.9 149.2 855.3 150.4 856.8 151.6 858.3 158.3 857.3 162.6 850.3 166.9 843.3 168.7 838.9 169.1 836.3 169.3 834.8 169.5 833.4 169.7 832.4 170.8 830.7 171.6 825.6 171.9 823.2 Z",
        onClick: e[90] || (e[90] = (...s) => n.spineSelected && n.spineSelected(...s)),
        onMouseenter: e[91] || (e[91] = (...s) => n.spineHoverIn && n.spineHoverIn(...s)),
        onMouseleave: e[92] || (e[92] = (...s) => n.spineHoverOut && n.spineHoverOut(...s))
      }, null, 544),
      d("text", nD, " . ", 512)
    ], 512)),
    d("div", oD, [
      d("div", sD, [
        d("div", aD, [
          d("label", {
            ref: "spine-label-C0",
            onMouseenter: e[94] || (e[94] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[95] || (e[95] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.c[0],
              onChange: e[93] || (e[93] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, iD),
            d("span", null, V(o.spineLocations.c[0]), 1),
            Z(a, {
              ref: "spine-connector-from-label-C0",
              class: "connector label",
              "data-anchor-y": "0.8"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-C1",
            onMouseenter: e[97] || (e[97] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[98] || (e[98] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.c[1],
              onChange: e[96] || (e[96] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, lD),
            d("span", null, V(o.spineLocations.c[1]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-C1",
              class: "connector spine",
              width: "30px"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-C1",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-C2",
            onMouseenter: e[100] || (e[100] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[101] || (e[101] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.c[2],
              onChange: e[99] || (e[99] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, uD),
            d("span", null, V(o.spineLocations.c[2]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-C2",
              class: "connector spine",
              width: "40px"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-C2",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-C3",
            onMouseenter: e[103] || (e[103] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[104] || (e[104] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.c[3],
              onChange: e[102] || (e[102] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, dD),
            d("span", null, V(o.spineLocations.c[3]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-C3",
              class: "connector spine",
              width: "50px"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-C3",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-C4",
            onMouseenter: e[106] || (e[106] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[107] || (e[107] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.c[4],
              onChange: e[105] || (e[105] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, cD),
            d("span", null, V(o.spineLocations.c[4]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-C4",
              class: "connector spine",
              width: "55px"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-C4",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-C5",
            onMouseenter: e[109] || (e[109] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[110] || (e[110] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.c[5],
              onChange: e[108] || (e[108] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, hD),
            d("span", null, V(o.spineLocations.c[5]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-C5",
              class: "connector spine",
              width: "60px",
              "data-anchor-y": "0.2"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-C5",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-C6",
            onMouseenter: e[112] || (e[112] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[113] || (e[113] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.c[6],
              onChange: e[111] || (e[111] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, fD),
            d("span", null, V(o.spineLocations.c[6]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-C6",
              class: "connector spine",
              width: "65px",
              "data-anchor-y": "0.2"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-C6",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-C7",
            onMouseenter: e[115] || (e[115] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[116] || (e[116] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.c[7],
              onChange: e[114] || (e[114] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, pD),
            d("span", null, V(o.spineLocations.c[7]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-C7",
              class: "connector spine",
              width: "65px",
              "data-anchor-y": "0.2"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-C7",
              class: "connector label"
            }, null, 512)
          ], 544)
        ]),
        d("div", {
          ref: "spine-stack-c",
          class: "spine-stack",
          "data-procedure-category": "c",
          innerHTML: o.procedureLayout.c
        }, null, 8, mD)
      ]),
      d("div", gD, [
        d("div", vD, [
          d("label", {
            ref: "spine-label-T1",
            onMouseenter: e[118] || (e[118] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[119] || (e[119] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[0],
              onChange: e[117] || (e[117] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, yD),
            d("span", null, V(o.spineLocations.t[0]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T1",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T2",
            onMouseenter: e[121] || (e[121] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[122] || (e[122] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[1],
              onChange: e[120] || (e[120] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, wD),
            d("span", null, V(o.spineLocations.t[1]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T2",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T3",
            onMouseenter: e[124] || (e[124] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[125] || (e[125] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[2],
              onChange: e[123] || (e[123] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, bD),
            d("span", null, V(o.spineLocations.t[2]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T3",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T4",
            onMouseenter: e[127] || (e[127] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[128] || (e[128] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[3],
              onChange: e[126] || (e[126] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, xD),
            d("span", null, V(o.spineLocations.t[3]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T4",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T5",
            onMouseenter: e[130] || (e[130] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[131] || (e[131] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[4],
              onChange: e[129] || (e[129] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, kD),
            d("span", null, V(o.spineLocations.t[4]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T5",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T6",
            onMouseenter: e[133] || (e[133] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[134] || (e[134] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[5],
              onChange: e[132] || (e[132] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, MD),
            d("span", null, V(o.spineLocations.t[5]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T6",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T7",
            onMouseenter: e[136] || (e[136] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[137] || (e[137] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[6],
              onChange: e[135] || (e[135] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, _D),
            d("span", null, V(o.spineLocations.t[6]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T7",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T8",
            onMouseenter: e[139] || (e[139] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[140] || (e[140] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[7],
              onChange: e[138] || (e[138] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, $D),
            d("span", null, V(o.spineLocations.t[7]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T8",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T9",
            onMouseenter: e[142] || (e[142] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[143] || (e[143] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[8],
              onChange: e[141] || (e[141] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, SD),
            d("span", null, V(o.spineLocations.t[8]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T9",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T10",
            onMouseenter: e[145] || (e[145] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[146] || (e[146] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[9],
              onChange: e[144] || (e[144] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, CD),
            d("span", null, V(o.spineLocations.t[9]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T10",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T11",
            onMouseenter: e[148] || (e[148] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[149] || (e[149] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[10],
              onChange: e[147] || (e[147] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, DD),
            d("span", null, V(o.spineLocations.t[10]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T11",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-T12",
            onMouseenter: e[151] || (e[151] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[152] || (e[152] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.t[11],
              onChange: e[150] || (e[150] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, zD),
            d("span", null, V(o.spineLocations.t[11]), 1),
            Z(a, {
              ref: "spine-connector-from-label-T12",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544)
        ]),
        d("div", {
          ref: "spine-stack-t",
          class: "spine-stack",
          "data-procedure-category": "t",
          innerHTML: o.procedureLayout.t
        }, null, 8, ID)
      ]),
      d("div", TD, [
        d("div", OD, [
          d("label", {
            ref: "spine-label-L1",
            onMouseenter: e[154] || (e[154] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[155] || (e[155] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.l[0],
              onChange: e[153] || (e[153] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, PD),
            d("span", null, V(o.spineLocations.l[0]), 1),
            Z(a, {
              ref: "spine-connector-from-label-L1",
              class: "connector label",
              "data-anchor-y": "0.3"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-L2",
            onMouseenter: e[157] || (e[157] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[158] || (e[158] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.l[1],
              onChange: e[156] || (e[156] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, ZD),
            d("span", null, V(o.spineLocations.l[1]), 1),
            Z(a, {
              ref: "spine-connector-from-label-L2",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-L3",
            onMouseenter: e[160] || (e[160] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[161] || (e[161] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.l[2],
              onChange: e[159] || (e[159] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, ED),
            d("span", null, V(o.spineLocations.l[2]), 1),
            Z(a, {
              ref: "spine-connector-from-label-L3",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-L4",
            onMouseenter: e[163] || (e[163] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[164] || (e[164] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.l[3],
              onChange: e[162] || (e[162] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, AD),
            d("span", null, V(o.spineLocations.l[3]), 1),
            Z(a, {
              ref: "spine-connector-from-label-L4",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-L5",
            onMouseenter: e[166] || (e[166] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[167] || (e[167] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.l[4],
              onChange: e[165] || (e[165] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, ND),
            d("span", null, V(o.spineLocations.l[4]), 1),
            Z(a, {
              ref: "spine-connector-from-label-L5",
              class: "connector label"
            }, null, 512)
          ], 544)
        ]),
        d("div", {
          ref: "spine-stack-l",
          class: "spine-stack",
          "data-procedure-category": "l",
          innerHTML: o.procedureLayout.l
        }, null, 8, HD)
      ]),
      d("div", BD, [
        d("div", VD, [
          d("label", {
            ref: "spine-label-S1",
            onMouseenter: e[169] || (e[169] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[170] || (e[170] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.s[0],
              onChange: e[168] || (e[168] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, RD),
            d("span", null, V(o.spineLocations.s[0]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-S1",
              class: "connector spine",
              width: "20px",
              "space-between": "2px",
              "data-anchor-y": "0.2"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-S1",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-S2",
            onMouseenter: e[172] || (e[172] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[173] || (e[173] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.s[1],
              onChange: e[171] || (e[171] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, YD),
            d("span", null, V(o.spineLocations.s[1]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-S2",
              class: "connector spine",
              width: "20px",
              "space-between": "2px",
              "data-anchor-y": "0.3"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-S2",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-S3",
            onMouseenter: e[175] || (e[175] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[176] || (e[176] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.s[2],
              onChange: e[174] || (e[174] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, FD),
            d("span", null, V(o.spineLocations.s[2]), 1),
            Z(a, {
              ref: "spine-connector-from-label-S3",
              class: "connector label",
              "data-anchor-y": "0.8"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-S4",
            onMouseenter: e[178] || (e[178] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[179] || (e[179] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.s[3],
              onChange: e[177] || (e[177] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, jD),
            d("span", null, V(o.spineLocations.s[3]), 1),
            Z(a, {
              ref: "spine-connector-from-label-S4",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-S5",
            onMouseenter: e[181] || (e[181] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[182] || (e[182] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.s[4],
              onChange: e[180] || (e[180] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, WD),
            d("span", null, V(o.spineLocations.s[4]), 1),
            Z(a, {
              ref: "spine-connector-from-label-S5",
              class: "connector label"
            }, null, 512)
          ], 544),
          d("label", {
            ref: "spine-label-Becken",
            onMouseenter: e[184] || (e[184] = (...s) => n.spineLabelHoverIn && n.spineLabelHoverIn(...s)),
            onMouseleave: e[185] || (e[185] = (...s) => n.spineLabelHoverOut && n.spineLabelHoverOut(...s))
          }, [
            d("input", {
              type: "checkbox",
              name: r.name,
              value: o.spineLocations.s[5],
              onChange: e[183] || (e[183] = (...s) => n.spineLabelSelected && n.spineLabelSelected(...s))
            }, null, 40, UD),
            d("span", null, V(o.spineLocations.s[5]), 1),
            Z(a, {
              ref: "spine-connector-from-spine-Becken",
              class: "connector spine",
              width: "35px",
              "data-anchor-x": "0.77",
              "data-anchor-y": "0.9"
            }, null, 512),
            Z(a, {
              ref: "spine-connector-from-label-Becken",
              class: "connector label"
            }, null, 512)
          ], 544)
        ]),
        d("div", {
          ref: "spine-stack-s",
          class: "spine-stack",
          "data-procedure-category": "s",
          innerHTML: o.procedureLayout.s
        }, null, 8, GD)
      ])
    ])
  ]);
}
const FT = /* @__PURE__ */ K(MC, [["render", KD]]);
var i3;
const d4 = typeof window < "u", l3 = () => {
};
d4 && ((i3 = window == null ? void 0 : window.navigator) != null && i3.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function u1(t) {
  return typeof t == "function" ? t() : O(t);
}
function qD(t, e) {
  function r(...L) {
    return new Promise((o, n) => {
      Promise.resolve(t(() => e.apply(this, L), { fn: e, thisArg: this, args: L })).then(o).catch(n);
    });
  }
  return r;
}
function XD(t, e = {}) {
  let r, L, o = l3;
  const n = (s) => {
    clearTimeout(s), o(), o = l3;
  };
  return (s) => {
    const i = u1(t), l = u1(e.maxWait);
    return r && n(r), i <= 0 || l !== void 0 && l <= 0 ? (L && (n(L), L = null), Promise.resolve(s())) : new Promise((u, c) => {
      o = e.rejectOnCancel ? c : u, l && !L && (L = setTimeout(() => {
        r && n(r), L = null, u(s());
      }, l)), r = setTimeout(() => {
        L && n(L), L = null, u(s());
      }, i);
    });
  };
}
function u3(t, e = !1, r = "Timeout") {
  return new Promise((L, o) => {
    setTimeout(e ? () => o(r) : L, t);
  });
}
function JD(t) {
  return t;
}
function QD(t, ...e) {
  return e.some((r) => r in t);
}
function lL(t) {
  return ZL() ? (EL(t), !0) : !1;
}
function V0() {
  const t = [], e = (o) => {
    const n = t.indexOf(o);
    n !== -1 && t.splice(n, 1);
  };
  return {
    on: (o) => {
      t.push(o);
      const n = () => e(o);
      return lL(n), {
        off: n
      };
    },
    off: e,
    trigger: (o) => {
      t.forEach((n) => n(o));
    }
  };
}
function ez(t, e = 200, r = {}) {
  return qD(XD(e, r), t);
}
function tz(t, e = 200, r = {}) {
  const L = P(t.value), o = ez(() => {
    L.value = t.value;
  }, e, r);
  return s5(t, () => o()), L;
}
function R0(t) {
  return typeof t == "function" ? U(t) : P(t);
}
function b2(t, e = !1) {
  function r(c, { flush: v = "sync", deep: p = !1, timeout: m, throwOnTimeout: f } = {}) {
    let x = null;
    const w = [new Promise((g) => {
      x = s5(t, (h) => {
        c(h) !== e && (x == null || x(), g(h));
      }, {
        flush: v,
        deep: p,
        immediate: !0
      });
    })];
    return m != null && w.push(u3(m, f).then(() => u1(t)).finally(() => x == null ? void 0 : x())), Promise.race(w);
  }
  function L(c, v) {
    if (!h1(c))
      return r((h) => h === c, v);
    const { flush: p = "sync", deep: m = !1, timeout: f, throwOnTimeout: x } = v ?? {};
    let y = null;
    const g = [new Promise((h) => {
      y = s5([t, c], ([k, M]) => {
        e !== (k === M) && (y == null || y(), h(k));
      }, {
        flush: p,
        deep: m,
        immediate: !0
      });
    })];
    return f != null && g.push(u3(f, x).then(() => u1(t)).finally(() => (y == null || y(), u1(t)))), Promise.race(g);
  }
  function o(c) {
    return r((v) => !!v, c);
  }
  function n(c) {
    return L(null, c);
  }
  function a(c) {
    return L(void 0, c);
  }
  function s(c) {
    return r(Number.isNaN, c);
  }
  function i(c, v) {
    return r((p) => {
      const m = Array.from(p);
      return m.includes(c) || m.includes(u1(c));
    }, v);
  }
  function l(c) {
    return u(1, c);
  }
  function u(c = 1, v) {
    let p = -1;
    return r(() => (p += 1, p >= c), v);
  }
  return Array.isArray(u1(t)) ? {
    toMatch: r,
    toContains: i,
    changed: l,
    changedTimes: u,
    get not() {
      return b2(t, !e);
    }
  } : {
    toMatch: r,
    toBe: L,
    toBeTruthy: o,
    toBeNull: n,
    toBeNaN: s,
    toBeUndefined: a,
    changed: l,
    changedTimes: u,
    get not() {
      return b2(t, !e);
    }
  };
}
function rz(t) {
  return b2(t);
}
function Lz(t, e, r = {}) {
  const {
    immediate: L = !0
  } = r, o = P(!1);
  let n = null;
  function a() {
    n && (clearTimeout(n), n = null);
  }
  function s() {
    o.value = !1, a();
  }
  function i(...l) {
    a(), o.value = !0, n = setTimeout(() => {
      o.value = !1, n = null, t(...l);
    }, u1(e));
  }
  return L && (o.value = !0, d4 && i()), lL(s), {
    isPending: PL(o),
    start: i,
    stop: s
  };
}
const nz = d4 ? window : void 0, d3 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, c3 = "__vueuse_ssr_handlers__";
d3[c3] = d3[c3] || {};
var oz = Object.defineProperty, sz = Object.defineProperties, az = Object.getOwnPropertyDescriptors, h3 = Object.getOwnPropertySymbols, iz = Object.prototype.hasOwnProperty, lz = Object.prototype.propertyIsEnumerable, f3 = (t, e, r) => e in t ? oz(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, B5 = (t, e) => {
  for (var r in e || (e = {}))
    iz.call(e, r) && f3(t, r, e[r]);
  if (h3)
    for (var r of h3(e))
      lz.call(e, r) && f3(t, r, e[r]);
  return t;
}, Ge = (t, e) => sz(t, az(e));
const uz = {
  json: "application/json",
  text: "text/plain"
};
function p3(t) {
  return t && QD(t, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch");
}
function Y0(t) {
  return typeof Headers < "u" && t instanceof Headers ? Object.fromEntries([...t.entries()]) : t;
}
function m3(t, ...e) {
  var r;
  const L = typeof AbortController == "function";
  let o = {}, n = { immediate: !0, refetch: !1, timeout: 0 };
  const a = {
    method: "GET",
    type: "text",
    payload: void 0
  };
  e.length > 0 && (p3(e[0]) ? n = B5(B5({}, n), e[0]) : o = e[0]), e.length > 1 && p3(e[1]) && (n = B5(B5({}, n), e[1]));
  const {
    fetch: s = (r = nz) == null ? void 0 : r.fetch,
    initialData: i,
    timeout: l
  } = n, u = V0(), c = V0(), v = V0(), p = P(!1), m = P(!1), f = P(!1), x = P(null), y = $0(null), w = $0(null), g = $0(i), h = U(() => L && m.value);
  let k, M;
  const $ = () => {
    L && k && (k.abort(), k = void 0);
  }, C = (N) => {
    m.value = N, p.value = !N;
  };
  l && (M = Lz($, l, { immediate: !1 }));
  const D = async (N = !1) => {
    var H;
    C(!0), w.value = null, x.value = null, f.value = !1, L && ($(), k = new AbortController(), k.signal.onabort = () => f.value = !0, o = Ge(B5({}, o), {
      signal: k.signal
    }));
    const G = {
      method: a.method,
      headers: {}
    };
    if (a.payload) {
      const h5 = Y0(G.headers);
      a.payloadType && (h5["Content-Type"] = (H = uz[a.payloadType]) != null ? H : a.payloadType);
      const n5 = u1(a.payload);
      G.body = a.payloadType === "json" ? JSON.stringify(n5) : n5;
    }
    let e5 = !1;
    const t5 = {
      url: u1(t),
      options: B5(B5({}, G), o),
      cancel: () => {
        e5 = !0;
      }
    };
    if (n.beforeFetch && Object.assign(t5, await n.beforeFetch(t5)), e5 || !s)
      return C(!1), Promise.resolve(null);
    let J = null;
    return M && M.start(), new Promise((h5, n5) => {
      var _5;
      s(t5.url, Ge(B5(B5({}, G), t5.options), {
        headers: B5(B5({}, Y0(G.headers)), Y0((_5 = t5.options) == null ? void 0 : _5.headers))
      })).then(async (o5) => {
        if (y.value = o5, x.value = o5.status, J = await o5[a.type](), n.afterFetch && x.value >= 200 && x.value < 300 && ({ data: J } = await n.afterFetch({ data: J, response: o5 })), g.value = J, !o5.ok)
          throw new Error(o5.statusText);
        return u.trigger(o5), h5(o5);
      }).catch(async (o5) => {
        let i5 = o5.message || o5.name;
        return n.onFetchError && ({ data: J, error: i5 } = await n.onFetchError({ data: J, error: o5, response: y.value })), g.value = J, w.value = i5, c.trigger(o5), N ? n5(o5) : h5(null);
      }).finally(() => {
        C(!1), M && M.stop(), v.trigger(null);
      });
    });
  }, S = R0(n.refetch);
  s5([
    S,
    R0(t)
  ], ([N]) => N && D(), { deep: !0 });
  const T = {
    isFinished: p,
    statusCode: x,
    response: y,
    error: w,
    data: g,
    isFetching: m,
    canAbort: h,
    aborted: f,
    abort: $,
    execute: D,
    onFetchResponse: u.on,
    onFetchError: c.on,
    onFetchFinally: v.on,
    get: B("GET"),
    put: B("PUT"),
    post: B("POST"),
    delete: B("DELETE"),
    patch: B("PATCH"),
    head: B("HEAD"),
    options: B("OPTIONS"),
    json: R("json"),
    text: R("text"),
    blob: R("blob"),
    arrayBuffer: R("arrayBuffer"),
    formData: R("formData")
  };
  function B(N) {
    return (H, G) => {
      if (!m.value) {
        a.method = N, a.payload = H, a.payloadType = G, h1(a.payload) && s5([
          S,
          R0(a.payload)
        ], ([t5]) => t5 && D(), { deep: !0 });
        const e5 = u1(a.payload);
        return !G && e5 && Object.getPrototypeOf(e5) === Object.prototype && !(e5 instanceof FormData) && (a.payloadType = "json"), Ge(B5({}, T), {
          then(t5, J) {
            return I().then(t5, J);
          }
        });
      }
    };
  }
  function I() {
    return new Promise((N, H) => {
      rz(p).toBe(!0).then(() => N(T)).catch((G) => H(G));
    });
  }
  function R(N) {
    return () => {
      if (!m.value)
        return a.type = N, Ge(B5({}, T), {
          then(H, G) {
            return I().then(H, G);
          }
        });
    };
  }
  return n.immediate && setTimeout(D, 0), Ge(B5({}, T), {
    then(N, H) {
      return I().then(N, H);
    }
  });
}
var g3;
(function(t) {
  t.UP = "UP", t.RIGHT = "RIGHT", t.DOWN = "DOWN", t.LEFT = "LEFT", t.NONE = "NONE";
})(g3 || (g3 = {}));
var dz = Object.defineProperty, v3 = Object.getOwnPropertySymbols, cz = Object.prototype.hasOwnProperty, hz = Object.prototype.propertyIsEnumerable, y3 = (t, e, r) => e in t ? dz(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, fz = (t, e) => {
  for (var r in e || (e = {}))
    cz.call(e, r) && y3(t, r, e[r]);
  if (v3)
    for (var r of v3(e))
      hz.call(e, r) && y3(t, r, e[r]);
  return t;
};
const pz = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
fz({
  linear: JD
}, pz);
const mz = (t) => (g1("data-v-c2e54fb4"), t = t(), v1(), t), gz = { class: "relative" }, vz = {
  key: 0,
  "data-test-id": "loading-spinner",
  class: "flex items-center justify-center w-full"
}, yz = /* @__PURE__ */ mz(() => /* @__PURE__ */ d("svg", {
  class: "spinner text-black",
  viewBox: "0 0 50 50"
}, [
  /* @__PURE__ */ d("circle", {
    class: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    "stroke-width": "5",
    stroke: "currentColor"
  })
], -1)), wz = [
  yz
], bz = {
  key: 1,
  class: "grid grid-flow-row gap-y-2",
  "data-test-id": "autocomplete-list"
}, xz = ["onClick"], kz = /* @__PURE__ */ r5({
  __name: "MfxAutoComplete",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    autocompleteValues: {
      type: Array,
      default: () => []
    },
    labelItemKey: {
      type: [String, Number],
      default: void 0
    },
    valueItemKey: {
      type: [String, Number],
      default: void 0
    },
    listKey: {
      type: [String, Number],
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    debounceDelay: {
      type: Number,
      default: 0
    },
    dropDownOffset: {
      type: Array,
      default: () => [0, -5],
      validator: (t) => Array.isArray(t) && t.length === 2
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "selectValue"],
  setup(t, { emit: e }) {
    const r = t, L = P(""), o = tz(L, r.debounceDelay), n = U(
      () => !!r.autocompleteValues.length
    ), a = (l) => {
      e("selectValue", l);
    }, s = s5(
      () => r.modelValue,
      (l) => {
        L.value = l;
      },
      { immediate: !0 }
    ), i = s5(o, (l) => {
      e("update:modelValue", l);
    });
    return s5(
      () => r.autocompleteValues,
      (l) => {
        console.log("autocompleteValues :>> ", l);
      },
      { immediate: !0, deep: !0 }
    ), se(() => {
      s(), i();
    }), (l, u) => (b(), _("div", gz, [
      Z(Nt, {
        modelValue: L.value,
        "onUpdate:modelValue": u[0] || (u[0] = (c) => L.value = c),
        "data-test-id": "autocomplete-input",
        placeholder: t.placeholder
      }, null, 8, ["modelValue", "placeholder"]),
      t.loading || n.value ? (b(), _("div", {
        key: 0,
        class: "absolute w-full bg-white rounded-md shadow-xl border p-2",
        style: R5({
          left: t.dropDownOffset[0],
          top: `calc(100% - ${t.dropDownOffset[1]}px)`
        })
      }, [
        t.loading ? (b(), _("div", vz, wz)) : n.value ? (b(), _("ul", bz, [
          (b(!0), _(p5, null, S5(t.autocompleteValues, (c, v) => (b(), _("li", {
            key: t.listKey ? c[t.listKey] : v,
            class: "text-black cursor-pointer",
            onClick: (p) => a(t.valueItemKey ? c[t.valueItemKey] : c)
          }, [
            u5(l.$slots, "autocompleteItem", { data: c }, () => [
              d("div", null, V(t.labelItemKey ? c[t.labelItemKey] : c), 1)
            ], !0)
          ], 8, xz))), 128))
        ])) : X("", !0)
      ], 4)) : X("", !0)
    ]));
  }
});
const Mz = /* @__PURE__ */ K(kz, [["__scopeId", "data-v-c2e54fb4"]]), F0 = "https://clinicaltables.nlm.nih.gov/loinc_form_definitions?loinc_num=", _z = "https://clinicaltables.nlm.nih.gov/api/loinc_items/v3/search?terms=$SEARCH_VALUE&df=LOINC_NUM,text&type=form_and_section&available=true", jT = /* @__PURE__ */ r5({
  __name: "FhirQuestionnaireLookup",
  props: {
    loink: {
      type: Boolean,
      default: !0
    },
    fhirApi: {
      type: String,
      required: !1
    },
    fhirApiToken: {
      type: String,
      required: !1
    },
    inputPlaceholder: {
      type: String,
      default: ""
    },
    inputDebounceDelay: {
      type: Number,
      default: 100
    }
  },
  emits: ["selectQuestionnaire"],
  setup(t, { emit: e }) {
    const r = t, L = P(""), o = P(F0), n = U(
      () => _z.replace(
        "$SEARCH_VALUE",
        L.value
      )
    ), a = m3(n, {
      immediate: !1
    }).get().json(), s = m3(o, {
      immediate: !1
    }).get().json(), i = U(
      () => a.isFetching.value || s.isFetching.value
    ), l = U(
      () => a.data.value ? a.data.value[3] : []
    ), u = U(
      () => r.loink ? l.value : []
    ), c = () => {
      a.data.value = [];
    }, v = () => {
      s.data.value = void 0;
    }, p = () => {
      L.value = "";
    }, m = () => {
      o.value = F0;
    }, f = async (y) => {
      if (!y)
        throw new Error("formId is required");
      return o.value = F0 + y, await s.execute(), m(), s.data.value;
    }, x = async (y) => {
      let w;
      r.loink && (w = await f(
        y[0]
      )), c(), p(), v(), w && e("selectQuestionnaire", w);
    };
    return s5(L, (y) => {
      if (!y.trim()) {
        c();
        return;
      }
      a.execute();
    }), se(() => {
      c(), p(), v(), m();
    }), (y, w) => (b(), x5(Mz, {
      modelValue: L.value,
      "onUpdate:modelValue": w[0] || (w[0] = (g) => L.value = g),
      "autocomplete-values": u.value,
      placeholder: t.inputPlaceholder,
      "debounce-delay": t.inputDebounceDelay,
      loading: i.value,
      onSelectValue: x
    }, {
      autocompleteItem: c5(({ data: g }) => [
        d("span", null, V(`${g[0]} - ${g[1]}`), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "autocomplete-values", "placeholder", "debounce-delay", "loading"]));
  }
}), $z = ["disabled", "value"], WT = /* @__PURE__ */ r5({
  __name: "MfxColorPicker",
  props: {
    label: {},
    labelPosition: { default: "left" },
    value: {},
    modelValue: { default: "" },
    disabled: { type: Boolean },
    inputClasses: {},
    mainClasses: {},
    labelClasses: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const r = t, { modelValue: L } = N5(r), { localValue: o } = y1(L, e), n = U(() => {
      const l = "flex align-center";
      return r.mainClasses ? T5(l, C5().toString(r.mainClasses)) : l;
    }), a = U(() => {
      const l = "";
      return r.inputClasses ? T5(l, C5().toString(r.inputClasses)) : l;
    }), s = U(() => {
      const l = "";
      return r.labelClasses ? T5(l, C5().toString(r.labelClasses)) : l;
    }), i = (l) => {
      o.value = l.target.value;
    };
    return (l, u) => (b(), _("div", {
      class: F([n.value])
    }, [
      l.label && l.labelPosition === "left" ? (b(), _("label", {
        key: 0,
        class: F([s.value])
      }, V(l.label), 3)) : X("", !0),
      d("input", {
        class: F([a.value]),
        type: "color",
        disabled: l.disabled,
        value: O(o),
        onChange: i
      }, null, 42, $z),
      l.label && l.labelPosition === "right" ? (b(), _("label", {
        key: 1,
        class: F([s.value])
      }, V(l.label), 3)) : X("", !0)
    ], 2));
  }
});
const UT = /* @__PURE__ */ r5({
  __name: "MfxBaum",
  props: {
    imageSelect: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t;
    return (r, L) => (b(), _("ul", {
      class: F(["baum", { "baum--image-select": e.imageSelect }])
    }, [
      u5(r.$slots, "default")
    ], 2));
  }
}), Sz = ["data-expand"], Cz = ["name", "value"], Dz = { class: "baum-branch__image" }, zz = ["src"], Iz = { class: "baum-branch__legend" }, Tz = { class: "baum-branch__controls" }, Oz = { class: "baum-branch__tooltip" }, Pz = { key: 0 }, Zz = ["name", "value"], Ez = /* @__PURE__ */ d("span", null, null, -1), GT = /* @__PURE__ */ r5({
  __name: "MfxBaumBranch",
  props: {
    expand: { default: "false" },
    imageSelect: { type: Boolean, default: !1 },
    name: { default: "" },
    value: { default: "" },
    label: { default: "" },
    image: { default: "" },
    tooltip: { default: "" }
  },
  emits: ["valueSelected"],
  setup(t, { emit: e }) {
    const r = t, { expand: L, imageSelect: o, name: n, value: a, label: s, image: i, tooltip: l } = N5(r), u = P(), c = U(() => typeof l.value == "string"), v = P(), { localValue: p } = y1(v, e);
    s5(p.value, (g, h) => {
      h.includes(a.value) && w(u.value), $e(() => {
        g.includes(a.value) && w(u.value);
      });
    }), I5(() => {
      if (u.value) {
        const g = u.value;
        if (g.querySelector(".baum")) {
          let h = g.getAttribute("data-expand");
          h = h === null ? !1 : typeof h == "string" && h.toLowerCase() === "true";
          const k = g.querySelector(
            'input[ type="checkbox" ]'
          );
          k && (k.checked = h);
        }
      }
    });
    const m = (g, h) => {
      g.isTrusted && e("valueSelected", h);
    }, f = (g, h) => {
      h && h.querySelectorAll(":scope > li.baum-branch").forEach((M) => {
        const $ = M.querySelector('input[ type="checkbox" ]');
        if ($.checked) {
          $.checked = !1, M.firstElementChild.classList.remove("baum--has-selection"), m(M, null);
          const C = M.querySelector(".baum");
          C && (M.setAttribute("data-expand", !1), f(g, C));
        }
      });
    }, x = (g, h, k) => {
      const M = k.querySelector('input[ type="checkbox" ]');
      let $ = h.getAttribute("data-single-select");
      $ = $ === null ? !1 : $.toLowerCase() === "true", M && (M.checked ? (k.firstElementChild.classList.add("baum--has-selection"), h.querySelectorAll(":scope > li.baum-branch").forEach((D) => {
        if (!D.isEqualNode(k)) {
          const S = D.querySelector(
            'input[ type="checkbox" ]'
          );
          if (S.checked && $) {
            S.checked = !1, D.firstElementChild.classList.remove(
              "baum--has-selection"
            ), m(g, D);
            const T = D.querySelector(".baum");
            T && (D.setAttribute("data-expand", !1), f(g, T));
          }
        }
      })) : (k.firstElementChild.classList.remove("baum--has-selection"), f(g, k.querySelector("ul.baum"))), m(g, k));
    }, y = (g) => {
      const h = g.target.closest("label"), k = h.parentElement, M = k.parentElement;
      if (x(g, M, k), !h.nextElementSibling || !h.nextElementSibling.matches(".baum"))
        return;
      let $ = k.getAttribute("data-expand");
      $ = $ === null ? !0 : $.toLowerCase() !== "true", $ = $.toString(), k.setAttribute("data-expand", $);
    }, w = (g) => {
      const h = g.parentElement.closest(".baum-branch[ data-expand ]");
      if (h && h.getAttribute("data-expand") === "false") {
        w(h);
        const k = h.firstElementChild.firstElementChild;
        k.checked = !k.checked, y({
          target: h.firstElementChild
        });
      }
    };
    return (g, h) => (b(), _("li", {
      ref_key: "$el",
      ref: u,
      class: F(["baum-branch", { "baum-branch--image-selection": O(o) }]),
      "data-expand": O(L)
    }, [
      O(o) ? (b(), _("label", {
        key: 1,
        class: F(["flex", {
          "baum--has-selection": O(p) ? O(p).includes(O(a)) : !1
        }])
      }, [
        d("div", Dz, [
          d("img", {
            style: {},
            src: O(i),
            alt: ""
          }, null, 8, zz)
        ]),
        d("div", Iz, [
          d("div", Tz, [
            d("span", null, V(O(s) === "" ? O(a) : O(s)), 1)
          ]),
          d("div", Oz, [
            O(l) !== "" ? (b(), _("div", Pz, [
              c.value ? (b(), x5(ft, {
                key: 0,
                trigger: "hover"
              }, {
                default: c5(() => [
                  c1(V(O(l)), 1)
                ]),
                _: 1
              })) : Array.isArray(O(l)) ? (b(), x5(ft, {
                key: 1,
                trigger: "hover"
              }, {
                default: c5(() => [
                  (b(!0), _(p5, null, S5(O(l), (k) => (b(), _("span", {
                    key: k,
                    class: "mb-2"
                  }, V(k), 1))), 128))
                ]),
                _: 1
              })) : X("", !0)
            ])) : X("", !0),
            b5(d("input", {
              "onUpdate:modelValue": h[1] || (h[1] = (k) => h1(p) ? p.value = k : null),
              type: "checkbox",
              name: O(n),
              value: O(a),
              onInput: y
            }, null, 40, Zz), [
              [ot, O(p)]
            ]),
            Ez
          ])
        ])
      ], 2)) : (b(), _(p5, { key: 0 }, [
        d("label", {
          class: F({
            "baum--has-selection": O(p) ? O(p).includes(O(a)) : !1
          })
        }, [
          b5(d("input", {
            "onUpdate:modelValue": h[0] || (h[0] = (k) => h1(p) ? p.value = k : null),
            type: "checkbox",
            name: O(n),
            value: O(a),
            onInput: y
          }, null, 40, Cz), [
            [ot, O(p)]
          ]),
          d("span", null, V(O(s) === "" ? O(a) : O(s)), 1)
        ], 2),
        u5(g.$slots, "default")
      ], 64))
    ], 10, Sz));
  }
}), Az = { class: "flex-1" }, Nz = { class: "flex gap-4" }, Hz = { class: "flex-1" }, Bz = { class: "" }, Vz = { class: "flex-1 mt-[50px] mb-[50px]" }, Rz = { class: "flex gap-4" }, Yz = { class: "flex-1" }, Fz = { class: "" }, jz = { class: "flex-1" }, Wz = { class: "flex gap-4" }, Uz = { class: "flex-1" }, Gz = { class: "" }, KT = /* @__PURE__ */ r5({
  __name: "MfxLineSpacingSelector",
  props: {
    vertical: { type: Boolean, default: !0 }
  },
  emits: ["update:linespacing"],
  setup(t, { emit: e }) {
    const r = t, L = P("Default"), o = (n) => {
      e("update:linespacing", n);
    };
    return (n, a) => (b(), _("div", {
      class: F(["flex justify-between", {
        "flex-col": r.vertical
      }])
    }, [
      d("div", Az, [
        d("div", Nz, [
          d("div", Hz, [
            Z(O(S0), {
              modelValue: L.value,
              "onUpdate:modelValue": [
                a[0] || (a[0] = (s) => L.value = s),
                o
              ],
              name: "spacing",
              text: "Default",
              value: "Default"
            }, null, 8, ["modelValue"])
          ]),
          d("div", Bz, [
            Z(O(wx))
          ])
        ])
      ]),
      d("div", Vz, [
        d("div", Rz, [
          d("div", Yz, [
            Z(O(S0), {
              modelValue: L.value,
              "onUpdate:modelValue": [
                a[1] || (a[1] = (s) => L.value = s),
                o
              ],
              name: "spacing",
              text: "Comfortable",
              value: "Comfortable"
            }, null, 8, ["modelValue"])
          ]),
          d("div", Fz, [
            Z(O(ix))
          ])
        ])
      ]),
      d("div", jz, [
        d("div", Wz, [
          d("div", Uz, [
            Z(O(S0), {
              modelValue: L.value,
              "onUpdate:modelValue": [
                a[2] || (a[2] = (s) => L.value = s),
                o
              ],
              name: "spacing",
              text: "Compact",
              value: "Compact"
            }, null, 8, ["modelValue"])
          ]),
          d("div", Gz, [
            Z(O(fx))
          ])
        ])
      ])
    ], 2));
  }
}), Kz = { class: "flex-1 text-center" }, qz = /* @__PURE__ */ d("div", null, "Default", -1), Xz = { class: "flex-1 text-center" }, Jz = /* @__PURE__ */ d("div", null, "Large", -1), Qz = { class: "flex-1 text-center" }, eI = /* @__PURE__ */ d("div", null, "Extra Large", -1), de = "selected", qT = /* @__PURE__ */ r5({
  __name: "MfxFontSizeSelector",
  props: {
    vertical: { type: Boolean, default: !1 }
  },
  emits: ["update:fontsize"],
  setup(t, { emit: e }) {
    const r = t, L = P(null), o = P(null), n = P(null), a = (s) => {
      switch (o.value.classList.remove(de), n.value.classList.remove(de), L.value.classList.remove(de), s) {
        case "LG":
          o.value.classList.add(de);
          break;
        case "XL":
          n.value.classList.add(de);
          break;
        default:
          L.value.classList.add(de);
          break;
      }
      e("update:fontsize", s);
    };
    return (s, i) => (b(), _("div", {
      class: F(["flex", {
        "flex-col": r.vertical
      }])
    }, [
      d("div", Kz, [
        d("div", {
          class: "mb-2 h-6 leading-38px",
          onClick: i[0] || (i[0] = (l) => a("D"))
        }, [
          d("span", {
            ref_key: "refDefault",
            ref: L,
            class: "selected cursor-pointer"
          }, "Aa", 512)
        ]),
        qz
      ]),
      d("div", Xz, [
        d("div", {
          class: "mb-2 h-6 leading-38px",
          onClick: i[1] || (i[1] = (l) => a("LG"))
        }, [
          d("span", {
            ref_key: "refLg",
            ref: o,
            class: "text-xl cursor-pointer"
          }, "Aa", 512)
        ]),
        Jz
      ]),
      d("div", Qz, [
        d("div", {
          class: "mb-2 h-6",
          onClick: i[2] || (i[2] = (l) => a("XL"))
        }, [
          d("span", {
            ref_key: "refXL",
            ref: n,
            class: "text-2xl cursor-pointer"
          }, "Aa", 512)
        ]),
        eI
      ])
    ], 2));
  }
});
const tI = { class: "flex justify-center relative" }, rI = {
  key: 0,
  class: "minimap-focus-border"
}, LI = {
  name: "ClusterMinimapStep"
}, nI = /* @__PURE__ */ r5({
  ...LI,
  props: {
    cluster: {
      type: Object,
      required: !0
    },
    activeClusterId: {
      type: String,
      default: "1"
    }
  },
  emits: ["setActiveCluster"],
  setup(t, { expose: e, emit: r }) {
    const L = t, o = U(() => ({
      "minimap-complete": L.cluster.complete,
      "minimap-default": !L.cluster.complete,
      "minimap-focus": L.cluster.id === L.activeClusterId,
      "minimap-invalid": L.cluster.invalid
    })), n = (a) => {
      r("setActiveCluster", a);
    };
    return e({
      props: L,
      setActiveCluster: n
    }), (a, s) => (b(), _("div", tI, [
      d("div", {
        "data-test-id": "step-container",
        class: "relative",
        onClick: s[0] || (s[0] = (i) => n(t.cluster))
      }, [
        t.cluster.id === t.activeClusterId ? (b(), _("span", rI)) : X("", !0),
        d("span", {
          class: F(["minimap transition-colors", o.value])
        }, V(t.cluster.id), 3)
      ])
    ]));
  }
});
const oI = /* @__PURE__ */ K(nI, [["__scopeId", "data-v-524dc7ec"]]), sI = {
  "aria-label": "Minimap",
  class: "cluster-minimap-wrapper relative block mt-28 w-bl-60 transform transition ease-in-out duration-500"
}, aI = { class: "relative grid auto-rows-max bg-white py-4 rounded-r-panel shadow" }, iI = {
  key: 0,
  class: "flex justify-center relative"
}, lI = /* @__PURE__ */ O5('<g id="Layer_2" data-name="Layer 2" data-v-9bdb2fdb><g id="Layer_1-2" data-name="Layer 1" data-v-9bdb2fdb><path class="cls-1 fill-current" d="M27.8,7.2a8.1,8.1,0,0,0-3.3-5,11.6,11.6,0,0,0-7-2.2,12.2,12.2,0,0,0-7.1,2.2,8.4,8.4,0,0,0-3.2,5A7.1,7.1,0,0,0,0,14.1,7.3,7.3,0,0,0,7.4,21H27.6A7.3,7.3,0,0,0,35,14.1,7.2,7.2,0,0,0,27.8,7.2Z" data-v-9bdb2fdb></path><path id="Pfad_6593" data-name="Pfad 6593" d="M23.1,13.1a.7.7,0,0,0-.6.7v2h-10v-2a.7.7,0,0,0-.6-.7.7.7,0,0,0-.7.7v2.6c0,.4.3.6.7.6H23.1c.4,0,.7-.2.7-.6V13.8a.7.7,0,0,0-.6-.7Z" data-v-9bdb2fdb></path><path id="Pfad_6594" data-name="Pfad 6594" d="M15.4,7.2a.4.4,0,0,0,.4-.2l1.1-1v6.9a.6.6,0,0,0,1.2,0v-7L19.2,7a.6.6,0,0,0,.9,0,.7.7,0,0,0,0-.9L17.5,3.5,14.9,6.1a.7.7,0,0,0,0,.9C15,7.2,15.2,7.2,15.4,7.2Z" data-v-9bdb2fdb></path></g></g>', 1), uI = [
  lI
], dI = {
  key: 1,
  class: "[ w-full border-t-2 border-solid flex flex-col items-center mt-5 ]"
}, cI = ["src", "alt", "onClick"], hI = {
  name: "ClusterMinimapDataWrapper"
}, fI = /* @__PURE__ */ r5({
  ...hI,
  props: {
    clusters: {
      type: Array,
      default: () => []
    },
    activeClusterId: {
      type: String,
      default: "1"
    },
    additionalIcons: {
      type: Array,
      default: () => []
    }
  },
  emits: ["setActiveCluster", "submit", "additionalIconHandler"],
  setup(t, { emit: e }) {
    const r = (n) => {
      e("setActiveCluster", n);
    }, L = () => {
      e("submit");
    }, o = (n) => {
      e("additionalIconHandler", n);
    };
    return (n, a) => (b(), _("nav", sI, [
      d("div", aI, [
        (b(!0), _(p5, null, S5(t.clusters, (s, i) => (b(), _("div", {
          key: i,
          "data-test-id": "cluster-step"
        }, [
          Z(oI, {
            "active-cluster-id": t.activeClusterId,
            cluster: s,
            onSetActiveCluster: r
          }, null, 8, ["active-cluster-id", "cluster"]),
          t.additionalIcons.length && i < t.clusters.length - 1 ? (b(), x5(O(a3), {
            key: 0,
            style: { "z-index": "20", margin: "5px 0" },
            offset: 6,
            vertical: "",
            size: 25,
            color: "#707070"
          })) : X("", !0),
          t.additionalIcons.length ? X("", !0) : (b(), x5(O(a3), {
            key: 1,
            style: { "z-index": "20", margin: "5px 0" },
            offset: 6,
            vertical: "",
            size: 25,
            color: "#707070"
          }))
        ]))), 128)),
        t.additionalIcons.length ? (b(), _("div", dI, [
          (b(!0), _(p5, null, S5(t.additionalIcons, (s, i) => (b(), _("div", {
            key: i,
            class: F(["[ cursor-pointer mt-4 ]", [i === t.additionalIcons.length - 1 ? "mb-4" : ""]])
          }, [
            d("img", {
              class: "additional-icons",
              src: s.icon,
              alt: s.name,
              onClick: (l) => o(s.name)
            }, null, 8, cI)
          ], 2))), 128))
        ])) : (b(), _("div", iI, [
          (b(), _("svg", {
            "data-test-id": "icon-submit",
            xmlns: "http://www.w3.org/2000/svg",
            width: "35",
            height: "21",
            viewBox: "0 0 35 21",
            class: "ring-4 ring-white cursor-pointer text-button-gray",
            onClick: L
          }, uI))
        ]))
      ])
    ]));
  }
});
const XT = /* @__PURE__ */ K(fI, [["__scopeId", "data-v-9bdb2fdb"]]), pI = { class: "inline-block align-top" }, mI = { class: "w-4 pt-1 ml-1 inline-block" }, gI = /* @__PURE__ */ r5({
  __name: "MfxFormSettings",
  props: {
    languages: {
      type: Array,
      default: () => []
    },
    settingsTitle: {
      type: String
    },
    themeModeToggleItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ["change:language", "change:themeMode"],
  setup(t, { emit: e }) {
    const r = t, L = U(
      () => r.languages.map((a) => a.text)
    ), o = (a) => {
      e("change:language", r.languages.filter((s) => s.text === a)[0]);
    }, n = (a) => {
      e("change:themeMode", a);
    };
    return (a, s) => (b(), x5(O(An), { "container-classes": "mr-2 mt-3 mb-3" }, {
      title: c5(() => [
        d("div", pI, V(t.settingsTitle), 1),
        d("div", mI, [
          Z(O(rx))
        ])
      ]),
      default: c5(() => [
        Z(O(wC), {
          items: L.value,
          classes: "w-[250px]",
          "onUpdate:selection": o
        }, null, 8, ["items"])
      ]),
      item2: c5(() => [
        Z(O(RS), {
          horizontal: !0,
          value: t.themeModeToggleItems[0],
          items: t.themeModeToggleItems,
          "selector-class": "bg-bl-panel-color dark:bg-bl-dk-panel-color",
          "background-class": "bg-bl-background-color dark:bg-bl-dk-background-color",
          onValueSelected: n
        }, null, 8, ["value", "items"])
      ]),
      _: 1
    }));
  }
});
var kt = {}, vI = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, uL = {}, J5 = {};
let c4;
const yI = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
J5.getSymbolSize = function(e) {
  if (!e)
    throw new Error('"version" cannot be null or undefined');
  if (e < 1 || e > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return e * 4 + 17;
};
J5.getSymbolTotalCodewords = function(e) {
  return yI[e];
};
J5.getBCHDigit = function(t) {
  let e = 0;
  for (; t !== 0; )
    e++, t >>>= 1;
  return e;
};
J5.setToSJISFunction = function(e) {
  if (typeof e != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  c4 = e;
};
J5.isKanjiModeEnabled = function() {
  return typeof c4 < "u";
};
J5.toSJIS = function(e) {
  return c4(e);
};
var x0 = {};
(function(t) {
  t.L = { bit: 1 }, t.M = { bit: 0 }, t.Q = { bit: 3 }, t.H = { bit: 2 };
  function e(r) {
    if (typeof r != "string")
      throw new Error("Param is not a string");
    switch (r.toLowerCase()) {
      case "l":
      case "low":
        return t.L;
      case "m":
      case "medium":
        return t.M;
      case "q":
      case "quartile":
        return t.Q;
      case "h":
      case "high":
        return t.H;
      default:
        throw new Error("Unknown EC Level: " + r);
    }
  }
  t.isValid = function(L) {
    return L && typeof L.bit < "u" && L.bit >= 0 && L.bit < 4;
  }, t.from = function(L, o) {
    if (t.isValid(L))
      return L;
    try {
      return e(L);
    } catch {
      return o;
    }
  };
})(x0);
function dL() {
  this.buffer = [], this.length = 0;
}
dL.prototype = {
  get: function(t) {
    const e = Math.floor(t / 8);
    return (this.buffer[e] >>> 7 - t % 8 & 1) === 1;
  },
  put: function(t, e) {
    for (let r = 0; r < e; r++)
      this.putBit((t >>> e - r - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(t) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var wI = dL;
function Mt(t) {
  if (!t || t < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
}
Mt.prototype.set = function(t, e, r, L) {
  const o = t * this.size + e;
  this.data[o] = r, L && (this.reservedBit[o] = !0);
};
Mt.prototype.get = function(t, e) {
  return this.data[t * this.size + e];
};
Mt.prototype.xor = function(t, e, r) {
  this.data[t * this.size + e] ^= r;
};
Mt.prototype.isReserved = function(t, e) {
  return this.reservedBit[t * this.size + e];
};
var bI = Mt, cL = {};
(function(t) {
  const e = J5.getSymbolSize;
  t.getRowColCoords = function(L) {
    if (L === 1)
      return [];
    const o = Math.floor(L / 7) + 2, n = e(L), a = n === 145 ? 26 : Math.ceil((n - 13) / (2 * o - 2)) * 2, s = [n - 7];
    for (let i = 1; i < o - 1; i++)
      s[i] = s[i - 1] - a;
    return s.push(6), s.reverse();
  }, t.getPositions = function(L) {
    const o = [], n = t.getRowColCoords(L), a = n.length;
    for (let s = 0; s < a; s++)
      for (let i = 0; i < a; i++)
        s === 0 && i === 0 || // top-left
        s === 0 && i === a - 1 || // bottom-left
        s === a - 1 && i === 0 || o.push([n[s], n[i]]);
    return o;
  };
})(cL);
var hL = {};
const xI = J5.getSymbolSize, w3 = 7;
hL.getPositions = function(e) {
  const r = xI(e);
  return [
    // top-left
    [0, 0],
    // top-right
    [r - w3, 0],
    // bottom-left
    [0, r - w3]
  ];
};
var fL = {};
(function(t) {
  t.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const e = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  t.isValid = function(o) {
    return o != null && o !== "" && !isNaN(o) && o >= 0 && o <= 7;
  }, t.from = function(o) {
    return t.isValid(o) ? parseInt(o, 10) : void 0;
  }, t.getPenaltyN1 = function(o) {
    const n = o.size;
    let a = 0, s = 0, i = 0, l = null, u = null;
    for (let c = 0; c < n; c++) {
      s = i = 0, l = u = null;
      for (let v = 0; v < n; v++) {
        let p = o.get(c, v);
        p === l ? s++ : (s >= 5 && (a += e.N1 + (s - 5)), l = p, s = 1), p = o.get(v, c), p === u ? i++ : (i >= 5 && (a += e.N1 + (i - 5)), u = p, i = 1);
      }
      s >= 5 && (a += e.N1 + (s - 5)), i >= 5 && (a += e.N1 + (i - 5));
    }
    return a;
  }, t.getPenaltyN2 = function(o) {
    const n = o.size;
    let a = 0;
    for (let s = 0; s < n - 1; s++)
      for (let i = 0; i < n - 1; i++) {
        const l = o.get(s, i) + o.get(s, i + 1) + o.get(s + 1, i) + o.get(s + 1, i + 1);
        (l === 4 || l === 0) && a++;
      }
    return a * e.N2;
  }, t.getPenaltyN3 = function(o) {
    const n = o.size;
    let a = 0, s = 0, i = 0;
    for (let l = 0; l < n; l++) {
      s = i = 0;
      for (let u = 0; u < n; u++)
        s = s << 1 & 2047 | o.get(l, u), u >= 10 && (s === 1488 || s === 93) && a++, i = i << 1 & 2047 | o.get(u, l), u >= 10 && (i === 1488 || i === 93) && a++;
    }
    return a * e.N3;
  }, t.getPenaltyN4 = function(o) {
    let n = 0;
    const a = o.data.length;
    for (let i = 0; i < a; i++)
      n += o.data[i];
    return Math.abs(Math.ceil(n * 100 / a / 5) - 10) * e.N4;
  };
  function r(L, o, n) {
    switch (L) {
      case t.Patterns.PATTERN000:
        return (o + n) % 2 === 0;
      case t.Patterns.PATTERN001:
        return o % 2 === 0;
      case t.Patterns.PATTERN010:
        return n % 3 === 0;
      case t.Patterns.PATTERN011:
        return (o + n) % 3 === 0;
      case t.Patterns.PATTERN100:
        return (Math.floor(o / 2) + Math.floor(n / 3)) % 2 === 0;
      case t.Patterns.PATTERN101:
        return o * n % 2 + o * n % 3 === 0;
      case t.Patterns.PATTERN110:
        return (o * n % 2 + o * n % 3) % 2 === 0;
      case t.Patterns.PATTERN111:
        return (o * n % 3 + (o + n) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + L);
    }
  }
  t.applyMask = function(o, n) {
    const a = n.size;
    for (let s = 0; s < a; s++)
      for (let i = 0; i < a; i++)
        n.isReserved(i, s) || n.xor(i, s, r(o, i, s));
  }, t.getBestMask = function(o, n) {
    const a = Object.keys(t.Patterns).length;
    let s = 0, i = 1 / 0;
    for (let l = 0; l < a; l++) {
      n(l), t.applyMask(l, o);
      const u = t.getPenaltyN1(o) + t.getPenaltyN2(o) + t.getPenaltyN3(o) + t.getPenaltyN4(o);
      t.applyMask(l, o), u < i && (i = u, s = l);
    }
    return s;
  };
})(fL);
var k0 = {};
const Y1 = x0, Et = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], At = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
k0.getBlocksCount = function(e, r) {
  switch (r) {
    case Y1.L:
      return Et[(e - 1) * 4 + 0];
    case Y1.M:
      return Et[(e - 1) * 4 + 1];
    case Y1.Q:
      return Et[(e - 1) * 4 + 2];
    case Y1.H:
      return Et[(e - 1) * 4 + 3];
    default:
      return;
  }
};
k0.getTotalCodewordsCount = function(e, r) {
  switch (r) {
    case Y1.L:
      return At[(e - 1) * 4 + 0];
    case Y1.M:
      return At[(e - 1) * 4 + 1];
    case Y1.Q:
      return At[(e - 1) * 4 + 2];
    case Y1.H:
      return At[(e - 1) * 4 + 3];
    default:
      return;
  }
};
var pL = {}, M0 = {};
const nt = new Uint8Array(512), L0 = new Uint8Array(256);
(function() {
  let e = 1;
  for (let r = 0; r < 255; r++)
    nt[r] = e, L0[e] = r, e <<= 1, e & 256 && (e ^= 285);
  for (let r = 255; r < 512; r++)
    nt[r] = nt[r - 255];
})();
M0.log = function(e) {
  if (e < 1)
    throw new Error("log(" + e + ")");
  return L0[e];
};
M0.exp = function(e) {
  return nt[e];
};
M0.mul = function(e, r) {
  return e === 0 || r === 0 ? 0 : nt[L0[e] + L0[r]];
};
(function(t) {
  const e = M0;
  t.mul = function(L, o) {
    const n = new Uint8Array(L.length + o.length - 1);
    for (let a = 0; a < L.length; a++)
      for (let s = 0; s < o.length; s++)
        n[a + s] ^= e.mul(L[a], o[s]);
    return n;
  }, t.mod = function(L, o) {
    let n = new Uint8Array(L);
    for (; n.length - o.length >= 0; ) {
      const a = n[0];
      for (let i = 0; i < o.length; i++)
        n[i] ^= e.mul(o[i], a);
      let s = 0;
      for (; s < n.length && n[s] === 0; )
        s++;
      n = n.slice(s);
    }
    return n;
  }, t.generateECPolynomial = function(L) {
    let o = new Uint8Array([1]);
    for (let n = 0; n < L; n++)
      o = t.mul(o, new Uint8Array([1, e.exp(n)]));
    return o;
  };
})(pL);
const mL = pL;
function h4(t) {
  this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
}
h4.prototype.initialize = function(e) {
  this.degree = e, this.genPoly = mL.generateECPolynomial(this.degree);
};
h4.prototype.encode = function(e) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const r = new Uint8Array(e.length + this.degree);
  r.set(e);
  const L = mL.mod(r, this.genPoly), o = this.degree - L.length;
  if (o > 0) {
    const n = new Uint8Array(this.degree);
    return n.set(L, o), n;
  }
  return L;
};
var kI = h4, gL = {}, K1 = {}, f4 = {};
f4.isValid = function(e) {
  return !isNaN(e) && e >= 1 && e <= 40;
};
var z1 = {};
const vL = "[0-9]+", MI = "[A-Z $%*+\\-./:]+";
let pt = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
pt = pt.replace(/u/g, "\\u");
const _I = "(?:(?![A-Z0-9 $%*+\\-./:]|" + pt + `)(?:.|[\r
]))+`;
z1.KANJI = new RegExp(pt, "g");
z1.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
z1.BYTE = new RegExp(_I, "g");
z1.NUMERIC = new RegExp(vL, "g");
z1.ALPHANUMERIC = new RegExp(MI, "g");
const $I = new RegExp("^" + pt + "$"), SI = new RegExp("^" + vL + "$"), CI = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
z1.testKanji = function(e) {
  return $I.test(e);
};
z1.testNumeric = function(e) {
  return SI.test(e);
};
z1.testAlphanumeric = function(e) {
  return CI.test(e);
};
(function(t) {
  const e = f4, r = z1;
  t.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, t.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, t.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, t.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, t.MIXED = {
    bit: -1
  }, t.getCharCountIndicator = function(n, a) {
    if (!n.ccBits)
      throw new Error("Invalid mode: " + n);
    if (!e.isValid(a))
      throw new Error("Invalid version: " + a);
    return a >= 1 && a < 10 ? n.ccBits[0] : a < 27 ? n.ccBits[1] : n.ccBits[2];
  }, t.getBestModeForData = function(n) {
    return r.testNumeric(n) ? t.NUMERIC : r.testAlphanumeric(n) ? t.ALPHANUMERIC : r.testKanji(n) ? t.KANJI : t.BYTE;
  }, t.toString = function(n) {
    if (n && n.id)
      return n.id;
    throw new Error("Invalid mode");
  }, t.isValid = function(n) {
    return n && n.bit && n.ccBits;
  };
  function L(o) {
    if (typeof o != "string")
      throw new Error("Param is not a string");
    switch (o.toLowerCase()) {
      case "numeric":
        return t.NUMERIC;
      case "alphanumeric":
        return t.ALPHANUMERIC;
      case "kanji":
        return t.KANJI;
      case "byte":
        return t.BYTE;
      default:
        throw new Error("Unknown mode: " + o);
    }
  }
  t.from = function(n, a) {
    if (t.isValid(n))
      return n;
    try {
      return L(n);
    } catch {
      return a;
    }
  };
})(K1);
(function(t) {
  const e = J5, r = k0, L = x0, o = K1, n = f4, a = 7973, s = e.getBCHDigit(a);
  function i(v, p, m) {
    for (let f = 1; f <= 40; f++)
      if (p <= t.getCapacity(f, m, v))
        return f;
  }
  function l(v, p) {
    return o.getCharCountIndicator(v, p) + 4;
  }
  function u(v, p) {
    let m = 0;
    return v.forEach(function(f) {
      const x = l(f.mode, p);
      m += x + f.getBitsLength();
    }), m;
  }
  function c(v, p) {
    for (let m = 1; m <= 40; m++)
      if (u(v, m) <= t.getCapacity(m, p, o.MIXED))
        return m;
  }
  t.from = function(p, m) {
    return n.isValid(p) ? parseInt(p, 10) : m;
  }, t.getCapacity = function(p, m, f) {
    if (!n.isValid(p))
      throw new Error("Invalid QR Code version");
    typeof f > "u" && (f = o.BYTE);
    const x = e.getSymbolTotalCodewords(p), y = r.getTotalCodewordsCount(p, m), w = (x - y) * 8;
    if (f === o.MIXED)
      return w;
    const g = w - l(f, p);
    switch (f) {
      case o.NUMERIC:
        return Math.floor(g / 10 * 3);
      case o.ALPHANUMERIC:
        return Math.floor(g / 11 * 2);
      case o.KANJI:
        return Math.floor(g / 13);
      case o.BYTE:
      default:
        return Math.floor(g / 8);
    }
  }, t.getBestVersionForData = function(p, m) {
    let f;
    const x = L.from(m, L.M);
    if (Array.isArray(p)) {
      if (p.length > 1)
        return c(p, x);
      if (p.length === 0)
        return 1;
      f = p[0];
    } else
      f = p;
    return i(f.mode, f.getLength(), x);
  }, t.getEncodedBits = function(p) {
    if (!n.isValid(p) || p < 7)
      throw new Error("Invalid QR Code version");
    let m = p << 12;
    for (; e.getBCHDigit(m) - s >= 0; )
      m ^= a << e.getBCHDigit(m) - s;
    return p << 12 | m;
  };
})(gL);
var yL = {};
const x2 = J5, wL = 1335, DI = 21522, b3 = x2.getBCHDigit(wL);
yL.getEncodedBits = function(e, r) {
  const L = e.bit << 3 | r;
  let o = L << 10;
  for (; x2.getBCHDigit(o) - b3 >= 0; )
    o ^= wL << x2.getBCHDigit(o) - b3;
  return (L << 10 | o) ^ DI;
};
var bL = {};
const zI = K1;
function xe(t) {
  this.mode = zI.NUMERIC, this.data = t.toString();
}
xe.getBitsLength = function(e) {
  return 10 * Math.floor(e / 3) + (e % 3 ? e % 3 * 3 + 1 : 0);
};
xe.prototype.getLength = function() {
  return this.data.length;
};
xe.prototype.getBitsLength = function() {
  return xe.getBitsLength(this.data.length);
};
xe.prototype.write = function(e) {
  let r, L, o;
  for (r = 0; r + 3 <= this.data.length; r += 3)
    L = this.data.substr(r, 3), o = parseInt(L, 10), e.put(o, 10);
  const n = this.data.length - r;
  n > 0 && (L = this.data.substr(r), o = parseInt(L, 10), e.put(o, n * 3 + 1));
};
var II = xe;
const TI = K1, j0 = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function ke(t) {
  this.mode = TI.ALPHANUMERIC, this.data = t;
}
ke.getBitsLength = function(e) {
  return 11 * Math.floor(e / 2) + 6 * (e % 2);
};
ke.prototype.getLength = function() {
  return this.data.length;
};
ke.prototype.getBitsLength = function() {
  return ke.getBitsLength(this.data.length);
};
ke.prototype.write = function(e) {
  let r;
  for (r = 0; r + 2 <= this.data.length; r += 2) {
    let L = j0.indexOf(this.data[r]) * 45;
    L += j0.indexOf(this.data[r + 1]), e.put(L, 11);
  }
  this.data.length % 2 && e.put(j0.indexOf(this.data[r]), 6);
};
var OI = ke, PI = function(e) {
  for (var r = [], L = e.length, o = 0; o < L; o++) {
    var n = e.charCodeAt(o);
    if (n >= 55296 && n <= 56319 && L > o + 1) {
      var a = e.charCodeAt(o + 1);
      a >= 56320 && a <= 57343 && (n = (n - 55296) * 1024 + a - 56320 + 65536, o += 1);
    }
    if (n < 128) {
      r.push(n);
      continue;
    }
    if (n < 2048) {
      r.push(n >> 6 | 192), r.push(n & 63 | 128);
      continue;
    }
    if (n < 55296 || n >= 57344 && n < 65536) {
      r.push(n >> 12 | 224), r.push(n >> 6 & 63 | 128), r.push(n & 63 | 128);
      continue;
    }
    if (n >= 65536 && n <= 1114111) {
      r.push(n >> 18 | 240), r.push(n >> 12 & 63 | 128), r.push(n >> 6 & 63 | 128), r.push(n & 63 | 128);
      continue;
    }
    r.push(239, 191, 189);
  }
  return new Uint8Array(r).buffer;
};
const ZI = PI, EI = K1;
function Me(t) {
  this.mode = EI.BYTE, typeof t == "string" && (t = ZI(t)), this.data = new Uint8Array(t);
}
Me.getBitsLength = function(e) {
  return e * 8;
};
Me.prototype.getLength = function() {
  return this.data.length;
};
Me.prototype.getBitsLength = function() {
  return Me.getBitsLength(this.data.length);
};
Me.prototype.write = function(t) {
  for (let e = 0, r = this.data.length; e < r; e++)
    t.put(this.data[e], 8);
};
var AI = Me;
const NI = K1, HI = J5;
function _e(t) {
  this.mode = NI.KANJI, this.data = t;
}
_e.getBitsLength = function(e) {
  return e * 13;
};
_e.prototype.getLength = function() {
  return this.data.length;
};
_e.prototype.getBitsLength = function() {
  return _e.getBitsLength(this.data.length);
};
_e.prototype.write = function(t) {
  let e;
  for (e = 0; e < this.data.length; e++) {
    let r = HI.toSJIS(this.data[e]);
    if (r >= 33088 && r <= 40956)
      r -= 33088;
    else if (r >= 57408 && r <= 60351)
      r -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[e] + `
Make sure your charset is UTF-8`
      );
    r = (r >>> 8 & 255) * 192 + (r & 255), t.put(r, 13);
  }
};
var BI = _e, xL = { exports: {} };
(function(t) {
  var e = {
    single_source_shortest_paths: function(r, L, o) {
      var n = {}, a = {};
      a[L] = 0;
      var s = e.PriorityQueue.make();
      s.push(L, 0);
      for (var i, l, u, c, v, p, m, f, x; !s.empty(); ) {
        i = s.pop(), l = i.value, c = i.cost, v = r[l] || {};
        for (u in v)
          v.hasOwnProperty(u) && (p = v[u], m = c + p, f = a[u], x = typeof a[u] > "u", (x || f > m) && (a[u] = m, s.push(u, m), n[u] = l));
      }
      if (typeof o < "u" && typeof a[o] > "u") {
        var y = ["Could not find a path from ", L, " to ", o, "."].join("");
        throw new Error(y);
      }
      return n;
    },
    extract_shortest_path_from_predecessor_list: function(r, L) {
      for (var o = [], n = L; n; )
        o.push(n), r[n], n = r[n];
      return o.reverse(), o;
    },
    find_path: function(r, L, o) {
      var n = e.single_source_shortest_paths(r, L, o);
      return e.extract_shortest_path_from_predecessor_list(
        n,
        o
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(r) {
        var L = e.PriorityQueue, o = {}, n;
        r = r || {};
        for (n in L)
          L.hasOwnProperty(n) && (o[n] = L[n]);
        return o.queue = [], o.sorter = r.sorter || L.default_sorter, o;
      },
      default_sorter: function(r, L) {
        return r.cost - L.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(r, L) {
        var o = { value: r, cost: L };
        this.queue.push(o), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  t.exports = e;
})(xL);
var VI = xL.exports;
(function(t) {
  const e = K1, r = II, L = OI, o = AI, n = BI, a = z1, s = J5, i = VI;
  function l(y) {
    return unescape(encodeURIComponent(y)).length;
  }
  function u(y, w, g) {
    const h = [];
    let k;
    for (; (k = y.exec(g)) !== null; )
      h.push({
        data: k[0],
        index: k.index,
        mode: w,
        length: k[0].length
      });
    return h;
  }
  function c(y) {
    const w = u(a.NUMERIC, e.NUMERIC, y), g = u(a.ALPHANUMERIC, e.ALPHANUMERIC, y);
    let h, k;
    return s.isKanjiModeEnabled() ? (h = u(a.BYTE, e.BYTE, y), k = u(a.KANJI, e.KANJI, y)) : (h = u(a.BYTE_KANJI, e.BYTE, y), k = []), w.concat(g, h, k).sort(function($, C) {
      return $.index - C.index;
    }).map(function($) {
      return {
        data: $.data,
        mode: $.mode,
        length: $.length
      };
    });
  }
  function v(y, w) {
    switch (w) {
      case e.NUMERIC:
        return r.getBitsLength(y);
      case e.ALPHANUMERIC:
        return L.getBitsLength(y);
      case e.KANJI:
        return n.getBitsLength(y);
      case e.BYTE:
        return o.getBitsLength(y);
    }
  }
  function p(y) {
    return y.reduce(function(w, g) {
      const h = w.length - 1 >= 0 ? w[w.length - 1] : null;
      return h && h.mode === g.mode ? (w[w.length - 1].data += g.data, w) : (w.push(g), w);
    }, []);
  }
  function m(y) {
    const w = [];
    for (let g = 0; g < y.length; g++) {
      const h = y[g];
      switch (h.mode) {
        case e.NUMERIC:
          w.push([
            h,
            { data: h.data, mode: e.ALPHANUMERIC, length: h.length },
            { data: h.data, mode: e.BYTE, length: h.length }
          ]);
          break;
        case e.ALPHANUMERIC:
          w.push([
            h,
            { data: h.data, mode: e.BYTE, length: h.length }
          ]);
          break;
        case e.KANJI:
          w.push([
            h,
            { data: h.data, mode: e.BYTE, length: l(h.data) }
          ]);
          break;
        case e.BYTE:
          w.push([
            { data: h.data, mode: e.BYTE, length: l(h.data) }
          ]);
      }
    }
    return w;
  }
  function f(y, w) {
    const g = {}, h = { start: {} };
    let k = ["start"];
    for (let M = 0; M < y.length; M++) {
      const $ = y[M], C = [];
      for (let D = 0; D < $.length; D++) {
        const S = $[D], T = "" + M + D;
        C.push(T), g[T] = { node: S, lastCount: 0 }, h[T] = {};
        for (let B = 0; B < k.length; B++) {
          const I = k[B];
          g[I] && g[I].node.mode === S.mode ? (h[I][T] = v(g[I].lastCount + S.length, S.mode) - v(g[I].lastCount, S.mode), g[I].lastCount += S.length) : (g[I] && (g[I].lastCount = S.length), h[I][T] = v(S.length, S.mode) + 4 + e.getCharCountIndicator(S.mode, w));
        }
      }
      k = C;
    }
    for (let M = 0; M < k.length; M++)
      h[k[M]].end = 0;
    return { map: h, table: g };
  }
  function x(y, w) {
    let g;
    const h = e.getBestModeForData(y);
    if (g = e.from(w, h), g !== e.BYTE && g.bit < h.bit)
      throw new Error('"' + y + '" cannot be encoded with mode ' + e.toString(g) + `.
 Suggested mode is: ` + e.toString(h));
    switch (g === e.KANJI && !s.isKanjiModeEnabled() && (g = e.BYTE), g) {
      case e.NUMERIC:
        return new r(y);
      case e.ALPHANUMERIC:
        return new L(y);
      case e.KANJI:
        return new n(y);
      case e.BYTE:
        return new o(y);
    }
  }
  t.fromArray = function(w) {
    return w.reduce(function(g, h) {
      return typeof h == "string" ? g.push(x(h, null)) : h.data && g.push(x(h.data, h.mode)), g;
    }, []);
  }, t.fromString = function(w, g) {
    const h = c(w, s.isKanjiModeEnabled()), k = m(h), M = f(k, g), $ = i.find_path(M.map, "start", "end"), C = [];
    for (let D = 1; D < $.length - 1; D++)
      C.push(M.table[$[D]].node);
    return t.fromArray(p(C));
  }, t.rawSplit = function(w) {
    return t.fromArray(
      c(w, s.isKanjiModeEnabled())
    );
  };
})(bL);
const _0 = J5, W0 = x0, RI = wI, YI = bI, FI = cL, jI = hL, k2 = fL, M2 = k0, WI = kI, n0 = gL, UI = yL, GI = K1, U0 = bL;
function KI(t, e) {
  const r = t.size, L = jI.getPositions(e);
  for (let o = 0; o < L.length; o++) {
    const n = L[o][0], a = L[o][1];
    for (let s = -1; s <= 7; s++)
      if (!(n + s <= -1 || r <= n + s))
        for (let i = -1; i <= 7; i++)
          a + i <= -1 || r <= a + i || (s >= 0 && s <= 6 && (i === 0 || i === 6) || i >= 0 && i <= 6 && (s === 0 || s === 6) || s >= 2 && s <= 4 && i >= 2 && i <= 4 ? t.set(n + s, a + i, !0, !0) : t.set(n + s, a + i, !1, !0));
  }
}
function qI(t) {
  const e = t.size;
  for (let r = 8; r < e - 8; r++) {
    const L = r % 2 === 0;
    t.set(r, 6, L, !0), t.set(6, r, L, !0);
  }
}
function XI(t, e) {
  const r = FI.getPositions(e);
  for (let L = 0; L < r.length; L++) {
    const o = r[L][0], n = r[L][1];
    for (let a = -2; a <= 2; a++)
      for (let s = -2; s <= 2; s++)
        a === -2 || a === 2 || s === -2 || s === 2 || a === 0 && s === 0 ? t.set(o + a, n + s, !0, !0) : t.set(o + a, n + s, !1, !0);
  }
}
function JI(t, e) {
  const r = t.size, L = n0.getEncodedBits(e);
  let o, n, a;
  for (let s = 0; s < 18; s++)
    o = Math.floor(s / 3), n = s % 3 + r - 8 - 3, a = (L >> s & 1) === 1, t.set(o, n, a, !0), t.set(n, o, a, !0);
}
function G0(t, e, r) {
  const L = t.size, o = UI.getEncodedBits(e, r);
  let n, a;
  for (n = 0; n < 15; n++)
    a = (o >> n & 1) === 1, n < 6 ? t.set(n, 8, a, !0) : n < 8 ? t.set(n + 1, 8, a, !0) : t.set(L - 15 + n, 8, a, !0), n < 8 ? t.set(8, L - n - 1, a, !0) : n < 9 ? t.set(8, 15 - n - 1 + 1, a, !0) : t.set(8, 15 - n - 1, a, !0);
  t.set(L - 8, 8, 1, !0);
}
function QI(t, e) {
  const r = t.size;
  let L = -1, o = r - 1, n = 7, a = 0;
  for (let s = r - 1; s > 0; s -= 2)
    for (s === 6 && s--; ; ) {
      for (let i = 0; i < 2; i++)
        if (!t.isReserved(o, s - i)) {
          let l = !1;
          a < e.length && (l = (e[a] >>> n & 1) === 1), t.set(o, s - i, l), n--, n === -1 && (a++, n = 7);
        }
      if (o += L, o < 0 || r <= o) {
        o -= L, L = -L;
        break;
      }
    }
}
function eT(t, e, r) {
  const L = new RI();
  r.forEach(function(i) {
    L.put(i.mode.bit, 4), L.put(i.getLength(), GI.getCharCountIndicator(i.mode, t)), i.write(L);
  });
  const o = _0.getSymbolTotalCodewords(t), n = M2.getTotalCodewordsCount(t, e), a = (o - n) * 8;
  for (L.getLengthInBits() + 4 <= a && L.put(0, 4); L.getLengthInBits() % 8 !== 0; )
    L.putBit(0);
  const s = (a - L.getLengthInBits()) / 8;
  for (let i = 0; i < s; i++)
    L.put(i % 2 ? 17 : 236, 8);
  return tT(L, t, e);
}
function tT(t, e, r) {
  const L = _0.getSymbolTotalCodewords(e), o = M2.getTotalCodewordsCount(e, r), n = L - o, a = M2.getBlocksCount(e, r), s = L % a, i = a - s, l = Math.floor(L / a), u = Math.floor(n / a), c = u + 1, v = l - u, p = new WI(v);
  let m = 0;
  const f = new Array(a), x = new Array(a);
  let y = 0;
  const w = new Uint8Array(t.buffer);
  for (let $ = 0; $ < a; $++) {
    const C = $ < i ? u : c;
    f[$] = w.slice(m, m + C), x[$] = p.encode(f[$]), m += C, y = Math.max(y, C);
  }
  const g = new Uint8Array(L);
  let h = 0, k, M;
  for (k = 0; k < y; k++)
    for (M = 0; M < a; M++)
      k < f[M].length && (g[h++] = f[M][k]);
  for (k = 0; k < v; k++)
    for (M = 0; M < a; M++)
      g[h++] = x[M][k];
  return g;
}
function rT(t, e, r, L) {
  let o;
  if (Array.isArray(t))
    o = U0.fromArray(t);
  else if (typeof t == "string") {
    let l = e;
    if (!l) {
      const u = U0.rawSplit(t);
      l = n0.getBestVersionForData(u, r);
    }
    o = U0.fromString(t, l || 40);
  } else
    throw new Error("Invalid data");
  const n = n0.getBestVersionForData(o, r);
  if (!n)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!e)
    e = n;
  else if (e < n)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + n + `.
`
    );
  const a = eT(e, r, o), s = _0.getSymbolSize(e), i = new YI(s);
  return KI(i, e), qI(i), XI(i, e), G0(i, r, 0), e >= 7 && JI(i, e), QI(i, a), isNaN(L) && (L = k2.getBestMask(
    i,
    G0.bind(null, i, r)
  )), k2.applyMask(L, i), G0(i, r, L), {
    modules: i,
    version: e,
    errorCorrectionLevel: r,
    maskPattern: L,
    segments: o
  };
}
uL.create = function(e, r) {
  if (typeof e > "u" || e === "")
    throw new Error("No input text");
  let L = W0.M, o, n;
  return typeof r < "u" && (L = W0.from(r.errorCorrectionLevel, W0.M), o = n0.from(r.version), n = k2.from(r.maskPattern), r.toSJISFunc && _0.setToSJISFunction(r.toSJISFunc)), rT(e, o, L, n);
};
var kL = {}, p4 = {};
(function(t) {
  function e(r) {
    if (typeof r == "number" && (r = r.toString()), typeof r != "string")
      throw new Error("Color should be defined as hex string");
    let L = r.slice().replace("#", "").split("");
    if (L.length < 3 || L.length === 5 || L.length > 8)
      throw new Error("Invalid hex color: " + r);
    (L.length === 3 || L.length === 4) && (L = Array.prototype.concat.apply([], L.map(function(n) {
      return [n, n];
    }))), L.length === 6 && L.push("F", "F");
    const o = parseInt(L.join(""), 16);
    return {
      r: o >> 24 & 255,
      g: o >> 16 & 255,
      b: o >> 8 & 255,
      a: o & 255,
      hex: "#" + L.slice(0, 6).join("")
    };
  }
  t.getOptions = function(L) {
    L || (L = {}), L.color || (L.color = {});
    const o = typeof L.margin > "u" || L.margin === null || L.margin < 0 ? 4 : L.margin, n = L.width && L.width >= 21 ? L.width : void 0, a = L.scale || 4;
    return {
      width: n,
      scale: n ? 4 : a,
      margin: o,
      color: {
        dark: e(L.color.dark || "#000000ff"),
        light: e(L.color.light || "#ffffffff")
      },
      type: L.type,
      rendererOpts: L.rendererOpts || {}
    };
  }, t.getScale = function(L, o) {
    return o.width && o.width >= L + o.margin * 2 ? o.width / (L + o.margin * 2) : o.scale;
  }, t.getImageWidth = function(L, o) {
    const n = t.getScale(L, o);
    return Math.floor((L + o.margin * 2) * n);
  }, t.qrToImageData = function(L, o, n) {
    const a = o.modules.size, s = o.modules.data, i = t.getScale(a, n), l = Math.floor((a + n.margin * 2) * i), u = n.margin * i, c = [n.color.light, n.color.dark];
    for (let v = 0; v < l; v++)
      for (let p = 0; p < l; p++) {
        let m = (v * l + p) * 4, f = n.color.light;
        if (v >= u && p >= u && v < l - u && p < l - u) {
          const x = Math.floor((v - u) / i), y = Math.floor((p - u) / i);
          f = c[s[x * a + y] ? 1 : 0];
        }
        L[m++] = f.r, L[m++] = f.g, L[m++] = f.b, L[m] = f.a;
      }
  };
})(p4);
(function(t) {
  const e = p4;
  function r(o, n, a) {
    o.clearRect(0, 0, n.width, n.height), n.style || (n.style = {}), n.height = a, n.width = a, n.style.height = a + "px", n.style.width = a + "px";
  }
  function L() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  t.render = function(n, a, s) {
    let i = s, l = a;
    typeof i > "u" && (!a || !a.getContext) && (i = a, a = void 0), a || (l = L()), i = e.getOptions(i);
    const u = e.getImageWidth(n.modules.size, i), c = l.getContext("2d"), v = c.createImageData(u, u);
    return e.qrToImageData(v.data, n, i), r(c, l, u), c.putImageData(v, 0, 0), l;
  }, t.renderToDataURL = function(n, a, s) {
    let i = s;
    typeof i > "u" && (!a || !a.getContext) && (i = a, a = void 0), i || (i = {});
    const l = t.render(n, a, i), u = i.type || "image/png", c = i.rendererOpts || {};
    return l.toDataURL(u, c.quality);
  };
})(kL);
var ML = {};
const LT = p4;
function x3(t, e) {
  const r = t.a / 255, L = e + '="' + t.hex + '"';
  return r < 1 ? L + " " + e + '-opacity="' + r.toFixed(2).slice(1) + '"' : L;
}
function K0(t, e, r) {
  let L = t + e;
  return typeof r < "u" && (L += " " + r), L;
}
function nT(t, e, r) {
  let L = "", o = 0, n = !1, a = 0;
  for (let s = 0; s < t.length; s++) {
    const i = Math.floor(s % e), l = Math.floor(s / e);
    !i && !n && (n = !0), t[s] ? (a++, s > 0 && i > 0 && t[s - 1] || (L += n ? K0("M", i + r, 0.5 + l + r) : K0("m", o, 0), o = 0, n = !1), i + 1 < e && t[s + 1] || (L += K0("h", a), a = 0)) : o++;
  }
  return L;
}
ML.render = function(e, r, L) {
  const o = LT.getOptions(r), n = e.modules.size, a = e.modules.data, s = n + o.margin * 2, i = o.color.light.a ? "<path " + x3(o.color.light, "fill") + ' d="M0 0h' + s + "v" + s + 'H0z"/>' : "", l = "<path " + x3(o.color.dark, "stroke") + ' d="' + nT(a, n, o.margin) + '"/>', u = 'viewBox="0 0 ' + s + " " + s + '"', v = '<svg xmlns="http://www.w3.org/2000/svg" ' + (o.width ? 'width="' + o.width + '" height="' + o.width + '" ' : "") + u + ' shape-rendering="crispEdges">' + i + l + `</svg>
`;
  return typeof L == "function" && L(null, v), v;
};
const oT = vI, _2 = uL, _L = kL, sT = ML;
function m4(t, e, r, L, o) {
  const n = [].slice.call(arguments, 1), a = n.length, s = typeof n[a - 1] == "function";
  if (!s && !oT())
    throw new Error("Callback required as last argument");
  if (s) {
    if (a < 2)
      throw new Error("Too few arguments provided");
    a === 2 ? (o = r, r = e, e = L = void 0) : a === 3 && (e.getContext && typeof o > "u" ? (o = L, L = void 0) : (o = L, L = r, r = e, e = void 0));
  } else {
    if (a < 1)
      throw new Error("Too few arguments provided");
    return a === 1 ? (r = e, e = L = void 0) : a === 2 && !e.getContext && (L = r, r = e, e = void 0), new Promise(function(i, l) {
      try {
        const u = _2.create(r, L);
        i(t(u, e, L));
      } catch (u) {
        l(u);
      }
    });
  }
  try {
    const i = _2.create(r, L);
    o(null, t(i, e, L));
  } catch (i) {
    o(i);
  }
}
kt.create = _2.create;
kt.toCanvas = m4.bind(null, _L.render);
kt.toDataURL = m4.bind(null, _L.renderToDataURL);
kt.toString = m4.bind(null, function(t, e, r) {
  return sT.render(t, r);
});
const JT = /* @__PURE__ */ r5({
  __name: "MfxQRCode",
  props: {
    text: {},
    isInlineBlock: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, r = P(), L = (o) => {
      kt.toCanvas(o).then((n) => {
        var a;
        (a = r.value) == null || a.appendChild(n);
      }).catch((n) => console.error(n));
    };
    return s5(
      () => e.text,
      (o) => {
        var a, s;
        const n = (a = r.value) == null ? void 0 : a.children[0];
        n && ((s = r.value) == null || s.removeChild(n)), L(o);
      }
    ), L(e.text), (o, n) => (b(), _("div", {
      ref_key: "qrContainerRef",
      ref: r,
      class: F({ "inline-block": o.isInlineBlock })
    }, null, 2));
  }
}), aT = { class: "durationContainer" }, iT = /* @__PURE__ */ r5({
  __name: "MfxTime",
  props: ["hours", "minutes", "seconds", "showSeconds"],
  emits: ["update:hours", "update:minutes", "update:seconds"],
  setup(t, { emit: e }) {
    const r = t, L = P(""), o = P(""), n = P("");
    return s5(L, (a, s) => {
      /^\d+$/.test(a) ? (Number(a) < 0 ? L.value = "0" : Number(a) > 23 && (L.value = "23", o.value = "59"), /^0{3,}/.test(a) && (L.value = a.slice(1)), /^0{2,}\d+|^0\d{2,}/.test(a) && (L.value = a.slice(1)), !/^0\d/.test(a) && Number(a) < 10 && (L.value = "0" + a)) : L.value = /\d+/.test(a) ? s : "", e("update:hours", L.value);
    }), s5(o, (a, s) => {
      /^\d+$/.test(a) ? (Number(a) < 0 ? o.value = "0" : Number(a) >= 60 && (o.value = "59"), /^0{3,}/.test(a) && (o.value = a.slice(1)), /^0{2,}\d+|^0\d{2,}/.test(a) && (o.value = a.slice(1)), !/^0\d/.test(a) && Number(a) < 10 && (o.value = "0" + a)) : o.value = /\d+/.test(a) ? s : "", e("update:minutes", o.value);
    }), s5(n, (a, s) => {
      /^\d+$/.test(a) ? (Number(a) < 0 ? n.value = "0" : Number(a) > 60 && (n.value = "60"), /^0{3,}/.test(a) && (n.value = a.slice(1)), /^0{2,}\d+|^0\d{2,}/.test(a) && (n.value = a.slice(1)), !/^0\d/.test(a) && Number(a) < 10 && (n.value = "0" + a)) : n.value = /\d+/.test(a) ? s : "", e("update:seconds", n.value);
    }), I5(() => {
      L.value = r.hours, o.value = r.minutes, n.value = r.seconds;
    }), (a, s) => (b(), _("div", aT, [
      b5(d("input", {
        "onUpdate:modelValue": s[0] || (s[0] = (i) => L.value = i),
        type: "tel",
        pattern: "[0-9]*",
        inputmode: "numeric",
        novalidate: "",
        placeholder: "hh"
      }, null, 512), [
        [qe, L.value]
      ]),
      c1(" : "),
      b5(d("input", {
        "onUpdate:modelValue": s[1] || (s[1] = (i) => o.value = i),
        type: "tel",
        pattern: "[0-9]*",
        inputmode: "numeric",
        novalidate: "",
        placeholder: "mm"
      }, null, 512), [
        [qe, o.value]
      ]),
      b5(d("span", null, [
        c1(" : "),
        b5(d("input", {
          "onUpdate:modelValue": s[2] || (s[2] = (i) => n.value = i),
          type: "tel",
          pattern: "[0-9]*",
          inputmode: "numeric",
          novalidate: "",
          placeholder: "ss"
        }, null, 512), [
          [qe, n.value]
        ])
      ], 512), [
        [T1, t.showSeconds]
      ])
    ]));
  }
});
const QT = /* @__PURE__ */ K(iT, [["__scopeId", "data-v-534f2449"]]);
export {
  ck as Africa,
  XT as ClusterMinimapDataWrapper,
  oI as ClusterMinimapStep,
  vk as EastAsia,
  Mk as Europe,
  jT as FhirQuestionnaireLookup,
  CT as IconBarcode,
  ce as IconBase,
  h2 as IconBin,
  DT as IconCD,
  f2 as IconCalendar,
  zT as IconCheck,
  Ib as IconCheckBig,
  mT as IconCheckSmall,
  pT as IconChevronDoubleDown,
  Pb as IconChevronDown,
  Wn as IconDiagnose,
  gT as IconDropdownClosed,
  vT as IconDropdownOpened,
  yT as IconEdit,
  IT as IconExclamation,
  rx as IconGear,
  ix as IconLineSpacingComfortable,
  fx as IconLineSpacingCompact,
  wx as IconLineSpacingDefault,
  TT as IconLoad,
  OT as IconMicrophone,
  wT as IconNextCluster,
  PT as IconPerson,
  Ix as IconPlus,
  bT as IconPreset,
  xT as IconScrolling,
  kT as IconShowList,
  ZT as IconSignal,
  MT as IconTime,
  _T as IconUploadCloud,
  $T as IconUploadVerticalNav,
  ST as IconWorldMaps,
  ET as IconX,
  zk as MENA,
  Mz as MfxAutoComplete,
  UT as MfxBaum,
  GT as MfxBaumBranch,
  r0 as MfxButton,
  cT as MfxCheckbox,
  WT as MfxColorPicker,
  $S as MfxCombobox,
  AT as MfxDatePicker,
  a3 as MfxDotify,
  An as MfxDropdownMenu,
  HT as MfxEditableTable,
  qT as MfxFontSizeSelector,
  gI as MfxFormSettings,
  BT as MfxFuzzyDatePicker,
  Nt as MfxInputText,
  VT as MfxLanguageSwitcher,
  KT as MfxLineSpacingSelector,
  NT as MfxModal,
  y_ as MfxNumericStepper,
  hT as MfxPanel,
  dT as MfxPatientIdentifier,
  RT as MfxProgressBar,
  JT as MfxQRCode,
  S0 as MfxRadioButton,
  wC as MfxSelect,
  fT as MfxSlider,
  FT as MfxSpine,
  QT as MfxTime,
  RS as MfxToggle,
  ft as MfxTooltip,
  YT as MfxTree,
  Ek as PacificIslander,
  Rk as SouthAmerica,
  Gk as SouthAsia,
  eM as WorldMap
};
//# sourceMappingURL=mfx-components.mjs.map
